webpackJsonp([1],{

/***/ "+E39":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("S82l")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "+KEG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("pDJT");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("35d345f0", content, true);

/***/ }),

/***/ "+ZMJ":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("lOnJ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "+aDL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-masker-box{position:relative}.vux-masker{position:absolute;top:0;left:0;bottom:0;right:0;border-radius:inherit}.vux-masker-fullscreen{position:fixed;z-index:10001}", ""]);

// exports


/***/ }),

/***/ "+k0Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _spinner = __webpack_require__("oRv6");

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral'];

exports.default = {
  mounted: function mounted() {
    (0, _spinner2.default)(this.$el, this.type);
  },

  props: {
    type: {
      type: String,
      default: 'ios'
    }
  },
  computed: {
    className: function className() {
      var rs = {};
      for (var i = 0; i < types.length; i++) {
        rs['vux-spinner-' + types[i]] = this.type === types[i];
      }
      return rs;
    }
  }
};

/***/ }),

/***/ "+tPU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("xGkn");
var global = __webpack_require__("7KvD");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var TO_STRING_TAG = __webpack_require__("dSzd")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "+vFv":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_panel{background-color:#fff;margin-top:10px;position:relative;overflow:hidden}.weui_panel:first-child{margin-top:0}.weui_panel:before{top:0;border-top:1px solid #e5e5e5;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_panel:after,.weui_panel:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#e5e5e5}.weui_panel:after{bottom:0;border-bottom:1px solid #e5e5e5;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_panel_hd{padding:14px 15px 10px;color:#999;font-size:13px;position:relative}.weui_panel_hd:after{content:\" \";position:absolute;left:0;bottom:0;width:100%;height:1px;border-bottom:1px solid #e5e5e5;color:#e5e5e5;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:15px}.weui_panel_ft{padding:10px 15px 12px;color:#999;font-size:14px;position:relative}.weui_panel_ft:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #e5e5e5;color:#e5e5e5;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:15px}.weui_panel_access .weui_panel_ft{display:block;color:#586c94;-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_panel_access .weui_panel_ft:active{background-color:#ececec}.weui_panel_access .weui_panel_ft:after{content:\" \";display:inline-block;-webkit-transform:rotate(45deg);transform:rotate(45deg);height:6px;width:6px;border-width:2px 2px 0 0;border-color:#c7c7cc;border-style:solid;position:relative;top:-2px;position:absolute;right:15px;top:50%;margin-top:-4px}", ""]);

// exports


/***/ }),

/***/ "/+79":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100px",
      "font-size": "100px"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "//Fk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("U5ju"), __esModule: true };

/***/ }),

/***/ "/1W4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var Clocker = __webpack_require__("fDGX");
exports.default = {
  mounted: function mounted() {
    this.slot = this.$el.querySelector('.vux-clocker-tpl');
    this.slotString = this.slot.innerHTML;
    if (this.slotString !== '') {
      this.showTimeString = false;
    }
    this.render();
  },

  methods: {
    render: function render() {
      var _this = this;

      if (!this.time) return;
      this.clocker = new Clocker(this.time, {
        sTime: this.sTime
      }).on('tick', function (event) {
        _this.update(event);
        _this.$emit('on-tick', event);
      }).on('finish', function () {
        _this.timeString = '00:00:00';
        _this.$emit('on-finish');
      }).start();
    },
    update: function update(event) {
      if (this.showTimeString) {
        this.timeString = event.strftime(this.format);
      } else {
        var string = event.strftime(this.slotString);
        if (string !== this.cacheSlotString) {
          this.slot.innerHTML = this.cacheSlotString = string;
        }
      }
    }
  },
  props: {
    sTime: [String, Number],
    time: [String, Number],
    format: {
      type: String,
      default: '%D 天 %H 小时 %M 分 %S 秒'
    }
  },
  watch: {
    time: function time() {
      if (this.clocker) {
        this.clocker.remove();
      }
      this.render();
    }
  },
  data: function data() {
    return {
      showTimeString: true,
      timeString: '',
      slotString: '',
      cacheSlotString: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this.clocker) {
      this.clocker.remove();
    }
    this.clocker = null;
  }
};

/***/ }),

/***/ "/Hk7":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-input weui_cell",
    class: {
      'weui_cell_warn': !_vm.valid
    }
  }, [_c('div', {
    staticClass: "weui_cell_hd"
  }, [(_vm.hasRestrictedLabel) ? _c('div', {
    style: (_vm.labelStyles)
  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._v(" "), _vm._t("label", [(_vm.title) ? _c('label', {
    staticClass: "weui_label",
    style: ({
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [(!_vm.type || _vm.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui_input",
    style: (_vm.inputStyle),
    attrs: {
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "text",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui_input",
    style: (_vm.inputStyle),
    attrs: {
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "number",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui_input",
    style: (_vm.inputStyle),
    attrs: {
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "email",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui_input",
    style: (_vm.inputStyle),
    attrs: {
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "password",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'tel') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui_input",
    style: (_vm.inputStyle),
    attrs: {
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "tel",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_ft",
    class: {
      'with_arrow': _vm.isLink
    }
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFocus && !_vm.equalWith && _vm.showClear && _vm.currentValue && !_vm.readonly && !_vm.disabled),
      expression: "isFocus && !equalWith && showClear && currentValue && !readonly && !disabled"
    }],
    attrs: {
      "type": "clear"
    },
    nativeOn: {
      "click": function($event) {
        _vm.clear($event)
      }
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.novalidate && !_vm.equalWith && ((_vm.touched && !_vm.valid && _vm.firstError) || (_vm.forceShowError && !_vm.valid && _vm.firstError))),
      expression: "!novalidate && !equalWith && ((touched && !valid && firstError) || (forceShowError && !valid && firstError))"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn",
      "title": !_vm.valid ? _vm.firstError : ''
    }
  }), _vm._v(" "), (!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid) ? _c('icon', {
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn"
    }
  }) : _vm._e(), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),
      expression: "!novalidate && equalWith && equalWith === currentValue && valid"
    }],
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.novalidate && _vm.iconType === 'success'),
      expression: "novalidate && iconType === 'success'"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.novalidate && _vm.iconType === 'error'),
      expression: "novalidate && iconType === 'error'"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn"
    }
  }), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "/P8N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__("uk4t");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { XInput: _index2.default },
  props: {
    placeholder: {
      type: String,
      default: '搜索'
    },
    value: {
      type: String,
      default: ''
    },
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  methods: {
    handleBlur: function handleBlur() {
      this.$emit('on-blur');
    },
    handleChange: function handleChange() {
      this.$emit('on-change', this.currentValue);
    },
    handleFocus: function handleFocus() {
      this.$emit('on-focus');
    },
    handleSearch: function handleSearch() {
      this.$emit('on-search');
    },
    handleClickClear: function handleClickClear() {
      this.$emit('on-click-clear-icon');
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal, oldVal) {
      this.$emit('input', newVal);
    }
  }
};

/***/ }),

/***/ "/ZPr":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OJKw");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3182bce2", content, true);

/***/ }),

/***/ "/bQp":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "/n6Q":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zQR9");
__webpack_require__("+tPU");
module.exports = __webpack_require__("Kh4W").f('iterator');


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ibnn");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0/UE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flexboxItem = __webpack_require__("D++O");

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_flexboxItem2.default.install = function (Vue) {
  Vue.component('LxFlexboxItem', _flexboxItem2.default);
};

exports.default = _flexboxItem2.default;

/***/ }),

/***/ "05Uq":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox-item",
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "06OY":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("3Eo+")('meta');
var isObject = __webpack_require__("EqjI");
var has = __webpack_require__("D2L2");
var setDesc = __webpack_require__("evD5").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("S82l")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "0PLs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _card = __webpack_require__("FWLK");

var _card2 = _interopRequireDefault(_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_card2.default.install = function (Vue) {
  Vue.component('LxCard', _card2.default);
};

exports.default = _card2.default;

/***/ }),

/***/ "0Trw":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("zeGv")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9MTE"),
  /* template */
  __webpack_require__("cVIA"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "0juH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cell = __webpack_require__("D4c5");

var _cell2 = _interopRequireDefault(_cell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_cell2.default.install = function (Vue) {
  Vue.component('LxCell', _cell2.default);
};

exports.default = _cell2.default;

/***/ }),

/***/ "0oNg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xTextarea = __webpack_require__("dloP");

var _xTextarea2 = _interopRequireDefault(_xTextarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xTextarea2.default.install = function (Vue) {
  Vue.component('LxXTextarea', _xTextarea2.default);
};

exports.default = _xTextarea2.default;

/***/ }),

/***/ "1DFO":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_tabbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "1DRG":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(window,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=47)}({0:function(t,e,n){"use strict";function r(t,e,n,r,o,i,u,f){var s,l="function"==typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=n,l._compiled=!0),r&&(l.functional=!0),i&&(l._scopeId="data-v-"+i),u?(s=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),o&&o.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(u)},l._ssrRegister=s):o&&(s=f?function(){o.call(this,this.$root.$options.shadowRoot)}:o),s)if(l.functional){l._injectStyles=s;var a=l.render;l.render=function(t,e){return s.call(e),a(t,e)}}else{var c=l.beforeCreate;l.beforeCreate=c?[].concat(c,s):[s]}return{exports:t,options:l}}n.d(e,"a",function(){return r})},14:function(t,e,n){"use strict";n.r(e);var r=n(15),o=n.n(r);for(var i in r)"default"!==i&&function(t){n.d(e,t,function(){return r[t]})}(i);e.default=o.a},15:function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{gutter:{type:Number,default:8},orient:{type:String,default:"horizontal"},justify:String,align:String,wrap:String,direction:String},computed:{styles:function(){return{"justify-content":this.justify,"align-items":this.align,"flex-wrap":this.wrap,"flex-direction":this.direction}}}}},16:function(t,e,n){},31:function(t,e,n){"use strict";var r=function(){var t=this.$createElement;return(this._self._c||t)("div",{staticClass:"vux-flexbox",class:{"vux-flex-col":"vertical"===this.orient,"vux-flex-row":"horizontal"===this.orient},style:this.styles},[this._t("default")],2)},o=[];r._withStripped=!0,n.d(e,"a",function(){return r}),n.d(e,"b",function(){return o})},47:function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(t){return t&&t.__esModule?t:{default:t}}(n(61));r.default.install=function(t){t.component("LxFlexbox",r.default)},e.default=r.default},61:function(t,e,n){"use strict";n.r(e);var r=n(31),o=n(14);for(var i in o)"default"!==i&&function(t){n.d(e,t,function(){return o[t]})}(i);n(62);var u=n(0),f=Object(u.a)(o.default,r.a,r.b,!1,null,null,null);f.options.__file="src\\components\\flexbox\\flexbox.vue",e.default=f.exports},62:function(t,e,n){"use strict";var r=n(16);n.n(r).a}})});

/***/ }),

/***/ "1W2J":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("NNfK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("59ef0b74", content, true);

/***/ }),

/***/ "1gOd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".keyboard-content{padding:.26666667rem .13333333rem .33333333rem;background-color:#d1d6dc}.keyboard-content .keyboard-list{display:-webkit-flex;display:flex;-webkit-justify-content:center;justify-content:center}.keyboard-content .keyboard-list:not(:last-child){margin-bottom:.30666667rem}.keyboard-content .keyboard-list li{width:.85333333rem;height:1.2rem;background-color:#fff;box-shadow:0 .02666667rem .10666667rem 0 hsla(210,3%,41%,.5),inset 0 -.04rem 0 0 rgba(209,214,220,.5);border-radius:.10666667rem;text-align:center;line-height:1.2rem;list-style-type:none;font-size:15px}.keyboard-content .keyboard-list li:not(:last-child){margin-right:.13333333rem}.keyboard-content .keyboard-list li.end{width:1.84rem;background-color:#5890ff;color:#fff}.keyboard-content .keyboard-list li.delete{display:-webkit-flex;display:flex;-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;align-items:center}.keyboard-content .keyboard-list li .delete-icon{display:block;width:.58666667rem;height:.53333333rem}.keyboard-content .keyboard-list li.touch-start{background-color:#8f969e}", ""]);

// exports


/***/ }),

/***/ "1kS7":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "1yli":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__("6O5g");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'check-icon',
  components: {
    Icon: _icon2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  }
};

/***/ }),

/***/ "2KxR":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "2LX0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__("fcJk");

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__("LLCR");

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__("CFqi");

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__("cddD");

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 256 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),

/***/ "2Mtz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    text: [String, Number]
  }
};

/***/ }),

/***/ "2t57":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-color-picker"
  }, [_c('flexbox', _vm._l((_vm.colors), function(color) {
    return _c('flexbox-item', {
      key: color,
      staticClass: "vux-color-box"
    }, [_c('span', {
      staticClass: "vux-color-item",
      class: {
        'vux-color-white': color === '#fff' || color === '#fff', 'vux-color-picker-small': _vm.size === 'small', 'vux-color-picker-middle': _vm.size === 'middle'
      },
      style: ({
        borderRadius: _vm.width / 2 + 'px',
        backgroundColor: color,
        width: _vm.width + 'px',
        height: _vm.width + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.change(color)
        }
      }
    }, [(color === _vm.value) ? _c('icon', {
      staticClass: "vux-color-checked",
      style: ({
        lineHeight: _vm.width + 'px'
      }),
      attrs: {
        "type": "success_no_circle"
      }
    }) : _vm._e()], 1)])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ "2xnn":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vqbq");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3cc636d0", content, true);

/***/ }),

/***/ "2zlb":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("UOVC")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Cltl"),
  /* template */
  __webpack_require__("1DFO"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "31Kt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "@w: 37.5rem;.vux-close{position:relative;display:inline-block;vertical-align:middle;width:24/@w;height:24/@w;overflow:hidden;color:#ccc;&:after,&:before{content:\"\";position:absolute;height:1px;width:100%;top:50%;left:0;background:#98979d}&:before{transform:rotate(45deg)}&:after{transform:rotate(-45deg)}}", ""]);

// exports


/***/ }),

/***/ "34oW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.weui_check_label{-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_check{position:absolute;left:-9999em}.weui_cells_radio .weui_cell_ft{padding-left:.93333333rem}.weui_cells_radio .weui_cell:active{background-color:#ececec}.weui_cells_radio .weui_check:checked+.weui_icon_checked:before{display:block;content:\"\\EA08\";color:#5890ff;font-size:.42666667rem}.weui_cells_checkbox .weui_cell_hd{padding-right:.4rem}.weui_cells_checkbox .weui_icon_checked:before{display:block;width:.4rem;height:.4rem;content:\"\";border:1px solid #e9e9eb;box-sizing:border-box}.weui_cells_checkbox .weui_check:checked+.weui_icon_checked{display:block;background-color:#409eff;width:.4rem;height:.4rem;position:relative}.weui_cells_checkbox .weui_check:checked+.weui_icon_checked:before{position:absolute;left:.08rem;top:.06666667rem;content:\"\";border-style:solid;width:.26666667rem;height:.16rem;border-color:#fff #fff transparent transparent;border-width:2px;-webkit-transform:rotate(135deg);transform:rotate(135deg)}.weui_cells_checkbox>label>*{pointer-events:none}.vux-checklist-disabled{opacity:.5}.vux-checklist-disabled .vux-checklist-icon-checked:before{display:none}.weui_cells>a{color:#000}.vux-checklist-label-left{-webkit-flex-direction:row-reverse;flex-direction:row-reverse}.vux-checklist-label-left .weui_cell_hd{padding-right:0}", ""]);

// exports


/***/ }),

/***/ "3Eo+":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "3NEM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3PEC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_tab"
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "weui_tab_bd vux-fix-safari-overflow-scrolling",
    attrs: {
      "ref:view-box-body": ""
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("bottom")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "3Q2f":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("NXzX")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("J6cF"),
  /* template */
  __webpack_require__("LKxN"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3S8j":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "3Uo8":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("mPHm")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("2Mtz"),
  /* template */
  __webpack_require__("b26m"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3bsv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3"),
    Base = __webpack_require__("5dD5"),
    Core = __webpack_require__("MeUp"),
    Animate = __webpack_require__("W0DV");

var transformOrigin = Util.prefixStyle("transformOrigin");
/** 
 * @constructor
 * @param {object} cfg config for scroll
 * @extends XScroll
 * @example
 * var xscroll = new OriginScroll({
 *    renderTo:"#scroll"
 * });
 * xscroll.render();
 */
function OriginScroll(cfg) {
    OriginScroll.superclass.constructor.call(this, cfg);
}

Util.extend(OriginScroll, Core, {
    init: function() {
        var self = this;
        OriginScroll.superclass.init.call(this);
        self.resetSize();
    },
    /**
     * get scroll top value
     * @memberof OriginScroll
     * @return {number} scrollTop
     */
    getScrollTop: function() {
        return this.renderTo.scrollTop;
    },
    /**
     * get scroll left value
     * @memberof OriginScroll
     * @return {number} scrollLeft
     */
    getScrollLeft: function() {
        return this.renderTo.scrollLeft;
    },
    /**
     * vertical scroll absolute to the destination
     * @memberof SimuScroll
     * @param scrollTop {number} scrollTop
     * @param duration {number} duration for animte
     * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
     **/
    scrollTop: function(y, duration, easing, callback) {
        var self = this;
        var y = Math.round(y);
        if (self.userConfig.lockY) return;
        var duration = duration || 0;
        var easing = easing || "quadratic";
        var config = {
            css: {
                scrollTop: y
            },
            duration: duration,
            easing: easing,
            run: function(e) {
                //trigger scroll event
                self.trigger("scroll", {
                    scrollTop: self.getScrollTop(),
                    scrollLeft: self.getScrollLeft()
                });
            },
            useTransition: false, //scrollTop 
            end: callback
        };
        self.__timers.y = self.__timers.y || new Animate(self.renderTo, config);
        //run
        self.__timers.y.stop();
        self.__timers.y.reset(config);
        self.__timers.y.run();
    },
    /**
     * horizontal scroll absolute to the destination
     * @memberof SimuScroll
     * @param scrollLeft {number} scrollLeft
     * @param duration {number} duration for animte
     * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
     **/
    scrollLeft: function(x, duration, easing, callback) {
        var self = this;
        var x = Math.round(x);
        if (self.userConfig.lockX) return;
        var duration = duration || 0;
        var easing = easing || "quadratic";
        var config = {
            css: {
                scrollLeft: x
            },
            duration: duration,
            easing: easing,
            run: function(e) {
                //trigger scroll event
                self.trigger("scroll", {
                    scrollTop: self.getScrollTop(),
                    scrollLeft: self.getScrollLeft()
                });
            },
            useTransition: false, //scrollTop 
            end: callback
        };
        self.__timers.x = self.__timers.x || new Animate(self.renderTo, config);
        //run
        self.__timers.x.stop();
        self.__timers.x.reset(config);
        self.__timers.x.run();
    },
    _bindEvt: function() {
        OriginScroll.superclass._bindEvt.call(this);
        var self = this;
        if (self.__isEvtBind) return;
        self.__isEvtBind = true;
        self.renderTo.addEventListener("scroll", function(e) {
            self.trigger("scroll", {
                type: "scroll",
                scrollTop: self.getScrollTop(),
                scrollLeft: self.getScrollLeft()
            })
        }, false)
    }
});

if (typeof module == 'object' && module.exports) {
    module.exports = OriginScroll;
}


/***/ }),

/***/ "3fs2":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "3r5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cookie__ = __webpack_require__("P5P/");






/**
 * ajax request help
 */


// sentry 数据上报
// import report from '../report'

var Ajax = function () {
  function Ajax(options) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Ajax);

    this.$http = __WEBPACK_IMPORTED_MODULE_6_axios___default.a;
    this.baseUrl = options && options.baseUrl ? options.baseUrl : '/api/v1';
    this.authUrl = options && options.authUrl ? options.authUrl : '/auth/weixin';
    // this.report = report
    this.$store = null; // vuex store
    this.isLogin = false;
    this.queryMap = {};
    this.createMap = {};
    this.putWayMap = {};
    this.patchMap = {};
    this.deleteMap = {};
    // 正在登陆
    this.logining = false;
    this.next = '';
    // 输出提示
    this.showTips = function (tips) {
      if (window.console) {
        console.log(tips);
      }
    };
    // 通用拦截器
    if (options && typeof options.success === 'function') {
      this.success = options.success;
    } else {
      this.success = function (res) {};
    }

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['channelType'] = 'wx';
    // request 请求拦截器
    // 给POST请求头加上x-crsf-token
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.request.use(function (config) {
      var csrftoken = __WEBPACK_IMPORTED_MODULE_7__cookie__["a" /* default */].getCookie('csrf-token');
      if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(config.method) && !__WEBPACK_IMPORTED_MODULE_6_axios___default.a.credentials) {
        config.headers.common['X-CSRF-Token'] = csrftoken;
      }
      return config;
    }, function (err) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(err);
    });

    // ajax 全局错误处理
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.response.use(function (response) {
      _this.success(response);
      return response;
    }, function (err) {
      if (err.response) {
        switch (err.response.status) {
          case 404:
            _this.showTips('请求发生404错误');
            break;
          case 500:
            _this.showTips('请求发生500错误');
            break;
          case 504:
            _this.showTips('请求超时');
            break;
          case 400: // 用户没有csrf-token
          case 401:
            // 用户没有登录态
            var next = '';
            if (window.location.hash === '') {
              next = encodeURIComponent('#/store/index');
            } else {
              next = encodeURIComponent('' + window.location.hash);
            }
            if (!_this.options.noAuthInFilte) {
              // 具体接口逻辑
              if (_this.options.noNeedMobileLogin) {
                // 不需要手机登录
                window.location.href = 'auth/weixin/login?next=' + next + '&binding_mobile=' + next;
              } else {
                // 需要手机登录
                window.location.href = 'auth/weixin/login?next=' + next + '&binding_mobile=' + encodeURIComponent('#/login?backUrl=' + next);
              }
            }
            break;
          default:
            _this.showTips('error:' + err.response.status);
            break;
        }
        var res = _this.normalizeRes(err.response);
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(res.data); // 返回接口返回的错误信息
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Ajax, [{
    key: 'normalizeRes',
    value: function normalizeRes(res) {
      if (res && typeof res.data === 'string') {
        res.data = {
          code: -1,
          message: res.statusText
        };
      } else if (res && res.statusText) {
        res.data = {
          code: res.status,
          message: res.statusText
        };
      } else {
        res = {
          data: {
            code: -1,
            message: '未知错误'
          }
        };
      }
      return res;
    }
  }, {
    key: 'setStore',
    value: function setStore(store) {
      this.$store = store;
    }

    // 设置用展示提示信息的函数

  }, {
    key: 'setTipFn',
    value: function setTipFn(fn) {
      this.showTips = fn;
    }
    // 设置自定义的回调

  }, {
    key: 'setSuccess',
    value: function setSuccess(success) {
      this.success = success;
    }
  }, {
    key: 'parse',
    value: function parse(path, id) {
      if (typeof id === 'string') {
        return path + '/' + id;
      }
      if ((typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(id)) === 'object') {
        var search = '?';
        var counter = 0;
        for (var key in id) {
          if (counter) search += '&';
          search += key + '=' + id[key];
          counter++;
        }
        return path + search;
      }
      return path;
    }
  }, {
    key: 'query',
    value: function query(path) {
      var _this2 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.queryMap[path]) {
        // cache path closure
        var url = '';
        this.queryMap[path] = function (id, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isReturnRes = arguments[3];

          // 合并config
          var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, config1, config2);
          // 关闭缓存
          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }
          url = expand ? path + '/' + expand : path;
          var newPath = id ? _this2.parse(url, id) : url;
          var baseUrl = config.baseUrl || _this2.baseUrl;
          return _this2.$http.get(baseUrl + newPath, config).then(function (res) {
            return isReturnRes ? res : res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
          });
        };
      }
      return this.queryMap[path];
    }

    // 增

  }, {
    key: 'create',
    value: function create(path) {
      var _this3 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.createMap[path]) {
        // cache path closure
        var url = '';
        this.createMap[path] = function (data, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isReturnRes = arguments[3];

          // 合并config
          var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, config1, config2);
          // 关闭缓存
          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }
          url = expand ? url = path + '/' + expand : path;
          var baseUrl = config.baseUrl || _this3.baseUrl;
          return _this3.$http.post(baseUrl + url, data, config).then(function (res) {
            return isReturnRes ? res : res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
          });
        };
      }
      return this.createMap[path];
    }

    // put 方法~

  }, {
    key: 'putWay',
    value: function putWay(path) {
      var _this4 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.putWayMap[path]) {
        // cache path closure
        var url = '';
        this.putWayMap[path] = function (data, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isReturnRes = arguments[3];

          // 合并config
          var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, config1, config2);
          // 关闭缓存
          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }
          url = expand ? url = path + '/' + expand : path;
          var baseUrl = config.baseUrl || _this4.baseUrl;
          return _this4.$http.put(baseUrl + url, data, config).then(function (res) {
            return isReturnRes ? res : res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
          });
        };
      }
      return this.putWayMap[path];
    }

    // patch 方法~

  }, {
    key: 'patch',
    value: function patch(path) {
      var _this5 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.patchMap[path]) {
        // cache path closure
        var url = '';
        this.patchMap[path] = function (data, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          // 合并config
          var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, config1, config2);
          // 关闭缓存
          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }
          url = expand ? url = path + '/' + expand : path;
          var baseUrl = config.baseUrl || _this5.baseUrl;
          return _this5.$http.patch(baseUrl + url, data, config).then(function (res) {
            return res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
          });
        };
      }
      return this.patchMap[path];
    }

    // delete方法

  }, {
    key: 'delete',
    value: function _delete(path) {
      var _this6 = this;

      var config1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { cache: false };

      if (!this.deleteMap[path]) {
        var url = '';
        this.deleteMap[path] = function (data, expand) {
          var config2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          // 合并config
          var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, config1, config2);
          // 关闭缓存
          if (!config.cache) {
            var headers = config.headers = config.headers || {};
            headers['Cache-Control'] = 'no-cahce';
            headers['If-Modified-Since'] = '0';
          }
          url = expand ? url = path + '/' + expand : path;
          var baseUrl = config.baseUrl || _this6.baseUrl;
          return _this6.$http.delete(baseUrl + url, data, config).then(function (res) {
            return res.data;
          }, function (res) {
            return res;
          }).catch(function (res) {
            throw new Error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
          });
        };
      }
      return this.deleteMap[path];
    }
  }]);

  return Ajax;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Ajax());

/***/ }),

/***/ "3ssR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("hWfb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("75a1921c", content, true);

/***/ }),

/***/ "3u/m":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("+KEG")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/P8N"),
  /* template */
  __webpack_require__("jLAQ"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "4+zm":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "weui_btn",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "40kK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GU06");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e23e24d2", content, true);

/***/ }),

/***/ "42BS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _selectorList = __webpack_require__("deEd");

var _selectorList2 = _interopRequireDefault(_selectorList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_selectorList2.default.install = function (Vue) {
  Vue.component('LxSelectorList', _selectorList2.default);
};

exports.default = _selectorList2.default;

/***/ }),

/***/ "42Vs":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ICxZ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("35236dd0", content, true);

/***/ }),

/***/ "4Ba1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popup = __webpack_require__("ooks");

var _popup2 = _interopRequireDefault(_popup);

var _provinces_abbreviation = __webpack_require__("rDjO");

var _provinces_abbreviation2 = _interopRequireDefault(_provinces_abbreviation);

var _alphanumeric = __webpack_require__("Bahx");

var _alphanumeric2 = _interopRequireDefault(_alphanumeric);

var _dom = __webpack_require__("eixu");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    popup: _popup2.default
  },
  methods: {
    clickKey: function clickKey(value, type) {
      var _this = this;

      if (type === 'provinces') {
        this.isShow = false;
      }
      if (value === 'delete') {
        this.$emit('handle-delete', value);
      } else if (value === 'end') {
        this.isShow = false;
      } else {
        this.$nextTick(function () {
          _this.$emit('handle-value', value);
        });
      }
    },
    handleTouchStart: function handleTouchStart(value) {
      this.currentTouchStart = value;
    },
    handleTouchEnd: function handleTouchEnd(value) {
      this.currentTouchStart = '';
    },
    handleProvincesData: function handleProvincesData() {
      var provincesArr = [];
      provincesArr.push(_provinces_abbreviation2.default.slice(0, 10));
      provincesArr.push(_provinces_abbreviation2.default.slice(10, 19));
      provincesArr.push(_provinces_abbreviation2.default.slice(19, 26));
      provincesArr.push(_provinces_abbreviation2.default.slice(26));
      return provincesArr;
    },
    handleAlphanumericData: function handleAlphanumericData() {
      var alphanumericArr = [];
      alphanumericArr.push(_alphanumeric2.default.slice(0, 10));
      alphanumericArr.push(_alphanumeric2.default.slice(10, 20));
      alphanumericArr.push(_alphanumeric2.default.slice(20, 30));
      alphanumericArr.push(_alphanumeric2.default.slice(30));
      return alphanumericArr;
    },
    showItem: function showItem(value) {
      if (value === 'delete') {
        return '';
      } else if (value === 'end') {
        return '完成';
      } else {
        return value;
      }
    },
    doToggle: function doToggle() {
      this.isShow = !this.isShow;
    },
    handleDocumentClick: function handleDocumentClick(e) {
      var reference = this.$refs.reference;
      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target)) return;
      this.isShow = false;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var reference = this.$refs.reference;
    (0, _dom.on)(reference, 'click', this.doToggle);
    (0, _dom.on)(document, 'click', this.handleDocumentClick);
  },
  destroyed: function destroyed() {
    var reference = this.$refs.reference;
    (0, _dom.off)(reference, 'click', this.doToggle);
    (0, _dom.off)(document, 'click', this.handleDocumentClick);
  },

  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'provinces';
      }
    },
    show: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      provincesData: this.handleProvincesData(),
      alphanumeric: this.handleAlphanumericData(),
      isShow: this.show,
      currentTouchStart: '' };
  },

  watch: {
    show: function show(newValue, oldValue) {
      this.isShow = newValue;
    },
    isShow: function isShow(newValue, oldValue) {
      if (newValue) {
        var mask = document.querySelector('.vux-popup-mask');
        mask.style.background = 'rgba(0,0,0,0)';
        mask.style.display = 'none';
        this.$emit('on-show');
      } else {
        var _mask = document.querySelector('.vux-popup-mask');
        _mask.style.background = 'rgba(0, 0, 0, 0.6)';
        _mask.style.display = 'block';
        this.$emit('on-hide');
      }
      this.$emit('change', newValue);
    }
  }
};

/***/ }),

/***/ "4czF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_panel{background-color:#fff;margin-top:10px;position:relative;overflow:hidden}.weui_panel:first-child{margin-top:0}.weui_panel:before{top:0;border-top:1px solid #e5e5e5;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_panel:after,.weui_panel:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#e5e5e5}.weui_panel:after{bottom:0;border-bottom:1px solid #e5e5e5;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_panel_hd{padding:14px 15px 10px;color:#999;font-size:13px;position:relative}.weui_panel_hd:after{content:\" \";position:absolute;left:0;bottom:0;width:100%;height:1px;border-bottom:1px solid #e5e5e5;color:#e5e5e5;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:15px}.weui_panel_ft{padding:10px 15px 12px;color:#999;font-size:14px;position:relative}.weui_panel_ft:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #e5e5e5;color:#e5e5e5;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:15px}.weui_panel_access .weui_panel_ft{display:block;color:#586c94;-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_panel_access .weui_panel_ft:active{background-color:#ececec}.weui_panel_access .weui_panel_ft:after{content:\" \";display:inline-block;-webkit-transform:rotate(45deg);transform:rotate(45deg);height:6px;width:6px;border-width:2px 2px 0 0;border-color:#c7c7cc;border-style:solid;position:relative;top:-2px;position:absolute;right:15px;top:50%;margin-top:-4px}.weui_media_box{padding:15px;position:relative}.weui_media_box:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #e5e5e5;color:#e5e5e5;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:15px}.weui_media_box:first-child:before{display:none}a.weui_media_box{color:#000;-webkit-tap-highlight-color:rgba(0,0,0,0)}a.weui_media_box:active{background-color:#ececec}.weui_media_box .weui_media_title{font-weight:400;font-size:17px;width:auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;word-wrap:break-word;word-break:break-all}.weui_media_box .weui_media_desc{color:#999;font-size:13px;line-height:1.2;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2}.weui_media_box.weui_media_text .weui_media_title{margin-bottom:8px}.weui_media_box.weui_media_text .weui_media_info{margin-top:15px;padding-bottom:5px;font-size:13px;color:#cecece;line-height:1em;list-style:none;overflow:hidden}.weui_media_box.weui_media_text .weui_media_info_meta{float:left;padding-right:1em}.weui_media_box.weui_media_text .weui_media_info_meta.weui_media_info_meta_extra{padding-left:1em;border-left:1px solid #cecece}.weui_media_box.weui_media_appmsg{display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_media_box.weui_media_appmsg .weui_media_hd{margin-right:.8em;width:60px;height:60px;line-height:60px;text-align:center}.weui_media_box.weui_media_appmsg .weui_media_appmsg_thumb{width:100%;max-height:100%;vertical-align:top}.weui_media_box.weui_media_appmsg .weui_media_bd{-webkit-flex:1;flex:1;min-width:0}.weui_media_box.weui_media_small_appmsg{padding:0}.weui_media_box.weui_media_small_appmsg .weui_cells{margin-top:0}.weui_media_box.weui_media_small_appmsg .weui_cells:before{display:none}", ""]);

// exports


/***/ }),

/***/ "4dc+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__("6YX8");

exports.default = {
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && (0, _router.go)(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
};

/***/ }),

/***/ "4gH2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _group = __webpack_require__("LRgB");

var _group2 = _interopRequireDefault(_group);

var _cell = __webpack_require__("0juH");

var _cell2 = _interopRequireDefault(_cell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    frKey: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '审核流程'
    },
    steps: {
      type: Array,
      default: []
    }
  },
  components: {
    Group: _group2.default,
    Cell: _cell2.default
  },
  data: function data() {
    return {
      iconClass: {
        pending_review: 'status_waiting',
        approved: 'status_ok',
        rejected: 'status_no',
        not_started: 'original'
      }
    };
  }
};

/***/ }),

/***/ "4mcu":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "4w7B":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.vux-next-icon,.vux-prev-icon{position:absolute;left:0;top:.4rem;display:inline-block;width:.32rem;height:.32rem;border:1px solid #5890ff;border-radius:0;border-top:none;border-right:none;-webkit-transform:rotate(45deg);transform:rotate(45deg);margin-left:.4rem;line-height:1.06666667rem}.vux-next-icon{-webkit-transform:rotate(-135deg);transform:rotate(-135deg);left:auto;top:.37333333rem;right:.4rem}.vux-prev-icon:before{display:block;width:.32rem;height:.32rem;border:1px solid #04be02;border-width:1px 0 0 1px;-webkit-transform:rotate(315deg);transform:rotate(315deg)}.is-weekend-highlight td.is-week-0,.is-weekend-highlight td.is-week-6,.is-weekend-highlight td.is-week-list-0,.is-weekend-highlight td.is-week-list-6{color:#e59313}.inline-calendar a{text-decoration:none;tap-highlight-color:transparent}.calendar-month,.calendar-year{position:relative}.calendar-header{line-height:1.06666667rem;font-size:.42666667rem;overflow:hidden}.calendar-header>div{float:left;width:50%;text-align:center;overflow:hidden}.calendar-header a:last-of-type{float:right;vertical-align:bottom}.calendar-title,.switch-btn{display:inline-block;border-radius:4px;line-height:.8rem}.switch-btn{width:.8rem;margin:.13333333rem;color:#39b5b8;font-family:SimSun}.calendar-title{padding:0 6%;color:#333}.calendar-header a.active,.calendar-title:active,.switch-btn:active{background-color:#39b5b8;color:#fff}.calendar-week{overflow:hidden}.calendar-week span{float:left;width:14.28%;font-size:.53333333rem;line-height:.90666667rem;text-align:center}.inline-calendar{width:100%;background:#fff;border-radius:2px;transition:all .5s ease}.inline-calendar td.is-today,.inline-calendar td.is-today.is-disabled{color:#5890ff}.calendar-enter,.calendar-leave{opacity:0;-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}.calendar:before{top:-.26666667rem;border:5px solid transparent;border-bottom-color:#dedede}.calendar:after,.calendar:before{position:absolute;left:.8rem;content:\"\"}.calendar:after{top:-.24rem;border:5px solid transparent;border-bottom-color:#fff}.calendar-tools{height:.85333333rem;font-size:.53333333rem;line-height:.85333333rem;color:#04be02}.calendar-tools .float.left{float:left}.calendar-tools .float.right{float:right}.calendar-tools input{font-size:.53333333rem;line-height:.85333333rem;color:#04be02;width:1.86666667rem;text-align:center;border:none;background-color:transparent}.calendar-tools>i{margin:0 .42666667rem;line-height:.85333333rem;cursor:pointer;color:#707070}.calendar-tools>i:hover{color:#5e7a88}.inline-calendar table{clear:both;width:100%;border-collapse:collapse;color:#444}.inline-calendar td{padding:.13333333rem 0;text-align:center;vertical-align:middle;font-size:.4rem;position:relative}.inline-calendar td.is-disabled,.inline-calendar td.week{pointer-events:none!important;cursor:default!important}.inline-calendar td.is-disabled{color:silver}.inline-calendar td>span{display:inline-block;width:.69333333rem;height:.69333333rem;line-height:.69333333rem;border-radius:50%;text-align:center}.vux-calendar-range.inline-calendar td.current{background-color:#04be02}.vux-calendar-range table{margin-bottom:.26666667rem}.inline-calendar td.current>span{background-color:#5890ff;color:#fff}.inline-calendar .timer{margin:.26666667rem 0;text-align:center}.inline-calendar .timer input{border-radius:2px;padding:.13333333rem;font-size:.37333333rem;line-height:.48rem;color:#5e7a88;width:1.33333333rem;text-align:center;border:1px solid #efefef}.inline-calendar .timer input:focus{border:1px solid #5e7a88}.calendar-button{text-align:center}.calendar-button button{border:none;cursor:pointer;display:inline-block;min-height:1em;min-width:8em;vertical-align:baseline;background:#5e7a88;color:#fff;margin:0 .25em 0 0;padding:.8em 2.5em;font-size:1em;line-height:1em;text-align:center;border-radius:.3em}.calendar-button button.cancel{background:#efefef;color:#666}", ""]);

// exports


/***/ }),

/***/ "4xZT":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("uwDN");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("75579853", content, true);

/***/ }),

/***/ "52gC":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "5LpO":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "vux-divider"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "5Oyj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.vux-slider{overflow:hidden;position:relative}.vux-slider .vux-indicator-right,.vux-slider>.vux-indicator{position:absolute;right:.4rem;bottom:.26666667rem}.vux-slider .vux-indicator-right>a,.vux-slider>.vux-indicator>a{float:left;margin-left:.16rem}.vux-slider .vux-indicator-right>a:first-child,.vux-slider>.vux-indicator>a:first-child{margin-left:0}.vux-slider .vux-indicator-right>a>.vux-icon-dot,.vux-slider>.vux-indicator>a>.vux-icon-dot{display:inline-block;vertical-align:middle;width:.16rem;height:.16rem;border-radius:50%;background-color:#d0cdd1}.vux-slider .vux-indicator-right>a>.vux-icon-dot.active,.vux-slider>.vux-indicator>a>.vux-icon-dot.active{background-color:#04be02}.vux-slider>.vux-indicator-center{right:50%;-webkit-transform:translateX(50%);transform:translateX(50%)}.vux-slider>.vux-indicator-left{left:.4rem;right:auto}.vux-slider>.vux-swiper{overflow:hidden;position:relative}.vux-slider>.vux-swiper>.vux-swiper-item{position:absolute;top:0;left:0;width:100%;height:100%}.vux-slider>.vux-swiper>.vux-swiper-item>a{display:block;width:100%;height:100%}.vux-slider>.vux-swiper>.vux-swiper-item>a>.vux-img{display:block;width:100%;height:100%;background:50% no-repeat;background-size:cover}.vux-slider>.vux-swiper>.vux-swiper-item>a>.vux-swiper-desc{position:absolute;left:0;right:0;bottom:0;height:.48rem;font-size:.42666667rem;padding:.53333333rem 1.33333333rem .32rem .34666667rem;margin:0;background-image:linear-gradient(180deg,transparent 0,rgba(0,0,0,.7));color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.5);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal}", ""]);

// exports


/***/ }),

/***/ "5QVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BwfY"), __esModule: true };

/***/ }),

/***/ "5UzD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    show: Boolean,
    text: {
      type: String,
      default: 'Loading'
    },
    position: String
  }
};

/***/ }),

/***/ "5dD5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3");
var Events = __webpack_require__("A0Zp");
/** 
      @constructor 
      @mixes Events
      */
var Base = function() {}

Util.mix(Base.prototype, Events);

Util.mix(Base.prototype, {
	/**
	 * @memberof Base
	 * @param  {object} plugin plug a plugin
	 */
	plug: function(plugin) {
		var self = this;
		if (!plugin || !plugin.pluginId) return;
		if (!self.__plugins) {
			self.__plugins = [];
		}
		var __plugin = self.getPlugin(plugin.pluginId);
		__plugin && self.unplug(plugin.pluginId);
		plugin.pluginInitializer(self);
		self.__plugins.push(plugin);
		return self;
	},
	/**
	 * @memberof Base
	 * @param  {object|string} plugin unplug a plugin by pluginId or plugin instance
	 */
	unplug: function(plugin) {
		var self = this;
		if (!plugin || !self.__plugins) return;
		var _plugin = typeof plugin == "string" ? self.getPlugin(plugin) : plugin;
		_plugin.pluginDestructor(self);
		for (var i = 0, l = self.__plugins.length;i < l;i++) {
			if (self.__plugins[i] == _plugin) {
				return self.__plugins.splice(i, 1);
			}
		}
	},
	/**
	 * @memberof Base
	 * @param  {object|string} plugin get plugin by pluginId
	 */
	getPlugin: function(pluginId) {
		var self = this;
		var plugins = [];
		if(!self.__plugins) return;
		for (var i = 0, l = self.__plugins.length;i < l;i++) {
			if (self.__plugins[i] && self.__plugins[i].pluginId == pluginId) {
				plugins.push(self.__plugins[i])
			}
		}
		return plugins.length > 1 ? plugins : plugins[0] || null;
	}
});

if (typeof module == 'object' && module.exports) {
	module.exports = Base;
}


/***/ }),

/***/ "5mS4":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Qvw+")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("a8s/"),
  /* template */
  __webpack_require__("nFV1"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5zA6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.childMixin = exports.parentMixin = undefined;

var _router = __webpack_require__("6YX8");

var parentMixin = {
  mounted: function mounted() {
    if (this.value >= 0) {
      this.currentIndex = this.value;
    }
    this.updateIndex();
  },

  methods: {
    updateIndex: function updateIndex() {
      if (!this.$children || !this.$children.length) return;
      this.number = this.$children.length;
      var children = this.$children;
      for (var i = 0; i < children.length; i++) {
        children[i].currentIndex = i;
        if (children[i].currentSelected) {
          this.index = i;
        }
      }
    }
  },
  props: {
    value: Number
  },
  watch: {
    currentIndex: function currentIndex(val, oldVal) {
      oldVal > -1 && this.$children[oldVal] && (this.$children[oldVal].currentSelected = false);
      val > -1 && this.$children[val] && (this.$children[val].currentSelected = true);
      this.$emit('input', val);
      this.$emit('on-index-change', val, oldVal);
    },
    index: function index(val) {
      this.currentIndex = val;
    },
    value: function value(val) {
      this.index = val;
    }
  },
  data: function data() {
    return {
      index: -1,
      currentIndex: this.index,
      number: this.$children.length
    };
  }
};

var childMixin = {
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.$parent.updateIndex();
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.updateIndex();
    });
  },

  methods: {
    onItemClick: function onItemClick(hasLink) {
      var _this = this;

      if (typeof this.disabled === 'undefined' || this.disabled === false) {
        this.currentSelected = true;
        this.$parent.currentIndex = this.currentIndex;
        this.$nextTick(function () {
          _this.$emit('on-item-click');
        });
      }
      if (hasLink === true) {
        (0, _router.go)(this.link, this.$router);
      }
    }
  },
  watch: {
    currentSelected: function currentSelected(val) {
      if (val) {
        this.$parent.index = this.currentIndex;
      }
    },
    selected: function selected(val) {
      this.currentSelected = val;
    }
  },
  data: function data() {
    return {
      currentIndex: -1,
      currentSelected: this.selected
    };
  }
};

exports.parentMixin = parentMixin;
exports.childMixin = childMixin;

/***/ }),

/***/ "65cV":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("larr")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("uyHn"),
  /* template */
  __webpack_require__("DIG2"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "6O5g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__("VTCs");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_icon2.default.install = function (Vue) {
  Vue.component('LxIcon', _icon2.default);
};

exports.default = _icon2.default;

/***/ }),

/***/ "6VQV":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var i in n)("object"==typeof exports?exports:t)[i]=n[i]}}(window,function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var r=e[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(i,r,function(e){return t[e]}.bind(null,r));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=119)}([function(t,e,n){"use strict";function i(t,e,n,i,r,o,l,s){var a,u="function"==typeof t?t.options:t;if(e&&(u.render=e,u.staticRenderFns=n,u._compiled=!0),i&&(u.functional=!0),o&&(u._scopeId="data-v-"+o),l?(a=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),r&&r.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(l)},u._ssrRegister=a):r&&(a=s?function(){r.call(this,this.$root.$options.shadowRoot)}:r),a)if(u.functional){u._injectStyles=a;var c=u.render;u.render=function(t,e){return a.call(e),c(t,e)}}else{var _=u.beforeCreate;u.beforeCreate=_?[].concat(_,a):[a]}return{exports:t,options:u}}n.d(e,"a",function(){return i})},,function(t,e){t.exports=__webpack_require__("pFYg")},,,,,,,,,,,,function(t,e,n){"use strict";n.r(e);var i=n(15),r=n.n(i);for(var o in i)"default"!==o&&function(t){n.d(e,t,function(){return i[t]})}(o);e.default=r.a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={props:{gutter:{type:Number,default:8},orient:{type:String,default:"horizontal"},justify:String,align:String,wrap:String,direction:String},computed:{styles:function(){return{"justify-content":this.justify,"align-items":this.align,"flex-wrap":this.wrap,"flex-direction":this.direction}}}}},function(t,e,n){},function(t,e,n){"use strict";n.r(e);var i=n(18),r=n.n(i);for(var o in i)"default"!==o&&function(t){n.d(e,t,function(){return i[t]})}(o);e.default=r.a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=["-moz-box-","-webkit-box-",""];e.default={props:{span:[Number,String],order:[Number,String]},methods:{buildWidth:function(t){return"number"==typeof t?t<1?t:t/12:"string"==typeof t?t.replace("px","")/document.documentElement.offsetWidth:void 0}},computed:{style:function(){var t={};if(t["horizontal"===this.$parent.orient?"marginLeft":"marginTop"]=this.$parent.gutter+"px",this.span)for(var e=0;e<i.length;e++)t[i[e]+"flex"]="0 0 "+100*this.buildWidth(this.span)+"%";return void 0!==this.order&&(t.order=this.order),t}},data:function(){return{}}}},function(t,e,n){},function(t,e){t.exports=__webpack_require__("mvHQ")},,,,,,,,,,,function(t,e,n){"use strict";var i=function(){var t=this.$createElement;return(this._self._c||t)("div",{staticClass:"vux-flexbox",class:{"vux-flex-col":"vertical"===this.orient,"vux-flex-row":"horizontal"===this.orient},style:this.styles},[this._t("default")],2)},r=[];i._withStripped=!0,n.d(e,"a",function(){return i}),n.d(e,"b",function(){return r})},function(t,e,n){"use strict";var i=function(){var t=this.$createElement;return(this._self._c||t)("div",{staticClass:"vux-flexbox-item",style:this.style},[this._t("default")],2)},r=[];i._withStripped=!0,n.d(e,"a",function(){return i}),n.d(e,"b",function(){return r})},,,,,,function(t,e,n){"use strict";n.r(e);var i=n(39),r=n.n(i);for(var o in i)"default"!==o&&function(t){n.d(e,t,function(){return i[t]})}(o);e.default=r.a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=u(n(20)),r=u(n(2)),o=u(n(100)),l=u(n(47)),s=u(n(48)),a=u(n(121));function u(t){return t&&t.__esModule?t:{default:t}}e.default={name:"picker",components:{Flexbox:l.default,FlexboxItem:s.default},created:function(){if(0!==this.columns){var t=this.columns;this.store=new a.default(this.data,t,this.fixedColumns||this.columns),this.currentData=this.store.getColumns(this.value)}},mounted:function(){var t=this;this.uuid=Math.random().toString(36).substring(3,8),this.$nextTick(function(){t.render(t.currentData,t.currentValue)})},props:{data:Array,columns:{type:Number,default:0},fixedColumns:{type:Number,default:0},value:Array,itemClass:{type:String,default:"scroller-item"}},methods:{getId:function(t){return"#vux-picker-"+this.uuid+"-"+t},render:function(t,e){this.count=this.currentData.length;var n=this;if(t&&t.length){var i=this.currentData.length;if(e.length<i)for(var l=0;l<i;l++)this.$set(n.currentValue,l,t[l][0].value||t[l][0]);for(var s=function(i){if(!document.querySelector(n.getId(i)))return{v:void 0};n.scroller[i]&&n.scroller[i].destroy(),n.scroller[i]=new o.default(n.getId(i),{data:t[i],defaultValue:e[i]||t[i][0].value,itemClass:n.itemClass,onSelect:function(t){n.$set(n.currentValue,i,t),(!this.columns||this.columns&&n.getValue().length===n.store.count)&&n.$nextTick(function(){n.$emit("on-change",n.getValue())}),0!==n.columns&&n.renderChain(i+1)}}),n.currentValue&&n.currentValue!==e&&n.scroller[i].select(e[i])},a=0;a<t.length;a++){var u=s(a);if("object"===(void 0===u?"undefined":(0,r.default)(u)))return u.v}}},renderChain:function(t){if(this.columns&&!(t>this.count-1)){var e=this,n=this.getId(t);this.scroller[t]&&this.scroller[t].destroy();var i=this.store.getChildren(e.getValue()[t-1]);this.scroller[t]=new o.default(n,{data:i,itemClass:e.itemClass,onSelect:function(n){e.$set(e.currentValue,t,n),e.$nextTick(function(){e.$emit("on-change",e.getValue())}),e.renderChain(t+1)}}),i.length?(this.$set(this.currentValue,t,i[0].value),this.renderChain(t+1)):this.$set(this.currentValue,t,null)}},getValue:function(){for(var t=[],e=0;e<this.currentData.length;e++){if(!this.scroller[e])return[];t.push(this.scroller[e].value)}return t},emitValueChange:function(t){(!this.columns||this.columns&&t.length===this.store.count)&&this.$emit("on-change",t)}},data:function(){return{scroller:[],count:0,uuid:"",currentData:this.data,currentValue:this.value}},watch:{value:function(t){(0,i.default)(t)!==(0,i.default)(this.currentValue)&&(this.currentValue=t)},currentValue:function(t,e){if(this.$emit("input",t),0!==this.columns)t.length>0&&(0,i.default)(t)!==(0,i.default)(e)&&(this.currentData=this.store.getColumns(t),this.$nextTick(function(){this.render(this.currentData,t)}));else if(t.length)for(var n=0;n<t.length;n++)this.scroller[n]&&this.scroller[n].value!==t[n]&&this.scroller[n].select(t[n]);else this.render(this.currentData,[])},data:function(t){(0,i.default)(t)!==(0,i.default)(this.currentData)&&(this.currentData=t)},currentData:function(t){var e=this;if("[object Array]"===Object.prototype.toString.call(t[0]))this.$nextTick(function(){e.render(t,e.currentValue),e.$nextTick(function(){e.emitValueChange(e.getValue()),(0,i.default)(e.getValue())!==(0,i.default)(e.currentValue)&&(!e.columns||e.columns&&e.getValue().length===e.store.count)&&(e.currentValue=e.getValue())})});else if(0!==this.columns){if(!t.length)return;var n=this.columns;this.store=new a.default(t,n,this.fixedColumns||this.columns),this.currentData=this.store.getColumns(this.currentValue)}}},beforeDestroy:function(){for(var t=0;t<this.count;t++)this.scroller[t]&&this.scroller[t].destroy(),this.scroller[t]=null}}},function(t,e,n){},,,,,,,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){return t&&t.__esModule?t:{default:t}}(n(61));i.default.install=function(t){t.component("LxFlexbox",i.default)},e.default=i.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){return t&&t.__esModule?t:{default:t}}(n(64));i.default.install=function(t){t.component("LxFlexboxItem",i.default)},e.default=i.default},,function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"vux-picker"},[n("flexbox",{attrs:{gutter:0}},t._l(t.currentData,function(e,i){return n("flexbox-item",{key:i,staticStyle:{"margin-left":"0"}},[n("div",{staticClass:"vux-picker-item",attrs:{id:"vux-picker-"+t.uuid+"-"+i}})])}))],1)},r=[];i._withStripped=!0,n.d(e,"a",function(){return i}),n.d(e,"b",function(){return r})},,,,,,,,,,,function(t,e,n){"use strict";n.r(e);var i=n(31),r=n(14);for(var o in r)"default"!==o&&function(t){n.d(e,t,function(){return r[t]})}(o);n(62);var l=n(0),s=Object(l.a)(r.default,i.a,i.b,!1,null,null,null);s.options.__file="src\\components\\flexbox\\flexbox.vue",e.default=s.exports},function(t,e,n){"use strict";var i=n(16);n.n(i).a},,function(t,e,n){"use strict";n.r(e);var i=n(32),r=n(17);for(var o in r)"default"!==o&&function(t){n.d(e,t,function(){return r[t]})}(o);n(65);var l=n(0),s=Object(l.a)(r.default,i.a,i.b,!1,null,null,null);s.options.__file="src\\components\\flexbox-item\\flexbox-item.vue",e.default=s.exports},function(t,e,n){"use strict";var i=n(19);n.n(i).a},,function(t,e){t.exports=__webpack_require__("Zrlr")},function(t,e){t.exports=__webpack_require__("wxAW")},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(t,e,n){"use strict";var i=s(n(20)),r=s(n(2)),o=s(n(101)),l=n(102);function s(t){return t&&t.__esModule?t:{default:t}}var a="object"===("undefined"==typeof window?"undefined":(0,r.default)(window)),u=function(t,e){var n=this;for(var r in n.dpr=function(){var t=1;return a&&(t=document.documentElement.getAttribute("data-dpr")||1),t}(),e=e||{},n.options={itemClass:"scroller-item",onSelect:function(){},defaultValue:0,data:[]},e)void 0!==e[r]&&(n.options[r]=e[r]);n.__container=(0,l.getElement)(t);var o=document.createElement("div");o.innerHTML=e.template||'\n<div class="scroller-component" data-role="component">\n  <div class="scroller-mask" data-role="mask"></div>\n  <div class="scroller-indicator" data-role="indicator"></div>\n  <div class="scroller-content" data-role="content"></div>\n</div>\n';var s=n.__component=o.querySelector("[data-role=component]"),u=n.__content=s.querySelector("[data-role=content]"),c=s.querySelector("[data-role=indicator]"),_=n.options.data,h="";_.length&&_[0].constructor===Object?_.forEach(function(t){h+='<div class="'+n.options.itemClass+'" data-value='+(0,i.default)({value:encodeURI(t.value)})+">"+t.name+"</div>"}):_.forEach(function(t){h+='<div class="'+n.options.itemClass+'" data-value='+(0,i.default)({value:encodeURI(t)})+">"+t+"</div>"}),u.innerHTML=h,n.__container&&n.__container.appendChild(s),n.__itemHeight=parseFloat((0,l.getComputedStyle)(c,"height"),10).toFixed(6),n.__callback=e.callback||function(t){var e=-t*n.dpr;u.style.webkitTransform="translate3d(0, "+e+"px, 0)",u.style.transform="translate3d(0, "+e+"px, 0)"};var f=s.getBoundingClientRect();n.__clientTop=f.top+s.clientTop||0,n.__setDimensions(s.clientHeight,u.offsetHeight),0===s.clientHeight&&n.__setDimensions(parseFloat((0,l.getComputedStyle)(s,"height"),10),204),n.select(n.options.defaultValue,!1),s.addEventListener("touchstart",function(t){t.target.tagName.match(/input|textarea|select/i)||(t.preventDefault(),n.__doTouchStart(t.touches,t.timeStamp))},!1),s.addEventListener("touchmove",function(t){n.__doTouchMove(t.touches,t.timeStamp)},!1),s.addEventListener("touchend",function(t){n.__doTouchEnd(t.timeStamp)},!1)},c={value:null,__prevValue:null,__isSingleTouch:!1,__isTracking:!1,__didDecelerationComplete:!1,__isGesturing:!1,__isDragging:!1,__isDecelerating:!1,__isAnimating:!1,__clientTop:0,__clientHeight:0,__contentHeight:0,__itemHeight:0,__scrollTop:0,__minScrollTop:0,__maxScrollTop:0,__scheduledTop:0,__lastTouchTop:null,__lastTouchMove:null,__positions:null,__minDecelerationScrollTop:null,__maxDecelerationScrollTop:null,__decelerationVelocityY:null,__setDimensions:function(t,e){this.__clientHeight=t,this.__contentHeight=e;var n=this.options.data.length,i=Math.round(this.__clientHeight/this.__itemHeight);this.__minScrollTop=-this.__itemHeight*(i/2),this.__maxScrollTop=this.__minScrollTop+n*this.__itemHeight-.1},selectByIndex:function(t,e){t<0||t>this.__content.childElementCount-1||(this.__scrollTop=this.__minScrollTop+t*this.__itemHeight,this.scrollTo(this.__scrollTop,e),this.__selectItem(this.__content.children[t]))},select:function(t,e){for(var n=this.__content.children,i=0,r=n.length;i<r;i++)if(decodeURI(JSON.parse(n[i].dataset.value).value)===t)return void this.selectByIndex(i,e);this.selectByIndex(0,e)},getValue:function(){return this.value},scrollTo:function(t,e){if(e=void 0===e||e,this.__isDecelerating&&(o.default.stop(this.__isDecelerating),this.__isDecelerating=!1),t=Math.round((t/this.__itemHeight).toFixed(5))*this.__itemHeight,(t=Math.max(Math.min(this.__maxScrollTop,t),this.__minScrollTop))===this.__scrollTop||!e)return this.__publish(t),void this.__scrollingComplete();this.__publish(t,250)},destroy:function(){this.__component.parentNode&&this.__component.parentNode.removeChild(this.__component)},__selectItem:function(t){var e=this.options.itemClass+"-selected",n=this.__content.querySelector("."+e);n&&n.classList.remove(e),t&&t.classList.add(e),null!==this.value&&(this.__prevValue=this.value),t&&(this.value=decodeURI(JSON.parse(t.dataset.value).value))},__scrollingComplete:function(){var t=Math.round((this.__scrollTop-this.__minScrollTop-this.__itemHeight/2)/this.__itemHeight);this.__selectItem(this.__content.children[t]),null!==this.__prevValue&&this.__prevValue!==this.value&&this.options.onSelect(this.value)},__doTouchStart:function(t,e){var n;if(null==t.length)throw new Error("Invalid touch list: "+t);if(e instanceof Date&&(e=e.valueOf()),"number"!=typeof e)throw new Error("Invalid timestamp value: "+e);this.__interruptedAnimation=!0,this.__isDecelerating&&(o.default.stop(this.__isDecelerating),this.__isDecelerating=!1,this.__interruptedAnimation=!0),this.__isAnimating&&(o.default.stop(this.__isAnimating),this.__isAnimating=!1,this.__interruptedAnimation=!0);var i=1===t.length;n=i?t[0].pageY:Math.abs(t[0].pageY+t[1].pageY)/2,this.__initialTouchTop=n,this.__lastTouchTop=n,this.__lastTouchMove=e,this.__lastScale=1,this.__enableScrollY=!i,this.__isTracking=!0,this.__didDecelerationComplete=!1,this.__isDragging=!i,this.__isSingleTouch=i,this.__positions=[]},__doTouchMove:function(t,e,n){if(null==t.length)throw new Error("Invalid touch list: "+t);if(e instanceof Date&&(e=e.valueOf()),"number"!=typeof e)throw new Error("Invalid timestamp value: "+e);if(this.__isTracking){var i;i=2===t.length?Math.abs(t[0].pageY+t[1].pageY)/2:t[0].pageY;var r=this.__positions;if(this.__isDragging){var o=i-this.__lastTouchTop,l=this.__scrollTop;if(this.__enableScrollY){l-=o;var s=this.__minScrollTop,a=this.__maxScrollTop;(l>a||l<s)&&(l=l>a?a:s)}r.length>40&&r.splice(0,20),r.push(l,e),this.__publish(l)}else{var u=Math.abs(i-this.__initialTouchTop);this.__enableScrollY=u>=0,r.push(this.__scrollTop,e),this.__isDragging=this.__enableScrollY&&u>=5,this.__isDragging&&(this.__interruptedAnimation=!1)}this.__lastTouchTop=i,this.__lastTouchMove=e,this.__lastScale=n}},__doTouchEnd:function(t){if(t instanceof Date&&(t=t.valueOf()),"number"!=typeof t)throw new Error("Invalid timestamp value: "+t);if(this.__isTracking){if(this.__isTracking=!1,this.__isDragging&&(this.__isDragging=!1,this.__isSingleTouch&&t-this.__lastTouchMove<=100)){for(var e=this.__positions,n=e.length-1,i=n,r=n;r>0&&e[r]>this.__lastTouchMove-100;r-=2)i=r;if(i!==n){var o=e[n]-e[i],l=this.__scrollTop-e[i-1];this.__decelerationVelocityY=l/o*(1e3/60);Math.abs(this.__decelerationVelocityY)>4&&this.__startDeceleration(t)}}this.__isDecelerating||this.scrollTo(this.__scrollTop),this.__positions.length=0}},__publish:function(t,e){var n=this,i=n.__isAnimating;if(i&&(o.default.stop(i),n.__isAnimating=!1),e){n.__scheduledTop=t;var r=n.__scrollTop,s=t-r;n.__isAnimating=o.default.start(function(t,e,i){n.__scrollTop=r+s*t,n.__callback&&n.__callback(n.__scrollTop)},function(t){return n.__isAnimating===t},function(t,e,i){e===n.__isAnimating&&(n.__isAnimating=!1),(n.__didDecelerationComplete||i)&&n.__scrollingComplete()},e,i?l.easeOutCubic:l.easeInOutCubic)}else n.__scheduledTop=n.__scrollTop=t,n.__callback&&n.__callback(t)},__startDeceleration:function(t){var e=this;e.__minDecelerationScrollTop=e.__minScrollTop,e.__maxDecelerationScrollTop=e.__maxScrollTop;e.__isDecelerating=o.default.start(function(t,n,i){e.__stepThroughDeceleration(i)},function(){var t=Math.abs(e.__decelerationVelocityY)>=.5;return t||(e.__didDecelerationComplete=!0),t},function(t,n,i){e.__isDecelerating=!1,e.__scrollTop<=e.__minScrollTop||e.__scrollTop>=e.__maxScrollTop?e.scrollTo(e.__scrollTop):e.__didDecelerationComplete&&e.__scrollingComplete()})},__stepThroughDeceleration:function(t){var e=this.__scrollTop+this.__decelerationVelocityY,n=Math.max(Math.min(this.__maxDecelerationScrollTop,e),this.__minDecelerationScrollTop);n!==e&&(e=n,this.__decelerationVelocityY=0),Math.abs(this.__decelerationVelocityY)<=1?Math.abs(e%this.__itemHeight)<1&&(this.__decelerationVelocityY=0):this.__decelerationVelocityY*=.95,this.__publish(e)}};for(var _ in c)u.prototype[_]=c[_];t.exports=u},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=Date.now||function(){return+new Date},r={},o=1,l="undefined"==typeof window;!function(){if(!l){for(var t=0,e=["ms","moz","webkit","o"],n=0;n<e.length&&!window.requestAnimationFrame;++n)window.requestAnimationFrame=window[e[n]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[e[n]+"CancelAnimationFrame"]||window[e[n]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(e,n){var i=(new Date).getTime(),r=Math.max(0,16-(i-t)),o=window.setTimeout(function(){e(i+r)},r);return t=i+r,o}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(t){clearTimeout(t)})}}(),e.default={requestAnimationFrame:function(){if(l)return"";var t=window.requestAnimationFrame;return function(e,n){t(e,n)}}(),stop:function(t){var e=null!=r[t];return e&&(r[t]=null),e},isRunning:function(t){return null!=r[t]},start:function(t,e,n,l,s,a){var u=this,c=i(),_=c,h=0,f=0,d=o++;if(a||(a=document.body),d%20==0){var p={};for(var m in r)p[m]=!0;r=p}return r[d]=!0,u.requestAnimationFrame(function o(p){var m=!0!==p,v=i();if(!r[d]||e&&!e(d))return r[d]=null,void(n&&n(60-f/((v-c)/1e3),d,!1));if(m)for(var g=Math.round((v-_)/(1e3/60))-1,b=0;b<Math.min(g,4);b++)o(!0),f++;l&&(h=(v-c)/l)>1&&(h=1);var T=s?s(h):h;!1!==t(T,v,m)&&1!==h||!m?m&&(_=v,u.requestAnimationFrame(o,a)):(r[d]=null,n&&n(60-f/((v-c)/1e3),d,1===h||null==l))},a),d}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getElement=function(t){return"string"==typeof t?document.querySelector(t):t},e.getComputedStyle=function(t,e){return i?"":window.getComputedStyle(t)[e]||""},e.easeOutCubic=function(t){return Math.pow(t-1,3)+1},e.easeInOutCubic=function(t){if((t/=.5)<1)return.5*Math.pow(t,3);return.5*(Math.pow(t-2,3)+2)};var i="undefined"==typeof window},,,,,,,,,,,,,,,,,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){return t&&t.__esModule?t:{default:t}}(n(120));i.default.install=function(t){t.component("LxPicker",i.default)},e.default=i.default},function(t,e,n){"use strict";n.r(e);var i=n(50),r=n(38);for(var o in r)"default"!==o&&function(t){n.d(e,t,function(){return r[t]})}(o);n(123);var l=n(0),s=Object(l.a)(r.default,i.a,i.b,!1,null,null,null);s.options.__file="src\\components\\picker\\picker.vue",e.default=s.exports},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=s(n(20)),r=s(n(67)),o=s(n(68)),l=s(n(122));function s(t){return t&&t.__esModule?t:{default:t}}var a=function(){function t(e,n,i){(0,r.default)(this,t),this.data=e,this.count=n,i&&(this.fixedColumns=i)}return(0,o.default)(t,[{key:"getChildren",value:function(t){return(0,l.default)(this.data,function(e){return e.parent===t})}},{key:"getFirstColumn",value:function(){return(0,l.default)(this.data,function(t){return!t.parent||0===t.parent||"0"===t.parent})}},{key:"getPure",value:function(t){return JSON.parse((0,i.default)(t))}},{key:"getColumns",value:function(t){var e=this;t.length>0&&(this.getPure(this.data).filter(function(n){return e.getPure(t).indexOf(n.value)>-1}).length<this.getPure(t).length&&(t=[]));for(var n=[],i=this.fixedColumns||8,r=0;r<i;r++)if(0===r)n.push(this.getFirstColumn());else if(t[r])n.push(this.getChildren(t[r-1]));else{if(void 0===n[r-1][0])break;var o=n[r-1][0].value;n.push(this.getChildren(o))}var l=n.filter(function(t){return t.length>0});return this.count=l.length,l}}]),t}();e.default=a},function(t,e){t.exports=__webpack_require__("tX24")},function(t,e,n){"use strict";var i=n(40);n.n(i).a}])});

/***/ }),

/***/ "6WL6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _scroller = __webpack_require__("zFCM");

var _scroller2 = _interopRequireDefault(_scroller);

var _flexbox = __webpack_require__("MeU4");

var _flexbox2 = _interopRequireDefault(_flexbox);

var _flexboxItem = __webpack_require__("0/UE");

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

var _chain = __webpack_require__("v4qD");

var _chain2 = _interopRequireDefault(_chain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'picker',
  components: {
    Flexbox: _flexbox2.default,
    FlexboxItem: _flexboxItem2.default
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new _chain2.default(this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    }
  },
  methods: {
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;

      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new _scroller2.default(_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue && _this.currentValue !== value) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);

      if (this.scroller[i]) {
        this.scroller[i].destroy();
      }
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new _scroller2.default(ID, {
        data: list,
        itemClass: _this.itemClass,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });

      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);

      if (this.columns !== 0) {
        if (val.length > 0) {
          if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);

          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if ((0, _stringify2.default)(_this3.getValue()) !== (0, _stringify2.default)(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new _chain2.default(newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
};

/***/ }),

/***/ "6YX8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

exports.go = go;
exports.getUrl = getUrl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function go(url, $router) {
  if (/^javas/.test(url) || !url) return;
  var useRouter = (typeof url === 'undefined' ? 'undefined' : (0, _typeof3.default)(url)) === 'object' || $router && typeof url === 'string' && !/http/.test(url);
  if (useRouter) {
    $router.push(url);
  } else {
    window.location.href = url;
  }
}

function getUrl(url, $router) {
  if ($router && !$router._history && typeof url === 'string' && !/http/.test(url)) {
    return '#!' + url;
  }
  return url && (typeof url === 'undefined' ? 'undefined' : (0, _typeof3.default)(url)) !== 'object' ? url : 'javascript:void(0);';
}

/***/ }),

/***/ "6dZ4":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_cell"
  }, [_c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "textarea",
    staticClass: "weui_textarea",
    style: (_vm.textareaStyle),
    attrs: {
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "maxlength": _vm.max
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCounter && _vm.max),
      expression: "showCounter && max"
    }],
    staticClass: "weui_textarea_counter"
  }, [_c('span', [_vm._v(_vm._s(_vm.count))]), _vm._v("/" + _vm._s(_vm.max))])])])
},staticRenderFns: []}

/***/ }),

/***/ "6fN7":
/***/ (function(module, exports) {

/**
 * Vue.js 2.0 plugin
 *
 */

function formatComponentName(vm) {
  if (vm.$root === vm) {
    return 'root instance';
  }
  var name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
    (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '')
  );
}

function vuePlugin(Raven, Vue) {
  Vue = Vue || window.Vue;

  // quit if Vue isn't on the page
  if (!Vue || !Vue.config) return;

  var _oldOnError = Vue.config.errorHandler;
  Vue.config.errorHandler = function VueErrorHandler(error, vm, info) {
    var metaData = {
      componentName: formatComponentName(vm),
      propsData: vm.$options.propsData
    };

    // lifecycleHook is not always available
    if (typeof info !== 'undefined') {
      metaData.lifecycleHook = info;
    }

    Raven.captureException(error, {
      extra: metaData
    });

    if (typeof _oldOnError === 'function') {
      _oldOnError.call(this, error, vm, info);
    }
  };
}

module.exports = vuePlugin;


/***/ }),

/***/ "77Pl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "78dt":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-checker-box"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "7BQH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5Oyj");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("30f1a8b4", content, true);

/***/ }),

/***/ "7KvD":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "7OVk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventSplitter = /\s+/;

function Events() {}

Events.prototype.on = function (events, callback, context) {
  var cache, event, list;
  if (!callback) return this;
  cache = this.__events || (this.__events = {});
  events = events.split(eventSplitter);
  while (event = events.shift()) {
    list = cache[event] || (cache[event] = []);
    list.push(callback, context);
  }
  return this;
};
Events.prototype.once = function (events, callback, context) {
  var that = this;
  var cb = function cb() {
    that.off(events, cb);
    callback.apply(context || that, arguments);
  };
  return this.on(events, cb, context);
};

Events.prototype.off = function (events, callback, context) {
  var cache, event, list, i;

  if (!(cache = this.__events)) return this;
  if (!(events || callback || context)) {
    delete this.__events;
    return this;
  }
  events = events ? events.split(eventSplitter) : keys(cache);

  while (event = events.shift()) {
    list = cache[event];
    if (!list) continue;
    if (!(callback || context)) {
      delete cache[event];
      continue;
    }
    for (i = list.length - 2; i >= 0; i -= 2) {
      if (!(callback && list[i] !== callback || context && list[i + 1] !== context)) {
        list.splice(i, 2);
      }
    }
  }
  return this;
};

Events.prototype.trigger = function (events) {
  var cache, event, all, list, i, len;
  var rest = [];
  var returned = true;
  if (!(cache = this.__events)) return this;
  events = events.split(eventSplitter);

  for (i = 1, len = arguments.length; i < len; i++) {
    rest[i - 1] = arguments[i];
  }

  while (event = events.shift()) {
    if (all = cache.all) all = all.slice();
    if (list = cache[event]) list = list.slice();
    if (event !== 'all') {
      returned = triggerEvents(list, rest, this) && returned;
    }

    returned = triggerEvents(all, [event].concat(rest), this) && returned;
  }
  return returned;
};
Events.prototype.emit = Events.prototype.trigger;

var keys = _keys2.default;
if (!keys) {
  keys = function keys(o) {
    var result = [];
    for (var name in o) {
      if (o.hasOwnProperty(name)) {
        result.push(name);
      }
    }
    return result;
  };
}

Events.mixTo = function (receiver) {
  var proto = Events.prototype;
  if (isFunction(receiver)) {
    for (var key in proto) {
      if (proto.hasOwnProperty(key)) {
        receiver.prototype[key] = proto[key];
      }
    }
  } else {
    var event = new Events();
    for (var _key in proto) {
      if (proto.hasOwnProperty(_key)) {
        copyProto(_key);
      }
    }
  }

  function copyProto(key) {
    receiver[key] = function () {
      proto[key].apply(event, Array.prototype.slice.call(arguments));
      return this;
    };
  }
};

function triggerEvents(list, args, context) {
  var pass = true;
  if (list) {
    var i = 0;
    var l = list.length;
    var a1 = args[0];
    var a2 = args[1];
    var a3 = args[2];

    switch (args.length) {
      case 0:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context) !== false && pass;
        }
        break;
      case 1:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1) !== false && pass;
        }
        break;
      case 2:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass;
        }
        break;
      case 3:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass;
        }
        break;
      default:
        for (; i < l; i += 2) {
          pass = list[i].apply(list[i + 1] || context, args) !== false && pass;
        }
        break;
    }
  }

  return pass;
}

function isFunction(func) {
  return Object.prototype.toString.call(func) === '[object Function]';
}
module.exports = Events;

/***/ }),

/***/ "7RDZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cells_access .weui_cell:not(.no_access){-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_cells_access .weui_cell:not(.no_access):active{background-color:#ececec}.weui_cells_access a.weui_cell{color:inherit}.weui_cells_access .weui_cell_ft:after{content:\" \";display:inline-block;-webkit-transform:rotate(45deg);transform:rotate(45deg);height:6px;width:6px;border-width:2px 2px 0 0;border-color:#c8c8cd;border-style:solid;position:relative;top:-2px;top:-1px;margin-left:.3em}.weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.vux-no-group-title{margin-top:.26666667rem}.weui_cells>a{color:#000}", ""]);

// exports


/***/ }),

/***/ "7RVF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabbarItem = __webpack_require__("FaFR");

var _tabbarItem2 = _interopRequireDefault(_tabbarItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_tabbarItem2.default.install = function (Vue) {
  Vue.component('LxTabbarItem', _tabbarItem2.default);
};

exports.default = _tabbarItem2.default;

/***/ }),

/***/ "7UMu":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("R9M2");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "7dzo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    min: Number,
    max: Number,
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: [Number, String],
      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 50
    },
    readonly: {
      type: Boolean,
      default: false
    },
    shell: {
      type: Boolean,
      default: true
    },
    inputClasses: {
      type: String,
      default: ''
    },
    lockMin: {
      type: Boolean,
      default: false
    },
    lockMax: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : +this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : +this.currentValue >= this.max;
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  watch: {
    value: function value(nVal, oVal) {
      if (!/^[+-\d]?[\d]*(\.[\d]*)?$/.test(this.value)) {
        this.value = '0.00';
      }
      this.currentValue = this.value;
    },
    currentValue: function currentValue(newValue, old) {
      if (typeof this.currentValue === 'string') {
        var isSymbol = /[+-.]/.test(this.currentValue.substr(0, 1));
        if (isSymbol) {
          this.currentValue = this.currentValue.substr(0, 1) + this.currentValue.substr(1).replace(/[^\d.]/g, '');
        } else {
          this.currentValue = this.currentValue.replace(/[^\d.]/g, '');
        }
      }
      if (this.min && +this.currentValue < this.min && !this.lockMin) {
        this.currentValue = this.min;
      }
      if (this.max && +this.currentValue > this.max && !this.lockMax) {
        this.currentValue = this.max;
      }
      this.$emit('on-change', this.currentValue);
      this.$emit('input', this.currentValue);
    }
  },
  methods: {
    focus: function focus(e) {
      this.$emit('on-focus', e);
    },
    blur: function blur(e) {
      this.$emit('on-blur', e);
    },
    add: function add() {
      if (!this.disabledMax) {
        this.currentValue = +this.currentValue + this.step;
        this.currentValue = this.currentValue.toFixed(2);
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        this.currentValue = +this.currentValue - this.step;
        this.currentValue = this.currentValue.toFixed(2);
      }
    }
  }
};

/***/ }),

/***/ "7lvc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("34oW");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2b4f5255", content, true);

/***/ }),

/***/ "82Mu":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var macrotask = __webpack_require__("L42u").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("R9M2")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "880/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hJx8");


/***/ }),

/***/ "8ZMC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  created: function created() {
    this.uuid = Math.random().toString(36).substring(3, 8);
  }
};

/***/ }),

/***/ "8toS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("5zA6");

exports.default = {
  mixins: [_multiItems.parentMixin],
  props: {
    height: Number
  }
};

/***/ }),

/***/ "8vQr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "944h":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("xnc0")

var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  __webpack_require__("5LpO"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "94VQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("Yobk");
var descriptor = __webpack_require__("X8DO");
var setToStringTag = __webpack_require__("e6n0");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("hJx8")(IteratorPrototype, __webpack_require__("dSzd")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "96pW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Dhg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".selector-parent{position:relative}.selector-list{position:absolute;left:0;top:0;bottom:0;right:0;background:#eee}.selector-list input[type=radio]{width:100%;height:100%;position:absolute;top:0;opacity:0}.selector-list input[type=radio]+.check_item_input{opacity:0;position:relative;z-index:11;width:.86rem;height:.96rem}.selector-list input[type=radio]:checked+.check_item_icon{background:#509eff;border:.08rem solid #fff;box-shadow:0 0 0 1px #509eff}.selector-list .vux-label-desc{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;padding-right:.4rem}.selector-list .weui_cell_ft{width:.8rem}.selector-list .check_item_icon{position:absolute;right:.4rem;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:.45333333rem;height:.45333333rem;border:1px solid #e7e7e7;border-radius:50%;box-sizing:border-box}.selector-list .weui_cell_primary{line-height:24px;overflow:hidden}.selector-list .search_input .weui_input{line-height:.66666667rem}.selector-list .search_input{background-color:#eee;padding:.26666667rem .4rem;font-size:15px;border-radius:.05333333rem}.selector-list .search_input .weui_cell{padding:.2rem .4rem;background-color:#fff}.selector-list .search_input .search_icon{width:.53333333rem;margin-bottom:-.13333333rem;margin-left:.13333333rem}.selector-list .weui_cells_title{padding-top:0}.selector-list .no-record{margin:0 auto;padding:3.33333333rem 0 .66666667rem;text-align:center;color:#000;opacity:.4;font-size:.4rem}", ""]);

// exports


/***/ }),

/***/ "9JMe":
/***/ (function(module, exports) {

exports.sync = function (store, router, options) {
  var moduleName = (options || {}).moduleName || 'route'

  store.registerModule(moduleName, {
    namespaced: true,
    state: cloneRoute(router.currentRoute),
    mutations: {
      'ROUTE_CHANGED': function ROUTE_CHANGED (state, transition) {
        store.state[moduleName] = cloneRoute(transition.to, transition.from)
      }
    }
  })

  var isTimeTraveling = false
  var currentPath

  // sync router on store change
  var storeUnwatch = store.watch(
    function (state) { return state[moduleName]; },
    function (route) {
      var fullPath = route.fullPath;
      if (fullPath === currentPath) {
        return
      }
      if (currentPath != null) {
        isTimeTraveling = true
        router.push(route)
      }
      currentPath = fullPath
    },
    { sync: true }
  )

  // sync store on router navigation
  var afterEachUnHook = router.afterEach(function (to, from) {
    if (isTimeTraveling) {
      isTimeTraveling = false
      return
    }
    currentPath = to.fullPath
    store.commit(moduleName + '/ROUTE_CHANGED', { to: to, from: from })
  })

  return function unsync () {
    // On unsync, remove router hook
    if (afterEachUnHook != null) {
      afterEachUnHook()
    }

    // On unsync, remove store watch
    if (storeUnwatch != null) {
      storeUnwatch()
    }

    // On unsync, unregister Module with store
    store.unregisterModule(moduleName)
  }
}

function cloneRoute (to, from) {
  var clone = {
    name: to.name,
    path: to.path,
    hash: to.hash,
    query: to.query,
    params: to.params,
    fullPath: to.fullPath,
    meta: to.meta
  }
  if (from) {
    clone.from = cloneRoute(from)
  }
  return Object.freeze(clone)
}



/***/ }),

/***/ "9MTE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: {
      type: String,
      default: 'vux-fade'
    },
    width: {
      type: String,
      default: '100/@w'
    },
    text: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    toastClass: function toastClass() {
      return {
        'weui_toast_forbidden': this.type === 'warn',
        'weui_toast_cancel': this.type === 'cancel',
        'weui_toast_success': this.type === 'success',
        'weui_toast_text': this.type === 'text'
      };
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('on-show');
        this.$emit('input', true);
      }
      if (val) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
};

/***/ }),

/***/ "9R7u":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_cells_title"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "9kVz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("5zA6");

exports.default = {
  mixins: [_multiItems.childMixin],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'no-border-right': this.shouldRemoveBorder
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  },
  data: function data() {
    return {
      shouldRemoveBorder: false
    };
  }
};

/***/ }),

/***/ "9mmv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, list) {
  var rs = (0, _arrayMap2.default)(value, function (one, index) {
    return (0, _arrayFind2.default)(list, function (item) {
      return item.value === one;
    });
  });
  return (0, _arrayMap2.default)(rs, function (one) {
    return one ? one.name : '';
  }).join(' ').replace('--', '');
};

var _arrayMap = __webpack_require__("diSF");

var _arrayMap2 = _interopRequireDefault(_arrayMap);

var _arrayFind = __webpack_require__("NXHL");

var _arrayFind2 = _interopRequireDefault(_arrayFind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "9mvZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    gap: String
  }
};

/***/ }),

/***/ "9w9E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineDesc = __webpack_require__("hc1C");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    InlineDesc: _inlineDesc2.default
  },
  computed: {
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return {
        width: width
      };
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: Boolean,
      default: false
    },
    inlineDesc: String
  },

  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
};

/***/ }),

/***/ "9waS":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui_loading_toast"
  }, [_c('div', {
    staticClass: "weui_mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui_toast",
    style: ({
      position: _vm.position
    })
  }, [_c('div', {
    staticClass: "weui_loading"
  }, _vm._l((12), function(i) {
    return _c('div', {
      staticClass: "weui_loading_leaf",
      class: ['weui_loading_leaf_' + (i - 1)]
    })
  })), _vm._v(" "), _c('p', {
    staticClass: "weui_toast_content"
  }, [_vm._v(_vm._s(_vm.text)), _vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ "A0Zp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3");
// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
var _once = function(func) {
  var ran = false,
    memo;
  return function() {
    if (ran) return memo;
    ran = true;
    memo = func.apply(this, arguments);
    func = null;
    return memo;
  };
};


/**
 * @discription events
 * @mixin
 */
var Events = {
  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  on: function(name, callback, context) {
    if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
    this._events || (this._events = {});
    var events = this._events[name] || (this._events[name] = []);
    events.push({
      callback: callback,
      context: context,
      ctx: context || this
    });
    return this;
  },


  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, it will be removed.
  once: function(name, callback, context) {
    if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
    var self = this;
    var once = _once(function() {
      self.off(name, once);
      callback.apply(this, arguments);
    });
    once._callback = callback;
    return this.on(name, once, context);
  },

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  off: function(name, callback, context) {
    if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;

    // Remove all callbacks for all events.
    if (!name && !callback && !context) {
      this._events = void 0;
      return this;
    }

    var names = name ? [name] : Object.keys(this._events);
    for (var i = 0, length = names.length; i < length; i++) {
      name = names[i];

      // Bail out if there are no events stored.
      var events = this._events[name];
      if (!events) continue;

      // Remove all callbacks for this event.
      if (!callback && !context) {
        delete this._events[name];
        continue;
      }

      // Find any remaining events.
      var remaining = [];
      for (var j = 0, k = events.length; j < k; j++) {
        var event = events[j];
        if (
          callback && callback !== event.callback &&
          callback !== event.callback._callback ||
          context && context !== event.context
        ) {
          remaining.push(event);
        }
      }

      // Replace events if there are any remaining.  Otherwise, clean up.
      if (remaining.length) {
        this._events[name] = remaining;
      } else {
        delete this._events[name];
      }
    }

    return this;
  },

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  trigger: function(name) {
    if (!this._events) return this;
    var args = Array.prototype.slice.call(arguments, 1);
    if (!eventsApi(this, 'trigger', name, args)) return this;
    var events = this._events[name];
    var allEvents = this._events.all;
    if (events) triggerEvents(events, args);
    if (allEvents) triggerEvents(allEvents, arguments);
    return this;
  },

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  listenTo: function(obj, name, callback) {
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var id = obj._listenId || (obj._listenId = Util.guid('l'));
    listeningTo[id] = obj;
    if (!callback && typeof name === 'object') callback = this;
    obj.on(name, callback, this);
    return this;
  },

  listenToOnce: function(obj, name, callback) {
    if (typeof name === 'object') {
      for (var event in name) this.listenToOnce(obj, event, name[event]);
      return this;
    }
    var cb = _once(function() {
      this.stopListening(obj, name, cb);
      callback.apply(this, arguments);
    });
    cb._callback = callback;
    return this.listenTo(obj, name, cb);
  },

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  stopListening: function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;
    var remove = !name && !callback;
    if (!callback && typeof name === 'object') callback = this;
    if (obj)(listeningTo = {})[obj._listenId] = obj;
    for (var id in listeningTo) {
      obj = listeningTo[id];
      obj.off(name, callback, this);
      if (remove || Util.isEmpty(obj._events)) delete this._listeningTo[id];
    }
    return this;
  }

};

// Regular expression used to split event strings.
var eventSplitter = /\s+/;

// Implement fancy features of the Events API such as multiple event
// names `"change blur"` and jQuery-style event maps `{change: action}`
// in terms of the existing API.
var eventsApi = function(obj, action, name, rest) {
  if (!name) return true;

  // Handle event maps.
  if (typeof name === 'object') {
    for (var key in name) {
      obj[action].apply(obj, [key, name[key]].concat(rest));
    }
    return false;
  }

  // Handle space separated event names.
  if (eventSplitter.test(name)) {
    var names = name.split(eventSplitter);
    for (var i = 0, length = names.length; i < length; i++) {
      obj[action].apply(obj, [names[i]].concat(rest));
    }
    return false;
  }

  return true;
};

// A difficult-to-believe, but optimized internal dispatch function for
// triggering events. Tries to keep the usual cases speedy (most internal
var triggerEvents = function(events, args) {
  var ev, i = -1,
    l = events.length,
    a1 = args[0],
    a2 = args[1],
    a3 = args[2];
  switch (args.length) {
    case 0:
      while (++i < l)(ev = events[i]).callback.call(ev.ctx);
      return;
    case 1:
      while (++i < l)(ev = events[i]).callback.call(ev.ctx, a1);
      return;
    case 2:
      while (++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2);
      return;
    case 3:
      while (++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
      return;
    default:
      while (++i < l)(ev = events[i]).callback.apply(ev.ctx, args);
      return;
  }
};

// Aliases for backwards compatibility.
Events.bind = Events.on;
Events.unbind = Events.off;

if (typeof module == 'object' && module.exports) {
  module.exports = Events;
}


/***/ }),

/***/ "ABbd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _countup = __webpack_require__("uOiQ");

var _countup2 = _interopRequireDefault(_countup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_countup2.default.install = function (Vue) {
  Vue.component('LxCountup', _countup2.default);
};

exports.default = _countup2.default;

/***/ }),

/***/ "AOR+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "APE8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.vux-popup-picker{border-top:1px solid #04be02}.vux-popup-picker-header{height:1.17333333rem;color:#5890ff}.vux-popup-picker-value{display:inline-block}.vue-popup-cancel{text-align:left;padding-left:.4rem;line-height:1.17333333rem;color:#000}.vue-popup-confirm{text-align:right;padding-right:.4rem;line-height:1.17333333rem}.cvux-popup-placeholder{color:#a0a0a0}", ""]);

// exports


/***/ }),

/***/ "Aa8e":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-checker-item{display:inline-block}", ""]);

// exports


/***/ }),

/***/ "Amue":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "@font-face{font-weight:400;font-style:normal;font-family:weui;src:url(\"data:application/octet-stream;base64,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\") format(\"truetype\")}[class*=\" weui_icon_\"]:before,[class^=weui_icon_]:before{font-family:weui;font-style:normal;font-weight:400;speak:none;display:inline-block;vertical-align:middle;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em}.weui_icon_circle:before{content:\"\\EA01\"}.weui_icon_download:before{content:\"\\EA02\"}.weui_icon_info:before{content:\"\\EA03\"}.weui_icon_safe_success:before{content:\"\\EA04\"}.weui_icon_safe_warn:before{content:\"\\EA05\"}.weui_icon_success:before{content:\"\\EA06\"}.weui_icon_success_circle:before{content:\"\\EA07\"}.weui_icon_success_no_circle:before{content:\"\\EA08\"}.weui_icon_waiting:before{content:\"\\EA09\"}.weui_icon_waiting_circle:before{content:\"\\EA0A\"}.weui_icon_warn:before{content:\"\\EA0B\"}.weui_icon_info_circle:before{content:\"\\EA0C\"}.weui_icon_cancel:before{content:\"\\EA0D\"}.weui_icon_search:before{content:\"\\EA0E\"}.weui_icon_clear:before{content:\"\\EA0F\"}[class*=\" weui_icon_\"]:before,[class^=weui_icon_]:before{margin:0}.weui_icon_success:before{font-size:23px;color:#09bb07}.weui_icon_waiting:before{font-size:23px;color:#10aeff}.weui_icon_warn:before{font-size:23px;color:#f43530}.weui_icon_info:before{font-size:23px;color:#10aeff}.weui_icon_success_circle:before,.weui_icon_success_no_circle:before{font-size:23px;color:#09bb07}.weui_icon_waiting_circle:before{font-size:23px;color:#10aeff}.weui_icon_circle:before{font-size:23px;color:#c9c9c9}.weui_icon_download:before,.weui_icon_info_circle:before{font-size:23px;color:#09bb07}.weui_icon_safe_success:before{color:#09bb07}.weui_icon_safe_warn:before{color:#ffbe00}.weui_icon_cancel:before{color:#f43530;font-size:22px}.weui_icon_clear:before,.weui_icon_search:before{color:#b2b2b2;font-size:14px}.weui_icon_msg:before{font-size:104px}.weui_icon_warn.weui_icon_msg:before{color:#f76260}.icon_big:before,.weui_icon_safe:before{font-size:104px}.icon_small:before{font-size:12px}", ""]);

// exports


/***/ }),

/***/ "AoOK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colorPicker = __webpack_require__("kWsW");

var _colorPicker2 = _interopRequireDefault(_colorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_colorPicker2.default.install = function (Vue) {
  Vue.component('LxColorPicker', _colorPicker2.default);
};

exports.default = _colorPicker2.default;

/***/ }),

/***/ "Atmb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radio = __webpack_require__("BKAG");

var _radio2 = _interopRequireDefault(_radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_radio2.default.install = function (Vue) {
  Vue.component('LxRadio', _radio2.default);
};

exports.default = _radio2.default;

/***/ }),

/***/ "AzoK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _photoswipe = __webpack_require__("hLg7");

var _photoswipe2 = _interopRequireDefault(_photoswipe);

var _photoswipeUiDefault = __webpack_require__("fzln");

var _photoswipeUiDefault2 = _interopRequireDefault(_photoswipeUiDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    init: function init(index) {
      var _this = this;

      var options = (0, _assign2.default)({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new _photoswipe2.default(this.$el, _photoswipeUiDefault2.default, this.list, options);
      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
    },
    show: function show(index) {
      this.init(index);
    },
    close: function close() {
      this.photoswipe.close();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};

/***/ }),

/***/ "B/Q7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buttonTabItem = __webpack_require__("eb4a");

var _buttonTabItem2 = _interopRequireDefault(_buttonTabItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_buttonTabItem2.default.install = function (Vue) {
  Vue.component('LxButtonTabItem', _buttonTabItem2.default);
};

exports.default = _buttonTabItem2.default;

/***/ }),

/***/ "BEQ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "BKAG":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("w6eq")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("hxh1"),
  /* template */
  __webpack_require__("ERXJ"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "BO1k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fxRn"), __esModule: true };

/***/ }),

/***/ "BTc1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElement = getElement;
exports.getComputedStyle = getComputedStyle;
exports.easeOutCubic = easeOutCubic;
exports.easeInOutCubic = easeInOutCubic;
var isServer = typeof window === 'undefined';
function getElement(expr) {
  return typeof expr === 'string' ? document.querySelector(expr) : expr;
}

function getComputedStyle(el, key) {
  if (isServer) return '';
  var computedStyle = window.getComputedStyle(el);
  return computedStyle[key] || '';
}

function easeOutCubic(pos) {
  return Math.pow(pos - 1, 3) + 1;
}

function easeInOutCubic(pos) {
  if ((pos /= 0.5) < 1) {
    return 0.5 * Math.pow(pos, 3);
  }
  return 0.5 * (Math.pow(pos - 2, 3) + 2);
}

/***/ }),

/***/ "BWGA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_progress{display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_progress_bar{background-color:#ebebeb;height:3px;-webkit-flex:1;flex:1}.weui_progress_inner_bar{width:0;height:100%;background-color:#09bb07}.weui_progress_opr{display:block;margin-left:15px;font-size:0}", ""]);

// exports


/***/ }),

/***/ "BYrx":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('cell', {
    attrs: {
      "title": _vm.title,
      "primary": "content",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.currentValue) + "\n  ")]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('inline-calendar', {
    attrs: {
      "render-month": _vm.renderMonth,
      "start-date": _vm.startDate,
      "end-date": _vm.endDate,
      "show-last-month": _vm.showLastMonth,
      "show-next-month": _vm.showNextMonth,
      "highlight-weekend": _vm.highlightWeekend,
      "return-six-rows": _vm.returnSixRows,
      "hide-header": _vm.hideHeader,
      "hide-week-list": _vm.hideWeekList,
      "replace-text-list": _vm.replaceTextList,
      "weeks-list": _vm.weeksList,
      "custom-slot-fn": _vm.customSlotFn,
      "render-on-value-change": _vm.renderOnValueChange,
      "disable-past": _vm.disablePast,
      "disable-future": _vm.disableFuture
    },
    on: {
      "on-change": _vm.onSelect
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "Bahx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var alphanumeric = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'delete', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'end'];

exports.default = alphanumeric;

/***/ }),

/***/ "BkBg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-button-group{display:-webkit-flex;display:flex}.vux-button-group>a{display:block;-webkit-flex:1;flex:1;width:100%;height:30px;padding:0;font-size:14px;line-height:31px;text-align:center;border:1px solid #d2d2d2;border-width:1px 1px 1px 0;color:#999;white-space:nowrap;background:#fdfdfd}.vux-button-group>a.hover,.vux-button-group>a.vux-button-group-current,.vux-button-group>a:active{border-color:#5890ff;color:#fff;background:#5890ff}.vux-button-group>a:first-child{border-width:1px;background-clip:padding-box}.vux-button-group>a:last-child{background-clip:padding-box}.vux-button-group>a.vux-button-group-current:disabled,.vux-button-group>a:disabled{border-color:#cdcdcd;background:#e5e5e5;box-shadow:0 1px 0 hsla(0,0%,100%,.6);text-shadow:0 1px 0 hsla(0,0%,100%,.8);color:#aaa}.vux-button-group .no-border-right{border-right-width:0!important}", ""]);

// exports


/***/ }),

/***/ "BwfY":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("fWfb");
__webpack_require__("M6a0");
__webpack_require__("OYls");
__webpack_require__("QWe/");
module.exports = __webpack_require__("FeBl").Symbol;


/***/ }),

/***/ "BxAf":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ieD3"),
  /* template */
  __webpack_require__("CMfq"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Bz5S":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("2xnn")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Cj+J"),
  /* template */
  __webpack_require__("a1VJ"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "BzPr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("j4p2");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xDialog2.default.install = function (Vue) {
  Vue.component('LxXDialog', _xDialog2.default);
};

exports.default = _xDialog2.default;

/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "C6hE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CFqi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__("fcJk");

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),

/***/ "CHhj":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Amue");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("32daaece", content, true);

/***/ }),

/***/ "CJig":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("dxOV")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("1yli"),
  /* template */
  __webpack_require__("sFQ0"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "CMfq":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popup-picker', {
    attrs: {
      "fixed-columns": _vm.hideDistrict ? 2 : 0,
      "columns": 3,
      "data": _vm.list,
      "title": _vm.title,
      "show-name": _vm.showName,
      "show-second-name": _vm.showSecondName,
      "inline-desc": _vm.inlineDesc,
      "placeholder": _vm.placeholder,
      "value-text-align": _vm.valueTextAlign
    },
    on: {
      "on-hide": _vm.emitHide,
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ "CO1h":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.vux-flexbox{width:100%;text-align:left;display:-webkit-flex;display:flex;box-align:center;-webkit-align-items:center;align-items:center}.vux-flexbox .vux-flexbox-item{-webkit-flex:1;flex:1;min-width:.53333333rem;width:0}.vux-flexbox-item>.vux-flexbox{width:100%}.vux-flexbox .vux-flexbox-item:first-child{margin-left:0!important;margin-top:0!important}.vux-flex-col{box-orient:vertical;-webkit-flex-direction:column;flex-direction:column}.vux-flex-col>.vux-flexbox-item{width:100%}.vux-flex-row{box-direction:row;box-orient:horizontal;-webkit-flex-direction:row;flex-direction:row}", ""]);

// exports


/***/ }),

/***/ "COnS":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var i=e();for(var o in i)("object"==typeof exports?exports:t)[o]=i[o]}}(window,function(){return function(t){var e={};function i(o){if(e[o])return e[o].exports;var n=e[o]={i:o,l:!1,exports:{}};return t[o].call(n.exports,n,n.exports,i),n.l=!0,n.exports}return i.m=t,i.c=e,i.d=function(t,e,o){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(i.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var n in t)i.d(o,n,function(e){return t[e]}.bind(null,n));return o},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=52)}({0:function(t,e,i){"use strict";function o(t,e,i,o,n,s,r,u){var a,l="function"==typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=i,l._compiled=!0),o&&(l.functional=!0),s&&(l._scopeId="data-v-"+s),r?(a=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),n&&n.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},l._ssrRegister=a):n&&(a=u?function(){n.call(this,this.$root.$options.shadowRoot)}:n),a)if(l.functional){l._injectStyles=a;var p=l.render;l.render=function(t,e){return a.call(e),p(t,e)}}else{var d=l.beforeCreate;l.beforeCreate=d?[].concat(d,a):[a]}return{exports:t,options:l}}i.d(e,"a",function(){return o})},10:function(t,e,i){},25:function(t,e){t.exports=__webpack_require__("fZjL")},29:function(t,e,i){"use strict";var o=function(){var t=this.$createElement;return(this._self._c||t)("div",{directives:[{name:"show",rawName:"v-show",value:this.show,expression:"show"}],staticClass:"vux-popup",style:{height:this.height},attrs:{transition:"vux-popup"}},[this._t("default")],2)},n=[];o._withStripped=!0,i.d(e,"a",function(){return o}),i.d(e,"b",function(){return n})},52:function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=function(t){return t&&t.__esModule?t:{default:t}}(i(53));o.default.install=function(t){t.component("LxPopup",o.default)},e.default=o.default},53:function(t,e,i){"use strict";i.r(e);var o=i(29),n=i(8);for(var s in n)"default"!==s&&function(t){i.d(e,t,function(){return n[t]})}(s);i(55);var r=i(0),u=Object(r.a)(n.default,o.a,o.b,!1,null,null,null);u.options.__file="src\\components\\popup\\popup.vue",e.default=u.exports},54:function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),"undefined"==typeof window||(window.__$vuxPopups=window.__$vuxPopups||{});var o=function(t){this.uuid=Math.random().toString(36).substring(3,8),this.params={},this.isShow=!1,"[object Object]"===Object.prototype.toString.call(t)&&(this.params={input:t.input||"",container:document.querySelector(t.input)||"",innerHTML:t.innerHTML||"",hideOnBlur:t.hideOnBlur,onOpen:t.onOpen||function(){},onClose:t.onClose||function(){}}),!!document.querySelectorAll(".vux-popup-mask").length<=0&&(this.divMask=document.createElement("a"),this.divMask.className="vux-popup-mask",this.divMask.dataset.uuid="",this.divMask.href="javascript:void(0)",document.body.appendChild(this.divMask));var e=void 0;return(e=t.container?t.container:document.createElement("div")).className="vux-popup-dialog vux-popup-dialog-"+this.uuid,t.container||document.body.appendChild(e),this.container=document.querySelector(".vux-popup-dialog-"+this.uuid),this.mask=document.querySelector(".vux-popup-mask"),this.mask.dataset.uuid+=","+this.uuid,this._bindEvents(),t=null,this};o.prototype.onClickMask=function(){this.params.hideOnBlur&&this.isShow&&this.hide(!1)},o.prototype._bindEvents=function(){this.params.hideOnBlur&&this.mask.addEventListener("click",this.onClickMask.bind(this),!1)},o.prototype.show=function(){this.mask.classList.add("vux-popup-show"),this.container.classList.add("vux-popup-show"),this.params.onOpen&&this.params.onOpen(this),this.isShow=!0,window.__$vuxPopups[this.uuid]=1},o.prototype.hide=function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.container.classList.remove("vux-popup-show"),document.querySelector(".vux-popup-dialog.vux-popup-show")||this.mask.classList.remove("vux-popup-show"),!1===t&&this.params.onClose&&this.params.hideOnBlur&&this.params.onClose(this),this.isShow=!1,delete window.__$vuxPopups[this.uuid]},o.prototype.html=function(t){this.container.innerHTML=t},o.prototype.destroy=function(){this.mask.dataset.uuid=this.mask.dataset.uuid.replace(new RegExp(","+this.uuid,"g"),""),this.mask.dataset.uuid?this.hide():(this.mask.removeEventListener("click",this.onClickMask.bind(this),!1),this.mask&&this.mask.parentNode&&this.mask.parentNode.removeChild(this.mask)),delete window.__$vuxPopups[this.uuid]},e.default=o},55:function(t,e,i){"use strict";var o=i(10);i.n(o).a},8:function(t,e,i){"use strict";i.r(e);var o=i(9),n=i.n(o);for(var s in o)"default"!==s&&function(t){i.d(e,t,function(){return o[t]})}(s);e.default=n.a},9:function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=s(i(25)),n=s(i(54));function s(t){return t&&t.__esModule?t:{default:t}}e.default={props:{value:Boolean,height:{type:String,default:"auto"},hideOnBlur:{type:Boolean,default:!0}},mounted:function(){this.show=this.value;var t=this;this.popup=new n.default({container:t.$el,innerHTML:"",hideOnBlur:t.hideOnBlur,onOpen:function(e){t.fixSafariOverflowScrolling("auto"),t.show=!0},onClose:function(e){t.show=!1,(0,o.default)(window.__$vuxPopups).length>=1||t.fixSafariOverflowScrolling("touch")}}),this.$overflowScrollingList=document.querySelectorAll(".vux-fix-safari-overflow-scrolling")},methods:{fixSafariOverflowScrolling:function(t){if(this.$overflowScrollingList.length&&/iphone/i.test(navigator.userAgent))for(var e=0;e<this.$overflowScrollingList.length;e++)this.$overflowScrollingList[e].style.webkitOverflowScrolling=t}},data:function(){return{hasFirstShow:!1,show:!1}},watch:{value:function(){this.show=this.value},show:function(t){t?(this.popup.show(),this.$emit("on-show"),this.hasFirstShow||(this.$emit("on-first-show"),this.hasFirstShow=!0)):(this.$emit("on-hide"),this.show=!1,this.popup.hide(!1)),this.$emit("input",t)}},beforeDestroy:function(){this.popup.destroy(),this.fixSafariOverflowScrolling("touch")}}}})});

/***/ }),

/***/ "CT+H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3"),
  Base = __webpack_require__("5dD5"),
  Core = __webpack_require__("MeUp"),
  Animate = __webpack_require__("W0DV"),
  Hammer = __webpack_require__("ZOvT"),
  ScrollBar = __webpack_require__("gjhP"),
  Controller = __webpack_require__("FsCZ");
//reduced boundry pan distance
var PAN_RATE = 1 - 0.618;
//constant for scrolling acceleration
var SCROLL_ACCELERATION = 0.0005;
//constant for outside of boundry acceleration
var BOUNDRY_ACCELERATION = 0.03;
//transform-origin
var transformOrigin = Util.prefixStyle("transformOrigin");
//transform
var transform = Util.prefixStyle("transform");
/** 
 * @constructor
 * @param {object} cfg config for scroll
 * @param {number} cfg.SCROLL_ACCELERATION  acceleration for scroll, min value make the scrolling smoothly
 * @param {number} cfg.BOUNDRY_CHECK_DURATION duration for boundry bounce
 * @param {number} cfg.BOUNDRY_CHECK_EASING easing for boundry bounce
 * @param {number} cfg.BOUNDRY_CHECK_ACCELERATION acceleration for boundry bounce
 * @param {boolean} cfg.lockX just like overflow-x:hidden
 * @param {boolean} cfg.lockY just like overflow-y:hidden
 * @param {boolean} cfg.scrollbarX config if the scrollbar-x is visible
 * @param {boolean} cfg.scrollbarY config if the scrollbar-y is visible
 * @param {boolean} cfg.useTransition config if use css3 transition or raf for scroll animation
 * @param {boolean} cfg.bounce config if use has the bounce effect when scrolling outside of the boundry
 * @param {boolean} cfg.boundryCheck config if scrolling inside of the boundry
 * @param {boolean} cfg.preventDefault prevent touchstart
 * @param {boolean} cfg.preventTouchMove prevent touchmove
 * @param {string|HTMLElement}  cfg.container config for scroller's container which default value is ".xs-container"
 * @param {string|HTMLElement}  cfg.content config for scroller's content which default value is ".xs-content"
 * @param {object}  cfg.indicatorInsets  config scrollbars position {top: number, left: number, bottom: number, right: number}
 * @param {string}  cfg.stickyElements config for sticky-positioned elements
 * @param {string}  cfg.fixedElements config for fixed-positioned elements
 * @param {string}  cfg.touchAction config for touchAction of the scroller
 * @extends XScroll
 * @example
 * var xscroll = new SimuScroll({
 *    renderTo:"#scroll",
 *    lockX:false,
 *    scrollbarX:true
 * });
 * xscroll.render();
 */
function SimuScroll(cfg) {
  SimuScroll.superclass.constructor.call(this, cfg);
}

Util.extend(SimuScroll, Core, {
  /** 
   * @memberof SimuScroll
   * @override
   */
  init: function() {
    var self = this;
    var defaultCfg = {
      preventDefault: true,
      preventTouchMove: true
    };
    SimuScroll.superclass.init.call(this);
    self.userConfig = Util.mix(defaultCfg, self.userConfig);
    self.SCROLL_ACCELERATION = self.userConfig.SCROLL_ACCELERATION || SCROLL_ACCELERATION;
    self.BOUNDRY_ACCELERATION = self.userConfig.BOUNDRY_ACCELERATION || BOUNDRY_ACCELERATION;
    self._initContainer();
    self.resetSize();
    //set overflow behaviors
    self._setOverflowBehavior();
    self.defaltConfig = {
      lockY: self.userConfig.lockY,
      lockX: self.userConfig.lockX
    }
    return self;
  },
  destroy: function() {
    var self = this;
    SimuScroll.superclass.destroy.call(this);
    self.renderTo.style.overflow = "";
    self.renderTo.style.touchAction = "";
    self.container.style.transform = "";
    self.container.style.transformOrigin = "";
    self.content.style.transform = "";
    self.content.style.transformOrigin = "";
    self.off("touchstart mousedown", self._ontouchstart);
    self.off("touchmove", self._ontouchmove);
    self.destroyScrollBars();
  },
  /**
   * set overflow behavior
   * @return {boolean} [description]
   */
  _setOverflowBehavior: function() {
    var self = this;
    var renderTo = self.renderTo;
    var computeStyle = getComputedStyle(renderTo);
    self.userConfig.lockX = undefined === self.userConfig.lockX ? ((computeStyle['overflow-x'] == "hidden" || self.width == self.containerWidth) ? true : false) : self.userConfig.lockX;
    self.userConfig.lockY = undefined === self.userConfig.lockY ? ((computeStyle['overflow-y'] == "hidden" || self.height == self.containerHeight) ? true : false) : self.userConfig.lockY;
    self.userConfig.scrollbarX = undefined === self.userConfig.scrollbarX ? (self.userConfig.lockX ? false : true) : self.userConfig.scrollbarX;
    self.userConfig.scrollbarY = undefined === self.userConfig.scrollbarY ? (self.userConfig.lockY ? false : true) : self.userConfig.scrollbarY;
    return self;
  },
  /**
   * reset lockX or lockY config to the default value
   */
  _resetLockConfig: function() {
    var self = this;
    self.userConfig.lockX = self.defaltConfig.lockX;
    self.userConfig.lockY = self.defaltConfig.lockY;
    return self;
  },
  /**
   * init container
   * @override
   * @return {SimuScroll}
   */
  _initContainer: function() {
    var self = this;
    SimuScroll.superclass._initContainer.call(self);
    if (self.__isContainerInited || !self.container || !self.content) return;
    self.container.style[transformOrigin] = "0 0";
    self.content.style[transformOrigin] = "0 0";
    self.translate(0, 0);
    self.__isContainerInited = true;
    return self;
  },
  /**
   * get scroll top value
   * @memberof SimuScroll
   * @return {number} scrollTop
   */
  getScrollTop: function() {
    var transY = window.getComputedStyle(this.container)[transform].match(/[-\d\.*\d*]+/g);
    return transY ? Math.round(transY[5]) === 0 ? 0 : -Math.round(transY[5]) : 0;
  },
  /**
   * get scroll left value
   * @memberof SimuScroll
   * @return {number} scrollLeft
   */
  getScrollLeft: function() {
    var transX = window.getComputedStyle(this.content)[transform].match(/[-\d\.*\d*]+/g);
    return transX ? Math.round(transX[4]) === 0 ? 0 : -Math.round(transX[4]) : 0;
  },
  /**
   * horizontal scroll absolute to the destination
   * @memberof SimuScroll
   * @param scrollLeft {number} scrollLeft
   * @param duration {number} duration for animte
   * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
   **/
  scrollLeft: function(x, duration, easing, callback) {
    if (this.userConfig.lockX) return;
    var translateZ = this.userConfig.gpuAcceleration ? " translateZ(0) " : "";
    this.x = (undefined === x || isNaN(x) || 0 === x) ? 0 : -Math.round(x);
    this._animate("x", "translateX(" + this.x + "px) scale(" + this.scale + ")" + translateZ, duration, easing, callback);
    return this;
  },
  /**
   * vertical scroll absolute to the destination
   * @memberof SimuScroll
   * @param scrollTop {number} scrollTop
   * @param duration {number} duration for animte
   * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
   **/
  scrollTop: function(y, duration, easing, callback) {
    if (this.userConfig.lockY) return;
    var translateZ = this.userConfig.gpuAcceleration ? " translateZ(0) " : "";
    this.y = (undefined === y || isNaN(y) || 0 === y) ? 0 : -Math.round(y);
    this._animate("y", "translateY(" + this.y + "px) " + translateZ, duration, easing, callback);
    return this;
  },
  /**
   * translate the scroller to a new destination includes x , y , scale
   * @memberof SimuScroll
   * @param x {number} x
   * @param y {number} y
   * @param scale {number} scale
   **/
  translate: function(x, y, scale) {
    var translateZ = this.userConfig.gpuAcceleration ? " translateZ(0) " : "";
    this.x = x || this.x || 0;
    this.y = y || this.y || 0;
    this.scale = scale || this.scale || 1;
    this.content.style[transform] = "translate(" + this.x + "px,0px) scale(" + this.scale + ") " + translateZ;
    this.container.style[transform] = "translate(0px," + this.y + "px) " + translateZ;
    return this;
  },
  _animate: function(type, transform, duration, easing, callback) {
    var self = this;
    var duration = duration || 0;
    var easing = easing || "quadratic";
    var el = type == "y" ? self.container : self.content;
    var config = {
      css: {
        transform: transform
      },
      duration: duration,
      easing: easing,
      run: function(e) {
        /**
         * @event {@link SimuScroll#"scroll"}
         */
        self.trigger("scroll", {
          scrollTop: self.getScrollTop(),
          scrollLeft: self.getScrollLeft(),
          type: "scroll"
        });
      },
      useTransition: self.userConfig.useTransition,
      end: function(e) {
        callback && callback();
        if ((self["_bounce" + type] === 0 || self["_bounce" + type] === undefined) && easing != "linear") {
          self['isScrolling' + type.toUpperCase()] = false;
          self['isRealScrolling' + type.toUpperCase()] = false;
          self.trigger("scrollend", {
            type: "scrollend",
            scrollTop: self.getScrollTop(),
            scrollLeft: self.getScrollLeft(),
            zoomType: type,
            duration: duration,
            easing: easing
          });
        }
      }
    };
    var timer = self.__timers[type] = self.__timers[type] || new Animate(el, config);
    timer.stop();
    timer.reset(config);
    timer.run();
    self.trigger("scrollanimate", {
      type: "scrollanimate",
      scrollTop: -self.y,
      scrollLeft: -self.x,
      duration: duration,
      easing: easing,
      zoomType: type
    })
    return this;
  },
  _ontap: function(e) {
    var self = this;
    self.boundryCheck();
    self._unPreventHref(e);
    if (!self.isRealScrollingX && !self.isRealScrollingY) {
      self._triggerClick(e);
    }
    self._preventHref(e);
    self.isRealScrollingY = false;
    self.isRealScrollingY = false;
  },
  _bindEvt: function() {
    SimuScroll.superclass._bindEvt.call(this);
    var self = this;
    if (self.__isEvtBind) return;
    self.__isEvtBind = true;
    var pinch = new Hammer.Pinch();
    self.mc.add(pinch);
    self.on("touchstart mousedown", self._ontouchstart, self);
    self.on("touchmove", self._ontouchmove, self);
    self.on("tap", self._ontap, self);
    self.on("panstart", self._onpanstart, self);
    self.on("pan", self._onpan, self);
    self.on("panend", self._onpanend, self);
    //window resize
    window.addEventListener("resize", function(e) {
      setTimeout(function() {
        self.resetSize();
        self.boundryCheck(0);
        self.render();
      }, 100);
    }, self);

    return this;
  },
  _ontouchstart: function(e) {
    var self = this;
    if (!(/(SELECT|INPUT|TEXTAREA)/i).test(e.target.tagName) && self.userConfig.preventDefault) {
      e.preventDefault();
    }
    self.stop();
  },
  _ontouchmove: function(e) {
    this.userConfig.preventTouchMove && e.preventDefault();
  },
  _onpanstart: function(e) {
    this.userConfig.preventTouchMove && e.preventDefault();
    var self = this;
    var scrollLeft = self.getScrollLeft();
    var scrollTop = self.getScrollTop();
    self.stop();
    self.translate(-scrollLeft, -scrollTop);
    var threshold = self.mc.get("pan").options.threshold;
    self.thresholdY = e.direction == "8" ? threshold : e.direction == "16" ? -threshold : 0;
    self.thresholdX = e.direction == "2" ? threshold : e.direction == "4" ? -threshold : 0;
    return self;
  },
  _onpan: function(e) {
    this.userConfig.preventTouchMove && e.preventDefault();
    var self = this;
    var boundry = self.boundry;
    var userConfig = self.userConfig;
    var boundryCheck = userConfig.boundryCheck;
    var bounce = userConfig.bounce;
    var scrollTop = self.__topstart || (self.__topstart = -self.getScrollTop());
    var scrollLeft = self.__leftstart || (self.__leftstart = -self.getScrollLeft());
    var y = userConfig.lockY ? Number(scrollTop) : Number(scrollTop) + (e.deltaY + self.thresholdY);
    var x = userConfig.lockX ? Number(scrollLeft) : Number(scrollLeft) + (e.deltaX + self.thresholdX);
    var containerWidth = self.containerWidth;
    var containerHeight = self.containerHeight;
    if (boundryCheck) {
      //over top
      y = y > boundry.top ? bounce ? (y - boundry.top) * PAN_RATE + boundry.top : boundry.top : y;
      //over bottom
      y = y < boundry.bottom - containerHeight ? bounce ? y + (boundry.bottom - containerHeight - y) * PAN_RATE : boundry.bottom - containerHeight : y;
      //over left
      x = x > boundry.left ? bounce ? (x - boundry.left) * PAN_RATE + boundry.left : boundry.left : x;
      //over right
      x = x < boundry.right - containerWidth ? bounce ? x + (boundry.right - containerWidth - x) * PAN_RATE : boundry.right - containerWidth : x;
    }
    //move to x,y
    self.translate(x, y);
    //pan trigger the opposite direction
    self.directionX = e.type == 'panleft' ? 'right' : e.type == 'panright' ? 'left' : '';
    self.directionY = e.type == 'panup' ? 'down' : e.type == 'pandown' ? 'up' : '';
    self.trigger("scroll", {
      scrollTop: -y,
      scrollLeft: -x,
      triggerType: "pan",
      type: "scroll"
    });
    return self;
  },
  _onpanend: function(e) {
    var self = this;
    var userConfig = self.userConfig;
    var transX = self.computeScroll("x", e.velocityX);
    var transY = self.computeScroll("y", e.velocityY);
    var scrollLeft = transX ? transX.pos : 0;
    var scrollTop = transY ? transY.pos : 0;
    var duration;
    if (transX && transY && transX.status == "inside" && transY.status == "inside" && transX.duration && transY.duration) {
      //ensure the same duration
      duration = Math.max(transX.duration, transY.duration);
    }
    transX && self.scrollLeft(scrollLeft, duration || transX.duration, transX.easing, function(e) {
      self.boundryCheckX();
    });
    transY && self.scrollTop(scrollTop, duration || transY.duration, transY.easing, function(e) {
      self.boundryCheckY();
    });
    //judge the direction
    self.directionX = e.velocityX < 0 ? "left" : "right";
    self.directionY = e.velocityY < 0 ? "up" : "down";
    //clear start
    self.__topstart = null;
    self.__leftstart = null;
    return self;
  },
  /**
   * judge the scroller is out of boundry horizontally and vertically
   * @memberof SimuScroll
   * @return {boolean} isBoundryOut
   **/
  isBoundryOut: function() {
    return this.isBoundryOutLeft() || this.isBoundryOutRight() || this.isBoundryOutTop() || this.isBoundryOutBottom();
  },
  /**
   * judge if the scroller is outsideof left
   * @memberof SimuScroll
   * @return {boolean} isBoundryOut
   **/
  isBoundryOutLeft: function() {
    return this.getBoundryOutLeft() > 0 ? true : false;
  },
  /**
   * judge if the scroller is outsideof right
   * @memberof SimuScroll
   * @return {boolean} isBoundryOut
   **/
  isBoundryOutRight: function() {
    return this.getBoundryOutRight() > 0 ? true : false;
  },
  /**
   * judge if the scroller is outsideof top
   * @memberof SimuScroll
   * @return {boolean} isBoundryOut
   **/
  isBoundryOutTop: function() {
    return this.getBoundryOutTop() > 0 ? true : false;
  },
  /**
   * judge if the scroller is outsideof bottom
   * @memberof SimuScroll
   * @return {boolean} isBoundryOut
   **/
  isBoundryOutBottom: function() {
    return this.getBoundryOutBottom() > 0 ? true : false;
  },
  /**
   * get the offset value outsideof top
   * @memberof SimuScroll
   * @return {number} offset
   **/
  getBoundryOutTop: function() {
    return -this.boundry.top - this.getScrollTop();
  },
  /**
   * get the offset value outsideof left
   * @memberof SimuScroll
   * @return {number} offset
   **/
  getBoundryOutLeft: function() {
    return -this.boundry.left - this.getScrollLeft();
  },
  /**
   * get the offset value outsideof bottom
   * @memberof SimuScroll
   * @return {number} offset
   **/
  getBoundryOutBottom: function() {
    return this.boundry.bottom - this.containerHeight + this.getScrollTop();
  },
  /**
   * get the offset value outsideof right
   * @memberof SimuScroll
   * @return {number} offset
   **/
  getBoundryOutRight: function() {
    return this.boundry.right - this.containerWidth + this.getScrollLeft();
  },
  /**
   * compute scroll transition by zoomType and velocity
   * @memberof SimuScroll
   * @param {string} zoomType zoomType of scrolling
   * @param {number} velocity velocity after panend
   * @example
   * var info = xscroll.computeScroll("x",2);
   * // return {pos:90,easing:"easing",status:"inside",duration:500}
   * @return {Object}
   **/
  computeScroll: function(type, v) {
    var self = this;
    var userConfig = self.userConfig;
    var boundry = self.boundry;
    var pos = type == "x" ? self.getScrollLeft() : self.getScrollTop();
    var boundryStart = type == "x" ? boundry.left : boundry.top;
    var boundryEnd = type == "x" ? boundry.right : boundry.bottom;
    var innerSize = type == "x" ? self.containerWidth : self.containerHeight;
    var maxSpeed = userConfig.maxSpeed || 2;
    var boundryCheck = userConfig.boundryCheck;
    var bounce = userConfig.bounce;
    var transition = {};
    var status = "inside";
    if (boundryCheck) {
      if (type == "x" && (self.isBoundryOutLeft() || self.isBoundryOutRight())) {
        self.boundryCheckX();
        return;
      } else if (type == "y" && (self.isBoundryOutTop() || self.isBoundryOutBottom())) {
        self.boundryCheckY();
        return;
      }
    }
    if (type == "x" && self.userConfig.lockX) return;
    if (type == "y" && self.userConfig.lockY) return;
    v = v > maxSpeed ? maxSpeed : v < -maxSpeed ? -maxSpeed : v;
    var a = self.SCROLL_ACCELERATION * (v / (Math.abs(v) || 1));
    var a2 = self.BOUNDRY_ACCELERATION;
    var t = isNaN(v / a) ? 0 : v / a;
    var s = Number(pos) + t * v / 2;
    //over top boundry check bounce
    if (s < -boundryStart && boundryCheck) {
      var _s = -boundryStart - pos;
      var _t = (Math.sqrt(-2 * a * _s + v * v) + v) / a;
      var v0 = v - a * _t;
      var _t2 = Math.abs(v0 / a2);
      var s2 = v0 / 2 * _t2;
      t = _t + _t2;
      s = bounce ? -boundryStart + s2 : -boundryStart;
      status = "outside";
    } else if (s > innerSize - boundryEnd && boundryCheck) {
      var _s = (boundryEnd - innerSize) + pos;
      var _t = (Math.sqrt(-2 * a * _s + v * v) - v) / a;
      var v0 = v - a * _t;
      var _t2 = Math.abs(v0 / a2);
      var s2 = v0 / 2 * _t2;
      t = _t + _t2;
      s = bounce ? innerSize - boundryEnd + s2 : innerSize - boundryEnd;
      status = "outside";
    }
    if (isNaN(s) || isNaN(t)) return;
    transition.pos = s;
    transition.duration = t;
    transition.easing = Math.abs(v) > 2 ? "circular" : "quadratic";
    transition.status = status;
    var Type = type.toUpperCase();
    self['isScrolling' + Type] = true;
    self['isRealScrolling' + Type] = true;
    return transition;
  },
  /**
   * bounce to the boundry horizontal
   * @memberof SimuScroll
   * @return {SimuScroll}
   **/
  boundryCheckX: function(duration, easing, callback) {
    var self = this;
    if (!self.userConfig.boundryCheck) return;
    if (typeof arguments[0] == "function") {
      callback = arguments[0];
      duration = self.userConfig.BOUNDRY_CHECK_DURATION;
      easing = self.userConfig.BOUNDRY_CHECK_EASING;
    } else {
      duration = duration === 0 ? 0 : self.userConfig.BOUNDRY_CHECK_DURATION,
        easing = easing || self.userConfig.BOUNDRY_CHECK_EASING;
    }
    if (!self.userConfig.bounce || self.userConfig.lockX) return;
    var boundry = self.boundry;
    if (self.isBoundryOutLeft()) {
      self.scrollLeft(-boundry.left, duration, easing, callback);
    } else if (self.isBoundryOutRight()) {
      self.scrollLeft(self.containerWidth - boundry.right, duration, easing, callback);
    }
    return self;
  },
  /**
   * bounce to the boundry vertical
   * @memberof SimuScroll
   * @return {SimuScroll}
   **/
  boundryCheckY: function(duration, easing, callback) {
    var self = this;
    if (!self.userConfig.boundryCheck) return;
    if (typeof arguments[0] == "function") {
      callback = arguments[0];
      duration = self.userConfig.BOUNDRY_CHECK_DURATION;
      easing = self.userConfig.BOUNDRY_CHECK_EASING;
    } else {
      duration = duration === 0 ? 0 : self.userConfig.BOUNDRY_CHECK_DURATION,
        easing = easing || self.userConfig.BOUNDRY_CHECK_EASING;
    }
    if (!self.userConfig.boundryCheck || self.userConfig.lockY) return;
    var boundry = self.boundry;
    if (self.isBoundryOutTop()) {
      self.scrollTop(-boundry.top, duration, easing, callback);
    } else if (self.isBoundryOutBottom()) {
      self.scrollTop(self.containerHeight - boundry.bottom, duration, easing, callback);
    }
    return self;
  },
  /**
   * bounce to the boundry vertical and horizontal
   * @memberof SimuScroll
   * @return {SimuScroll}
   **/
  boundryCheck: function(duration, easing, callback) {
    this.boundryCheckX(duration, easing, callback);
    this.boundryCheckY(duration, easing, callback);
    return this;
  },
  /**
   * stop scrolling immediatelly
   * @memberof SimuScroll
   * @return {SimuScroll}
   **/
  stop: function() {
    var self = this;
    self.__timers.x && self.__timers.x.stop();
    self.__timers.y && self.__timers.y.stop();
    if (self.isScrollingX || self.isScrollingY) {
      var scrollTop = self.getScrollTop(),
        scrollLeft = self.getScrollLeft();
      self.trigger("scrollend", {
        scrollTop: scrollTop,
        scrollLeft: scrollLeft
      });
      self.trigger("stop", {
        scrollTop: scrollTop,
        scrollLeft: scrollLeft
      })
      self.isScrollingX = false;
      self.isScrollingY = false;
    }
    return self;
  },
  /**
   * render scroll
   * @memberof SimuScroll
   * @return {SimuScroll}
   **/
  render: function() {
    var self = this;
    SimuScroll.superclass.render.call(this);
    //fixed for scrollbars
    if (getComputedStyle(self.renderTo).position == "static") {
      self.renderTo.style.position = "relative";
    }
    self.renderTo.style.overflow = "hidden";
    self.initScrollBars();
    self.initController();
    return self;
  },
  /**
   * init scrollbars
   * @memberof SimuScroll
   * @return {SimuScroll}
   */
  initScrollBars: function() {
    var self = this;
    if (!self.userConfig.boundryCheck) return;
    var indicatorInsets = self.userConfig.indicatorInsets;
    if (self.userConfig.scrollbarX) {
      self.scrollbarX = self.scrollbarX || new ScrollBar({
        xscroll: self,
        type: "x",
        spacing: indicatorInsets.spacing
      });
      self.scrollbarX.render();
      self.scrollbarX._update();
      self.scrollbarX.hide();
    }
    if (self.userConfig.scrollbarY) {
      self.scrollbarY = self.scrollbarY || new ScrollBar({
        xscroll: self,
        type: "y",
        spacing: indicatorInsets.spacing
      });
      self.scrollbarY.render();
      self.scrollbarY._update();
      self.scrollbarY.hide();
    }
    return self;
  },
  /**
   * destroy scrollbars
   * @memberof SimuScroll
   * @return {SimuScroll}
   */
  destroyScrollBars: function() {
    this.scrollbarX && this.scrollbarX.destroy();
    this.scrollbarY && this.scrollbarY.destroy();
    return this;
  },
  /**
   * init controller for multi-scrollers
   * @memberof SimuScroll
   * @return {SimuScroll}
   */
  initController: function() {
    var self = this;
    self.controller = self.controller || new Controller({
      xscroll: self
    });
    return self;
  },
  _unPreventHref: function(e) {
    var target = Util.findParentEl(e.target,'a',this.renderTo);
    if(!target) return;
    if (target.tagName.toLowerCase() == "a") {
      var href = target.getAttribute("data-xs-href");
      if (href) {
        target.setAttribute("href", href);
      }
    }
  },
  _preventHref: function(e) {
    var target = Util.findParentEl(e.target,'a',this.renderTo);
    if(!target) return;
    if (target.tagName.toLowerCase() == "a") {
      var href = target.getAttribute("href");
      href && target.setAttribute("href", "javascript:void(0)");
      href && target.setAttribute("data-xs-href", href);
    }
  },
  _triggerClick: function(e) {
    var target = e.target;
    if (!(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName)) {
      var ev = document.createEvent('MouseEvents');
      ev.initMouseEvent('click', true, true, e.view, 1,
        target.screenX, target.screenY, target.clientX, target.clientY,
        e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
        0, null);
      target.dispatchEvent(ev);
    }
  }
});

if (typeof module == 'object' && module.exports) {
  module.exports = SimuScroll;
}


/***/ }),

/***/ "CX70":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HQk5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8ee5bfe2", content, true);

/***/ }),

/***/ "CXu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




/**
 * cache help methods
 */
var Cache = function () {
  function Cache() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Cache);

    this.buffer = {
      nonMark: false, // 无痕浏览：用户数据不存本地，刷新即丢失
      zsData: {
        localData: {}, // 本地数据
        sessionData: {} // 动态数据
      }
    };

    this.keyMap = {
      'CACHE_STORE_ID': 'cache_store_id',
      'CACHE_STORE_STATUS': 'cache_store_status'
      // 判断localStorage是否可用，不可用则设置为无痕模式
    };if (!window.localStorage || !window.sessionStorage) {
      this.buffer.nonMark = true;
    } else {
      try {
        window.localStorage.setItem('test', {});
        window.sessionStorage.setItem('test', {});
      } catch (e) {
        this.buffer.nonMark = true;
      }
    }
  }
  /**
   * 设置会话数据，临时数据存储使用
   * @param key
   * @param val
   * @return {*}
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Cache, [{
    key: 'setSessionData',
    value: function setSessionData(key, val) {
      if (!this.buffer.nonMark && window.sessionStorage.setItem) {
        try {
          window.sessionStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        } catch (e) {
          this.buffer.nonMark = true;
          this.buffer.zsData.sessionData[key] = val;
        }
      } else {
        this.buffer.zsData.sessionData[key] = val;
      }
    }

    /**
     * 获取会话数据，临时数据存储使用
     * @param key
     * @return {*}
     */

  }, {
    key: 'getSessionData',
    value: function getSessionData(key) {
      if (!this.buffer.nonMark && window.sessionStorage.getItem) {
        var val = window.sessionStorage.getItem(key);
        return val === null || val === '' ? val : JSON.parse(val);
      } else {
        return this.buffer.zsData.sessionData[key];
      }
    }
  }, {
    key: 'setLocalStorageData',
    value: function setLocalStorageData(key, val) {
      if (!this.buffer.nonMark && window.localStorage.setItem) {
        try {
          window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
        } catch (e) {
          this.buffer.nonMark = true;
          this.buffer.zsData.localData[key] = val;
        }
      } else {
        this.buffer.zsData.localData[key] = val;
      }
    }
  }, {
    key: 'getLocalStorageData',
    value: function getLocalStorageData(key) {
      if (!this.buffer.nonMark && window.localStorage.getItem) {
        var val = window.localStorage.getItem(key);
        return val === null || val === '' ? val : JSON.parse(val);
      } else {
        return this.buffer.zsData.localData[key];
      }
    }
  }, {
    key: 'clearSessionData',
    value: function clearSessionData(key) {
      if (window.sessionStorage.removeItem && !this.buffer.nonMark) {
        window.sessionStorage.removeItem(key);
      } else {
        this.buffer.zsData.sessionData[key] = [];
      }
    }
  }, {
    key: 'clearLocalStorageData',
    value: function clearLocalStorageData(key) {
      if (window.localStorage.removeItem && !this.buffer.nonMark) {
        window.localStorage.removeItem(key);
      } else {
        this.buffer.zsData.localData[key] = [];
      }
    }
  }]);

  return Cache;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Cache());

/***/ }),

/***/ "CXvc":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab-item",
    class: [_vm.selected ? _vm.activeClass : '', {
      'vux-tab-selected': _vm.selected
    }],
    style: (_vm.style),
    on: {
      "click": _vm.onItemClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "CXw9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var global = __webpack_require__("7KvD");
var ctx = __webpack_require__("+ZMJ");
var classof = __webpack_require__("RY/4");
var $export = __webpack_require__("kM2E");
var isObject = __webpack_require__("EqjI");
var aFunction = __webpack_require__("lOnJ");
var anInstance = __webpack_require__("2KxR");
var forOf = __webpack_require__("NWt+");
var speciesConstructor = __webpack_require__("t8x9");
var task = __webpack_require__("L42u").set;
var microtask = __webpack_require__("82Mu")();
var newPromiseCapabilityModule = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");
var promiseResolve = __webpack_require__("fJUb");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("dSzd")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("xH/j")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("e6n0")($Promise, PROMISE);
__webpack_require__("bRrM")(PROMISE);
Wrapper = __webpack_require__("FeBl")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("dY0y")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "Cdx3":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("sB3e");
var $keys = __webpack_require__("lktj");

__webpack_require__("uqUo")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "Cj+J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : (0, _typeof3.default)(_item)) === 'object') {
          _item = JSON.parse((0, _stringify2.default)(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
  }
};

/***/ }),

/***/ "Cltl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("5zA6");

exports.default = {
  name: 'Tabbar',
  mixins: [_multiItems.parentMixin],
  props: {
    iconClass: String
  }
};

/***/ }),

/***/ "D++O":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("ntOx")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("aDDo"),
  /* template */
  __webpack_require__("05Uq"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "D2L2":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "D4c5":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("/ZPr")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Sy49"),
  /* template */
  __webpack_require__("VQdg"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "D8b5":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("42Vs")

var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "DIG2":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "DVIs":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vux-spinner",
    class: _vm.className
  })
},staticRenderFns: []}

/***/ }),

/***/ "Dd8w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "EGZi":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "EJJR":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "verifyCode",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.getCode($event)
      }
    }
  }, [_vm._l((12), function(i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show),
        expression: "show"
      }],
      staticClass: "weui_loading_leaf",
      class: ['weui_loading_leaf_' + (i - 1)]
    })
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeText))])], 2)
},staticRenderFns: []}

/***/ }),

/***/ "EQRb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.vux-number-input{float:left;height:.53333333rem;font-size:.53333333rem;color:#666;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:1px solid #ececec;padding:.08rem 0;text-align:center;border-radius:1px}.vux-number-selector{float:left;height:.53333333rem;font-size:.66666667rem;line-height:.48rem;color:#5890ff;border:1px solid #ececec}.vux-number-selector.vux-number-disabled{color:#ccc}.vux-number-selector-sub{border-right:none;padding:.08rem .26666667rem;border-radius:2px 0 0 2px}.vux-number-selector-plus{border-left:none;margin-right:.13333333rem;padding:.08rem .21333333rem;border-radius:0 .05333333rem .05333333rem 0}", ""]);

// exports


/***/ }),

/***/ "ERXJ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_cells_radio"
  }, [_vm._l((_vm.options), function(one, index) {
    return _c('label', {
      staticClass: "weui_cell weui_cell_radio weui_check_label",
      attrs: {
        "for": 'radio_' + _vm.uuid + '_' + index
      }
    }, [_c('div', {
      staticClass: "weui_cell_bd weui_cell_primary"
    }, [_c('p', [_vm._v("\n        " + _vm._s(_vm._f("getValue")(one)) + "\n        "), _vm._t("default", null, {
      one: one
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "weui_cell_ft"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "weui_check",
      attrs: {
        "type": "radio",
        "id": 'radio_' + _vm.uuid + '_' + index
      },
      domProps: {
        "value": _vm._f("getKey")(one),
        "checked": _vm._q(_vm.currentValue, _vm._f("getKey")(one))
      },
      on: {
        "change": function($event) {
          _vm.currentValue = _vm._f("getKey")(one)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "weui_icon_checked"
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fillMode),
      expression: "fillMode"
    }],
    staticClass: "weui_cell"
  }, [_c('div', {
    staticClass: "weui_cell_hd"
  }, [_c('label', {
    staticClass: "weui_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.fillLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fillValue),
      expression: "fillValue"
    }],
    staticClass: "weui_input needsclick",
    attrs: {
      "type": "text",
      "placeholder": _vm.fillPlaceholder
    },
    domProps: {
      "value": (_vm.fillValue)
    },
    on: {
      "blur": function($event) {
        _vm.isFocus = false
      },
      "focus": function($event) {
        _vm.onFocus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fillValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value === '' && !_vm.isFocus),
      expression: "value==='' && !isFocus"
    }],
    staticClass: "weui_cell_ft"
  }, [_c('i', {
    staticClass: "weui_icon_warn"
  })])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ "EbL4":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a,n){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=n(require,exports,module):a.CountUp=n()}(this,function(a,n,t){var e=function(a,n,t,e,i,r){function o(a){a=a.toFixed(l.decimals),a+="";var n,t,e,i,r,o;if(n=a.split("."),t=n[0],e=n.length>1?l.options.decimal+n[1]:"",l.options.useGrouping){for(i="",r=0,o=t.length;r<o;++r)0!==r&&r%3===0&&(i=l.options.separator+i),i=t[o-r-1]+i;t=i}return l.options.numerals.length&&(t=t.replace(/[0-9]/g,function(a){return l.options.numerals[+a]}),e=e.replace(/[0-9]/g,function(a){return l.options.numerals[+a]})),l.options.prefix+t+e+l.options.suffix}function u(a,n,t,e){return t*(-Math.pow(2,-10*a/e)+1)*1024/1023+n}function s(a){return"number"==typeof a&&!isNaN(a)}var l=this;if(l.version=function(){return"1.9.2"},l.options={useEasing:!0,useGrouping:!0,separator:",",decimal:".",easingFn:u,formattingFn:o,prefix:"",suffix:"",numerals:[]},r&&"object"==typeof r)for(var m in l.options)r.hasOwnProperty(m)&&null!==r[m]&&(l.options[m]=r[m]);""===l.options.separator?l.options.useGrouping=!1:l.options.separator=""+l.options.separator;for(var d=0,c=["webkit","moz","ms","o"],f=0;f<c.length&&!window.requestAnimationFrame;++f)window.requestAnimationFrame=window[c[f]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[f]+"CancelAnimationFrame"]||window[c[f]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(a,n){var t=(new Date).getTime(),e=Math.max(0,16-(t-d)),i=window.setTimeout(function(){a(t+e)},e);return d=t+e,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)}),l.initialize=function(){return!!l.initialized||(l.error="",l.d="string"==typeof a?document.getElementById(a):a,l.d?(l.startVal=Number(n),l.endVal=Number(t),s(l.startVal)&&s(l.endVal)?(l.decimals=Math.max(0,e||0),l.dec=Math.pow(10,l.decimals),l.duration=1e3*Number(i)||2e3,l.countDown=l.startVal>l.endVal,l.frameVal=l.startVal,l.initialized=!0,!0):(l.error="[CountUp] startVal ("+n+") or endVal ("+t+") is not a number",!1)):(l.error="[CountUp] target is null or undefined",!1))},l.printValue=function(a){var n=l.options.formattingFn(a);"INPUT"===l.d.tagName?this.d.value=n:"text"===l.d.tagName||"tspan"===l.d.tagName?this.d.textContent=n:this.d.innerHTML=n},l.count=function(a){l.startTime||(l.startTime=a),l.timestamp=a;var n=a-l.startTime;l.remaining=l.duration-n,l.options.useEasing?l.countDown?l.frameVal=l.startVal-l.options.easingFn(n,0,l.startVal-l.endVal,l.duration):l.frameVal=l.options.easingFn(n,l.startVal,l.endVal-l.startVal,l.duration):l.countDown?l.frameVal=l.startVal-(l.startVal-l.endVal)*(n/l.duration):l.frameVal=l.startVal+(l.endVal-l.startVal)*(n/l.duration),l.countDown?l.frameVal=l.frameVal<l.endVal?l.endVal:l.frameVal:l.frameVal=l.frameVal>l.endVal?l.endVal:l.frameVal,l.frameVal=Math.round(l.frameVal*l.dec)/l.dec,l.printValue(l.frameVal),n<l.duration?l.rAF=requestAnimationFrame(l.count):l.callback&&l.callback()},l.start=function(a){l.initialize()&&(l.callback=a,l.rAF=requestAnimationFrame(l.count))},l.pauseResume=function(){l.paused?(l.paused=!1,delete l.startTime,l.duration=l.remaining,l.startVal=l.frameVal,requestAnimationFrame(l.count)):(l.paused=!0,cancelAnimationFrame(l.rAF))},l.reset=function(){l.paused=!1,delete l.startTime,l.initialized=!1,l.initialize()&&(cancelAnimationFrame(l.rAF),l.printValue(l.startVal))},l.update=function(a){if(l.initialize()){if(a=Number(a),!s(a))return void(l.error="[CountUp] update() - new endVal is not a number: "+a);l.error="",a!==l.frameVal&&(cancelAnimationFrame(l.rAF),l.paused=!1,delete l.startTime,l.startVal=l.frameVal,l.endVal=a,l.countDown=l.startVal>l.endVal,l.rAF=requestAnimationFrame(l.count))}},l.initialize()&&l.printValue(l.startVal)};return e});

/***/ }),

/***/ "EbfE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _countdown = __webpack_require__("gF0p");

var _countdown2 = _interopRequireDefault(_countdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_countdown2.default.install = function (Vue) {
  Vue.component('LxCountdown', _countdown2.default);
};

exports.default = _countdown2.default;

/***/ }),

/***/ "Eg/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cvux_src_components__ = __webpack_require__("pNBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cvux_src_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cvux_src_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_url__ = __webpack_require__("NZti");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_cvux_src_components__["Loading"],
    Toast: __WEBPACK_IMPORTED_MODULE_0_cvux_src_components__["Toast"]
  },
  created: function created() {
    var source = __WEBPACK_IMPORTED_MODULE_1__common_url__["a" /* default */].getSearch('source').source || 'default';
    this.$store.dispatch('UPDATE_SOURCE', source);
  },

  computed: {
    loading: function loading() {
      return this.$store.state.loading;
    },
    direction: function direction() {
      // 场景动画切换方向
      return this.$store.state.direction;
    },
    toast: function toast() {
      return this.$store.state.toast;
    }
  }
});

/***/ }),

/***/ "EhX6":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("dH1g")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("hDb/"),
  /* template */
  __webpack_require__("lOT8"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "EqBC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var speciesConstructor = __webpack_require__("t8x9");
var promiseResolve = __webpack_require__("fJUb");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "EqjI":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "ErLd":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('div', {
    staticClass: "weui_cells_title",
    style: ({
      color: _vm.titleColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui_cells",
    class: {
      'vux-no-group-title': !_vm.title
    },
    style: ({
      marginTop: _vm.gutter
    })
  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "Ewe+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMobilePhone;

var _assertString = __webpack_require__("fcJk");

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var phones = {
  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
  'da-DK': /^(\+?45)?(\d{8})$/,
  'el-GR': /^(\+?30)?(69\d{8})$/,
  'en-AU': /^(\+?61|0)4\d{8}$/,
  'en-GB': /^(\+?44|0)7\d{9}$/,
  'en-HK': /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/,
  'en-IN': /^(\+?91|0)?[789]\d{9}$/,
  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
  'en-ZA': /^(\+?27|0)\d{9}$/,
  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5)?|50)\s?(\d\s?){4,8}\d$/,
  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  'he-IL': /^(\+972|0)([23489]|5[0248]|77)[1-9]\d{6}/,
  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'ja-JP': /^(\+?81|0)\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/,
  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'nb-NO': /^(\+?47)?[49]\d{7}$/,
  'nl-BE': /^(\+?32|0)4?\d{8}$/,
  'nn-NO': /^(\+?47)?[49]\d{7}$/,
  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  'tr-TR': /^(\+?90|0)?5\d{9}$/,
  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
  'zh-CN': /^(\+?0?86\-?)?1[345789]\d{9}$/,
  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
};
/* eslint-enable max-len */

// aliases
phones['en-CA'] = phones['en-US'];
phones['fr-BE'] = phones['nl-BE'];
phones['zh-HK'] = phones['en-HK'];

function isMobilePhone(str, locale) {
  (0, _assertString2.default)(str);
  if (locale in phones) {
    return phones[locale].test(str);
  }
  return false;
}
module.exports = exports['default'];

/***/ }),

/***/ "EzvB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__("0Trw");

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_toast2.default.install = function (Vue) {
  Vue.component('LxToast', _toast2.default);
};

exports.default = _toast2.default;

/***/ }),

/***/ "FKI+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ca2Y");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8e0dd3ea", content, true);

/***/ }),

/***/ "FUd2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-fade-transition{opacity:1;transition:opacity .2s linear}.vux-fade-enter,.vux-fade-leave{opacity:0}.vux-dialog-transition{opacity:1;transition-duration:.4s;-webkit-transform:translate(-50%,-50%) scale(1)!important;transform:translate(-50%,-50%) scale(1)!important;transition-property:opacity,-webkit-transform!important;transition-property:transform,opacity!important;transition-property:transform,opacity,-webkit-transform!important}.vux-dialog-enter,.vux-dialog-leave{opacity:0}.vux-dialog-enter{-webkit-transform:translate(-50%,-50%) scale(1.185)!important;transform:translate(-50%,-50%) scale(1.185)!important}.vux-dialog-leave{-webkit-transform:translate(-50%,-50%) scale(1)!important;transform:translate(-50%,-50%) scale(1)!important}.weui-mask{background:rgba(0,0,0,.6)}.weui-mask,.weui-mask_transparent{position:fixed;z-index:1000;top:0;right:0;left:0;bottom:0}.weui_mask{z-index:1000;background:rgba(0,0,0,.6)}.weui_mask,.weui_mask_transparent{position:fixed;width:100%;height:100%;top:0;left:0}.weui_mask_transparent{z-index:5001}.weui_mask_transition{display:none;position:fixed;z-index:1000;width:100%;height:100%;top:0;left:0;background:transparent;transition:background .3s}.weui_fade_toggle{background:rgba(0,0,0,.6)}.weui_dialog{position:fixed;z-index:5000;width:85%;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:#fafafc;text-align:center;border-radius:.21333333rem;overflow:hidden}.weui_dialog_confirm .weui_dialog .weui_dialog_bd{text-align:left}.weui_dialog_mes{line-height:.66666667rem;padding:.66666667rem 0}.weui_dialog_title{font-weight:400;font-size:.45333333rem}.weui_dialog_bd{padding:0 .26666667rem;font-size:.4rem;color:#000;word-wrap:break-word;word-break:break-all}.weui_dialog_ft{position:relative;line-height:1.12rem;font-size:.45333333rem;display:-webkit-flex;display:flex}.weui_dialog_ft a{display:block;-webkit-flex:1;flex:1;color:#3cc51f;text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_dialog_ft a:active{background-color:#eee}.weui_dialog_ft:after{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d5d5d6;color:#d5d5d6;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_dialog_confirm .weui_dialog_ft a{position:relative}.weui_dialog_confirm .weui_dialog_ft a:after{content:\" \";position:absolute;left:0;top:0;width:1px;height:100%;border-left:1px solid #d5d5d6;color:#d5d5d6;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleX(.5);transform:scaleX(.5)}.weui_dialog_confirm .weui_dialog_ft a:first-child:after{display:none}.weui_btn_dialog.default{color:#333}.weui_btn_dialog.primary{color:#5890ff}@media screen and (min-width:1024px){.weui_dialog{width:35%}}", ""]);

// exports


/***/ }),

/***/ "FWLK":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("kx2W")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("4dc+"),
  /* template */
  __webpack_require__("NiOf"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "FaFR":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("uy6L")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("yJfb"),
  /* template */
  __webpack_require__("SRRW"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "FaU1":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("uxDs"),
  /* template */
  __webpack_require__("BYrx"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Fatl":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("3ssR")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("o3S7"),
  /* template */
  __webpack_require__("fOQa"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "FeBl":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "FsCZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
	wrapped scroll controller
*/

var Util = __webpack_require__("rla3"),
	Base = __webpack_require__("5dD5");

var Controller = function(cfg) {
	Controller.superclass.constructor.call(this, cfg);
	this.userConfig = Util.mix({}, cfg);
	this.init();
}

Util.extend(Controller, Base, {
	init: function() {
		var self = this;
		self.xscroll = self.userConfig.xscroll;
	},
	add: function(scroll, cfg) {
		var self = this;
		cfg = Util.extend({
			captureBounce: false,
			stopPropagation: true
		}, cfg)
		if (!self.__scrolls) {
			self.__scrolls = {};
		}
		if (scroll.guid && !self.__scrolls[scroll.guid]) {
			scroll.parentscroll = self.xscroll;
			self._bind(scroll);
			return self.__scrolls[scroll.guid] = scroll;
		}
		return;
	},
	remove: function(scroll) {
		var self = this;
		if (!scroll || !scroll.guid) return;
		var subscroll = self.__scrolls[scroll.guid];
		if (subscroll) {
			subscroll.parentscroll = null;
			self._unbind(scroll);
			subscroll = null;
		}
	},
	get: function(guid) {
		if (guid) {
			return this.__scrolls[guid];
		}
		return this.__scrolls;
	},

	_unbind: function(sub) {

	},

	_bind: function(sub) {
		var self = this,
			xscroll = self.xscroll;
		xscroll.renderTo.addEventListener("touchstart", function() {
			xscroll._resetLockConfig();
		});
		sub.renderTo.addEventListener("touchstart", function() {
			sub._resetLockConfig();
		});
		xscroll.on("panend", xscroll._resetLockConfig);
		sub.on("panend", sub._resetLockConfig);
		sub.on("panstart", function(e) {
			//vertical scroll enabled
			if (!sub.userConfig.lockY && !xscroll.userConfig.lockY) {
				//outside of boundry
				if (sub.isBoundryOut()) {
					xscroll.userConfig.lockY = true;
					return;
				}
				if (e.direction == 16 && sub.getBoundryOutTop() >= 0) {
					sub.userConfig.lockY = true;
				} else if (e.direction == 8 && sub.getBoundryOutTop() >= 0 && sub.getBoundryOutBottom() < 0) {
					xscroll.userConfig.lockY = true;
				}
				if (e.direction == 8 && sub.getBoundryOutBottom() >= 0) {
					sub.userConfig.lockY = true;
				} else if (e.direction == 16 && sub.getBoundryOutBottom() >= 0 && sub.getBoundryOutTop() < 0) {
					xscroll.userConfig.lockY = true;
				}
				if (sub.getBoundryOutTop() < 0 && sub.getBoundryOutBottom() < 0) {
					xscroll.userConfig.lockY = true;
				}
			}
			//horizontal scroll enabled
			if (!sub.userConfig.lockX && !xscroll.userConfig.lockX) {
				if (sub.isBoundryOut()) {
					xscroll.userConfig.lockX = true;
					return;
				}
				if (e.direction == 4 && sub.getBoundryOutLeft() >= 0) {
					sub.userConfig.lockX = true;
				} else if (e.direction == 2 && sub.getBoundryOutLeft() >= 0 && sub.getBoundryOutRight() < 0) {
					xscroll.userConfig.lockX = true;
				}
				if (e.direction == 2 && sub.getBoundryOutRight() >= 0) {
					sub.userConfig.lockX = true;
				} else if (e.direction == 4 && sub.getBoundryOutRight() >= 0 && sub.getBoundryOutLeft() < 0) {
					xscroll.userConfig.lockX = true;
				}
				if (sub.getBoundryOutLeft() < 0 && sub.getBoundryOutRight() < 0) {
					xscroll.userConfig.lockX = true;
				}
			}

			if (!sub.userConfig.lockX && xscroll.userConfig.lockX) {
				//pan x
				if (e.direction == 2 || e.direction == 4) {
					xscroll.userConfig.lockY = true;
				} else {
					sub.userConfig.lockX = true;
				}
			}

			if (!sub.userConfig.lockY && xscroll.userConfig.lockY) {
				//pan y
				if (e.direction == 8 || e.direction == 16) {
					xscroll.userConfig.lockX = true;
				} else {
					sub.userConfig.lockY = true;
				}
			}
		});
	}
});

if (typeof module == 'object' && module.exports) {
	module.exports = Controller;
}


/***/ }),

/***/ "G1qw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__("6YX8");

exports.default = {
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    getUrl: function getUrl(url) {
      return (0, _router.getUrl)(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      (0, _router.go)(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      (0, _router.go)(item.url, this.$router);
    }
  }
};

/***/ }),

/***/ "G5Aw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAABYCAQAAACjBqE3AAAB6klEQVR4Ae3bsWpUQRTG8YkkanwCa7GzVotsI/gEgk9h4Vu4ySLYmMYgbJrc3lrwZbJwC0FMt4j7F6Y4oIZrsXtgxvx/1c0ufEX4cnbmLCmSJEmSJEmSJEmSJP3XCBPvbJU+8doWmDFwyZpLBmYlNJebz0KwzykwsuSYJSNwykEJreV2BaBMaLIQZ2xYcFgqDlmw4ayE/FwL0dDk4Qh4W37DAjgqIT+3HRbigjH+iikVdxgZStgyN0Su2sXIeTwTT+esdpcbIlfNAuZ/TxresG4zV8kYWSZNiKUTokMMSWeIwTNEn4fK2TW3gRNgVkJLuVksROA9G+bEvoATNlBCa7nZXEwdxEZxzpKRKFh+bsv8LmPFmhX1OwfIz81jIRJQ5eeqG9B+riRJkiRJkiRJkiRJkiRJkiRJUkvA/8RQoEpKlJWINFkJ62AlrEP/mNBibnv2yz/A3t7Uq3LcpoxP8COjC1T5vxoAD5VdoEqdDrd5QuW1swtUSaueh3zkiuBiqgtA2OlkeMcP/uDqugsJdbjHF65VdPMKwS0+WQc/MgKvrIOHysB9vgPwk8+85hmPbnQdvHZyDMAFD7L3EOpgMcVdvnHFS0/vlatrXvCVx0U9gt3fxvnA0/hB4nmRJEmSJEmSJEmSJGmHfgFLaDPoMu5xWwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "GPhx":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.time))])
},staticRenderFns: []}

/***/ }),

/***/ "GU06":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.vux-header{position:relative;padding:.08rem 0;box-sizing:border-box;background-color:#35495e}.vux-header .vux-header-title,.vux-header h1{margin:0 2.34666667rem;margin-left:2.66666667rem;line-height:1.06666667rem;text-align:center;height:1.06666667rem;font-size:.48rem;font-weight:400;width:auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#fff}.vux-header .vux-header-title>span{display:inline-block}.vux-header .vux-header-left,.vux-header .vux-header-right{position:absolute;top:.37333333rem;display:block;font-size:.37333333rem;line-height:.56rem;color:#ccc}.vux-header .vux-header-left a,.vux-header .vux-header-left button,.vux-header .vux-header-right a,.vux-header .vux-header-right button{float:left;margin-right:.21333333rem;color:#ccc}.vux-header .vux-header-left a:active,.vux-header .vux-header-left button:active,.vux-header .vux-header-right a:active,.vux-header .vux-header-right button:active{opacity:.5}.vux-header .vux-header-left{left:.48rem}.vux-header .vux-header-left .vux-header-back{padding-left:.42666667rem}.vux-header .vux-header-left .left-arrow{position:absolute;width:.8rem;height:.8rem;top:-.13333333rem;left:-.13333333rem}.vux-header .vux-header-left .left-arrow:before{content:\"\";position:absolute;width:.32rem;height:.32rem;border:1px solid #ccc;border-width:1px 0 0 1px;-webkit-transform:rotate(315deg);transform:rotate(315deg);top:.21333333rem;left:.18666667rem}.vux-header .vux-header-right{right:.4rem}.vux-header .vux-header-right a,.vux-header .vux-header-right button{margin-left:.21333333rem;margin-right:0}.vux-header .vux-header-right .vux-header-more:after{content:\"\\2022   \\2022   \\2022   \";font-size:.42666667rem}.vux-header-fade-in-right-enter{-webkit-animation:fadeinR .5s;animation:fadeinR .5s}.vux-header-fade-in-left-enter{-webkit-animation:fadeinL .5s;animation:fadeinL .5s}@-webkit-keyframes fadeinR{0%{opacity:0;-webkit-transform:translateX(2.13333333rem);transform:translateX(2.13333333rem)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes fadeinR{0%{opacity:0;-webkit-transform:translateX(2.13333333rem);transform:translateX(2.13333333rem)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes fadeinL{0%{opacity:0;-webkit-transform:translateX(-2.13333333rem);transform:translateX(-2.13333333rem)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes fadeinL{0%{opacity:0;-webkit-transform:translateX(-2.13333333rem);transform:translateX(-2.13333333rem)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}", ""]);

// exports


/***/ }),

/***/ "Ghib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GjZm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _masker = __webpack_require__("3Q2f");

var _masker2 = _interopRequireDefault(_masker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_masker2.default.install = function (Vue) {
  Vue.component('LxMasker', _masker2.default);
};

exports.default = _masker2.default;

/***/ }),

/***/ "H4bY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_check_label{-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_check{position:absolute;left:-9999em}.weui_cells_radio .weui_cell_ft{padding-left:.93333333rem}.weui_cells_radio .weui_cell:active{background-color:#ececec}.weui_cells_radio .weui_check:checked+.weui_icon_checked:before{display:block;content:\"\\EA08\";color:#5890ff;font-size:.42666667rem}.weui_cells_checkbox .weui_cell_hd{padding-right:.4rem}.weui_cells_checkbox .weui_icon_checked:before{display:block;width:.4rem;height:.4rem;content:\"\";border:1px solid #e9e9eb;box-sizing:border-box}.weui_cells_checkbox .weui_check:checked+.weui_icon_checked{display:block;background-color:#409eff;width:.4rem;height:.4rem;position:relative}.weui_cells_checkbox .weui_check:checked+.weui_icon_checked:before{position:absolute;left:.08rem;top:.06666667rem;content:\"\";border-style:solid;width:.26666667rem;height:.16rem;border-color:#fff #fff transparent transparent;border-width:2px;-webkit-transform:rotate(135deg);transform:rotate(135deg)}.weui_label{color:#000;display:block;width:2.4rem;word-wrap:break-word;word-break:break-all;padding-right:.13333333rem}.weui_input{width:100%;border:0;outline:0;-webkit-appearance:none;background-color:transparent;font-size:inherit;color:inherit;line-height:2.26666667}.weui_input::-webkit-inner-spin-button,.weui_input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.weui_textarea{display:block;border:0;resize:none;width:100%;color:inherit;font-size:.34666667rem;line-height:inherit;outline:0}.weui_textarea_counter{color:#999;text-align:right}.weui_cell_warn .weui_textarea_counter{color:#e64340}.weui_toptips{display:none;position:fixed;-webkit-transform:translateZ(0);width:100%;top:0;line-height:2.3;font-size:14px;text-align:center;color:#fff;z-index:50000}.weui_toptips.weui_warn{background-color:#e64340}.weui_cells_form .weui_cell_warn{color:#e64340}.weui_cells_form .weui_cell_warn .weui_icon_warn{display:inline-block}.weui_cells_form .weui_cell_ft{font-size:0}.weui_cells_form .weui_icon_warn{display:none}.weui_cells_form input,.weui_cells_form label[for],.weui_cells_form textarea{-webkit-tap-highlight-color:rgba(0,0,0,0)}@font-face{font-weight:400;font-style:normal;font-family:weui;src:url(\"data:application/octet-stream;base64,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\") format(\"truetype\")}[class*=\" weui_icon_\"]:before,[class^=weui_icon_]:before{font-family:weui;font-style:normal;font-weight:400;speak:none;display:inline-block;vertical-align:middle;text-decoration:inherit;width:1em;margin-right:.56rem;text-align:center;font-variant:normal;text-transform:none;line-height:1;margin-left:.2rem}.weui_icon_circle:before{content:\"\\EA01\"}.weui_icon_download:before{content:\"\\EA02\"}.weui_icon_info:before{content:\"\\EA03\"}.weui_icon_safe_success:before{content:\"\\EA04\"}.weui_icon_safe_warn:before{content:\"\\EA05\"}.weui_icon_success:before{content:\"\\EA06\"}.weui_icon_success_circle:before{content:\"\\EA07\"}.weui_icon_success_no_circle:before{content:\"\\EA08\"}.weui_icon_waiting:before{content:\"\\EA09\"}.weui_icon_waiting_circle:before{content:\"\\EA0A\"}.weui_icon_warn:before{content:\"\\EA0B\"}.weui_icon_info_circle:before{content:\"\\EA0C\"}.weui_icon_cancel:before{content:\"\\EA0D\"}.weui_icon_search:before{content:\"\\EA0E\"}.weui_icon_clear:before{content:\"\\EA0F\"}[class*=\" weui_icon_\"]:before,[class^=weui_icon_]:before{margin:0}.weui_icon_success:before{font-size:.61333333rem;color:#09bb07}.weui_icon_waiting:before{font-size:.61333333rem;color:#10aeff}.weui_icon_warn:before{font-size:.61333333rem;color:#f43530}.weui_icon_info:before{font-size:.61333333rem;color:#10aeff}.weui_icon_success_circle:before,.weui_icon_success_no_circle:before{font-size:.61333333rem;color:#09bb07}.weui_icon_waiting_circle:before{font-size:.48rem;color:#10aeff}.weui_icon_circle:before{font-size:.48rem;color:#c9c9c9}.weui_icon_download:before,.weui_icon_info_circle:before{font-size:.48rem;color:#09bb07}.weui_icon_safe_success:before{color:#09bb07}.weui_icon_safe_warn:before{color:#ffbe00}.weui_icon_cancel:before{color:#f43530;font-size:.58666667rem}.weui_icon_clear:before,.weui_icon_search:before{color:#b2b2b2;font-size:.37333333rem}.weui_icon_msg:before{font-size:2.77333333rem}.weui_icon_warn.weui_icon_msg:before{color:#f76260}.weui_icon_safe:before{font-size:2.77333333rem}.weui_cell_radio>*{pointer-events:none}", ""]);

// exports


/***/ }),

/***/ "H6Tm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("xsd4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("77b38711", content, true);

/***/ }),

/***/ "HHx2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (arr) {
	if (!Array.isArray(arr)) {
		throw new TypeError('Expected Array, got ' + typeof arr);
	}

	var rand;
	var tmp;
	var len = arr.length;
	var ret = arr.slice();

	while (len) {
		rand = Math.floor(Math.random() * len--);
		tmp = ret[len];
		ret[len] = ret[rand];
		ret[rand] = tmp;
	}

	return ret;
};


/***/ }),

/***/ "HQk5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cells_access .weui_cell:not(.no_access){-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_cells_access .weui_cell:not(.no_access):active{background-color:#ececec}.weui_cells_access a.weui_cell{color:inherit}.weui_cells_access .weui_cell_ft:after{content:\" \";display:inline-block;-webkit-transform:rotate(45deg);transform:rotate(45deg);height:6px;width:6px;border-width:2px 2px 0 0;border-color:#c8c8cd;border-style:solid;position:relative;top:-2px;top:-1px;margin-left:.3em}.weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.weui_label{color:#000;display:block;width:2.4rem;word-wrap:break-word;word-break:break-all;padding-right:.13333333rem}.weui_input{width:100%;border:0;outline:0;-webkit-appearance:none;background-color:transparent;font-size:inherit;color:inherit;line-height:2.26666667}.weui_input::-webkit-inner-spin-button,.weui_input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.weui_textarea{display:block;border:0;resize:none;width:100%;color:inherit;font-size:.34666667rem;line-height:inherit;outline:0}.weui_textarea_counter{color:#999;text-align:right}.weui_cell_warn .weui_textarea_counter{color:#e64340}.weui_toptips{display:none;position:fixed;-webkit-transform:translateZ(0);width:100%;top:0;line-height:2.3;font-size:14px;text-align:center;color:#fff;z-index:50000}.weui_toptips.weui_warn{background-color:#e64340}.weui_cells_form .weui_cell_warn{color:#e64340}.weui_cells_form .weui_cell_warn .weui_icon_warn{display:inline-block}.weui_cells_form .weui_cell_ft{font-size:0}.weui_cells_form .weui_icon_warn{display:none}.weui_cells_form input,.weui_cells_form label[for],.weui_cells_form textarea{-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_vcode{padding-top:0!important;padding-right:0!important;padding-bottom:0!important}.weui_vcode .weui_cell_ft img{margin-left:5px;height:1.44rem;vertical-align:middle}.weui_vcode .weui_btn{margin-left:5px;width:auto;display:inline-block;height:1.44rem}.vux-input-icon.vux-input-icon,.vux-input-icon.weui_icon_success:before,.vux-input-icon.weui_icon_warn:before{font-size:.48rem}.vux-x-input .weui_icon{padding-left:.13333333rem}.vux-x-input.weui_cell_vcode{padding-top:0;padding-right:0;padding-bottom:0}", ""]);

// exports


/***/ }),

/***/ "HXfK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var time = Date.now || function () {
  return +new Date();
};

var running = {};
var counter = 1;
var desiredFrames = 60;
var millisecondsPerSecond = 1000;
var isServer = typeof window === 'undefined';(function () {
  if (isServer) return;
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (handler, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        handler(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
})();

exports.default = {
  requestAnimationFrame: function () {
    if (isServer) return '';
    var requestFrame = window.requestAnimationFrame;
    return function (callback, root) {
      requestFrame(callback, root);
    };
  }(),

  stop: function stop(id) {
    var cleared = running[id] != null;
    if (cleared) {
      running[id] = null;
    }
    return cleared;
  },
  isRunning: function isRunning(id) {
    return running[id] != null;
  },
  start: function start(stepCallback, verifyCallback, completedCallback, duration, easingMethod, root) {
    var _this = this;
    var start = time();
    var lastFrame = start;
    var percent = 0;
    var dropCounter = 0;
    var id = counter++;

    if (!root) {
      root = document.body;
    }

    if (id % 20 === 0) {
      var newRunning = {};
      for (var usedId in running) {
        newRunning[usedId] = true;
      }
      running = newRunning;
    }

    var step = function step(virtual) {
      var render = virtual !== true;

      var now = time();

      if (!running[id] || verifyCallback && !verifyCallback(id)) {
        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, false);
        return;
      }

      if (render) {
        var droppedFrames = Math.round((now - lastFrame) / (millisecondsPerSecond / desiredFrames)) - 1;
        for (var j = 0; j < Math.min(droppedFrames, 4); j++) {
          step(true);
          dropCounter++;
        }
      }

      if (duration) {
        percent = (now - start) / duration;
        if (percent > 1) {
          percent = 1;
        }
      }

      var value = easingMethod ? easingMethod(percent) : percent;
      if ((stepCallback(value, now, render) === false || percent === 1) && render) {
        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, percent === 1 || duration == null);
      } else if (render) {
        lastFrame = now;
        _this.requestAnimationFrame(step, root);
      }
    };

    running[id] = true;

    _this.requestAnimationFrame(step, root);

    return id;
  }
};

/***/ }),

/***/ "HiMk":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Ltgl");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("14481ece", content, true);

/***/ }),

/***/ "HjgP":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-picker"
  }, [_c('flexbox', {
    attrs: {
      "gutter": 0
    }
  }, _vm._l((_vm.currentData), function(one, index) {
    return _c('flexbox-item', {
      key: index,
      staticStyle: {
        "margin-left": "0"
      }
    }, [_c('div', {
      staticClass: "vux-picker-item",
      attrs: {
        "id": ("vux-picker-" + _vm.uuid + "-" + index)
      }
    })])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ "Ht/C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _divider = __webpack_require__("944h");

var _divider2 = _interopRequireDefault(_divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_divider2.default.install = function (Vue) {
  Vue.component('LxDivider', _divider2.default);
};

exports.default = _divider2.default;

/***/ }),

/***/ "HuhE":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("enee")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ZSyl"),
  /* template */
  __webpack_require__("CXvc"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "I1r6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("SddO");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6f2ce621", content, true);

/***/ }),

/***/ "I9ad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xAlert = __webpack_require__("omWz");

var _xAlert2 = _interopRequireDefault(_xAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xAlert2.default.install = function (Vue) {
  Vue.component('LxXAlert', _xAlert2.default);
};

exports.default = _xAlert2.default;

/***/ }),

/***/ "ICxZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("kjxU"), "");

// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "IWQ4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_tabbar{display:-webkit-flex;display:flex;position:absolute;z-index:100;bottom:0;width:100%;background-color:#f7f7fa}.weui_tabbar:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #979797;color:#979797;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_tabbar_item{display:block;-webkit-flex:1;flex:1;padding:.18666667rem 0 0;-webkit-tap-highlight-color:transparent}.weui_tabbar_item.weui_bar_item_on .weui_tabbar_label{color:#09bb07}.weui_tabbar_icon{margin:0 auto;width:.64rem;height:.64rem}.weui_tabbar_icon img{display:block;width:100%;height:100%}.weui_tabbar_icon+.weui_tabbar_label{margin-top:.13333333rem}.weui_tabbar_label{text-align:center;color:#000;font-size:.32rem}.weui_tab{position:relative;height:100%}.weui_tab_bd{box-sizing:border-box;height:100%;padding-bottom:1.46666667rem;overflow:auto;-webkit-overflow-scrolling:touch;font-size:.34666667rem}.weui_tab_bd_item{display:none}.weui_tab_bd_item_active{display:block}.weui_tabbar_icon{position:relative}.weui_tabbar_icon>sup{position:absolute;top:-.21333333rem;left:100%;-webkit-transform:translateX(-50%);transform:translateX(-50%);z-index:101}", ""]);

// exports


/***/ }),

/***/ "Ibhu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("D2L2");
var toIObject = __webpack_require__("TcQ7");
var arrayIndexOf = __webpack_require__("vFc/")(false);
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "J6cF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _converter = __webpack_require__("v93z");

exports.default = {
  props: {
    color: {
      type: String,
      default: '0, 0, 0'
    },
    opacity: {
      type: Number,
      default: 0.5
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style: function style() {
      var color = /,/.test(this.color) ? this.color : (0, _converter.toRGB)(this.color.replace('#', '')).join(',');
      return {
        backgroundColor: 'rgba(' + color + ',' + this.opacity + ')'
      };
    }
  }
};

/***/ }),

/***/ "J9cy":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.with_arrow:after{content:\" \";display:inline-block;-webkit-transform:rotate(45deg);transform:rotate(45deg);height:.21333333rem;width:.21333333rem;border-width:1px 1px 0 0;border-color:#a0a0a0;border-style:solid;position:relative;top:-1px;margin-left:.3em}.scroller-component{display:block;position:relative;height:6.34666667rem;overflow:hidden;width:100%}.scroller-content{z-index:-1}.scroller-content,.scroller-mask{position:absolute;left:0;top:0;width:100%}.scroller-mask{height:100%;margin:0 auto;z-index:3;background-image:linear-gradient(180deg,hsla(0,0%,100%,.95),hsla(0,0%,100%,.6)),linear-gradient(0deg,hsla(0,0%,100%,.95),hsla(0,0%,100%,.6));background-position:top,bottom;background-size:100% 2.72rem;background-repeat:no-repeat}.scroller-item{text-align:center;font-size:.42666667rem;height:.90666667rem;line-height:.90666667rem;color:#000}.scroller-indicator{width:100%;height:.90666667rem;position:absolute;left:0;top:2.72rem;z-index:3;background-image:linear-gradient(180deg,#d0d0d0,#d0d0d0,transparent,transparent),linear-gradient(0deg,#d0d0d0,#d0d0d0,transparent,transparent);background-position:top,bottom;background-size:100% 1px;background-repeat:no-repeat}.dp-container{bottom:0;z-index:10000;background-color:#fff;display:none;transition:-webkit-transform .3s ease;transition:transform .3s ease;transition:transform .3s ease,-webkit-transform .3s ease;-webkit-transform:translateY(100%);transform:translateY(100%)}.dp-container,.dp-mask{position:fixed;width:100%;left:0}.dp-mask{z-index:998;height:100%;top:0;opacity:0;transition:opacity .1s ease;background-color:#000;z-index:9999}.dp-header{display:-webkit-flex;display:flex;width:100%;box-align:center;-webkit-align-items:center;align-items:center;background-image:linear-gradient(180deg,#e7e7e7,#e7e7e7,transparent,transparent);background-position:bottom;background-size:100% 1px;background-repeat:no-repeat}.dp-header .dp-item{font-size:.48rem;height:1.17333333rem;line-height:1.17333333rem;cursor:pointer}.dp-center,.dp-left{color:#333}.dp-right{color:#5890ff}.dp-content{display:-webkit-flex;display:flex;width:100%;box-align:center;-webkit-align-items:center;align-items:center;padding:.26666667rem 0}.dp-content .dp-item,.dp-header .dp-item{box-sizing:border-box;-webkit-flex:1;flex:1;text-align:center}.vux-datetime .vux-input-icon{float:right}.vux-cell-primary{-webkit-flex:1;flex:1}.cvux-datetime-placeholder{color:#a0a0a0}", ""]);

// exports


/***/ }),

/***/ "JJHH":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-tab-ink-bar{position:absolute;height:2px;bottom:0;left:0}.vux-tab-ink-bar-transition-forward{transition:right .3s cubic-bezier(.35,0,.25,1),left .3s cubic-bezier(.35,0,.25,1) .09s}.vux-tab-ink-bar-transition-backward{transition:right .3s cubic-bezier(.35,0,.25,1) .09s,left .3s cubic-bezier(.35,0,.25,1)}.vux-tab{display:-webkit-flex;display:flex;background-color:#fff;height:44px;position:relative}.vux-tab button{padding:0;border:0;outline:0;background:0 0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.vux-tab .vux-tab-item{display:block;-webkit-flex:1;flex:1;width:100%;height:100%;box-sizing:border-box;background:linear-gradient(180deg,#e5e5e5,#e5e5e5,hsla(0,0%,90%,0)) 0 100% no-repeat;background-size:100% 1px;font-size:14px;text-align:center;line-height:44px;color:#666}.vux-tab .vux-tab-item.vux-tab-selected{color:#04be02;border-bottom:3px solid #04be02}.vux-tab.vux-tab-no-animate .vux-tab-item.vux-tab-selected{background:0 0}", ""]);

// exports


/***/ }),

/***/ "JSH0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7RDZ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1995baf4", content, true);

/***/ }),

/***/ "Jb5b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("EQRb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b330980c", content, true);

/***/ }),

/***/ "JiaV":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("zpgl")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("p/yB"),
  /* template */
  __webpack_require__("uAG8"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Jl4W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ajax__ = __webpack_require__("3r5k");

/**
 * rest 请求配置
 */


// 预约租车接口配置项
var optionsV1 = {
  baseUrl: '/api/v1/rent_car',
  cache: false
};

var optionsV2 = {
  baseUrl: '/api/v1',
  cache: false
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 预约租车配置相关
  rent: {
    // 车辆信息
    getCarInfo: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].query('/list_rentable_models', optionsV1),
    // 可租车时间
    getRentInfo: function getRentInfo(id) {
      // return ajax.query(`/list_rentable_datetime/${id}`, optionsV1)
      return __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].query('/book_vehicle/' + id, optionsV1);
    },

    // 租车信息提交
    postSuccess: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].create('/rent_car_orders', optionsV1)
  },
  auth: {
    // 获取验证码
    createVeiCode: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].create('/auth/verification_code', optionsV2)
  },
  coupon: {
    // 提交客户信息领取优惠券
    createChannelCoupon: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].create('/coupon/channel_coupon', optionsV2),
    // 通过token获取优惠券信息
    fetchIssueChannelCouponInfo: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].query('/coupon/issue_channels', optionsV2),
    // 获取发行渠道部分信息
    fetchIssueChannelProfile: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].query('/coupon/issue_channel_profile', optionsV2),
    // 创建发放渠道优惠券链接token
    creatCouponIssueChannelToken: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].query('/coupon/issue_channel_token', optionsV2),
    // 生成二维码
    createQrCode: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].create('/coupon/qr_code', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, optionsV2, { responseType: 'blob' })),
    // 生成二维码预检查
    createQrCodePrefight: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].create('/coupon/qr_code', optionsV2),
    // 获取验证码
    fetchSendVeliCode: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].create('/coupon/verification_code', optionsV2),
    // 获取优惠券页面通过token获取优惠券信息1
    fetchReceChannelCouponInfo: __WEBPACK_IMPORTED_MODULE_1__common_ajax__["a" /* default */].query('/coupon/channel_coupon', optionsV2)
  }
});

/***/ }),

/***/ "Jsix":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Z0YM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7a2b68d0", content, true);

/***/ }),

/***/ "K6xk":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("FUd2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2ac1d394", content, true);

/***/ }),

/***/ "Kh4W":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("dSzd");


/***/ }),

/***/ "L42u":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var invoke = __webpack_require__("knuC");
var html = __webpack_require__("RPLV");
var cel = __webpack_require__("ON07");
var global = __webpack_require__("7KvD");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("R9M2")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "LEZY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_toast[data-v-2a7d6ad9]{position:fixed;z-index:50000;width:3.25333333rem;min-height:3.25333333rem;top:4.8rem;left:50%;margin-left:-.81333333rem;background:rgba(40,40,40,.75);text-align:center;border-radius:5px;color:#fff}.weui_icon_toast[data-v-2a7d6ad9]{margin:.58666667rem 0 0;display:block}.weui_icon_toast[data-v-2a7d6ad9]:before{content:\"\\EA08\";color:#fff;font-size:1.46666667rem}.weui_toast_content[data-v-2a7d6ad9]{margin:0 0 .4rem}.weui_loading_toast .weui_toast_content[data-v-2a7d6ad9]{margin-top:64%;font-size:.37333333rem}.weui_loading[data-v-2a7d6ad9]{position:absolute;width:0;z-index:1;left:50%;top:38%}.weui_loading_leaf[data-v-2a7d6ad9]{top:-1px;opacity:.25}.weui_loading_leaf[data-v-2a7d6ad9]:before{content:\" \";position:absolute;width:.1104rem;height:.05546667rem;background:#d1d1d5;box-shadow:0 0 1px rgba(0,0,0,.0980392);border-radius:1px;-webkit-transform-origin:left 50% 0;transform-origin:left 50% 0}.weui_loading_leaf_0[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-0-12 1.25s linear infinite;animation:opacity-60-25-0-12 1.25s linear infinite}.weui_loading_leaf_0[data-v-2a7d6ad9]:before{-webkit-transform:rotate(0deg) translate(.09333333rem);transform:rotate(0deg) translate(.09333333rem)}.weui_loading_leaf_1[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-1-12 1.25s linear infinite;animation:opacity-60-25-1-12 1.25s linear infinite}.weui_loading_leaf_1[data-v-2a7d6ad9]:before{-webkit-transform:rotate(30deg) translate(.09333333rem);transform:rotate(30deg) translate(.09333333rem)}.weui_loading_leaf_2[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-2-12 1.25s linear infinite;animation:opacity-60-25-2-12 1.25s linear infinite}.weui_loading_leaf_2[data-v-2a7d6ad9]:before{-webkit-transform:rotate(60deg) translate(.09333333rem);transform:rotate(60deg) translate(.09333333rem)}.weui_loading_leaf_3[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-3-12 1.25s linear infinite;animation:opacity-60-25-3-12 1.25s linear infinite}.weui_loading_leaf_3[data-v-2a7d6ad9]:before{-webkit-transform:rotate(90deg) translate(.09333333rem);transform:rotate(90deg) translate(.09333333rem)}.weui_loading_leaf_4[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-4-12 1.25s linear infinite;animation:opacity-60-25-4-12 1.25s linear infinite}.weui_loading_leaf_4[data-v-2a7d6ad9]:before{-webkit-transform:rotate(120deg) translate(.09333333rem);transform:rotate(120deg) translate(.09333333rem)}.weui_loading_leaf_5[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-5-12 1.25s linear infinite;animation:opacity-60-25-5-12 1.25s linear infinite}.weui_loading_leaf_5[data-v-2a7d6ad9]:before{-webkit-transform:rotate(150deg) translate(.09333333rem);transform:rotate(150deg) translate(.09333333rem)}.weui_loading_leaf_6[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-6-12 1.25s linear infinite;animation:opacity-60-25-6-12 1.25s linear infinite}.weui_loading_leaf_6[data-v-2a7d6ad9]:before{-webkit-transform:rotate(180deg) translate(.09333333rem);transform:rotate(180deg) translate(.09333333rem)}.weui_loading_leaf_7[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-7-12 1.25s linear infinite;animation:opacity-60-25-7-12 1.25s linear infinite}.weui_loading_leaf_7[data-v-2a7d6ad9]:before{-webkit-transform:rotate(210deg) translate(.09333333rem);transform:rotate(210deg) translate(.09333333rem)}.weui_loading_leaf_8[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-8-12 1.25s linear infinite;animation:opacity-60-25-8-12 1.25s linear infinite}.weui_loading_leaf_8[data-v-2a7d6ad9]:before{-webkit-transform:rotate(240deg) translate(.09333333rem);transform:rotate(240deg) translate(.09333333rem)}.weui_loading_leaf_9[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-9-12 1.25s linear infinite;animation:opacity-60-25-9-12 1.25s linear infinite}.weui_loading_leaf_9[data-v-2a7d6ad9]:before{-webkit-transform:rotate(270deg) translate(.09333333rem);transform:rotate(270deg) translate(.09333333rem)}.weui_loading_leaf_10[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-10-12 1.25s linear infinite;animation:opacity-60-25-10-12 1.25s linear infinite}.weui_loading_leaf_10[data-v-2a7d6ad9]:before{-webkit-transform:rotate(300deg) translate(.09333333rem);transform:rotate(300deg) translate(.09333333rem)}.weui_loading_leaf_11[data-v-2a7d6ad9]{-webkit-animation:opacity-60-25-11-12 1.25s linear infinite;animation:opacity-60-25-11-12 1.25s linear infinite}.weui_loading_leaf_11[data-v-2a7d6ad9]:before{-webkit-transform:rotate(330deg) translate(.09333333rem);transform:rotate(330deg) translate(.09333333rem)}@-webkit-keyframes opacity-60-25-0-12{0%{opacity:.25}0.01%{opacity:.25}0.02%{opacity:1}60.01%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-0-12{0%{opacity:.25}0.01%{opacity:.25}0.02%{opacity:1}60.01%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-1-12{0%{opacity:.25}8.34333%{opacity:.25}8.35333%{opacity:1}68.3433%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-1-12{0%{opacity:.25}8.34333%{opacity:.25}8.35333%{opacity:1}68.3433%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-2-12{0%{opacity:.25}16.6767%{opacity:.25}16.6867%{opacity:1}76.6767%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-2-12{0%{opacity:.25}16.6767%{opacity:.25}16.6867%{opacity:1}76.6767%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-3-12{0%{opacity:.25}25.01%{opacity:.25}25.02%{opacity:1}85.01%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-3-12{0%{opacity:.25}25.01%{opacity:.25}25.02%{opacity:1}85.01%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-4-12{0%{opacity:.25}33.3433%{opacity:.25}33.3533%{opacity:1}93.3433%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-4-12{0%{opacity:.25}33.3433%{opacity:.25}33.3533%{opacity:1}93.3433%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-5-12{0%{opacity:.270958333333333}41.6767%{opacity:.25}41.6867%{opacity:1}1.67667%{opacity:.25}to{opacity:.270958333333333}}@keyframes opacity-60-25-5-12{0%{opacity:.270958333333333}41.6767%{opacity:.25}41.6867%{opacity:1}1.67667%{opacity:.25}to{opacity:.270958333333333}}@-webkit-keyframes opacity-60-25-6-12{0%{opacity:.375125}50.01%{opacity:.25}50.02%{opacity:1}10.01%{opacity:.25}to{opacity:.375125}}@keyframes opacity-60-25-6-12{0%{opacity:.375125}50.01%{opacity:.25}50.02%{opacity:1}10.01%{opacity:.25}to{opacity:.375125}}@-webkit-keyframes opacity-60-25-7-12{0%{opacity:.479291666666667}58.3433%{opacity:.25}58.3533%{opacity:1}18.3433%{opacity:.25}to{opacity:.479291666666667}}@keyframes opacity-60-25-7-12{0%{opacity:.479291666666667}58.3433%{opacity:.25}58.3533%{opacity:1}18.3433%{opacity:.25}to{opacity:.479291666666667}}@-webkit-keyframes opacity-60-25-8-12{0%{opacity:.583458333333333}66.6767%{opacity:.25}66.6867%{opacity:1}26.6767%{opacity:.25}to{opacity:.583458333333333}}@keyframes opacity-60-25-8-12{0%{opacity:.583458333333333}66.6767%{opacity:.25}66.6867%{opacity:1}26.6767%{opacity:.25}to{opacity:.583458333333333}}@-webkit-keyframes opacity-60-25-9-12{0%{opacity:.687625}75.01%{opacity:.25}75.02%{opacity:1}35.01%{opacity:.25}to{opacity:.687625}}@keyframes opacity-60-25-9-12{0%{opacity:.687625}75.01%{opacity:.25}75.02%{opacity:1}35.01%{opacity:.25}to{opacity:.687625}}@-webkit-keyframes opacity-60-25-10-12{0%{opacity:.791791666666667}83.3433%{opacity:.25}83.3533%{opacity:1}43.3433%{opacity:.25}to{opacity:.791791666666667}}@keyframes opacity-60-25-10-12{0%{opacity:.791791666666667}83.3433%{opacity:.25}83.3533%{opacity:1}43.3433%{opacity:.25}to{opacity:.791791666666667}}@-webkit-keyframes opacity-60-25-11-12{0%{opacity:.895958333333333}91.6767%{opacity:.25}91.6867%{opacity:1}51.6767%{opacity:.25}to{opacity:.895958333333333}}@keyframes opacity-60-25-11-12{0%{opacity:.895958333333333}91.6767%{opacity:.25}91.6867%{opacity:1}51.6767%{opacity:.25}to{opacity:.895958333333333}}.verifyCode[data-v-2a7d6ad9]{position:absolute;top:2rem;right:.4rem;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-size:.34666667rem;line-height:.70666667rem;padding:0 .4rem;text-align:center;background:#fff;color:#5890ff;border:1px solid #5890ff;border-radius:.10666667rem}.weui_loading_leaf[data-v-2a7d6ad9]{position:absolute;top:45%;left:.2rem}", ""]);

// exports


/***/ }),

/***/ "LKZe":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("NpIQ");
var createDesc = __webpack_require__("X8DO");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var has = __webpack_require__("D2L2");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("+E39") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "LKxN":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-masker-box"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "vux-masker",
    class: {
      'vux-masker-fullscreen': _vm.fullscreen
    },
    style: (_vm.style)
  }, [_vm._t("content")], 2)], 2)
},staticRenderFns: []}

/***/ }),

/***/ "LLCR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),

/***/ "LRgB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _group = __webpack_require__("RJAK");

var _group2 = _interopRequireDefault(_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_group2.default.install = function (Vue) {
  Vue.component('LxGroup', _group2.default);
};

exports.default = _group2.default;

/***/ }),

/***/ "LXxo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-loading{animation-duration:.6s;animation-iteration-count:infinite;animation-name:vux-loading;animation-timing-function:linear;border-radius:99em;border:3px solid #ddd;border-left-color:#666;display:inline-block;width:16px;height:16px;border-width:2px;display:table-cell;vertical-align:middle}@keyframes vux-loading{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),

/***/ "LlVN":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9Dhg");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1f6f2f4e", content, true);

/***/ }),

/***/ "LnV4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _popup = __webpack_require__("eqjz");

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hideOnBlur: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {
    this.show = this.value;
    var _this = this;
    this.popup = new _popup2.default({
      container: _this.$el,
      innerHTML: '',
      hideOnBlur: _this.hideOnBlur,
      onOpen: function onOpen(dialog) {
        _this.fixSafariOverflowScrolling('auto');
        _this.show = true;
      },
      onClose: function onClose(dialog) {
        _this.show = false;
        if ((0, _keys2.default)(window.__$vuxPopups).length >= 1) return;
        _this.fixSafariOverflowScrolling('touch');
      }
    });
    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
  },

  methods: {
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      if (!/iphone/i.test(navigator.userAgent)) return;
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    }
  },
  data: function data() {
    return {
      hasFirstShow: false,
      show: false
    };
  },

  watch: {
    value: function value() {
      this.show = this.value;
    },
    show: function show(val) {
      if (val) {
        this.popup.show();
        this.$emit('on-show');
        if (!this.hasFirstShow) {
          this.$emit('on-first-show');
          this.hasFirstShow = true;
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
      }
      this.$emit('input', val);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
  }
};

/***/ }),

/***/ "Lrpu":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("QLWW")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9w9E"),
  /* template */
  __webpack_require__("sFvm"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Ltgl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-spinner{stroke:#444;fill:#444;vertical-align:middle;display:inline-block}.vux-spinner,.vux-spinner svg{width:28px;height:28px}.vux-spinner.vux-spinner-inverse{stroke:#fff;fill:#fff}.vux-spinner-android{stroke:#4b8bf4}.vux-spinner-ios,.vux-spinner-ios-small{stroke:#69717d}.vux-spinner-spiral .stop1{stop-color:#fff;stop-opacity:0}.vux-spinner-spiral.vux-spinner-inverse .stop1{stop-color:#000}.vux-spinner-spiral.vux-spinner-inverse .stop2{stop-color:#fff}", ""]);

// exports


/***/ }),

/***/ "LwiA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (typeof Array.from === 'function' ?
  Array.from :
  __webpack_require__("Mkfm")
);


/***/ }),

/***/ "M6a0":
/***/ (function(module, exports) {



/***/ }),

/***/ "M93x":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("NuQy")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Eg/a"),
  /* template */
  __webpack_require__("iWea"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "MME6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _viewBox = __webpack_require__("nsQR");

var _viewBox2 = _interopRequireDefault(_viewBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_viewBox2.default.install = function (Vue) {
  Vue.component('LxViewBox', _viewBox2.default);
};

exports.default = _viewBox2.default;

/***/ }),

/***/ "MU5D":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("R9M2");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "MXo5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui-mask{background:rgba(0,0,0,.6)}.weui-mask,.weui-mask_transparent{position:fixed;z-index:1000;top:0;right:0;left:0;bottom:0}.weui_mask{z-index:1000;background:rgba(0,0,0,.6)}.weui_mask,.weui_mask_transparent{position:fixed;width:100%;height:100%;top:0;left:0}.weui_mask_transparent{z-index:5001}.weui_mask_transition{display:none;position:fixed;z-index:1000;width:100%;height:100%;top:0;left:0;background:transparent;transition:background .3s}.weui_fade_toggle{background:rgba(0,0,0,.6)}.weui_toast{position:fixed;z-index:50000;width:3.25333333rem;min-height:3.25333333rem;top:4.8rem;left:50%;margin-left:-.81333333rem;background:rgba(40,40,40,.75);text-align:center;border-radius:5px;color:#fff}.weui_icon_toast{margin:.58666667rem 0 0;display:block}.weui_icon_toast:before{content:\"\\EA08\";color:#fff;font-size:1.46666667rem}.weui_toast_content{margin:0 0 .4rem}.weui_loading_toast .weui_toast_content{margin-top:64%;font-size:.37333333rem}.weui_loading{position:absolute;width:0;z-index:1;left:50%;top:38%}.weui_loading_leaf{position:absolute;top:-1px;opacity:.25}.weui_loading_leaf:before{content:\" \";position:absolute;width:.21706667rem;height:.08213333rem;background:#d1d1d5;box-shadow:0 0 1px rgba(0,0,0,.0980392);border-radius:1px;-webkit-transform-origin:left 50% 0;transform-origin:left 50% 0}.weui_loading_leaf_0{-webkit-animation:opacity-60-25-0-12 1.25s linear infinite;animation:opacity-60-25-0-12 1.25s linear infinite}.weui_loading_leaf_0:before{-webkit-transform:rotate(0deg) translate(.2112rem);transform:rotate(0deg) translate(.2112rem)}.weui_loading_leaf_1{-webkit-animation:opacity-60-25-1-12 1.25s linear infinite;animation:opacity-60-25-1-12 1.25s linear infinite}.weui_loading_leaf_1:before{-webkit-transform:rotate(30deg) translate(.2112rem);transform:rotate(30deg) translate(.2112rem)}.weui_loading_leaf_2{-webkit-animation:opacity-60-25-2-12 1.25s linear infinite;animation:opacity-60-25-2-12 1.25s linear infinite}.weui_loading_leaf_2:before{-webkit-transform:rotate(60deg) translate(.2112rem);transform:rotate(60deg) translate(.2112rem)}.weui_loading_leaf_3{-webkit-animation:opacity-60-25-3-12 1.25s linear infinite;animation:opacity-60-25-3-12 1.25s linear infinite}.weui_loading_leaf_3:before{-webkit-transform:rotate(90deg) translate(.2112rem);transform:rotate(90deg) translate(.2112rem)}.weui_loading_leaf_4{-webkit-animation:opacity-60-25-4-12 1.25s linear infinite;animation:opacity-60-25-4-12 1.25s linear infinite}.weui_loading_leaf_4:before{-webkit-transform:rotate(120deg) translate(.2112rem);transform:rotate(120deg) translate(.2112rem)}.weui_loading_leaf_5{-webkit-animation:opacity-60-25-5-12 1.25s linear infinite;animation:opacity-60-25-5-12 1.25s linear infinite}.weui_loading_leaf_5:before{-webkit-transform:rotate(150deg) translate(.2112rem);transform:rotate(150deg) translate(.2112rem)}.weui_loading_leaf_6{-webkit-animation:opacity-60-25-6-12 1.25s linear infinite;animation:opacity-60-25-6-12 1.25s linear infinite}.weui_loading_leaf_6:before{-webkit-transform:rotate(180deg) translate(.2112rem);transform:rotate(180deg) translate(.2112rem)}.weui_loading_leaf_7{-webkit-animation:opacity-60-25-7-12 1.25s linear infinite;animation:opacity-60-25-7-12 1.25s linear infinite}.weui_loading_leaf_7:before{-webkit-transform:rotate(210deg) translate(.2112rem);transform:rotate(210deg) translate(.2112rem)}.weui_loading_leaf_8{-webkit-animation:opacity-60-25-8-12 1.25s linear infinite;animation:opacity-60-25-8-12 1.25s linear infinite}.weui_loading_leaf_8:before{-webkit-transform:rotate(240deg) translate(.2112rem);transform:rotate(240deg) translate(.2112rem)}.weui_loading_leaf_9{-webkit-animation:opacity-60-25-9-12 1.25s linear infinite;animation:opacity-60-25-9-12 1.25s linear infinite}.weui_loading_leaf_9:before{-webkit-transform:rotate(270deg) translate(.2112rem);transform:rotate(270deg) translate(.2112rem)}.weui_loading_leaf_10{-webkit-animation:opacity-60-25-10-12 1.25s linear infinite;animation:opacity-60-25-10-12 1.25s linear infinite}.weui_loading_leaf_10:before{-webkit-transform:rotate(300deg) translate(.2112rem);transform:rotate(300deg) translate(.2112rem)}.weui_loading_leaf_11{-webkit-animation:opacity-60-25-11-12 1.25s linear infinite;animation:opacity-60-25-11-12 1.25s linear infinite}.weui_loading_leaf_11:before{-webkit-transform:rotate(330deg) translate(.2112rem);transform:rotate(330deg) translate(.2112rem)}@-webkit-keyframes opacity-60-25-0-12{0%{opacity:.25}0.01%{opacity:.25}0.02%{opacity:1}60.01%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-0-12{0%{opacity:.25}0.01%{opacity:.25}0.02%{opacity:1}60.01%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-1-12{0%{opacity:.25}8.34333%{opacity:.25}8.35333%{opacity:1}68.3433%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-1-12{0%{opacity:.25}8.34333%{opacity:.25}8.35333%{opacity:1}68.3433%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-2-12{0%{opacity:.25}16.6767%{opacity:.25}16.6867%{opacity:1}76.6767%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-2-12{0%{opacity:.25}16.6767%{opacity:.25}16.6867%{opacity:1}76.6767%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-3-12{0%{opacity:.25}25.01%{opacity:.25}25.02%{opacity:1}85.01%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-3-12{0%{opacity:.25}25.01%{opacity:.25}25.02%{opacity:1}85.01%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-4-12{0%{opacity:.25}33.3433%{opacity:.25}33.3533%{opacity:1}93.3433%{opacity:.25}to{opacity:.25}}@keyframes opacity-60-25-4-12{0%{opacity:.25}33.3433%{opacity:.25}33.3533%{opacity:1}93.3433%{opacity:.25}to{opacity:.25}}@-webkit-keyframes opacity-60-25-5-12{0%{opacity:.270958333333333}41.6767%{opacity:.25}41.6867%{opacity:1}1.67667%{opacity:.25}to{opacity:.270958333333333}}@keyframes opacity-60-25-5-12{0%{opacity:.270958333333333}41.6767%{opacity:.25}41.6867%{opacity:1}1.67667%{opacity:.25}to{opacity:.270958333333333}}@-webkit-keyframes opacity-60-25-6-12{0%{opacity:.375125}50.01%{opacity:.25}50.02%{opacity:1}10.01%{opacity:.25}to{opacity:.375125}}@keyframes opacity-60-25-6-12{0%{opacity:.375125}50.01%{opacity:.25}50.02%{opacity:1}10.01%{opacity:.25}to{opacity:.375125}}@-webkit-keyframes opacity-60-25-7-12{0%{opacity:.479291666666667}58.3433%{opacity:.25}58.3533%{opacity:1}18.3433%{opacity:.25}to{opacity:.479291666666667}}@keyframes opacity-60-25-7-12{0%{opacity:.479291666666667}58.3433%{opacity:.25}58.3533%{opacity:1}18.3433%{opacity:.25}to{opacity:.479291666666667}}@-webkit-keyframes opacity-60-25-8-12{0%{opacity:.583458333333333}66.6767%{opacity:.25}66.6867%{opacity:1}26.6767%{opacity:.25}to{opacity:.583458333333333}}@keyframes opacity-60-25-8-12{0%{opacity:.583458333333333}66.6767%{opacity:.25}66.6867%{opacity:1}26.6767%{opacity:.25}to{opacity:.583458333333333}}@-webkit-keyframes opacity-60-25-9-12{0%{opacity:.687625}75.01%{opacity:.25}75.02%{opacity:1}35.01%{opacity:.25}to{opacity:.687625}}@keyframes opacity-60-25-9-12{0%{opacity:.687625}75.01%{opacity:.25}75.02%{opacity:1}35.01%{opacity:.25}to{opacity:.687625}}@-webkit-keyframes opacity-60-25-10-12{0%{opacity:.791791666666667}83.3433%{opacity:.25}83.3533%{opacity:1}43.3433%{opacity:.25}to{opacity:.791791666666667}}@keyframes opacity-60-25-10-12{0%{opacity:.791791666666667}83.3433%{opacity:.25}83.3533%{opacity:1}43.3433%{opacity:.25}to{opacity:.791791666666667}}@-webkit-keyframes opacity-60-25-11-12{0%{opacity:.895958333333333}91.6767%{opacity:.25}91.6867%{opacity:1}51.6767%{opacity:.25}to{opacity:.895958333333333}}@keyframes opacity-60-25-11-12{0%{opacity:.895958333333333}91.6767%{opacity:.25}91.6867%{opacity:1}51.6767%{opacity:.25}to{opacity:.895958333333333}}", ""]);

// exports


/***/ }),

/***/ "MZYl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "@w: 37.5rem;.vux-reddot,.vux-reddot-border,.vux-reddot-s{position:relative}.vux-reddot-border:after,.vux-reddot-s:after,.vux-reddot:after{background-color:#f74c31;right:-3/@w;top:-3/@w}.vux-reddot-border:after,.vux-reddot-border:before,.vux-reddot-s:after,.vux-reddot:after{content:\"\";position:absolute;display:block;width:8/@w;height:8/@w;border-radius:5px;background-clip:padding-box}.vux-reddot-border:before{background-color:#fff;right:-4/@w;top:-4/@w;padding:1px}.vux-reddot-s:after{width:6/@w;height:6/@w;top:-5/@w;right:-5/@w}", ""]);

// exports


/***/ }),

/***/ "MbSb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.vux-divider{display:table;white-space:nowrap;height:auto;overflow:hidden;line-height:1;text-align:center;padding:.26666667rem 0;color:#666}.vux-divider:after,.vux-divider:before{content:\"\";display:table-cell;position:relative;top:50%;width:50%;background-repeat:no-repeat;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC)}.vux-divider:before{background-position:right 1em top 50%}.vux-divider:after{background-position:left 1em top 50%}", ""]);

// exports


/***/ }),

/***/ "MeU4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flexbox = __webpack_require__("x75x");

var _flexbox2 = _interopRequireDefault(_flexbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_flexbox2.default.install = function (Vue) {
  Vue.component('LxFlexbox', _flexbox2.default);
};

exports.default = _flexbox2.default;

/***/ }),

/***/ "MeUp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3"),
    Base = __webpack_require__("5dD5"),
    Animate = __webpack_require__("W0DV"),
    Boundry = __webpack_require__("hlpk"),
    Hammer = __webpack_require__("ZOvT"),
    Sticky = __webpack_require__("g2NE"),
    Fixed = __webpack_require__("cW+z");
// boundry checked bounce effect
var BOUNDRY_CHECK_DURATION = 500;
var BOUNDRY_CHECK_EASING = "ease";
var BOUNDRY_CHECK_ACCELERATION = 0.1;
/** 
 * @constructor
 * @param {object} cfg config for scroll
 * @param {number} cfg.SCROLL_ACCELERATION  acceleration for scroll, min value make the scrolling smoothly
 * @param {number} cfg.BOUNDRY_CHECK_DURATION duration for boundry bounce
 * @param {number} cfg.BOUNDRY_CHECK_EASING easing for boundry bounce
 * @param {number} cfg.BOUNDRY_CHECK_ACCELERATION acceleration for boundry bounce
 * @param {boolean} cfg.lockX just like overflow-x:hidden
 * @param {boolean} cfg.lockY just like overflow-y:hidden
 * @param {boolean} cfg.scrollbarX config if the scrollbar-x is visible
 * @param {boolean} cfg.scrollbarY config if the scrollbar-y is visible
 * @param {boolean} cfg.useTransition config if use css3 transition or raf for scroll animation
 * @param {boolean} cfg.useOriginScroll config if use simulate or origin scroll
 * @param {boolean} cfg.bounce config if use has the bounce effect when scrolling outside of the boundry
 * @param {boolean} cfg.boundryCheck config if scrolling inside of the boundry
 * @param {boolean} cfg.preventDefault prevent touchstart
 * @param {boolean} cfg.preventTouchMove prevent touchmove
 * @param {string|HTMLElement}  cfg.container config for scroller's container which default value is ".xs-container"
 * @param {string|HTMLElement}  cfg.content config for scroller's content which default value is ".xs-content"
 * @param {object}  cfg.indicatorInsets  config scrollbars position {top: number, left: number, bottom: number, right: number}
 * @param {string}  cfg.stickyElements config for sticky-positioned elements
 * @param {string}  cfg.fixedElements config for fixed-positioned elements
 * @param {string}  cfg.touchAction config for touchAction of the scroller
 * @extends XScroll
 * @example
 * var xscroll = new XScroll({
 *    renderTo:"#scroll",
 *    lockX:false,
 *    scrollbarX:true
 * });
 * xscroll.render();
 */
function XScroll(cfg) {
    XScroll.superclass.constructor.call(this);
    this.userConfig = cfg;
    this.init();
}

Util.extend(XScroll, Base, {
    /**
     * version
     * @memberof XScroll
     * @type {string}
     */
    version: "3.0.13",
    /**
     * init scroll
     * @memberof XScroll
     * @return {XScroll}
     */
    init: function() {
        var self = this;
        var defaultCfg = {
            preventDefault: true,
            bounce: true,
            boundryCheck: true,
            useTransition: true,
            gpuAcceleration: true,
            BOUNDRY_CHECK_EASING: BOUNDRY_CHECK_EASING,
            BOUNDRY_CHECK_DURATION: BOUNDRY_CHECK_DURATION,
            BOUNDRY_CHECK_ACCELERATION: BOUNDRY_CHECK_ACCELERATION,
            useOriginScroll: false,
            zoomType: "y",
            indicatorInsets: {
                top: 3,
                bottom: 3,
                left: 3,
                right: 3,
                width: 3,
                spacing: 5
            },
            container: ".xs-container",
            content: ".xs-content",
            stickyElements: ".xs-sticky",
            fixedElements: ".xs-fixed",
            touchAction: "auto"
        };
        //generate guid
        self.guid = Util.guid();
        self.renderTo = Util.getNode(self.userConfig.renderTo);
        //timer for animtion
        self.__timers = {};
        //config attributes on element
        var elCfg = JSON.parse(self.renderTo.getAttribute('xs-cfg'));
        var userConfig = self.userConfig = Util.mix(Util.mix(defaultCfg, elCfg), self.userConfig);
        self.container = Util.getNode(userConfig.container,self.renderTo);
        self.content = Util.getNode(userConfig.content,self.renderTo);
        self.boundry = new Boundry();
        self.boundry.refresh();
        return self;
    },
    /**
     * destroy scroll
     * @memberof XScroll
     * @return {XScroll}
     */
    destroy: function() {
        var self = this;
        self.mc && self.mc.destroy();
        self.sticky && self.sticky.destroy();
        self.fixed && self.fixed.destroy();
    },
    _initContainer: function() {},
    /**
     * @memberof XScroll
     * @return {XScroll}
     */
    enableGPUAcceleration: function() {
        this.userConfig.gpuAcceleration = true;
        return this;
    },
    /**
     * @memberof XScroll
     * @return {XScroll}
     */
    disableGPUAcceleration: function() {
        this.userConfig.gpuAcceleration = false;
        return this;
    },
    /**
     * get scroll offset
     * @memberof XScroll
     * @return {Object} {scrollTop:scrollTop,scrollLeft:scrollLeft}
     */
    getScrollPos: function() {
        var self = this;
        return {
            scrollLeft: self.getScrollLeft(),
            scrollTop: self.getScrollTop()
        }
    },
    /**
     * get scroll top value
     * @memberof XScroll
     * @return {number} scrollTop
     */
    getScrollTop: function() {},
    /**
     * get scroll left value
     * @memberof XScroll
     * @return {number} scrollLeft
     */
    getScrollLeft: function() {},
    /**
     * scroll absolute to the destination
     * @memberof XScroll
     * @param scrollLeft {number} scrollLeft
     * @param scrollTop {number} scrollTop
     * @param duration {number} duration for animte
     * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
     **/
    scrollTo: function(scrollLeft, scrollTop, duration, easing, callback) {
        var self = this;
        var scrollLeft = (undefined === scrollLeft || isNaN(scrollLeft)) ? -self.getScrollLeft() : scrollLeft;
        var scrollTop = (undefined === scrollTop || isNaN(scrollTop)) ? -self.getScrollTop() : scrollTop;
        self.scrollLeft(scrollLeft, duration, easing, callback);
        self.scrollTop(scrollTop, duration, easing, callback);
    },
    /**
     * scroll relative to the destination
     * @memberof XScroll
     * @param scrollLeft {number} scrollLeft
     * @param scrollTop {number} scrollTop
     * @param duration {number} duration for animte
     * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
     **/
    scrollBy: function(scrollLeft, scrollTop, duration, easing, callback) {
        this.scrollByX(scrollLeft, duration, easing, callback);
        this.scrollByY(scrollTop, duration, easing, callback);
    },
    /**
     * horizontal scroll relative to the destination
     * @memberof XScroll
     * @param scrollLeft {number} scrollLeft
     * @param duration {number} duration for animte
     * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
     **/
    scrollLeftBy: function(scrollLeft, duration, easing, callback) {
        this.scrollLeft(Number(scrollLeft) + Number(this.getScrollLeft()), duration, easing, callback);
    },
    /**
     * vertical scroll relative to the destination
     * @memberof XScroll
     * @param scrollTop {number} scrollTop
     * @param duration {number} duration for animte
     * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
     **/
    scrollTopBy: function(scrollTop, duration, easing, callback) {
        this.scrollTop(Number(scrollTop) + Number(this.getScrollTop()), duration, easing, callback);
    },
    /**
     * horizontal scroll absolute to the destination
     * @memberof XScroll
     * @param scrollLeft {number} scrollLeft
     * @param duration {number} duration for animte
     * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
     **/
    scrollLeft: function(scrollLeft, duration, easing, callback) {},
    /**
     * vertical scroll absolute to the destination
     * @memberof XScroll
     * @param scrollTop {number} scrollTop
     * @param duration {number} duration for animte
     * @param easing {string} easing functio for animate : ease-in | ease-in-out | ease | bezier(n,n,n,n)
     **/
    scrollTop: function(scrollTop, duration, easing, callback) {},
    /**
     * reset the boundry size
     * @memberof XScroll
     * @return {XScroll}
     **/
    resetSize: function() {
        var self = this;
        if(!self.container || !self.content) return;
        var userConfig = self.userConfig;
        var renderToStyle = getComputedStyle(self.renderTo);
        var width = self.width = (userConfig.width || self.renderTo.offsetWidth) - Util.px2Num(renderToStyle['padding-left']) - Util.px2Num(renderToStyle['padding-right']);
        var height = self.height = (userConfig.height || self.renderTo.offsetHeight) - Util.px2Num(renderToStyle['padding-top']) - Util.px2Num(renderToStyle['padding-bottom']);;
        var containerWidth = userConfig.containerWidth || self.content.offsetWidth;
        var containerHeight = userConfig.containerHeight || self.content.offsetHeight;
        self.containerWidth = containerWidth < self.width ? self.width : containerWidth;
        self.containerHeight = containerHeight < self.height ? self.height : containerHeight;
        self.boundry.refresh({
            width: self.width,
            height: self.height
        });
        return self;
    },
    /**
     * render scroll
     * @memberof XScroll
     * @return {XScroll}
     **/
    render: function() {
        var self = this;
        self.resetSize();
        //init stickies
        self.initSticky();
        //init fixed elements
        self.initFixed();

        self.trigger("afterrender", {
            type: "afterrender"
        });
        self._bindEvt();
        //update touch-action 
        self.initTouchAction();
        return self;
    },
    /**
     * init touch action
     * @memberof XScroll
     * @return {XScroll}
     */
    initTouchAction: function() {
        var self = this;
        self.mc.set({
            touchAction: self.userConfig.touchAction
        });
        return self;
    },
    initFixed: function() {
        var self = this,
            userConfig = self.userConfig;
        self.fixed = self.fixed || new Fixed({
            fixedElements:userConfig.fixedElements,
            xscroll:self,
            fixedRenderTo:userConfig.fixedRenderTo
        });
        self.fixed.render();
        self.resetSize();
        return self;
    },
    initSticky:function(){
        var self = this,userConfig = self.userConfig;
        var sticky = self.sticky = self.sticky || new Sticky({
            xscroll:self,
            zoomType:userConfig.zoomType,
            stickyRenderTo:userConfig.stickyRenderTo
        });
        sticky.render();
    },
    /**
     * bounce to the boundry vertical and horizontal
     * @memberof XScroll
     * @return {XScroll}
     **/
    boundryCheck: function() {
        return this;
    },
    /**
     * bounce to the boundry horizontal
     * @memberof XScroll
     * @return {XScroll}
     **/
    boundryCheckX: function() {
        return this;
    },
    /**
     * bounce to the boundry vertical
     * @memberof XScroll
     * @return {XScroll}
     **/
    boundryCheckY: function() {
        return this;
    },
    _bindEvt: function() {
        var self = this;
        if (self.___isEvtBind) return;
        self.___isEvtBind = true;
        var mc = self.mc = new Hammer.Manager(self.renderTo);
        var tap = new Hammer.Tap();
        var pan = new Hammer.Pan();
        var pinch = new Hammer.Pinch();
        mc.add([tap, pan]);
        //trigger all events 
        self.mc.on("panstart pan panend pancancel pinchstart pinchmove pinchend pinchcancel pinchin pinchout", function(e) {
            self.trigger(e.type, e);
        });
        //trigger touch events
        var touchEvents = ['touchstart', 'touchmove', 'touchend', 'touchcancel','mousedown'];
        for (var i = 0, l = touchEvents.length; i < l; i++) {
            self.renderTo.addEventListener(touchEvents[i], function(e) {
                self.trigger(e.type, e);
            });
        }
        self.mc.on("tap", function(e) {
            if (e.tapCount == 1) {
                e.type = "tap";
                self.trigger(e.type, e);
            } else if (e.tapCount == 2) {
                e.type = "doubletap";
                self.trigger("doubletap", e);
            }
        });
        return self;
    },
    _resetLockConfig: function() {},
    stop: function() {}
});

if (typeof module == 'object' && module.exports) {
    module.exports = XScroll;
}


/***/ }),

/***/ "Mhyx":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("/bQp");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "MieJ":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhFAAUAPMIAIeHhz8/P1dXVycnJ8/Pz7e3t5+fn29vb////wAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAIACwAAAAAFAAUAEAEUxDJSatFxtwaggWAdIyHJAhXoRYSQUhDPGx0TbmujahbXGWZWqdDAYEsp5NupLPkdDwE7oXwWVasimzWrAE1tKFHErQRK8eL8mMUlRBJVI307uoiACH5BAUHAAgALAEAAQASABIAAAROEMkpS6E4W5upMdUmEQT2feFIltMJYivbvhnZ3R0A4NMwIDodz+cL7nDEn5CH8DGZh8MtEMBEoxkqlXKVIgQCibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpjaE4W5spANUmFQX2feFIltMJYivbvhnZ3d1x4BNBIDodz+cL7nDEn5CH8DGZAsFtMMBEoxkqlXKVIgIBibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpAaA4W5vpOdUmGQb2feFIltMJYivbvhnZ3Z0g4FNRIDodz+cL7nDEn5CH8DGZgcCNQMBEoxkqlXKVIgYDibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpz6E4W5upENUmAQD2feFIltMJYivbvhnZ3V0Q4JNhIDodz+cL7nDEn5CH8DGZg8GtUMBEoxkqlXKVIggEibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkphaA4W5tpCNUmHQf2feFIltMJYivbvhnZ3d0w4BMAIDodz+cL7nDEn5CH8DGZBMLNYMBEoxkqlXKVIgoFibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpQ6A4W5vpGNUmCQL2feFIltMJYivbvhnZ3R1B4NNxIDodz+cL7nDEn5CH8DGZhcINAMBEoxkqlXKVIgwGibbK9YLBYvLtHH5K0J0IACH5BAUHAAcALAEAAQASABIAAANCeLo6wzA6FxkhbaoQ4L3ZxnXLh0EjWZ4RV71VUcCLIByyTNt2PsO8m452sBGJBsNxkUwuD03lAQBASqnUJ7aq5UYSADs="

/***/ }),

/***/ "MjVu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _box = __webpack_require__("THZP");

var _box2 = _interopRequireDefault(_box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_box2.default.install = function (Vue) {
  Vue.component('LxBox', _box2.default);
};

exports.default = _box2.default;

/***/ }),

/***/ "Mkfm":
/***/ (function(module, exports) {

// Production steps of ECMA-262, Edition 6, 22.1.2.1
// Reference: http://www.ecma-international.org/ecma-262/6.0/#sec-array.from
module.exports = (function() {
  var isCallable = function(fn) {
    return typeof fn === 'function';
  };
  var toInteger = function (value) {
    var number = Number(value);
    if (isNaN(number)) { return 0; }
    if (number === 0 || !isFinite(number)) { return number; }
    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };
  var maxSafeInteger = Math.pow(2, 53) - 1;
  var toLength = function (value) {
    var len = toInteger(value);
    return Math.min(Math.max(len, 0), maxSafeInteger);
  };
  var iteratorProp = function(value) {
    if(value != null) {
      if(['string','number','boolean','symbol'].indexOf(typeof value) > -1){
        return Symbol.iterator;
      } else if (
        (typeof Symbol !== 'undefined') &&
        ('iterator' in Symbol) &&
        (Symbol.iterator in value)
      ) {
        return Symbol.iterator;
      }
      // Support "@@iterator" placeholder, Gecko 27 to Gecko 35
      else if ('@@iterator' in value) {
        return '@@iterator';
      }
    }
  };
  var getMethod = function(O, P) {
    // Assert: IsPropertyKey(P) is true.
    if (O != null && P != null) {
      // Let func be GetV(O, P).
      var func = O[P];
      // ReturnIfAbrupt(func).
      // If func is either undefined or null, return undefined.
      if(func == null) {
        return void 0;
      }
      // If IsCallable(func) is false, throw a TypeError exception.
      if (!isCallable(func)) {
        throw new TypeError(func + ' is not a function');
      }
      return func;
    }
  };
  var iteratorStep = function(iterator) {
    // Let result be IteratorNext(iterator).
    // ReturnIfAbrupt(result).
    var result = iterator.next();
    // Let done be IteratorComplete(result).
    // ReturnIfAbrupt(done).
    var done = Boolean(result.done);
    // If done is true, return false.
    if(done) {
      return false;
    }
    // Return result.
    return result;
  };

  // The length property of the from method is 1.
  return function from(items /*, mapFn, thisArg */ ) {
    'use strict';

    // 1. Let C be the this value.
    var C = this;

    // 2. If mapfn is undefined, let mapping be false.
    var mapFn = arguments.length > 1 ? arguments[1] : void 0;

    var T;
    if (typeof mapFn !== 'undefined') {
      // 3. else
      //   a. If IsCallable(mapfn) is false, throw a TypeError exception.
      if (!isCallable(mapFn)) {
        throw new TypeError(
          'Array.from: when provided, the second argument must be a function'
        );
      }

      //   b. If thisArg was supplied, let T be thisArg; else let T
      //      be undefined.
      if (arguments.length > 2) {
        T = arguments[2];
      }
      //   c. Let mapping be true (implied by mapFn)
    }

    var A, k;

    // 4. Let usingIterator be GetMethod(items, @@iterator).
    // 5. ReturnIfAbrupt(usingIterator).
    var usingIterator = getMethod(items, iteratorProp(items));

    // 6. If usingIterator is not undefined, then
    if (usingIterator !== void 0) {
      // a. If IsConstructor(C) is true, then
      //   i. Let A be the result of calling the [[Construct]]
      //      internal method of C with an empty argument list.
      // b. Else,
      //   i. Let A be the result of the abstract operation ArrayCreate
      //      with argument 0.
      // c. ReturnIfAbrupt(A).
      A = isCallable(C) ? Object(new C()) : [];

      // d. Let iterator be GetIterator(items, usingIterator).
      var iterator = usingIterator.call(items);

      // e. ReturnIfAbrupt(iterator).
      if (iterator == null) {
        throw new TypeError(
          'Array.from requires an array-like or iterable object'
        );
      }

      // f. Let k be 0.
      k = 0;

      // g. Repeat
      var next, nextValue;
      while (true) {
        // i. Let Pk be ToString(k).
        // ii. Let next be IteratorStep(iterator).
        // iii. ReturnIfAbrupt(next).
        next = iteratorStep(iterator);

        // iv. If next is false, then
        if (!next) {

          // 1. Let setStatus be Set(A, "length", k, true).
          // 2. ReturnIfAbrupt(setStatus).
          A.length = k;

          // 3. Return A.
          return A;
        }
        // v. Let nextValue be IteratorValue(next).
        // vi. ReturnIfAbrupt(nextValue)
        nextValue = next.value;

        // vii. If mapping is true, then
        //   1. Let mappedValue be Call(mapfn, T, «nextValue, k»).
        //   2. If mappedValue is an abrupt completion, return
        //      IteratorClose(iterator, mappedValue).
        //   3. Let mappedValue be mappedValue.[[value]].
        // viii. Else, let mappedValue be nextValue.
        // ix.  Let defineStatus be the result of
        //      CreateDataPropertyOrThrow(A, Pk, mappedValue).
        // x. [TODO] If defineStatus is an abrupt completion, return
        //    IteratorClose(iterator, defineStatus).
        if (mapFn) {
          A[k] = mapFn.call(T, nextValue, k);
        }
        else {
          A[k] = nextValue;
        }
        // xi. Increase k by 1.
        k++;
      }
      // 7. Assert: items is not an Iterable so assume it is
      //    an array-like object.
    } else {

      // 8. Let arrayLike be ToObject(items).
      var arrayLike = Object(items);

      // 9. ReturnIfAbrupt(items).
      if (items == null) {
        throw new TypeError(
          'Array.from requires an array-like object - not null or undefined'
        );
      }

      // 10. Let len be ToLength(Get(arrayLike, "length")).
      // 11. ReturnIfAbrupt(len).
      var len = toLength(arrayLike.length);

      // 12. If IsConstructor(C) is true, then
      //     a. Let A be Construct(C, «len»).
      // 13. Else
      //     a. Let A be ArrayCreate(len).
      // 14. ReturnIfAbrupt(A).
      A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 15. Let k be 0.
      k = 0;
      // 16. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = arrayLike[k];
        if (mapFn) {
          A[k] = mapFn.call(T, kValue, k);
        }
        else {
          A[k] = kValue;
        }
        k++;
      }
      // 17. Let setStatus be Set(A, "length", len, true).
      // 18. ReturnIfAbrupt(setStatus).
      A.length = len;
      // 19. Return A.
    }
    return A;
  };
})();


/***/ }),

/***/ "MmMw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("EqjI");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "N3gE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-1px-t{border-top:1px solid #e0e0e0}.vux-1px-b,.vux-1px-tb{border-bottom:1px solid #e0e0e0}.vux-1px-tb{border-top:1px solid #e0e0e0;background-image:none}.vux-1px-l{border-left:1px solid #e0e0e0}.vux-1px-r{border-right:1px solid #e0e0e0}.vux-1px,.vux-1px-radius{border:1px solid #e0e0e0}.vux-1px-radius{border-radius:4px}@media screen and (min-device-pixel-ratio:2){.vux-1px-radius{position:relative;border:0}.vux-1px-radius:before{content:\"\";width:200%;height:200%;position:absolute;top:0;left:0;border:1px solid #e0e0e0;transform:scale(.5);transform-origin:0 0;padding:1px;box-sizing:border-box;border-radius:8px;pointer-events:none}}@media screen and (-webkit-min-device-pixel-ratio:2){.vux-1px{position:relative;border:0}.vux-1px-b,.vux-1px-l,.vux-1px-r,.vux-1px-t,.vux-1px-tb{border:0}.vux-1px-t{background-position:0 0;background-image:-webkit-gradient(linear,left bottom,left top,color-stop(.5,transparent),color-stop(.5,#e0e0e0))}.vux-1px-b{background-position:0 100%;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(.5,transparent),color-stop(.5,#e0e0e0))}.vux-1px-b,.vux-1px-t,.vux-1px-tb{background-repeat:repeat-x;-webkit-background-size:100% 1px}.vux-1px-tb{background-image:-webkit-gradient(linear,left bottom,left top,color-stop(.5,transparent),color-stop(.5,#e0e0e0)),-webkit-gradient(linear,left top,left bottom,color-stop(.5,transparent),color-stop(.5,#e0e0e0));background-position:top,bottom}.vux-1px-l{background-position:0 0;background-image:-webkit-gradient(linear,right top,left top,color-stop(.5,transparent),color-stop(.5,#e0e0e0))}.vux-1px-r{background-position:100% 0;background-image:-webkit-gradient(linear,left top,right top,color-stop(.5,transparent),color-stop(.5,#e0e0e0))}.vux-1px-l,.vux-1px-r{background-repeat:repeat-y;background-size:1px 100%}.vux-1px:after{content:\"\";width:100%;height:100%;position:absolute;top:0;left:0;background-image:-webkit-gradient(linear,left bottom,left top,color-stop(.5,transparent),color-stop(.5,#e0e0e0)),-webkit-gradient(linear,left top,right top,color-stop(.5,transparent),color-stop(.5,#e0e0e0)),-webkit-gradient(linear,left top,left bottom,color-stop(.5,transparent),color-stop(.5,#e0e0e0)),-webkit-gradient(linear,right top,left top,color-stop(.5,transparent),color-stop(.5,#e0e0e0));background-size:100% 1px,1px 100%,100% 1px,1px 100%;background-repeat:no-repeat;background-position:top,100%,bottom,0;padding:1px;box-sizing:border-box;z-index:10;pointer-events:none}}", ""]);

// exports


/***/ }),

/***/ "NFXr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{line-height:1.6;font-family:Helvetica Neue,Helvetica,microsoft yahei,Arial,sans-serif}*{margin:0;padding:0}a img{border:0}a{text-decoration:none}body{background-color:#fbf9fe}@-webkit-keyframes popInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes popInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@-webkit-keyframes popOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes popOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@-webkit-keyframes popInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes popInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@-webkit-keyframes popOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes popOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.router-view{width:100%;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-backface-visibility:hidden;backface-visibility:hidden}.vux-pop-in-enter-active,.vux-pop-in-leave-active,.vux-pop-out-enter-active,.vux-pop-out-leave-active{will-change:transform;height:100%;position:absolute;left:0}.vux-pop-out-enter-active{-webkit-animation-name:popInLeft;animation-name:popInLeft}.vux-pop-out-leave-active{-webkit-animation-name:popOutRight;animation-name:popOutRight}.vux-pop-in-enter-active{-webkit-perspective:1000;perspective:1000;-webkit-animation-name:popInRight;animation-name:popInRight}.vux-pop-in-leave-active{-webkit-animation-name:popOutLeft;animation-name:popOutLeft}", ""]);

// exports


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cvux_lib_theme_default_flexbox_item_css__ = __webpack_require__("AOR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cvux_lib_theme_default_flexbox_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cvux_lib_theme_default_flexbox_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cvux_lib_theme_default_base_css__ = __webpack_require__("Ghib");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cvux_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cvux_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cvux_lib_flexbox_item__ = __webpack_require__("ytHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cvux_lib_flexbox_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_cvux_lib_flexbox_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cvux_lib_theme_default_flexbox_css__ = __webpack_require__("96pW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cvux_lib_theme_default_flexbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cvux_lib_theme_default_flexbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cvux_lib_flexbox__ = __webpack_require__("1DRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cvux_lib_flexbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_cvux_lib_flexbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cvux_lib_theme_default_picker_css__ = __webpack_require__("C6hE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cvux_lib_theme_default_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_cvux_lib_theme_default_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cvux_lib_picker__ = __webpack_require__("6VQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cvux_lib_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_cvux_lib_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cvux_lib_theme_default_popup_css__ = __webpack_require__("oGHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cvux_lib_theme_default_popup_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_cvux_lib_theme_default_popup_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_cvux_lib_popup__ = __webpack_require__("COnS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_cvux_lib_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_cvux_lib_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_mixins__ = __webpack_require__("q3JJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rest__ = __webpack_require__("i4WM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__stylesheets_app_less__ = __webpack_require__("3NEM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__stylesheets_app_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__stylesheets_app_less__);












// 调试模式
// replacing_debug


// 按需引入cvux


// 数据上报
var report = {};
if (true) {
  report = __webpack_require__("l+Iq");
}

// vuex 仓库


// 微信SDK调用
// import wechat from './wechat'

// 初始化全局toast



// api配置

// 路由配置

 // 使用require导入样式文件

// Vue.use(Cvux)
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_cvux_lib_popup___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_cvux_lib_picker___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_cvux_lib_flexbox___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_cvux_lib_flexbox_item___default.a);

var FastClick = __webpack_require__("v5o6");
FastClick.attach(document.body);

// 解决FastClick的点击穿透问题(输入框在ios上点击输入调取手机自带输入键盘不灵敏,安卓上完全没问题)
FastClick.prototype.focus = function (targetElement) {
  var length = void 0;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_9_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__vuex_store__["a" /* default */],
  rest: __WEBPACK_IMPORTED_MODULE_13__rest__["a" /* default */],
  // wechat, // wx
  report: report, // sentry 数据上报
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_12__App_vue___default.a
  }
});

/***/ }),

/***/ "NNfK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".steps{padding-bottom:.4rem}.steps .steps_item{position:relative;padding:.4rem}.steps .steps_item:before{left:1.06666667rem}.steps .step_status{background-color:#eee;width:.48rem;margin-right:.32rem}.steps .step_status i.status_line{position:absolute;left:.64rem;top:0;bottom:0;width:1px;-webkit-transform:translateX(-50%);transform:translateX(-50%);background-color:#bebebe}.steps .step_status i.status_line_blue{background-color:#5890ff}.steps .step_status i.icon{position:absolute;left:.49333333rem;top:.49333333rem;width:.32rem;height:.32rem;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;-ms-border-radius:50%;-o-border-radius:50%}.steps .step_status i.original{left:.56rem;top:.56rem;width:.16rem;height:.16rem;background-color:#bebebe}.steps .step_status i.status_ok{background-color:#5890ff}.steps .step_status i.status_ok:after{content:\" \";position:absolute;left:.06666667rem;top:.08rem;width:.13333333rem;height:.08rem;border-left:.04rem solid #fff;border-bottom:.04rem solid #fff}.steps .step_status i.status_no,.steps .step_status i.status_ok:after{transform:rotate(-45deg);-ms-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-webkit-transform:rotate(-45deg);-o-transform:rotate(-45deg)}.steps .step_status i.status_no{box-shadow:0 0 0 .08rem #fdb2b2;-webkit-box-shadow:0 0 0 .08rem #fdb2b2;background-color:#fb3f3f}.steps .step_status i.status_no:before{width:.21333333rem;height:.05333333rem}.steps .step_status i.status_no:after,.steps .step_status i.status_no:before{content:\" \";position:absolute;left:50%;top:50%;background-color:#fff;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.steps .step_status i.status_no:after{width:.05333333rem;height:.21333333rem}.steps .step_status i.status_waiting{box-shadow:0 0 0 .08rem #cdddff;-webkit-box-shadow:0 0 0 .08rem #cdddff;background-color:#5890ff}.steps .steps_item:first-child i.status_line{top:.56rem}.steps .steps_item:last-child i.status_line{height:.56rem}.steps .step_info{font-size:.34666667rem;line-height:.53333333rem;color:#9a9a9a}.steps .step_info .step_title_info{padding-bottom:.06666667rem}.steps .step_info .step_title{color:#000}.steps .step_info .step_frKey{float:right}.steps .step_info .i_phone{color:#5890ff}", ""]);

// exports


/***/ }),

/***/ "NWt+":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var anObject = __webpack_require__("77Pl");
var toLength = __webpack_require__("QRG4");
var getIterFn = __webpack_require__("3fs2");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "NXHL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function find(array, predicate, context) {
  if (typeof Array.prototype.find === 'function') {
    return array.find(predicate, context);
  }

  context = context || this;
  var length = array.length;
  var i;

  if (typeof predicate !== 'function') {
    throw new TypeError(predicate + ' is not a function');
  }

  for (i = 0; i < length; i++) {
    if (predicate.call(context, array[i], i, array)) {
      return array[i];
    }
  }
}

module.exports = find;


/***/ }),

/***/ "NXzX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+aDL");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7a832e73", content, true);

/***/ }),

/***/ "NZti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * url help methods
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 将查询字符串解析成一个对象
   * @param str
   * @returns {{}}
   */
  getParams: function getParams(str) {
    var rs = {};
    if (typeof str === 'string' && str.trim()) {
      var decode = decodeURIComponent;
      var pairs = str.split('&');
      for (var i = 0, l = pairs.length; i < l; ++i) {
        var pair = pairs[i].split('=');
        var key = decode(pair[0]).replace('[]', '');
        var val = decode(pair[1]);
        if (key in rs) {
          if (Array.isArray(rs[key])) {
            rs[key].push(val);
          } else {
            rs[key] = [rs[key], val];
          }
        } else {
          rs[key] = val;
        }
      }
    }
    return rs;
  },

  /**
   * 解析location.hash部分，得出模块名称和传递的参数
   * @param hash location.hash
   * @returns {{}}
   */
  parseHash: function parseHash(hash) {
    var hashName = '';
    var dataObj = {};
    if (hash !== 'undefined' && hash !== '') {
      var hashArr = hash.substring(1).split('?');
      hashName = hashArr[0];
      if (hashArr.length > 1) {
        dataObj = this.getParams(hashArr[1]);
      }
    }
    return {
      hashName: hashName,
      params: dataObj
    };
  },

  /**
   * 获取 location.search的值
   * @returns [Object] 对象
   */
  getSearch: function getSearch() {
    var hash = window.location.hash;
    var index = hash.indexOf('?');
    var o = {};
    var item = void 0;
    var searchs = [window.location.search, index !== -1 ? hash.substr(index) : ''];
    searchs.forEach(function (search) {
      if (search) {
        search = search.substr(1).split('&');
        // for (var i = 0, len = search.length; i < len; i++) {
        //   item = search[i].split('=')
        //   o[item[0]] = item[1]
        // }
        search.forEach(function (val) {
          item = val.split('=');
          o[item[0]] = item[1];
        });
      }
    });
    return o;
  }
});

/***/ }),

/***/ "NiOf":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_panel weui_panel_access"
  }, [(_vm.header && _vm.header.title) ? _c('div', {
    staticClass: "weui_panel_hd",
    domProps: {
      "innerHTML": _vm._s(_vm.header.title)
    },
    on: {
      "click": function($event) {
        _vm.$emit('on-click-header')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "weui_panel_bd"
  }, [_c('div', {
    staticClass: "vux-card-content"
  }, [_vm._t("content")], 2)]), _vm._v(" "), (_vm.footer && _vm.footer.title) ? _c('a', {
    staticClass: "weui_panel_ft",
    attrs: {
      "href": "javascript:"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.footer.title)
    },
    on: {
      "click": _vm.onClickFooter
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "NpIQ":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "NqmX":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_panel weui_panel_access"
  }, [(_vm.header) ? _c('div', {
    staticClass: "weui_panel_hd",
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    },
    on: {
      "click": _vm.onClickHeader
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui_panel_bd"
  }, [_vm._l((_vm.list), function(item) {
    return (_vm.type === '1') ? _c('a', {
      staticClass: "weui_media_box weui_media_appmsg",
      attrs: {
        "href": _vm.getUrl(item.url)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onItemClick(item)
        }
      }
    }, [(item.src) ? _c('div', {
      staticClass: "weui_media_hd"
    }, [_c('img', {
      staticClass: "weui_media_appmsg_thumb",
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "weui_media_bd"
    }, [_c('h4', {
      staticClass: "weui_media_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "weui_media_desc"
    }, [_vm._v(_vm._s(item.desc))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return (_vm.type === '2') ? _c('div', {
      staticClass: "weui_media_box weui_media_text",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onItemClick(item)
        }
      }
    }, [_c('h4', {
      staticClass: "weui_media_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "weui_media_desc"
    }, [_vm._v(_vm._s(item.desc))])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "weui_media_box weui_media_small_appmsg"
  }, [_c('div', {
    staticClass: "weui_cells weui_cells_access"
  }, _vm._l((_vm.list), function(item) {
    return (_vm.type === '3') ? _c('a', {
      staticClass: "weui_cell",
      attrs: {
        "href": _vm.getUrl(item.url)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onItemClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "weui_cell_hd"
    }, [_c('img', {
      staticStyle: {
        "width": "20px",
        "margin-right": "5px",
        "display": "block"
      },
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "weui_cell_bd weui_cell_primary"
    }, [_c('p', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('span', {
      staticClass: "weui_cell_ft"
    })]) : _vm._e()
  }))]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return (_vm.type === '4') ? _c('a', {
      staticClass: "weui_media_box weui_media_appmsg",
      attrs: {
        "href": _vm.getUrl(item.url)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onItemClick(item)
        }
      }
    }, [(item.src) ? _c('div', {
      staticClass: "weui_media_hd"
    }, [_c('img', {
      staticClass: "weui_media_appmsg_thumb",
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "weui_media_bd"
    }, [_c('h4', {
      staticClass: "weui_media_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h4', {
      staticClass: "weui_media_title"
    }, [_c('span', [_vm._v("title: ")]), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h4', {
      staticClass: "weui_media_title"
    }, [_c('span', [_vm._v("title: ")]), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h4', {
      staticClass: "weui_media_title"
    }, [_c('span', [_vm._v("title: ")]), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "weui_media_desc"
    }, [_vm._v(_vm._s(item.desc))])])]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.footer && _vm.type !== '3') ? _c('a', {
    staticClass: "weui_panel_ft",
    attrs: {
      "href": _vm.getUrl(_vm.footer.url)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.footer.title)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickFooter($event)
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ "NuQy":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("NFXr");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b8f7e290", content, true);

/***/ }),

/***/ "NwRT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    leftOptions: {
      type: Object,
      default: function _default() {
        return {
          showBack: true,
          backText: 'Back',
          preventGoBack: false
        };
      }
    },
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this.leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        window.history.back();
      }
    }
  }
};

/***/ }),

/***/ "Nwok":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("MXo5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("47810c74", content, true);

/***/ }),

/***/ "O+Sz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xButton = __webpack_require__("xy9C");

var _xButton2 = _interopRequireDefault(_xButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xButton2.default.install = function (Vue) {
  Vue.component('LxXButton', _xButton2.default);
};

exports.default = _xButton2.default;

/***/ }),

/***/ "O/iI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nav) {
  if (isServer) return;
  if (gtIOS6() || isSupportSticky()) {
    nav.classList.add('vux-sticky');
  } else {
    var navOffsetY = nav.offsetTop;
    window.addEventListener('scroll', function () {
      window.scrollY >= navOffsetY ? nav.classList.add('vux-fixed') : nav.classList.remove('vux-fixed');
    });
  }
};

var isServer = typeof window === 'undefined';

function gtIOS6() {
  if (isServer) return;
  var userAgent = window.navigator.userAgent;
  var ios = userAgent.match(/(iPad|iPhone|iPod)\s+OS\s([\d_.]+)/);
  return ios && ios[2] && parseInt(ios[2].replace(/_/g, '.'), 10) >= 6;
}

function isSupportSticky() {
  if (isServer) return;
  var prefixTestList = ['', '-webkit-', '-ms-', '-moz-', '-o-'];
  var stickyText = '';
  for (var i = 0; i < prefixTestList.length; i++) {
    stickyText += 'position:' + prefixTestList[i] + 'sticky';
  }

  var div = document.createElement('div');
  var body = document.body;
  div.style.cssText = 'display:none' + stickyText;
  body.appendChild(div);
  var isSupport = /sticky/i.test(window.getComputedStyle(div).position);
  body.removeChild(div);
  div = null;
  return isSupport;
}

/***/ }),

/***/ "O4g8":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "OJKw":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-tap-active{tap-highlight-color:transparent}.vux-tap-active:active{background-color:#ececec}.weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.weui_cell_bd__start{display:-webkit-flex;display:flex;-webkit-align-items:flex-start!important;align-items:flex-start!important}.weui_cell_bd>p{color:#000}.with_arrow:after{content:\" \";display:inline-block;-webkit-transform:rotate(45deg);transform:rotate(45deg);height:.21333333rem;width:.21333333rem;border-width:1px 1px 0 0;border-color:#a0a0a0;border-style:solid;position:relative;top:-1px;margin-left:.3em}", ""]);

// exports


/***/ }),

/***/ "ON07":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var document = __webpack_require__("7KvD").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "ON1w":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "OYls":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("crlp")('asyncIterator');


/***/ }),

/***/ "Oe79":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _swiper = __webpack_require__("iodU");

var _swiper2 = _interopRequireDefault(_swiper);

var _router = __webpack_require__("6YX8");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    if (!(this.list && this.list.length === 0)) {
      this.render();
    }
    this.xheight = this.getHeight();
  },

  methods: {
    clickListItem: function clickListItem(item) {
      (0, _router.go)(item[this.urlKey], this.$router);
      this.$emit('on-click-list-item', JSON.parse((0, _stringify2.default)(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(url) {
      return 'url(' + url + ')';
    },
    render: function render() {
      var _this = this;

      this.swiper && this.swiper.destroy();
      this.swiper = new _swiper2.default({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this.current = index % _this.length;
      });
    },
    rerender: function rerender() {
      var _this2 = this;

      if (!this.$el) {
        return;
      }
      this.$nextTick(function () {
        _this2.current = 0;
        _this2.length = _this2.list.length || _this2.$children.length;
        _this2.destroy();
        _this2.render();
      });
    },
    destroy: function destroy() {
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: {
      type: Boolean,
      default: false
    },
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },

    value: {
      type: Number,
      default: 0
    },
    imgKey: {
      type: String,
      default: 'img'
    },
    urlKey: {
      type: String,
      default: 'url'
    },
    titleKey: {
      type: String,
      default: 'title'
    },
    cssClasses: String
  },
  data: function data() {
    return {
      current: this.value,
      xheight: 'auto',
      length: this.list.length
    };
  },

  watch: {
    list: function list(val) {
      this.rerender();
    },
    current: function current(currentIndex) {
      this.$emit('on-index-change', currentIndex);
      this.$emit('input', currentIndex);
    },
    value: function value(val) {
      var _this3 = this;

      if (val !== this.current) {
        this.$nextTick(function () {
          _this3.swiper.go(val);
        });
      }
    }
  },
  computed: {
    classes: function classes() {
      return this.cssClasses;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
};

/***/ }),

/***/ "OesP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _panel = __webpack_require__("PhtK");

var _panel2 = _interopRequireDefault(_panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_panel2.default.install = function (Vue) {
  Vue.component('LxPanel', _panel2.default);
};

exports.default = _panel2.default;

/***/ }),

/***/ "OypD":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      margin: _vm.gap
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "P2UH":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("H6Tm")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("LnV4"),
  /* template */
  __webpack_require__("iuxd"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "P5P/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * cookie helper method
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  getCookie: function getCookie(name) {
    var c = document.cookie;
    if (c.length > 0) {
      var s = c.indexOf(name + '=');
      if (s !== -1) {
        s = s + name.length + 1;
        var e = c.indexOf(';', s);
        if (e === -1) {
          e = c.length;
        }
        return unescape(c.substring(s, e));
      }
    }
    return '';
  }
});

/***/ }),

/***/ "P8xc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _steps = __webpack_require__("cK8J");

var _steps2 = _interopRequireDefault(_steps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_steps2.default.install = function (Vue) {
  Vue.component('LxSteps', _steps2.default);
};

exports.default = _steps2.default;

/***/ }),

/***/ "PHL5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xHeader = __webpack_require__("T5rm");

var _xHeader2 = _interopRequireDefault(_xHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xHeader2.default.install = function (Vue) {
  Vue.component('LxXHeader', _xHeader2.default);
};

exports.default = _xHeader2.default;

/***/ }),

/***/ "PL3R":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-label-desc{font-size:14px;color:#666}", ""]);

// exports


/***/ }),

/***/ "POu9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Aa8e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("193a6cf9", content, true);

/***/ }),

/***/ "PQj0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (time) {
  var date = typeof time === 'number' ? new Date(time) : new Date((time || '').replace(/-/g, '/'));
  var diff = (new Date().getTime() - date.getTime()) / 1000;
  var dayDiff = Math.floor(diff / 86400);

  var isValidDate = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());

  if (!isValidDate) {
    console.error('not a valid date');
  }
  var formatDate = function formatDate(date) {
    var today = new Date(date);
    var year = today.getFullYear();
    var month = ('0' + (today.getMonth() + 1)).slice(-2);
    var day = ('0' + today.getDate()).slice(-2);
    var hour = today.getHours();
    var minute = today.getMinutes();
    var second = today.getSeconds();
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
  };

  if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {
    return formatDate(date);
  }

  return dayDiff === 0 && (diff < 60 && '刚刚' || diff < 120 && '1分钟前' || diff < 3600 && Math.floor(diff / 60) + '分钟前' || diff < 7200 && '1小时前' || diff < 86400 && Math.floor(diff / 3600) + '小时前') || dayDiff === 1 && '昨天' || dayDiff < 7 && dayDiff + '天前' || dayDiff < 31 && Math.ceil(dayDiff / 7) + '周前';
};

/***/ }),

/***/ "PURL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    cssClasses: String
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  },
  computed: {
    classes: function classes() {
      return [{
        weui_btn_disabled: this.disabled,
        weui_btn_mini: this.mini
      }, 'weui_btn_' + this.type, this.plain ? 'weui_btn_plain_' + this.type : '', this.cssClasses];
    }
  }
};

/***/ }),

/***/ "PZnC":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("CX70")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Yhil"),
  /* template */
  __webpack_require__("/Hk7"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "PgOA":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.startVal))])
},staticRenderFns: []}

/***/ }),

/***/ "PhtK":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("j+yQ")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("G1qw"),
  /* template */
  __webpack_require__("NqmX"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "PjmF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("LEZY");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c5032c56", content, true);

/***/ }),

/***/ "Plik":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _previewer = __webpack_require__("ZVAZ");

var _previewer2 = _interopRequireDefault(_previewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_previewer2.default.install = function (Vue) {
  Vue.component('LxPreviewer', _previewer2.default);
};

exports.default = _previewer2.default;

/***/ }),

/***/ "PzxK":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("D2L2");
var toObject = __webpack_require__("sB3e");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "Q3JV":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-fade-transition{opacity:1;transition:opacity .2s linear}.vux-fade-enter,.vux-fade-leave{opacity:0}.vux-dialog-transition{opacity:1;transition-duration:.4s;-webkit-transform:translate(-50%,-50%) scale(1)!important;transform:translate(-50%,-50%) scale(1)!important;transition-property:opacity,-webkit-transform!important;transition-property:transform,opacity!important;transition-property:transform,opacity,-webkit-transform!important}.vux-dialog-enter,.vux-dialog-leave{opacity:0}.vux-dialog-enter{-webkit-transform:translate(-50%,-50%) scale(1.185)!important;transform:translate(-50%,-50%) scale(1.185)!important}.vux-dialog-leave{-webkit-transform:translate(-50%,-50%) scale(1)!important;transform:translate(-50%,-50%) scale(1)!important}.weui-mask{background:rgba(0,0,0,.6)}.weui-mask,.weui-mask_transparent{position:fixed;z-index:1000;top:0;right:0;left:0;bottom:0}.weui_mask{z-index:1000;background:rgba(0,0,0,.6)}.weui_mask,.weui_mask_transparent{position:fixed;width:100%;height:100%;top:0;left:0}.weui_mask_transparent{z-index:5001}.weui_mask_transition{display:none;position:fixed;z-index:1000;width:100%;height:100%;top:0;left:0;background:transparent;transition:background .3s}.weui_fade_toggle{background:rgba(0,0,0,.6)}.weui_dialog{position:fixed;z-index:5000;width:85%;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:#fafafc;text-align:center;border-radius:.21333333rem;overflow:hidden}.weui_dialog_confirm .weui_dialog .weui_dialog_bd{text-align:left}.weui_dialog_mes{line-height:.66666667rem;padding:.66666667rem 0}.weui_dialog_title{font-weight:400;font-size:.45333333rem}.weui_dialog_bd{padding:0 .26666667rem;font-size:.4rem;color:#000;word-wrap:break-word;word-break:break-all}.weui_dialog_ft{position:relative;line-height:1.12rem;font-size:.45333333rem;display:-webkit-flex;display:flex}.weui_dialog_ft a{display:block;-webkit-flex:1;flex:1;color:#3cc51f;text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_dialog_ft a:active{background-color:#eee}.weui_dialog_ft:after{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d5d5d6;color:#d5d5d6;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_dialog_confirm .weui_dialog_ft a{position:relative}.weui_dialog_confirm .weui_dialog_ft a:after{content:\" \";position:absolute;left:0;top:0;width:1px;height:100%;border-left:1px solid #d5d5d6;color:#d5d5d6;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleX(.5);transform:scaleX(.5)}.weui_dialog_confirm .weui_dialog_ft a:first-child:after{display:none}.weui_btn_dialog.default{color:#333}.weui_btn_dialog.primary{color:#5890ff}@media screen and (min-width:1024px){.weui_dialog{width:35%}}", ""]);

// exports


/***/ }),

/***/ "QAu5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xAddress = __webpack_require__("BxAf");

var _xAddress2 = _interopRequireDefault(_xAddress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xAddress2.default.install = function (Vue) {
  Vue.component('LxXAddress', _xAddress2.default);
};

exports.default = _xAddress2.default;

/***/ }),

/***/ "QLWW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lUlh");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2e951d00", content, true);

/***/ }),

/***/ "QRG4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("UuGF");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "QWe/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("crlp")('observable');


/***/ }),

/***/ "Qvw+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BWGA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("75947708", content, true);

/***/ }),

/***/ "R4wc":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("kM2E");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("To3L") });


/***/ }),

/***/ "R9M2":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "RGVm":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-fade-transition{opacity:1;transition:opacity .2s linear}.vux-fade-enter,.vux-fade-leave{opacity:0}.vux-dialog-transition{opacity:1;transition-duration:.4s;-webkit-transform:translate(-50%,-50%) scale(1)!important;transform:translate(-50%,-50%) scale(1)!important;transition-property:opacity,-webkit-transform!important;transition-property:transform,opacity!important;transition-property:transform,opacity,-webkit-transform!important}.vux-dialog-enter,.vux-dialog-leave{opacity:0}.vux-dialog-enter{-webkit-transform:translate(-50%,-50%) scale(1.185)!important;transform:translate(-50%,-50%) scale(1.185)!important}.vux-dialog-leave{-webkit-transform:translate(-50%,-50%) scale(1)!important;transform:translate(-50%,-50%) scale(1)!important}.weui-mask{background:rgba(0,0,0,.6)}.weui-mask,.weui-mask_transparent{position:fixed;z-index:1000;top:0;right:0;left:0;bottom:0}.weui_mask{z-index:1000;background:rgba(0,0,0,.6)}.weui_mask,.weui_mask_transparent{position:fixed;width:100%;height:100%;top:0;left:0}.weui_mask_transparent{z-index:5001}.weui_mask_transition{display:none;position:fixed;z-index:1000;width:100%;height:100%;top:0;left:0;background:transparent;transition:background .3s}.weui_fade_toggle{background:rgba(0,0,0,.6)}.weui_dialog{position:fixed;z-index:5000;width:85%;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:#fafafc;text-align:center;border-radius:.21333333rem;overflow:hidden}.weui_dialog_confirm .weui_dialog .weui_dialog_bd{text-align:left}.weui_dialog_mes{line-height:.66666667rem;padding:.66666667rem 0}.weui_dialog_title{font-weight:400;font-size:.45333333rem}.weui_dialog_bd{padding:0 .26666667rem;font-size:.4rem;color:#000;word-wrap:break-word;word-break:break-all}.weui_dialog_ft{position:relative;line-height:1.12rem;font-size:.45333333rem;display:-webkit-flex;display:flex}.weui_dialog_ft a{display:block;-webkit-flex:1;flex:1;color:#3cc51f;text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_dialog_ft a:active{background-color:#eee}.weui_dialog_ft:after{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d5d5d6;color:#d5d5d6;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_dialog_confirm .weui_dialog_ft a{position:relative}.weui_dialog_confirm .weui_dialog_ft a:after{content:\" \";position:absolute;left:0;top:0;width:1px;height:100%;border-left:1px solid #d5d5d6;color:#d5d5d6;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleX(.5);transform:scaleX(.5)}.weui_dialog_confirm .weui_dialog_ft a:first-child:after{display:none}.weui_btn_dialog.default{color:#333}.weui_btn_dialog.primary{color:#5890ff}@media screen and (min-width:1024px){.weui_dialog{width:35%}}", ""]);

// exports


/***/ }),

/***/ "RJAK":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("JSH0")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("WG2n"),
  /* template */
  __webpack_require__("ErLd"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "RPLV":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7KvD").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "RY/4":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("R9M2");
var TAG = __webpack_require__("dSzd")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "Rb6m":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("xAyU");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4a7f1e58", content, true);

/***/ }),

/***/ "RcWJ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1gOd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3b6368e0", content, true);

/***/ }),

/***/ "Rrel":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("TcQ7");
var gOPN = __webpack_require__("n0T6").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "Rxl4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabItem = __webpack_require__("HuhE");

var _tabItem2 = _interopRequireDefault(_tabItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_tabItem2.default.install = function (Vue) {
  Vue.component('LxTabItem', _tabItem2.default);
};

exports.default = _tabItem2.default;

/***/ }),

/***/ "S82l":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "SEQM":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('cell', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCell),
      expression: "showCell"
    }],
    attrs: {
      "title": _vm.title,
      "primary": "content",
      "is-link": "",
      "inline-desc": _vm.inlineDesc,
      "value-text-align": _vm.valueTextAlign
    },
    nativeOn: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [(!_vm.showName && _vm.value.length && !_vm.showSecondName) ? _c('span', {
    staticClass: "vux-popup-picker-value"
  }, [_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]) : (_vm.showName && _vm.value.length && !_vm.showSecondName) ? _c('span', {
    staticClass: "vux-popup-picker-value"
  }, [_vm._v(_vm._s(_vm._f("value2name")(_vm.value, _vm.data)))]) : _vm._e(), _vm._v(" "), (_vm.showSecondName && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value"
  }, [_vm._v(_vm._s(_vm.getSecondNameValues(_vm.value, _vm.data)))]) : _vm._e(), _vm._v(" "), (!_vm.value.length && _vm.placeholder) ? _c('span', {
    staticClass: "cvux-popup-placeholder",
    domProps: {
      "innerHTML": _vm._s(_vm.placeholder)
    }
  }) : _vm._e()]), _vm._v(" "), _c('popup', {
    staticClass: "vux-popup-picker",
    attrs: {
      "id": ("vux-popup-picker-" + _vm.uuid)
    },
    on: {
      "on-hide": _vm.onPopupHide,
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "vux-popup-picker-container"
  }, [_c('div', {
    staticClass: "vux-popup-picker-header"
  }, [_c('flexbox', [_c('flexbox-item', {
    staticClass: "vue-popup-cancel",
    nativeOn: {
      "click": function($event) {
        _vm.onHide(false)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "vue-popup-confirm",
    nativeOn: {
      "click": function($event) {
        _vm.onHide(true)
      }
    }
  }, [_vm._v("完成")])], 1)], 1), _vm._v(" "), _c('picker', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "fixed-columns": _vm.fixedColumns,
      "container": ("#vux-popup-picker-" + _vm.uuid),
      "id": _vm.id
    },
    on: {
      "on-change": _vm.onPickerChange
    },
    model: {
      value: (_vm.tempValue),
      callback: function($$v) {
        _vm.tempValue = $$v
      },
      expression: "tempValue"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "SNea":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popupPicker = __webpack_require__("vQ0r");

var _popupPicker2 = _interopRequireDefault(_popupPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_popupPicker2.default.install = function (Vue) {
  Vue.component('LxPopupPicker', _popupPicker2.default);
};

exports.default = _popupPicker2.default;

/***/ }),

/***/ "SQEW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _picker = __webpack_require__("aDd6");

var _picker2 = _interopRequireDefault(_picker);

var _cell = __webpack_require__("0juH");

var _cell2 = _interopRequireDefault(_cell);

var _popup = __webpack_require__("ooks");

var _popup2 = _interopRequireDefault(_popup);

var _flexbox = __webpack_require__("MeU4");

var _flexbox2 = _interopRequireDefault(_flexbox);

var _flexboxItem = __webpack_require__("0/UE");

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

var _array2String = __webpack_require__("nPpt");

var _array2String2 = _interopRequireDefault(_array2String);

var _value2name = __webpack_require__("9mmv");

var _value2name2 = _interopRequireDefault(_value2name);

var _mixin_uuid = __webpack_require__("8ZMC");

var _mixin_uuid2 = _interopRequireDefault(_mixin_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getObject = function getObject(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
};

exports.default = {
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [_mixin_uuid2.default],
  components: {
    Picker: _picker2.default,
    Cell: _cell2.default,
    Popup: _popup2.default,
    Flexbox: _flexbox2.default,
    FlexboxItem: _flexboxItem2.default
  },
  filters: {
    array2string: _array2String2.default,
    value2name: _value2name2.default
  },
  props: {
    title: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: String,
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    id: {
      type: String,
      default: ''
    },
    showSecondName: Boolean
  },
  methods: {
    getNameValues: function getNameValues() {
      return (0, _value2name2.default)(this.currentValue, this.data);
    },
    onClick: function onClick() {
      this.showValue = true;
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.currentValue.length > 0) {
          this.tempValue = getObject(this.currentValue);
        }
      }
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if ((0, _stringify2.default)(this.currentValue) !== (0, _stringify2.default)(val)) {
        if (this.value.length) {
          var nowData = (0, _stringify2.default)(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = getObject(val);
          }
          this.currentData = nowData;
        } else {}
      }
      this.$emit('on-shadow-change', getObject(val));
    },
    getSecondNameValues: function getSecondNameValues(value, list) {
      var nameStr = (0, _value2name2.default)(value, list);
      return nameStr.split(' ')[1];
    }
  },
  watch: {
    value: function value(val) {
      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.tempValue)) {
        this.tempValue = getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('on-change', getObject(val));
      this.$emit('input', getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    }
  },
  data: function data() {
    return {
      tempValue: getObject(this.value),
      closeType: false,
      currentData: (0, _stringify2.default)(this.data),
      showValue: false,
      currentValue: this.value
    };
  }
};

/***/ }),

/***/ "SRRW":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "weui_tabbar_item",
    class: {
      'weui_bar_item_on': _vm.$parent.currentIndex === _vm.currentIndex
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.onItemClick(true)
      }
    }
  }, [_c('div', {
    staticClass: "weui_tabbar_icon",
    class: [_vm.iconClass || _vm.$parent.iconClass, {
      'vux-reddot': _vm.showDot
    }]
  }, [_vm._t("icon"), _vm._v(" "), _c('sup', [(_vm.badge) ? _c('badge', {
    attrs: {
      "text": _vm.badge
    }
  }) : _vm._e()], 1)], 2), _vm._v(" "), _c('p', {
    staticClass: "weui_tabbar_label"
  }, [_vm._t("label")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "SXob":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jzLX");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ac22199a", content, true);

/***/ }),

/***/ "SddO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".scroller-component{display:block;position:relative;height:6.34666667rem;overflow:hidden;width:100%}.scroller-content{z-index:1}.scroller-content,.scroller-mask{position:absolute;left:0;top:0;width:100%}.scroller-mask{height:100%;margin:0 auto;z-index:3;background-image:linear-gradient(180deg,hsla(0,0%,100%,.95),hsla(0,0%,100%,.6)),linear-gradient(0deg,hsla(0,0%,100%,.95),hsla(0,0%,100%,.6));background-position:top,bottom;background-size:100% 2.72rem;background-repeat:no-repeat}.scroller-item{text-align:center;font-size:.42666667rem;height:.90666667rem;line-height:.90666667rem;color:#000}.scroller-indicator{width:100%;height:.90666667rem;position:absolute;left:0;top:2.72rem;z-index:3;background-image:linear-gradient(180deg,#d0d0d0,#d0d0d0,transparent,transparent),linear-gradient(0deg,#d0d0d0,#d0d0d0,transparent,transparent);background-position:top,bottom;background-size:100% 1px;background-repeat:no-repeat}.scroller-item{line-clamp:1;-webkit-line-clamp:1;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports


/***/ }),

/***/ "SfB7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("+E39") && !__webpack_require__("S82l")(function () {
  return Object.defineProperty(__webpack_require__("ON07")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "SldL":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "Sy49":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineDesc = __webpack_require__("hc1C");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _router = __webpack_require__("6YX8");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    InlineDesc: _inlineDesc2.default
  },
  props: {
    bdStart: {
      type: Boolean,
      default: false
    },
    title: String,
    value: [String, Number],
    isLink: Boolean,
    inlineDesc: [String, Number],
    primary: {
      type: String,
      default: 'title'
    },
    link: {
      type: [String, Object]
    }
  },
  methods: {
    onClick: function onClick() {
      (0, _router.go)(this.link, this.$router);
    }
  },
  computed: {
    bdClasses: function bdClasses() {
      return {
        'weui_cell_primary': this.primary === 'title'
      };
    },
    classes: function classes() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui_cell_bd__start': this.bdStart
      };
    }
  }

};

/***/ }),

/***/ "T131":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixin_uuid = __webpack_require__("8ZMC");

var _mixin_uuid2 = _interopRequireDefault(_mixin_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_mixin_uuid2.default],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.handleChangeEvent = false;
  },

  computed: {
    dirty: function dirty() {
      return !this.prisine;
    },
    invalid: function invalid() {
      return !this.valid;
    }
  },
  methods: {
    setTouched: function setTouched() {
      this.touched = true;
    }
  },
  watch: {
    value: function value(newVal) {
      if (this.prisine === true) {
        this.prisine = false;
      }
      if (!this.handleChangeEvent) {
        this.$emit('on-change', newVal);
      }
    }
  },
  data: function data() {
    return {
      errors: {},
      prisine: true,
      touched: false,
      valid: true
    };
  }
};

/***/ }),

/***/ "T5rm":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("40kK")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("NwRT"),
  /* template */
  __webpack_require__("t3S2"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "TDUU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tab = __webpack_require__("rrdG");

var _tab2 = _interopRequireDefault(_tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_tab2.default.install = function (Vue) {
  Vue.component('LxTab', _tab2.default);
};

exports.default = _tab2.default;

/***/ }),

/***/ "THZP":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9mvZ"),
  /* template */
  __webpack_require__("OypD"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "TTBw":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-calendar",
    class: {
      'is-weekend-highlight': _vm.highlightWeekend
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideHeader),
      expression: "!hideHeader"
    }],
    staticClass: "calendar-header"
  }, [_c('div', {
    staticClass: "calendar-year"
  }, [_c('a', {
    staticClass: "year-prev vux-prev-icon",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.year - 1, _vm.month)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "calendar-year-txt calendar-title",
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v(_vm._s(_vm.year))]), _vm._v(" "), _c('a', {
    staticClass: "year-next vux-next-icon",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.year + 1, _vm.month)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar-month"
  }, [_c('a', {
    staticClass: "month-prev vux-prev-icon",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.prev
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "calendar-month-txt calendar-title",
    attrs: {
      "href": "javascript:"
    }
  }, [_vm._v(_vm._s(_vm.months[_vm.month]))]), _vm._v(" "), _c('a', {
    staticClass: "month-next vux-next-icon",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.next
    }
  })])]), _vm._v(" "), _c('table', [_c('thead', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideWeekList),
      expression: "!hideWeekList"
    }]
  }, [_c('tr', _vm._l((_vm.weeksList), function(week, index) {
    return _c('th', {
      staticClass: "`week is-week-list-${index}`"
    }, [_vm._v(_vm._s(week))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.days), function(day, k1) {
    return _c('tr', _vm._l((day), function(child, k2) {
      return _c('td', {
        class: _vm.buildClass(k2, child, _vm.formatDate(_vm.year, _vm.month, child) === _vm.currentValue && !child.isLastMonth && !child.isNextMonth),
        attrs: {
          "data-date": _vm.formatDate(_vm.year, _vm.month, child),
          "data-current": _vm.currentValue
        },
        on: {
          "click": function($event) {
            _vm.select(k1, k2, $event)
          }
        }
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((!child.isLastMonth && !child.isNextMonth) || (child.isLastMonth && _vm.showLastMonth) || (child.isNextMonth && _vm.showNextMonth)),
          expression: "(!child.isLastMonth && !child.isNextMonth ) || (child.isLastMonth && showLastMonth) || (child.isNextMonth && showNextMonth)"
        }]
      }, [_vm._v(_vm._s(_vm.replaceText(child.day, _vm.formatDate(_vm.year, _vm.month, child))))]), _vm._v("\n          " + _vm._s(_vm.customSlotFn(k1, k2, child)) + "\n        ")])
    }))
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ "TcQ7":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("MU5D");
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "TfpO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_tabbar{display:-webkit-flex;display:flex;position:absolute;z-index:100;bottom:0;width:100%;background-color:#f7f7fa}.weui_tabbar:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #979797;color:#979797;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_tabbar_item{display:block;-webkit-flex:1;flex:1;padding:7px 0 0;-webkit-tap-highlight-color:transparent}.weui_tabbar_item.weui_bar_item_on .weui_tabbar_label{color:#09bb07}.weui_tabbar_icon{margin:0 auto;width:24px;height:24px}.weui_tabbar_icon img{display:block;width:100%;height:100%}.weui_tabbar_icon+.weui_tabbar_label{margin-top:5px}.weui_tabbar_label{text-align:center;color:#888;font-size:12px}.weui_tab{position:relative;height:100%}.weui_tab_bd{box-sizing:border-box;height:100%;padding-bottom:55px;overflow:auto;-webkit-overflow-scrolling:touch}.weui_tab_bd_item{display:none}.weui_tab_bd_item_active{display:block}", ""]);

// exports


/***/ }),

/***/ "TmAB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _spinner = __webpack_require__("USUq");

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_spinner2.default.install = function (Vue) {
  Vue.component('LxSpinner', _spinner2.default);
};

exports.default = _spinner2.default;

/***/ }),

/***/ "To3L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
var toObject = __webpack_require__("sB3e");
var IObject = __webpack_require__("MU5D");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("S82l")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "TvHH":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("PjmF")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("UKSO"),
  /* template */
  __webpack_require__("EJJR"),
  /* scopeId */
  "data-v-2a7d6ad9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "U1wk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checker = __webpack_require__("nNlF");

var _checker2 = _interopRequireDefault(_checker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_checker2.default.install = function (Vue) {
  Vue.component('LxChecker', _checker2.default);
};

exports.default = _checker2.default;

/***/ }),

/***/ "U2OI":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vux-label-desc"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "U5ju":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
__webpack_require__("zQR9");
__webpack_require__("+tPU");
__webpack_require__("CXw9");
__webpack_require__("EqBC");
__webpack_require__("jKW+");
module.exports = __webpack_require__("FeBl").Promise;


/***/ }),

/***/ "UKSO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: Object,
      default: {
        show: false,
        time: 60,
        start: false,
        codeText: ''
      }
    }
  },
  methods: {
    getCode: function getCode() {
      if (this.interval !== null) {
        return false;
      }
      this.$emit('on-getCode');
    },
    tick: function tick() {
      var _this = this;

      var seconds = this.time;
      this.show = false;
      this.codeText = '\u5269\u4F59: ' + seconds + ' \u79D2';
      this.interval = setInterval(function () {
        if (seconds-- > 0) {
          _this.codeText = '\u5269\u4F59: ' + seconds + ' \u79D2';
        } else {
          _this.stop();
        }
      }, 1000);
    },
    stop: function stop() {
      this.codeText = this.text;
      clearInterval(this.interval);
      this.interval = null;
      this.start = false;
    }
  },
  watch: {
    'value.show': function valueShow(val) {
      this.show = val;
    },
    'value.time': function valueTime(val) {
      this.time = val;
    },
    'value.start': function valueStart(val) {
      this.start = val;
    },
    'value.codeText': function valueCodeText(val) {
      this.codeText = val;
    },
    show: function show(val) {
      var options = {
        show: val,
        time: this.time,
        start: this.start,
        codeText: this.codeText
      };
      this.$emit('input', options);
    },
    codeText: function codeText(val) {
      var options = {
        show: this.show,
        time: this.time,
        start: this.start,
        codeText: val
      };
      this.$emit('input', options);
    },
    time: function time(val) {
      var options = {
        show: this.show,
        time: val,
        start: this.start,
        codeText: this.codeText
      };
      this.$emit('input', options);
    },
    start: function start(newVal, oldVal) {
      if (newVal === true && oldVal === false && this.time > 0) {
        this.tick();
      }
      if (newVal === false && oldVal === true) {
        this.stop();
      }
      var options = {
        show: this.show,
        time: this.time,
        start: newVal,
        codeText: this.codeText
      };
      this.$emit('input', options);
    }
  },
  created: function created() {
    this.show = this.value.show;
    this.time = this.value.time;
    this.start = this.value.start;
    this.text = this.codeText = this.value.codeText;
    if (this.start) {
      this.tick();
    }
  },
  data: function data() {
    return {
      show: false,
      interval: null,
      time: 60,
      start: false,
      codeText: '',
      text: ''
    };
  }
};

/***/ }),

/***/ "UOVC":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("IWQ4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4156be37", content, true);

/***/ }),

/***/ "USUq":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("HiMk")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("+k0Q"),
  /* template */
  __webpack_require__("DVIs"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "UVJq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clocker = __webpack_require__("tta2");

var _clocker2 = _interopRequireDefault(_clocker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_clocker2.default.install = function (Vue) {
  Vue.component('LxClocker', _clocker2.default);
};

exports.default = _clocker2.default;

/***/ }),

/***/ "UuGF":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "V3tA":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("R4wc");
module.exports = __webpack_require__("FeBl").Object.assign;


/***/ }),

/***/ "VI9z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lib = __webpack_require__("sWRC");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    number: Number,
    width: {
      type: Number,
      default: 3
    }
  },
  mounted: function mounted() {
    this._roller = new _lib2.default({
      container: this.$el,
      width: this.width
    });
    this._roller.roll(this.number);
  },

  watch: {
    number: function number(newVal, oldVal) {
      if (newVal.toString().length !== oldVal.toString().length) {
        this._roller.width = newVal.toString().length;
        this._roller.setWidth();
      }
      this._roller.roll(newVal);
    }
  }
};

/***/ }),

/***/ "VQZ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__("6O5g");

var _icon2 = _interopRequireDefault(_icon);

var _flexbox = __webpack_require__("MeU4");

var _flexbox2 = _interopRequireDefault(_flexbox);

var _flexboxItem = __webpack_require__("0/UE");

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizeMap = {
  'large': 40,
  'middle': 30,
  'small': 20
};
exports.default = {
  components: {
    Icon: _icon2.default,
    Flexbox: _flexbox2.default,
    FlexboxItem: _flexboxItem2.default
  },
  props: {
    colors: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      default: 'large'
    },
    value: String,
    enableNull: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      color: ''
    };
  },

  computed: {
    width: function width() {
      return sizeMap[this.size];
    }
  },
  methods: {
    change: function change(color) {
      if (this.color === color && this.enableNull) {
        color = '';
      }
      this.color = color;
    }
  },
  watch: {
    color: function color(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    },
    value: function value(val) {
      this.color = val;
    }
  }
};

/***/ }),

/***/ "VQdg":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_cell",
    class: _vm.classes,
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui_cell_hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_bd",
    class: _vm.bdClasses
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))])], 1), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_ft",
    class: {
      'weui_cell_primary': _vm.primary === 'content'
    }
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n    "), _vm._t("value"), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: {
      'with_arrow': _vm.isLink || !!_vm.link
    }
  }), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "VTCs":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("CHhj")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("fcAM"),
  /* template */
  __webpack_require__("hNm9"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "VU/8":
/***/ (function(module, exports) {

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "VZyn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    hideOnBlur: Boolean,
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    onHide: function onHide() {
      this.show = false;
      this.$emit('on-hide');
    }
  },
  watch: {
    show: function show(val) {
      this.$emit(val ? 'on-show' : 'on-hide');
      this.$emit('input', val);
    },
    value: function value(val) {
      this.show = val;
    }
  }
};

/***/ }),

/***/ "VoyQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionsheet = __webpack_require__("Bz5S");

var _actionsheet2 = _interopRequireDefault(_actionsheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_actionsheet2.default.install = function (Vue) {
  Vue.component('LxActionSheet', _actionsheet2.default);
};

exports.default = _actionsheet2.default;

/***/ }),

/***/ "W0DV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3");
var Timer = __webpack_require__("dJCP");
var Easing = __webpack_require__("jYb5");
var Base = __webpack_require__("5dD5");
//transform
var vendorTransform = Util.prefixStyle("transform");
//transition webkitTransition MozTransition OTransition msTtransition
var vendorTransition = Util.prefixStyle("transition");

var vendorTransitionDuration = Util.prefixStyle("transitionDuration");

var vendorTransformOrigin = Util.prefixStyle("transformOrigin");

var vendorTransitionEnd = Util.vendor ? Util.prefixStyle("transitionEnd") : "transitionend";

var vendorTransformStr = Util.vendor ? ["-", Util.vendor, "-transform"].join("") : "transform";

var translateTpl = 'translateX({translateX}px) translateY({translateY}px) translateZ(0)';
//limit attrs
var animAttrs = {
	'transform': true,
	'opacity': true,
	'scrollTop': true,
	'scrollLeft': true
};

function myParse(v) {
	return Math.round(parseFloat(v) * 1e5) / 1e5;
}

function defaultDecompose() {
	return {
		translateX: 0,
		translateY: 0,
		rotate: 0,
		skewX: 0,
		skewY: 0,
		scaleX: 1,
		scaleY: 1
	};
}

function toMatrixArray(matrix) {
	matrix = matrix.split(/,/);
	matrix = Array.prototype.map.call(matrix, function(v) {
		return myParse(v);
	});
	return matrix;
}

function decomposeMatrix(matrix) {
	matrix = toMatrixArray(matrix);
	var scaleX, scaleY, skew,
		A = matrix[0],
		B = matrix[1],
		C = matrix[2],
		D = matrix[3];

	// Make sure matrix is not singular
	if (A * D - B * C) {
		scaleX = Math.sqrt(A * A + B * B);
		skew = (A * C + B * D) / (A * D - C * B);
		scaleY = (A * D - B * C) / scaleX;
		// step (6)
		if (A * D < B * C) {
			skew = -skew;
			scaleX = -scaleX;
		}
		// matrix is singular and cannot be interpolated
	} else {
		// In this case the elem shouldn't be rendered, hence scale == 0
		scaleX = scaleY = skew = 0;
	}

	// The recomposition order is very important
	// see http://hg.mozilla.org/mozilla-central/file/7cb3e9795d04/layout/style/nsStyleAnimation.cpp#l971
	return {
		translateX: myParse(matrix[4]),
		translateY: myParse(matrix[5]),
		rotate: myParse(Math.atan2(B, A) * 180 / Math.PI),
		skewX: myParse(Math.atan(skew) * 180 / Math.PI),
		skewY: 0,
		scaleX: myParse(scaleX),
		scaleY: myParse(scaleY)
	};
}

function getTransformInfo(transform) {
	transform = transform.split(')');
	var trim = Util.trim,
		i = -1,
		l = transform.length - 1,
		split, prop, val,
		ret = defaultDecompose();

	// Loop through the transform properties, parse and multiply them
	while (++i < l) {
		split = transform[i].split('(');
		prop = trim(split[0]);
		val = split[1];
		switch (prop) {
			case 'translateX':
			case 'translateY':
			case 'scaleX':
			case 'scaleY':
				ret[prop] = myParse(val);
				break;
			case 'translate':
			case 'translate3d':
				val = val.split(',');
				ret.translateX = myParse(val[0]);
				ret.translateY = myParse(val[1] || 0);
				break;
			case 'scale':
				val = val.split(',');
				ret.scaleX = myParse(val[0]);
				ret.scaleY = myParse(val[1] || val[0]);
				break;
			case 'matrix':
				return decomposeMatrix(val);
		}
	}

	return ret;
}

/**
 * animate function
 * @constructor
 * @param {HTMLElement} el element to animate
 * @param {Object} config config for animate
 * @param {Object} config.css
 * @param {Number} config.duration
 * @param {String} config.easing
 * @extends {Base}
 */
function Animate(el, cfg) {
	if (!el || !cfg || !cfg.css) return;
	var self = this;
	self.cfg = cfg;
	self.el = el;
	var duration = cfg.duration || 0,
		easing = cfg.easing || "ease",
		delay = cfg.delay || 0;
	//trigger run
	if (cfg.run) {
		//frame animate
		self.timer = self.timer || new Timer({
			duration: Math.round(duration),
			easing: easing,
		});
		self.timer.on("run", cfg.run);
	}
	self._bindEvt();
	return self;
}

function computeTransform(prevTransform, destTransform) {
	var transform = getTransformInfo(prevTransform);
	var dest = getTransformInfo(destTransform);
	var trans = {};
	for (var i in dest) {
		trans[i] = {
			prevVal: transform[i],
			newVal: dest[i]
		}
	}
	return trans;
}

//for scroll only
function setStyle(el, styleName, prevVal, newVal, percent) {
	prevVal = isNaN(Number(prevVal)) ? 0 : Number(prevVal);
	var curVal = ((newVal - prevVal) * percent + prevVal);
	css(el, styleName, curVal);
}

function css(el, styleName, val) {
	switch (styleName) {
		case "scrollTop":
		case "scrollLeft":
			el[styleName] = val;
			break;
		case "transform":
			el.style[vendorTransform] = val;
		case "opacity":
			el.style[styleName] = val;
			break;

	}
}

Util.extend(Animate, Base, {
	/**
	 * to start the animation
	 * @memberof Animate
	 * @return {Animate}
	 */
	run: function() {
		var self = this;
		var cfg = self.cfg,
			el = self.el,
			duration = cfg.duration || 0,
			easing = cfg.easing || "ease",
			delay = cfg.delay || 0;
		self.__isTransitionEnd = false;
		clearTimeout(self.__itv)
		self.timer && self.timer.run();
		if (duration <= Timer.MIN_DURATION) {
			for (var i in cfg.css) {
				css(el, i, cfg.css[i]);
			}
			self.stop()
			self.__handlers.stop.call(self);
			return;
		}

		if(Util.isBadAndroid()){
			//use frame animate on bad android device
			cfg.useTransition = false;
		}

		if (cfg.useTransition) {
			//transition
			el.style[vendorTransition] = Util.substitute('all {duration}ms {easing} {delay}ms', {
				duration: Math.round(duration),
				easing: Easing.format(easing),
				delay: delay
			});
			for (var i in cfg.css) {
				//set css
				css(el, i, cfg.css[i]);
			}
			self.__itv = setTimeout(function() {
				if (!self.__isTransitionEnd) {
					self.__isTransitionEnd = true;
					self.trigger("transitionend");
				}
			}, Number(duration) + 60);
		} else {
			self.computeStyle = self.computeStyle || window.getComputedStyle(el);
			//transform
			if (cfg.css.transform && self.timer) {
				var transmap = self.transmap = computeTransform(self.computeStyle[vendorTransform], cfg.css.transform);
				self.timer.off("run", self.__handlers.transRun);
				self.timer.on("run", self.__handlers.transRun, self);
				self.timer.off("end",self.__handlers.transRun);
				self.timer.on("end", self.__handlers.transRun, self);
			}
		}
		return self;
	},
	_transitionEndHandler: function(e) {
		var self = this;
		self.stop();
		self.__handlers.stop.call(self);
	},
	__handlers: {
		transRun: function(e) {
			var self = this;
			var transmap = self.transmap;
			var el = self.el;
			var newTrans = {};
			for (var i in transmap) {
				newTrans[i] = (transmap[i].newVal - transmap[i].prevVal) * e.percent + transmap[i].prevVal
			}
			var ret = Util.substitute(translateTpl + ' ' +
				'scale({scaleX},{scaleY})', newTrans);
			el.style[vendorTransform] = ret;
		},
		stop: function(e) {
			var self = this;
			var cfg = self.cfg;
			cfg.end && cfg.end({
				percent: 1
			});
		}
	},
	_bindEvt: function() {
		var self = this;
		var cfg = self.cfg;
		var el = self.el;
		self.el.addEventListener(vendorTransitionEnd, function(e) {
			self.__isTransitionEnd = true;
			if (e.target !== e.currentTarget) return;
			self.trigger("transitionend", e);
		})
		self.on("transitionend", self._transitionEndHandler, self);
		var cssRun = function(e) {
			self.computeStyle = self.computeStyle || window.getComputedStyle(el);
			for (var i in cfg.css) {
				if (!/transform/.test(i)) {
					setStyle(self.el, i, self.computeStyle[i], cfg.css[i], e.percent);
				}
			}
		};
		self.timer && self.timer.on("run", cssRun);
		self.timer && self.timer.on("stop", self.__handlers.stop, self);
	},
	/**
	 * to stop the animation
	 * @memberof Animate
	 * @return {Animate}
	 */
	stop: function() {
		var self = this;
		if (self.cfg.useTransition && self.cfg.duration > Timer.MIN_DURATION) {
			var computeStyle = window.getComputedStyle(this.el);
			for (var i in self.cfg.css) {
				if (animAttrs[i]) {
					var value = /transform/.test(i) ? computeStyle[vendorTransform] : computeStyle[i];
					css(self.el, i, Util.substitute(translateTpl + ' ' + 'scale({scaleX},{scaleY})', getTransformInfo(value)));
				}
			}
			self.el.style[vendorTransition] = "none";
		}
		self.timer && self.timer.stop() && self.timer.reset();
		self.computeStyle = null;
		return self;
	},
	/**
	 * to reset the animation to a new state
	 * @memberof Animate
	 * @param {object} cfg cfg for new animation
	 * @return {Animate}
	 */
	reset: function(cfg) {
		var self = this;
		self.computeStyle = null;
		Util.mix(self.cfg, cfg);
		this.timer && self.timer.reset({
			duration: Math.round(self.cfg.duration),
			easing: self.cfg.easing
		});
		return self;
	}
});


if (typeof module == 'object' && module.exports) {
	module.exports = Animate;
}


/***/ }),

/***/ "WEml":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "WG2n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    title: String,
    titleColor: String,
    ABBBBBBBB: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: String
  }
};

/***/ }),

/***/ "WKYa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("YWpz");

var _format2 = _interopRequireDefault(_format);

var _util = __webpack_require__("WWgO");

var _props = __webpack_require__("lsGX");

var _props2 = _interopRequireDefault(_props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: (0, _props2.default)(),
  data: function data() {
    return {
      year: 0,
      month: 0,
      days: [],
      current: [],
      today: (0, _format2.default)(new Date(), 'YYYY-MM-DD'),
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      currentValue: ''
    };
  },
  created: function created() {
    this.currentValue = this.value;
  },
  mounted: function mounted() {
    this.currentValue = this.convertDate(this.currentValue);
    this.render(this.renderMonth[0], this.renderMonth[1] - 1);
  },

  computed: {
    _replaceTextList: function _replaceTextList() {
      var rs = {};
      for (var i in this.replaceTextList) {
        rs[this.convertDate(i)] = this.replaceTextList[i];
      }
      return rs;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.currentValue = this.convertDate(val);
      if (this.renderOnValueChange) {
        this.render(null, null, val);
      } else {
        this.render(this.year, this.month, this.currentValue);
      }
      this.$emit('on-change', val);
      this.$emit('input', val);
    },
    returnSixRows: function returnSixRows(val) {
      this.render(this.year, this.month, this.currentValue);
    },
    disablePast: function disablePast() {
      this.render(this.year, this.month, this.currentValue);
    },
    disableFuture: function disableFuture() {
      this.render(this.year, this.month, this.currentValue);
    }
  },
  methods: {
    replaceText: function replaceText(day, formatDay) {
      return this._replaceTextList[formatDay] || day;
    },
    convertDate: function convertDate(date) {
      return date === 'TODAY' ? this.today : date;
    },
    buildClass: function buildClass(index, child, isCurrent) {
      var className = {
        current: child.current || isCurrent,
        'is-disabled': child.disabled,
        'is-today': child.isToday
      };
      className['is-week-' + index] = true;
      return className;
    },
    render: function render(year, month) {
      var data = (0, _util.getDays)({
        year: year,
        month: month,
        value: this.currentValue,
        rangeBegin: this.convertDate(this.startDate),
        rangeEnd: this.convertDate(this.endDate),
        returnSixRows: this.returnSixRows,
        disablePast: this.disablePast,
        disableFuture: this.disableFuture
      });
      this.days = data.days;
      this.year = data.year;
      this.month = data.month;
    },

    formatDate: function formatDate(year, month, child) {
      return [year, (0, _util.zero)(child.month + 1), (0, _util.zero)(child.day)].join('-');
    },
    prev: function prev() {
      if (this.month === 0) {
        this.month = 11;
        this.year = this.year - 1;
      } else {
        this.month = this.month - 1;
      }
      this.render(this.year, this.month);
    },
    next: function next() {
      if (this.month === 11) {
        this.month = 0;
        this.year = this.year + 1;
      } else {
        this.month = this.month + 1;
      }
      this.render(this.year, this.month);
    },
    go: function go(year, month) {
      this.render(year, month);
    },
    select: function select(k1, k2) {
      if (this.current.length > 0) {
        this.days[this.current[0]][this.current[1]].isCurrent = false;
      }
      this.days[k1][k2].current = true;
      this.current = [k1, k2];
      this.currentValue = [this.year, (0, _util.zero)(this.month + 1), (0, _util.zero)(this.days[k1][k2].day)].join('-');
    }
  }
};

/***/ }),

/***/ "WOkT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Boolean],
    max: Number
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  watch: {
    currentValue: function currentValue(newValue) {
      this.$emit('on-change', newValue);
      this.$emit('input', newValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
    }
  }
};

/***/ }),

/***/ "WS8O":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JJHH");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9340607c", content, true);

/***/ }),

/***/ "WWgO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zero = zero;
exports.splitValue = splitValue;
exports.getPrevTime = getPrevTime;
exports.getNextTime = getNextTime;
exports.getDays = getDays;

var _format2 = __webpack_require__("YWpz");

var _format3 = _interopRequireDefault(_format2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function zero(n) {
  return n < 10 ? '0' + n : n;
}

function splitValue(value) {
  var split = value.split('-');
  return {
    year: parseInt(split[0], 10),
    month: parseInt(split[1], 10) - 1,
    day: parseInt(split[2], 10)
  };
}

function getPrevTime(year, month) {
  if (month === 0) {
    return {
      month: 11,
      year: year - 1
    };
  } else {
    return {
      year: year,
      month: month - 1
    };
  }
}

function getNextTime(year, month) {
  if (month === 11) {
    return {
      month: 0,
      year: year + 1
    };
  } else {
    return {
      year: year,
      month: month + 1
    };
  }
}

function getTime(str) {
  if (typeof str === 'number') {
    return str;
  }
  return typeof str === 'string' ? new Date(str.replace(/-/g, '/')).getTime() : str.getTime();
}

function isBetween(value, start, end) {
  value = getTime(value);
  var isGte = start ? value >= getTime(start) : true;
  var isLte = end ? value <= getTime(end) : true;
  return isGte && isLte;
}

function getDays(_ref) {
  var year = _ref.year,
      month = _ref.month,
      value = _ref.value,
      _ref$isRange = _ref.isRange,
      isRange = _ref$isRange === undefined ? false : _ref$isRange,
      rangeBegin = _ref.rangeBegin,
      rangeEnd = _ref.rangeEnd,
      _ref$returnSixRows = _ref.returnSixRows,
      returnSixRows = _ref$returnSixRows === undefined ? true : _ref$returnSixRows,
      _ref$disablePast = _ref.disablePast,
      disablePast = _ref$disablePast === undefined ? false : _ref$disablePast,
      _ref$disableFuture = _ref.disableFuture,
      disableFuture = _ref$disableFuture === undefined ? false : _ref$disableFuture;

  var today = (0, _format3.default)(new Date(), 'YYYY-MM-DD');
  var startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  var _splitValue = splitValue(value || today);

  if (typeof year !== 'number' || typeof month !== 'number' || month < 0) {
    year = _splitValue.year;
    month = _splitValue.month;
  }

  if (disablePast) {
    if (!rangeBegin) {
      rangeBegin = startOfToday;
    } else {
      rangeBegin = Math.max(startOfToday.getTime(), getTime(rangeBegin));
    }
  }

  if (disableFuture) {
    if (!rangeEnd) {
      rangeEnd = startOfToday;
    } else {
      rangeEnd = Math.min(startOfToday.getTime(), getTime(rangeEnd));
    }
  }

  var firstDayOfMonth = new Date(year, month, 1).getDay();
  var lastDateOfMonth = new Date(year, month + 1, 0).getDate();
  var lastDayOfLastMonth = new Date(year, month, 0).getDate();

  var i;
  var line = 0;
  var temp = [];
  for (i = 1; i <= lastDateOfMonth; i++) {
    var dow = new Date(year, month, i).getDay();

    if (dow === 0) {
      temp[line] = [];
    } else if (i === 1) {
      temp[line] = [];

      var k = lastDayOfLastMonth - firstDayOfMonth + 1;
      for (var j = 0; j < firstDayOfMonth; j++) {
        var rs = getPrevTime(year, month);
        temp[line].push({
          year: rs.year,
          month: rs.month,
          month_str: rs.month + 1,
          day: k,
          disabled: true,
          isLastMonth: true
        });
        k++;
      }
    }

    var _format = (0, _format3.default)(new Date(year + '/' + (month + 1) + '/' + i), 'YYYY/MM/DD');
    var options = {
      year: year,
      month: month,
      month_str: month + 1,
      day: i,
      isCurrent: value && (0, _format3.default)(new Date(value), 'YYYY/MM/DD') === _format,
      disabled: !isBetween(_format, rangeBegin, rangeEnd),
      isToday: (0, _format3.default)(new Date(), 'YYYY/MM/DD') === _format
    };
    temp[line].push(options);

    if (dow === 6) {
      line++;
    } else if (i === lastDateOfMonth) {
      var _k = 1;
      for (dow; dow < 6; dow++) {
        var _rs = getNextTime(year, month);
        temp[line].push({
          year: _rs.year,
          month: _rs.month,
          month_str: _rs.month + 1,
          day: _k,
          disabled: true,
          isNextMonth: true
        });
        _k++;
      }
    }
  }

  if (returnSixRows && temp.length === 5) {
    var _rs2 = getNextTime(year, month);
    var start = temp[4][6].isNextMonth ? temp[4][6].day : 0;
    temp[6] = [];
    for (var _i = 0; _i < 7; _i++) {
      temp[6].push({
        year: _rs2.year,
        month: _rs2.month,
        month_str: _rs2.month + 1,
        day: ++start,
        disabled: true,
        isNextMonth: true
      });
    }
  }

  if (returnSixRows && temp.length === 4) {
    var _rs3 = getNextTime(year, month);
    var _start = 0;
    temp[5] = [];
    temp[6] = [];
    for (var _i2 = 0; _i2 < 7; _i2++) {
      temp[5].push({
        year: _rs3.year,
        month: _rs3.month,
        month_str: _rs3.month + 1,
        day: ++_start,
        disabled: true,
        isNextMonth: true
      });
      temp[6].push({
        year: _rs3.year,
        month: _rs3.month,
        month_str: _rs3.month + 1,
        day: ++_start,
        disabled: true,
        isNextMonth: true
      });
    }
  }

  return {
    year: year,
    month: month,
    month_str: month + 1,
    days: temp
  };
}

/***/ }),

/***/ "We/D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xNumber = __webpack_require__("w+x0");

var _xNumber2 = _interopRequireDefault(_xNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xNumber2.default.install = function (Vue) {
  Vue.component('LxXNumber', _xNumber2.default);
};

exports.default = _xNumber2.default;

/***/ }),

/***/ "WsQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * sentry配置
 * 1.1.3 需要在构造文件config/index.js中配置
 * production 需要在构建配置中配置config/index.js中配置
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  DNS: 'https://8b712704069047ad8efad5ef06004f9b@sentry.lixinio.com/133',
  config: {
    release: '1.1.3',
    logger: 'javascript',
    ignoreUrls: [/sentry\.lixinio\.com/, /hm\.baidu\.com/, /map\.qq\.com/],
    environment: 'production',
    ignoreErrors: [/^Can't find variable: WeixinJSBridge$/, /^WeixinJSBridge is not defined$/]
  }
});

/***/ }),

/***/ "WuYj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _verifyCode = __webpack_require__("TvHH");

var _verifyCode2 = _interopRequireDefault(_verifyCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_verifyCode2.default.install = function (Vue) {
  Vue.component('LxVerifyCode', _verifyCode2.default);
};

exports.default = _verifyCode2.default;

/***/ }),

/***/ "X/SP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabbar = __webpack_require__("2zlb");

var _tabbar2 = _interopRequireDefault(_tabbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_tabbar2.default.install = function (Vue) {
  Vue.component('LxTabbar', _tabbar2.default);
};

exports.default = _tabbar2.default;

/***/ }),

/***/ "X3fh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-tap-active{tap-highlight-color:transparent}.vux-tap-active:active{background-color:#ececec}", ""]);

// exports


/***/ }),

/***/ "X8DO":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "XDhV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.each = each;
exports.trimZero = trimZero;
exports.addZero = addZero;
exports.isLeapYear = isLeapYear;
exports.getMaxDay = getMaxDay;
exports.parseRow = parseRow;
exports.parseDate = parseDate;
exports.getElement = getElement;
exports.toElement = toElement;
exports.removeElement = removeElement;

var _format = __webpack_require__("YWpz");

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function each(obj, fn) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (fn.call(obj[key], key, obj[key]) === false) {
        break;
      }
    }
  }
}

function trimZero(val) {
  val = String(val);
  val = val ? parseFloat(val.replace(/^0+/g, '')) : '';
  val = val || 0;
  val = val + '';
  return val;
}

function addZero(val) {
  val = String(val);
  return val.length < 2 ? '0' + val : val;
}

function isLeapYear(year) {
  return year % 100 !== 0 && year % 4 === 0 || year % 400 === 0;
}

function getMaxDay(year, month) {
  year = parseFloat(year);
  month = parseFloat(month);
  if (month === 2) {
    return isLeapYear(year) ? 29 : 28;
  }
  return [4, 6, 9, 11].indexOf(month) >= 0 ? 30 : 31;
}

function parseRow(tmpl, value) {
  return tmpl.replace(/\{value\}/g, value);
}

function parseDate(format, value) {
  var formatParts = format.split(/[^A-Za-z]+/);
  var valueParts = value.split(/\D+/);
  if (formatParts.length !== valueParts.length) {
    var date = (0, _format2.default)(new Date(), format);
    valueParts = date.split(/\D+/);
  }

  var result = {};

  for (var i = 0; i < formatParts.length; i++) {
    if (formatParts[i]) {
      result[formatParts[i]] = valueParts[i];
    }
  }
  return result;
}

function getElement(expr) {
  return typeof expr === 'string' ? document.querySelector(expr) : expr;
}

function toElement(html) {
  var tempContainer = document.createElement('div');
  tempContainer.innerHTML = html;
  return tempContainer.firstElementChild;
}

function removeElement(el) {
  el && el.parentNode.removeChild(el);
}

/***/ }),

/***/ "XQPt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Xc4G":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "Xxa5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("jyFz");


/***/ }),

/***/ "Xylu":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_cell",
    class: {
      'weui_select_after': _vm.title, 'weui_cell_select': !_vm.readonly
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "weui_cell_hd",
    class: {
      'weui_cell_primary': _vm.readonly
    }
  }, [_c('label', {
    staticClass: "weui_label",
    style: ({
      width: _vm.$parent.labelWidth + 'rem',
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui_select",
    class: _vm.classes,
    style: ({
      direction: _vm.direction
    }),
    attrs: {
      "name": _vm.name
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.placeholder) ? _c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": _vm.placeholder && !_vm.currentValue
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.processOptions), function(one) {
    return _c('option', {
      domProps: {
        "value": one.key
      }
    }, [_vm._v(_vm._s(one.value))])
  })], 2)]) : _c('div', {
    staticClass: "weui_cell_ft"
  }, [_vm._v("\n    " + _vm._s(_vm._f("findByKey")(_vm.currentValue, _vm.processOptions)) + "\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ "YUPw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _search = __webpack_require__("3u/m");

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_search2.default.install = function (Vue) {
  Vue.component('LxSearch', _search2.default);
};

exports.default = _search2.default;

/***/ }),

/***/ "YWpz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

  var o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468' : '') + week[date.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_ba__ = __webpack_require__("ZCU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_ba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_ba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_cache__ = __webpack_require__("CXu2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__("dOCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rest__ = __webpack_require__("i4WM");




var _this = this;



// 百度统计插件

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_ba___default.a, 'dd5f0f30e36b45b3a08fd1c04f66f83f');
// 同步路由参数

// vuex 仓库

// 缓存处理

// 路由配置



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["default"]);
// 构造路由
var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["default"](__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */]);
// 路由钩子
// S 转场动画
var historyCount = __WEBPACK_IMPORTED_MODULE_8__common_cache__["a" /* default */].getSessionData('count') * 1 || 0;
__WEBPACK_IMPORTED_MODULE_8__common_cache__["a" /* default */].setSessionData('/', 0);
var commit = __WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */].commit || __WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */].dispatch;

var checkIsLogin = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var flag;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            flag = false;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_10__rest__["a" /* default */].login.is_login(null, 'is-login').then(function (res) {
              if (res.code === 0) {
                flag = res.data.is_login;
              } else {
                flag = true; // 如果接口报错，beforeEach放行，交由ajax 401错误处理
              }
            });

          case 3:
            return _context.abrupt('return', flag);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function checkIsLogin() {
    return _ref.apply(this, arguments);
  };
}();

router.beforeEach(function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
    var meta, _next, titleKey, title, toIndex, fromIndex;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            meta = to.meta || {};

            // needLogin  0:不需要登录 1:需要微信登录 2:需要手机登录

            _context2.t0 = meta.needLogin > 0;

            if (!_context2.t0) {
              _context2.next = 6;
              break;
            }

            _context2.next = 5;
            return checkIsLogin();

          case 5:
            _context2.t0 = !_context2.sent;

          case 6:
            if (!_context2.t0) {
              _context2.next = 10;
              break;
            }

            _next = encodeURIComponent('?_=1#' + to.path);

            if (meta.needLogin === 1) {
              // 不需要手机登录
              window.location.href = 'auth/weixin/login?next=' + _next + '&binding_mobile=' + _next;
            } else {
              // 需要手机登录
              window.location.href = 'auth/weixin/login?next=' + _next + '&binding_mobile=' + encodeURIComponent('?_=1#/login?backUrl=' + _next);
            }

            return _context2.abrupt('return');

          case 10:
            titleKey = '';

            if (meta.titles && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(meta.titles).find) {
              titleKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(meta.titles).find(function (val) {
                return to.path.endsWith(val);
              });
            }
            // 路由变化，修改title
            if (meta && meta.title) {
              // let title = (meta.titles && meta.titles[to.path]) || meta.title
              title = meta.titles && meta.titles[titleKey] || meta.title;

              changeTitle(title);
            }
            // 转场动画方向控制
            toIndex = __WEBPACK_IMPORTED_MODULE_8__common_cache__["a" /* default */].getSessionData(to.path);
            fromIndex = __WEBPACK_IMPORTED_MODULE_8__common_cache__["a" /* default */].getSessionData(from.path);

            if (toIndex) {
              if (toIndex > fromIndex) {
                commit('UPDATE_DIRECTION', 'forward');
              } else {
                commit('UPDATE_DIRECTION', 'reverse');
              }
            } else {
              ++historyCount;
              __WEBPACK_IMPORTED_MODULE_8__common_cache__["a" /* default */].setSessionData('count', historyCount);
              to.path !== '/' && __WEBPACK_IMPORTED_MODULE_8__common_cache__["a" /* default */].setSessionData(to.path, historyCount);
              commit('UPDATE_DIRECTION', 'forward');
            }
            // loading 动画
            if (meta && meta.needLoading) {
              __WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */].commit('UPDATE_LOADING', {
                status: true,
                text: '加载中...'
              });
            }
            next();

          case 18:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
Object(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */], router);
// E 转场动画
// 页面渲染完毕后关闭loading
router.afterEach(function (to) {
  // 百度 pv 统计
  var env = 'production';
  if (env === 'production') {
    var source = __WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */].state.source || 'default';
    __WEBPACK_IMPORTED_MODULE_5_vue_ba___default.a.trackPageview('?source=' + source + '/' + to.path);
  }

  // 判断是否需要展示loading界面
  if (to.meta && to.meta.needLoading) {
    window.setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */].commit('UPDATE_LOADING', {
        status: false
      });
    }, 1000);
  }
});
// 修改title
function changeTitle(title) {
  document.title = title;
  var iframe = document.createElement('iframe');
  iframe.src = '/static/favicon.ico';
  iframe.style.display = 'none';
  iframe.style.width = '1px';
  iframe.style.height = '1px';
  iframe.onload = function () {
    setTimeout(function () {
      document.body.removeChild(iframe);
    }, 0);
  };
  document.body.appendChild(iframe);
}
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yhil":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _base = __webpack_require__("T131");

var _base2 = _interopRequireDefault(_base);

var _icon = __webpack_require__("6O5g");

var _icon2 = _interopRequireDefault(_icon);

var _inlineDesc = __webpack_require__("hc1C");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _isEmail = __webpack_require__("2LX0");

var _isEmail2 = _interopRequireDefault(_isEmail);

var _isMobilePhone = __webpack_require__("Ewe+");

var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);

var _debounce = __webpack_require__("c58Y");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {
  'email': {
    fn: _isEmail2.default,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return (0, _isMobilePhone2.default)(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
exports.default = {
  created: function created() {
    var _this = this;

    this.currentValue = this.value || '';
    if (!this.title && !this.placeholder && !this.currentValue) {
      console.warn('no title and no placeholder?');
    }
    if (this.required && !this.currentValue) {
      this.valid = false;
      this.validate();
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = (0, _debounce2.default)(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  mounted: function mounted() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [_base2.default],
  components: {
    Icon: _icon2.default,
    InlineDesc: _inlineDesc2.default
  },
  props: {
    required: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    isLink: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,

    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.$parent.labelWidth || this.labelWidth + 'em',
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    hasErrors: function hasErrors() {
      return (0, _keys2.default)(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    }
  },
  methods: {
    clear: function clear() {
      this.currentValue = '';
      this.$refs.input.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    focusHandler: function focusHandler() {
      this.isFocus = true;
      this.$emit('on-focus', this.currentValue);
    },
    blur: function blur() {
      this.isFocus = false;
      this.setTouched();
      this.validate();
      this.$emit('on-blur', this.currentValue);
    },
    getError: function getError() {
      var key = (0, _keys2.default)(this.errors)[0];
      this.firstError = this.errors[key];
      this.$emit('on-vali', this.errors, this.valid, this.uuid);
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        this.getError();
        return;
      }
      this.errors = {};
      if (!this.currentValue && !this.required) {
        this.valid = true;
        this.getError();
        return;
      }
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = this.title + '必填';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          this.valid = validator['fn'](this.currentValue);
          if (!this.valid) {
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
            this.getError();
          }
        }
      }
      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue, this.name);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();

          return;
        } else {
          delete this.errors.format;
          this.getError();
        }
      }
      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();

          return;
        } else {
          delete this.errors.min;
          this.getError();
        }
      }
      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
          this.getError();
        }
      }
      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;

      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    }
  },
  data: function data() {
    var data = {
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      isFocus: false
    };
    return data;
  },

  watch: {
    valid: function valid(val) {},
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal) {
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
        this.getError();
      }
      this.$emit('input', newVal);
      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
};

/***/ }),

/***/ "Yobk":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("77Pl");
var dPs = __webpack_require__("qio6");
var enumBugKeys = __webpack_require__("xnc9");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ON07")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("RPLV").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

/**
 * vuex 状态管理
 */


// import rest from '../rest'
// import submit from './modules/usedcar/submit'

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["default"]);

var state = {
  loading: {
    status: false,
    text: '',
    time: 0
  },
  direction: 'forward',
  toast: {
    show: false,
    text: '',
    time: 1000
  },
  customized: null, // 网站定制
  isDOS: false,
  source: 'default', // 默认来源
  authPrefix: '/auth/weixin'
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["default"].Store({
  strict: "production" !== 'production',
  state: state,
  mutations: {
    UPDATE_LOADING: function UPDATE_LOADING(state, loading) {
      state.loading = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.loading, loading);
    },
    UPDATE_DIRECTION: function UPDATE_DIRECTION(state, direction) {
      state.direction = direction;
    },
    UPDATE_TOAST: function UPDATE_TOAST(state, toast) {
      state.toast = toast;
    },
    UPDATE_SOURCE: function UPDATE_SOURCE(state, source) {
      if (source) {
        state.source = source;
      }
    }
  },
  actions: {
    UPDATE_TOAST: function UPDATE_TOAST(_ref, toast) {
      var commit = _ref.commit;

      var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, toast);
      commit('UPDATE_TOAST', t);
      var st = null;
      clearTimeout(st);
      st = setTimeout(function () {
        toast.show = false;
        t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, toast);
        commit('UPDATE_TOAST', t);
      }, t.time);
    },
    UPDATE_LOADING: function UPDATE_LOADING(_ref2, loading) {
      var commit = _ref2.commit;

      commit('UPDATE_LOADING', loading);
      if (loading && loading.time) {
        var st = null;
        clearTimeout(st);
        st = setTimeout(function () {
          loading.show = false;
          commit('UPDATE_LOADING', loading);
        }, loading.time);
      }
    },
    UPDATE_SOURCE: function UPDATE_SOURCE(_ref3, source) {
      var commit = _ref3.commit;

      commit('UPDATE_SOURCE', source);
    }
  },
  modules: {}
}));

/***/ }),

/***/ "Z0YM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.weui_label{color:#000;display:block;width:2.4rem;word-wrap:break-word;word-break:break-all;padding-right:.13333333rem}.weui_input{width:100%;border:0;outline:0;-webkit-appearance:none;background-color:transparent;font-size:inherit;color:inherit;line-height:2.26666667}.weui_input::-webkit-inner-spin-button,.weui_input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.weui_textarea{display:block;border:0;resize:none;width:100%;color:inherit;font-size:.34666667rem;line-height:inherit;outline:0}.weui_textarea_counter{color:#999;text-align:right}.weui_cell_warn .weui_textarea_counter{color:#e64340}.weui_toptips{display:none;position:fixed;-webkit-transform:translateZ(0);width:100%;top:0;line-height:2.3;font-size:14px;text-align:center;color:#fff;z-index:50000}.weui_toptips.weui_warn{background-color:#e64340}.weui_cells_form .weui_cell_warn{color:#e64340}.weui_cells_form .weui_cell_warn .weui_icon_warn{display:inline-block}.weui_cells_form .weui_cell_ft{font-size:0}.weui_cells_form .weui_icon_warn{display:none}.weui_cells_form input,.weui_cells_form label[for],.weui_cells_form textarea{-webkit-tap-highlight-color:rgba(0,0,0,0)}", ""]);

// exports


/***/ }),

/***/ "Z41a":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("FKI+")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("aMpv"),
  /* template */
  __webpack_require__("Xylu"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ZCU/":
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var e=n();for(var r in e)("object"==typeof exports?exports:t)[r]=e[r]}}(this,function(){return function(t){function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var e={};return n.m=t,n.c=e,n.i=function(t){return t},n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:r})},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=17)}([function(t,n,e){var r=e(30)("wks"),o=e(21),i=e(1).Symbol,u="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=r},function(t,n){var e=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=e)},function(t,n){var e=t.exports={version:"2.4.0"};"number"==typeof __e&&(__e=e)},function(t,n,e){var r=e(4),o=e(40),i=e(34),u=Object.defineProperty;n.f=e(5)?Object.defineProperty:function(t,n,e){if(r(t),n=i(n,!0),r(e),o)try{return u(t,n,e)}catch(t){}if("get"in e||"set"in e)throw TypeError("Accessors not supported!");return"value"in e&&(t[n]=e.value),t}},function(t,n,e){var r=e(13);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,n,e){t.exports=!e(12)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var e={}.hasOwnProperty;t.exports=function(t,n){return e.call(t,n)}},function(t,n,e){var r=e(3),o=e(16);t.exports=e(5)?function(t,n,e){return r.f(t,n,o(1,e))}:function(t,n,e){return t[n]=e,t}},function(t,n,e){var r=e(75),o=e(25);t.exports=function(t){return r(o(t))}},function(t,n){var e={}.toString;t.exports=function(t){return e.call(t).slice(8,-1)}},function(t,n,e){var r=e(24);t.exports=function(t,n,e){if(r(t),void 0===n)return t;switch(e){case 1:return function(e){return t.call(n,e)};case 2:return function(e,r){return t.call(n,e,r)};case 3:return function(e,r,o){return t.call(n,e,r,o)}}return function(){return t.apply(n,arguments)}}},function(t,n,e){var r=e(1),o=e(2),i=e(10),u=e(7),c=function(t,n,e){var f,a,s,l=t&c.F,p=t&c.G,v=t&c.S,h=t&c.P,d=t&c.B,y=t&c.W,m=p?o:o[n]||(o[n]={}),b=m.prototype,g=p?r:v?r[n]:(r[n]||{}).prototype;p&&(e=n);for(f in e)(a=!l&&g&&void 0!==g[f])&&f in m||(s=a?g[f]:e[f],m[f]=p&&"function"!=typeof g[f]?e[f]:d&&a?i(s,r):y&&g[f]==s?function(t){var n=function(n,e,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(n);case 2:return new t(n,e)}return new t(n,e,r)}return t.apply(this,arguments)};return n.prototype=t.prototype,n}(s):h&&"function"==typeof s?i(Function.call,s):s,h&&((m.virtual||(m.virtual={}))[f]=s,t&c.R&&b&&!b[f]&&u(b,f,s)))};c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,t.exports=c},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){t.exports={}},function(t,n,e){var r=e(48),o=e(27);t.exports=Object.keys||function(t){return r(t,o)}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var r=e(22),o=e.n(r),i=e(55),u=e.n(i),c=e(54),f={};f.promise=new u.a(function(t,n){f.resolve=t,f.reject=n});var a=["trackPageview","trackEvent","setCustomVar"],s={_cache:[],_resolve:function(){f.resolve()},_reject:function(){f.reject()},_push:function(){for(var t=arguments.length,n=Array(t),e=0;e<t;e++)n[e]=arguments[e];if(this.debug(n),window._hmt){var r;(r=window._hmt).push.apply(r,o()(n))}else{var i;(i=this._cache).push.apply(i,o()(n))}},_createMethod:function(t){var n=this;return function(){for(var e=arguments.length,r=Array(e),o=0;o<e;o++)r[o]=arguments[o];n._push(["_"+t].concat(r))}},debug:function(){},ready:function(){return f.promise},install:c.a,patch:function(t){this[t]=this._createMethod(t)}};a.forEach(function(t){return s[t]=s._createMethod(t)}),window.Vue&&(window.ba=s),n.default=s},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var o=e(62),i=r(o),u=e(61),c=r(u),f="function"==typeof c.default&&"symbol"==typeof i.default?function(t){return typeof t}:function(t){return t&&"function"==typeof c.default&&t.constructor===c.default&&t!==c.default.prototype?"symbol":typeof t};n.default="function"==typeof c.default&&"symbol"===f(i.default)?function(t){return void 0===t?"undefined":f(t)}:function(t){return t&&"function"==typeof c.default&&t.constructor===c.default&&t!==c.default.prototype?"symbol":void 0===t?"undefined":f(t)}},function(t,n){t.exports=!0},function(t,n,e){var r=e(3).f,o=e(6),i=e(0)("toStringTag");t.exports=function(t,n,e){t&&!o(t=e?t:t.prototype,i)&&r(t,i,{configurable:!0,value:n})}},function(t,n){var e=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++e+r).toString(36))}},function(t,n,e){"use strict";n.__esModule=!0;var r=e(59),o=function(t){return t&&t.__esModule?t:{default:t}}(r);n.default=function(t){if(Array.isArray(t)){for(var n=0,e=Array(t.length);n<t.length;n++)e[n]=t[n];return e}return(0,o.default)(t)}},function(t,n,e){"use strict";function r(t){return void 0!==t.oldValue&&("object"===u()(t.value)?f()(t.value,t.oldValue):t.value===t.oldValue)}function o(t){return""===t.value||void 0===t.value||null===t.value}n.a=r,n.b=o;var i=e(18),u=e.n(i),c=e(99),f=e.n(c)},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,e){var r=e(13),o=e(1).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,n){n.f={}.propertyIsEnumerable},function(t,n,e){var r=e(30)("keys"),o=e(21);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,n,e){var r=e(1),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n){var e=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:e)(t)}},function(t,n,e){var r=e(31),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,n,e){var r=e(25);t.exports=function(t){return Object(r(t))}},function(t,n,e){var r=e(13);t.exports=function(t,n){if(!r(t))return t;var e,o;if(n&&"function"==typeof(e=t.toString)&&!r(o=e.call(t)))return o;if("function"==typeof(e=t.valueOf)&&!r(o=e.call(t)))return o;if(!n&&"function"==typeof(e=t.toString)&&!r(o=e.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n,e){var r=e(1),o=e(2),i=e(19),u=e(36),c=e(3).f;t.exports=function(t){var n=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in n||c(n,t,{value:u.f(t)})}},function(t,n,e){n.f=e(0)},function(t,n,e){"use strict";var r=e(90)(!0);e(43)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,n=this._t,e=this._i;return e>=n.length?{value:void 0,done:!0}:(t=r(n,e),this._i+=t.length,{value:t,done:!1})})},function(t,n,e){var r=e(9),o=e(0)("toStringTag"),i="Arguments"==r(function(){return arguments}()),u=function(t,n){try{return t[n]}catch(t){}};t.exports=function(t){var n,e,c;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(e=u(n=Object(t),o))?e:i?r(n):"Object"==(c=r(n))&&"function"==typeof n.callee?"Arguments":c}},function(t,n,e){t.exports=e(1).document&&document.documentElement},function(t,n,e){t.exports=!e(5)&&!e(12)(function(){return 7!=Object.defineProperty(e(26)("div"),"a",{get:function(){return 7}}).a})},function(t,n,e){var r=e(14),o=e(0)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,n,e){var r=e(4);t.exports=function(t,n,e,o){try{return o?n(r(e)[0],e[1]):n(e)}catch(n){var i=t.return;throw void 0!==i&&r(i.call(t)),n}}},function(t,n,e){"use strict";var r=e(19),o=e(11),i=e(49),u=e(7),c=e(6),f=e(14),a=e(77),s=e(20),l=e(85),p=e(0)("iterator"),v=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,n,e,d,y,m,b){a(e,n,d);var g,_,x,w=function(t){if(!v&&t in P)return P[t];switch(t){case"keys":case"values":return function(){return new e(this,t)}}return function(){return new e(this,t)}},j=n+" Iterator",O="values"==y,S=!1,P=t.prototype,E=P[p]||P["@@iterator"]||y&&P[y],M=E||w(y),A=y?O?w("entries"):M:void 0,k="Array"==n?P.entries||E:E;if(k&&(x=l(k.call(new t)))!==Object.prototype&&(s(x,j,!0),r||c(x,p)||u(x,p,h)),O&&E&&"values"!==E.name&&(S=!0,M=function(){return E.call(this)}),r&&!b||!v&&!S&&P[p]||u(P,p,M),f[n]=M,f[j]=h,y)if(g={values:O?M:w("values"),keys:m?M:w("keys"),entries:A},b)for(_ in g)_ in P||i(P,_,g[_]);else o(o.P+o.F*(v||S),n,g);return g}},function(t,n,e){var r=e(0)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,n){if(!n&&!o)return!1;var e=!1;try{var i=[7],u=i[r]();u.next=function(){return{done:e=!0}},i[r]=function(){return u},t(i)}catch(t){}return e}},function(t,n,e){var r=e(4),o=e(82),i=e(27),u=e(29)("IE_PROTO"),c=function(){},f=function(){var t,n=e(26)("iframe"),r=i.length;for(n.style.display="none",e(39).appendChild(n),n.src="javascript:",t=n.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),f=t.F;r--;)delete f.prototype[i[r]];return f()};t.exports=Object.create||function(t,n){var e;return null!==t?(c.prototype=r(t),e=new c,c.prototype=null,e[u]=t):e=f(),void 0===n?e:o(e,n)}},function(t,n,e){var r=e(48),o=e(27).concat("length","prototype");n.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,n){n.f=Object.getOwnPropertySymbols},function(t,n,e){var r=e(6),o=e(8),i=e(70)(!1),u=e(29)("IE_PROTO");t.exports=function(t,n){var e,c=o(t),f=0,a=[];for(e in c)e!=u&&r(c,e)&&a.push(e);for(;n.length>f;)r(c,e=n[f++])&&(~i(a,e)||a.push(e));return a}},function(t,n,e){t.exports=e(7)},function(t,n,e){var r,o,i,u=e(10),c=e(74),f=e(39),a=e(26),s=e(1),l=s.process,p=s.setImmediate,v=s.clearImmediate,h=s.MessageChannel,d=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var n=y[t];delete y[t],n()}},b=function(t){m.call(t.data)};p&&v||(p=function(t){for(var n=[],e=1;arguments.length>e;)n.push(arguments[e++]);return y[++d]=function(){c("function"==typeof t?t:Function(t),n)},r(d),d},v=function(t){delete y[t]},"process"==e(9)(l)?r=function(t){l.nextTick(u(m,t,1))}:h?(o=new h,i=o.port2,o.port1.onmessage=b,r=u(i.postMessage,i,1)):s.addEventListener&&"function"==typeof postMessage&&!s.importScripts?(r=function(t){s.postMessage(t+"","*")},s.addEventListener("message",b,!1)):r="onreadystatechange"in a("script")?function(t){f.appendChild(a("script")).onreadystatechange=function(){f.removeChild(this),m.call(t)}}:function(t){setTimeout(u(m,t,1),0)}),t.exports={set:p,clear:v}},function(t,n,e){var r=e(38),o=e(0)("iterator"),i=e(14);t.exports=e(2).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,n){},function(t,n,e){e(93);for(var r=e(1),o=e(7),i=e(14),u=e(0)("toStringTag"),c=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],f=0;f<5;f++){var a=c[f],s=r[a],l=s&&s.prototype;l&&!l[u]&&o(l,u,a),i[a]=i.Array}},function(t,n,e){"use strict";function r(t,n){var e=this;if(!this.install.installed){n.debug?this.debug=console.log:this.debug=function(){};var r=null;if("object"===(void 0===n?"undefined":i()(n))?(r=n.siteId,!1!==n.autoPageview&&(n.autoPageview=!0)):r=n,!r)return console.error(" siteId is missing");this.install.installed=!0;var o=document.createElement("script"),a="https://hm.baidu.com/hm.js?"+r,s=n.src||a;o.innerHTML="var _hmt = _hmt || []; (function(){var hm = document.createElement('script');hm.src=\""+s+'";var s = document.getElementsByTagName("script")[0];s.parentNode.insertBefore(hm, s);})()',o.onload=function(){if(!window._hmt)return console.error("loading ba statistics script failed, please check src and siteId"),e._reject();e._resolve(),e._cache.forEach(function(t){window._hmt.push(t)}),e._cache=[]},document.body.appendChild(o),Object.defineProperty(t.prototype,"$ba",{get:function(){return e}}),t.directive("auto-pageview",u.a),t.directive("track-event",c.a),t.directive("track-pageview",f.a)}}n.a=r;var o=e(18),i=e.n(o),u=e(56),c=e(57),f=e(58)},function(t,n,e){t.exports={default:e(65),__esModule:!0}},function(t,n,e){"use strict";var r=e(17),o=e(23);n.a=function(t,n){if(!e.i(o.a)(n)){var i=[];!1===n.value||"false"===n.value?i.push(!1):i.push(!0),r.default.setAutoPageview.apply(r.default,i)}}},function(t,n,e){"use strict";var r=e(22),o=e.n(r),i=e(18),u=e.n(i),c=e(60),f=e.n(c),a=e(17),s=e(23);n.a=function(t,n){if(!e.i(s.a)(n)&&!e.i(s.b)(n)){var r=[],i=f()(n.modifiers).map(function(t){if(n.modifiers[t])return t});if("object"===u()(n.value)){var c=n.value;c.category&&r.push(c.category),c.action&&r.push(c.action),c.opt_label&&r.push(c.opt_label),c.opt_value&&r.push(c.opt_value)}else"string"==typeof n.value&&(r=n.value.split(","),r.forEach(function(t,n){return r[n]=t.trim()}));i.length||i.push("click"),i.forEach(function(n){t.addEventListener(n,function(){return a.default.trackEvent.apply(a.default,o()(r))},!1)})}}},function(t,n,e){"use strict";var r=e(22),o=e.n(r),i=e(18),u=e.n(i),c=e(17),f=e(23),a=[],s={bind:function(t,n){var r=a.findIndex(function(n){return n===t}),i=-1!==r;if("none"===t.style.display)return void(i||a.push(t));if(i&&a.splice(r,1),i||!e.i(f.a)(n)&&!e.i(f.b)(n)){var s=[];if("object"===u()(n.value)){var l=n.value;l.pageURL&&s.push(l.pageURL)}else"string"==typeof n.value&&n.value&&(s=n.value.split(","),s.forEach(function(t,n){return t[n]=t.trim()}));c.default.trackPageview.apply(c.default,o()(s))}},unbind:function(t,n){var e=a.findIndex(function(n){return n===t});-1!==e&&a.splice(e,1)}};s.update=s.bind,n.a=s},function(t,n,e){t.exports={default:e(63),__esModule:!0}},function(t,n,e){t.exports={default:e(64),__esModule:!0}},function(t,n,e){t.exports={default:e(66),__esModule:!0}},function(t,n,e){t.exports={default:e(67),__esModule:!0}},function(t,n,e){e(37),e(92),t.exports=e(2).Array.from},function(t,n,e){e(94),t.exports=e(2).Object.keys},function(t,n,e){e(52),e(37),e(53),e(95),t.exports=e(2).Promise},function(t,n,e){e(96),e(52),e(97),e(98),t.exports=e(2).Symbol},function(t,n,e){e(37),e(53),t.exports=e(36).f("iterator")},function(t,n){t.exports=function(){}},function(t,n){t.exports=function(t,n,e,r){if(!(t instanceof n)||void 0!==r&&r in t)throw TypeError(e+": incorrect invocation!");return t}},function(t,n,e){var r=e(8),o=e(32),i=e(91);t.exports=function(t){return function(n,e,u){var c,f=r(n),a=o(f.length),s=i(u,a);if(t&&e!=e){for(;a>s;)if((c=f[s++])!=c)return!0}else for(;a>s;s++)if((t||s in f)&&f[s]===e)return t||s||0;return!t&&-1}}},function(t,n,e){"use strict";var r=e(3),o=e(16);t.exports=function(t,n,e){n in t?r.f(t,n,o(0,e)):t[n]=e}},function(t,n,e){var r=e(15),o=e(47),i=e(28);t.exports=function(t){var n=r(t),e=o.f;if(e)for(var u,c=e(t),f=i.f,a=0;c.length>a;)f.call(t,u=c[a++])&&n.push(u);return n}},function(t,n,e){var r=e(10),o=e(42),i=e(41),u=e(4),c=e(32),f=e(51),a={},s={},n=t.exports=function(t,n,e,l,p){var v,h,d,y,m=p?function(){return t}:f(t),b=r(e,l,n?2:1),g=0;if("function"!=typeof m)throw TypeError(t+" is not iterable!");if(i(m)){for(v=c(t.length);v>g;g++)if((y=n?b(u(h=t[g])[0],h[1]):b(t[g]))===a||y===s)return y}else for(d=m.call(t);!(h=d.next()).done;)if((y=o(d,b,h.value,n))===a||y===s)return y};n.BREAK=a,n.RETURN=s},function(t,n){t.exports=function(t,n,e){var r=void 0===e;switch(n.length){case 0:return r?t():t.call(e);case 1:return r?t(n[0]):t.call(e,n[0]);case 2:return r?t(n[0],n[1]):t.call(e,n[0],n[1]);case 3:return r?t(n[0],n[1],n[2]):t.call(e,n[0],n[1],n[2]);case 4:return r?t(n[0],n[1],n[2],n[3]):t.call(e,n[0],n[1],n[2],n[3])}return t.apply(e,n)}},function(t,n,e){var r=e(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,n,e){var r=e(9);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,n,e){"use strict";var r=e(45),o=e(16),i=e(20),u={};e(7)(u,e(0)("iterator"),function(){return this}),t.exports=function(t,n,e){t.prototype=r(u,{next:o(1,e)}),i(t,n+" Iterator")}},function(t,n){t.exports=function(t,n){return{value:n,done:!!t}}},function(t,n,e){var r=e(15),o=e(8);t.exports=function(t,n){for(var e,i=o(t),u=r(i),c=u.length,f=0;c>f;)if(i[e=u[f++]]===n)return e}},function(t,n,e){var r=e(21)("meta"),o=e(13),i=e(6),u=e(3).f,c=0,f=Object.isExtensible||function(){return!0},a=!e(12)(function(){return f(Object.preventExtensions({}))}),s=function(t){u(t,r,{value:{i:"O"+ ++c,w:{}}})},l=function(t,n){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!f(t))return"F";if(!n)return"E";s(t)}return t[r].i},p=function(t,n){if(!i(t,r)){if(!f(t))return!0;if(!n)return!1;s(t)}return t[r].w},v=function(t){return a&&h.NEED&&f(t)&&!i(t,r)&&s(t),t},h=t.exports={KEY:r,NEED:!1,fastKey:l,getWeak:p,onFreeze:v}},function(t,n,e){var r=e(1),o=e(50).set,i=r.MutationObserver||r.WebKitMutationObserver,u=r.process,c=r.Promise,f="process"==e(9)(u);t.exports=function(){var t,n,e,a=function(){var r,o;for(f&&(r=u.domain)&&r.exit();t;){o=t.fn,t=t.next;try{o()}catch(r){throw t?e():n=void 0,r}}n=void 0,r&&r.enter()};if(f)e=function(){u.nextTick(a)};else if(i){var s=!0,l=document.createTextNode("");new i(a).observe(l,{characterData:!0}),e=function(){l.data=s=!s}}else if(c&&c.resolve){var p=c.resolve();e=function(){p.then(a)}}else e=function(){o.call(r,a)};return function(r){var o={fn:r,next:void 0};n&&(n.next=o),t||(t=o,e()),n=o}}},function(t,n,e){var r=e(3),o=e(4),i=e(15);t.exports=e(5)?Object.defineProperties:function(t,n){o(t);for(var e,u=i(n),c=u.length,f=0;c>f;)r.f(t,e=u[f++],n[e]);return t}},function(t,n,e){var r=e(28),o=e(16),i=e(8),u=e(34),c=e(6),f=e(40),a=Object.getOwnPropertyDescriptor;n.f=e(5)?a:function(t,n){if(t=i(t),n=u(n,!0),f)try{return a(t,n)}catch(t){}if(c(t,n))return o(!r.f.call(t,n),t[n])}},function(t,n,e){var r=e(8),o=e(46).f,i={}.toString,u="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],c=function(t){try{return o(t)}catch(t){return u.slice()}};t.exports.f=function(t){return u&&"[object Window]"==i.call(t)?c(t):o(r(t))}},function(t,n,e){var r=e(6),o=e(33),i=e(29)("IE_PROTO"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,n,e){var r=e(11),o=e(2),i=e(12);t.exports=function(t,n){var e=(o.Object||{})[t]||Object[t],u={};u[t]=n(e),r(r.S+r.F*i(function(){e(1)}),"Object",u)}},function(t,n,e){var r=e(7);t.exports=function(t,n,e){for(var o in n)e&&t[o]?t[o]=n[o]:r(t,o,n[o]);return t}},function(t,n,e){"use strict";var r=e(1),o=e(2),i=e(3),u=e(5),c=e(0)("species");t.exports=function(t){var n="function"==typeof o[t]?o[t]:r[t];u&&n&&!n[c]&&i.f(n,c,{configurable:!0,get:function(){return this}})}},function(t,n,e){var r=e(4),o=e(24),i=e(0)("species");t.exports=function(t,n){var e,u=r(t).constructor;return void 0===u||void 0==(e=r(u)[i])?n:o(e)}},function(t,n,e){var r=e(31),o=e(25);t.exports=function(t){return function(n,e){var i,u,c=String(o(n)),f=r(e),a=c.length;return f<0||f>=a?t?"":void 0:(i=c.charCodeAt(f),i<55296||i>56319||f+1===a||(u=c.charCodeAt(f+1))<56320||u>57343?t?c.charAt(f):i:t?c.slice(f,f+2):u-56320+(i-55296<<10)+65536)}}},function(t,n,e){var r=e(31),o=Math.max,i=Math.min;t.exports=function(t,n){return t=r(t),t<0?o(t+n,0):i(t,n)}},function(t,n,e){"use strict";var r=e(10),o=e(11),i=e(33),u=e(42),c=e(41),f=e(32),a=e(71),s=e(51);o(o.S+o.F*!e(44)(function(t){Array.from(t)}),"Array",{from:function(t){var n,e,o,l,p=i(t),v="function"==typeof this?this:Array,h=arguments.length,d=h>1?arguments[1]:void 0,y=void 0!==d,m=0,b=s(p);if(y&&(d=r(d,h>2?arguments[2]:void 0,2)),void 0==b||v==Array&&c(b))for(n=f(p.length),e=new v(n);n>m;m++)a(e,m,y?d(p[m],m):p[m]);else for(l=b.call(p),e=new v;!(o=l.next()).done;m++)a(e,m,y?u(l,d,[o.value,m],!0):o.value);return e.length=m,e}})},function(t,n,e){"use strict";var r=e(68),o=e(78),i=e(14),u=e(8);t.exports=e(43)(Array,"Array",function(t,n){this._t=u(t),this._i=0,this._k=n},function(){var t=this._t,n=this._k,e=this._i++;return!t||e>=t.length?(this._t=void 0,o(1)):"keys"==n?o(0,e):"values"==n?o(0,t[e]):o(0,[e,t[e]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,n,e){var r=e(33),o=e(15);e(86)("keys",function(){return function(t){return o(r(t))}})},function(t,n,e){"use strict";var r,o,i,u=e(19),c=e(1),f=e(10),a=e(38),s=e(11),l=e(13),p=e(24),v=e(69),h=e(73),d=e(89),y=e(50).set,m=e(81)(),b=c.TypeError,g=c.process,_=c.Promise,g=c.process,x="process"==a(g),w=function(){},j=!!function(){try{var t=_.resolve(1),n=(t.constructor={})[e(0)("species")]=function(t){t(w,w)};return(x||"function"==typeof PromiseRejectionEvent)&&t.then(w)instanceof n}catch(t){}}(),O=function(t,n){return t===n||t===_&&n===i},S=function(t){var n;return!(!l(t)||"function"!=typeof(n=t.then))&&n},P=function(t){return O(_,t)?new E(t):new o(t)},E=o=function(t){var n,e;this.promise=new t(function(t,r){if(void 0!==n||void 0!==e)throw b("Bad Promise constructor");n=t,e=r}),this.resolve=p(n),this.reject=p(e)},M=function(t){try{t()}catch(t){return{error:t}}},A=function(t,n){if(!t._n){t._n=!0;var e=t._c;m(function(){for(var r=t._v,o=1==t._s,i=0;e.length>i;)!function(n){var e,i,u=o?n.ok:n.fail,c=n.resolve,f=n.reject,a=n.domain;try{u?(o||(2==t._h&&F(t),t._h=1),!0===u?e=r:(a&&a.enter(),e=u(r),a&&a.exit()),e===n.promise?f(b("Promise-chain cycle")):(i=S(e))?i.call(e,c,f):c(e)):f(r)}catch(t){f(t)}}(e[i++]);t._c=[],t._n=!1,n&&!t._h&&k(t)})}},k=function(t){y.call(c,function(){var n,e,r,o=t._v;if(T(t)&&(n=M(function(){x?g.emit("unhandledRejection",o,t):(e=c.onunhandledrejection)?e({promise:t,reason:o}):(r=c.console)&&r.error&&r.error("Unhandled promise rejection",o)}),t._h=x||T(t)?2:1),t._a=void 0,n)throw n.error})},T=function(t){if(1==t._h)return!1;for(var n,e=t._a||t._c,r=0;e.length>r;)if(n=e[r++],n.fail||!T(n.promise))return!1;return!0},F=function(t){y.call(c,function(){var n;x?g.emit("rejectionHandled",t):(n=c.onrejectionhandled)&&n({promise:t,reason:t._v})})},I=function(t){var n=this;n._d||(n._d=!0,n=n._w||n,n._v=t,n._s=2,n._a||(n._a=n._c.slice()),A(n,!0))},N=function(t){var n,e=this;if(!e._d){e._d=!0,e=e._w||e;try{if(e===t)throw b("Promise can't be resolved itself");(n=S(t))?m(function(){var r={_w:e,_d:!1};try{n.call(t,f(N,r,1),f(I,r,1))}catch(t){I.call(r,t)}}):(e._v=t,e._s=1,A(e,!1))}catch(t){I.call({_w:e,_d:!1},t)}}};j||(_=function(t){v(this,_,"Promise","_h"),p(t),r.call(this);try{t(f(N,this,1),f(I,this,1))}catch(t){I.call(this,t)}},r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},r.prototype=e(87)(_.prototype,{then:function(t,n){var e=P(d(this,_));return e.ok="function"!=typeof t||t,e.fail="function"==typeof n&&n,e.domain=x?g.domain:void 0,this._c.push(e),this._a&&this._a.push(e),this._s&&A(this,!1),e.promise},catch:function(t){return this.then(void 0,t)}}),E=function(){var t=new r;this.promise=t,this.resolve=f(N,t,1),this.reject=f(I,t,1)}),s(s.G+s.W+s.F*!j,{Promise:_}),e(20)(_,"Promise"),e(88)("Promise"),i=e(2).Promise,s(s.S+s.F*!j,"Promise",{reject:function(t){var n=P(this);return(0,n.reject)(t),n.promise}}),s(s.S+s.F*(u||!j),"Promise",{resolve:function(t){if(t instanceof _&&O(t.constructor,this))return t;var n=P(this);return(0,n.resolve)(t),n.promise}}),s(s.S+s.F*!(j&&e(44)(function(t){_.all(t).catch(w)})),"Promise",{all:function(t){var n=this,e=P(n),r=e.resolve,o=e.reject,i=M(function(){var e=[],i=0,u=1;h(t,!1,function(t){var c=i++,f=!1;e.push(void 0),u++,n.resolve(t).then(function(t){f||(f=!0,e[c]=t,--u||r(e))},o)}),--u||r(e)});return i&&o(i.error),e.promise},race:function(t){var n=this,e=P(n),r=e.reject,o=M(function(){h(t,!1,function(t){n.resolve(t).then(e.resolve,r)})});return o&&r(o.error),e.promise}})},function(t,n,e){"use strict";var r=e(1),o=e(6),i=e(5),u=e(11),c=e(49),f=e(80).KEY,a=e(12),s=e(30),l=e(20),p=e(21),v=e(0),h=e(36),d=e(35),y=e(79),m=e(72),b=e(76),g=e(4),_=e(8),x=e(34),w=e(16),j=e(45),O=e(84),S=e(83),P=e(3),E=e(15),M=S.f,A=P.f,k=O.f,T=r.Symbol,F=r.JSON,I=F&&F.stringify,N=v("_hidden"),C=v("toPrimitive"),R={}.propertyIsEnumerable,L=s("symbol-registry"),D=s("symbols"),W=s("op-symbols"),B=Object.prototype,U="function"==typeof T,K=r.QObject,V=!K||!K.prototype||!K.prototype.findChild,G=i&&a(function(){return 7!=j(A({},"a",{get:function(){return A(this,"a",{value:7}).a}})).a})?function(t,n,e){var r=M(B,n);r&&delete B[n],A(t,n,e),r&&t!==B&&A(B,n,r)}:A,J=function(t){var n=D[t]=j(T.prototype);return n._k=t,n},z=U&&"symbol"==typeof T.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof T},H=function(t,n,e){return t===B&&H(W,n,e),g(t),n=x(n,!0),g(e),o(D,n)?(e.enumerable?(o(t,N)&&t[N][n]&&(t[N][n]=!1),e=j(e,{enumerable:w(0,!1)})):(o(t,N)||A(t,N,w(1,{})),t[N][n]=!0),G(t,n,e)):A(t,n,e)},Y=function(t,n){g(t);for(var e,r=m(n=_(n)),o=0,i=r.length;i>o;)H(t,e=r[o++],n[e]);return t},Q=function(t,n){return void 0===n?j(t):Y(j(t),n)},$=function(t){var n=R.call(this,t=x(t,!0));return!(this===B&&o(D,t)&&!o(W,t))&&(!(n||!o(this,t)||!o(D,t)||o(this,N)&&this[N][t])||n)},q=function(t,n){if(t=_(t),n=x(n,!0),t!==B||!o(D,n)||o(W,n)){var e=M(t,n);return!e||!o(D,n)||o(t,N)&&t[N][n]||(e.enumerable=!0),e}},X=function(t){for(var n,e=k(_(t)),r=[],i=0;e.length>i;)o(D,n=e[i++])||n==N||n==f||r.push(n);return r},Z=function(t){for(var n,e=t===B,r=k(e?W:_(t)),i=[],u=0;r.length>u;)!o(D,n=r[u++])||e&&!o(B,n)||i.push(D[n]);return i};U||(T=function(){if(this instanceof T)throw TypeError("Symbol is not a constructor!");var t=p(arguments.length>0?arguments[0]:void 0),n=function(e){this===B&&n.call(W,e),o(this,N)&&o(this[N],t)&&(this[N][t]=!1),G(this,t,w(1,e))};return i&&V&&G(B,t,{configurable:!0,set:n}),J(t)},c(T.prototype,"toString",function(){return this._k}),S.f=q,P.f=H,e(46).f=O.f=X,e(28).f=$,e(47).f=Z,i&&!e(19)&&c(B,"propertyIsEnumerable",$,!0),h.f=function(t){return J(v(t))}),u(u.G+u.W+u.F*!U,{Symbol:T});for(var tt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;tt.length>nt;)v(tt[nt++]);for(var tt=E(v.store),nt=0;tt.length>nt;)d(tt[nt++]);u(u.S+u.F*!U,"Symbol",{for:function(t){return o(L,t+="")?L[t]:L[t]=T(t)},keyFor:function(t){if(z(t))return y(L,t);throw TypeError(t+" is not a symbol!")},useSetter:function(){V=!0},useSimple:function(){V=!1}}),u(u.S+u.F*!U,"Object",{create:Q,defineProperty:H,defineProperties:Y,getOwnPropertyDescriptor:q,getOwnPropertyNames:X,getOwnPropertySymbols:Z}),F&&u(u.S+u.F*(!U||a(function(){var t=T();return"[null]"!=I([t])||"{}"!=I({a:t})||"{}"!=I(Object(t))})),"JSON",{stringify:function(t){if(void 0!==t&&!z(t)){for(var n,e,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);return n=r[1],"function"==typeof n&&(e=n),!e&&b(n)||(n=function(t,n){if(e&&(n=e.call(this,t,n)),!z(n))return n}),r[1]=n,I.apply(F,r)}}}),T.prototype[C]||e(7)(T.prototype,C,T.prototype.valueOf),l(T,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,n,e){e(35)("asyncIterator")},function(t,n,e){e(35)("observable")},function(t,n,e){function r(t){return null===t||void 0===t}function o(t){return!(!t||"object"!=typeof t||"number"!=typeof t.length)&&("function"==typeof t.copy&&"function"==typeof t.slice&&!(t.length>0&&"number"!=typeof t[0]))}function i(t,n,e){var i,s;if(r(t)||r(n))return!1;if(t.prototype!==n.prototype)return!1;if(f(t))return!!f(n)&&(t=u.call(t),n=u.call(n),a(t,n,e));if(o(t)){if(!o(n))return!1;if(t.length!==n.length)return!1;for(i=0;i<t.length;i++)if(t[i]!==n[i])return!1;return!0}try{var l=c(t),p=c(n)}catch(t){return!1}if(l.length!=p.length)return!1;for(l.sort(),p.sort(),i=l.length-1;i>=0;i--)if(l[i]!=p[i])return!1;for(i=l.length-1;i>=0;i--)if(s=l[i],!a(t[s],n[s],e))return!1;return typeof t==typeof n}var u=Array.prototype.slice,c=e(101),f=e(100),a=t.exports=function(t,n,e){return e||(e={}),t===n||(t instanceof Date&&n instanceof Date?t.getTime()===n.getTime():!t||!n||"object"!=typeof t&&"object"!=typeof n?e.strict?t===n:t==n:i(t,n,e))}},function(t,n){function e(t){return"[object Arguments]"==Object.prototype.toString.call(t)}function r(t){return t&&"object"==typeof t&&"number"==typeof t.length&&Object.prototype.hasOwnProperty.call(t,"callee")&&!Object.prototype.propertyIsEnumerable.call(t,"callee")||!1}var o="[object Arguments]"==function(){return Object.prototype.toString.call(arguments)}();n=t.exports=o?e:r,n.supported=e,n.unsupported=r},function(t,n){function e(t){var n=[];for(var e in t)n.push(e);return n}n=t.exports="function"==typeof Object.keys?Object.keys:e,n.shim=e}])});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "ZOVm":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_dialog_alert",
    on: {
      "touchmove": function($event) {
        !this.scroll && $event.preventDefault()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui_mask",
    attrs: {
      "transition": _vm.maskTransition
    },
    on: {
      "click": _vm.onHide
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui_dialog",
    attrs: {
      "transition": _vm.dialogTransition
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "ZOvT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! Hammer.JS - v2.0.4 - 2014-09-28
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2014 Jorik Tangelder;
 * Licensed under the MIT license */
  
var isServer = typeof window === 'undefined'
var VENDOR_PREFIXES = ['', 'webkit', 'moz', 'MS', 'ms', 'o'];
if (isServer) {
    var TEST_ELEMENT = null
} else {
    var TEST_ELEMENT = document.createElement('div');
}

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge]
 * @returns {Object} dest
 */
function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
function merge(dest, src) {
    return extend(dest, src, true);
}

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        extend(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument;
    return (doc.defaultView || doc.parentWindow);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
if (isServer) {
  var SUPPORT_TOUCH = false;
  var SUPPORT_POINTER_EVENTS = false;
  var SUPPORT_ONLY_TOUCH = true;
} else {
  var SUPPORT_TOUCH = ('ontouchstart' in window);
  var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
  var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
};

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;
    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = last.deltaX - input.deltaX;
        var deltaY = last.deltaY - input.deltaY;
        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }
    
    if (abs(x) >= abs(y)) {
        return x > 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y > 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) - getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.allow = true; // used by Input.TouchMouse to disable mouse events
    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down, and mouse events are allowed (see the TouchMouse input)
        if (!this.pressed || !this.allow) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (!isServer) {
    if (window.MSPointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */
function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        // when we're in a touch event, so  block all upcoming mouse events
        // most mobile browser also emit mouseevents, right after touchstart
        if (isTouch) {
            this.mouse.allow = false;
        } else if (isMouse && !this.mouse.allow) {
            return;
        }

        // reset the allowMouse when we're done
        if (inputEvent & (INPUT_END | INPUT_CANCEL)) {
            this.mouse.allow = true;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});
if (isServer) {
    var PREFIXED_TOUCH_ACTION = undefined
    var NATIVE_TOUCH_ACTION = true
} else {
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
}

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager &&  this.manager.element &&  this.manager.element.style) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        if (this.manager && this.manager.element) {
            this.set(this.manager.options.touchAction);
        }
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        // not needed with native support for the touchAction property
        if (NATIVE_TOUCH_ACTION) {
            return;
        }

        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // pan-x and pan-y can be combined
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_PAN_X + ' ' + TOUCH_ACTION_PAN_Y;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.id = uniqueId();

    this.manager = null;
    this.options = merge(options || {}, this.defaults);

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        extend(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(withState) {
            self.manager.emit(self.options.event + (withState ? stateStr(state) : ''), input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(true);
        }

        emit(); // simple 'eventName' events

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(true);
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = extend({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this._super.emit.call(this, input);
    },
    reset:function(){
        
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        this._super.emit.call(this, input);
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            this.manager.emit(this.options.event + inOut, input);
        }
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 500, // minimal time of the pointer to be pressed
        threshold: 5 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.65,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.velocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.velocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.velocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.direction &&
            input.distance > this.options.threshold &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.direction);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 10, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;
        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }
        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;
            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED ) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create an manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.4';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, { enable: false }],
        [PinchRecognizer, { enable: false }, ['rotate']],
        [SwipeRecognizer,{ direction: DIRECTION_HORIZONTAL }],
        [PanRecognizer, { direction: DIRECTION_HORIZONTAL }, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, { event: 'doubletap', taps: 2 }, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    options = options || {};

    this.options = merge(options, Hammer.defaults);
    this.options.inputTarget = this.options.inputTarget || element;
    this.handlers = {};
    this.session = {};
    this.recognizers = [];

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        extend(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        var recognizers = this.recognizers;
        recognizer = this.get(recognizer);
        recognizers.splice(inArray(recognizers, recognizer), 1);

        this.touchAction.update();
        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    each(manager.options.cssProps, function(value, name) {
        element.style[prefixed(element.style, name)] = add ? value : '';
    });
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

extend(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

if (typeof module == 'object' && module.exports) {
    module.exports = Hammer;
}


/***/ }),

/***/ "ZSw/":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*! PhotoSwipe Default UI CSS by Dmitry Semenov | photoswipe.com | MIT license */.pswp__button{width:44px;height:44px;position:relative;background:none;cursor:pointer;overflow:visible;-webkit-appearance:none;display:block;border:0;padding:0;margin:0;float:right;opacity:.75;-webkit-transition:opacity .2s;transition:opacity .2s;-webkit-box-shadow:none;box-shadow:none}.pswp__button:focus,.pswp__button:hover{opacity:1}.pswp__button:active{outline:none;opacity:.9}.pswp__button::-moz-focus-inner{padding:0;border:0}.pswp__ui--over-close .pswp__button--close{opacity:1}.pswp__button,.pswp__button--arrow--left:before,.pswp__button--arrow--right:before{background:url(" + escape(__webpack_require__("G5Aw")) + ") 0 0 no-repeat;background-size:264px 88px;width:44px;height:44px}@media (-webkit-min-device-pixel-ratio:1.1),(-webkit-min-device-pixel-ratio:1.09375),(min-resolution:1.1dppx),(min-resolution:105dpi){.pswp--svg .pswp__button,.pswp--svg .pswp__button--arrow--left:before,.pswp--svg .pswp__button--arrow--right:before{background-image:url(" + escape(__webpack_require__("3S8j")) + ")}.pswp--svg .pswp__button--arrow--left,.pswp--svg .pswp__button--arrow--right{background:none}}.pswp__button--close{background-position:0 -44px}.pswp__button--share{background-position:-44px -44px}.pswp__button--fs{display:none}.pswp--supports-fs .pswp__button--fs{display:block}.pswp--fs .pswp__button--fs{background-position:-44px 0}.pswp__button--zoom{display:none;background-position:-88px 0}.pswp--zoom-allowed .pswp__button--zoom{display:block}.pswp--zoomed-in .pswp__button--zoom{background-position:-132px 0}.pswp--touch .pswp__button--arrow--left,.pswp--touch .pswp__button--arrow--right{visibility:hidden}.pswp__button--arrow--left,.pswp__button--arrow--right{background:none;top:50%;margin-top:-50px;width:70px;height:100px;position:absolute}.pswp__button--arrow--left{left:0}.pswp__button--arrow--right{right:0}.pswp__button--arrow--left:before,.pswp__button--arrow--right:before{content:\"\";top:35px;background-color:rgba(0,0,0,.3);height:30px;width:32px;position:absolute}.pswp__button--arrow--left:before{left:6px;background-position:-138px -44px}.pswp__button--arrow--right:before{right:6px;background-position:-94px -44px}.pswp__counter,.pswp__share-modal{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pswp__share-modal{display:block;background:rgba(0,0,0,.5);width:100%;height:100%;top:0;left:0;padding:10px;position:absolute;z-index:1600;opacity:0;-webkit-transition:opacity .25s ease-out;transition:opacity .25s ease-out;-webkit-backface-visibility:hidden;will-change:opacity}.pswp__share-modal--hidden{display:none}.pswp__share-tooltip{z-index:1620;position:absolute;background:#fff;top:56px;border-radius:2px;display:block;width:auto;right:44px;-webkit-box-shadow:0 2px 5px rgba(0,0,0,.25);box-shadow:0 2px 5px rgba(0,0,0,.25);-webkit-transform:translateY(6px);-ms-transform:translateY(6px);transform:translateY(6px);-webkit-transition:-webkit-transform .25s;transition:transform .25s;-webkit-backface-visibility:hidden;will-change:transform}.pswp__share-tooltip a{display:block;padding:8px 12px;font-size:14px;line-height:18px}.pswp__share-tooltip a,.pswp__share-tooltip a:hover{color:#000;text-decoration:none}.pswp__share-tooltip a:first-child{border-radius:2px 2px 0 0}.pswp__share-tooltip a:last-child{border-radius:0 0 2px 2px}.pswp__share-modal--fade-in{opacity:1}.pswp__share-modal--fade-in .pswp__share-tooltip{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.pswp--touch .pswp__share-tooltip a{padding:16px 12px}a.pswp__share--facebook:before{content:\"\";display:block;width:0;height:0;position:absolute;top:-12px;right:15px;border:6px solid transparent;border-bottom-color:#fff;-webkit-pointer-events:none;-moz-pointer-events:none;pointer-events:none}a.pswp__share--facebook:hover{background:#3e5c9a;color:#fff}a.pswp__share--facebook:hover:before{border-bottom-color:#3e5c9a}a.pswp__share--twitter:hover{background:#55acee;color:#fff}a.pswp__share--pinterest:hover{background:#ccc;color:#ce272d}a.pswp__share--download:hover{background:#ddd}.pswp__counter{position:absolute;left:0;top:0;height:44px;font-size:13px;line-height:44px;color:#fff;opacity:.75;padding:0 10px}.pswp__caption{position:absolute;left:0;bottom:0;width:100%;min-height:44px}.pswp__caption small{font-size:11px;color:#bbb}.pswp__caption__center{text-align:left;max-width:420px;margin:0 auto;font-size:13px;padding:10px;line-height:20px;color:#ccc}.pswp__caption--empty{display:none}.pswp__caption--fake{visibility:hidden}.pswp__preloader{width:44px;height:44px;position:absolute;top:0;left:50%;margin-left:-22px;opacity:0;-webkit-transition:opacity .25s ease-out;transition:opacity .25s ease-out;will-change:opacity;direction:ltr}.pswp__preloader__icn{width:20px;height:20px;margin:12px}.pswp__preloader--active{opacity:1}.pswp__preloader--active .pswp__preloader__icn{background:url(" + escape(__webpack_require__("MieJ")) + ") 0 0 no-repeat}.pswp--css_animation .pswp__preloader--active{opacity:1}.pswp--css_animation .pswp__preloader--active .pswp__preloader__icn{-webkit-animation:clockwise .5s linear infinite;animation:clockwise .5s linear infinite}.pswp--css_animation .pswp__preloader--active .pswp__preloader__donut{-webkit-animation:donut-rotate 1s cubic-bezier(.4,0,.22,1) infinite;animation:donut-rotate 1s cubic-bezier(.4,0,.22,1) infinite}.pswp--css_animation .pswp__preloader__icn{background:none;opacity:.75;width:14px;height:14px;position:absolute;left:15px;top:15px;margin:0}.pswp--css_animation .pswp__preloader__cut{position:relative;width:7px;height:14px;overflow:hidden}.pswp--css_animation .pswp__preloader__donut{-webkit-box-sizing:border-box;box-sizing:border-box;width:14px;height:14px;border:2px solid #fff;border-radius:50%;border-left-color:transparent;border-bottom-color:transparent;position:absolute;top:0;left:0;background:none;margin:0}@media screen and (max-width:1024px){.pswp__preloader{position:relative;left:auto;top:auto;margin:0;float:right}}@-webkit-keyframes clockwise{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes clockwise{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes donut-rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}50%{-webkit-transform:rotate(-140deg);transform:rotate(-140deg)}to{-webkit-transform:rotate(0);transform:rotate(0)}}@keyframes donut-rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}50%{-webkit-transform:rotate(-140deg);transform:rotate(-140deg)}to{-webkit-transform:rotate(0);transform:rotate(0)}}.pswp__ui{-webkit-font-smoothing:auto;visibility:visible;opacity:1;z-index:1550}.pswp__top-bar{position:absolute;left:0;top:0;height:44px;width:100%}.pswp--has_mouse .pswp__button--arrow--left,.pswp--has_mouse .pswp__button--arrow--right,.pswp__caption,.pswp__top-bar{-webkit-backface-visibility:hidden;will-change:opacity;-webkit-transition:opacity 333ms cubic-bezier(.4,0,.22,1);transition:opacity 333ms cubic-bezier(.4,0,.22,1)}.pswp--has_mouse .pswp__button--arrow--left,.pswp--has_mouse .pswp__button--arrow--right{visibility:visible}.pswp__caption,.pswp__top-bar{background-color:rgba(0,0,0,.5)}.pswp__ui--fit .pswp__caption,.pswp__ui--fit .pswp__top-bar{background-color:rgba(0,0,0,.3)}.pswp__ui--idle .pswp__button--arrow--left,.pswp__ui--idle .pswp__button--arrow--right,.pswp__ui--idle .pswp__top-bar{opacity:0}.pswp__ui--hidden .pswp__button--arrow--left,.pswp__ui--hidden .pswp__button--arrow--right,.pswp__ui--hidden .pswp__caption,.pswp__ui--hidden .pswp__top-bar{opacity:.001}.pswp__ui--one-slide .pswp__button--arrow--left,.pswp__ui--one-slide .pswp__button--arrow--right,.pswp__ui--one-slide .pswp__counter{display:none}.pswp__element--disabled{display:none!important}.pswp--minimal--dark .pswp__top-bar{background:none}", ""]);

// exports


/***/ }),

/***/ "ZSyl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("5zA6");

exports.default = {
  mixins: [_multiItems.childMixin],
  props: {
    activeClass: String,
    disabled: Boolean
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.selected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
};

/***/ }),

/***/ "ZVAZ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("tOj0")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("AzoK"),
  /* template */
  __webpack_require__("deFV"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "Zzip":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("/n6Q"), __esModule: true };

/***/ }),

/***/ "a1VJ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-actionsheet"
  }, [_c('transition', {
    attrs: {
      "name": "vux-actionsheet-mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask weui-mask_transparent",
    on: {
      "click": _vm.onClickingMask
    }
  })]), _vm._v(" "), (_vm.theme === 'android') ? _c('div', {
    staticClass: "weui-skin_android"
  }, [_c('transition', {
    attrs: {
      "name": "vux-android-actionsheet"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-actionsheet"
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, _vm._l((_vm.menus), function(text, key) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      domProps: {
        "innerHTML": _vm._s(text.label || text)
      },
      on: {
        "click": function($event) {
          _vm.onMenuClick(text, key)
        }
      }
    })
  }))])])], 1) : _c('div', {
    staticClass: "weui-actionsheet",
    class: {
      'weui-actionsheet_toggle': _vm.show
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [(_vm.hasHeaderSlot) ? _c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.menus), function(text, key) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      class: ("vux-actionsheet-menu-" + (text.type || 'default')),
      domProps: {
        "innerHTML": _vm._s(text.label || text)
      },
      on: {
        "click": function($event) {
          _vm.onMenuClick(text, key)
        }
      }
    })
  })], 2), _vm._v(" "), (_vm.showCancel) ? _c('div', {
    staticClass: "weui-actionsheet__action",
    on: {
      "click": function($event) {
        _vm.emitEvent('on-click-menu', 'cancel')
      }
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "a8s/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = __webpack_require__("T131");

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'x-progress',
  mixins: [_base2.default],
  props: {
    percent: {
      type: Number,
      default: 0
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('on-cancel');
    }
  }
};

/***/ }),

/***/ "a9zO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _base = __webpack_require__("T131");

var _base2 = _interopRequireDefault(_base);

var _tip = __webpack_require__("nvcE");

var _tip2 = _interopRequireDefault(_tip);

var _icon = __webpack_require__("6O5g");

var _icon2 = _interopRequireDefault(_icon);

var _inlineDesc = __webpack_require__("hc1C");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _objectFilter = __webpack_require__("pVtq");

var _arrayShuffle = __webpack_require__("HHx2");

var _arrayShuffle2 = _interopRequireDefault(_arrayShuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Tip: _tip2.default,
    Icon: _icon2.default,
    InlineDesc: _inlineDesc2.default
  },
  filters: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey
  },
  mixins: [_base2.default],
  props: {
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options
    };
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
    }
    if (this.randomOrder) {
      this.currentOptions = (0, _arrayShuffle2.default)(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey,
    getInlineDesc: _objectFilter.getInlineDesc,
    getFullValue: function getFullValue() {
      var labels = (0, _objectFilter.getLabels)(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required) {
        return 0;
      }
      if (this.min) {
        if (this.min < 0) {
          return 1;
        }
        if (this.min >= this._total) {
          return this._total;
        }
        return this.min;
      } else {
        return 1;
      }
    },
    _max: function _max() {
      if (!this.required) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    validy: function validy() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    },
    error: function error() {
      var err = [];
      if (this.currentValue.length < this._min) {
        err.push('\u6700\u5C11\u8981\u9009\u62E9' + this._min + '\u4E2A\u54E6');
      }
      if (this.currentValue.length > this._max) {
        err.push('\u6700\u591A\u53EA\u80FD\u9009\u62E9' + this._max + '\u4E2A\u54E6');
      }
      return err;
    }
  },
  watch: {
    value: function value(newVal) {
      if ((0, _stringify2.default)(newVal) !== (0, _stringify2.default)(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = pure(newVal);
      this.$emit('on-change', val);
      this.$emit('input', val, (0, _objectFilter.getLabels)(this.options, val));
      var err = {};
      if (this._min) {
        if (this.required) {
          if (this.currentValue.length < this._min) {
            err = {
              min: this._min
            };
          }
        } else {
          if (this.currentValue.length && this.currentValue.length < this._min) {
            err = {
              min: this._min
            };
          }
        }
      }
      if (!this.validy && this.dirty && (0, _keys2.default)(err).length) {
        this.$emit('on-error', err);
      } else {
        this.$emit('on-clear-error');
      }
    }
  }
};


function pure(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
}

/***/ }),

/***/ "aDDo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var prefixList = ['-moz-box-', '-webkit-box-', ''];

exports.default = {
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / document.documentElement.offsetWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';
      styles[marginName] = this.$parent.gutter + 'px';

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ "aDd6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__("nnTn");

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_picker2.default.install = function (Vue) {
  Vue.component('LxPicker', _picker2.default);
};

exports.default = _picker2.default;

/***/ }),

/***/ "aMpv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayFind = __webpack_require__("NXHL");

var _arrayFind2 = _interopRequireDefault(_arrayFind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findByKey = function findByKey(key, options) {
  var _rs = (0, _arrayFind2.default)(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

exports.default = {
  computed: {
    processOptions: function processOptions() {
      if (this.options.length && {}.hasOwnProperty.call(this.options[0], 'key')) {
        return this.options;
      } else {
        return this.options.map(function (item) {
          return {
            key: item,
            value: item
          };
        });
      }
    },
    classes: function classes() {
      return {
        'vux-selector-no-padding': !this.title,
        'cvux-selector-placeholder': this.currentValue === ''
      };
    }
  },
  filters: {
    findByKey: findByKey
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(newValue) {
      this.$emit('input', newValue);
      this.$emit('on-change', newValue);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: {
      type: [String, Number, Boolean],
      default: ''
    }
  }
};

/***/ }),

/***/ "aoRB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _numberRoller = __webpack_require__("e478");

var _numberRoller2 = _interopRequireDefault(_numberRoller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_numberRoller2.default.install = function (Vue) {
  Vue.component('LxNumberRoller', _numberRoller2.default);
};

exports.default = _numberRoller2.default;

/***/ }),

/***/ "ax3d":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("e8AB")('keys');
var uid = __webpack_require__("3Eo+");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "b0Xt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scroller = __webpack_require__("zFCM");

var _scroller2 = _interopRequireDefault(_scroller);

var _util = __webpack_require__("XDhV");

var _makeData2 = __webpack_require__("myzo");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MASK_TEMPLATE = '<div class="dp-mask"></div>';

var TEMPLATE = '<div class="dp-container">\n  <div class="dp-header">\n    <div class="dp-item dp-left" data-role="cancel">cancel</div>\n    <div class="dp-item dp-center" data-role="clear"></div>\n    <div class="dp-item dp-right" data-role="confirm">ok</div>\n  </div>\n  <div class="dp-content">\n    <div class="dp-item" data-role="year"></div>\n    <div class="dp-item" data-role="month"></div>\n    <div class="dp-item" data-role="day"></div>\n    <div class="dp-item" data-role="hour"></div>\n    <div class="dp-item" data-role="minute"></div>\n  </div>\n</div>';

var SHOW_ANIMATION_TIME = 100;
var SHOW_CONTAINER_TIME = 300;

var TYPE_MAP = {
  year: ['YYYY'],
  month: ['MM', 'M'],
  day: ['DD', 'D'],
  hour: ['HH', 'H'],
  minute: ['mm', 'm']
};

var MASK = null;

var CURRENT_PICKER;

var NOW = new Date();

var DEFAULT_CONFIG = {
  template: TEMPLATE,
  trigger: null,
  output: null,
  currentYear: NOW.getFullYear(),
  currentMonth: NOW.getMonth() + 1,
  minYear: 2000,
  maxYear: 2030,
  minHour: 0,
  maxHour: 23,
  startDate: null,
  endDate: null,
  yearRow: '{value}',
  monthRow: '{value}',
  dayRow: '{value}',
  hourRow: '{value}',
  minuteRow: '{value}',
  format: 'YYYY-MM-DD',
  value: NOW.getFullYear() + '-' + (NOW.getMonth() + 1) + '-' + NOW.getDate(),
  onSelect: function onSelect() {},
  onConfirm: function onConfirm() {},
  onClear: function onClear() {},
  onShow: function onShow() {},
  onHide: function onHide() {},

  confirmText: 'ok',
  clearText: '',
  cancelText: 'cancel'
};

function renderScroller(el, data, value, fn) {
  var scroller = new _scroller2.default(el, {
    data: data,
    defaultValue: value,
    onSelect: fn
  });
  return scroller;
}

function showMask() {
  if (!MASK) {
    MASK = (0, _util.toElement)(MASK_TEMPLATE);
    document.body.appendChild(MASK);

    MASK.addEventListener('click', function () {
      CURRENT_PICKER && CURRENT_PICKER.hide();
    }, false);
  }

  MASK.style.display = 'block';

  setTimeout(function () {
    MASK && (MASK.style.opacity = 0.5);
  }, 0);
}

function hideMask() {
  if (!MASK) {
    return;
  }

  MASK.style.opacity = 0;

  setTimeout(function () {
    MASK && (MASK.style.display = 'none');
  }, SHOW_ANIMATION_TIME);
}

function DatetimePicker(config) {
  var self = this;
  self.config = {};
  self.value = config.value || '';
  (0, _util.each)(DEFAULT_CONFIG, function (key, val) {
    self.config[key] = config[key] || val;
  });

  if (typeof this.config.startDate === 'string') {
    this.config.startDate = new Date(this.config.startDate.replace(/-/g, '/'));
  }

  if (typeof this.config.endDate === 'string') {
    this.config.endDate = new Date(this.config.endDate.replace(/-/g, '/'));
  }

  if (this.config.startDate && !this.config.endDate) {
    this.config.endDate = new Date('2030-12-31');
  }

  this.reMakeData = !!this.config.startDate && !!this.config.endDate;

  var trigger = self.config.trigger;

  this.triggerHandler = function (e) {
    e.preventDefault();
    self.show(self.value);
  };
  if (trigger) {
    trigger = self.trigger = (0, _util.getElement)(trigger);
    this.trigger = trigger;
    this.trigger.addEventListener('click', this.triggerHandler, false);
  }
}

DatetimePicker.prototype = {
  _show: function _show(newValueMap) {
    var self = this;

    self.container.style.display = 'block';

    (0, _util.each)(TYPE_MAP, function (type) {
      self[type + 'Scroller'] && self[type + 'Scroller'].select((0, _util.trimZero)(newValueMap[type]), false);
    });

    setTimeout(function () {
      self.container.style['-webkit-transform'] = 'translateY(0)';
      self.container.style.transform = 'translateY(0)';
    }, 0);
  },
  show: function show(value) {
    var self = this;
    var config = self.config;
    CURRENT_PICKER = self;
    var valueMap = self.valueMap = (0, _util.parseDate)(config.format, value || config.value);
    var newValueMap = {};

    (0, _util.each)(TYPE_MAP, function (type, list) {
      newValueMap[type] = list.length === 1 ? valueMap[list[0]] : valueMap[list[0]] || valueMap[list[1]];
    });

    if (self.container) {
      self._show(newValueMap);
    } else {
      var container = self.container = (0, _util.toElement)(config.template);
      document.body.appendChild(container);

      self.container.style.display = 'block';

      container.addEventListener('touchstart', function (e) {}, false);

      (0, _util.each)(TYPE_MAP, function (type) {
        var div = self.find('[data-role=' + type + ']');
        if (newValueMap[type] === undefined) {
          (0, _util.removeElement)(div);
          return;
        }
        var data;
        if (type === 'day') {
          data = self._makeData(type, (0, _util.trimZero)(newValueMap.year), (0, _util.trimZero)(newValueMap.month));
        } else {
          data = self._makeData(type);
        }

        self[type + 'Scroller'] = renderScroller(div, data, (0, _util.trimZero)(newValueMap[type]), function (currentValue) {
          config.onSelect.call(self, type, currentValue);
          var currentDay;
          if (!self.dayScroller) {
            return;
          }
          if (type === 'year') {
            var currentMonth = self.monthScroller ? self.monthScroller.value : config.currentMonth;
            currentDay = self.dayScroller.value;
            self._setMonthScroller(currentValue, currentMonth);
            self._setDayScroller(currentValue, currentMonth, currentDay);
          } else if (type === 'month') {
            var currentYear = self.yearScroller ? self.yearScroller.value : config.currentYear;
            currentDay = self.dayScroller.value;
            self._setDayScroller(currentYear, currentValue, currentDay);
          }
        });
      });

      if (!self.renderText) {
        if (self.config.confirmText) {
          self.find('[data-role=confirm]').innerText = self.config.confirmText;
        }

        if (self.config.cancelText) {
          self.find('[data-role=cancel]').innerText = self.config.cancelText;
        }
        if (self.config.clearText) {
          self.find('[data-role=clear]').innerText = self.config.clearText;
        }
        self.renderText = true;
      }

      this._show(newValueMap);

      self.find('[data-role=cancel]').addEventListener('click', function (e) {
        e.preventDefault();
        self.hide();
      }, false);

      self.find('[data-role=confirm]').addEventListener('click', function (e) {
        e.preventDefault();
        self.confirm();
      }, false);

      if (self.config.clearText) {
        self.find('[data-role=clear]').addEventListener('click', function (e) {
          e.preventDefault();
          self.clear();
        }, false);
      }
    }

    showMask();
    config.onShow.call(self);
  },
  _makeData: function _makeData(type, year, month) {
    var config = this.config;
    var valueMap = this.valueMap;
    var list = TYPE_MAP[type];
    var data = [];
    var min;
    var max;

    if (type === 'year') {
      min = config.minYear;
      max = config.maxYear;
      if (this.reMakeData) {
        var _getYears = (0, _makeData2.getYears)(this.config.startDate, this.config.endDate),
            minYear = _getYears.minYear,
            maxYear = _getYears.maxYear;

        min = Math.max(min, minYear);
        max = Math.min(max, maxYear);
      }
    } else if (type === 'month') {
      min = 1;
      max = 12;
      if (this.reMakeData) {
        var _getMonths = (0, _makeData2.getMonths)(this.config.startDate, this.config.endDate, this.yearScroller.value * 1),
            minMonth = _getMonths.minMonth,
            maxMonth = _getMonths.maxMonth;

        min = Math.max(min, minMonth);
        max = Math.min(max, maxMonth);
      }
    } else if (type === 'day') {
      min = 1;
      max = (0, _util.getMaxDay)(year, month);
      if (this.reMakeData) {
        var _getDays = (0, _makeData2.getDays)(this.config.startDate, this.config.endDate, this.yearScroller.value * 1, this.monthScroller.value * 1),
            minDay = _getDays.minDay,
            maxDay = _getDays.maxDay;

        min = Math.max(min, minDay);
        max = Math.min(max, maxDay);
      }
    } else if (type === 'hour') {
      min = this.config.minHour;
      max = this.config.maxHour;
    } else if (type === 'minute') {
      min = 0;
      max = 59;
    }
    for (var i = min; i <= max; i++) {
      var name;
      if (type === 'year') {
        name = (0, _util.parseRow)(config.yearRow, i);
      } else {
        var val = valueMap[list[0]] ? (0, _util.addZero)(i) : i;
        name = (0, _util.parseRow)(config[type + 'Row'], val);
      }
      data.push({
        name: name,
        value: i
      });
    }
    return data;
  },
  _setMonthScroller: function _setMonthScroller(currentValue, month) {
    var self = this;
    this.monthScroller.destroy();
    if (!self.container) return;
    var div = self.find('[data-role=month]');
    self.monthScroller = renderScroller(div, self._makeData('month'), month, function (currentValue) {
      self.config.onSelect.call(self, 'month', currentValue);
      var currentYear = self.yearScroller ? self.yearScroller.value : self.config.currentYear;
      var currentDay = self.dayScroller.value;
      self._setDayScroller(currentYear, currentValue, currentDay);
    });
  },
  _setDayScroller: function _setDayScroller(year, month, day) {
    var self = this;
    var maxDay = (0, _util.getMaxDay)(year, month);
    if (day > maxDay) {
      day = maxDay;
    }
    self.dayScroller.destroy();
    if (!self.container) return;
    var div = self.find('[data-role=day]');
    self.dayScroller = renderScroller(div, self._makeData('day', year, month), day, function (currentValue) {
      self.config.onSelect.call(self, 'day', currentValue);
    });
  },
  find: function find(selector) {
    return this.container.querySelector(selector);
  },
  hide: function hide() {
    var self = this;
    self.container.style.removeProperty('transform');
    self.container.style.removeProperty('-webkit-transform');

    setTimeout(function () {
      self.container && (self.container.style.display = 'none');
    }, SHOW_CONTAINER_TIME);

    hideMask();

    self.config.onHide.call(self);
  },
  select: function select(type, value) {
    this[type + 'Scroller'].select(value, false);
  },
  destroy: function destroy() {
    var self = this;
    this.trigger.removeEventListener('click', this.triggerHandler, false);
    (0, _util.removeElement)(MASK);
    (0, _util.removeElement)(self.container);
    MASK = null;
    self.container = null;
  },
  getValue: function getValue() {
    var self = this;
    var config = self.config;

    var value = config.format;

    function formatValue(scroller, expr1, expr2) {
      if (scroller) {
        var val = scroller.value;
        if (expr1) {
          value = value.replace(new RegExp(expr1, 'g'), (0, _util.addZero)(val));
        }
        if (expr2) {
          value = value.replace(new RegExp(expr2, 'g'), (0, _util.trimZero)(val));
        }
      }
    }

    (0, _util.each)(TYPE_MAP, function (key, list) {
      formatValue(self[key + 'Scroller'], list[0], list[1]);
    });

    return value;
  },
  confirm: function confirm() {
    var self = this;
    var value = self.getValue();
    this.value = value;

    if (self.config.onConfirm.call(self, value) === false) {
      return;
    }

    self.hide();
  },
  clear: function clear() {
    var self = this;
    var value = self.getValue();

    if (self.config.onClear.call(self, value) === false) {
      return;
    }

    self.hide();
  }
};

exports.default = DatetimePicker;

/***/ }),

/***/ "b26m":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: ['vux-badge', {
      'vux-badge-single': _vm.text.length === 1
    }],
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "bRpw":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Rb6m")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("h/xf"),
  /* template */
  __webpack_require__("wojb"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "bRrM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var dP = __webpack_require__("evD5");
var DESCRIPTORS = __webpack_require__("+E39");
var SPECIES = __webpack_require__("dSzd")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "bdnq":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "c58Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("y1vT");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _lodash2.default;

/***/ }),

/***/ "cK8J":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("1W2J")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("4gH2"),
  /* template */
  __webpack_require__("kSun"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "cPP0":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("7lvc")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("a9zO"),
  /* template */
  __webpack_require__("ui1D"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "cVIA":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui_mask_transparent"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui_toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    }),
    attrs: {
      "transition": _vm.transition
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui_icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui_toast_content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui_toast_content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ "cW+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3");
var Base = __webpack_require__("5dD5");
var transform = Util.prefixStyle("transform");

var Fixed = function(cfg) {
  Fixed.superclass.constructor.call(this, cfg);
  this.userConfig = Util.mix({
    fixedRenderTo: undefined,
    fixedElements: ".xs-fixed",
    prefix: "xs-fixed-container",
    zoomType: "y"
  }, cfg);
  this.init();
}

Util.extend(Fixed, Base, {
  fixedElements: [],
  init: function() {
    var self = this,
      userConfig = self.userConfig,
      xscroll = self.xscroll = userConfig.xscroll,
      xscrollConfig = self.xscrollConfig = xscroll.userConfig;
    self.isY = !!(userConfig.zoomType == "y");
    self._ = self.isY ? {
      top: "top",
      height: "height",
      width: "width",
      offsetTop:"offsetTop"
    } : {
      top: "left",
      height: "width",
      width: "height",
      offsetTop:"offsetLeft"
    };
    self.fixedRenderTo = Util.getNode(userConfig.fixedRenderTo);
    return self;
  },
  render: function() {
    var self = this;
    var xscroll = self.xscroll;
    self.infinite = xscroll.getPlugin("infinite");
    if (!self.fixedRenderTo) {
      self.fixedRenderTo = document.createElement('div');
      xscroll.renderTo.appendChild(self.fixedRenderTo);
    }
    Util.addClass(self.fixedRenderTo, self.userConfig.prefix);
    var originalFixedElements = self.originalFixedElements = self.getFixedElements();
    for (var i = 0, l = originalFixedElements.length; i < l; i++) {
      self.renderFixedElement(originalFixedElements[i], i,self.fixedRenderTo);
    }
    return self;
  },
  getFixedElements: function() {
    var self = this;
    var infinite = self.infinite;
    var userConfig = self.userConfig;
    if (infinite) {
      var els = [];
      for (var i in infinite.__serializedData) {
        var data = infinite.__serializedData[i];
        if (data && data.style && data.style.position == "fixed") {
          els.push(data);
        }
      }
      return els;
    } else {
      return Util.getNodes(userConfig.fixedElements, self.xscroll.content);
    }
  },
  renderFixedElement: function(el, fixedIndex,fixedRenderTo) {
    var self = this;
    var isRender = true;
    var _ = self._;
    var xscroll = self.xscroll;
    var userConfig = self.userConfig;
    var xscrollConfig = self.xscrollConfig;
    var useOriginScroll = xscrollConfig.useOriginScroll;
    var infinite = self.infinite;
    var fixedElement = self.fixedElements[fixedIndex];
    if (!self.fixedElements[fixedIndex]) {
      isRender = false;
      if (useOriginScroll && !infinite) {
        //use original position:fixed stylesheet
        el.style.position = "fixed";
        el.style.display = "block";
      } else {
        //deep clone fixed nodes and hide original nodes
        fixedElement = document.createElement("div");
        if (infinite) {
          fixedElement.setAttribute("style", Util.stringifyStyle(Util.mix(el.style, {
            display: "block",
            width: "100%"
          })));
          fixedElement.style[_.top] = (el.style[_.top] >= 0 ? el.style[_.top] : el._top) + "px";
          if (el.style[_.height]) {
            fixedElement.style[_.height] = el.style[_.height] + "px";
          }
          infinite.userConfig.renderHook.call(self, fixedElement, el);
        } else {
          fixedElement.style.display = "block";
          fixedElement.style.position = "absolute";
          fixedElement.style[_.width] = "100%";
          fixedElement.innerHTML = el.innerHTML;
          fixedElement.className = el.className;
          fixedElement.setAttribute("style", el.getAttribute("style"));
          fixedElement.style[_.top] = el[_.offsetTop] + "px";
          el.style.display = "none";
        }
        fixedRenderTo.appendChild(fixedElement);
        self.fixedElements.push(fixedElement);
      }
    }
    xscroll.trigger("fixedchange", {
      fixedIndex: fixedIndex,
      fixedElement: useOriginScroll ? el : fixedElement,
      originalFixedElement: el,
      isRender: isRender
    });
  },
  destroy: function() {
    var self = this;
    self.fixedElements = undefined;
  }
});

if (typeof module == 'object' && module.exports) {
  module.exports = Fixed;
}


/***/ }),

/***/ "ca2Y":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cells_access .weui_cell:not(.no_access){-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_cells_access .weui_cell:not(.no_access):active{background-color:#ececec}.weui_cells_access a.weui_cell{color:inherit}.weui_cells_access .weui_cell_ft:after{content:\" \";display:inline-block;-webkit-transform:rotate(45deg);transform:rotate(45deg);height:6px;width:6px;border-width:2px 2px 0 0;border-color:#c8c8cd;border-style:solid;position:relative;top:-2px;top:-1px;margin-left:.3em}.weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.weui_label{color:#000;display:block;width:2.4rem;word-wrap:break-word;word-break:break-all;padding-right:.13333333rem}.weui_input{width:100%;border:0;outline:0;-webkit-appearance:none;background-color:transparent;font-size:inherit;color:inherit;line-height:2.26666667}.weui_input::-webkit-inner-spin-button,.weui_input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.weui_textarea{display:block;border:0;resize:none;width:100%;color:inherit;font-size:.34666667rem;line-height:inherit;outline:0}.weui_textarea_counter{color:#999;text-align:right}.weui_cell_warn .weui_textarea_counter{color:#e64340}.weui_toptips{display:none;position:fixed;-webkit-transform:translateZ(0);width:100%;top:0;line-height:2.3;font-size:14px;text-align:center;color:#fff;z-index:50000}.weui_toptips.weui_warn{background-color:#e64340}.weui_cells_form .weui_cell_warn{color:#e64340}.weui_cells_form .weui_cell_warn .weui_icon_warn{display:inline-block}.weui_cells_form .weui_cell_ft{font-size:0}.weui_cells_form .weui_icon_warn{display:none}.weui_cells_form input,.weui_cells_form label[for],.weui_cells_form textarea{-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_cell_select{padding-top:0!important;padding-bottom:0!important}.weui_cell_select .weui_select{padding-right:.8rem}.weui_cell_select .weui_cell_bd:after{content:\" \";display:inline-block;-webkit-transform:rotate(45deg);transform:rotate(45deg);height:.21333333rem;width:.21333333rem;border-width:1px 1px 0 0;border-color:#a0a0a0;border-style:solid;position:relative;top:-2px;position:absolute;top:50%;right:.4rem;margin-top:-3px}.weui_select{-webkit-appearance:none;border:0;outline:0;background-color:transparent;width:100%;font-size:inherit;height:1.44rem;line-height:1.44rem;position:relative;z-index:1}.weui_select,.weui_select_after{padding-left:.4rem}.vux-selector-no-padding,.weui_select_after .weui_select{padding-left:0}.cvux-selector-placeholder{color:#a0a0a0}", ""]);

// exports


/***/ }),

/***/ "cddD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFDQN;

var _assertString = __webpack_require__("fcJk");

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__("LLCR");

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFDQN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    if (/[\uff01-\uff5e]/.test(part)) {
      // disallow full-width chars
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),

/***/ "crlp":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var LIBRARY = __webpack_require__("O4g8");
var wksExt = __webpack_require__("Kh4W");
var defineProperty = __webpack_require__("evD5").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "czWR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("J9cy");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("60470f7f", content, true);

/***/ }),

/***/ "dH1g":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("neo6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7fe0d744", content, true);

/***/ }),

/***/ "dJCP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isServer = typeof window === 'undefined'
var Util = __webpack_require__("rla3");
var Base = __webpack_require__("5dD5");
var Easing = __webpack_require__("jYb5");

if (isServer) {
	var RAF = function (callback) {
		window.setTimeout(callback, 1000 / 60);
	},
	cancelRAF = function (id) {
		window.clearTimeout(id)
	};
} else {
	var RAF = window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		function (callback) {
			window.setTimeout(callback, 1000 / 60);
		};

	var vendors = ['webkit', 'moz', 'ms', 'o'];
	var cancelRAF = window.cancelAnimationFrame;
	for (var i = 0; i < vendors.length; i++) {
		if (window[vendors[i] + 'CancelAnimationFrame'] || window[vendors[i] + 'CancelRequestAnimationFrame']) {
			cancelRAF = window[vendors[i] + 'CancelAnimationFrame'] || window[vendors[i] + 'CancelRequestAnimationFrame'];
		}
	}
	cancelRAF = cancelRAF || window.clearTimeout;
}

function Bezier(x1, y1, x2, y2, epsilon) {
	var curveX = function(t) {
		var v = 1 - t;
		return 3 * v * v * t * x1 + 3 * v * t * t * x2 + t * t * t;
	};

	var curveY = function(t) {
		var v = 1 - t;
		return 3 * v * v * t * y1 + 3 * v * t * t * y2 + t * t * t;
	};

	var derivativeCurveX = function(t) {
		var v = 1 - t;
		return 3 * (2 * (t - 1) * t + v * v) * x1 + 3 * (-t * t * t + 2 * v * t) * x2;
	};

	return function(t) {

		var x = t,
			t0, t1, t2, x2, d2, i;

		// First try a few iterations of Newton's method -- normally very fast.
		for (t2 = x, i = 0; i < 8; i++) {
			x2 = curveX(t2) - x;
			if (Math.abs(x2) < epsilon) return curveY(t2);
			d2 = derivativeCurveX(t2);
			if (Math.abs(d2) < 1e-6) break;
			t2 = t2 - x2 / d2;
		}

		t0 = 0, t1 = 1, t2 = x;

		if (t2 < t0) return curveY(t0);
		if (t2 > t1) return curveY(t1);

		// Fallback to the bisection method for reliability.
		while (t0 < t1) {
			x2 = curveX(t2);
			if (Math.abs(x2 - x) < epsilon) return curveY(t2);
			if (x > x2) t0 = t2;
			else t1 = t2;
			t2 = (t1 - t0) * .5 + t0;
		}

		// Failure
		return curveY(t2);

	};

};



function Timer(cfg) {
	var self = this;
	self.cfg = Util.mix({
		easing: "linear"
	}, cfg)
}

Timer.MIN_DURATION = 1;

Util.extend(Timer, Base, {
	reset: function(cfg) {
		var self = this;
		Util.mix(self.cfg, cfg);
		self.isfinished = false;
		self.percent = 0;
		self._stop = null;
	},
	run: function() {
		var self = this;
		var duration = self.cfg.duration;
		if (duration <= Timer.MIN_DURATION) {
			self.isfinished = true;
			self.trigger("run", {
				percent: 1
			});
			self.trigger("end", {
				percent: 1
			});
		}
		if (self.isfinished) return;
		self._hasFinishedPercent = self._stop && self._stop.percent || 0;
		self._stop = null;
		self.start = Date.now();
		self.percent = 0;
		// epsilon determines the precision of the solved values
		var epsilon = (1000 / 60 / duration) / 4;
		var b = Easing[self.cfg.easing];
		self.easingFn = Bezier(b[0], b[1], b[2], b[3], epsilon);
		self._run();
	},
	_run: function() {
		var self = this;
		cancelRAF(self._raf);
		self._raf = RAF(function() {
			self.now = Date.now();
			self.duration = self.now - self.start >= self.cfg.duration ? self.cfg.duration : self.now - self.start;
			self.progress = self.easingFn(self.duration / self.cfg.duration);
			self.percent = self.duration / self.cfg.duration + self._hasFinishedPercent;
			if (self.percent >= 1 || self._stop) {
				self.percent = self._stop && self._stop.percent ? self._stop.percent : 1;
				self.duration = self._stop && self._stop.duration ? self._stop.duration : self.duration;
				var param = {
					percent: self.percent
				};
				self.trigger("stop", param);
				if (self.percent >= 1) {
					self.isfinished = true;
					self.trigger("end", {
						percent: 1
					});
				}
				return;
			}
			self.trigger("run", {
				percent: self.progress,
				originPercent:self.percent
			});
			self._run();
		})
	},
	stop: function() {
		var self = this;
		self._stop = {
			percent: self.percent,
			now: self.now
		};
		cancelRAF(self._raf)
	}
});


if (typeof module == 'object' && module.exports) {
	module.exports = Timer;
}


/***/ }),

/***/ "dNDb":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "dOCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 路由
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  routes: [{
    path: '/',
    redirect: '/qrcode'
  },
  // { // 租车页
  //   path: '/rent',
  //   name: 'rent',
  //   // component: Rent,
  //   component: resolve => import(/* webpackChunkName: "Rent" */'../modules/rent/Rent').then(resolve),
  //   meta: {
  //     title: '预约租车'
  //   }
  // }, { // 预约页
  //   path: '/book',
  //   name: 'book',
  //   // component: Book,
  //   component: resolve => import(/* webpackChunkName: "Book" */'../modules/book/Book').then(resolve),
  //   meta: {
  //     title: '预约雷克萨斯'
  //   }
  // }, { // 成功页
  //   path: '/success',
  //   name: 'success',
  //   // component: Success,
  //   component: resolve => import(/* webpackChunkName: "Success" */'../modules/success/Success').then(resolve),
  //   meta: {
  //     title: '预约租车成功'
  //   }
  // },
  { // 增加扫码页面口令
    path: '/checked',
    name: 'checked',
    component: function component(resolve) {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "k4E1")).then(resolve);
    }
  }, { // 扫码页面
    path: '/qrCode',
    name: 'qrCode',
    component: function component(resolve) {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "P0fV")).then(resolve);
    }
  }, { // 领取优惠券
    path: '/receCoupon',
    name: 'receCoupon',
    component: function component(resolve) {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "/6Lj")).then(resolve);
    }
  }]
});

/***/ }),

/***/ "dSzd":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("e8AB")('wks');
var uid = __webpack_require__("3Eo+");
var Symbol = __webpack_require__("7KvD").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "dXZI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
};

/***/ }),

/***/ "dY0y":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("dSzd")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "deEd":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("LlVN")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("fsq/"),
  /* template */
  __webpack_require__("qXpI"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "deFV":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp vux-previewer",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden"
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])])])])
}]}

/***/ }),

/***/ "diSF":
/***/ (function(module, exports) {

module.exports = function (xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        var x = xs[i];
        if (hasOwn.call(xs, i)) res.push(f(x, i, xs));
    }
    return res;
};

var hasOwn = Object.prototype.hasOwnProperty;


/***/ }),

/***/ "dloP":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Jsix")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("uvUq"),
  /* template */
  __webpack_require__("6dZ4"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "dnAt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("BzPr");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    XDialog: _xDialog2.default
  },
  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: {
      type: String,
      default: 'OK'
    },
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    autoCloseTime: Number
  },
  methods: {
    _onHide: function _onHide() {
      this.show = false;
    }
  },
  data: function data() {
    return {
      show: false,
      timeId: ''
    };
  },

  watch: {
    show: function show(val) {
      var _this = this;

      if (val && this.autoCloseTime > 0) {
        var _autoCloseTime = this.autoCloseTime;
        this.timeId = setTimeout(function () {
          _this.show = false;
        }, _autoCloseTime);
      }
      if (!val && this.timeId) {
        clearTimeout(this.timeId);
        this.timeId = '';
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.show = val;
    }
  }
};

/***/ }),

/***/ "dxOV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WEml");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b83555a4", content, true);

/***/ }),

/***/ "e05S":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "weui_cell",
    attrs: {
      "href": "javascript:"
    }
  }, [_c('div', {
    staticClass: "weui_cell_bd weui_cell_content"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_ft vux-cell-primary vux-datetime-value",
    style: ({
      textAlign: _vm.valueTextAlign
    })
  }, [_vm._v("\n    " + _vm._s(_vm.currentValue) + "\n    "), (!_vm.currentValue.length && _vm.placeholder) ? _c('span', {
    staticClass: "cvux-datetime-placeholder",
    domProps: {
      "innerHTML": _vm._s(_vm.placeholder)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "with_arrow"
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.valid),
      expression: "!valid"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn",
      "title": _vm.firstError
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "e478":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("VI9z"),
  /* template */
  __webpack_require__("/+79"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "e6n0":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("evD5").f;
var has = __webpack_require__("D2L2");
var TAG = __webpack_require__("dSzd")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "e8AB":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "eb4a":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("xoz2")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("9kVz"),
  /* template */
  __webpack_require__("erIo"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "eixu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var on = exports.on = function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

var off = exports.off = function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/***/ }),

/***/ "enee":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("iQSq");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("edbafd00", content, true);

/***/ }),

/***/ "eqjz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var isServer = typeof window === 'undefined';
if (!isServer) {
  window.__$vuxPopups = window.__$vuxPopups || {};
}
var popupDialog = function popupDialog(option) {
  this.uuid = Math.random().toString(36).substring(3, 8);
  this.params = {};
  this.isShow = false;
  if (Object.prototype.toString.call(option) === '[object Object]') {
    this.params = {
      input: option.input || '',
      container: document.querySelector(option.input) || '',
      innerHTML: option.innerHTML || '',
      hideOnBlur: option.hideOnBlur,
      onOpen: option.onOpen || function () {},
      onClose: option.onClose || function () {}
    };
  }
  if (!!document.querySelectorAll('.vux-popup-mask').length <= 0) {
    this.divMask = document.createElement('a');
    this.divMask.className = 'vux-popup-mask';
    this.divMask.dataset.uuid = '';
    this.divMask.href = 'javascript:void(0)';
    document.body.appendChild(this.divMask);
  }
  var div = void 0;
  if (!option.container) {
    div = document.createElement('div');
  } else {
    div = option.container;
  }
  div.className = 'vux-popup-dialog vux-popup-dialog-' + this.uuid;

  if (!option.container) {
    document.body.appendChild(div);
  }
  this.container = document.querySelector('.vux-popup-dialog-' + this.uuid);
  this.mask = document.querySelector('.vux-popup-mask');
  this.mask.dataset.uuid += ',' + this.uuid;
  this._bindEvents();
  option = null;
  return this;
};

popupDialog.prototype.onClickMask = function () {
  if (this.params.hideOnBlur && this.isShow) {
    this.hide(false);
  }
};

popupDialog.prototype._bindEvents = function () {
  this.params.hideOnBlur && this.mask.addEventListener('click', this.onClickMask.bind(this), false);
};

popupDialog.prototype.show = function () {
  this.mask.classList.add('vux-popup-show');
  this.container.classList.add('vux-popup-show');
  this.params.onOpen && this.params.onOpen(this);
  this.isShow = true;
  window.__$vuxPopups[this.uuid] = 1;
};

popupDialog.prototype.hide = function () {
  var shouldCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  this.container.classList.remove('vux-popup-show');
  if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
    this.mask.classList.remove('vux-popup-show');
  }
  shouldCallback === false && this.params.onClose && this.params.hideOnBlur && this.params.onClose(this);
  this.isShow = false;
  delete window.__$vuxPopups[this.uuid];
};

popupDialog.prototype.html = function (html) {
  this.container.innerHTML = html;
};

popupDialog.prototype.destroy = function () {
  this.mask.dataset.uuid = this.mask.dataset.uuid.replace(new RegExp(',' + this.uuid, 'g'), '');
  if (!this.mask.dataset.uuid) {
    this.mask.removeEventListener('click', this.onClickMask.bind(this), false);
    this.mask && this.mask.parentNode && this.mask.parentNode.removeChild(this.mask);
  } else {
    this.hide();
  }
  delete window.__$vuxPopups[this.uuid];
};

exports.default = popupDialog;

/***/ }),

/***/ "erIo":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "vux-button-tab-item",
    class: _vm.classes,
    style: (_vm.style),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.onItemClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "evD5":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var toPrimitive = __webpack_require__("MmMw");
var dP = Object.defineProperty;

exports.f = __webpack_require__("+E39") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "exGp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "f/u1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _countup = __webpack_require__("EbL4");

var _countup2 = _interopRequireDefault(_countup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    this.startVal = this.value;
    this._countup = new _countup2.default(this.$el, this.startVal, this.endVal, this.decimals, this.duration, this.options);
    this._countup.start();
  },

  props: {
    value: {
      type: Number,
      default: 0
    },
    endVal: {
      type: Number,
      required: true
    },

    decimals: {
      type: Number,
      default: 0
    },

    duration: {
      type: Number,
      default: 2
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      startVal: 0
    };
  },

  watch: {
    value: function value(val) {
      this.startVal = val;
    },
    starValue: function starValue(val) {
      this.$emit('input', val);
    },
    endVal: function endVal(val) {
      this._countup.update(val);
    }
  }
};

/***/ }),

/***/ "f2/U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("5zA6");

exports.default = {
  mixins: [_multiItems.parentMixin],
  ready: function ready() {
    var _this = this;

    setTimeout(function () {
      _this.hasReady = true;
    }, 0);
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: {
      type: String,
      default: '#04be02'
    },
    defaultColor: {
      type: String,
      default: '#666'
    },
    disabledColor: {
      type: String,
      default: '#ddd'
    },
    animate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    barLeft: function barLeft() {
      return this.index * (100 / this.number) + '%';
    },
    barRight: function barRight() {
      return (this.number - this.index - 1) * (100 / this.number) + '%';
    },
    barStyle: function barStyle() {
      return {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        backgroundColor: this.activeColor,
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    }
  },
  watch: {
    index: function index(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  }
};

/***/ }),

/***/ "fDGX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var instances = [];
var matchers = [];

matchers.push(/^[0-9]*$/.source);

matchers.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);

matchers.push(/[0-9]{4}([/-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);

matchers = new RegExp(matchers.join('|'));


function parseDateString(dateString) {
  if (dateString instanceof Date) {
    return dateString;
  }

  if (String(dateString).match(matchers)) {
    if (String(dateString).match(/^[0-9]*$/)) {
      dateString = Number(dateString);
    }

    if (String(dateString).match(/-/)) {
      dateString = String(dateString).replace(/-/g, '/');
    }
    return new Date(dateString);
  } else {
    throw new Error('Couldn\'t cast `' + dateString + '` to a date object.');
  }
}

var DIRECTIVE_KEY_MAP = {
  'Y': 'years',
  'm': 'months',
  'w': 'weeks',
  'D': 'days',
  'H': 'hours',
  'M': 'minutes',
  'S': 'seconds'
};


function escapedRegExp(str) {
  var sanitize = str.toString().replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  return new RegExp(sanitize);
}


function strftime(offsetObject) {
  return function (format) {
    var directives = format.match(/%(-|!)?[A-Z]{1}(:[^]+)?/gi);
    if (directives) {
      for (var i = 0, len = directives.length; i < len; ++i) {
        var directive = directives[i].match(/%(-|!)?([a-zA-Z]{1})(:[^]+)?/);
        var regexp = escapedRegExp(directive[0]);
        var modifier = directive[1] || '';
        var plural = directive[3] || '';
        var value = null;

        directive = directive[2];

        if (DIRECTIVE_KEY_MAP.hasOwnProperty(directive)) {
          value = DIRECTIVE_KEY_MAP[directive];
          value = Number(offsetObject[value]);
        }
        if (value !== null) {
          if (modifier === '!') {
            value = pluralize(plural, value);
          }

          if (modifier === '') {
            if (value < 10) {
              value = '0' + value.toString();
            }
          }

          format = format.replace(regexp, value.toString());
        }
      }
    }
    format = format.replace('%_M1', offsetObject.minutes_1).replace('%_M2', offsetObject.minutes_2).replace('%_S1', offsetObject.seconds_1).replace('%_S2', offsetObject.seconds_2).replace('%_H1', offsetObject.hours_1).replace('%_H2', offsetObject.hours_2).replace('%_D1', offsetObject.days_1).replace('%_D2', offsetObject.days_2);
    format = format.replace(/%%/, '%');
    return format;
  };
}


function pluralize(format, count) {
  var plural = 's';
  var singular = '';
  if (format) {
    format = format.replace(/(:||\s)/gi, '').split(/,/);
    if (format.length === 1) {
      plural = format[0];
    } else {
      singular = format[0];
      plural = format[1];
    }
  }
  if (Math.abs(count) === 1) {
    return singular;
  } else {
    return plural;
  }
}

function splitNumber(number) {
  number = number + '';
  number = (number.length === 1 ? '0' + number : number) + '';
  return number.split('');
}

var Countdown = function Countdown(finalDate, option) {
  option = option || {};
  this.PRECISION = option.precision || 100;
  this.interval = null;
  this.offset = {};

  this.instanceNumber = instances.length;
  instances.push(this);

  this.setFinalDate(finalDate, option.sTime);
};
var Eventor = __webpack_require__("7OVk");
Eventor.mixTo(Countdown);
var pro = Countdown.prototype;

var fns = {
  start: function start() {
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
    var self = this;
    this.update();
    this.interval = setInterval(function () {
      self.update();
    }, this.PRECISION);
    return this;
  },
  stop: function stop() {
    clearInterval(this.interval);
    this.interval = null;
    this._dispatchEvent('stoped');
    return this;
  },
  toggle: function toggle() {
    if (this.interval) {
      this.stop();
    } else {
      this.start();
    }
    return this;
  },
  pause: function pause() {
    return this.stop();
  },
  resume: function resume() {
    return this.start();
  },
  remove: function remove() {
    this.stop();
    instances[this.instanceNumber] = null;
  },
  setFinalDate: function setFinalDate(fValue, sValue) {
    if (sValue) {
      this.finalDate = parseDateString(parseDateString(fValue).getTime() - parseDateString(sValue).getTime() + new Date().getTime());
    } else {
      this.finalDate = parseDateString(fValue);
    }
    return this;
  },
  getOffset: function getOffset() {
    this.totalSecsLeft = this.finalDate.getTime() - new Date().getTime();
    this.totalSecsLeft = Math.ceil(this.totalSecsLeft / 1000);
    this.totalSecsLeft = this.totalSecsLeft < 0 ? 0 : this.totalSecsLeft;

    return {
      seconds: this.totalSecsLeft % 60,
      minutes: Math.floor(this.totalSecsLeft / 60) % 60,
      hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
      days: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
      weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
      months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30),
      years: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 365)
    };
  },
  update: function update() {
    this.offset = this.getOffset();


    var list = ['days', 'hours', 'minutes', 'seconds'];

    for (var i = 0; i < list.length; i++) {
      var key = list[i];
      var numbers = splitNumber(this.offset[key]);
      this.offset[key + '_1'] = numbers[0];
      this.offset[key + '_2'] = numbers[1];
    }

    if (this.totalSecsLeft === 0) {
      this.stop();
      this._dispatchEvent('finish');
    } else {
      this._dispatchEvent('update');
    }
    return this;
  },
  _dispatchEvent: function _dispatchEvent(eventName) {
    var event = {};
    event.finalDate = this.finalDate;
    event.offset = this.offset;
    event.strftime = strftime(this.offset);
    this.emit(eventName, event);
    this.emit('tick', event);
  }
};

for (var i in fns) {
  pro[i] = fns[i];
}

module.exports = Countdown;

/***/ }),

/***/ "fDWL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyboard = __webpack_require__("igrb");

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_keyboard2.default.install = function (Vue) {
  Vue.component('LxKeyboard', _keyboard2.default);
};

exports.default = _keyboard2.default;

/***/ }),

/***/ "fJUb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var newPromiseCapability = __webpack_require__("qARP");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "fOQa":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-checker-item",
    class: _vm.classNames,
    on: {
      "click": _vm.select
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "fWfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("7KvD");
var has = __webpack_require__("D2L2");
var DESCRIPTORS = __webpack_require__("+E39");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var META = __webpack_require__("06OY").KEY;
var $fails = __webpack_require__("S82l");
var shared = __webpack_require__("e8AB");
var setToStringTag = __webpack_require__("e6n0");
var uid = __webpack_require__("3Eo+");
var wks = __webpack_require__("dSzd");
var wksExt = __webpack_require__("Kh4W");
var wksDefine = __webpack_require__("crlp");
var enumKeys = __webpack_require__("Xc4G");
var isArray = __webpack_require__("7UMu");
var anObject = __webpack_require__("77Pl");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var createDesc = __webpack_require__("X8DO");
var _create = __webpack_require__("Yobk");
var gOPNExt = __webpack_require__("Rrel");
var $GOPD = __webpack_require__("LKZe");
var $DP = __webpack_require__("evD5");
var $keys = __webpack_require__("lktj");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("n0T6").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("NpIQ").f = $propertyIsEnumerable;
  __webpack_require__("1kS7").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("O4g8")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("hJx8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "fZjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("jFbC"), __esModule: true };

/***/ }),

/***/ "fcAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: String
  },
  computed: {
    className: function className() {
      return "weui_icon weui_icon_" + this.type;
    }
  }
};

/***/ }),

/***/ "fcJk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  if (typeof input !== 'string') {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "fkB2":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "fsq/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      keyWord: '',
      roleNew: []
    };
  },

  props: {
    title: {
      type: String,
      default: '请先让行政经理把门店人员添加到系统中'
    },
    nameKey: {
      type: String,
      default: 'name'
    },
    roleKey: {
      type: String,
      default: 'roles'
    },
    roleList: {
      type: Array,
      default: [],
      required: true
    }
  },
  created: function created() {
    this.roleNew = this.roleList;
  },

  watch: {
    roleList: function roleList(val) {
      this.roleNew = val;
    }
  },
  methods: {
    inputSearch: function inputSearch() {
      if (this.keyWord === '') {
        this.roleNew = this.roleList;
      }
    },
    valueSearch: function valueSearch() {
      var _this = this;

      var value = this.keyWord;
      if (value) {
        this.roleNew = this.roleList.filter(function (v) {
          return v[_this.nameKey].indexOf(value) > -1;
        });
      }
    },
    checkItem: function checkItem(item, index) {
      this.roleList.forEach(function (v) {
        v.ischecked = false;
      });
      item.ischecked = true;
      this.$emit('check-item', item);
    }
  }
};

/***/ }),

/***/ "fxRn":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+tPU");
__webpack_require__("zQR9");
module.exports = __webpack_require__("g8Ux");


/***/ }),

/***/ "fzln":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe Default UI - 4.1.2 - 2017-04-05
* http://photoswipe.com
* Copyright (c) 2017 Dmitry Semenov; */
/**
*
* UI on top of main sliding area (caption, arrows, close button, etc.).
* Built just using public methods/properties of PhotoSwipe.
* 
*/
(function (root, factory) { 
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		root.PhotoSwipeUI_Default = factory();
	}
})(this, function () {

	'use strict';



var PhotoSwipeUI_Default =
 function(pswp, framework) {

	var ui = this;
	var _overlayUIUpdated = false,
		_controlsVisible = true,
		_fullscrenAPI,
		_controls,
		_captionContainer,
		_fakeCaptionContainer,
		_indexIndicator,
		_shareButton,
		_shareModal,
		_shareModalHidden = true,
		_initalCloseOnScrollValue,
		_isIdle,
		_listen,

		_loadingIndicator,
		_loadingIndicatorHidden,
		_loadingIndicatorTimeout,

		_galleryHasOneSlide,

		_options,
		_defaultUIOptions = {
			barsSize: {top:44, bottom:'auto'},
			closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'], 
			timeToIdle: 4000, 
			timeToIdleOutside: 1000,
			loadingIndicatorDelay: 1000, // 2s
			
			addCaptionHTMLFn: function(item, captionEl /*, isFake */) {
				if(!item.title) {
					captionEl.children[0].innerHTML = '';
					return false;
				}
				captionEl.children[0].innerHTML = item.title;
				return true;
			},

			closeEl:true,
			captionEl: true,
			fullscreenEl: true,
			zoomEl: true,
			shareEl: true,
			counterEl: true,
			arrowEl: true,
			preloaderEl: true,

			tapToClose: false,
			tapToToggleControls: true,

			clickToCloseNonZoomable: true,

			shareButtons: [
				{id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/sharer/sharer.php?u={{url}}'},
				{id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'},
				{id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/'+
													'?url={{url}}&media={{image_url}}&description={{text}}'},
				{id:'download', label:'Download image', url:'{{raw_image_url}}', download:true}
			],
			getImageURLForShare: function( /* shareButtonData */ ) {
				return pswp.currItem.src || '';
			},
			getPageURLForShare: function( /* shareButtonData */ ) {
				return window.location.href;
			},
			getTextForShare: function( /* shareButtonData */ ) {
				return pswp.currItem.title || '';
			},
				
			indexIndicatorSep: ' / ',
			fitControlsWidth: 1200

		},
		_blockControlsTap,
		_blockControlsTapTimeout;



	var _onControlsTap = function(e) {
			if(_blockControlsTap) {
				return true;
			}


			e = e || window.event;

			if(_options.timeToIdle && _options.mouseUsed && !_isIdle) {
				// reset idle timer
				_onIdleMouseMove();
			}


			var target = e.target || e.srcElement,
				uiElement,
				clickedClass = target.getAttribute('class') || '',
				found;

			for(var i = 0; i < _uiElements.length; i++) {
				uiElement = _uiElements[i];
				if(uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name ) > -1 ) {
					uiElement.onTap();
					found = true;

				}
			}

			if(found) {
				if(e.stopPropagation) {
					e.stopPropagation();
				}
				_blockControlsTap = true;

				// Some versions of Android don't prevent ghost click event 
				// when preventDefault() was called on touchstart and/or touchend.
				// 
				// This happens on v4.3, 4.2, 4.1, 
				// older versions strangely work correctly, 
				// but just in case we add delay on all of them)	
				var tapDelay = framework.features.isOldAndroid ? 600 : 30;
				_blockControlsTapTimeout = setTimeout(function() {
					_blockControlsTap = false;
				}, tapDelay);
			}

		},
		_fitControlsInViewport = function() {
			return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
		},
		_togglePswpClass = function(el, cName, add) {
			framework[ (add ? 'add' : 'remove') + 'Class' ](el, 'pswp__' + cName);
		},

		// add class when there is just one item in the gallery
		// (by default it hides left/right arrows and 1ofX counter)
		_countNumItems = function() {
			var hasOneSlide = (_options.getNumItemsFn() === 1);

			if(hasOneSlide !== _galleryHasOneSlide) {
				_togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
				_galleryHasOneSlide = hasOneSlide;
			}
		},
		_toggleShareModalClass = function() {
			_togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
		},
		_toggleShareModal = function() {

			_shareModalHidden = !_shareModalHidden;
			
			
			if(!_shareModalHidden) {
				_toggleShareModalClass();
				setTimeout(function() {
					if(!_shareModalHidden) {
						framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
					}
				}, 30);
			} else {
				framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
				setTimeout(function() {
					if(_shareModalHidden) {
						_toggleShareModalClass();
					}
				}, 300);
			}
			
			if(!_shareModalHidden) {
				_updateShareURLs();
			}
			return false;
		},

		_openWindowPopup = function(e) {
			e = e || window.event;
			var target = e.target || e.srcElement;

			pswp.shout('shareLinkClick', e, target);

			if(!target.href) {
				return false;
			}

			if( target.hasAttribute('download') ) {
				return true;
			}

			window.open(target.href, 'pswp_share', 'scrollbars=yes,resizable=yes,toolbar=no,'+
										'location=yes,width=550,height=420,top=100,left=' + 
										(window.screen ? Math.round(screen.width / 2 - 275) : 100)  );

			if(!_shareModalHidden) {
				_toggleShareModal();
			}
			
			return false;
		},
		_updateShareURLs = function() {
			var shareButtonOut = '',
				shareButtonData,
				shareURL,
				image_url,
				page_url,
				share_text;

			for(var i = 0; i < _options.shareButtons.length; i++) {
				shareButtonData = _options.shareButtons[i];

				image_url = _options.getImageURLForShare(shareButtonData);
				page_url = _options.getPageURLForShare(shareButtonData);
				share_text = _options.getTextForShare(shareButtonData);

				shareURL = shareButtonData.url.replace('{{url}}', encodeURIComponent(page_url) )
									.replace('{{image_url}}', encodeURIComponent(image_url) )
									.replace('{{raw_image_url}}', image_url )
									.replace('{{text}}', encodeURIComponent(share_text) );

				shareButtonOut += '<a href="' + shareURL + '" target="_blank" '+
									'class="pswp__share--' + shareButtonData.id + '"' +
									(shareButtonData.download ? 'download' : '') + '>' + 
									shareButtonData.label + '</a>';

				if(_options.parseShareButtonOut) {
					shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
				}
			}
			_shareModal.children[0].innerHTML = shareButtonOut;
			_shareModal.children[0].onclick = _openWindowPopup;

		},
		_hasCloseClass = function(target) {
			for(var  i = 0; i < _options.closeElClasses.length; i++) {
				if( framework.hasClass(target, 'pswp__' + _options.closeElClasses[i]) ) {
					return true;
				}
			}
		},
		_idleInterval,
		_idleTimer,
		_idleIncrement = 0,
		_onIdleMouseMove = function() {
			clearTimeout(_idleTimer);
			_idleIncrement = 0;
			if(_isIdle) {
				ui.setIdle(false);
			}
		},
		_onMouseLeaveWindow = function(e) {
			e = e ? e : window.event;
			var from = e.relatedTarget || e.toElement;
			if (!from || from.nodeName === 'HTML') {
				clearTimeout(_idleTimer);
				_idleTimer = setTimeout(function() {
					ui.setIdle(true);
				}, _options.timeToIdleOutside);
			}
		},
		_setupFullscreenAPI = function() {
			if(_options.fullscreenEl && !framework.features.isOldAndroid) {
				if(!_fullscrenAPI) {
					_fullscrenAPI = ui.getFullscreenAPI();
				}
				if(_fullscrenAPI) {
					framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
					ui.updateFullscreen();
					framework.addClass(pswp.template, 'pswp--supports-fs');
				} else {
					framework.removeClass(pswp.template, 'pswp--supports-fs');
				}
			}
		},
		_setupLoadingIndicator = function() {
			// Setup loading indicator
			if(_options.preloaderEl) {
			
				_toggleLoadingIndicator(true);

				_listen('beforeChange', function() {

					clearTimeout(_loadingIndicatorTimeout);

					// display loading indicator with delay
					_loadingIndicatorTimeout = setTimeout(function() {

						if(pswp.currItem && pswp.currItem.loading) {

							if( !pswp.allowProgressiveImg() || (pswp.currItem.img && !pswp.currItem.img.naturalWidth)  ) {
								// show preloader if progressive loading is not enabled, 
								// or image width is not defined yet (because of slow connection)
								_toggleLoadingIndicator(false); 
								// items-controller.js function allowProgressiveImg
							}
							
						} else {
							_toggleLoadingIndicator(true); // hide preloader
						}

					}, _options.loadingIndicatorDelay);
					
				});
				_listen('imageLoadComplete', function(index, item) {
					if(pswp.currItem === item) {
						_toggleLoadingIndicator(true);
					}
				});

			}
		},
		_toggleLoadingIndicator = function(hide) {
			if( _loadingIndicatorHidden !== hide ) {
				_togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
				_loadingIndicatorHidden = hide;
			}
		},
		_applyNavBarGaps = function(item) {
			var gap = item.vGap;

			if( _fitControlsInViewport() ) {
				
				var bars = _options.barsSize; 
				if(_options.captionEl && bars.bottom === 'auto') {
					if(!_fakeCaptionContainer) {
						_fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
						_fakeCaptionContainer.appendChild( framework.createEl('pswp__caption__center') );
						_controls.insertBefore(_fakeCaptionContainer, _captionContainer);
						framework.addClass(_controls, 'pswp__ui--fit');
					}
					if( _options.addCaptionHTMLFn(item, _fakeCaptionContainer, true) ) {

						var captionSize = _fakeCaptionContainer.clientHeight;
						gap.bottom = parseInt(captionSize,10) || 44;
					} else {
						gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
					}
				} else {
					gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
				}
				
				// height of top bar is static, no need to calculate it
				gap.top = bars.top;
			} else {
				gap.top = gap.bottom = 0;
			}
		},
		_setupIdle = function() {
			// Hide controls when mouse is used
			if(_options.timeToIdle) {
				_listen('mouseUsed', function() {
					
					framework.bind(document, 'mousemove', _onIdleMouseMove);
					framework.bind(document, 'mouseout', _onMouseLeaveWindow);

					_idleInterval = setInterval(function() {
						_idleIncrement++;
						if(_idleIncrement === 2) {
							ui.setIdle(true);
						}
					}, _options.timeToIdle / 2);
				});
			}
		},
		_setupHidingControlsDuringGestures = function() {

			// Hide controls on vertical drag
			_listen('onVerticalDrag', function(now) {
				if(_controlsVisible && now < 0.95) {
					ui.hideControls();
				} else if(!_controlsVisible && now >= 0.95) {
					ui.showControls();
				}
			});

			// Hide controls when pinching to close
			var pinchControlsHidden;
			_listen('onPinchClose' , function(now) {
				if(_controlsVisible && now < 0.9) {
					ui.hideControls();
					pinchControlsHidden = true;
				} else if(pinchControlsHidden && !_controlsVisible && now > 0.9) {
					ui.showControls();
				}
			});

			_listen('zoomGestureEnded', function() {
				pinchControlsHidden = false;
				if(pinchControlsHidden && !_controlsVisible) {
					ui.showControls();
				}
			});

		};



	var _uiElements = [
		{ 
			name: 'caption', 
			option: 'captionEl',
			onInit: function(el) {  
				_captionContainer = el; 
			} 
		},
		{ 
			name: 'share-modal', 
			option: 'shareEl',
			onInit: function(el) {  
				_shareModal = el;
			},
			onTap: function() {
				_toggleShareModal();
			} 
		},
		{ 
			name: 'button--share', 
			option: 'shareEl',
			onInit: function(el) { 
				_shareButton = el;
			},
			onTap: function() {
				_toggleShareModal();
			} 
		},
		{ 
			name: 'button--zoom', 
			option: 'zoomEl',
			onTap: pswp.toggleDesktopZoom
		},
		{ 
			name: 'counter', 
			option: 'counterEl',
			onInit: function(el) {  
				_indexIndicator = el;
			} 
		},
		{ 
			name: 'button--close', 
			option: 'closeEl',
			onTap: pswp.close
		},
		{ 
			name: 'button--arrow--left', 
			option: 'arrowEl',
			onTap: pswp.prev
		},
		{ 
			name: 'button--arrow--right', 
			option: 'arrowEl',
			onTap: pswp.next
		},
		{ 
			name: 'button--fs', 
			option: 'fullscreenEl',
			onTap: function() {  
				if(_fullscrenAPI.isFullscreen()) {
					_fullscrenAPI.exit();
				} else {
					_fullscrenAPI.enter();
				}
			} 
		},
		{ 
			name: 'preloader', 
			option: 'preloaderEl',
			onInit: function(el) {  
				_loadingIndicator = el;
			} 
		}

	];

	var _setupUIElements = function() {
		var item,
			classAttr,
			uiElement;

		var loopThroughChildElements = function(sChildren) {
			if(!sChildren) {
				return;
			}

			var l = sChildren.length;
			for(var i = 0; i < l; i++) {
				item = sChildren[i];
				classAttr = item.className;

				for(var a = 0; a < _uiElements.length; a++) {
					uiElement = _uiElements[a];

					if(classAttr.indexOf('pswp__' + uiElement.name) > -1  ) {

						if( _options[uiElement.option] ) { // if element is not disabled from options
							
							framework.removeClass(item, 'pswp__element--disabled');
							if(uiElement.onInit) {
								uiElement.onInit(item);
							}
							
							//item.style.display = 'block';
						} else {
							framework.addClass(item, 'pswp__element--disabled');
							//item.style.display = 'none';
						}
					}
				}
			}
		};
		loopThroughChildElements(_controls.children);

		var topBar =  framework.getChildByClass(_controls, 'pswp__top-bar');
		if(topBar) {
			loopThroughChildElements( topBar.children );
		}
	};


	

	ui.init = function() {

		// extend options
		framework.extend(pswp.options, _defaultUIOptions, true);

		// create local link for fast access
		_options = pswp.options;

		// find pswp__ui element
		_controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');

		// create local link
		_listen = pswp.listen;


		_setupHidingControlsDuringGestures();

		// update controls when slides change
		_listen('beforeChange', ui.update);

		// toggle zoom on double-tap
		_listen('doubleTap', function(point) {
			var initialZoomLevel = pswp.currItem.initialZoomLevel;
			if(pswp.getZoomLevel() !== initialZoomLevel) {
				pswp.zoomTo(initialZoomLevel, point, 333);
			} else {
				pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
			}
		});

		// Allow text selection in caption
		_listen('preventDragEvent', function(e, isDown, preventObj) {
			var t = e.target || e.srcElement;
			if(
				t && 
				t.getAttribute('class') && e.type.indexOf('mouse') > -1 && 
				( t.getAttribute('class').indexOf('__caption') > 0 || (/(SMALL|STRONG|EM)/i).test(t.tagName) ) 
			) {
				preventObj.prevent = false;
			}
		});

		// bind events for UI
		_listen('bindEvents', function() {
			framework.bind(_controls, 'pswpTap click', _onControlsTap);
			framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);

			if(!pswp.likelyTouchDevice) {
				framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
			}
		});

		// unbind events for UI
		_listen('unbindEvents', function() {
			if(!_shareModalHidden) {
				_toggleShareModal();
			}

			if(_idleInterval) {
				clearInterval(_idleInterval);
			}
			framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
			framework.unbind(document, 'mousemove', _onIdleMouseMove);
			framework.unbind(_controls, 'pswpTap click', _onControlsTap);
			framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
			framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);

			if(_fullscrenAPI) {
				framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
				if(_fullscrenAPI.isFullscreen()) {
					_options.hideAnimationDuration = 0;
					_fullscrenAPI.exit();
				}
				_fullscrenAPI = null;
			}
		});


		// clean up things when gallery is destroyed
		_listen('destroy', function() {
			if(_options.captionEl) {
				if(_fakeCaptionContainer) {
					_controls.removeChild(_fakeCaptionContainer);
				}
				framework.removeClass(_captionContainer, 'pswp__caption--empty');
			}

			if(_shareModal) {
				_shareModal.children[0].onclick = null;
			}
			framework.removeClass(_controls, 'pswp__ui--over-close');
			framework.addClass( _controls, 'pswp__ui--hidden');
			ui.setIdle(false);
		});
		

		if(!_options.showAnimationDuration) {
			framework.removeClass( _controls, 'pswp__ui--hidden');
		}
		_listen('initialZoomIn', function() {
			if(_options.showAnimationDuration) {
				framework.removeClass( _controls, 'pswp__ui--hidden');
			}
		});
		_listen('initialZoomOut', function() {
			framework.addClass( _controls, 'pswp__ui--hidden');
		});

		_listen('parseVerticalMargin', _applyNavBarGaps);
		
		_setupUIElements();

		if(_options.shareEl && _shareButton && _shareModal) {
			_shareModalHidden = true;
		}

		_countNumItems();

		_setupIdle();

		_setupFullscreenAPI();

		_setupLoadingIndicator();
	};

	ui.setIdle = function(isIdle) {
		_isIdle = isIdle;
		_togglePswpClass(_controls, 'ui--idle', isIdle);
	};

	ui.update = function() {
		// Don't update UI if it's hidden
		if(_controlsVisible && pswp.currItem) {
			
			ui.updateIndexIndicator();

			if(_options.captionEl) {
				_options.addCaptionHTMLFn(pswp.currItem, _captionContainer);

				_togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
			}

			_overlayUIUpdated = true;

		} else {
			_overlayUIUpdated = false;
		}

		if(!_shareModalHidden) {
			_toggleShareModal();
		}

		_countNumItems();
	};

	ui.updateFullscreen = function(e) {

		if(e) {
			// some browsers change window scroll position during the fullscreen
			// so PhotoSwipe updates it just in case
			setTimeout(function() {
				pswp.setScrollOffset( 0, framework.getScrollY() );
			}, 50);
		}
		
		// toogle pswp--fs class on root element
		framework[ (_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class' ](pswp.template, 'pswp--fs');
	};

	ui.updateIndexIndicator = function() {
		if(_options.counterEl) {
			_indexIndicator.innerHTML = (pswp.getCurrentIndex()+1) + 
										_options.indexIndicatorSep + 
										_options.getNumItemsFn();
		}
	};
	
	ui.onGlobalTap = function(e) {
		e = e || window.event;
		var target = e.target || e.srcElement;

		if(_blockControlsTap) {
			return;
		}

		if(e.detail && e.detail.pointerType === 'mouse') {

			// close gallery if clicked outside of the image
			if(_hasCloseClass(target)) {
				pswp.close();
				return;
			}

			if(framework.hasClass(target, 'pswp__img')) {
				if(pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
					if(_options.clickToCloseNonZoomable) {
						pswp.close();
					}
				} else {
					pswp.toggleDesktopZoom(e.detail.releasePoint);
				}
			}
			
		} else {

			// tap anywhere (except buttons) to toggle visibility of controls
			if(_options.tapToToggleControls) {
				if(_controlsVisible) {
					ui.hideControls();
				} else {
					ui.showControls();
				}
			}

			// tap to close gallery
			if(_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target)) ) {
				pswp.close();
				return;
			}
			
		}
	};
	ui.onMouseOver = function(e) {
		e = e || window.event;
		var target = e.target || e.srcElement;

		// add class when mouse is over an element that should close the gallery
		_togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
	};

	ui.hideControls = function() {
		framework.addClass(_controls,'pswp__ui--hidden');
		_controlsVisible = false;
	};

	ui.showControls = function() {
		_controlsVisible = true;
		if(!_overlayUIUpdated) {
			ui.update();
		}
		framework.removeClass(_controls,'pswp__ui--hidden');
	};

	ui.supportsFullscreen = function() {
		var d = document;
		return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
	};

	ui.getFullscreenAPI = function() {
		var dE = document.documentElement,
			api,
			tF = 'fullscreenchange';

		if (dE.requestFullscreen) {
			api = {
				enterK: 'requestFullscreen',
				exitK: 'exitFullscreen',
				elementK: 'fullscreenElement',
				eventK: tF
			};

		} else if(dE.mozRequestFullScreen ) {
			api = {
				enterK: 'mozRequestFullScreen',
				exitK: 'mozCancelFullScreen',
				elementK: 'mozFullScreenElement',
				eventK: 'moz' + tF
			};

			

		} else if(dE.webkitRequestFullscreen) {
			api = {
				enterK: 'webkitRequestFullscreen',
				exitK: 'webkitExitFullscreen',
				elementK: 'webkitFullscreenElement',
				eventK: 'webkit' + tF
			};

		} else if(dE.msRequestFullscreen) {
			api = {
				enterK: 'msRequestFullscreen',
				exitK: 'msExitFullscreen',
				elementK: 'msFullscreenElement',
				eventK: 'MSFullscreenChange'
			};
		}

		if(api) {
			api.enter = function() { 
				// disable close-on-scroll in fullscreen
				_initalCloseOnScrollValue = _options.closeOnScroll; 
				_options.closeOnScroll = false; 

				if(this.enterK === 'webkitRequestFullscreen') {
					pswp.template[this.enterK]( Element.ALLOW_KEYBOARD_INPUT );
				} else {
					return pswp.template[this.enterK](); 
				}
			};
			api.exit = function() { 
				_options.closeOnScroll = _initalCloseOnScrollValue;

				return document[this.exitK](); 

			};
			api.isFullscreen = function() { return document[this.elementK]; };
		}

		return api;
	};



};
return PhotoSwipeUI_Default;


});


/***/ }),

/***/ "g2NE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3");
var Base = __webpack_require__("5dD5");
//transform
var transform = Util.prefixStyle("transform");
// default render function for position:sticky elements
var defaultStickyRenderFunc = function(e) {
  var stickyElement = e.stickyElement;
  var curStickyElement = e.curStickyElement;
  var xscroll = e.xscroll;
  var _ = e._;
  var infinite = xscroll.getPlugin("infinite");
  if (infinite) {
    infinite.userConfig.renderHook.call(self, stickyElement, curStickyElement);
    stickyElement.setAttribute("xs-guid", curStickyElement.guid);
    Util.addClass(stickyElement, curStickyElement.className);
    for (var attrName in curStickyElement.style) {
      if (attrName != "display" && attrName != "position") {
        //copy styles
        stickyElement.style[attrName] = attrName == _.height ? curStickyElement.style[attrName] + 'px' : curStickyElement.style[attrName];
      }
    }
  } else {
    var style = curStickyElement.getAttribute("style");
    stickyElement.innerHTML = curStickyElement.innerHTML;
    stickyElement.className = curStickyElement.className;
    style && stickyElement.setAttribute("style", style);
  }
}

var Sticky = function(cfg) {
  Sticky.superclass.constructor.call(this, cfg);
  this.userConfig = Util.mix({
    stickyRenderTo: undefined,
    forceSticky: true,
    prefix: "xs-sticky-container",
    stickyRenderFunc: defaultStickyRenderFunc,
    zoomType: "y"
  }, cfg);
  this.init();
}

Util.extend(Sticky, Base, {
  init: function() {
    var self = this,
      userConfig = self.userConfig,
      xscroll = self.xscroll = userConfig.xscroll;
    var isY = self.isY = !!(userConfig.zoomType == "y");
    self._ = {
      top: self.isY ? "top" : "left",
      left: self.isY ? "left" : "bottom",
      right: self.isY ? "right" : "top",
      height: self.isY ? "height" : "width",
      width: self.isY ? "width" : "height"
    };
    self.stickyRenderTo = Util.getNode(userConfig.stickyRenderTo);
    self._handlers = [];
    return self;
  },
  getStickiesPos: function() {
    var self = this;
    var xscroll = self.xscroll;
    var isInfinite = self.isInfinite;
    var isY = self.isY;
    var _ = self._;
    var stickiesPos = [];
    var getPos = function(sticky) {
      var pos = {};
      if (isInfinite) {
        pos[_.top] = isY ? sticky._top : sticky._left;
        pos[_.height] = isY ? sticky._height : sticky._width;
      } else {
        pos[_.top] = self.isY ? Util.getOffsetTop(sticky) : Util.getOffsetLeft(sticky);
        pos[_.height] = self.isY ? sticky.offsetHeight : sticky.offsetWidth;
      }
      return pos;
    }
    for (var i = 0; i < self.stickiesNum; i++) {
      var pos = getPos(self.stickyElements[i]);
      self._handlers[i] = self._handlers[i] || self.createStickyEl();
      pos.el = self._handlers[i];
      pos.isRender = false;
      stickiesPos.push(pos);
    }
    return stickiesPos
  },
  getStickyElements: function() {
    var self = this;
    var xscroll = self.xscroll;
    var userConfig = self.userConfig;
    var isInfinite = self.isInfinite;
    var infinite = xscroll.getPlugin("infinite");
    if (infinite) {
      var stickyElements = [],
        serializedData = infinite.__serializedData;
      for (var i in serializedData) {
        var rowData = serializedData[i];
        if (rowData && rowData.style && "sticky" == rowData.style.position) {
          stickyElements.push(rowData);
        }
      }
      return stickyElements;
    } else {
      return Util.getNodes(xscroll.userConfig.stickyElements, xscroll.content);
    }
  },
  render: function(force) {
    var self = this;
    var userConfig = self.userConfig;
    var xscroll = self.xscroll;
    self.isInfinite = !!xscroll.getPlugin("infinite");
    var _ = self._;
    self.stickyElements = self.getStickyElements();
    self.stickiesNum = self.stickyElements && self.stickyElements.length;
    if (!self.stickiesNum) return;
    if (!self.stickyRenderTo) {
      self.stickyRenderTo = document.createElement('div');
      xscroll.renderTo.appendChild(self.stickyRenderTo);
    }
    self.stickiesPos = self.getStickiesPos();
    var stickyRenderTo = self.stickyRenderTo;
    stickyRenderTo.style[_.top] = 0;
    stickyRenderTo.style[_.left] = 0;
    stickyRenderTo.style[_.right] = 0;
    stickyRenderTo.style.position = xscroll.userConfig.useOriginScroll ? "fixed" : "absolute";
    Util.addClass(self.stickyRenderTo, userConfig.prefix);
    self.stickyHandler(force);
    self._bindEvt();
  },
  createStickyEl: function() {
    var self = this;
    var el = document.createElement('div');
    el.style.display = "none";
    Util.addClass(el, "xs-sticky-handler");
    self.stickyRenderTo.appendChild(el);
    return el;
  },
  _bindEvt: function() {
    var self = this,
      xscroll = self.xscroll;
    xscroll.on("scroll", self.stickyHandler, self);
  },
  stickyHandler: function(force) {
    var self = this;
    var xscroll = self.xscroll;
    var userConfig = self.userConfig;
    var scrollTop = self.isY ? xscroll.getScrollTop() : xscroll.getScrollLeft();
    var stickiesPos = self.stickiesPos;
    var _ = self._;
    var indexes = [];
    for (var i = 0, l = stickiesPos.length; i < l; i++) {
      var top = stickiesPos[i][_.top];
      if (scrollTop > top) {
        indexes.push(i);
      }
    }
    if (!indexes.length) {
      if (self.stickyElement) {
        self.stickyElement.style.display = "none";
      }
      self.curStickyIndex = undefined;
      return;
    }

    var curStickyIndex = Math.max.apply(null, indexes);
    if (self.curStickyIndex != curStickyIndex || force) {
      var prevStickyIndex = self.curStickyIndex;
      self.curStickyIndex = curStickyIndex;
      self.curStickyElement = self.stickyElements[curStickyIndex];
      self.curStickyPos = stickiesPos[curStickyIndex];
      self.stickyElement = self.curStickyPos.el;
      for (var i = 0, l = stickiesPos.length; i < l; i++) {
        stickiesPos[i].el.style.display = "none";
      }
      var eventsObj = {
        stickyElement: self.stickyElement,
        curStickyIndex: self.curStickyIndex,
        prevStickyIndex: prevStickyIndex,
        curStickyPos: self.curStickyPos,
        isRender: self.curStickyPos.isRender
      };
      xscroll.trigger("beforestickychange", eventsObj);
      self._stickyRenderFunc(self);
      xscroll.trigger("stickychange", eventsObj);
    }

    var trans = 0;
    if (self.stickiesPos[self.curStickyIndex + 1]) {
      var cur = self.stickiesPos[self.curStickyIndex];
      var next = self.stickiesPos[self.curStickyIndex + 1];
      if (scrollTop + cur[_.height] > next[_.top] && scrollTop + cur[_.height] < next[_.top] + cur[_.height]) {
        trans = cur[_.height] + scrollTop - next[_.top];
      } else {
        trans = 0;
      }
    }
    self.stickyElement.style[transform] = self.isY ? "translateY(-" + (trans) + "px) translateZ(0)" : "translateX(-" + (trans) + "px) translateZ(0)";
  },
  _stickyRenderFunc: function(e) {
    var self = this;
    var _ = self._;
    var stickyRenderFunc = self.userConfig.stickyRenderFunc;
    var el = self.curStickyPos.el;
    if (!self.curStickyPos.isRender) {
      el.style[_.left] = 0;
      el.style[_.right] = 0;
      stickyRenderFunc && stickyRenderFunc.call(self, e);
    }
    el.style.display = "block";
    self.curStickyPos.isRender = true;
  },
  destroy: function() {
    var self = this;
    self.stickyElements = undefined;
    self.stickiesNum = undefined;
    self.stickiesPos = undefined;
    Util.remove(self.stickyElement);
    self.stickyElement = undefined;
  }
});

if (typeof module == 'object' && module.exports) {
  module.exports = Sticky;
}


/***/ }),

/***/ "g4ZZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shake = __webpack_require__("oKbp");

var _shake2 = _interopRequireDefault(_shake);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_shake2.default.install = function (Vue) {
  Vue.component('LxShake', _shake2.default);
};

exports.default = _shake2.default;

/***/ }),

/***/ "g8Ux":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var get = __webpack_require__("3fs2");
module.exports = __webpack_require__("FeBl").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "gF0p":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("vjwT"),
  /* template */
  __webpack_require__("GPhx"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "gh4x":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_tabbar{display:-webkit-flex;display:flex;position:absolute;z-index:100;bottom:0;width:100%;background-color:#f7f7fa}.weui_tabbar:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #979797;color:#979797;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_tabbar_item{display:block;-webkit-flex:1;flex:1;padding:.18666667rem 0 0;-webkit-tap-highlight-color:transparent}.weui_tabbar_item.weui_bar_item_on .weui_tabbar_label{color:#09bb07}.weui_tabbar_icon{margin:0 auto;width:.64rem;height:.64rem}.weui_tabbar_icon img{display:block;width:100%;height:100%}.weui_tabbar_icon+.weui_tabbar_label{margin-top:.13333333rem}.weui_tabbar_label{text-align:center;color:#000;font-size:.32rem}.weui_tab{position:relative;height:100%}.weui_tab_bd{box-sizing:border-box;height:100%;padding-bottom:1.46666667rem;overflow:auto;-webkit-overflow-scrolling:touch;font-size:.34666667rem}.weui_tab_bd_item{display:none}.weui_tab_bd_item_active{display:block}.vux-badge{display:inline-block;text-align:center;background:#f74c31;color:#fff;font-size:.32rem;height:.48rem;line-height:.50666667rem;border-radius:.21333333rem;padding:0 .16rem;background-clip:padding-box}.vux-badge-single{padding:0;width:.42666667rem}", ""]);

// exports


/***/ }),

/***/ "gjhP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3");
var Animate = __webpack_require__("W0DV");
var MAX_BOUNCE_DISTANCE = 40;
var MIN_BAR_SCROLLED_SIZE = 10;
var MIN_BAR_SIZE = 50;
var transform = Util.prefixStyle("transform");
var transformStr = Util.vendor ? ["-", Util.vendor, "-transform"].join("") : "transform";
var transition = Util.prefixStyle("transition");
var borderRadius = Util.prefixStyle("borderRadius");
var transitionDuration = Util.prefixStyle("transitionDuration");

var ScrollBar = function(cfg) {
	this.userConfig = Util.mix({
		MIN_BAR_SCROLLED_SIZE:MIN_BAR_SCROLLED_SIZE,
		MIN_BAR_SIZE:MIN_BAR_SIZE,
		MAX_BOUNCE_DISTANCE:MAX_BOUNCE_DISTANCE,
		spacing:5
	}, cfg);
	this.init(cfg.xscroll);
}

Util.mix(ScrollBar.prototype, {
	init: function(xscroll) {
		var self = this;
		self.xscroll = xscroll;
		self.type = self.userConfig.type;
		self.isY = self.type == "y" ? true : false;
		self.scrollTopOrLeft = self.isY ? "scrollTop" : "scrollLeft";
	},
	destroy: function() {
		var self = this;
		Util.remove(self.scrollbar);
		self.xscroll.off("scroll", self._scrollHandler, self);
		self.xscroll.off("scrollend", self._scrollEndHandler, self);
	},
	render: function() {
		var self = this;
		var xscroll = self.xscroll;
		var boundry = xscroll.boundry;
		var indicatorInsets = self.xscroll.userConfig.indicatorInsets;
		var translateZ = xscroll.userConfig.gpuAcceleration ? " translateZ(0) " : "";
		var transform = translateZ ? transformStr + ":" + translateZ + ";" : "";
		var commonCss = "opacity:0;position:absolute;z-index:999;overflow:hidden;-webkit-border-radius:3px;-moz-border-radius:3px;-o-border-radius:3px;" + transform;
		indicatorInsets._xright =  indicatorInsets.right + indicatorInsets.spacing;
		indicatorInsets._xbottom =  indicatorInsets.bottom + indicatorInsets.spacing;
		var css = self.isY ?
			Util.substitute("width:{width}px;bottom:{_xbottom}px;top:{top}px;right:{right}px;", indicatorInsets) + commonCss :
			Util.substitute("height:{width}px;left:{left}px;right:{_xright}px;bottom:{bottom}px;",indicatorInsets) + commonCss;
		

		if(!self.scrollbar){
			self.scrollbar = document.createElement("div");	
			self.indicate = document.createElement("div");
			xscroll.renderTo.appendChild(self.scrollbar);
			self.scrollbar.appendChild(self.indicate);
		}
		self.scrollbar.style.cssText = css;
		var size = self.isY ? "width:100%;" : "height:100%;";
		self.indicate.style.cssText = size + "position:absolute;background:rgba(0,0,0,0.3);-webkit-border-radius:3px;-moz-border-radius:3px;-o-border-radius:3px;"
		self._update();
		self.hide(0);
		self._bindEvt();
	},
	_update: function(pos, duration, easing, callback) {
		var self = this;
		var pos = undefined === pos ? (self.isY ? self.xscroll.getScrollTop() : self.xscroll.getScrollLeft()) : pos;
		var barInfo = self.computeScrollBar(pos);
		var size = self.isY ? "height" : "width";
		self.indicate.style[size] = Math.round(barInfo.size) + "px";
		if (duration && easing) {
			self.scrollTo(barInfo.pos, duration, easing, callback);
		} else {
			self.moveTo(barInfo.pos);
		}
	},
	//compute the position and size of the scrollbar
	computeScrollBar: function(pos) {
		var self = this;
		var type = self.isY ? "y" : "x";
		var spacing = self.userConfig.spacing;
		var xscroll = self.xscroll;
		var boundry = xscroll.boundry;
		var userConfig = self.userConfig;
		var pos = self.isY ? Math.round(pos) + boundry._xtop : Math.round(pos) + boundry._xleft;
		var MIN_BAR_SCROLLED_SIZE = userConfig.MIN_BAR_SCROLLED_SIZE;
		var MIN_BAR_SIZE = userConfig.MIN_BAR_SIZE;
		var MAX_BOUNCE_DISTANCE = userConfig.MAX_BOUNCE_DISTANCE;
		self.containerSize = self.isY ? xscroll.containerHeight + boundry._xtop + boundry._xbottom : self.xscroll.containerWidth + boundry._xright + boundry._xleft;
		self.size = self.isY ? boundry.cfg.height : boundry.cfg.width;
		self.indicateSize = self.isY ? boundry.cfg.height - spacing * 2 : boundry.cfg.width - spacing * 2;
		var indicateSize = self.indicateSize;
		var containerSize = self.containerSize;
		var barPos = indicateSize * pos / containerSize;
		var barSize = Math.round(indicateSize * self.size / containerSize);
		var overTop = self.isY ? xscroll.getBoundryOutTop() : xscroll.getBoundryOutLeft();
		var overBottom = self.isY ? xscroll.getBoundryOutBottom() : xscroll.getBoundryOutRight();
		var barShiftSize = MIN_BAR_SIZE - barSize > 0 ? MIN_BAR_SIZE - barSize : 0;
		barSize = barSize < MIN_BAR_SIZE ? MIN_BAR_SIZE : barSize;
		barPos = (indicateSize - barShiftSize) * pos / containerSize;
		if (overTop >= 0) {
			var pct = overTop / MAX_BOUNCE_DISTANCE;
			pct = pct > 1 ? 1 : pct;
			barPos = - pct * (barSize -  MIN_BAR_SCROLLED_SIZE)
		}
		if (overBottom >= 0) {
			var pct = overBottom / MAX_BOUNCE_DISTANCE;
			pct = pct > 1 ? 1 : pct;
			barPos = pct * (barSize - MIN_BAR_SCROLLED_SIZE) + indicateSize - barSize; 
		}
		self.barPos = Math.round(barPos);
		return {
			size: Math.round(barSize),
			pos: self.barPos
		};
	},
	scrollTo: function(pos, duration, easing, callback) {
		var self = this;
		self.show();
		var translateZ = self.xscroll.userConfig.gpuAcceleration ? " translateZ(0) " : "";
		var config = {
			css: {
				transform: self.isY ? "translateY(" + pos + "px)" + translateZ : "translateX(" + pos + "px)" + translateZ
			},
			duration: duration,
			easing: easing,
			useTransition: self.xscroll.userConfig.useTransition,
			end: callback
		};
		self.__timer = self.__timer || new Animate(self.indicate, config);
		//run
		self.__timer.stop();
		self.__timer.reset(config);
		self.__timer.run();
	},
	moveTo: function(pos) {
		var self = this;
		self.show();
		var translateZ = self.xscroll.userConfig.gpuAcceleration ? " translateZ(0) " : "";
		self.isY ? self.indicate.style[transform] = "translateY(" + pos + "px) " + translateZ : self.indicate.style[transform] = "translateX(" + pos + "px) " + translateZ
		self.indicate.style[transition] = "";
	},
	_scrollHandler: function(e) {
		var self = this;
		self._update(e[self.scrollTopOrLeft]);
		return self;
	},
	isBoundryOut: function() {
		var self = this;
		return !self.isY ? (self.xscroll.isBoundryOutLeft() || self.xscroll.isBoundryOutRight()) : (self.xscroll.isBoundryOutTop() || self.xscroll.isBoundryOutBottom());
	},
	_scrollEndHandler: function(e) {
		var self = this;
		if (!self.isBoundryOut()) {
			self._update(e[self.scrollTopOrLeft]);
			self.hide();
		}
		return self;
	},
	_bindEvt: function() {
		var self = this;
		if (self.__isEvtBind) return;
		self.__isEvtBind = true;
		self.xscroll.on("scroll", self._scrollHandler, self);
		self.xscroll.on("scrollend", self._scrollEndHandler, self);
	},
	reset: function() {
		var self = this;
		self.pos = 0;
		self._update();
	},
	hide: function(duration, easing, delay) {
		var self = this;
		var duration = duration >= 0 ? duration : 300;
		var easing = easing || "ease-out";
		var delay = delay >= 0 ? delay : 100;
		self.scrollbar.style.opacity = 0;
		self.scrollbar.style[transition] = ["opacity ", duration, "ms ", " ease-out ", delay, "ms"].join("");
	},
	show: function() {
		var self = this;
		self.scrollbar.style.opacity = 1;
		self.scrollbar.style[transition] = "";
	}
});

if (typeof module == 'object' && module.exports) {
	module.exports = ScrollBar;
}


/***/ }),

/***/ "gtsc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("RGVm");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("fdddb1f6", content, true);

/***/ }),

/***/ "h/xf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _xscroll = __webpack_require__("sZYo");

var _xscroll2 = _interopRequireDefault(_xscroll);

var _pulldown = __webpack_require__("vfpP");

var _pulldown2 = _interopRequireDefault(_pulldown);

var _pullup = __webpack_require__("uTsL");

var _pullup2 = _interopRequireDefault(_pullup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

exports.default = {
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: 'enabled'
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: true
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },

    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    scrollTo: function scrollTo(scrollLeft, scrollTop, duration, easing, callback) {
      if (this._xscroll) {
        this._xscroll.scrollTo(scrollLeft, scrollTop, duration, easing, callback);
      }
    },
    getScroll: function getScroll() {
      return this._xscroll;
    },
    reset: function reset(scrollPosition) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll && this._xscroll.scrollLeft(scrollPosition.left);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll && this._xscroll.scrollTop(scrollPosition.top);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup(time) {
      var _this2 = this;

      if (time) {
        this.timer = setTimeout(function () {
          _this2.pullup.complete();
          _this2.currentValue.pullupStatus = 'default';
          _this2.reset();
        }, time);
      } else {
        this.pullup.complete();
        this.currentValue.pullupStatus = 'default';
        this.reset();
      }
    }
  },
  computed: {
    styles: function styles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        var clientHeight = document.documentElement.clientHeight;
        var scale = clientHeight / 667;
        var h1 = parseInt(this.height);
        height = clientHeight + parseInt(h1 * scale) + 'px';
      }
      return {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this3 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: 'enabled'
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      _this3.reset();
    };
  },
  data: function data() {
    return {
      timer: null,
      currentValue: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this4.$el.setAttribute('id', 'vux-scroller-' + _this4.uuid);
      var content = null;
      if (_this4.$slots.default) {
        content = _this4.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }
      _this4._xscroll = new _xscroll2.default({
        renderTo: '#vux-scroller-' + _this4.uuid,
        lockX: _this4.lockX,
        lockY: _this4.lockY,
        scrollbarX: _this4.scrollbarX,
        scrollbarY: _this4.scrollbarY,
        content: content,
        bounce: _this4.bounce,
        useOriginScroll: _this4.useOriginScroll,
        useTransition: _this4.useTransition,
        preventDefault: _this4.preventDefault,
        boundryCheck: _this4.boundryCheck,
        gpuAcceleration: _this4.gpuAcceleration,
        stopPropagation: _this4.stopPropagation
      });

      if (_this4.usePulldown) {
        var container = _this4.$slots.pulldown;
        var config = (0, _objectAssign2.default)(pulldownDefaultConfig(), _this4.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this4.pulldown = new _pulldown2.default(config);
        _this4._xscroll.plug(_this4.pulldown);
        _this4.pulldown.on('loading', function (e) {
          _this4.$emit('on-pulldown-loading', _this4.uuid);
        });
        _this4.pulldown.on('statuschange', function (val) {
          _this4.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this4.usePullup) {
        var _container = _this4.$slots.pullup;
        var _config = (0, _objectAssign2.default)(pullupDefaultConfig(), _this4.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this4.pullup = new _pullup2.default(_config);
        _this4._xscroll.plug(_this4.pullup);
        _this4.pullup.on('loading', function (e) {
          _this4.$emit('on-pullup-loading', _this4.donePullup, _this4.uuid);
        });
        _this4.pullup.on('statuschange', function (val) {
          _this4.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this4.enableHorizontalSwiping) {
        _this4._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this4.scrollbarY) {
              _this4._xscroll.userConfig.scrollbarY = false;
            }
            _this4._xscroll.userConfig.lockY = true;
          }
        });
        _this4._xscroll.on('panend', function () {
          if (_this4.scrollbarY) {
            _this4._xscroll.userConfig.scrollbarY = true;
          }
          _this4._xscroll.userConfig.lockY = false;
        });
      }
      _this4._xscroll.on('panend', function (e) {
        _this4.$emit('on-scroll-end', e);
      });
      _this4._xscroll.on('panstart', function (e) {
        _this4.$emit('on-scroll-start', e);
      });
      _this4._xscroll.render();
      window.addEventListener('orientationchange', _this4.handleOrientationchange, false);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
    clearTimeout(this.timer);
  }
};


function pure(obj) {
  return JSON.parse((0, _stringify2.default)(obj));
}

/***/ }),

/***/ "h06R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _icon = __webpack_require__("6O5g");

var _icon2 = _interopRequireDefault(_icon);

var _datetimepicker = __webpack_require__("b0Xt");

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _group = __webpack_require__("LRgB");

var _group2 = _interopRequireDefault(_group);

var _inlineDesc = __webpack_require__("hc1C");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _base = __webpack_require__("T131");

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_base2.default],
  components: {
    Group: _group2.default,
    InlineDesc: _inlineDesc2.default,
    Icon: _icon2.default
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: {
      type: String,
      default: 'ok'
    },
    cancelText: {
      type: String,
      default: 'cancel'
    },
    clearText: {
      type: String,
      default: ''
    },
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: String,
    endDate: String,
    valueTextAlign: String
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$nextTick(function () {
      _this2.$el.setAttribute('id', 'vux-datetime-' + uuid);
      _this2.render();
    });
  },

  computed: {
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: this.confirmText,
        cancelText: _this.cancelText,
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide() {
          _this.validate();
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = (0, _keys2.default)(this.errors)[0];
      return this.errors[key];
    }
  },
  methods: {
    render: function render() {
      if (this.picker) {
        this.picker.destroy();
      }
      this.picker = new _datetimepicker2.default(this.pickerOptions);
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = this.title + '必填';
      } else {
        this.valid = true;
        this.errors = {};
      }
      this.$emit('on-vali', this.errors, this.valid, this.uuid);
    }
  },
  created: function created() {
    this.currentValue = this.value;
    this.handleChangeEvent = true;
  },
  data: function data() {
    return {
      currentValue: null,
      valid: true,
      errors: {}
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      if (this.value !== val) {
        this.$emit('on-change', val);
      }
      this.$emit('input', val);
      this.validate();
    },
    value: function value(val) {
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.picker && this.picker.destroy();
        this.render();
      }
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
};

/***/ }),

/***/ "h65t":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var defined = __webpack_require__("52gC");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "h6KC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js_plugins_vue__ = __webpack_require__("6fN7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raven_js_plugins_vue__);


/**
 * 前端上报接口
 */



var Report = function () {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Report, null, [{
    key: 'install',
    value: function install() {}
  }]);

  function Report(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Report);

    // 本地开发环境和测试环境不上报
    if (options.config.environment === 'production') {
      return __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.config(options.DNS, options.config).addPlugin(__WEBPACK_IMPORTED_MODULE_3_raven_js_plugins_vue___default.a, Vue).install();
    } else {
      return null;
    }
  }

  return Report;
}();

/* harmony default export */ __webpack_exports__["a"] = (Report);


function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      if (options.report) {
        this.$report = options.report;
      } else if (options.parent && options.parent.$report) {
        this.$report = options.parent.$report;
      }
    }
  });
}

Report.install = install;
Report.version = '__VERSION__';

/***/ }),

/***/ "hDb/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
};

/***/ }),

/***/ "hJx8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");
module.exports = __webpack_require__("+E39") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "hKtO":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.showTimeString) ? _c('span', [_vm._v(_vm._s(_vm.timeString))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vux-clocker-tpl"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "hLg7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe - v4.1.2 - 2017-04-05
* http://photoswipe.com
* Copyright (c) 2017 Dmitry Semenov; */
(function (root, factory) { 
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		root.PhotoSwipe = factory();
	}
})(this, function () {

	'use strict';
	var PhotoSwipe = function(template, UiClass, items, options){

/*>>framework-bridge*/
/**
 *
 * Set of generic functions used by gallery.
 * 
 * You're free to modify anything here as long as functionality is kept.
 * 
 */
var framework = {
	features: null,
	bind: function(target, type, listener, unbind) {
		var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
		type = type.split(' ');
		for(var i = 0; i < type.length; i++) {
			if(type[i]) {
				target[methodName]( type[i], listener, false);
			}
		}
	},
	isArray: function(obj) {
		return (obj instanceof Array);
	},
	createEl: function(classes, tag) {
		var el = document.createElement(tag || 'div');
		if(classes) {
			el.className = classes;
		}
		return el;
	},
	getScrollY: function() {
		var yOffset = window.pageYOffset;
		return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
	},
	unbind: function(target, type, listener) {
		framework.bind(target,type,listener,true);
	},
	removeClass: function(el, className) {
		var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
		el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, ''); 
	},
	addClass: function(el, className) {
		if( !framework.hasClass(el,className) ) {
			el.className += (el.className ? ' ' : '') + className;
		}
	},
	hasClass: function(el, className) {
		return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
	},
	getChildByClass: function(parentEl, childClassName) {
		var node = parentEl.firstChild;
		while(node) {
			if( framework.hasClass(node, childClassName) ) {
				return node;
			}
			node = node.nextSibling;
		}
	},
	arraySearch: function(array, value, key) {
		var i = array.length;
		while(i--) {
			if(array[i][key] === value) {
				return i;
			} 
		}
		return -1;
	},
	extend: function(o1, o2, preventOverwrite) {
		for (var prop in o2) {
			if (o2.hasOwnProperty(prop)) {
				if(preventOverwrite && o1.hasOwnProperty(prop)) {
					continue;
				}
				o1[prop] = o2[prop];
			}
		}
	},
	easing: {
		sine: {
			out: function(k) {
				return Math.sin(k * (Math.PI / 2));
			},
			inOut: function(k) {
				return - (Math.cos(Math.PI * k) - 1) / 2;
			}
		},
		cubic: {
			out: function(k) {
				return --k * k * k + 1;
			}
		}
		/*
			elastic: {
				out: function ( k ) {

					var s, a = 0.1, p = 0.4;
					if ( k === 0 ) return 0;
					if ( k === 1 ) return 1;
					if ( !a || a < 1 ) { a = 1; s = p / 4; }
					else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
					return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );

				},
			},
			back: {
				out: function ( k ) {
					var s = 1.70158;
					return --k * k * ( ( s + 1 ) * k + s ) + 1;
				}
			}
		*/
	},

	/**
	 * 
	 * @return {object}
	 * 
	 * {
	 *  raf : request animation frame function
	 *  caf : cancel animation frame function
	 *  transfrom : transform property key (with vendor), or null if not supported
	 *  oldIE : IE8 or below
	 * }
	 * 
	 */
	detectFeatures: function() {
		if(framework.features) {
			return framework.features;
		}
		var helperEl = framework.createEl(),
			helperStyle = helperEl.style,
			vendor = '',
			features = {};

		// IE8 and below
		features.oldIE = document.all && !document.addEventListener;

		features.touch = 'ontouchstart' in window;

		if(window.requestAnimationFrame) {
			features.raf = window.requestAnimationFrame;
			features.caf = window.cancelAnimationFrame;
		}

		features.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled;

		// fix false-positive detection of old Android in new IE
		// (IE11 ua string contains "Android 4.0")
		
		if(!features.pointerEvent) { 

			var ua = navigator.userAgent;

			// Detect if device is iPhone or iPod and if it's older than iOS 8
			// http://stackoverflow.com/a/14223920
			// 
			// This detection is made because of buggy top/bottom toolbars
			// that don't trigger window.resize event.
			// For more info refer to _isFixedPosition variable in core.js

			if (/iP(hone|od)/.test(navigator.platform)) {
				var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
				if(v && v.length > 0) {
					v = parseInt(v[1], 10);
					if(v >= 1 && v < 8 ) {
						features.isOldIOSPhone = true;
					}
				}
			}

			// Detect old Android (before KitKat)
			// due to bugs related to position:fixed
			// http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
			
			var match = ua.match(/Android\s([0-9\.]*)/);
			var androidversion =  match ? match[1] : 0;
			androidversion = parseFloat(androidversion);
			if(androidversion >= 1 ) {
				if(androidversion < 4.4) {
					features.isOldAndroid = true; // for fixed position bug & performance
				}
				features.androidVersion = androidversion; // for touchend bug
			}	
			features.isMobileOpera = /opera mini|opera mobi/i.test(ua);

			// p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
		}
		
		var styleChecks = ['transform', 'perspective', 'animationName'],
			vendors = ['', 'webkit','Moz','ms','O'],
			styleCheckItem,
			styleName;

		for(var i = 0; i < 4; i++) {
			vendor = vendors[i];

			for(var a = 0; a < 3; a++) {
				styleCheckItem = styleChecks[a];

				// uppercase first letter of property name, if vendor is present
				styleName = vendor + (vendor ? 
										styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : 
										styleCheckItem);
			
				if(!features[styleCheckItem] && styleName in helperStyle ) {
					features[styleCheckItem] = styleName;
				}
			}

			if(vendor && !features.raf) {
				vendor = vendor.toLowerCase();
				features.raf = window[vendor+'RequestAnimationFrame'];
				if(features.raf) {
					features.caf = window[vendor+'CancelAnimationFrame'] || 
									window[vendor+'CancelRequestAnimationFrame'];
				}
			}
		}
			
		if(!features.raf) {
			var lastTime = 0;
			features.raf = function(fn) {
				var currTime = new Date().getTime();
				var timeToCall = Math.max(0, 16 - (currTime - lastTime));
				var id = window.setTimeout(function() { fn(currTime + timeToCall); }, timeToCall);
				lastTime = currTime + timeToCall;
				return id;
			};
			features.caf = function(id) { clearTimeout(id); };
		}

		// Detect SVG support
		features.svg = !!document.createElementNS && 
						!!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;

		framework.features = features;

		return features;
	}
};

framework.detectFeatures();

// Override addEventListener for old versions of IE
if(framework.features.oldIE) {

	framework.bind = function(target, type, listener, unbind) {
		
		type = type.split(' ');

		var methodName = (unbind ? 'detach' : 'attach') + 'Event',
			evName,
			_handleEv = function() {
				listener.handleEvent.call(listener);
			};

		for(var i = 0; i < type.length; i++) {
			evName = type[i];
			if(evName) {

				if(typeof listener === 'object' && listener.handleEvent) {
					if(!unbind) {
						listener['oldIE' + evName] = _handleEv;
					} else {
						if(!listener['oldIE' + evName]) {
							return false;
						}
					}

					target[methodName]( 'on' + evName, listener['oldIE' + evName]);
				} else {
					target[methodName]( 'on' + evName, listener);
				}

			}
		}
	};
	
}

/*>>framework-bridge*/

/*>>core*/
//function(template, UiClass, items, options)

var self = this;

/**
 * Static vars, don't change unless you know what you're doing.
 */
var DOUBLE_TAP_RADIUS = 25, 
	NUM_HOLDERS = 3;

/**
 * Options
 */
var _options = {
	allowPanToNext:true,
	spacing: 0.12,
	bgOpacity: 1,
	mouseUsed: false,
	loop: true,
	pinchToClose: true,
	closeOnScroll: true,
	closeOnVerticalDrag: true,
	verticalDragRange: 0.75,
	hideAnimationDuration: 333,
	showAnimationDuration: 333,
	showHideOpacity: false,
	focus: true,
	escKey: true,
	arrowKeys: true,
	mainScrollEndFriction: 0.35,
	panEndFriction: 0.35,
	isClickableElement: function(el) {
        return el.tagName === 'A';
    },
    getDoubleTapZoom: function(isMouseClick, item) {
    	if(isMouseClick) {
    		return 1;
    	} else {
    		return item.initialZoomLevel < 0.7 ? 1 : 1.33;
    	}
    },
    maxSpreadZoom: 1.33,
	modal: true,

	// not fully implemented yet
	scaleMode: 'fit' // TODO
};
framework.extend(_options, options);


/**
 * Private helper variables & functions
 */

var _getEmptyPoint = function() { 
		return {x:0,y:0}; 
	};

var _isOpen,
	_isDestroying,
	_closedByScroll,
	_currentItemIndex,
	_containerStyle,
	_containerShiftIndex,
	_currPanDist = _getEmptyPoint(),
	_startPanOffset = _getEmptyPoint(),
	_panOffset = _getEmptyPoint(),
	_upMoveEvents, // drag move, drag end & drag cancel events array
	_downEvents, // drag start events array
	_globalEventHandlers,
	_viewportSize = {},
	_currZoomLevel,
	_startZoomLevel,
	_translatePrefix,
	_translateSufix,
	_updateSizeInterval,
	_itemsNeedUpdate,
	_currPositionIndex = 0,
	_offset = {},
	_slideSize = _getEmptyPoint(), // size of slide area, including spacing
	_itemHolders,
	_prevItemIndex,
	_indexDiff = 0, // difference of indexes since last content update
	_dragStartEvent,
	_dragMoveEvent,
	_dragEndEvent,
	_dragCancelEvent,
	_transformKey,
	_pointerEventEnabled,
	_isFixedPosition = true,
	_likelyTouchDevice,
	_modules = [],
	_requestAF,
	_cancelAF,
	_initalClassName,
	_initalWindowScrollY,
	_oldIE,
	_currentWindowScrollY,
	_features,
	_windowVisibleSize = {},
	_renderMaxResolution = false,
	_orientationChangeTimeout,


	// Registers PhotoSWipe module (History, Controller ...)
	_registerModule = function(name, module) {
		framework.extend(self, module.publicMethods);
		_modules.push(name);
	},

	_getLoopedId = function(index) {
		var numSlides = _getNumItems();
		if(index > numSlides - 1) {
			return index - numSlides;
		} else  if(index < 0) {
			return numSlides + index;
		}
		return index;
	},
	
	// Micro bind/trigger
	_listeners = {},
	_listen = function(name, fn) {
		if(!_listeners[name]) {
			_listeners[name] = [];
		}
		return _listeners[name].push(fn);
	},
	_shout = function(name) {
		var listeners = _listeners[name];

		if(listeners) {
			var args = Array.prototype.slice.call(arguments);
			args.shift();

			for(var i = 0; i < listeners.length; i++) {
				listeners[i].apply(self, args);
			}
		}
	},

	_getCurrentTime = function() {
		return new Date().getTime();
	},
	_applyBgOpacity = function(opacity) {
		_bgOpacity = opacity;
		self.bg.style.opacity = opacity * _options.bgOpacity;
	},

	_applyZoomTransform = function(styleObj,x,y,zoom,item) {
		if(!_renderMaxResolution || (item && item !== self.currItem) ) {
			zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);	
		}
			
		styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
	},
	_applyCurrentZoomPan = function( allowRenderResolution ) {
		if(_currZoomElementStyle) {

			if(allowRenderResolution) {
				if(_currZoomLevel > self.currItem.fitRatio) {
					if(!_renderMaxResolution) {
						_setImageSize(self.currItem, false, true);
						_renderMaxResolution = true;
					}
				} else {
					if(_renderMaxResolution) {
						_setImageSize(self.currItem);
						_renderMaxResolution = false;
					}
				}
			}
			

			_applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
		}
	},
	_applyZoomPanToItem = function(item) {
		if(item.container) {

			_applyZoomTransform(item.container.style, 
								item.initialPosition.x, 
								item.initialPosition.y, 
								item.initialZoomLevel,
								item);
		}
	},
	_setTranslateX = function(x, elStyle) {
		elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
	},
	_moveMainScroll = function(x, dragging) {

		if(!_options.loop && dragging) {
			var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
				delta = Math.round(x - _mainScrollPos.x);

			if( (newSlideIndexOffset < 0 && delta > 0) || 
				(newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) ) {
				x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
			} 
		}
		
		_mainScrollPos.x = x;
		_setTranslateX(x, _containerStyle);
	},
	_calculatePanOffset = function(axis, zoomLevel) {
		var m = _midZoomPoint[axis] - _offset[axis];
		return _startPanOffset[axis] + _currPanDist[axis] + m - m * ( zoomLevel / _startZoomLevel );
	},
	
	_equalizePoints = function(p1, p2) {
		p1.x = p2.x;
		p1.y = p2.y;
		if(p2.id) {
			p1.id = p2.id;
		}
	},
	_roundPoint = function(p) {
		p.x = Math.round(p.x);
		p.y = Math.round(p.y);
	},

	_mouseMoveTimeout = null,
	_onFirstMouseMove = function() {
		// Wait until mouse move event is fired at least twice during 100ms
		// We do this, because some mobile browsers trigger it on touchstart
		if(_mouseMoveTimeout ) { 
			framework.unbind(document, 'mousemove', _onFirstMouseMove);
			framework.addClass(template, 'pswp--has_mouse');
			_options.mouseUsed = true;
			_shout('mouseUsed');
		}
		_mouseMoveTimeout = setTimeout(function() {
			_mouseMoveTimeout = null;
		}, 100);
	},

	_bindEvents = function() {
		framework.bind(document, 'keydown', self);

		if(_features.transform) {
			// don't bind click event in browsers that don't support transform (mostly IE8)
			framework.bind(self.scrollWrap, 'click', self);
		}
		

		if(!_options.mouseUsed) {
			framework.bind(document, 'mousemove', _onFirstMouseMove);
		}

		framework.bind(window, 'resize scroll orientationchange', self);

		_shout('bindEvents');
	},

	_unbindEvents = function() {
		framework.unbind(window, 'resize scroll orientationchange', self);
		framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
		framework.unbind(document, 'keydown', self);
		framework.unbind(document, 'mousemove', _onFirstMouseMove);

		if(_features.transform) {
			framework.unbind(self.scrollWrap, 'click', self);
		}

		if(_isDragging) {
			framework.unbind(window, _upMoveEvents, self);
		}

		clearTimeout(_orientationChangeTimeout);

		_shout('unbindEvents');
	},
	
	_calculatePanBounds = function(zoomLevel, update) {
		var bounds = _calculateItemSize( self.currItem, _viewportSize, zoomLevel );
		if(update) {
			_currPanBounds = bounds;
		}
		return bounds;
	},
	
	_getMinZoomLevel = function(item) {
		if(!item) {
			item = self.currItem;
		}
		return item.initialZoomLevel;
	},
	_getMaxZoomLevel = function(item) {
		if(!item) {
			item = self.currItem;
		}
		return item.w > 0 ? _options.maxSpreadZoom : 1;
	},

	// Return true if offset is out of the bounds
	_modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
		if(destZoomLevel === self.currItem.initialZoomLevel) {
			destPanOffset[axis] = self.currItem.initialPosition[axis];
			return true;
		} else {
			destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel); 

			if(destPanOffset[axis] > destPanBounds.min[axis]) {
				destPanOffset[axis] = destPanBounds.min[axis];
				return true;
			} else if(destPanOffset[axis] < destPanBounds.max[axis] ) {
				destPanOffset[axis] = destPanBounds.max[axis];
				return true;
			}
		}
		return false;
	},

	_setupTransforms = function() {

		if(_transformKey) {
			// setup 3d transforms
			var allow3dTransform = _features.perspective && !_likelyTouchDevice;
			_translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
			_translateSufix = _features.perspective ? ', 0px)' : ')';	
			return;
		}

		// Override zoom/pan/move functions in case old browser is used (most likely IE)
		// (so they use left/top/width/height, instead of CSS transform)
	
		_transformKey = 'left';
		framework.addClass(template, 'pswp--ie');

		_setTranslateX = function(x, elStyle) {
			elStyle.left = x + 'px';
		};
		_applyZoomPanToItem = function(item) {

			var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
				s = item.container.style,
				w = zoomRatio * item.w,
				h = zoomRatio * item.h;

			s.width = w + 'px';
			s.height = h + 'px';
			s.left = item.initialPosition.x + 'px';
			s.top = item.initialPosition.y + 'px';

		};
		_applyCurrentZoomPan = function() {
			if(_currZoomElementStyle) {

				var s = _currZoomElementStyle,
					item = self.currItem,
					zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
					w = zoomRatio * item.w,
					h = zoomRatio * item.h;

				s.width = w + 'px';
				s.height = h + 'px';


				s.left = _panOffset.x + 'px';
				s.top = _panOffset.y + 'px';
			}
			
		};
	},

	_onKeyDown = function(e) {
		var keydownAction = '';
		if(_options.escKey && e.keyCode === 27) { 
			keydownAction = 'close';
		} else if(_options.arrowKeys) {
			if(e.keyCode === 37) {
				keydownAction = 'prev';
			} else if(e.keyCode === 39) { 
				keydownAction = 'next';
			}
		}

		if(keydownAction) {
			// don't do anything if special key pressed to prevent from overriding default browser actions
			// e.g. in Chrome on Mac cmd+arrow-left returns to previous page
			if( !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey ) {
				if(e.preventDefault) {
					e.preventDefault();
				} else {
					e.returnValue = false;
				} 
				self[keydownAction]();
			}
		}
	},

	_onGlobalClick = function(e) {
		if(!e) {
			return;
		}

		// don't allow click event to pass through when triggering after drag or some other gesture
		if(_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
			e.preventDefault();
			e.stopPropagation();
		}
	},

	_updatePageScrollOffset = function() {
		self.setScrollOffset(0, framework.getScrollY());		
	};
	


	



// Micro animation engine
var _animations = {},
	_numAnimations = 0,
	_stopAnimation = function(name) {
		if(_animations[name]) {
			if(_animations[name].raf) {
				_cancelAF( _animations[name].raf );
			}
			_numAnimations--;
			delete _animations[name];
		}
	},
	_registerStartAnimation = function(name) {
		if(_animations[name]) {
			_stopAnimation(name);
		}
		if(!_animations[name]) {
			_numAnimations++;
			_animations[name] = {};
		}
	},
	_stopAllAnimations = function() {
		for (var prop in _animations) {

			if( _animations.hasOwnProperty( prop ) ) {
				_stopAnimation(prop);
			} 
			
		}
	},
	_animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
		var startAnimTime = _getCurrentTime(), t;
		_registerStartAnimation(name);

		var animloop = function(){
			if ( _animations[name] ) {
				
				t = _getCurrentTime() - startAnimTime; // time diff
				//b - beginning (start prop)
				//d - anim duration

				if ( t >= d ) {
					_stopAnimation(name);
					onUpdate(endProp);
					if(onComplete) {
						onComplete();
					}
					return;
				}
				onUpdate( (endProp - b) * easingFn(t/d) + b );

				_animations[name].raf = _requestAF(animloop);
			}
		};
		animloop();
	};
	


var publicMethods = {

	// make a few local variables and functions public
	shout: _shout,
	listen: _listen,
	viewportSize: _viewportSize,
	options: _options,

	isMainScrollAnimating: function() {
		return _mainScrollAnimating;
	},
	getZoomLevel: function() {
		return _currZoomLevel;
	},
	getCurrentIndex: function() {
		return _currentItemIndex;
	},
	isDragging: function() {
		return _isDragging;
	},	
	isZooming: function() {
		return _isZooming;
	},
	setScrollOffset: function(x,y) {
		_offset.x = x;
		_currentWindowScrollY = _offset.y = y;
		_shout('updateScrollOffset', _offset);
	},
	applyZoomPan: function(zoomLevel,panX,panY,allowRenderResolution) {
		_panOffset.x = panX;
		_panOffset.y = panY;
		_currZoomLevel = zoomLevel;
		_applyCurrentZoomPan( allowRenderResolution );
	},

	init: function() {

		if(_isOpen || _isDestroying) {
			return;
		}

		var i;

		self.framework = framework; // basic functionality
		self.template = template; // root DOM element of PhotoSwipe
		self.bg = framework.getChildByClass(template, 'pswp__bg');

		_initalClassName = template.className;
		_isOpen = true;
				
		_features = framework.detectFeatures();
		_requestAF = _features.raf;
		_cancelAF = _features.caf;
		_transformKey = _features.transform;
		_oldIE = _features.oldIE;
		
		self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
		self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');

		_containerStyle = self.container.style; // for fast access

		// Objects that hold slides (there are only 3 in DOM)
		self.itemHolders = _itemHolders = [
			{el:self.container.children[0] , wrap:0, index: -1},
			{el:self.container.children[1] , wrap:0, index: -1},
			{el:self.container.children[2] , wrap:0, index: -1}
		];

		// hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
		_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';

		_setupTransforms();

		// Setup global events
		_globalEventHandlers = {
			resize: self.updateSize,

			// Fixes: iOS 10.3 resize event
			// does not update scrollWrap.clientWidth instantly after resize
			// https://github.com/dimsemenov/PhotoSwipe/issues/1315
			orientationchange: function() {
				clearTimeout(_orientationChangeTimeout);
				_orientationChangeTimeout = setTimeout(function() {
					if(_viewportSize.x !== self.scrollWrap.clientWidth) {
						self.updateSize();
					}
				}, 500);
			},
			scroll: _updatePageScrollOffset,
			keydown: _onKeyDown,
			click: _onGlobalClick
		};

		// disable show/hide effects on old browsers that don't support CSS animations or transforms, 
		// old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
		var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
		if(!_features.animationName || !_features.transform || oldPhone) {
			_options.showAnimationDuration = _options.hideAnimationDuration = 0;
		}

		// init modules
		for(i = 0; i < _modules.length; i++) {
			self['init' + _modules[i]]();
		}
		
		// init
		if(UiClass) {
			var ui = self.ui = new UiClass(self, framework);
			ui.init();
		}

		_shout('firstUpdate');
		_currentItemIndex = _currentItemIndex || _options.index || 0;
		// validate index
		if( isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems() ) {
			_currentItemIndex = 0;
		}
		self.currItem = _getItemAt( _currentItemIndex );

		
		if(_features.isOldIOSPhone || _features.isOldAndroid) {
			_isFixedPosition = false;
		}
		
		template.setAttribute('aria-hidden', 'false');
		if(_options.modal) {
			if(!_isFixedPosition) {
				template.style.position = 'absolute';
				template.style.top = framework.getScrollY() + 'px';
			} else {
				template.style.position = 'fixed';
			}
		}

		if(_currentWindowScrollY === undefined) {
			_shout('initialLayout');
			_currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
		}
		
		// add classes to root element of PhotoSwipe
		var rootClasses = 'pswp--open ';
		if(_options.mainClass) {
			rootClasses += _options.mainClass + ' ';
		}
		if(_options.showHideOpacity) {
			rootClasses += 'pswp--animate_opacity ';
		}
		rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
		rootClasses += _features.animationName ? ' pswp--css_animation' : '';
		rootClasses += _features.svg ? ' pswp--svg' : '';
		framework.addClass(template, rootClasses);

		self.updateSize();

		// initial update
		_containerShiftIndex = -1;
		_indexDiff = null;
		for(i = 0; i < NUM_HOLDERS; i++) {
			_setTranslateX( (i+_containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
		}

		if(!_oldIE) {
			framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
		}	

		_listen('initialZoomInEnd', function() {
			self.setContent(_itemHolders[0], _currentItemIndex-1);
			self.setContent(_itemHolders[2], _currentItemIndex+1);

			_itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';

			if(_options.focus) {
				// focus causes layout, 
				// which causes lag during the animation, 
				// that's why we delay it untill the initial zoom transition ends
				template.focus();
			}
			 

			_bindEvents();
		});

		// set content for center slide (first time)
		self.setContent(_itemHolders[1], _currentItemIndex);
		
		self.updateCurrItem();

		_shout('afterInit');

		if(!_isFixedPosition) {

			// On all versions of iOS lower than 8.0, we check size of viewport every second.
			// 
			// This is done to detect when Safari top & bottom bars appear, 
			// as this action doesn't trigger any events (like resize). 
			// 
			// On iOS8 they fixed this.
			// 
			// 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.
			
			_updateSizeInterval = setInterval(function() {
				if(!_numAnimations && !_isDragging && !_isZooming && (_currZoomLevel === self.currItem.initialZoomLevel)  ) {
					self.updateSize();
				}
			}, 1000);
		}

		framework.addClass(template, 'pswp--visible');
	},

	// Close the gallery, then destroy it
	close: function() {
		if(!_isOpen) {
			return;
		}

		_isOpen = false;
		_isDestroying = true;
		_shout('close');
		_unbindEvents();

		_showOrHide(self.currItem, null, true, self.destroy);
	},

	// destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
	destroy: function() {
		_shout('destroy');

		if(_showOrHideTimeout) {
			clearTimeout(_showOrHideTimeout);
		}
		
		template.setAttribute('aria-hidden', 'true');
		template.className = _initalClassName;

		if(_updateSizeInterval) {
			clearInterval(_updateSizeInterval);
		}

		framework.unbind(self.scrollWrap, _downEvents, self);

		// we unbind scroll event at the end, as closing animation may depend on it
		framework.unbind(window, 'scroll', self);

		_stopDragUpdateLoop();

		_stopAllAnimations();

		_listeners = null;
	},

	/**
	 * Pan image to position
	 * @param {Number} x     
	 * @param {Number} y     
	 * @param {Boolean} force Will ignore bounds if set to true.
	 */
	panTo: function(x,y,force) {
		if(!force) {
			if(x > _currPanBounds.min.x) {
				x = _currPanBounds.min.x;
			} else if(x < _currPanBounds.max.x) {
				x = _currPanBounds.max.x;
			}

			if(y > _currPanBounds.min.y) {
				y = _currPanBounds.min.y;
			} else if(y < _currPanBounds.max.y) {
				y = _currPanBounds.max.y;
			}
		}
		
		_panOffset.x = x;
		_panOffset.y = y;
		_applyCurrentZoomPan();
	},
	
	handleEvent: function (e) {
		e = e || window.event;
		if(_globalEventHandlers[e.type]) {
			_globalEventHandlers[e.type](e);
		}
	},


	goTo: function(index) {

		index = _getLoopedId(index);

		var diff = index - _currentItemIndex;
		_indexDiff = diff;

		_currentItemIndex = index;
		self.currItem = _getItemAt( _currentItemIndex );
		_currPositionIndex -= diff;
		
		_moveMainScroll(_slideSize.x * _currPositionIndex);
		

		_stopAllAnimations();
		_mainScrollAnimating = false;

		self.updateCurrItem();
	},
	next: function() {
		self.goTo( _currentItemIndex + 1);
	},
	prev: function() {
		self.goTo( _currentItemIndex - 1);
	},

	// update current zoom/pan objects
	updateCurrZoomItem: function(emulateSetContent) {
		if(emulateSetContent) {
			_shout('beforeChange', 0);
		}

		// itemHolder[1] is middle (current) item
		if(_itemHolders[1].el.children.length) {
			var zoomElement = _itemHolders[1].el.children[0];
			if( framework.hasClass(zoomElement, 'pswp__zoom-wrap') ) {
				_currZoomElementStyle = zoomElement.style;
			} else {
				_currZoomElementStyle = null;
			}
		} else {
			_currZoomElementStyle = null;
		}
		
		_currPanBounds = self.currItem.bounds;	
		_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;

		_panOffset.x = _currPanBounds.center.x;
		_panOffset.y = _currPanBounds.center.y;

		if(emulateSetContent) {
			_shout('afterChange');
		}
	},


	invalidateCurrItems: function() {
		_itemsNeedUpdate = true;
		for(var i = 0; i < NUM_HOLDERS; i++) {
			if( _itemHolders[i].item ) {
				_itemHolders[i].item.needsUpdate = true;
			}
		}
	},

	updateCurrItem: function(beforeAnimation) {

		if(_indexDiff === 0) {
			return;
		}

		var diffAbs = Math.abs(_indexDiff),
			tempHolder;

		if(beforeAnimation && diffAbs < 2) {
			return;
		}


		self.currItem = _getItemAt( _currentItemIndex );
		_renderMaxResolution = false;
		
		_shout('beforeChange', _indexDiff);

		if(diffAbs >= NUM_HOLDERS) {
			_containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
			diffAbs = NUM_HOLDERS;
		}
		for(var i = 0; i < diffAbs; i++) {
			if(_indexDiff > 0) {
				tempHolder = _itemHolders.shift();
				_itemHolders[NUM_HOLDERS-1] = tempHolder; // move first to last

				_containerShiftIndex++;
				_setTranslateX( (_containerShiftIndex+2) * _slideSize.x, tempHolder.el.style);
				self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
			} else {
				tempHolder = _itemHolders.pop();
				_itemHolders.unshift( tempHolder ); // move last to first

				_containerShiftIndex--;
				_setTranslateX( _containerShiftIndex * _slideSize.x, tempHolder.el.style);
				self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
			}
			
		}

		// reset zoom/pan on previous item
		if(_currZoomElementStyle && Math.abs(_indexDiff) === 1) {

			var prevItem = _getItemAt(_prevItemIndex);
			if(prevItem.initialZoomLevel !== _currZoomLevel) {
				_calculateItemSize(prevItem , _viewportSize );
				_setImageSize(prevItem);
				_applyZoomPanToItem( prevItem ); 				
			}

		}

		// reset diff after update
		_indexDiff = 0;

		self.updateCurrZoomItem();

		_prevItemIndex = _currentItemIndex;

		_shout('afterChange');
		
	},



	updateSize: function(force) {
		
		if(!_isFixedPosition && _options.modal) {
			var windowScrollY = framework.getScrollY();
			if(_currentWindowScrollY !== windowScrollY) {
				template.style.top = windowScrollY + 'px';
				_currentWindowScrollY = windowScrollY;
			}
			if(!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
				return;
			}
			_windowVisibleSize.x = window.innerWidth;
			_windowVisibleSize.y = window.innerHeight;

			//template.style.width = _windowVisibleSize.x + 'px';
			template.style.height = _windowVisibleSize.y + 'px';
		}



		_viewportSize.x = self.scrollWrap.clientWidth;
		_viewportSize.y = self.scrollWrap.clientHeight;

		_updatePageScrollOffset();

		_slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
		_slideSize.y = _viewportSize.y;

		_moveMainScroll(_slideSize.x * _currPositionIndex);

		_shout('beforeResize'); // even may be used for example to switch image sources


		// don't re-calculate size on inital size update
		if(_containerShiftIndex !== undefined) {

			var holder,
				item,
				hIndex;

			for(var i = 0; i < NUM_HOLDERS; i++) {
				holder = _itemHolders[i];
				_setTranslateX( (i+_containerShiftIndex) * _slideSize.x, holder.el.style);

				hIndex = _currentItemIndex+i-1;

				if(_options.loop && _getNumItems() > 2) {
					hIndex = _getLoopedId(hIndex);
				}

				// update zoom level on items and refresh source (if needsUpdate)
				item = _getItemAt( hIndex );

				// re-render gallery item if `needsUpdate`,
				// or doesn't have `bounds` (entirely new slide object)
				if( item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds) ) {

					self.cleanSlide( item );
					
					self.setContent( holder, hIndex );

					// if "center" slide
					if(i === 1) {
						self.currItem = item;
						self.updateCurrZoomItem(true);
					}

					item.needsUpdate = false;

				} else if(holder.index === -1 && hIndex >= 0) {
					// add content first time
					self.setContent( holder, hIndex );
				}
				if(item && item.container) {
					_calculateItemSize(item, _viewportSize);
					_setImageSize(item);
					_applyZoomPanToItem( item );
				}
				
			}
			_itemsNeedUpdate = false;
		}	

		_startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
		_currPanBounds = self.currItem.bounds;

		if(_currPanBounds) {
			_panOffset.x = _currPanBounds.center.x;
			_panOffset.y = _currPanBounds.center.y;
			_applyCurrentZoomPan( true );
		}
		
		_shout('resize');
	},
	
	// Zoom current item to
	zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
		/*
			if(destZoomLevel === 'fit') {
				destZoomLevel = self.currItem.fitRatio;
			} else if(destZoomLevel === 'fill') {
				destZoomLevel = self.currItem.fillRatio;
			}
		*/

		if(centerPoint) {
			_startZoomLevel = _currZoomLevel;
			_midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x ;
			_midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y ;
			_equalizePoints(_startPanOffset, _panOffset);
		}

		var destPanBounds = _calculatePanBounds(destZoomLevel, false),
			destPanOffset = {};

		_modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
		_modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);

		var initialZoomLevel = _currZoomLevel;
		var initialPanOffset = {
			x: _panOffset.x,
			y: _panOffset.y
		};

		_roundPoint(destPanOffset);

		var onUpdate = function(now) {
			if(now === 1) {
				_currZoomLevel = destZoomLevel;
				_panOffset.x = destPanOffset.x;
				_panOffset.y = destPanOffset.y;
			} else {
				_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
				_panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
				_panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
			}

			if(updateFn) {
				updateFn(now);
			}

			_applyCurrentZoomPan( now === 1 );
		};

		if(speed) {
			_animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
		} else {
			onUpdate(1);
		}
	}


};


/*>>core*/

/*>>gestures*/
/**
 * Mouse/touch/pointer event handlers.
 * 
 * separated from @core.js for readability
 */

var MIN_SWIPE_DISTANCE = 30,
	DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe

var _gestureStartTime,
	_gestureCheckSpeedTime,

	// pool of objects that are used during dragging of zooming
	p = {}, // first point
	p2 = {}, // second point (for zoom gesture)
	delta = {},
	_currPoint = {},
	_startPoint = {},
	_currPointers = [],
	_startMainScrollPos = {},
	_releaseAnimData,
	_posPoints = [], // array of points during dragging, used to determine type of gesture
	_tempPoint = {},

	_isZoomingIn,
	_verticalDragInitiated,
	_oldAndroidTouchEndTimeout,
	_currZoomedItemIndex = 0,
	_centerPoint = _getEmptyPoint(),
	_lastReleaseTime = 0,
	_isDragging, // at least one pointer is down
	_isMultitouch, // at least two _pointers are down
	_zoomStarted, // zoom level changed during zoom gesture
	_moved,
	_dragAnimFrame,
	_mainScrollShifted,
	_currentPoints, // array of current touch points
	_isZooming,
	_currPointsDistance,
	_startPointsDistance,
	_currPanBounds,
	_mainScrollPos = _getEmptyPoint(),
	_currZoomElementStyle,
	_mainScrollAnimating, // true, if animation after swipe gesture is running
	_midZoomPoint = _getEmptyPoint(),
	_currCenterPoint = _getEmptyPoint(),
	_direction,
	_isFirstMove,
	_opacityChanged,
	_bgOpacity,
	_wasOverInitialZoom,

	_isEqualPoints = function(p1, p2) {
		return p1.x === p2.x && p1.y === p2.y;
	},
	_isNearbyPoints = function(touch0, touch1) {
		return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
	},
	_calculatePointsDistance = function(p1, p2) {
		_tempPoint.x = Math.abs( p1.x - p2.x );
		_tempPoint.y = Math.abs( p1.y - p2.y );
		return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
	},
	_stopDragUpdateLoop = function() {
		if(_dragAnimFrame) {
			_cancelAF(_dragAnimFrame);
			_dragAnimFrame = null;
		}
	},
	_dragUpdateLoop = function() {
		if(_isDragging) {
			_dragAnimFrame = _requestAF(_dragUpdateLoop);
			_renderMovement();
		}
	},
	_canPan = function() {
		return !(_options.scaleMode === 'fit' && _currZoomLevel ===  self.currItem.initialZoomLevel);
	},
	
	// find the closest parent DOM element
	_closestElement = function(el, fn) {
	  	if(!el || el === document) {
	  		return false;
	  	}

	  	// don't search elements above pswp__scroll-wrap
	  	if(el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1 ) {
	  		return false;
	  	}

	  	if( fn(el) ) {
	  		return el;
	  	}

	  	return _closestElement(el.parentNode, fn);
	},

	_preventObj = {},
	_preventDefaultEventBehaviour = function(e, isDown) {
	    _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);

		_shout('preventDragEvent', e, isDown, _preventObj);
		return _preventObj.prevent;

	},
	_convertTouchToPoint = function(touch, p) {
		p.x = touch.pageX;
		p.y = touch.pageY;
		p.id = touch.identifier;
		return p;
	},
	_findCenterOfPoints = function(p1, p2, pCenter) {
		pCenter.x = (p1.x + p2.x) * 0.5;
		pCenter.y = (p1.y + p2.y) * 0.5;
	},
	_pushPosPoint = function(time, x, y) {
		if(time - _gestureCheckSpeedTime > 50) {
			var o = _posPoints.length > 2 ? _posPoints.shift() : {};
			o.x = x;
			o.y = y; 
			_posPoints.push(o);
			_gestureCheckSpeedTime = time;
		}
	},

	_calculateVerticalDragOpacityRatio = function() {
		var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
		return 1 -  Math.abs( yOffset / (_viewportSize.y / 2)  );
	},

	
	// points pool, reused during touch events
	_ePoint1 = {},
	_ePoint2 = {},
	_tempPointsArr = [],
	_tempCounter,
	_getTouchPoints = function(e) {
		// clean up previous points, without recreating array
		while(_tempPointsArr.length > 0) {
			_tempPointsArr.pop();
		}

		if(!_pointerEventEnabled) {
			if(e.type.indexOf('touch') > -1) {

				if(e.touches && e.touches.length > 0) {
					_tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
					if(e.touches.length > 1) {
						_tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
					}
				}
				
			} else {
				_ePoint1.x = e.pageX;
				_ePoint1.y = e.pageY;
				_ePoint1.id = '';
				_tempPointsArr[0] = _ePoint1;//_ePoint1;
			}
		} else {
			_tempCounter = 0;
			// we can use forEach, as pointer events are supported only in modern browsers
			_currPointers.forEach(function(p) {
				if(_tempCounter === 0) {
					_tempPointsArr[0] = p;
				} else if(_tempCounter === 1) {
					_tempPointsArr[1] = p;
				}
				_tempCounter++;

			});
		}
		return _tempPointsArr;
	},

	_panOrMoveMainScroll = function(axis, delta) {

		var panFriction,
			overDiff = 0,
			newOffset = _panOffset[axis] + delta[axis],
			startOverDiff,
			dir = delta[axis] > 0,
			newMainScrollPosition = _mainScrollPos.x + delta.x,
			mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
			newPanPos,
			newMainScrollPos;

		// calculate fdistance over the bounds and friction
		if(newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
			panFriction = _options.panEndFriction;
			// Linear increasing of friction, so at 1/4 of viewport it's at max value. 
			// Looks not as nice as was expected. Left for history.
			// panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
		} else {
			panFriction = 1;
		}
		
		newOffset = _panOffset[axis] + delta[axis] * panFriction;

		// move main scroll or start panning
		if(_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {


			if(!_currZoomElementStyle) {
				
				newMainScrollPos = newMainScrollPosition;

			} else if(_direction === 'h' && axis === 'x' && !_zoomStarted ) {
				
				if(dir) {
					if(newOffset > _currPanBounds.min[axis]) {
						panFriction = _options.panEndFriction;
						overDiff = _currPanBounds.min[axis] - newOffset;
						startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
					}
					
					// drag right
					if( (startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1 ) {
						newMainScrollPos = newMainScrollPosition;
						if(mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
							newMainScrollPos = _startMainScrollPos.x;
						}
					} else {
						if(_currPanBounds.min.x !== _currPanBounds.max.x) {
							newPanPos = newOffset;
						}
						
					}

				} else {

					if(newOffset < _currPanBounds.max[axis] ) {
						panFriction =_options.panEndFriction;
						overDiff = newOffset - _currPanBounds.max[axis];
						startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
					}

					if( (startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1 ) {
						newMainScrollPos = newMainScrollPosition;

						if(mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
							newMainScrollPos = _startMainScrollPos.x;
						}

					} else {
						if(_currPanBounds.min.x !== _currPanBounds.max.x) {
							newPanPos = newOffset;
						}
					}

				}


				//
			}

			if(axis === 'x') {

				if(newMainScrollPos !== undefined) {
					_moveMainScroll(newMainScrollPos, true);
					if(newMainScrollPos === _startMainScrollPos.x) {
						_mainScrollShifted = false;
					} else {
						_mainScrollShifted = true;
					}
				}

				if(_currPanBounds.min.x !== _currPanBounds.max.x) {
					if(newPanPos !== undefined) {
						_panOffset.x = newPanPos;
					} else if(!_mainScrollShifted) {
						_panOffset.x += delta.x * panFriction;
					}
				}

				return newMainScrollPos !== undefined;
			}

		}

		if(!_mainScrollAnimating) {
			
			if(!_mainScrollShifted) {
				if(_currZoomLevel > self.currItem.fitRatio) {
					_panOffset[axis] += delta[axis] * panFriction;
				
				}
			}

			
		}
		
	},

	// Pointerdown/touchstart/mousedown handler
	_onDragStart = function(e) {

		// Allow dragging only via left mouse button.
		// As this handler is not added in IE8 - we ignore e.which
		// 
		// http://www.quirksmode.org/js/events_properties.html
		// https://developer.mozilla.org/en-US/docs/Web/API/event.button
		if(e.type === 'mousedown' && e.button > 0  ) {
			return;
		}

		if(_initialZoomRunning) {
			e.preventDefault();
			return;
		}

		if(_oldAndroidTouchEndTimeout && e.type === 'mousedown') {
			return;
		}

		if(_preventDefaultEventBehaviour(e, true)) {
			e.preventDefault();
		}



		_shout('pointerDown');

		if(_pointerEventEnabled) {
			var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
			if(pointerIndex < 0) {
				pointerIndex = _currPointers.length;
			}
			_currPointers[pointerIndex] = {x:e.pageX, y:e.pageY, id: e.pointerId};
		}
		


		var startPointsList = _getTouchPoints(e),
			numPoints = startPointsList.length;

		_currentPoints = null;

		_stopAllAnimations();

		// init drag
		if(!_isDragging || numPoints === 1) {

			

			_isDragging = _isFirstMove = true;
			framework.bind(window, _upMoveEvents, self);

			_isZoomingIn = 
				_wasOverInitialZoom = 
				_opacityChanged = 
				_verticalDragInitiated = 
				_mainScrollShifted = 
				_moved = 
				_isMultitouch = 
				_zoomStarted = false;

			_direction = null;

			_shout('firstTouchStart', startPointsList);

			_equalizePoints(_startPanOffset, _panOffset);

			_currPanDist.x = _currPanDist.y = 0;
			_equalizePoints(_currPoint, startPointsList[0]);
			_equalizePoints(_startPoint, _currPoint);

			//_equalizePoints(_startMainScrollPos, _mainScrollPos);
			_startMainScrollPos.x = _slideSize.x * _currPositionIndex;

			_posPoints = [{
				x: _currPoint.x,
				y: _currPoint.y
			}];

			_gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();

			//_mainScrollAnimationEnd(true);
			_calculatePanBounds( _currZoomLevel, true );
			
			// Start rendering
			_stopDragUpdateLoop();
			_dragUpdateLoop();
			
		}

		// init zoom
		if(!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
			_startZoomLevel = _currZoomLevel;
			_zoomStarted = false; // true if zoom changed at least once

			_isZooming = _isMultitouch = true;
			_currPanDist.y = _currPanDist.x = 0;

			_equalizePoints(_startPanOffset, _panOffset);

			_equalizePoints(p, startPointsList[0]);
			_equalizePoints(p2, startPointsList[1]);

			_findCenterOfPoints(p, p2, _currCenterPoint);

			_midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
			_midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
			_currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
		}


	},

	// Pointermove/touchmove/mousemove handler
	_onDragMove = function(e) {

		e.preventDefault();

		if(_pointerEventEnabled) {
			var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
			if(pointerIndex > -1) {
				var p = _currPointers[pointerIndex];
				p.x = e.pageX;
				p.y = e.pageY; 
			}
		}

		if(_isDragging) {
			var touchesList = _getTouchPoints(e);
			if(!_direction && !_moved && !_isZooming) {

				if(_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
					// if main scroll position is shifted – direction is always horizontal
					_direction = 'h';
				} else {
					var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
					// check the direction of movement
					if(Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
						_direction = diff > 0 ? 'h' : 'v';
						_currentPoints = touchesList;
					}
				}
				
			} else {
				_currentPoints = touchesList;
			}
		}	
	},
	// 
	_renderMovement =  function() {

		if(!_currentPoints) {
			return;
		}

		var numPoints = _currentPoints.length;

		if(numPoints === 0) {
			return;
		}

		_equalizePoints(p, _currentPoints[0]);

		delta.x = p.x - _currPoint.x;
		delta.y = p.y - _currPoint.y;

		if(_isZooming && numPoints > 1) {
			// Handle behaviour for more than 1 point

			_currPoint.x = p.x;
			_currPoint.y = p.y;
		
			// check if one of two points changed
			if( !delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2) ) {
				return;
			}

			_equalizePoints(p2, _currentPoints[1]);


			if(!_zoomStarted) {
				_zoomStarted = true;
				_shout('zoomGestureStarted');
			}
			
			// Distance between two points
			var pointsDistance = _calculatePointsDistance(p,p2);

			var zoomLevel = _calculateZoomLevel(pointsDistance);

			// slightly over the of initial zoom level
			if(zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) {
				_wasOverInitialZoom = true;
			}

			// Apply the friction if zoom level is out of the bounds
			var zoomFriction = 1,
				minZoomLevel = _getMinZoomLevel(),
				maxZoomLevel = _getMaxZoomLevel();

			if ( zoomLevel < minZoomLevel ) {
				
				if(_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
					// fade out background if zooming out
					var minusDiff = minZoomLevel - zoomLevel;
					var percent = 1 - minusDiff / (minZoomLevel / 1.2);

					_applyBgOpacity(percent);
					_shout('onPinchClose', percent);
					_opacityChanged = true;
				} else {
					zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
					if(zoomFriction > 1) {
						zoomFriction = 1;
					}
					zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
				}
				
			} else if ( zoomLevel > maxZoomLevel ) {
				// 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
				zoomFriction = (zoomLevel - maxZoomLevel) / ( minZoomLevel * 6 );
				if(zoomFriction > 1) {
					zoomFriction = 1;
				}
				zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
			}

			if(zoomFriction < 0) {
				zoomFriction = 0;
			}

			// distance between touch points after friction is applied
			_currPointsDistance = pointsDistance;

			// _centerPoint - The point in the middle of two pointers
			_findCenterOfPoints(p, p2, _centerPoint);
		
			// paning with two pointers pressed
			_currPanDist.x += _centerPoint.x - _currCenterPoint.x;
			_currPanDist.y += _centerPoint.y - _currCenterPoint.y;
			_equalizePoints(_currCenterPoint, _centerPoint);

			_panOffset.x = _calculatePanOffset('x', zoomLevel);
			_panOffset.y = _calculatePanOffset('y', zoomLevel);

			_isZoomingIn = zoomLevel > _currZoomLevel;
			_currZoomLevel = zoomLevel;
			_applyCurrentZoomPan();

		} else {

			// handle behaviour for one point (dragging or panning)

			if(!_direction) {
				return;
			}

			if(_isFirstMove) {
				_isFirstMove = false;

				// subtract drag distance that was used during the detection direction  

				if( Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
					delta.x -= _currentPoints[0].x - _startPoint.x;
				}
				
				if( Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
					delta.y -= _currentPoints[0].y - _startPoint.y;
				}
			}

			_currPoint.x = p.x;
			_currPoint.y = p.y;

			// do nothing if pointers position hasn't changed
			if(delta.x === 0 && delta.y === 0) {
				return;
			}

			if(_direction === 'v' && _options.closeOnVerticalDrag) {
				if(!_canPan()) {
					_currPanDist.y += delta.y;
					_panOffset.y += delta.y;

					var opacityRatio = _calculateVerticalDragOpacityRatio();

					_verticalDragInitiated = true;
					_shout('onVerticalDrag', opacityRatio);

					_applyBgOpacity(opacityRatio);
					_applyCurrentZoomPan();
					return ;
				}
			}

			_pushPosPoint(_getCurrentTime(), p.x, p.y);

			_moved = true;
			_currPanBounds = self.currItem.bounds;
			
			var mainScrollChanged = _panOrMoveMainScroll('x', delta);
			if(!mainScrollChanged) {
				_panOrMoveMainScroll('y', delta);

				_roundPoint(_panOffset);
				_applyCurrentZoomPan();
			}

		}

	},
	
	// Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
	_onDragRelease = function(e) {

		if(_features.isOldAndroid ) {

			if(_oldAndroidTouchEndTimeout && e.type === 'mouseup') {
				return;
			}

			// on Android (v4.1, 4.2, 4.3 & possibly older) 
			// ghost mousedown/up event isn't preventable via e.preventDefault,
			// which causes fake mousedown event
			// so we block mousedown/up for 600ms
			if( e.type.indexOf('touch') > -1 ) {
				clearTimeout(_oldAndroidTouchEndTimeout);
				_oldAndroidTouchEndTimeout = setTimeout(function() {
					_oldAndroidTouchEndTimeout = 0;
				}, 600);
			}
			
		}

		_shout('pointerUp');

		if(_preventDefaultEventBehaviour(e, false)) {
			e.preventDefault();
		}

		var releasePoint;

		if(_pointerEventEnabled) {
			var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
			
			if(pointerIndex > -1) {
				releasePoint = _currPointers.splice(pointerIndex, 1)[0];

				if(navigator.pointerEnabled) {
					releasePoint.type = e.pointerType || 'mouse';
				} else {
					var MSPOINTER_TYPES = {
						4: 'mouse', // event.MSPOINTER_TYPE_MOUSE
						2: 'touch', // event.MSPOINTER_TYPE_TOUCH 
						3: 'pen' // event.MSPOINTER_TYPE_PEN
					};
					releasePoint.type = MSPOINTER_TYPES[e.pointerType];

					if(!releasePoint.type) {
						releasePoint.type = e.pointerType || 'mouse';
					}
				}

			}
		}

		var touchList = _getTouchPoints(e),
			gestureType,
			numPoints = touchList.length;

		if(e.type === 'mouseup') {
			numPoints = 0;
		}

		// Do nothing if there were 3 touch points or more
		if(numPoints === 2) {
			_currentPoints = null;
			return true;
		}

		// if second pointer released
		if(numPoints === 1) {
			_equalizePoints(_startPoint, touchList[0]);
		}				


		// pointer hasn't moved, send "tap release" point
		if(numPoints === 0 && !_direction && !_mainScrollAnimating) {
			if(!releasePoint) {
				if(e.type === 'mouseup') {
					releasePoint = {x: e.pageX, y: e.pageY, type:'mouse'};
				} else if(e.changedTouches && e.changedTouches[0]) {
					releasePoint = {x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type:'touch'};
				}		
			}

			_shout('touchRelease', e, releasePoint);
		}

		// Difference in time between releasing of two last touch points (zoom gesture)
		var releaseTimeDiff = -1;

		// Gesture completed, no pointers left
		if(numPoints === 0) {
			_isDragging = false;
			framework.unbind(window, _upMoveEvents, self);

			_stopDragUpdateLoop();

			if(_isZooming) {
				// Two points released at the same time
				releaseTimeDiff = 0;
			} else if(_lastReleaseTime !== -1) {
				releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
			}
		}
		_lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
		
		if(releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
			gestureType = 'zoom';
		} else {
			gestureType = 'swipe';
		}

		if(_isZooming && numPoints < 2) {
			_isZooming = false;

			// Only second point released
			if(numPoints === 1) {
				gestureType = 'zoomPointerUp';
			}
			_shout('zoomGestureEnded');
		}

		_currentPoints = null;
		if(!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) {
			// nothing to animate
			return;
		}
	
		_stopAllAnimations();

		
		if(!_releaseAnimData) {
			_releaseAnimData = _initDragReleaseAnimationData();
		}
		
		_releaseAnimData.calculateSwipeSpeed('x');


		if(_verticalDragInitiated) {

			var opacityRatio = _calculateVerticalDragOpacityRatio();

			if(opacityRatio < _options.verticalDragRange) {
				self.close();
			} else {
				var initalPanY = _panOffset.y,
					initialBgOpacity = _bgOpacity;

				_animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {
					
					_panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;

					_applyBgOpacity(  (1 - initialBgOpacity) * now + initialBgOpacity );
					_applyCurrentZoomPan();
				});

				_shout('onVerticalDrag', 1);
			}

			return;
		}


		// main scroll 
		if(  (_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
			var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
			if(itemChanged) {
				return;
			}
			gestureType = 'zoomPointerUp';
		}

		// prevent zoom/pan animation when main scroll animation runs
		if(_mainScrollAnimating) {
			return;
		}
		
		// Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
		if(gestureType !== 'swipe') {
			_completeZoomGesture();
			return;
		}
	
		// Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
		if(!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) {
			_completePanGesture(_releaseAnimData);
		}
	},


	// Returns object with data about gesture
	// It's created only once and then reused
	_initDragReleaseAnimationData  = function() {
		// temp local vars
		var lastFlickDuration,
			tempReleasePos;

		// s = this
		var s = {
			lastFlickOffset: {},
			lastFlickDist: {},
			lastFlickSpeed: {},
			slowDownRatio:  {},
			slowDownRatioReverse:  {},
			speedDecelerationRatio:  {},
			speedDecelerationRatioAbs:  {},
			distanceOffset:  {},
			backAnimDestination: {},
			backAnimStarted: {},
			calculateSwipeSpeed: function(axis) {
				

				if( _posPoints.length > 1) {
					lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
					tempReleasePos = _posPoints[_posPoints.length-2][axis];
				} else {
					lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
					tempReleasePos = _startPoint[axis];
				}
				s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
				s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
				if(s.lastFlickDist[axis] > 20) {
					s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
				} else {
					s.lastFlickSpeed[axis] = 0;
				}
				if( Math.abs(s.lastFlickSpeed[axis]) < 0.1 ) {
					s.lastFlickSpeed[axis] = 0;
				}
				
				s.slowDownRatio[axis] = 0.95;
				s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
				s.speedDecelerationRatio[axis] = 1;
			},

			calculateOverBoundsAnimOffset: function(axis, speed) {
				if(!s.backAnimStarted[axis]) {

					if(_panOffset[axis] > _currPanBounds.min[axis]) {
						s.backAnimDestination[axis] = _currPanBounds.min[axis];
						
					} else if(_panOffset[axis] < _currPanBounds.max[axis]) {
						s.backAnimDestination[axis] = _currPanBounds.max[axis];
					}

					if(s.backAnimDestination[axis] !== undefined) {
						s.slowDownRatio[axis] = 0.7;
						s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
						if(s.speedDecelerationRatioAbs[axis] < 0.05) {

							s.lastFlickSpeed[axis] = 0;
							s.backAnimStarted[axis] = true;

							_animateProp('bounceZoomPan'+axis,_panOffset[axis], 
								s.backAnimDestination[axis], 
								speed || 300, 
								framework.easing.sine.out, 
								function(pos) {
									_panOffset[axis] = pos;
									_applyCurrentZoomPan();
								}
							);

						}
					}
				}
			},

			// Reduces the speed by slowDownRatio (per 10ms)
			calculateAnimOffset: function(axis) {
				if(!s.backAnimStarted[axis]) {
					s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + 
												s.slowDownRatioReverse[axis] - 
												s.slowDownRatioReverse[axis] * s.timeDiff / 10);

					s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
					s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
					_panOffset[axis] += s.distanceOffset[axis];

				}
			},

			panAnimLoop: function() {
				if ( _animations.zoomPan ) {
					_animations.zoomPan.raf = _requestAF(s.panAnimLoop);

					s.now = _getCurrentTime();
					s.timeDiff = s.now - s.lastNow;
					s.lastNow = s.now;
					
					s.calculateAnimOffset('x');
					s.calculateAnimOffset('y');

					_applyCurrentZoomPan();
					
					s.calculateOverBoundsAnimOffset('x');
					s.calculateOverBoundsAnimOffset('y');


					if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {

						// round pan position
						_panOffset.x = Math.round(_panOffset.x);
						_panOffset.y = Math.round(_panOffset.y);
						_applyCurrentZoomPan();
						
						_stopAnimation('zoomPan');
						return;
					}
				}

			}
		};
		return s;
	},

	_completePanGesture = function(animData) {
		// calculate swipe speed for Y axis (paanning)
		animData.calculateSwipeSpeed('y');

		_currPanBounds = self.currItem.bounds;
		
		animData.backAnimDestination = {};
		animData.backAnimStarted = {};

		// Avoid acceleration animation if speed is too low
		if(Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05 ) {
			animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;

			// Run pan drag release animation. E.g. if you drag image and release finger without momentum.
			animData.calculateOverBoundsAnimOffset('x');
			animData.calculateOverBoundsAnimOffset('y');
			return true;
		}

		// Animation loop that controls the acceleration after pan gesture ends
		_registerStartAnimation('zoomPan');
		animData.lastNow = _getCurrentTime();
		animData.panAnimLoop();
	},


	_finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData) {
		var itemChanged;
		if(!_mainScrollAnimating) {
			_currZoomedItemIndex = _currentItemIndex;
		}


		
		var itemsDiff;

		if(gestureType === 'swipe') {
			var totalShiftDist = _currPoint.x - _startPoint.x,
				isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;

			// if container is shifted for more than MIN_SWIPE_DISTANCE, 
			// and last flick gesture was in right direction
			if(totalShiftDist > MIN_SWIPE_DISTANCE && 
				(isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20) ) {
				// go to prev item
				itemsDiff = -1;
			} else if(totalShiftDist < -MIN_SWIPE_DISTANCE && 
				(isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20) ) {
				// go to next item
				itemsDiff = 1;
			}
		}

		var nextCircle;

		if(itemsDiff) {
			
			_currentItemIndex += itemsDiff;

			if(_currentItemIndex < 0) {
				_currentItemIndex = _options.loop ? _getNumItems()-1 : 0;
				nextCircle = true;
			} else if(_currentItemIndex >= _getNumItems()) {
				_currentItemIndex = _options.loop ? 0 : _getNumItems()-1;
				nextCircle = true;
			}

			if(!nextCircle || _options.loop) {
				_indexDiff += itemsDiff;
				_currPositionIndex -= itemsDiff;
				itemChanged = true;
			}
			

			
		}

		var animateToX = _slideSize.x * _currPositionIndex;
		var animateToDist = Math.abs( animateToX - _mainScrollPos.x );
		var finishAnimDuration;


		if(!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) {
			// "return to current" duration, e.g. when dragging from slide 0 to -1
			finishAnimDuration = 333; 
		} else {
			finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? 
									animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 
									333;

			finishAnimDuration = Math.min(finishAnimDuration, 400);
			finishAnimDuration = Math.max(finishAnimDuration, 250);
		}

		if(_currZoomedItemIndex === _currentItemIndex) {
			itemChanged = false;
		}
		
		_mainScrollAnimating = true;
		
		_shout('mainScrollAnimStart');

		_animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, 
			_moveMainScroll,
			function() {
				_stopAllAnimations();
				_mainScrollAnimating = false;
				_currZoomedItemIndex = -1;
				
				if(itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
					self.updateCurrItem();
				}
				
				_shout('mainScrollAnimComplete');
			}
		);

		if(itemChanged) {
			self.updateCurrItem(true);
		}

		return itemChanged;
	},

	_calculateZoomLevel = function(touchesDistance) {
		return  1 / _startPointsDistance * touchesDistance * _startZoomLevel;
	},

	// Resets zoom if it's out of bounds
	_completeZoomGesture = function() {
		var destZoomLevel = _currZoomLevel,
			minZoomLevel = _getMinZoomLevel(),
			maxZoomLevel = _getMaxZoomLevel();

		if ( _currZoomLevel < minZoomLevel ) {
			destZoomLevel = minZoomLevel;
		} else if ( _currZoomLevel > maxZoomLevel ) {
			destZoomLevel = maxZoomLevel;
		}

		var destOpacity = 1,
			onUpdate,
			initialOpacity = _bgOpacity;

		if(_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
			//_closedByScroll = true;
			self.close();
			return true;
		}

		if(_opacityChanged) {
			onUpdate = function(now) {
				_applyBgOpacity(  (destOpacity - initialOpacity) * now + initialOpacity );
			};
		}

		self.zoomTo(destZoomLevel, 0, 200,  framework.easing.cubic.out, onUpdate);
		return true;
	};


_registerModule('Gestures', {
	publicMethods: {

		initGestures: function() {

			// helper function that builds touch/pointer/mouse events
			var addEventNames = function(pref, down, move, up, cancel) {
				_dragStartEvent = pref + down;
				_dragMoveEvent = pref + move;
				_dragEndEvent = pref + up;
				if(cancel) {
					_dragCancelEvent = pref + cancel;
				} else {
					_dragCancelEvent = '';
				}
			};

			_pointerEventEnabled = _features.pointerEvent;
			if(_pointerEventEnabled && _features.touch) {
				// we don't need touch events, if browser supports pointer events
				_features.touch = false;
			}

			if(_pointerEventEnabled) {
				if(navigator.pointerEnabled) {
					addEventNames('pointer', 'down', 'move', 'up', 'cancel');
				} else {
					// IE10 pointer events are case-sensitive
					addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
				}
			} else if(_features.touch) {
				addEventNames('touch', 'start', 'move', 'end', 'cancel');
				_likelyTouchDevice = true;
			} else {
				addEventNames('mouse', 'down', 'move', 'up');	
			}

			_upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent  + ' ' +  _dragCancelEvent;
			_downEvents = _dragStartEvent;

			if(_pointerEventEnabled && !_likelyTouchDevice) {
				_likelyTouchDevice = (navigator.maxTouchPoints > 1) || (navigator.msMaxTouchPoints > 1);
			}
			// make variable public
			self.likelyTouchDevice = _likelyTouchDevice; 
			
			_globalEventHandlers[_dragStartEvent] = _onDragStart;
			_globalEventHandlers[_dragMoveEvent] = _onDragMove;
			_globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken

			if(_dragCancelEvent) {
				_globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
			}

			// Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
			if(_features.touch) {
				_downEvents += ' mousedown';
				_upMoveEvents += ' mousemove mouseup';
				_globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
				_globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
				_globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
			}

			if(!_likelyTouchDevice) {
				// don't allow pan to next slide from zoomed state on Desktop
				_options.allowPanToNext = false;
			}
		}

	}
});


/*>>gestures*/

/*>>show-hide-transition*/
/**
 * show-hide-transition.js:
 *
 * Manages initial opening or closing transition.
 *
 * If you're not planning to use transition for gallery at all,
 * you may set options hideAnimationDuration and showAnimationDuration to 0,
 * and just delete startAnimation function.
 * 
 */


var _showOrHideTimeout,
	_showOrHide = function(item, img, out, completeFn) {

		if(_showOrHideTimeout) {
			clearTimeout(_showOrHideTimeout);
		}

		_initialZoomRunning = true;
		_initialContentSet = true;
		
		// dimensions of small thumbnail {x:,y:,w:}.
		// Height is optional, as calculated based on large image.
		var thumbBounds; 
		if(item.initialLayout) {
			thumbBounds = item.initialLayout;
			item.initialLayout = null;
		} else {
			thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
		}

		var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;

		var onComplete = function() {
			_stopAnimation('initialZoom');
			if(!out) {
				_applyBgOpacity(1);
				if(img) {
					img.style.display = 'block';
				}
				framework.addClass(template, 'pswp--animated-in');
				_shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
			} else {
				self.template.removeAttribute('style');
				self.bg.removeAttribute('style');
			}

			if(completeFn) {
				completeFn();
			}
			_initialZoomRunning = false;
		};

		// if bounds aren't provided, just open gallery without animation
		if(!duration || !thumbBounds || thumbBounds.x === undefined) {

			_shout('initialZoom' + (out ? 'Out' : 'In') );

			_currZoomLevel = item.initialZoomLevel;
			_equalizePoints(_panOffset,  item.initialPosition );
			_applyCurrentZoomPan();

			template.style.opacity = out ? 0 : 1;
			_applyBgOpacity(1);

			if(duration) {
				setTimeout(function() {
					onComplete();
				}, duration);
			} else {
				onComplete();
			}

			return;
		}

		var startAnimation = function() {
			var closeWithRaf = _closedByScroll,
				fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;
			
			// apply hw-acceleration to image
			if(item.miniImg) {
				item.miniImg.style.webkitBackfaceVisibility = 'hidden';
			}

			if(!out) {
				_currZoomLevel = thumbBounds.w / item.w;
				_panOffset.x = thumbBounds.x;
				_panOffset.y = thumbBounds.y - _initalWindowScrollY;

				self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
				_applyCurrentZoomPan();
			}

			_registerStartAnimation('initialZoom');
			
			if(out && !closeWithRaf) {
				framework.removeClass(template, 'pswp--animated-in');
			}

			if(fadeEverything) {
				if(out) {
					framework[ (closeWithRaf ? 'remove' : 'add') + 'Class' ](template, 'pswp--animate_opacity');
				} else {
					setTimeout(function() {
						framework.addClass(template, 'pswp--animate_opacity');
					}, 30);
				}
			}

			_showOrHideTimeout = setTimeout(function() {

				_shout('initialZoom' + (out ? 'Out' : 'In') );
				

				if(!out) {

					// "in" animation always uses CSS transitions (instead of rAF).
					// CSS transition work faster here, 
					// as developer may also want to animate other things, 
					// like ui on top of sliding area, which can be animated just via CSS
					
					_currZoomLevel = item.initialZoomLevel;
					_equalizePoints(_panOffset,  item.initialPosition );
					_applyCurrentZoomPan();
					_applyBgOpacity(1);

					if(fadeEverything) {
						template.style.opacity = 1;
					} else {
						_applyBgOpacity(1);
					}

					_showOrHideTimeout = setTimeout(onComplete, duration + 20);
				} else {

					// "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
					var destZoomLevel = thumbBounds.w / item.w,
						initialPanOffset = {
							x: _panOffset.x,
							y: _panOffset.y
						},
						initialZoomLevel = _currZoomLevel,
						initalBgOpacity = _bgOpacity,
						onUpdate = function(now) {
							
							if(now === 1) {
								_currZoomLevel = destZoomLevel;
								_panOffset.x = thumbBounds.x;
								_panOffset.y = thumbBounds.y  - _currentWindowScrollY;
							} else {
								_currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
								_panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
								_panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
							}
							
							_applyCurrentZoomPan();
							if(fadeEverything) {
								template.style.opacity = 1 - now;
							} else {
								_applyBgOpacity( initalBgOpacity - now * initalBgOpacity );
							}
						};

					if(closeWithRaf) {
						_animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
					} else {
						onUpdate(1);
						_showOrHideTimeout = setTimeout(onComplete, duration + 20);
					}
				}
			
			}, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
					// create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
					// Which avoids lag at the beginning of scale transition.
		};
		startAnimation();

		
	};

/*>>show-hide-transition*/

/*>>items-controller*/
/**
*
* Controller manages gallery items, their dimensions, and their content.
* 
*/

var _items,
	_tempPanAreaSize = {},
	_imagesToAppendPool = [],
	_initialContentSet,
	_initialZoomRunning,
	_controllerDefaultOptions = {
		index: 0,
		errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
		forceProgressiveLoading: false, // TODO
		preload: [1,1],
		getNumItemsFn: function() {
			return _items.length;
		}
	};


var _getItemAt,
	_getNumItems,
	_initialIsLoop,
	_getZeroBounds = function() {
		return {
			center:{x:0,y:0}, 
			max:{x:0,y:0}, 
			min:{x:0,y:0}
		};
	},
	_calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH ) {
		var bounds = item.bounds;

		// position of element when it's centered
		bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
		bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;

		// maximum pan position
		bounds.max.x = (realPanElementW > _tempPanAreaSize.x) ? 
							Math.round(_tempPanAreaSize.x - realPanElementW) : 
							bounds.center.x;
		
		bounds.max.y = (realPanElementH > _tempPanAreaSize.y) ? 
							Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : 
							bounds.center.y;
		
		// minimum pan position
		bounds.min.x = (realPanElementW > _tempPanAreaSize.x) ? 0 : bounds.center.x;
		bounds.min.y = (realPanElementH > _tempPanAreaSize.y) ? item.vGap.top : bounds.center.y;
	},
	_calculateItemSize = function(item, viewportSize, zoomLevel) {

		if (item.src && !item.loadError) {
			var isInitial = !zoomLevel;
			
			if(isInitial) {
				if(!item.vGap) {
					item.vGap = {top:0,bottom:0};
				}
				// allows overriding vertical margin for individual items
				_shout('parseVerticalMargin', item);
			}


			_tempPanAreaSize.x = viewportSize.x;
			_tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;

			if (isInitial) {
				var hRatio = _tempPanAreaSize.x / item.w;
				var vRatio = _tempPanAreaSize.y / item.h;

				item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
				//item.fillRatio = hRatio > vRatio ? hRatio : vRatio;

				var scaleMode = _options.scaleMode;

				if (scaleMode === 'orig') {
					zoomLevel = 1;
				} else if (scaleMode === 'fit') {
					zoomLevel = item.fitRatio;
				}

				if (zoomLevel > 1) {
					zoomLevel = 1;
				}

				item.initialZoomLevel = zoomLevel;
				
				if(!item.bounds) {
					// reuse bounds object
					item.bounds = _getZeroBounds(); 
				}
			}

			if(!zoomLevel) {
				return;
			}

			_calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);

			if (isInitial && zoomLevel === item.initialZoomLevel) {
				item.initialPosition = item.bounds.center;
			}

			return item.bounds;
		} else {
			item.w = item.h = 0;
			item.initialZoomLevel = item.fitRatio = 1;
			item.bounds = _getZeroBounds();
			item.initialPosition = item.bounds.center;

			// if it's not image, we return zero bounds (content is not zoomable)
			return item.bounds;
		}
		
	},

	


	_appendImage = function(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
		

		if(item.loadError) {
			return;
		}

		if(img) {

			item.imageAppended = true;
			_setImageSize(item, img, (item === self.currItem && _renderMaxResolution) );
			
			baseDiv.appendChild(img);

			if(keepPlaceholder) {
				setTimeout(function() {
					if(item && item.loaded && item.placeholder) {
						item.placeholder.style.display = 'none';
						item.placeholder = null;
					}
				}, 500);
			}
		}
	},
	


	_preloadImage = function(item) {
		item.loading = true;
		item.loaded = false;
		var img = item.img = framework.createEl('pswp__img', 'img');
		var onComplete = function() {
			item.loading = false;
			item.loaded = true;

			if(item.loadComplete) {
				item.loadComplete(item);
			} else {
				item.img = null; // no need to store image object
			}
			img.onload = img.onerror = null;
			img = null;
		};
		img.onload = onComplete;
		img.onerror = function() {
			item.loadError = true;
			onComplete();
		};		

		img.src = item.src;// + '?a=' + Math.random();

		return img;
	},
	_checkForError = function(item, cleanUp) {
		if(item.src && item.loadError && item.container) {

			if(cleanUp) {
				item.container.innerHTML = '';
			}

			item.container.innerHTML = _options.errorMsg.replace('%url%',  item.src );
			return true;
			
		}
	},
	_setImageSize = function(item, img, maxRes) {
		if(!item.src) {
			return;
		}

		if(!img) {
			img = item.container.lastChild;
		}

		var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
			h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
		
		if(item.placeholder && !item.loaded) {
			item.placeholder.style.width = w + 'px';
			item.placeholder.style.height = h + 'px';
		}

		img.style.width = w + 'px';
		img.style.height = h + 'px';
	},
	_appendImagesPool = function() {

		if(_imagesToAppendPool.length) {
			var poolItem;

			for(var i = 0; i < _imagesToAppendPool.length; i++) {
				poolItem = _imagesToAppendPool[i];
				if( poolItem.holder.index === poolItem.index ) {
					_appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
				}
			}
			_imagesToAppendPool = [];
		}
	};
	


_registerModule('Controller', {

	publicMethods: {

		lazyLoadItem: function(index) {
			index = _getLoopedId(index);
			var item = _getItemAt(index);

			if(!item || ((item.loaded || item.loading) && !_itemsNeedUpdate)) {
				return;
			}

			_shout('gettingData', index, item);

			if (!item.src) {
				return;
			}

			_preloadImage(item);
		},
		initController: function() {
			framework.extend(_options, _controllerDefaultOptions, true);
			self.items = _items = items;
			_getItemAt = self.getItemAt;
			_getNumItems = _options.getNumItemsFn; //self.getNumItems;



			_initialIsLoop = _options.loop;
			if(_getNumItems() < 3) {
				_options.loop = false; // disable loop if less then 3 items
			}

			_listen('beforeChange', function(diff) {

				var p = _options.preload,
					isNext = diff === null ? true : (diff >= 0),
					preloadBefore = Math.min(p[0], _getNumItems() ),
					preloadAfter = Math.min(p[1], _getNumItems() ),
					i;


				for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) {
					self.lazyLoadItem(_currentItemIndex+i);
				}
				for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) {
					self.lazyLoadItem(_currentItemIndex-i);
				}
			});

			_listen('initialLayout', function() {
				self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
			});

			_listen('mainScrollAnimComplete', _appendImagesPool);
			_listen('initialZoomInEnd', _appendImagesPool);



			_listen('destroy', function() {
				var item;
				for(var i = 0; i < _items.length; i++) {
					item = _items[i];
					// remove reference to DOM elements, for GC
					if(item.container) {
						item.container = null; 
					}
					if(item.placeholder) {
						item.placeholder = null;
					}
					if(item.img) {
						item.img = null;
					}
					if(item.preloader) {
						item.preloader = null;
					}
					if(item.loadError) {
						item.loaded = item.loadError = false;
					}
				}
				_imagesToAppendPool = null;
			});
		},


		getItemAt: function(index) {
			if (index >= 0) {
				return _items[index] !== undefined ? _items[index] : false;
			}
			return false;
		},

		allowProgressiveImg: function() {
			// 1. Progressive image loading isn't working on webkit/blink 
			//    when hw-acceleration (e.g. translateZ) is applied to IMG element.
			//    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
			//    
			// 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
			//    That's why it's disabled on touch devices (mainly because of swipe transition)
			//    
			// 3. Progressive image loading sometimes doesn't work in IE (up to 11).

			// Don't allow progressive loading on non-large touch devices
			return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200; 
			// 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
		},

		setContent: function(holder, index) {

			if(_options.loop) {
				index = _getLoopedId(index);
			}

			var prevItem = self.getItemAt(holder.index);
			if(prevItem) {
				prevItem.container = null;
			}
	
			var item = self.getItemAt(index),
				img;
			
			if(!item) {
				holder.el.innerHTML = '';
				return;
			}

			// allow to override data
			_shout('gettingData', index, item);

			holder.index = index;
			holder.item = item;

			// base container DIV is created only once for each of 3 holders
			var baseDiv = item.container = framework.createEl('pswp__zoom-wrap'); 

			

			if(!item.src && item.html) {
				if(item.html.tagName) {
					baseDiv.appendChild(item.html);
				} else {
					baseDiv.innerHTML = item.html;
				}
			}

			_checkForError(item);

			_calculateItemSize(item, _viewportSize);
			
			if(item.src && !item.loadError && !item.loaded) {

				item.loadComplete = function(item) {

					// gallery closed before image finished loading
					if(!_isOpen) {
						return;
					}

					// check if holder hasn't changed while image was loading
					if(holder && holder.index === index ) {
						if( _checkForError(item, true) ) {
							item.loadComplete = item.img = null;
							_calculateItemSize(item, _viewportSize);
							_applyZoomPanToItem(item);

							if(holder.index === _currentItemIndex) {
								// recalculate dimensions
								self.updateCurrZoomItem();
							}
							return;
						}
						if( !item.imageAppended ) {
							if(_features.transform && (_mainScrollAnimating || _initialZoomRunning) ) {
								_imagesToAppendPool.push({
									item:item,
									baseDiv:baseDiv,
									img:item.img,
									index:index,
									holder:holder,
									clearPlaceholder:true
								});
							} else {
								_appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
							}
						} else {
							// remove preloader & mini-img
							if(!_initialZoomRunning && item.placeholder) {
								item.placeholder.style.display = 'none';
								item.placeholder = null;
							}
						}
					}

					item.loadComplete = null;
					item.img = null; // no need to store image element after it's added

					_shout('imageLoadComplete', index, item);
				};

				if(framework.features.transform) {
					
					var placeholderClassName = 'pswp__img pswp__img--placeholder'; 
					placeholderClassName += (item.msrc ? '' : ' pswp__img--placeholder--blank');

					var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
					if(item.msrc) {
						placeholder.src = item.msrc;
					}
					
					_setImageSize(item, placeholder);

					baseDiv.appendChild(placeholder);
					item.placeholder = placeholder;

				}
				

				

				if(!item.loading) {
					_preloadImage(item);
				}


				if( self.allowProgressiveImg() ) {
					// just append image
					if(!_initialContentSet && _features.transform) {
						_imagesToAppendPool.push({
							item:item, 
							baseDiv:baseDiv, 
							img:item.img, 
							index:index, 
							holder:holder
						});
					} else {
						_appendImage(index, item, baseDiv, item.img, true, true);
					}
				}
				
			} else if(item.src && !item.loadError) {
				// image object is created every time, due to bugs of image loading & delay when switching images
				img = framework.createEl('pswp__img', 'img');
				img.style.opacity = 1;
				img.src = item.src;
				_setImageSize(item, img);
				_appendImage(index, item, baseDiv, img, true);
			}
			

			if(!_initialContentSet && index === _currentItemIndex) {
				_currZoomElementStyle = baseDiv.style;
				_showOrHide(item, (img ||item.img) );
			} else {
				_applyZoomPanToItem(item);
			}

			holder.el.innerHTML = '';
			holder.el.appendChild(baseDiv);
		},

		cleanSlide: function( item ) {
			if(item.img ) {
				item.img.onload = item.img.onerror = null;
			}
			item.loaded = item.loading = item.img = item.imageAppended = false;
		}

	}
});

/*>>items-controller*/

/*>>tap*/
/**
 * tap.js:
 *
 * Displatches tap and double-tap events.
 * 
 */

var tapTimer,
	tapReleasePoint = {},
	_dispatchTapEvent = function(origEvent, releasePoint, pointerType) {		
		var e = document.createEvent( 'CustomEvent' ),
			eDetail = {
				origEvent:origEvent, 
				target:origEvent.target, 
				releasePoint: releasePoint, 
				pointerType:pointerType || 'touch'
			};

		e.initCustomEvent( 'pswpTap', true, true, eDetail );
		origEvent.target.dispatchEvent(e);
	};

_registerModule('Tap', {
	publicMethods: {
		initTap: function() {
			_listen('firstTouchStart', self.onTapStart);
			_listen('touchRelease', self.onTapRelease);
			_listen('destroy', function() {
				tapReleasePoint = {};
				tapTimer = null;
			});
		},
		onTapStart: function(touchList) {
			if(touchList.length > 1) {
				clearTimeout(tapTimer);
				tapTimer = null;
			}
		},
		onTapRelease: function(e, releasePoint) {
			if(!releasePoint) {
				return;
			}

			if(!_moved && !_isMultitouch && !_numAnimations) {
				var p0 = releasePoint;
				if(tapTimer) {
					clearTimeout(tapTimer);
					tapTimer = null;

					// Check if taped on the same place
					if ( _isNearbyPoints(p0, tapReleasePoint) ) {
						_shout('doubleTap', p0);
						return;
					}
				}

				if(releasePoint.type === 'mouse') {
					_dispatchTapEvent(e, releasePoint, 'mouse');
					return;
				}

				var clickedTagName = e.target.tagName.toUpperCase();
				// avoid double tap delay on buttons and elements that have class pswp__single-tap
				if(clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap') ) {
					_dispatchTapEvent(e, releasePoint);
					return;
				}

				_equalizePoints(tapReleasePoint, p0);

				tapTimer = setTimeout(function() {
					_dispatchTapEvent(e, releasePoint);
					tapTimer = null;
				}, 300);
			}
		}
	}
});

/*>>tap*/

/*>>desktop-zoom*/
/**
 *
 * desktop-zoom.js:
 *
 * - Binds mousewheel event for paning zoomed image.
 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
 *   (which are used for cursors and zoom icon)
 * - Adds toggleDesktopZoom function.
 * 
 */

var _wheelDelta;
	
_registerModule('DesktopZoom', {

	publicMethods: {

		initDesktopZoom: function() {

			if(_oldIE) {
				// no zoom for old IE (<=8)
				return;
			}

			if(_likelyTouchDevice) {
				// if detected hardware touch support, we wait until mouse is used,
				// and only then apply desktop-zoom features
				_listen('mouseUsed', function() {
					self.setupDesktopZoom();
				});
			} else {
				self.setupDesktopZoom(true);
			}

		},

		setupDesktopZoom: function(onInit) {

			_wheelDelta = {};

			var events = 'wheel mousewheel DOMMouseScroll';
			
			_listen('bindEvents', function() {
				framework.bind(template, events,  self.handleMouseWheel);
			});

			_listen('unbindEvents', function() {
				if(_wheelDelta) {
					framework.unbind(template, events, self.handleMouseWheel);
				}
			});

			self.mouseZoomedIn = false;

			var hasDraggingClass,
				updateZoomable = function() {
					if(self.mouseZoomedIn) {
						framework.removeClass(template, 'pswp--zoomed-in');
						self.mouseZoomedIn = false;
					}
					if(_currZoomLevel < 1) {
						framework.addClass(template, 'pswp--zoom-allowed');
					} else {
						framework.removeClass(template, 'pswp--zoom-allowed');
					}
					removeDraggingClass();
				},
				removeDraggingClass = function() {
					if(hasDraggingClass) {
						framework.removeClass(template, 'pswp--dragging');
						hasDraggingClass = false;
					}
				};

			_listen('resize' , updateZoomable);
			_listen('afterChange' , updateZoomable);
			_listen('pointerDown', function() {
				if(self.mouseZoomedIn) {
					hasDraggingClass = true;
					framework.addClass(template, 'pswp--dragging');
				}
			});
			_listen('pointerUp', removeDraggingClass);

			if(!onInit) {
				updateZoomable();
			}
			
		},

		handleMouseWheel: function(e) {

			if(_currZoomLevel <= self.currItem.fitRatio) {
				if( _options.modal ) {

					if (!_options.closeOnScroll || _numAnimations || _isDragging) {
						e.preventDefault();
					} else if(_transformKey && Math.abs(e.deltaY) > 2) {
						// close PhotoSwipe
						// if browser supports transforms & scroll changed enough
						_closedByScroll = true;
						self.close();
					}

				}
				return true;
			}

			// allow just one event to fire
			e.stopPropagation();

			// https://developer.mozilla.org/en-US/docs/Web/Events/wheel
			_wheelDelta.x = 0;

			if('deltaX' in e) {
				if(e.deltaMode === 1 /* DOM_DELTA_LINE */) {
					// 18 - average line height
					_wheelDelta.x = e.deltaX * 18;
					_wheelDelta.y = e.deltaY * 18;
				} else {
					_wheelDelta.x = e.deltaX;
					_wheelDelta.y = e.deltaY;
				}
			} else if('wheelDelta' in e) {
				if(e.wheelDeltaX) {
					_wheelDelta.x = -0.16 * e.wheelDeltaX;
				}
				if(e.wheelDeltaY) {
					_wheelDelta.y = -0.16 * e.wheelDeltaY;
				} else {
					_wheelDelta.y = -0.16 * e.wheelDelta;
				}
			} else if('detail' in e) {
				_wheelDelta.y = e.detail;
			} else {
				return;
			}

			_calculatePanBounds(_currZoomLevel, true);

			var newPanX = _panOffset.x - _wheelDelta.x,
				newPanY = _panOffset.y - _wheelDelta.y;

			// only prevent scrolling in nonmodal mode when not at edges
			if (_options.modal ||
				(
				newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x &&
				newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y
				) ) {
				e.preventDefault();
			}

			// TODO: use rAF instead of mousewheel?
			self.panTo(newPanX, newPanY);
		},

		toggleDesktopZoom: function(centerPoint) {
			centerPoint = centerPoint || {x:_viewportSize.x/2 + _offset.x, y:_viewportSize.y/2 + _offset.y };

			var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
			var zoomOut = _currZoomLevel === doubleTapZoomLevel;
			
			self.mouseZoomedIn = !zoomOut;

			self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
			framework[ (!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
		}

	}
});


/*>>desktop-zoom*/

/*>>history*/
/**
 *
 * history.js:
 *
 * - Back button to close gallery.
 * 
 * - Unique URL for each slide: example.com/&pid=1&gid=3
 *   (where PID is picture index, and GID and gallery index)
 *   
 * - Switch URL when slides change.
 * 
 */


var _historyDefaultOptions = {
	history: true,
	galleryUID: 1
};

var _historyUpdateTimeout,
	_hashChangeTimeout,
	_hashAnimCheckTimeout,
	_hashChangedByScript,
	_hashChangedByHistory,
	_hashReseted,
	_initialHash,
	_historyChanged,
	_closedFromURL,
	_urlChangedOnce,
	_windowLoc,

	_supportsPushState,

	_getHash = function() {
		return _windowLoc.hash.substring(1);
	},
	_cleanHistoryTimeouts = function() {

		if(_historyUpdateTimeout) {
			clearTimeout(_historyUpdateTimeout);
		}

		if(_hashAnimCheckTimeout) {
			clearTimeout(_hashAnimCheckTimeout);
		}
	},

	// pid - Picture index
	// gid - Gallery index
	_parseItemIndexFromURL = function() {
		var hash = _getHash(),
			params = {};

		if(hash.length < 5) { // pid=1
			return params;
		}

		var i, vars = hash.split('&');
		for (i = 0; i < vars.length; i++) {
			if(!vars[i]) {
				continue;
			}
			var pair = vars[i].split('=');	
			if(pair.length < 2) {
				continue;
			}
			params[pair[0]] = pair[1];
		}
		if(_options.galleryPIDs) {
			// detect custom pid in hash and search for it among the items collection
			var searchfor = params.pid;
			params.pid = 0; // if custom pid cannot be found, fallback to the first item
			for(i = 0; i < _items.length; i++) {
				if(_items[i].pid === searchfor) {
					params.pid = i;
					break;
				}
			}
		} else {
			params.pid = parseInt(params.pid,10)-1;
		}
		if( params.pid < 0 ) {
			params.pid = 0;
		}
		return params;
	},
	_updateHash = function() {

		if(_hashAnimCheckTimeout) {
			clearTimeout(_hashAnimCheckTimeout);
		}


		if(_numAnimations || _isDragging) {
			// changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
			// that's why we update hash only when no animations running
			_hashAnimCheckTimeout = setTimeout(_updateHash, 500);
			return;
		}
		
		if(_hashChangedByScript) {
			clearTimeout(_hashChangeTimeout);
		} else {
			_hashChangedByScript = true;
		}


		var pid = (_currentItemIndex + 1);
		var item = _getItemAt( _currentItemIndex );
		if(item.hasOwnProperty('pid')) {
			// carry forward any custom pid assigned to the item
			pid = item.pid;
		}
		var newHash = _initialHash + '&'  +  'gid=' + _options.galleryUID + '&' + 'pid=' + pid;

		if(!_historyChanged) {
			if(_windowLoc.hash.indexOf(newHash) === -1) {
				_urlChangedOnce = true;
			}
			// first time - add new hisory record, then just replace
		}

		var newURL = _windowLoc.href.split('#')[0] + '#' +  newHash;

		if( _supportsPushState ) {

			if('#' + newHash !== window.location.hash) {
				history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
			}

		} else {
			if(_historyChanged) {
				_windowLoc.replace( newURL );
			} else {
				_windowLoc.hash = newHash;
			}
		}
		
		

		_historyChanged = true;
		_hashChangeTimeout = setTimeout(function() {
			_hashChangedByScript = false;
		}, 60);
	};



	

_registerModule('History', {

	

	publicMethods: {
		initHistory: function() {

			framework.extend(_options, _historyDefaultOptions, true);

			if( !_options.history ) {
				return;
			}


			_windowLoc = window.location;
			_urlChangedOnce = false;
			_closedFromURL = false;
			_historyChanged = false;
			_initialHash = _getHash();
			_supportsPushState = ('pushState' in history);


			if(_initialHash.indexOf('gid=') > -1) {
				_initialHash = _initialHash.split('&gid=')[0];
				_initialHash = _initialHash.split('?gid=')[0];
			}
			

			_listen('afterChange', self.updateURL);
			_listen('unbindEvents', function() {
				framework.unbind(window, 'hashchange', self.onHashChange);
			});


			var returnToOriginal = function() {
				_hashReseted = true;
				if(!_closedFromURL) {

					if(_urlChangedOnce) {
						history.back();
					} else {

						if(_initialHash) {
							_windowLoc.hash = _initialHash;
						} else {
							if (_supportsPushState) {

								// remove hash from url without refreshing it or scrolling to top
								history.pushState('', document.title,  _windowLoc.pathname + _windowLoc.search );
							} else {
								_windowLoc.hash = '';
							}
						}
					}
					
				}

				_cleanHistoryTimeouts();
			};


			_listen('unbindEvents', function() {
				if(_closedByScroll) {
					// if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
					// this is done to keep the scroll position
					returnToOriginal();
				}
			});
			_listen('destroy', function() {
				if(!_hashReseted) {
					returnToOriginal();
				}
			});
			_listen('firstUpdate', function() {
				_currentItemIndex = _parseItemIndexFromURL().pid;
			});

			

			
			var index = _initialHash.indexOf('pid=');
			if(index > -1) {
				_initialHash = _initialHash.substring(0, index);
				if(_initialHash.slice(-1) === '&') {
					_initialHash = _initialHash.slice(0, -1);
				}
			}
			

			setTimeout(function() {
				if(_isOpen) { // hasn't destroyed yet
					framework.bind(window, 'hashchange', self.onHashChange);
				}
			}, 40);
			
		},
		onHashChange: function() {

			if(_getHash() === _initialHash) {

				_closedFromURL = true;
				self.close();
				return;
			}
			if(!_hashChangedByScript) {

				_hashChangedByHistory = true;
				self.goTo( _parseItemIndexFromURL().pid );
				_hashChangedByHistory = false;
			}
			
		},
		updateURL: function() {

			// Delay the update of URL, to avoid lag during transition, 
			// and to not to trigger actions like "refresh page sound" or "blinking favicon" to often
			
			_cleanHistoryTimeouts();
			

			if(_hashChangedByHistory) {
				return;
			}

			if(!_historyChanged) {
				_updateHash(); // first time
			} else {
				_historyUpdateTimeout = setTimeout(_updateHash, 800);
			}
		}
	
	}
});


/*>>history*/
	framework.extend(self, publicMethods); };
	return PhotoSwipe;
});

/***/ }),

/***/ "hNm9":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.className
  })
},staticRenderFns: []}

/***/ }),

/***/ "hWfb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-tap-active{tap-highlight-color:transparent}.vux-tap-active:active{background-color:#ececec}", ""]);

// exports


/***/ }),

/***/ "hc1C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineDesc = __webpack_require__("pzLd");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_inlineDesc2.default.install = function (Vue) {
  Vue.component('LxInlineDesc', _inlineDesc2.default);
};

exports.default = _inlineDesc2.default;

/***/ }),

/***/ "hetT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiper = __webpack_require__("tO1L");

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_swiper2.default.install = function (Vue) {
  Vue.component('LxSwiper', _swiper2.default);
};

exports.default = _swiper2.default;

/***/ }),

/***/ "hlpk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

 var Util = __webpack_require__("rla3");

 function Boundry(cfg) {
     this.cfg = Util.mix({
         width: 0,
         height: 0
     }, cfg)
     this.init();
 }
 Util.mix(Boundry.prototype, {
     init: function() {
         var self = this;
         self._xtop = 0;
         self._xright = 0;
         self._xleft = 0;
         self._xbottom = 0;
         self.refresh({
             width: self.cfg.width,
             height: self.cfg.height
         });
     },
     reset: function() {
         this.resetTop();
         this.resetLeft();
         this.resetBottom();
         this.resetRight();
         return this;
     },
     resetTop: function() {
         this._xtop = 0;
         this.refresh();
         return this;
     },
     resetLeft: function() {
         this._xleft = 0;
         this.refresh();
         return this;
     },
     resetBottom: function() {
         this._xbottom = 0;
         this.refresh();
         return this;
     },
     resetRight: function() {
         this._xright = 0;
         this.refresh();
         return this;
     },
     expandTop: function(top) {
         this._xtop = top;
         this.refresh();
         return this;
     },
     expandLeft: function(left) {
         this._xleft = left;
         this.refresh();
         return this;
     },
     expandRight: function(right) {
         this._xright = right;
         this.refresh();
         return this;
     },
     expandBottom: function(bottom) {
         this._xbottom = bottom;
         this.refresh();
         return this;
     },
     refresh: function(cfg) {
         Util.mix(this.cfg, cfg);
         this.top = this._xtop;
         this.left = this._xleft;
         this.bottom = (cfg && cfg.height || this.cfg.height || 0) - this._xbottom;
         this.right = (cfg && cfg.width || this.cfg.width || 0) - this._xright;
         this.width = this.right - this.left > 0 ? this.right - this.left : 0;
         this.height = this.bottom - this.top > 0 ? this.bottom - this.top : 0;
         return this;
     }
 });


 if (typeof module == 'object' && module.exports) {
     module.exports = Boundry;
 }
 

/***/ }),

/***/ "hoPN":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab",
    class: {
      'vux-tab-no-animate': !_vm.animate
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.animate) ? _c('div', {
    staticClass: "vux-tab-ink-bar",
    class: _vm.barClass,
    style: (_vm.barStyle)
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ "hxh1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = __webpack_require__("T131");

var _base2 = _interopRequireDefault(_base);

var _objectFilter = __webpack_require__("pVtq");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_base2.default],
  filters: {
    getValue: _objectFilter.getValue,
    getKey: _objectFilter.getKey
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: String,
    fillMode: {
      type: Boolean,
      default: false
    },
    fillPlaceholder: {
      type: String,
      default: '其他'
    },
    fillLabel: {
      type: String,
      default: '其他'
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal);
      this.$emit('input', newVal);
    },
    value: function value(newVal) {
      this.currentValue = newVal;
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
};


function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}

/***/ }),

/***/ "i4WM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_rest__ = __webpack_require__("kq8S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("Jl4W");
/**
 * api 接口
 */

// api 插件

// api 配置

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__plugins_rest__["a" /* default */]);
// rest
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1__plugins_rest__["a" /* default */]({
  rest: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */]
}));

/***/ }),

/***/ "iCsi":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TfpO");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("143de3d2", content, true);

/***/ }),

/***/ "iQSq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "iWea":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('loading', {
    attrs: {
      "show": _vm.loading.status,
      "text": _vm.loading.text,
      "position": "absolute"
    }
  }), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": _vm.toast.time
    },
    model: {
      value: (_vm.toast.show),
      callback: function($$v) {
        _vm.$set(_vm.toast, "show", $$v)
      },
      expression: "toast.show"
    }
  }, [_vm._v(_vm._s(_vm.toast.text))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": 'vux-pop-' + (_vm.direction === 'forward' ? 'in' : 'out')
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "ieD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobile = __webpack_require__("mNQs");

var _popupPicker = __webpack_require__("SNea");

var _popupPicker2 = _interopRequireDefault(_popupPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var value2name = _mobile.tools.value2name;
var name2value = _mobile.tools.name2value;

exports.default = {
  components: {
    PopupPicker: _popupPicker2.default
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: false,
      default: function _default() {
        return _mobile.cvux;
      }
    },
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    showSecondName: Boolean,
    showName: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = name2value(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('Vux: Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return value2name(this.value, this.list);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  computed: {
    nameValue: function nameValue() {
      return value2name(this.currentValue, this.list);
    }
  },
  watch: {
    currentValue: function currentValue(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
        var addressName = this.nameValue.split(' ');
        var changeDate = {
          province: addressName[0],
          provinceCode: val[0],
          city: addressName[1],
          cityCode: val[1],
          district: addressName[2] ? addressName[2] : null,
          districtCode: val[2] ? val[2] : null
        };
        this.$emit('on-change', changeDate);
      }
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
};

/***/ }),

/***/ "igrb":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("RcWJ")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("4Ba1"),
  /* template */
  __webpack_require__("ihHh"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ihHh":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type === 'provinces') ? _c('popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "keyboard-content"
  }, _vm._l((_vm.provincesData), function(i, index) {
    return _c('ul', {
      key: index,
      staticClass: "keyboard-list"
    }, _vm._l((i), function(item, itemIndex) {
      return _c('li', {
        key: itemIndex,
        class: {
          'touch-start': _vm.currentTouchStart === item.value
        },
        on: {
          "click": function($event) {
            _vm.clickKey(item.value, 'provinces')
          },
          "touchstart": function($event) {
            _vm.handleTouchStart(item.value)
          },
          "touchend": function($event) {
            _vm.handleTouchEnd(item.value)
          }
        }
      }, [_vm._v("\n          " + _vm._s(item.value) + "\n        ")])
    }))
  }))]) : _vm._e(), _vm._v(" "), (_vm.type === 'alphanumeric') ? _c('popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "keyboard-content"
  }, _vm._l((_vm.alphanumeric), function(i, index) {
    return _c('ul', {
      key: index,
      staticClass: "keyboard-list"
    }, _vm._l((i), function(item, itemIndex) {
      return _c('li', {
        key: itemIndex,
        class: {
          'delete': item === 'delete',
            'touch-start': _vm.currentTouchStart === item,
            'end': item === 'end'
        },
        on: {
          "click": function($event) {
            _vm.clickKey(item, 'alphanumeric')
          },
          "touchstart": function($event) {
            _vm.handleTouchStart(item)
          },
          "touchend": function($event) {
            _vm.handleTouchEnd(item)
          }
        }
      }, [_vm._v("\n          " + _vm._s(_vm.showItem(item)) + "\n          "), (item === 'delete') ? _c('img', {
        staticClass: "delete-icon",
        attrs: {
          "src": __webpack_require__("ON1w")
        }
      }) : _vm._e()])
    }))
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "reference"
  }, [_vm._t("reference")], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "iodU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _arrayFrom = __webpack_require__("LwiA");

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = typeof window === 'undefined';

var Swiper = function () {
  function Swiper(options) {
    (0, _classCallCheck3.default)(this, Swiper);

    this._default = {
      container: '.vux-swiper',
      item: '.vux-swiper-item',
      direction: 'vertical',
      activeClass: 'active',
      threshold: 50,
      duration: 300,
      auto: false,
      loop: false,
      interval: 3000,
      height: 'auto',
      minMovingDistance: 0
    };
    this._options = (0, _objectAssign2.default)(this._default, options);
    this._options.height = this._options.height.replace('px', '');
    this._start = {};
    this._move = {};
    this._end = {};
    this._eventHandlers = {};
    this._prev = this._current = this._goto = 0;
    this._width = this._height = this._distance = 0;
    this._offset = [];
    this.$box = this._options.container;
    this.$container = this._options.container.querySelector('.vux-swiper');
    this.$items = this.$container.querySelectorAll(this._options.item);
    this.count = this.$items.length;
    this.realCount = this.$items.length;
    this._position = [];
    this._firstItemIndex = 0;
    if (!this.count) {
      return;
    }
    this._init();
    this._auto();
    this._bind();
    this._onResize();
    return this;
  }

  (0, _createClass3.default)(Swiper, [{
    key: '_auto',
    value: function _auto() {
      var me = this;
      me.stop();
      if (me._options.auto) {
        me.timer = setTimeout(function () {
          me.next();
        }, me._options.interval);
      }
    }
  }, {
    key: 'updateItemWidth',
    value: function updateItemWidth() {
      this._width = this.$box.offsetWidth;
      this._distance = this._options.direction === 'horizontal' ? this._width : this._height;
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.timer && clearTimeout(this.timer);
    }
  }, {
    key: '_loop',
    value: function _loop() {
      return this._options.loop && this.realCount >= 3;
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      var me = this;
      this.resizeHandler = function () {
        setTimeout(function () {
          me.updateItemWidth();
          me._setOffset();
          me._setTransfrom();
        }, 100);
      };
      window.addEventListener('orientationchange', this.resizeHandler, false);
    }
  }, {
    key: '_init',
    value: function _init() {
      if (this._options.loop) {
        this._loopTwoItems();
      }
      this._height = this._options.height === 'auto' ? 'auto' : this._options.height - 0;
      this.updateItemWidth();
      this._initPosition();
      this._activate(this._current);
      this._setOffset();
      this._setTransfrom();
      if (this._loop()) {
        this._loopRender();
      }
    }
  }, {
    key: '_initPosition',
    value: function _initPosition() {
      for (var i = 0; i < this.realCount; i++) {
        this._position.push(i);
      }
    }
  }, {
    key: '_movePosition',
    value: function _movePosition(position) {
      var me = this;
      if (position > 0) {
        var firstIndex = me._position.splice(0, 1);
        me._position.push(firstIndex[0]);
      } else if (position < 0) {
        var lastIndex = me._position.pop();
        me._position.unshift(lastIndex);
      }
    }
  }, {
    key: '_setOffset',
    value: function _setOffset() {
      var me = this;
      var index = me._position.indexOf(me._current);
      me._offset = [];
      (0, _arrayFrom2.default)(me.$items).forEach(function ($item, key) {
        me._offset.push((key - index) * me._distance);
      });
    }
  }, {
    key: '_setTransition',
    value: function _setTransition(duration) {
      duration = duration || this._options.duration || 'none';
      var transition = duration === 'none' ? 'none' : duration + 'ms';
      (0, _arrayFrom2.default)(this.$items).forEach(function ($item, key) {
        $item.style.webkitTransition = transition;
        $item.style.transition = transition;
      });
    }
  }, {
    key: '_setTransfrom',
    value: function _setTransfrom(offset) {
      var me = this;
      offset = offset || 0;
      (0, _arrayFrom2.default)(me.$items).forEach(function ($item, key) {
        var distance = me._offset[key] + offset;
        var transform = 'translate3d(' + distance + 'px, 0, 0)';
        if (me._options.direction === 'vertical') {
          transform = 'translate3d(0, ' + distance + 'px, 0)';
        }
        $item.style.webkitTransform = transform;
        $item.style.transform = transform;
      });
    }
  }, {
    key: '_bind',
    value: function _bind() {
      var me = this;
      me.touchstartHandler = function (e) {
        me.stop();
        me._start.x = e.changedTouches[0].pageX;
        me._start.y = e.changedTouches[0].pageY;
        me._setTransition('none');
      };
      me.touchmoveHandler = function (e) {
        me._move.x = e.changedTouches[0].pageX;
        me._move.y = e.changedTouches[0].pageY;
        var distanceX = me._move.x - me._start.x;
        var distanceY = me._move.y - me._start.y;
        var distance = distanceY;
        var noScrollerY = Math.abs(distanceX) > Math.abs(distanceY);
        if (me._options.direction === 'horizontal' && noScrollerY) {
          distance = distanceX;
        }
        if ((me._options.minMovingDistance && Math.abs(distance) >= me._options.minMovingDistance || !me._options.minMovingDistance) && noScrollerY) {
          me._setTransfrom(distance);
        }

        noScrollerY && e.preventDefault();
      };

      me.touchendHandler = function (e) {
        me._end.x = e.changedTouches[0].pageX;
        me._end.y = e.changedTouches[0].pageY;

        var distance = me._end.y - me._start.y;
        if (me._options.direction === 'horizontal') {
          distance = me._end.x - me._start.x;
        }

        distance = me.getDistance(distance);
        if (distance !== 0 && me._options.minMovingDistance && Math.abs(distance) < me._options.minMovingDistance) {
          return;
        }
        if (distance > me._options.threshold) {
          me.move(-1);
        } else if (distance < -me._options.threshold) {
          me.move(1);
        } else {
          me.move(0);
        }

        me._loopRender();
      };

      me.transitionEndHandler = function (e) {
        me._activate(me._current);
        var cb = me._eventHandlers.swiped;
        cb && cb.apply(me, [me._prev % me.count, me._current % me.count]);
        me._auto();
        me._loopRender();
        e.preventDefault();
      };
      me.$container.addEventListener('touchstart', me.touchstartHandler, false);
      me.$container.addEventListener('touchmove', me.touchmoveHandler, false);
      me.$container.addEventListener('touchend', me.touchendHandler, false);
      me.$items[1] && me.$items[1].addEventListener('webkitTransitionEnd', me.transitionEndHandler, false);
    }
  }, {
    key: '_loopTwoItems',
    value: function _loopTwoItems() {
      if (isServer) return;

      if (this.count === 2) {
        var div = document.createElement('div');
        var $item = void 0;
        for (var i = this.$items.length - 1; i >= 0; i--) {
          div.innerHTML = this.$items[i].outerHTML;
          $item = div.querySelector(this._options.item);
          $item.classList.add(this._options.item.replace('.', '') + '-clone');
          this.$container.appendChild($item);
        }
        this.realCount = 4;
      }
    }
  }, {
    key: '_loopRender',
    value: function _loopRender() {
      var me = this;
      if (me._loop()) {
        if (me._offset[me._offset.length - 1] === 0) {
          me.$container.appendChild(me.$items[0]);
          me._loopEvent(1);
        } else if (me._offset[0] === 0) {
          me.$container.insertBefore(me.$items[me.$items.length - 1], me.$container.firstChild);
          me._loopEvent(-1);
        }
      }
    }
  }, {
    key: '_loopEvent',
    value: function _loopEvent(num) {
      var me = this;
      me._itemDestoy();
      me.$items = me.$container.querySelectorAll(me._options.item);
      me.$items[1] && me.$items[1].addEventListener('webkitTransitionEnd', me.transitionEndHandler, false);
      me._movePosition(num);
      me._setOffset();
      me._setTransfrom();
    }
  }, {
    key: 'getDistance',
    value: function getDistance(distance) {
      if (this._loop()) {
        return distance;
      } else {
        if (distance > 0 && this._current === 0) {
          return 0;
        } else if (distance < 0 && this._current === this.realCount - 1) {
          return 0;
        } else {
          return distance;
        }
      }
    }
  }, {
    key: '_moveIndex',
    value: function _moveIndex(num) {
      if (num !== 0) {
        this._prev = this._current;
        this._current += this.realCount;
        this._current += num;
        this._current %= this.realCount;
      }
    }
  }, {
    key: '_activate',
    value: function _activate(index) {
      var clazz = this._options.activeClass;
      Array.prototype.forEach.call(this.$items, function ($item, key) {
        $item.classList.remove(clazz);
        if (index === Number($item.dataset.index)) {
          $item.classList.add(clazz);
        }
      });
    }
  }, {
    key: 'go',
    value: function go(index) {
      var me = this;
      me.stop();

      index = index || 0;
      index += this.realCount;
      index = index % this.realCount;
      index = this._position.indexOf(index) - this._position.indexOf(this._current);

      me._moveIndex(index);
      me._setOffset();
      me._setTransition();
      me._setTransfrom();
      me._auto();
      return this;
    }
  }, {
    key: 'next',
    value: function next() {
      this.move(1);
      return this;
    }
  }, {
    key: 'move',
    value: function move(num) {
      this.go(this._current + num);
      return this;
    }
  }, {
    key: 'on',
    value: function on(event, callback) {
      if (this._eventHandlers[event]) {
        console.error('[swiper] event ' + event + ' is already register');
      }
      if (typeof callback !== 'function') {
        console.error('[swiper] parameter callback must be a function');
      }
      this._eventHandlers[event] = callback;
      return this;
    }
  }, {
    key: '_itemDestoy',
    value: function _itemDestoy() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.$items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.removeEventListener('webkitTransitionEnd', this.transitionEndHandler, false);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (isServer) return;
      this.stop();
      this._current = 0;
      this._setTransfrom(0);
      window.removeEventListener('orientationchange', this.resizeHandler, false);
      this.$container.removeEventListener('touchstart', this.touchstartHandler, false);
      this.$container.removeEventListener('touchmove', this.touchmoveHandler, false);
      this.$container.removeEventListener('touchend', this.touchendHandler, false);
      this._itemDestoy();

      if (this._options.loop && this.count === 2) {
        var $item = this.$container.querySelector(this._options.item + '-clone');
        $item && this.$container.removeChild($item);
        $item = this.$container.querySelector(this._options.item + '-clone');
        $item && this.$container.removeChild($item);
      }
    }
  }]);
  return Swiper;
}();

exports.default = Swiper;

/***/ }),

/***/ "iuxd":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "vux-popup",
    style: ({
      height: _vm.height
    }),
    attrs: {
      "transition": "vux-popup"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "iys0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineCalendar = __webpack_require__("qnRG");

var _inlineCalendar2 = _interopRequireDefault(_inlineCalendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_inlineCalendar2.default.install = function (Vue) {
  Vue.component('LxInlineCalendar', _inlineCalendar2.default);
};

exports.default = _inlineCalendar2.default;

/***/ }),

/***/ "j+yQ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4czF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1885db85", content, true);

/***/ }),

/***/ "j4p2":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("gtsc")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("VZyn"),
  /* template */
  __webpack_require__("ZOVm"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "j9Fw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checklist = __webpack_require__("cPP0");

var _checklist2 = _interopRequireDefault(_checklist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_checklist2.default.install = function (Vue) {
  Vue.component('LxChecklist', _checklist2.default);
};

exports.default = _checklist2.default;

/***/ }),

/***/ "jFbC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Cdx3");
module.exports = __webpack_require__("FeBl").Object.keys;


/***/ }),

/***/ "jKW+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("kM2E");
var newPromiseCapability = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "jLAQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search_input"
  }, [_c('x-input', {
    attrs: {
      "placeholder": _vm.placeholder,
      "min": _vm.min,
      "max": _vm.max,
      "show-clear": _vm.showClear,
      "title": _vm.title
    },
    on: {
      "on-change": _vm.handleChange,
      "on-focus": _vm.handleFocus,
      "on-blur": _vm.handleBlur,
      "on-click-clear-icon": _vm.handleClickClear
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, [_vm._t("label", null, {
    slot: "label"
  }), _vm._v(" "), _c('img', {
    staticClass: "search_icon",
    attrs: {
      "slot": "right",
      "src": __webpack_require__("XQPt")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleSearch($event)
      }
    },
    slot: "right"
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "jYb5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//easing
var Easing = {
	"linear": [0, 0, 1, 1],
	"ease": [.25, .1, .25, 1],
	"ease-in":[.42,0,1,1],
	"ease-out": [0, 0, .58, 1],
	"ease-in-out": [.42, 0, .58, 1],
	"quadratic": [0.33, 0.66, 0.66, 1],
	"circular": [0.1, 0.57, 0.1, 1],
	"bounce": [.71, 1.35, .47, 1.41],
	format: function(easing) {
		if (!easing) return;
		if (typeof easing === "string" && this[easing]) {
			return this[easing] instanceof Array ? [" cubic-bezier(", this[easing], ") "].join("") : this[easing];
		}
		if (easing instanceof Array) {
			return [" cubic-bezier(", easing, ") "].join("");
		}
		return easing;
	}
}
if (typeof module == 'object' && module.exports) {
	module.exports = Easing;
}


/***/ }),

/***/ "jlVh":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Nwok")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("5UzD"),
  /* template */
  __webpack_require__("9waS"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "jvnJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*! PhotoSwipe main CSS by Dmitry Semenov | photoswipe.com | MIT license */.pswp{display:none;position:absolute;width:100%;height:100%;left:0;top:0;overflow:hidden;-ms-touch-action:none;touch-action:none;z-index:1500;-webkit-text-size-adjust:100%;-webkit-backface-visibility:hidden;outline:none}.pswp *{-webkit-box-sizing:border-box;box-sizing:border-box}.pswp img{max-width:none}.pswp--animate_opacity{opacity:.001;will-change:opacity;-webkit-transition:opacity 333ms cubic-bezier(.4,0,.22,1);transition:opacity 333ms cubic-bezier(.4,0,.22,1)}.pswp--open{display:block}.pswp--zoom-allowed .pswp__img{cursor:-webkit-zoom-in;cursor:-moz-zoom-in;cursor:zoom-in}.pswp--zoomed-in .pswp__img{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab}.pswp--dragging .pswp__img{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.pswp__bg{background:#000;opacity:0;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-backface-visibility:hidden}.pswp__bg,.pswp__scroll-wrap{position:absolute;left:0;top:0;width:100%;height:100%}.pswp__scroll-wrap{overflow:hidden}.pswp__container,.pswp__zoom-wrap{-ms-touch-action:none;touch-action:none;position:absolute;left:0;right:0;top:0;bottom:0}.pswp__container,.pswp__img{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none}.pswp__zoom-wrap{position:absolute;width:100%;-webkit-transform-origin:left top;-ms-transform-origin:left top;transform-origin:left top;-webkit-transition:-webkit-transform 333ms cubic-bezier(.4,0,.22,1);transition:transform 333ms cubic-bezier(.4,0,.22,1)}.pswp__bg{will-change:opacity;-webkit-transition:opacity 333ms cubic-bezier(.4,0,.22,1);transition:opacity 333ms cubic-bezier(.4,0,.22,1)}.pswp--animated-in .pswp__bg,.pswp--animated-in .pswp__zoom-wrap{-webkit-transition:none;transition:none}.pswp__container,.pswp__zoom-wrap{-webkit-backface-visibility:hidden}.pswp__item{right:0;bottom:0;overflow:hidden}.pswp__img,.pswp__item{position:absolute;left:0;top:0}.pswp__img{width:auto;height:auto}.pswp__img--placeholder{-webkit-backface-visibility:hidden}.pswp__img--placeholder--blank{background:#222}.pswp--ie .pswp__img{width:100%!important;height:auto!important;left:0;top:0}.pswp__error-msg{position:absolute;left:0;top:50%;width:100%;text-align:center;font-size:14px;line-height:16px;margin-top:-8px;color:#ccc}.pswp__error-msg a{color:#ccc;text-decoration:underline}", ""]);

// exports


/***/ }),

/***/ "jyFz":
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("SldL");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "jzLX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_btn.weui_btn_mini{line-height:1.9;font-size:.37333333rem;padding:0 .75em;display:inline-block}button.weui_btn,input.weui_btn{width:100%;border-width:0;outline:0;-webkit-appearance:none}button.weui_btn:focus,input.weui_btn:focus{outline:0}button.weui_btn_inline,button.weui_btn_mini,input.weui_btn_inline,input.weui_btn_mini{width:auto}.weui_btn.weui_btn_inline+.weui_btn.weui_btn_inline{margin-top:auto;margin-left:.4rem}.weui_btn_area{margin:50em .4rem .3em}.weui_btn_area.weui_btn_area_inline{display:-webkit-flex;display:flex}.weui_btn_area.weui_btn_area_inline .weui_btn{margin-top:auto;margin-right:.4rem;width:100%;-webkit-flex:1;flex:1}.weui_btn_area.weui_btn_area_inline .weui_btn:last-child{margin-right:0}.weui_btn{position:relative;display:block;margin-left:auto;margin-right:auto;padding-left:.37333333rem;padding-right:.37333333rem;box-sizing:border-box;font-size:.48rem;text-align:center;text-decoration:none;color:#fff;line-height:2.33333333;border-radius:5px;-webkit-tap-highlight-color:rgba(0,0,0,0);overflow:hidden}.weui_btn:after{content:\" \";width:200%;height:200%;position:absolute;top:0;left:0;border:1px solid rgba(0,0,0,.2);-webkit-transform:scale(.5);transform:scale(.5);-webkit-transform-origin:0 0;transform-origin:0 0;box-sizing:border-box;border-radius:10px}.weui_btn.weui_btn_inline{display:inline-block}.weui_btn_default{background-color:#f7f7f7;color:#454545}.weui_btn_default:not(.weui_btn_disabled):visited{color:#454545}.weui_btn_default:not(.weui_btn_disabled):active{color:#a1a1a1;background-color:#dedede}.weui_btn_primary{background-color:#3b5999}.weui_btn_primary:not(.weui_btn_disabled):visited{color:#fff}.weui_btn_primary:not(.weui_btn_disabled):active{color:hsla(0,0%,100%,.4);background-color:#283c64}.weui_btn_warn{background-color:#ef4f4f}.weui_btn_warn:not(.weui_btn_disabled):visited{color:#fff}.weui_btn_warn:not(.weui_btn_disabled):active{color:hsla(0,0%,100%,.4);background-color:#c13e3e}.weui_btn_disabled{color:hsla(0,0%,100%,.6)}.weui_btn_disabled.weui_btn_default{color:#c9c9c9}.weui_btn_plain_primary{color:#3b5999;border:1px solid #3b5999}button.weui_btn_plain_primary,input.weui_btn_plain_primary{border-width:1px;background-color:transparent}.weui_btn_plain_primary:active{border-color:#283c64}.weui_btn_plain_primary:after{border-width:0}.weui_btn_plain_default{color:#5a5a5a;border:1px solid #5a5a5a}button.weui_btn_plain_default,input.weui_btn_plain_default{border-width:1px;background-color:transparent}.weui_btn_plain_default:after{border-width:0}", ""]);

// exports


/***/ }),

/***/ "kFvY":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("zpZo")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("dXZI"),
  /* template */
  __webpack_require__("ypYz"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "kM2E":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var ctx = __webpack_require__("+ZMJ");
var hide = __webpack_require__("hJx8");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "kSun":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('group', {
    staticClass: "steps",
    attrs: {
      "title": _vm.title
    }
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('cell', {
      key: index,
      staticClass: "steps_item",
      attrs: {
        "bdStart": true
      }
    }, [_c('div', {
      staticClass: "step_status",
      attrs: {
        "slot": "icon"
      },
      slot: "icon"
    }, [_c('i', {
      staticClass: "status_line",
      class: {
        'status_line_blue': step.status !== 'not_started'
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon",
      class: _vm.iconClass[step.status]
    })]), _vm._v(" "), _c('div', {
      staticClass: "step_info",
      attrs: {
        "slot": "after-title"
      },
      slot: "after-title"
    }, [_c('div', {
      staticClass: "step_title_info"
    }, [_c('span', {
      staticClass: "step_title"
    }, [_vm._v(_vm._s(step.title))]), _vm._v(" "), (_vm.frKey) ? _c('span', {
      staticClass: "step_frKey"
    }, [_vm._v(_vm._s(step[_vm.frKey]))]) : _vm._e()]), _vm._v(" "), _vm._t("default", null, {
      step: step
    })], 2)])
  }))
},staticRenderFns: []}

/***/ }),

/***/ "kWsW":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("4xZT")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("VQZ3"),
  /* template */
  __webpack_require__("2t57"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "khXJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "kjxU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("pCng"), "");
exports.i(__webpack_require__("N3gE"), "");
exports.i(__webpack_require__("n3MF"), "");
exports.i(__webpack_require__("MZYl"), "");
exports.i(__webpack_require__("uFQh"), "");
exports.i(__webpack_require__("LXxo"), "");
exports.i(__webpack_require__("31Kt"), "");
exports.i(__webpack_require__("X3fh"), "");

// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "knUv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sticky = __webpack_require__("65cV");

var _sticky2 = _interopRequireDefault(_sticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_sticky2.default.install = function (Vue) {
  Vue.component('LxSticky', _sticky2.default);
};

exports.default = _sticky2.default;

/***/ }),

/***/ "knuC":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "kq8S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




/**
 * 服务接口
 * 以插件形式存在
 */
var Rest = function () {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Rest, null, [{
    key: 'install',
    value: function install() {}
  }]);

  function Rest() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Rest);

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this, options.rest);
  }

  return Rest;
}();

/* harmony default export */ __webpack_exports__["a"] = (Rest);


function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      if (options.rest) {
        this.$rest = options.rest;
      } else if (options.parent && options.parent.$rest) {
        this.$rest = options.parent.$rest;
      }
    }
  });
}

Rest.install = install;
Rest.version = '__VERSION__';

/***/ }),

/***/ "kqA7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Author: Alex Gibson
 * https://github.com/alexgibson/shake.js
 * License: MIT license
 */

(function(global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return factory(global, global.document);
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = factory(global, global.document);
    } else {
        global.Shake = factory(global, global.document);
    }
} (typeof window !== 'undefined' ? window : this, function (window, document) {

    'use strict';

    function Shake(options) {
        //feature detect
        this.hasDeviceMotion = 'ondevicemotion' in window;

        this.options = {
            threshold: 15, //default velocity threshold for shake to register
            timeout: 1000 //default interval between events
        };

        if (typeof options === 'object') {
            for (var i in options) {
                if (options.hasOwnProperty(i)) {
                    this.options[i] = options[i];
                }
            }
        }

        //use date to prevent multiple shakes firing
        this.lastTime = new Date();

        //accelerometer values
        this.lastX = null;
        this.lastY = null;
        this.lastZ = null;

        //create custom event
        if (typeof document.CustomEvent === 'function') {
            this.event = new document.CustomEvent('shake', {
                bubbles: true,
                cancelable: true
            });
        } else if (typeof document.createEvent === 'function') {
            this.event = document.createEvent('Event');
            this.event.initEvent('shake', true, true);
        } else {
            return false;
        }
    }

    //reset timer values
    Shake.prototype.reset = function () {
        this.lastTime = new Date();
        this.lastX = null;
        this.lastY = null;
        this.lastZ = null;
    };

    //start listening for devicemotion
    Shake.prototype.start = function () {
        this.reset();
        if (this.hasDeviceMotion) {
            window.addEventListener('devicemotion', this, false);
        }
    };

    //stop listening for devicemotion
    Shake.prototype.stop = function () {
        if (this.hasDeviceMotion) {
            window.removeEventListener('devicemotion', this, false);
        }
        this.reset();
    };

    //calculates if shake did occur
    Shake.prototype.devicemotion = function (e) {
        var current = e.accelerationIncludingGravity;
        var currentTime;
        var timeDifference;
        var deltaX = 0;
        var deltaY = 0;
        var deltaZ = 0;

        if ((this.lastX === null) && (this.lastY === null) && (this.lastZ === null)) {
            this.lastX = current.x;
            this.lastY = current.y;
            this.lastZ = current.z;
            return;
        }

        deltaX = Math.abs(this.lastX - current.x);
        deltaY = Math.abs(this.lastY - current.y);
        deltaZ = Math.abs(this.lastZ - current.z);

        if (((deltaX > this.options.threshold) && (deltaY > this.options.threshold)) || ((deltaX > this.options.threshold) && (deltaZ > this.options.threshold)) || ((deltaY > this.options.threshold) && (deltaZ > this.options.threshold))) {
            //calculate time in milliseconds since last shake registered
            currentTime = new Date();
            timeDifference = currentTime.getTime() - this.lastTime.getTime();

            if (timeDifference > this.options.timeout) {
                window.dispatchEvent(this.event);
                this.lastTime = new Date();
            }
        }

        this.lastX = current.x;
        this.lastY = current.y;
        this.lastZ = current.z;

    };

    //event handler
    Shake.prototype.handleEvent = function (e) {
        if (typeof (this[e.type]) === 'function') {
            return this[e.type](e);
        }
    };

    return Shake;
}));


/***/ }),

/***/ "kx2W":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+vFv");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("56131e08", content, true);

/***/ }),

/***/ "kxFB":
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ "l+Iq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_report__ = __webpack_require__("h6KC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("WsQ7");
/**
 * 数据上报
 */

// api 插件

// api 配置

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__plugins_report__["a" /* default */]);
// rest
var report = new __WEBPACK_IMPORTED_MODULE_1__plugins_report__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_vue__["default"], __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */]);
// 测试sentry是否正常配置
// if (report.captureMessage && !report.isProduction) {
//   report.captureMessage('test~')
// }
/* harmony default export */ __webpack_exports__["default"] = (report);

/***/ }),

/***/ "lOT8":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-swiper-item"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "lOnJ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "lUlh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_label{color:#000;display:block;width:2.4rem;word-wrap:break-word;word-break:break-all;padding-right:.13333333rem}.weui_input{width:100%;border:0;outline:0;-webkit-appearance:none;background-color:transparent;font-size:inherit;color:inherit;line-height:2.26666667}.weui_input::-webkit-inner-spin-button,.weui_input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.weui_textarea{display:block;border:0;resize:none;width:100%;color:inherit;font-size:.34666667rem;line-height:inherit;outline:0}.weui_textarea_counter{color:#999;text-align:right}.weui_cell_warn .weui_textarea_counter{color:#e64340}.weui_toptips{display:none;position:fixed;-webkit-transform:translateZ(0);width:100%;top:0;line-height:2.3;font-size:14px;text-align:center;color:#fff;z-index:50000}.weui_toptips.weui_warn{background-color:#e64340}.weui_cells_form .weui_cell_warn{color:#e64340}.weui_cells_form .weui_cell_warn .weui_icon_warn{display:inline-block}.weui_cells_form .weui_cell_ft{font-size:0}.weui_cells_form .weui_icon_warn{display:none}.weui_cells_form input,.weui_cells_form label[for],.weui_cells_form textarea{-webkit-tap-highlight-color:rgba(0,0,0,0)}.weui_cell.weui_cell_switch{padding-top:.29333333rem;padding-bottom:.29333333rem}.weui_switch{-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;width:1.38666667rem;height:.85333333rem;border:1px solid #dfdfdf;outline:0;border-radius:16px;box-sizing:border-box;background:#dfdfdf}.weui_switch:before{width:1.33333333rem;background-color:#fdfdfd}.weui_switch:after,.weui_switch:before{content:\" \";position:absolute;top:0;left:0;height:.8rem;border-radius:15px;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.weui_switch:after{width:.8rem;background-color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.4)}.weui_switch:checked{border-color:#5890ff;background-color:#5890ff}.weui_switch:checked:before{-webkit-transform:scale(0);transform:scale(0)}.weui_switch:checked:after{-webkit-transform:translateX(20px);transform:translateX(20px)}.weui_cell_switch .weui_cell_ft{font-size:0}", ""]);

// exports


/***/ }),

/***/ "lYBz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xSwitch = __webpack_require__("Lrpu");

var _xSwitch2 = _interopRequireDefault(_xSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xSwitch2.default.install = function (Vue) {
  Vue.component('LxXSwitch', _xSwitch2.default);
};

exports.default = _xSwitch2.default;

/***/ }),

/***/ "larr":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ziR6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4ed0d79f", content, true);

/***/ }),

/***/ "lktj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Ibhu");
var enumBugKeys = __webpack_require__("xnc9");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "lsGX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    value: {
      type: String,
      default: ''
    },
    renderMonth: {
      type: Array, default: function _default() {
        return [null, null];
      }
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    },
    showLastMonth: {
      type: Boolean,
      default: true
    },
    showNextMonth: {
      type: Boolean,
      default: true
    },
    highlightWeekend: {
      type: Boolean,
      default: false
    },
    returnSixRows: {
      type: Boolean,
      default: true
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideWeekList: {
      type: Boolean,
      default: false
    },
    replaceTextList: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    weeksList: {
      type: Array,
      default: function _default() {
        return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
      }
    },
    customSlotFn: {
      type: Function,
      default: function _default() {
        return '';
      }
    },
    renderOnValueChange: {
      type: Boolean,
      default: true
    },
    disablePast: {
      type: Boolean,
      default: false
    },
    disableFuture: {
      type: Boolean,
      default: false
    }
  };
};

/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "mNQs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var map = _interopDefault(__webpack_require__("diSF"));
var find = _interopDefault(__webpack_require__("NXHL"));

var cvux = [{
  "name": "北京市",
  "value": "110000"
}, {
  "name": "天津市",
  "value": "120000"
}, {
  "name": "河北省",
  "value": "130000"
}, {
  "name": "山西省",
  "value": "140000"
}, {
  "name": "内蒙古自治区",
  "value": "150000"
}, {
  "name": "辽宁省",
  "value": "210000"
}, {
  "name": "吉林省",
  "value": "220000"
}, {
  "name": "黑龙江省",
  "value": "230000"
}, {
  "name": "上海市",
  "value": "310000"
}, {
  "name": "江苏省",
  "value": "320000"
}, {
  "name": "浙江省",
  "value": "330000"
}, {
  "name": "安徽省",
  "value": "340000"
}, {
  "name": "福建省",
  "value": "350000"
}, {
  "name": "江西省",
  "value": "360000"
}, {
  "name": "山东省",
  "value": "370000"
}, {
  "name": "河南省",
  "value": "410000"
}, {
  "name": "湖北省",
  "value": "420000"
}, {
  "name": "湖南省",
  "value": "430000"
}, {
  "name": "广东省",
  "value": "440000"
}, {
  "name": "广西壮族自治区",
  "value": "450000"
}, {
  "name": "海南省",
  "value": "460000"
}, {
  "name": "重庆市",
  "value": "500000"
}, {
  "name": "四川省",
  "value": "510000"
}, {
  "name": "贵州省",
  "value": "520000"
}, {
  "name": "云南省",
  "value": "530000"
}, {
  "name": "西藏自治区",
  "value": "540000"
}, {
  "name": "陕西省",
  "value": "610000"
}, {
  "name": "甘肃省",
  "value": "620000"
}, {
  "name": "青海省",
  "value": "630000"
}, {
  "name": "宁夏回族自治区",
  "value": "640000"
}, {
  "name": "新疆维吾尔自治区",
  "value": "650000"
}, {
  "name": "台湾省",
  "value": "710000"
}, {
  "name": "香港特别行政区",
  "value": "810000"
}, {
  "name": "澳门特别行政区",
  "value": "820000"
}, {
  "name": "北京市市辖区",
  "value": "110100",
  "parent": "110000"
}, {
  "name": "东城区",
  "value": "110101",
  "parent": "110100"
}, {
  "name": "西城区",
  "value": "110102",
  "parent": "110100"
}, {
  "name": "朝阳区",
  "value": "110105",
  "parent": "110100"
}, {
  "name": "丰台区",
  "value": "110106",
  "parent": "110100"
}, {
  "name": "石景山区",
  "value": "110107",
  "parent": "110100"
}, {
  "name": "海淀区",
  "value": "110108",
  "parent": "110100"
}, {
  "name": "门头沟区",
  "value": "110109",
  "parent": "110100"
}, {
  "name": "房山区",
  "value": "110111",
  "parent": "110100"
}, {
  "name": "通州区",
  "value": "110112",
  "parent": "110100"
}, {
  "name": "顺义区",
  "value": "110113",
  "parent": "110100"
}, {
  "name": "昌平区",
  "value": "110114",
  "parent": "110100"
}, {
  "name": "大兴区",
  "value": "110115",
  "parent": "110100"
}, {
  "name": "怀柔区",
  "value": "110116",
  "parent": "110100"
}, {
  "name": "平谷区",
  "value": "110117",
  "parent": "110100"
}, {
  "name": "密云区",
  "value": "110118",
  "parent": "110100"
}, {
  "name": "延庆区",
  "value": "110119",
  "parent": "110100"
}, {
  "name": "天津市市辖区",
  "value": "120100",
  "parent": "120000"
}, {
  "name": "天津市郊县",
  "value": "120200",
  "parent": "120000"
}, {
  "name": "和平区",
  "value": "120101",
  "parent": "120100"
}, {
  "name": "河东区",
  "value": "120102",
  "parent": "120100"
}, {
  "name": "河西区",
  "value": "120103",
  "parent": "120100"
}, {
  "name": "南开区",
  "value": "120104",
  "parent": "120100"
}, {
  "name": "河北区",
  "value": "120105",
  "parent": "120100"
}, {
  "name": "红桥区",
  "value": "120106",
  "parent": "120100"
}, {
  "name": "东丽区",
  "value": "120110",
  "parent": "120100"
}, {
  "name": "西青区",
  "value": "120111",
  "parent": "120100"
}, {
  "name": "津南区",
  "value": "120112",
  "parent": "120100"
}, {
  "name": "北辰区",
  "value": "120113",
  "parent": "120100"
}, {
  "name": "武清区",
  "value": "120114",
  "parent": "120100"
}, {
  "name": "宝坻区",
  "value": "120115",
  "parent": "120100"
}, {
  "name": "滨海新区",
  "value": "120116",
  "parent": "120100"
}, {
  "name": "宁河区",
  "value": "120117",
  "parent": "120100"
}, {
  "name": "静海区",
  "value": "120118",
  "parent": "120100"
}, {
  "name": "蓟县",
  "value": "120225",
  "parent": "120100"
}, {
  "name": "石家庄市",
  "value": "130100",
  "parent": "130000"
}, {
  "name": "唐山市",
  "value": "130200",
  "parent": "130000"
}, {
  "name": "秦皇岛市",
  "value": "130300",
  "parent": "130000"
}, {
  "name": "邯郸市",
  "value": "130400",
  "parent": "130000"
}, {
  "name": "邢台市",
  "value": "130500",
  "parent": "130000"
}, {
  "name": "保定市",
  "value": "130600",
  "parent": "130000"
}, {
  "name": "张家口市",
  "value": "130700",
  "parent": "130000"
}, {
  "name": "承德市",
  "value": "130800",
  "parent": "130000"
}, {
  "name": "沧州市",
  "value": "130900",
  "parent": "130000"
}, {
  "name": "廊坊市",
  "value": "131000",
  "parent": "130000"
}, {
  "name": "衡水市",
  "value": "131100",
  "parent": "130000"
}, {
  "name": "长安区",
  "value": "130102",
  "parent": "130100"
}, {
  "name": "桥西区",
  "value": "130104",
  "parent": "130100"
}, {
  "name": "新华区",
  "value": "130105",
  "parent": "130100"
}, {
  "name": "井陉矿区",
  "value": "130107",
  "parent": "130100"
}, {
  "name": "裕华区",
  "value": "130108",
  "parent": "130100"
}, {
  "name": "藁城区",
  "value": "130109",
  "parent": "130100"
}, {
  "name": "鹿泉区",
  "value": "130110",
  "parent": "130100"
}, {
  "name": "栾城区",
  "value": "130111",
  "parent": "130100"
}, {
  "name": "井陉县",
  "value": "130121",
  "parent": "130100"
}, {
  "name": "正定县",
  "value": "130123",
  "parent": "130100"
}, {
  "name": "行唐县",
  "value": "130125",
  "parent": "130100"
}, {
  "name": "灵寿县",
  "value": "130126",
  "parent": "130100"
}, {
  "name": "高邑县",
  "value": "130127",
  "parent": "130100"
}, {
  "name": "深泽县",
  "value": "130128",
  "parent": "130100"
}, {
  "name": "赞皇县",
  "value": "130129",
  "parent": "130100"
}, {
  "name": "无极县",
  "value": "130130",
  "parent": "130100"
}, {
  "name": "平山县",
  "value": "130131",
  "parent": "130100"
}, {
  "name": "元氏县",
  "value": "130132",
  "parent": "130100"
}, {
  "name": "赵县",
  "value": "130133",
  "parent": "130100"
}, {
  "name": "辛集市",
  "value": "130181",
  "parent": "130100"
}, {
  "name": "晋州市",
  "value": "130183",
  "parent": "130100"
}, {
  "name": "新乐市",
  "value": "130184",
  "parent": "130100"
}, {
  "name": "路南区",
  "value": "130202",
  "parent": "130200"
}, {
  "name": "路北区",
  "value": "130203",
  "parent": "130200"
}, {
  "name": "古冶区",
  "value": "130204",
  "parent": "130200"
}, {
  "name": "开平区",
  "value": "130205",
  "parent": "130200"
}, {
  "name": "丰南区",
  "value": "130207",
  "parent": "130200"
}, {
  "name": "丰润区",
  "value": "130208",
  "parent": "130200"
}, {
  "name": "曹妃甸区",
  "value": "130209",
  "parent": "130200"
}, {
  "name": "滦县",
  "value": "130223",
  "parent": "130200"
}, {
  "name": "滦南县",
  "value": "130224",
  "parent": "130200"
}, {
  "name": "乐亭县",
  "value": "130225",
  "parent": "130200"
}, {
  "name": "迁西县",
  "value": "130227",
  "parent": "130200"
}, {
  "name": "玉田县",
  "value": "130229",
  "parent": "130200"
}, {
  "name": "遵化市",
  "value": "130281",
  "parent": "130200"
}, {
  "name": "迁安市",
  "value": "130283",
  "parent": "130200"
}, {
  "name": "海港区",
  "value": "130302",
  "parent": "130300"
}, {
  "name": "山海关区",
  "value": "130303",
  "parent": "130300"
}, {
  "name": "北戴河区",
  "value": "130304",
  "parent": "130300"
}, {
  "name": "抚宁区",
  "value": "130306",
  "parent": "130300"
}, {
  "name": "青龙满族自治县",
  "value": "130321",
  "parent": "130300"
}, {
  "name": "昌黎县",
  "value": "130322",
  "parent": "130300"
}, {
  "name": "卢龙县",
  "value": "130324",
  "parent": "130300"
}, {
  "name": "邯山区",
  "value": "130402",
  "parent": "130400"
}, {
  "name": "丛台区",
  "value": "130403",
  "parent": "130400"
}, {
  "name": "复兴区",
  "value": "130404",
  "parent": "130400"
}, {
  "name": "峰峰矿区",
  "value": "130406",
  "parent": "130400"
}, {
  "name": "邯郸县",
  "value": "130421",
  "parent": "130400"
}, {
  "name": "临漳县",
  "value": "130423",
  "parent": "130400"
}, {
  "name": "成安县",
  "value": "130424",
  "parent": "130400"
}, {
  "name": "大名县",
  "value": "130425",
  "parent": "130400"
}, {
  "name": "涉县",
  "value": "130426",
  "parent": "130400"
}, {
  "name": "磁县",
  "value": "130427",
  "parent": "130400"
}, {
  "name": "肥乡县",
  "value": "130428",
  "parent": "130400"
}, {
  "name": "永年县",
  "value": "130429",
  "parent": "130400"
}, {
  "name": "邱县",
  "value": "130430",
  "parent": "130400"
}, {
  "name": "鸡泽县",
  "value": "130431",
  "parent": "130400"
}, {
  "name": "广平县",
  "value": "130432",
  "parent": "130400"
}, {
  "name": "馆陶县",
  "value": "130433",
  "parent": "130400"
}, {
  "name": "魏县",
  "value": "130434",
  "parent": "130400"
}, {
  "name": "曲周县",
  "value": "130435",
  "parent": "130400"
}, {
  "name": "武安市",
  "value": "130481",
  "parent": "130400"
}, {
  "name": "桥东区",
  "value": "130502",
  "parent": "130500"
}, {
  "name": "桥西区",
  "value": "130503",
  "parent": "130500"
}, {
  "name": "邢台县",
  "value": "130521",
  "parent": "130500"
}, {
  "name": "临城县",
  "value": "130522",
  "parent": "130500"
}, {
  "name": "内丘县",
  "value": "130523",
  "parent": "130500"
}, {
  "name": "柏乡县",
  "value": "130524",
  "parent": "130500"
}, {
  "name": "隆尧县",
  "value": "130525",
  "parent": "130500"
}, {
  "name": "任县",
  "value": "130526",
  "parent": "130500"
}, {
  "name": "南和县",
  "value": "130527",
  "parent": "130500"
}, {
  "name": "宁晋县",
  "value": "130528",
  "parent": "130500"
}, {
  "name": "巨鹿县",
  "value": "130529",
  "parent": "130500"
}, {
  "name": "新河县",
  "value": "130530",
  "parent": "130500"
}, {
  "name": "广宗县",
  "value": "130531",
  "parent": "130500"
}, {
  "name": "平乡县",
  "value": "130532",
  "parent": "130500"
}, {
  "name": "威县",
  "value": "130533",
  "parent": "130500"
}, {
  "name": "清河县",
  "value": "130534",
  "parent": "130500"
}, {
  "name": "临西县",
  "value": "130535",
  "parent": "130500"
}, {
  "name": "南宫市",
  "value": "130581",
  "parent": "130500"
}, {
  "name": "沙河市",
  "value": "130582",
  "parent": "130500"
}, {
  "name": "竞秀区",
  "value": "130602",
  "parent": "130600"
}, {
  "name": "莲池区",
  "value": "130606",
  "parent": "130600"
}, {
  "name": "满城区",
  "value": "130607",
  "parent": "130600"
}, {
  "name": "清苑区",
  "value": "130608",
  "parent": "130600"
}, {
  "name": "徐水区",
  "value": "130609",
  "parent": "130600"
}, {
  "name": "涞水县",
  "value": "130623",
  "parent": "130600"
}, {
  "name": "阜平县",
  "value": "130624",
  "parent": "130600"
}, {
  "name": "定兴县",
  "value": "130626",
  "parent": "130600"
}, {
  "name": "唐县",
  "value": "130627",
  "parent": "130600"
}, {
  "name": "高阳县",
  "value": "130628",
  "parent": "130600"
}, {
  "name": "容城县",
  "value": "130629",
  "parent": "130600"
}, {
  "name": "涞源县",
  "value": "130630",
  "parent": "130600"
}, {
  "name": "望都县",
  "value": "130631",
  "parent": "130600"
}, {
  "name": "安新县",
  "value": "130632",
  "parent": "130600"
}, {
  "name": "易县",
  "value": "130633",
  "parent": "130600"
}, {
  "name": "曲阳县",
  "value": "130634",
  "parent": "130600"
}, {
  "name": "蠡县",
  "value": "130635",
  "parent": "130600"
}, {
  "name": "顺平县",
  "value": "130636",
  "parent": "130600"
}, {
  "name": "博野县",
  "value": "130637",
  "parent": "130600"
}, {
  "name": "雄县",
  "value": "130638",
  "parent": "130600"
}, {
  "name": "涿州市",
  "value": "130681",
  "parent": "130600"
}, {
  "name": "定州市",
  "value": "130682",
  "parent": "130600"
}, {
  "name": "安国市",
  "value": "130683",
  "parent": "130600"
}, {
  "name": "高碑店市",
  "value": "130684",
  "parent": "130600"
}, {
  "name": "桥东区",
  "value": "130702",
  "parent": "130700"
}, {
  "name": "桥西区",
  "value": "130703",
  "parent": "130700"
}, {
  "name": "宣化区",
  "value": "130705",
  "parent": "130700"
}, {
  "name": "下花园区",
  "value": "130706",
  "parent": "130700"
}, {
  "name": "宣化县",
  "value": "130721",
  "parent": "130700"
}, {
  "name": "张北县",
  "value": "130722",
  "parent": "130700"
}, {
  "name": "康保县",
  "value": "130723",
  "parent": "130700"
}, {
  "name": "沽源县",
  "value": "130724",
  "parent": "130700"
}, {
  "name": "尚义县",
  "value": "130725",
  "parent": "130700"
}, {
  "name": "蔚县",
  "value": "130726",
  "parent": "130700"
}, {
  "name": "阳原县",
  "value": "130727",
  "parent": "130700"
}, {
  "name": "怀安县",
  "value": "130728",
  "parent": "130700"
}, {
  "name": "万全县",
  "value": "130729",
  "parent": "130700"
}, {
  "name": "怀来县",
  "value": "130730",
  "parent": "130700"
}, {
  "name": "涿鹿县",
  "value": "130731",
  "parent": "130700"
}, {
  "name": "赤城县",
  "value": "130732",
  "parent": "130700"
}, {
  "name": "崇礼县",
  "value": "130733",
  "parent": "130700"
}, {
  "name": "双桥区",
  "value": "130802",
  "parent": "130800"
}, {
  "name": "双滦区",
  "value": "130803",
  "parent": "130800"
}, {
  "name": "鹰手营子矿区",
  "value": "130804",
  "parent": "130800"
}, {
  "name": "承德县",
  "value": "130821",
  "parent": "130800"
}, {
  "name": "兴隆县",
  "value": "130822",
  "parent": "130800"
}, {
  "name": "平泉县",
  "value": "130823",
  "parent": "130800"
}, {
  "name": "滦平县",
  "value": "130824",
  "parent": "130800"
}, {
  "name": "隆化县",
  "value": "130825",
  "parent": "130800"
}, {
  "name": "丰宁满族自治县",
  "value": "130826",
  "parent": "130800"
}, {
  "name": "宽城满族自治县",
  "value": "130827",
  "parent": "130800"
}, {
  "name": "围场满族蒙古族自治县",
  "value": "130828",
  "parent": "130800"
}, {
  "name": "新华区",
  "value": "130902",
  "parent": "130900"
}, {
  "name": "运河区",
  "value": "130903",
  "parent": "130900"
}, {
  "name": "沧县",
  "value": "130921",
  "parent": "130900"
}, {
  "name": "青县",
  "value": "130922",
  "parent": "130900"
}, {
  "name": "东光县",
  "value": "130923",
  "parent": "130900"
}, {
  "name": "海兴县",
  "value": "130924",
  "parent": "130900"
}, {
  "name": "盐山县",
  "value": "130925",
  "parent": "130900"
}, {
  "name": "肃宁县",
  "value": "130926",
  "parent": "130900"
}, {
  "name": "南皮县",
  "value": "130927",
  "parent": "130900"
}, {
  "name": "吴桥县",
  "value": "130928",
  "parent": "130900"
}, {
  "name": "献县",
  "value": "130929",
  "parent": "130900"
}, {
  "name": "孟村回族自治县",
  "value": "130930",
  "parent": "130900"
}, {
  "name": "泊头市",
  "value": "130981",
  "parent": "130900"
}, {
  "name": "任丘市",
  "value": "130982",
  "parent": "130900"
}, {
  "name": "黄骅市",
  "value": "130983",
  "parent": "130900"
}, {
  "name": "河间市",
  "value": "130984",
  "parent": "130900"
}, {
  "name": "安次区",
  "value": "131002",
  "parent": "131000"
}, {
  "name": "广阳区",
  "value": "131003",
  "parent": "131000"
}, {
  "name": "固安县",
  "value": "131022",
  "parent": "131000"
}, {
  "name": "永清县",
  "value": "131023",
  "parent": "131000"
}, {
  "name": "香河县",
  "value": "131024",
  "parent": "131000"
}, {
  "name": "大城县",
  "value": "131025",
  "parent": "131000"
}, {
  "name": "文安县",
  "value": "131026",
  "parent": "131000"
}, {
  "name": "大厂回族自治县",
  "value": "131028",
  "parent": "131000"
}, {
  "name": "霸州市",
  "value": "131081",
  "parent": "131000"
}, {
  "name": "三河市",
  "value": "131082",
  "parent": "131000"
}, {
  "name": "桃城区",
  "value": "131102",
  "parent": "131100"
}, {
  "name": "枣强县",
  "value": "131121",
  "parent": "131100"
}, {
  "name": "武邑县",
  "value": "131122",
  "parent": "131100"
}, {
  "name": "武强县",
  "value": "131123",
  "parent": "131100"
}, {
  "name": "饶阳县",
  "value": "131124",
  "parent": "131100"
}, {
  "name": "安平县",
  "value": "131125",
  "parent": "131100"
}, {
  "name": "故城县",
  "value": "131126",
  "parent": "131100"
}, {
  "name": "景县",
  "value": "131127",
  "parent": "131100"
}, {
  "name": "阜城县",
  "value": "131128",
  "parent": "131100"
}, {
  "name": "冀州市",
  "value": "131181",
  "parent": "131100"
}, {
  "name": "深州市",
  "value": "131182",
  "parent": "131100"
}, {
  "name": "太原市",
  "value": "140100",
  "parent": "140000"
}, {
  "name": "大同市",
  "value": "140200",
  "parent": "140000"
}, {
  "name": "阳泉市",
  "value": "140300",
  "parent": "140000"
}, {
  "name": "长治市",
  "value": "140400",
  "parent": "140000"
}, {
  "name": "晋城市",
  "value": "140500",
  "parent": "140000"
}, {
  "name": "朔州市",
  "value": "140600",
  "parent": "140000"
}, {
  "name": "晋中市",
  "value": "140700",
  "parent": "140000"
}, {
  "name": "运城市",
  "value": "140800",
  "parent": "140000"
}, {
  "name": "忻州市",
  "value": "140900",
  "parent": "140000"
}, {
  "name": "临汾市",
  "value": "141000",
  "parent": "140000"
}, {
  "name": "吕梁市",
  "value": "141100",
  "parent": "140000"
}, {
  "name": "小店区",
  "value": "140105",
  "parent": "140100"
}, {
  "name": "迎泽区",
  "value": "140106",
  "parent": "140100"
}, {
  "name": "杏花岭区",
  "value": "140107",
  "parent": "140100"
}, {
  "name": "尖草坪区",
  "value": "140108",
  "parent": "140100"
}, {
  "name": "万柏林区",
  "value": "140109",
  "parent": "140100"
}, {
  "name": "晋源区",
  "value": "140110",
  "parent": "140100"
}, {
  "name": "清徐县",
  "value": "140121",
  "parent": "140100"
}, {
  "name": "阳曲县",
  "value": "140122",
  "parent": "140100"
}, {
  "name": "娄烦县",
  "value": "140123",
  "parent": "140100"
}, {
  "name": "古交市",
  "value": "140181",
  "parent": "140100"
}, {
  "name": "城区",
  "value": "140202",
  "parent": "140200"
}, {
  "name": "矿区",
  "value": "140203",
  "parent": "140200"
}, {
  "name": "南郊区",
  "value": "140211",
  "parent": "140200"
}, {
  "name": "新荣区",
  "value": "140212",
  "parent": "140200"
}, {
  "name": "阳高县",
  "value": "140221",
  "parent": "140200"
}, {
  "name": "天镇县",
  "value": "140222",
  "parent": "140200"
}, {
  "name": "广灵县",
  "value": "140223",
  "parent": "140200"
}, {
  "name": "灵丘县",
  "value": "140224",
  "parent": "140200"
}, {
  "name": "浑源县",
  "value": "140225",
  "parent": "140200"
}, {
  "name": "左云县",
  "value": "140226",
  "parent": "140200"
}, {
  "name": "大同县",
  "value": "140227",
  "parent": "140200"
}, {
  "name": "城区",
  "value": "140302",
  "parent": "140300"
}, {
  "name": "矿区",
  "value": "140303",
  "parent": "140300"
}, {
  "name": "郊区",
  "value": "140311",
  "parent": "140300"
}, {
  "name": "平定县",
  "value": "140321",
  "parent": "140300"
}, {
  "name": "盂县",
  "value": "140322",
  "parent": "140300"
}, {
  "name": "城区",
  "value": "140402",
  "parent": "140400"
}, {
  "name": "郊区",
  "value": "140411",
  "parent": "140400"
}, {
  "name": "长治县",
  "value": "140421",
  "parent": "140400"
}, {
  "name": "襄垣县",
  "value": "140423",
  "parent": "140400"
}, {
  "name": "屯留县",
  "value": "140424",
  "parent": "140400"
}, {
  "name": "平顺县",
  "value": "140425",
  "parent": "140400"
}, {
  "name": "黎城县",
  "value": "140426",
  "parent": "140400"
}, {
  "name": "壶关县",
  "value": "140427",
  "parent": "140400"
}, {
  "name": "长子县",
  "value": "140428",
  "parent": "140400"
}, {
  "name": "武乡县",
  "value": "140429",
  "parent": "140400"
}, {
  "name": "沁县",
  "value": "140430",
  "parent": "140400"
}, {
  "name": "沁源县",
  "value": "140431",
  "parent": "140400"
}, {
  "name": "潞城市",
  "value": "140481",
  "parent": "140400"
}, {
  "name": "城区",
  "value": "140502",
  "parent": "140500"
}, {
  "name": "沁水县",
  "value": "140521",
  "parent": "140500"
}, {
  "name": "阳城县",
  "value": "140522",
  "parent": "140500"
}, {
  "name": "陵川县",
  "value": "140524",
  "parent": "140500"
}, {
  "name": "泽州县",
  "value": "140525",
  "parent": "140500"
}, {
  "name": "高平市",
  "value": "140581",
  "parent": "140500"
}, {
  "name": "朔城区",
  "value": "140602",
  "parent": "140600"
}, {
  "name": "平鲁区",
  "value": "140603",
  "parent": "140600"
}, {
  "name": "山阴县",
  "value": "140621",
  "parent": "140600"
}, {
  "name": "应县",
  "value": "140622",
  "parent": "140600"
}, {
  "name": "右玉县",
  "value": "140623",
  "parent": "140600"
}, {
  "name": "怀仁县",
  "value": "140624",
  "parent": "140600"
}, {
  "name": "榆次区",
  "value": "140702",
  "parent": "140700"
}, {
  "name": "榆社县",
  "value": "140721",
  "parent": "140700"
}, {
  "name": "左权县",
  "value": "140722",
  "parent": "140700"
}, {
  "name": "和顺县",
  "value": "140723",
  "parent": "140700"
}, {
  "name": "昔阳县",
  "value": "140724",
  "parent": "140700"
}, {
  "name": "寿阳县",
  "value": "140725",
  "parent": "140700"
}, {
  "name": "太谷县",
  "value": "140726",
  "parent": "140700"
}, {
  "name": "祁县",
  "value": "140727",
  "parent": "140700"
}, {
  "name": "平遥县",
  "value": "140728",
  "parent": "140700"
}, {
  "name": "灵石县",
  "value": "140729",
  "parent": "140700"
}, {
  "name": "介休市",
  "value": "140781",
  "parent": "140700"
}, {
  "name": "盐湖区",
  "value": "140802",
  "parent": "140800"
}, {
  "name": "临猗县",
  "value": "140821",
  "parent": "140800"
}, {
  "name": "万荣县",
  "value": "140822",
  "parent": "140800"
}, {
  "name": "闻喜县",
  "value": "140823",
  "parent": "140800"
}, {
  "name": "稷山县",
  "value": "140824",
  "parent": "140800"
}, {
  "name": "新绛县",
  "value": "140825",
  "parent": "140800"
}, {
  "name": "绛县",
  "value": "140826",
  "parent": "140800"
}, {
  "name": "垣曲县",
  "value": "140827",
  "parent": "140800"
}, {
  "name": "夏县",
  "value": "140828",
  "parent": "140800"
}, {
  "name": "平陆县",
  "value": "140829",
  "parent": "140800"
}, {
  "name": "芮城县",
  "value": "140830",
  "parent": "140800"
}, {
  "name": "永济市",
  "value": "140881",
  "parent": "140800"
}, {
  "name": "河津市",
  "value": "140882",
  "parent": "140800"
}, {
  "name": "忻府区",
  "value": "140902",
  "parent": "140900"
}, {
  "name": "定襄县",
  "value": "140921",
  "parent": "140900"
}, {
  "name": "五台县",
  "value": "140922",
  "parent": "140900"
}, {
  "name": "代县",
  "value": "140923",
  "parent": "140900"
}, {
  "name": "繁峙县",
  "value": "140924",
  "parent": "140900"
}, {
  "name": "宁武县",
  "value": "140925",
  "parent": "140900"
}, {
  "name": "静乐县",
  "value": "140926",
  "parent": "140900"
}, {
  "name": "神池县",
  "value": "140927",
  "parent": "140900"
}, {
  "name": "五寨县",
  "value": "140928",
  "parent": "140900"
}, {
  "name": "岢岚县",
  "value": "140929",
  "parent": "140900"
}, {
  "name": "河曲县",
  "value": "140930",
  "parent": "140900"
}, {
  "name": "保德县",
  "value": "140931",
  "parent": "140900"
}, {
  "name": "偏关县",
  "value": "140932",
  "parent": "140900"
}, {
  "name": "原平市",
  "value": "140981",
  "parent": "140900"
}, {
  "name": "尧都区",
  "value": "141002",
  "parent": "141000"
}, {
  "name": "曲沃县",
  "value": "141021",
  "parent": "141000"
}, {
  "name": "翼城县",
  "value": "141022",
  "parent": "141000"
}, {
  "name": "襄汾县",
  "value": "141023",
  "parent": "141000"
}, {
  "name": "洪洞县",
  "value": "141024",
  "parent": "141000"
}, {
  "name": "古县",
  "value": "141025",
  "parent": "141000"
}, {
  "name": "安泽县",
  "value": "141026",
  "parent": "141000"
}, {
  "name": "浮山县",
  "value": "141027",
  "parent": "141000"
}, {
  "name": "吉县",
  "value": "141028",
  "parent": "141000"
}, {
  "name": "乡宁县",
  "value": "141029",
  "parent": "141000"
}, {
  "name": "大宁县",
  "value": "141030",
  "parent": "141000"
}, {
  "name": "隰县",
  "value": "141031",
  "parent": "141000"
}, {
  "name": "永和县",
  "value": "141032",
  "parent": "141000"
}, {
  "name": "蒲县",
  "value": "141033",
  "parent": "141000"
}, {
  "name": "汾西县",
  "value": "141034",
  "parent": "141000"
}, {
  "name": "侯马市",
  "value": "141081",
  "parent": "141000"
}, {
  "name": "霍州市",
  "value": "141082",
  "parent": "141000"
}, {
  "name": "离石区",
  "value": "141102",
  "parent": "141100"
}, {
  "name": "文水县",
  "value": "141121",
  "parent": "141100"
}, {
  "name": "交城县",
  "value": "141122",
  "parent": "141100"
}, {
  "name": "兴县",
  "value": "141123",
  "parent": "141100"
}, {
  "name": "临县",
  "value": "141124",
  "parent": "141100"
}, {
  "name": "柳林县",
  "value": "141125",
  "parent": "141100"
}, {
  "name": "石楼县",
  "value": "141126",
  "parent": "141100"
}, {
  "name": "岚县",
  "value": "141127",
  "parent": "141100"
}, {
  "name": "方山县",
  "value": "141128",
  "parent": "141100"
}, {
  "name": "中阳县",
  "value": "141129",
  "parent": "141100"
}, {
  "name": "交口县",
  "value": "141130",
  "parent": "141100"
}, {
  "name": "孝义市",
  "value": "141181",
  "parent": "141100"
}, {
  "name": "汾阳市",
  "value": "141182",
  "parent": "141100"
}, {
  "name": "呼和浩特市",
  "value": "150100",
  "parent": "150000"
}, {
  "name": "包头市",
  "value": "150200",
  "parent": "150000"
}, {
  "name": "乌海市",
  "value": "150300",
  "parent": "150000"
}, {
  "name": "赤峰市",
  "value": "150400",
  "parent": "150000"
}, {
  "name": "通辽市",
  "value": "150500",
  "parent": "150000"
}, {
  "name": "鄂尔多斯市",
  "value": "150600",
  "parent": "150000"
}, {
  "name": "呼伦贝尔市",
  "value": "150700",
  "parent": "150000"
}, {
  "name": "巴彦淖尔市",
  "value": "150800",
  "parent": "150000"
}, {
  "name": "乌兰察布市",
  "value": "150900",
  "parent": "150000"
}, {
  "name": "兴安盟",
  "value": "152200",
  "parent": "150000"
}, {
  "name": "锡林郭勒盟",
  "value": "152500",
  "parent": "150000"
}, {
  "name": "阿拉善盟",
  "value": "152900",
  "parent": "150000"
}, {
  "name": "新城区",
  "value": "150102",
  "parent": "150100"
}, {
  "name": "回民区",
  "value": "150103",
  "parent": "150100"
}, {
  "name": "玉泉区",
  "value": "150104",
  "parent": "150100"
}, {
  "name": "赛罕区",
  "value": "150105",
  "parent": "150100"
}, {
  "name": "土默特左旗",
  "value": "150121",
  "parent": "150100"
}, {
  "name": "托克托县",
  "value": "150122",
  "parent": "150100"
}, {
  "name": "和林格尔县",
  "value": "150123",
  "parent": "150100"
}, {
  "name": "清水河县",
  "value": "150124",
  "parent": "150100"
}, {
  "name": "武川县",
  "value": "150125",
  "parent": "150100"
}, {
  "name": "东河区",
  "value": "150202",
  "parent": "150200"
}, {
  "name": "昆都仑区",
  "value": "150203",
  "parent": "150200"
}, {
  "name": "青山区",
  "value": "150204",
  "parent": "150200"
}, {
  "name": "石拐区",
  "value": "150205",
  "parent": "150200"
}, {
  "name": "白云鄂博矿区",
  "value": "150206",
  "parent": "150200"
}, {
  "name": "九原区",
  "value": "150207",
  "parent": "150200"
}, {
  "name": "土默特右旗",
  "value": "150221",
  "parent": "150200"
}, {
  "name": "固阳县",
  "value": "150222",
  "parent": "150200"
}, {
  "name": "达尔罕茂明安联合旗",
  "value": "150223",
  "parent": "150200"
}, {
  "name": "海勃湾区",
  "value": "150302",
  "parent": "150300"
}, {
  "name": "海南区",
  "value": "150303",
  "parent": "150300"
}, {
  "name": "乌达区",
  "value": "150304",
  "parent": "150300"
}, {
  "name": "红山区",
  "value": "150402",
  "parent": "150400"
}, {
  "name": "元宝山区",
  "value": "150403",
  "parent": "150400"
}, {
  "name": "松山区",
  "value": "150404",
  "parent": "150400"
}, {
  "name": "阿鲁科尔沁旗",
  "value": "150421",
  "parent": "150400"
}, {
  "name": "巴林左旗",
  "value": "150422",
  "parent": "150400"
}, {
  "name": "巴林右旗",
  "value": "150423",
  "parent": "150400"
}, {
  "name": "林西县",
  "value": "150424",
  "parent": "150400"
}, {
  "name": "克什克腾旗",
  "value": "150425",
  "parent": "150400"
}, {
  "name": "翁牛特旗",
  "value": "150426",
  "parent": "150400"
}, {
  "name": "喀喇沁旗",
  "value": "150428",
  "parent": "150400"
}, {
  "name": "宁城县",
  "value": "150429",
  "parent": "150400"
}, {
  "name": "敖汉旗",
  "value": "150430",
  "parent": "150400"
}, {
  "name": "科尔沁区",
  "value": "150502",
  "parent": "150500"
}, {
  "name": "科尔沁左翼中旗",
  "value": "150521",
  "parent": "150500"
}, {
  "name": "科尔沁左翼后旗",
  "value": "150522",
  "parent": "150500"
}, {
  "name": "开鲁县",
  "value": "150523",
  "parent": "150500"
}, {
  "name": "库伦旗",
  "value": "150524",
  "parent": "150500"
}, {
  "name": "奈曼旗",
  "value": "150525",
  "parent": "150500"
}, {
  "name": "扎鲁特旗",
  "value": "150526",
  "parent": "150500"
}, {
  "name": "霍林郭勒市",
  "value": "150581",
  "parent": "150500"
}, {
  "name": "东胜区",
  "value": "150602",
  "parent": "150600"
}, {
  "name": "达拉特旗",
  "value": "150621",
  "parent": "150600"
}, {
  "name": "准格尔旗",
  "value": "150622",
  "parent": "150600"
}, {
  "name": "鄂托克前旗",
  "value": "150623",
  "parent": "150600"
}, {
  "name": "鄂托克旗",
  "value": "150624",
  "parent": "150600"
}, {
  "name": "杭锦旗",
  "value": "150625",
  "parent": "150600"
}, {
  "name": "乌审旗",
  "value": "150626",
  "parent": "150600"
}, {
  "name": "伊金霍洛旗",
  "value": "150627",
  "parent": "150600"
}, {
  "name": "海拉尔区",
  "value": "150702",
  "parent": "150700"
}, {
  "name": "扎赉诺尔区",
  "value": "150703",
  "parent": "150700"
}, {
  "name": "阿荣旗",
  "value": "150721",
  "parent": "150700"
}, {
  "name": "莫力达瓦达斡尔族自治旗",
  "value": "150722",
  "parent": "150700"
}, {
  "name": "鄂伦春自治旗",
  "value": "150723",
  "parent": "150700"
}, {
  "name": "鄂温克族自治旗",
  "value": "150724",
  "parent": "150700"
}, {
  "name": "陈巴尔虎旗",
  "value": "150725",
  "parent": "150700"
}, {
  "name": "新巴尔虎左旗",
  "value": "150726",
  "parent": "150700"
}, {
  "name": "新巴尔虎右旗",
  "value": "150727",
  "parent": "150700"
}, {
  "name": "满洲里市",
  "value": "150781",
  "parent": "150700"
}, {
  "name": "牙克石市",
  "value": "150782",
  "parent": "150700"
}, {
  "name": "扎兰屯市",
  "value": "150783",
  "parent": "150700"
}, {
  "name": "额尔古纳市",
  "value": "150784",
  "parent": "150700"
}, {
  "name": "根河市",
  "value": "150785",
  "parent": "150700"
}, {
  "name": "临河区",
  "value": "150802",
  "parent": "150800"
}, {
  "name": "五原县",
  "value": "150821",
  "parent": "150800"
}, {
  "name": "磴口县",
  "value": "150822",
  "parent": "150800"
}, {
  "name": "乌拉特前旗",
  "value": "150823",
  "parent": "150800"
}, {
  "name": "乌拉特中旗",
  "value": "150824",
  "parent": "150800"
}, {
  "name": "乌拉特后旗",
  "value": "150825",
  "parent": "150800"
}, {
  "name": "杭锦后旗",
  "value": "150826",
  "parent": "150800"
}, {
  "name": "集宁区",
  "value": "150902",
  "parent": "150900"
}, {
  "name": "卓资县",
  "value": "150921",
  "parent": "150900"
}, {
  "name": "化德县",
  "value": "150922",
  "parent": "150900"
}, {
  "name": "商都县",
  "value": "150923",
  "parent": "150900"
}, {
  "name": "兴和县",
  "value": "150924",
  "parent": "150900"
}, {
  "name": "凉城县",
  "value": "150925",
  "parent": "150900"
}, {
  "name": "察哈尔右翼前旗",
  "value": "150926",
  "parent": "150900"
}, {
  "name": "察哈尔右翼中旗",
  "value": "150927",
  "parent": "150900"
}, {
  "name": "察哈尔右翼后旗",
  "value": "150928",
  "parent": "150900"
}, {
  "name": "四子王旗",
  "value": "150929",
  "parent": "150900"
}, {
  "name": "丰镇市",
  "value": "150981",
  "parent": "150900"
}, {
  "name": "乌兰浩特市",
  "value": "152201",
  "parent": "152200"
}, {
  "name": "阿尔山市",
  "value": "152202",
  "parent": "152200"
}, {
  "name": "科尔沁右翼前旗",
  "value": "152221",
  "parent": "152200"
}, {
  "name": "科尔沁右翼中旗",
  "value": "152222",
  "parent": "152200"
}, {
  "name": "扎赉特旗",
  "value": "152223",
  "parent": "152200"
}, {
  "name": "突泉县",
  "value": "152224",
  "parent": "152200"
}, {
  "name": "二连浩特市",
  "value": "152501",
  "parent": "152500"
}, {
  "name": "锡林浩特市",
  "value": "152502",
  "parent": "152500"
}, {
  "name": "阿巴嘎旗",
  "value": "152522",
  "parent": "152500"
}, {
  "name": "苏尼特左旗",
  "value": "152523",
  "parent": "152500"
}, {
  "name": "苏尼特右旗",
  "value": "152524",
  "parent": "152500"
}, {
  "name": "东乌珠穆沁旗",
  "value": "152525",
  "parent": "152500"
}, {
  "name": "西乌珠穆沁旗",
  "value": "152526",
  "parent": "152500"
}, {
  "name": "太仆寺旗",
  "value": "152527",
  "parent": "152500"
}, {
  "name": "镶黄旗",
  "value": "152528",
  "parent": "152500"
}, {
  "name": "正镶白旗",
  "value": "152529",
  "parent": "152500"
}, {
  "name": "正蓝旗",
  "value": "152530",
  "parent": "152500"
}, {
  "name": "多伦县",
  "value": "152531",
  "parent": "152500"
}, {
  "name": "阿拉善左旗",
  "value": "152921",
  "parent": "152900"
}, {
  "name": "阿拉善右旗",
  "value": "152922",
  "parent": "152900"
}, {
  "name": "额济纳旗",
  "value": "152923",
  "parent": "152900"
}, {
  "name": "沈阳市",
  "value": "210100",
  "parent": "210000"
}, {
  "name": "大连市",
  "value": "210200",
  "parent": "210000"
}, {
  "name": "鞍山市",
  "value": "210300",
  "parent": "210000"
}, {
  "name": "抚顺市",
  "value": "210400",
  "parent": "210000"
}, {
  "name": "本溪市",
  "value": "210500",
  "parent": "210000"
}, {
  "name": "丹东市",
  "value": "210600",
  "parent": "210000"
}, {
  "name": "锦州市",
  "value": "210700",
  "parent": "210000"
}, {
  "name": "营口市",
  "value": "210800",
  "parent": "210000"
}, {
  "name": "阜新市",
  "value": "210900",
  "parent": "210000"
}, {
  "name": "辽阳市",
  "value": "211000",
  "parent": "210000"
}, {
  "name": "盘锦市",
  "value": "211100",
  "parent": "210000"
}, {
  "name": "铁岭市",
  "value": "211200",
  "parent": "210000"
}, {
  "name": "朝阳市",
  "value": "211300",
  "parent": "210000"
}, {
  "name": "葫芦岛市",
  "value": "211400",
  "parent": "210000"
}, {
  "name": "和平区",
  "value": "210102",
  "parent": "210100"
}, {
  "name": "沈河区",
  "value": "210103",
  "parent": "210100"
}, {
  "name": "大东区",
  "value": "210104",
  "parent": "210100"
}, {
  "name": "皇姑区",
  "value": "210105",
  "parent": "210100"
}, {
  "name": "铁西区",
  "value": "210106",
  "parent": "210100"
}, {
  "name": "苏家屯区",
  "value": "210111",
  "parent": "210100"
}, {
  "name": "浑南区",
  "value": "210112",
  "parent": "210100"
}, {
  "name": "沈北新区",
  "value": "210113",
  "parent": "210100"
}, {
  "name": "于洪区",
  "value": "210114",
  "parent": "210100"
}, {
  "name": "辽中县",
  "value": "210122",
  "parent": "210100"
}, {
  "name": "康平县",
  "value": "210123",
  "parent": "210100"
}, {
  "name": "法库县",
  "value": "210124",
  "parent": "210100"
}, {
  "name": "新民市",
  "value": "210181",
  "parent": "210100"
}, {
  "name": "中山区",
  "value": "210202",
  "parent": "210200"
}, {
  "name": "西岗区",
  "value": "210203",
  "parent": "210200"
}, {
  "name": "沙河口区",
  "value": "210204",
  "parent": "210200"
}, {
  "name": "甘井子区",
  "value": "210211",
  "parent": "210200"
}, {
  "name": "旅顺口区",
  "value": "210212",
  "parent": "210200"
}, {
  "name": "金州区",
  "value": "210213",
  "parent": "210200"
}, {
  "name": "普兰店区",
  "value": "210214",
  "parent": "210200"
}, {
  "name": "长海县",
  "value": "210224",
  "parent": "210200"
}, {
  "name": "瓦房店市",
  "value": "210281",
  "parent": "210200"
}, {
  "name": "庄河市",
  "value": "210283",
  "parent": "210200"
}, {
  "name": "铁东区",
  "value": "210302",
  "parent": "210300"
}, {
  "name": "铁西区",
  "value": "210303",
  "parent": "210300"
}, {
  "name": "立山区",
  "value": "210304",
  "parent": "210300"
}, {
  "name": "千山区",
  "value": "210311",
  "parent": "210300"
}, {
  "name": "台安县",
  "value": "210321",
  "parent": "210300"
}, {
  "name": "岫岩满族自治县",
  "value": "210323",
  "parent": "210300"
}, {
  "name": "海城市",
  "value": "210381",
  "parent": "210300"
}, {
  "name": "新抚区",
  "value": "210402",
  "parent": "210400"
}, {
  "name": "东洲区",
  "value": "210403",
  "parent": "210400"
}, {
  "name": "望花区",
  "value": "210404",
  "parent": "210400"
}, {
  "name": "顺城区",
  "value": "210411",
  "parent": "210400"
}, {
  "name": "抚顺县",
  "value": "210421",
  "parent": "210400"
}, {
  "name": "新宾满族自治县",
  "value": "210422",
  "parent": "210400"
}, {
  "name": "清原满族自治县",
  "value": "210423",
  "parent": "210400"
}, {
  "name": "平山区",
  "value": "210502",
  "parent": "210500"
}, {
  "name": "溪湖区",
  "value": "210503",
  "parent": "210500"
}, {
  "name": "明山区",
  "value": "210504",
  "parent": "210500"
}, {
  "name": "南芬区",
  "value": "210505",
  "parent": "210500"
}, {
  "name": "本溪满族自治县",
  "value": "210521",
  "parent": "210500"
}, {
  "name": "桓仁满族自治县",
  "value": "210522",
  "parent": "210500"
}, {
  "name": "元宝区",
  "value": "210602",
  "parent": "210600"
}, {
  "name": "振兴区",
  "value": "210603",
  "parent": "210600"
}, {
  "name": "振安区",
  "value": "210604",
  "parent": "210600"
}, {
  "name": "宽甸满族自治县",
  "value": "210624",
  "parent": "210600"
}, {
  "name": "东港市",
  "value": "210681",
  "parent": "210600"
}, {
  "name": "凤城市",
  "value": "210682",
  "parent": "210600"
}, {
  "name": "古塔区",
  "value": "210702",
  "parent": "210700"
}, {
  "name": "凌河区",
  "value": "210703",
  "parent": "210700"
}, {
  "name": "太和区",
  "value": "210711",
  "parent": "210700"
}, {
  "name": "黑山县",
  "value": "210726",
  "parent": "210700"
}, {
  "name": "义县",
  "value": "210727",
  "parent": "210700"
}, {
  "name": "凌海市",
  "value": "210781",
  "parent": "210700"
}, {
  "name": "北镇市",
  "value": "210782",
  "parent": "210700"
}, {
  "name": "站前区",
  "value": "210802",
  "parent": "210800"
}, {
  "name": "西市区",
  "value": "210803",
  "parent": "210800"
}, {
  "name": "鲅鱼圈区",
  "value": "210804",
  "parent": "210800"
}, {
  "name": "老边区",
  "value": "210811",
  "parent": "210800"
}, {
  "name": "盖州市",
  "value": "210881",
  "parent": "210800"
}, {
  "name": "大石桥市",
  "value": "210882",
  "parent": "210800"
}, {
  "name": "海州区",
  "value": "210902",
  "parent": "210900"
}, {
  "name": "新邱区",
  "value": "210903",
  "parent": "210900"
}, {
  "name": "太平区",
  "value": "210904",
  "parent": "210900"
}, {
  "name": "清河门区",
  "value": "210905",
  "parent": "210900"
}, {
  "name": "细河区",
  "value": "210911",
  "parent": "210900"
}, {
  "name": "阜新蒙古族自治县",
  "value": "210921",
  "parent": "210900"
}, {
  "name": "彰武县",
  "value": "210922",
  "parent": "210900"
}, {
  "name": "白塔区",
  "value": "211002",
  "parent": "211000"
}, {
  "name": "文圣区",
  "value": "211003",
  "parent": "211000"
}, {
  "name": "宏伟区",
  "value": "211004",
  "parent": "211000"
}, {
  "name": "弓长岭区",
  "value": "211005",
  "parent": "211000"
}, {
  "name": "太子河区",
  "value": "211011",
  "parent": "211000"
}, {
  "name": "辽阳县",
  "value": "211021",
  "parent": "211000"
}, {
  "name": "灯塔市",
  "value": "211081",
  "parent": "211000"
}, {
  "name": "双台子区",
  "value": "211102",
  "parent": "211100"
}, {
  "name": "兴隆台区",
  "value": "211103",
  "parent": "211100"
}, {
  "name": "大洼县",
  "value": "211121",
  "parent": "211100"
}, {
  "name": "盘山县",
  "value": "211122",
  "parent": "211100"
}, {
  "name": "银州区",
  "value": "211202",
  "parent": "211200"
}, {
  "name": "清河区",
  "value": "211204",
  "parent": "211200"
}, {
  "name": "铁岭县",
  "value": "211221",
  "parent": "211200"
}, {
  "name": "西丰县",
  "value": "211223",
  "parent": "211200"
}, {
  "name": "昌图县",
  "value": "211224",
  "parent": "211200"
}, {
  "name": "调兵山市",
  "value": "211281",
  "parent": "211200"
}, {
  "name": "开原市",
  "value": "211282",
  "parent": "211200"
}, {
  "name": "双塔区",
  "value": "211302",
  "parent": "211300"
}, {
  "name": "龙城区",
  "value": "211303",
  "parent": "211300"
}, {
  "name": "朝阳县",
  "value": "211321",
  "parent": "211300"
}, {
  "name": "建平县",
  "value": "211322",
  "parent": "211300"
}, {
  "name": "喀喇沁左翼蒙古族自治县",
  "value": "211324",
  "parent": "211300"
}, {
  "name": "北票市",
  "value": "211381",
  "parent": "211300"
}, {
  "name": "凌源市",
  "value": "211382",
  "parent": "211300"
}, {
  "name": "连山区",
  "value": "211402",
  "parent": "211400"
}, {
  "name": "龙港区",
  "value": "211403",
  "parent": "211400"
}, {
  "name": "南票区",
  "value": "211404",
  "parent": "211400"
}, {
  "name": "绥中县",
  "value": "211421",
  "parent": "211400"
}, {
  "name": "建昌县",
  "value": "211422",
  "parent": "211400"
}, {
  "name": "兴城市",
  "value": "211481",
  "parent": "211400"
}, {
  "name": "长春市",
  "value": "220100",
  "parent": "220000"
}, {
  "name": "吉林市",
  "value": "220200",
  "parent": "220000"
}, {
  "name": "四平市",
  "value": "220300",
  "parent": "220000"
}, {
  "name": "辽源市",
  "value": "220400",
  "parent": "220000"
}, {
  "name": "通化市",
  "value": "220500",
  "parent": "220000"
}, {
  "name": "白山市",
  "value": "220600",
  "parent": "220000"
}, {
  "name": "松原市",
  "value": "220700",
  "parent": "220000"
}, {
  "name": "白城市",
  "value": "220800",
  "parent": "220000"
}, {
  "name": "延边朝鲜族自治州",
  "value": "222400",
  "parent": "220000"
}, {
  "name": "南关区",
  "value": "220102",
  "parent": "220100"
}, {
  "name": "宽城区",
  "value": "220103",
  "parent": "220100"
}, {
  "name": "朝阳区",
  "value": "220104",
  "parent": "220100"
}, {
  "name": "二道区",
  "value": "220105",
  "parent": "220100"
}, {
  "name": "绿园区",
  "value": "220106",
  "parent": "220100"
}, {
  "name": "双阳区",
  "value": "220112",
  "parent": "220100"
}, {
  "name": "九台区",
  "value": "220113",
  "parent": "220100"
}, {
  "name": "农安县",
  "value": "220122",
  "parent": "220100"
}, {
  "name": "榆树市",
  "value": "220182",
  "parent": "220100"
}, {
  "name": "德惠市",
  "value": "220183",
  "parent": "220100"
}, {
  "name": "昌邑区",
  "value": "220202",
  "parent": "220200"
}, {
  "name": "龙潭区",
  "value": "220203",
  "parent": "220200"
}, {
  "name": "船营区",
  "value": "220204",
  "parent": "220200"
}, {
  "name": "丰满区",
  "value": "220211",
  "parent": "220200"
}, {
  "name": "永吉县",
  "value": "220221",
  "parent": "220200"
}, {
  "name": "蛟河市",
  "value": "220281",
  "parent": "220200"
}, {
  "name": "桦甸市",
  "value": "220282",
  "parent": "220200"
}, {
  "name": "舒兰市",
  "value": "220283",
  "parent": "220200"
}, {
  "name": "磐石市",
  "value": "220284",
  "parent": "220200"
}, {
  "name": "铁西区",
  "value": "220302",
  "parent": "220300"
}, {
  "name": "铁东区",
  "value": "220303",
  "parent": "220300"
}, {
  "name": "梨树县",
  "value": "220322",
  "parent": "220300"
}, {
  "name": "伊通满族自治县",
  "value": "220323",
  "parent": "220300"
}, {
  "name": "公主岭市",
  "value": "220381",
  "parent": "220300"
}, {
  "name": "双辽市",
  "value": "220382",
  "parent": "220300"
}, {
  "name": "龙山区",
  "value": "220402",
  "parent": "220400"
}, {
  "name": "西安区",
  "value": "220403",
  "parent": "220400"
}, {
  "name": "东丰县",
  "value": "220421",
  "parent": "220400"
}, {
  "name": "东辽县",
  "value": "220422",
  "parent": "220400"
}, {
  "name": "东昌区",
  "value": "220502",
  "parent": "220500"
}, {
  "name": "二道江区",
  "value": "220503",
  "parent": "220500"
}, {
  "name": "通化县",
  "value": "220521",
  "parent": "220500"
}, {
  "name": "辉南县",
  "value": "220523",
  "parent": "220500"
}, {
  "name": "柳河县",
  "value": "220524",
  "parent": "220500"
}, {
  "name": "梅河口市",
  "value": "220581",
  "parent": "220500"
}, {
  "name": "集安市",
  "value": "220582",
  "parent": "220500"
}, {
  "name": "浑江区",
  "value": "220602",
  "parent": "220600"
}, {
  "name": "江源区",
  "value": "220605",
  "parent": "220600"
}, {
  "name": "抚松县",
  "value": "220621",
  "parent": "220600"
}, {
  "name": "靖宇县",
  "value": "220622",
  "parent": "220600"
}, {
  "name": "长白朝鲜族自治县",
  "value": "220623",
  "parent": "220600"
}, {
  "name": "临江市",
  "value": "220681",
  "parent": "220600"
}, {
  "name": "宁江区",
  "value": "220702",
  "parent": "220700"
}, {
  "name": "前郭尔罗斯蒙古族自治县",
  "value": "220721",
  "parent": "220700"
}, {
  "name": "长岭县",
  "value": "220722",
  "parent": "220700"
}, {
  "name": "乾安县",
  "value": "220723",
  "parent": "220700"
}, {
  "name": "扶余市",
  "value": "220781",
  "parent": "220700"
}, {
  "name": "洮北区",
  "value": "220802",
  "parent": "220800"
}, {
  "name": "镇赉县",
  "value": "220821",
  "parent": "220800"
}, {
  "name": "通榆县",
  "value": "220822",
  "parent": "220800"
}, {
  "name": "洮南市",
  "value": "220881",
  "parent": "220800"
}, {
  "name": "大安市",
  "value": "220882",
  "parent": "220800"
}, {
  "name": "延吉市",
  "value": "222401",
  "parent": "222400"
}, {
  "name": "图们市",
  "value": "222402",
  "parent": "222400"
}, {
  "name": "敦化市",
  "value": "222403",
  "parent": "222400"
}, {
  "name": "珲春市",
  "value": "222404",
  "parent": "222400"
}, {
  "name": "龙井市",
  "value": "222405",
  "parent": "222400"
}, {
  "name": "和龙市",
  "value": "222406",
  "parent": "222400"
}, {
  "name": "汪清县",
  "value": "222424",
  "parent": "222400"
}, {
  "name": "安图县",
  "value": "222426",
  "parent": "222400"
}, {
  "name": "哈尔滨市",
  "value": "230100",
  "parent": "230000"
}, {
  "name": "齐齐哈尔市",
  "value": "230200",
  "parent": "230000"
}, {
  "name": "鸡西市",
  "value": "230300",
  "parent": "230000"
}, {
  "name": "鹤岗市",
  "value": "230400",
  "parent": "230000"
}, {
  "name": "双鸭山市",
  "value": "230500",
  "parent": "230000"
}, {
  "name": "大庆市",
  "value": "230600",
  "parent": "230000"
}, {
  "name": "伊春市",
  "value": "230700",
  "parent": "230000"
}, {
  "name": "佳木斯市",
  "value": "230800",
  "parent": "230000"
}, {
  "name": "七台河市",
  "value": "230900",
  "parent": "230000"
}, {
  "name": "牡丹江市",
  "value": "231000",
  "parent": "230000"
}, {
  "name": "黑河市",
  "value": "231100",
  "parent": "230000"
}, {
  "name": "绥化市",
  "value": "231200",
  "parent": "230000"
}, {
  "name": "大兴安岭地区",
  "value": "232700",
  "parent": "230000"
}, {
  "name": "道里区",
  "value": "230102",
  "parent": "230100"
}, {
  "name": "南岗区",
  "value": "230103",
  "parent": "230100"
}, {
  "name": "道外区",
  "value": "230104",
  "parent": "230100"
}, {
  "name": "平房区",
  "value": "230108",
  "parent": "230100"
}, {
  "name": "松北区",
  "value": "230109",
  "parent": "230100"
}, {
  "name": "香坊区",
  "value": "230110",
  "parent": "230100"
}, {
  "name": "呼兰区",
  "value": "230111",
  "parent": "230100"
}, {
  "name": "阿城区",
  "value": "230112",
  "parent": "230100"
}, {
  "name": "双城区",
  "value": "230113",
  "parent": "230100"
}, {
  "name": "依兰县",
  "value": "230123",
  "parent": "230100"
}, {
  "name": "方正县",
  "value": "230124",
  "parent": "230100"
}, {
  "name": "宾县",
  "value": "230125",
  "parent": "230100"
}, {
  "name": "巴彦县",
  "value": "230126",
  "parent": "230100"
}, {
  "name": "木兰县",
  "value": "230127",
  "parent": "230100"
}, {
  "name": "通河县",
  "value": "230128",
  "parent": "230100"
}, {
  "name": "延寿县",
  "value": "230129",
  "parent": "230100"
}, {
  "name": "尚志市",
  "value": "230183",
  "parent": "230100"
}, {
  "name": "五常市",
  "value": "230184",
  "parent": "230100"
}, {
  "name": "龙沙区",
  "value": "230202",
  "parent": "230200"
}, {
  "name": "建华区",
  "value": "230203",
  "parent": "230200"
}, {
  "name": "铁锋区",
  "value": "230204",
  "parent": "230200"
}, {
  "name": "昂昂溪区",
  "value": "230205",
  "parent": "230200"
}, {
  "name": "富拉尔基区",
  "value": "230206",
  "parent": "230200"
}, {
  "name": "碾子山区",
  "value": "230207",
  "parent": "230200"
}, {
  "name": "梅里斯达斡尔族区",
  "value": "230208",
  "parent": "230200"
}, {
  "name": "龙江县",
  "value": "230221",
  "parent": "230200"
}, {
  "name": "依安县",
  "value": "230223",
  "parent": "230200"
}, {
  "name": "泰来县",
  "value": "230224",
  "parent": "230200"
}, {
  "name": "甘南县",
  "value": "230225",
  "parent": "230200"
}, {
  "name": "富裕县",
  "value": "230227",
  "parent": "230200"
}, {
  "name": "克山县",
  "value": "230229",
  "parent": "230200"
}, {
  "name": "克东县",
  "value": "230230",
  "parent": "230200"
}, {
  "name": "拜泉县",
  "value": "230231",
  "parent": "230200"
}, {
  "name": "讷河市",
  "value": "230281",
  "parent": "230200"
}, {
  "name": "鸡冠区",
  "value": "230302",
  "parent": "230300"
}, {
  "name": "恒山区",
  "value": "230303",
  "parent": "230300"
}, {
  "name": "滴道区",
  "value": "230304",
  "parent": "230300"
}, {
  "name": "梨树区",
  "value": "230305",
  "parent": "230300"
}, {
  "name": "城子河区",
  "value": "230306",
  "parent": "230300"
}, {
  "name": "麻山区",
  "value": "230307",
  "parent": "230300"
}, {
  "name": "鸡东县",
  "value": "230321",
  "parent": "230300"
}, {
  "name": "虎林市",
  "value": "230381",
  "parent": "230300"
}, {
  "name": "密山市",
  "value": "230382",
  "parent": "230300"
}, {
  "name": "向阳区",
  "value": "230402",
  "parent": "230400"
}, {
  "name": "工农区",
  "value": "230403",
  "parent": "230400"
}, {
  "name": "南山区",
  "value": "230404",
  "parent": "230400"
}, {
  "name": "兴安区",
  "value": "230405",
  "parent": "230400"
}, {
  "name": "东山区",
  "value": "230406",
  "parent": "230400"
}, {
  "name": "兴山区",
  "value": "230407",
  "parent": "230400"
}, {
  "name": "萝北县",
  "value": "230421",
  "parent": "230400"
}, {
  "name": "绥滨县",
  "value": "230422",
  "parent": "230400"
}, {
  "name": "尖山区",
  "value": "230502",
  "parent": "230500"
}, {
  "name": "岭东区",
  "value": "230503",
  "parent": "230500"
}, {
  "name": "四方台区",
  "value": "230505",
  "parent": "230500"
}, {
  "name": "宝山区",
  "value": "230506",
  "parent": "230500"
}, {
  "name": "集贤县",
  "value": "230521",
  "parent": "230500"
}, {
  "name": "友谊县",
  "value": "230522",
  "parent": "230500"
}, {
  "name": "宝清县",
  "value": "230523",
  "parent": "230500"
}, {
  "name": "饶河县",
  "value": "230524",
  "parent": "230500"
}, {
  "name": "萨尔图区",
  "value": "230602",
  "parent": "230600"
}, {
  "name": "龙凤区",
  "value": "230603",
  "parent": "230600"
}, {
  "name": "让胡路区",
  "value": "230604",
  "parent": "230600"
}, {
  "name": "红岗区",
  "value": "230605",
  "parent": "230600"
}, {
  "name": "大同区",
  "value": "230606",
  "parent": "230600"
}, {
  "name": "肇州县",
  "value": "230621",
  "parent": "230600"
}, {
  "name": "肇源县",
  "value": "230622",
  "parent": "230600"
}, {
  "name": "林甸县",
  "value": "230623",
  "parent": "230600"
}, {
  "name": "杜尔伯特蒙古族自治县",
  "value": "230624",
  "parent": "230600"
}, {
  "name": "伊春区",
  "value": "230702",
  "parent": "230700"
}, {
  "name": "南岔区",
  "value": "230703",
  "parent": "230700"
}, {
  "name": "友好区",
  "value": "230704",
  "parent": "230700"
}, {
  "name": "西林区",
  "value": "230705",
  "parent": "230700"
}, {
  "name": "翠峦区",
  "value": "230706",
  "parent": "230700"
}, {
  "name": "新青区",
  "value": "230707",
  "parent": "230700"
}, {
  "name": "美溪区",
  "value": "230708",
  "parent": "230700"
}, {
  "name": "金山屯区",
  "value": "230709",
  "parent": "230700"
}, {
  "name": "五营区",
  "value": "230710",
  "parent": "230700"
}, {
  "name": "乌马河区",
  "value": "230711",
  "parent": "230700"
}, {
  "name": "汤旺河区",
  "value": "230712",
  "parent": "230700"
}, {
  "name": "带岭区",
  "value": "230713",
  "parent": "230700"
}, {
  "name": "乌伊岭区",
  "value": "230714",
  "parent": "230700"
}, {
  "name": "红星区",
  "value": "230715",
  "parent": "230700"
}, {
  "name": "上甘岭区",
  "value": "230716",
  "parent": "230700"
}, {
  "name": "嘉荫县",
  "value": "230722",
  "parent": "230700"
}, {
  "name": "铁力市",
  "value": "230781",
  "parent": "230700"
}, {
  "name": "向阳区",
  "value": "230803",
  "parent": "230800"
}, {
  "name": "前进区",
  "value": "230804",
  "parent": "230800"
}, {
  "name": "东风区",
  "value": "230805",
  "parent": "230800"
}, {
  "name": "郊区",
  "value": "230811",
  "parent": "230800"
}, {
  "name": "桦南县",
  "value": "230822",
  "parent": "230800"
}, {
  "name": "桦川县",
  "value": "230826",
  "parent": "230800"
}, {
  "name": "汤原县",
  "value": "230828",
  "parent": "230800"
}, {
  "name": "抚远市",
  "value": "230833",
  "parent": "230800"
}, {
  "name": "同江市",
  "value": "230881",
  "parent": "230800"
}, {
  "name": "富锦市",
  "value": "230882",
  "parent": "230800"
}, {
  "name": "新兴区",
  "value": "230902",
  "parent": "230900"
}, {
  "name": "桃山区",
  "value": "230903",
  "parent": "230900"
}, {
  "name": "茄子河区",
  "value": "230904",
  "parent": "230900"
}, {
  "name": "勃利县",
  "value": "230921",
  "parent": "230900"
}, {
  "name": "东安区",
  "value": "231002",
  "parent": "231000"
}, {
  "name": "阳明区",
  "value": "231003",
  "parent": "231000"
}, {
  "name": "爱民区",
  "value": "231004",
  "parent": "231000"
}, {
  "name": "西安区",
  "value": "231005",
  "parent": "231000"
}, {
  "name": "林口县",
  "value": "231025",
  "parent": "231000"
}, {
  "name": "绥芬河市",
  "value": "231081",
  "parent": "231000"
}, {
  "name": "海林市",
  "value": "231083",
  "parent": "231000"
}, {
  "name": "宁安市",
  "value": "231084",
  "parent": "231000"
}, {
  "name": "穆棱市",
  "value": "231085",
  "parent": "231000"
}, {
  "name": "东宁市",
  "value": "231086",
  "parent": "231000"
}, {
  "name": "爱辉区",
  "value": "231102",
  "parent": "231100"
}, {
  "name": "嫩江县",
  "value": "231121",
  "parent": "231100"
}, {
  "name": "逊克县",
  "value": "231123",
  "parent": "231100"
}, {
  "name": "孙吴县",
  "value": "231124",
  "parent": "231100"
}, {
  "name": "北安市",
  "value": "231181",
  "parent": "231100"
}, {
  "name": "五大连池市",
  "value": "231182",
  "parent": "231100"
}, {
  "name": "北林区",
  "value": "231202",
  "parent": "231200"
}, {
  "name": "望奎县",
  "value": "231221",
  "parent": "231200"
}, {
  "name": "兰西县",
  "value": "231222",
  "parent": "231200"
}, {
  "name": "青冈县",
  "value": "231223",
  "parent": "231200"
}, {
  "name": "庆安县",
  "value": "231224",
  "parent": "231200"
}, {
  "name": "明水县",
  "value": "231225",
  "parent": "231200"
}, {
  "name": "绥棱县",
  "value": "231226",
  "parent": "231200"
}, {
  "name": "安达市",
  "value": "231281",
  "parent": "231200"
}, {
  "name": "肇东市",
  "value": "231282",
  "parent": "231200"
}, {
  "name": "海伦市",
  "value": "231283",
  "parent": "231200"
}, {
  "name": "加格达奇区",
  "value": "232701",
  "parent": "232700"
}, {
  "name": "呼玛县",
  "value": "232721",
  "parent": "232700"
}, {
  "name": "塔河县",
  "value": "232722",
  "parent": "232700"
}, {
  "name": "漠河县",
  "value": "232723",
  "parent": "232700"
}, {
  "name": "上海市市辖区",
  "value": "310100",
  "parent": "310000"
}, {
  "name": "上海市郊县",
  "value": "310200",
  "parent": "310000"
}, {
  "name": "黄浦区",
  "value": "310101",
  "parent": "310100"
}, {
  "name": "徐汇区",
  "value": "310104",
  "parent": "310100"
}, {
  "name": "长宁区",
  "value": "310105",
  "parent": "310100"
}, {
  "name": "静安区",
  "value": "310106",
  "parent": "310100"
}, {
  "name": "普陀区",
  "value": "310107",
  "parent": "310100"
}, {
  "name": "虹口区",
  "value": "310109",
  "parent": "310100"
}, {
  "name": "杨浦区",
  "value": "310110",
  "parent": "310100"
}, {
  "name": "闵行区",
  "value": "310112",
  "parent": "310100"
}, {
  "name": "宝山区",
  "value": "310113",
  "parent": "310100"
}, {
  "name": "嘉定区",
  "value": "310114",
  "parent": "310100"
}, {
  "name": "浦东新区",
  "value": "310115",
  "parent": "310100"
}, {
  "name": "金山区",
  "value": "310116",
  "parent": "310100"
}, {
  "name": "松江区",
  "value": "310117",
  "parent": "310100"
}, {
  "name": "青浦区",
  "value": "310118",
  "parent": "310100"
}, {
  "name": "奉贤区",
  "value": "310120",
  "parent": "310100"
}, {
  "name": "崇明县",
  "value": "310230",
  "parent": "310100"
}, {
  "name": "南京市",
  "value": "320100",
  "parent": "320000"
}, {
  "name": "无锡市",
  "value": "320200",
  "parent": "320000"
}, {
  "name": "徐州市",
  "value": "320300",
  "parent": "320000"
}, {
  "name": "常州市",
  "value": "320400",
  "parent": "320000"
}, {
  "name": "苏州市",
  "value": "320500",
  "parent": "320000"
}, {
  "name": "南通市",
  "value": "320600",
  "parent": "320000"
}, {
  "name": "连云港市",
  "value": "320700",
  "parent": "320000"
}, {
  "name": "淮安市",
  "value": "320800",
  "parent": "320000"
}, {
  "name": "盐城市",
  "value": "320900",
  "parent": "320000"
}, {
  "name": "扬州市",
  "value": "321000",
  "parent": "320000"
}, {
  "name": "镇江市",
  "value": "321100",
  "parent": "320000"
}, {
  "name": "泰州市",
  "value": "321200",
  "parent": "320000"
}, {
  "name": "宿迁市",
  "value": "321300",
  "parent": "320000"
}, {
  "name": "玄武区",
  "value": "320102",
  "parent": "320100"
}, {
  "name": "秦淮区",
  "value": "320104",
  "parent": "320100"
}, {
  "name": "建邺区",
  "value": "320105",
  "parent": "320100"
}, {
  "name": "鼓楼区",
  "value": "320106",
  "parent": "320100"
}, {
  "name": "浦口区",
  "value": "320111",
  "parent": "320100"
}, {
  "name": "栖霞区",
  "value": "320113",
  "parent": "320100"
}, {
  "name": "雨花台区",
  "value": "320114",
  "parent": "320100"
}, {
  "name": "江宁区",
  "value": "320115",
  "parent": "320100"
}, {
  "name": "六合区",
  "value": "320116",
  "parent": "320100"
}, {
  "name": "溧水区",
  "value": "320117",
  "parent": "320100"
}, {
  "name": "高淳区",
  "value": "320118",
  "parent": "320100"
}, {
  "name": "锡山区",
  "value": "320205",
  "parent": "320200"
}, {
  "name": "惠山区",
  "value": "320206",
  "parent": "320200"
}, {
  "name": "滨湖区",
  "value": "320211",
  "parent": "320200"
}, {
  "name": "梁溪区",
  "value": "320213",
  "parent": "320200"
}, {
  "name": "新吴区",
  "value": "320214",
  "parent": "320200"
}, {
  "name": "江阴市",
  "value": "320281",
  "parent": "320200"
}, {
  "name": "宜兴市",
  "value": "320282",
  "parent": "320200"
}, {
  "name": "鼓楼区",
  "value": "320302",
  "parent": "320300"
}, {
  "name": "云龙区",
  "value": "320303",
  "parent": "320300"
}, {
  "name": "贾汪区",
  "value": "320305",
  "parent": "320300"
}, {
  "name": "泉山区",
  "value": "320311",
  "parent": "320300"
}, {
  "name": "铜山区",
  "value": "320312",
  "parent": "320300"
}, {
  "name": "丰县",
  "value": "320321",
  "parent": "320300"
}, {
  "name": "沛县",
  "value": "320322",
  "parent": "320300"
}, {
  "name": "睢宁县",
  "value": "320324",
  "parent": "320300"
}, {
  "name": "新沂市",
  "value": "320381",
  "parent": "320300"
}, {
  "name": "邳州市",
  "value": "320382",
  "parent": "320300"
}, {
  "name": "天宁区",
  "value": "320402",
  "parent": "320400"
}, {
  "name": "钟楼区",
  "value": "320404",
  "parent": "320400"
}, {
  "name": "新北区",
  "value": "320411",
  "parent": "320400"
}, {
  "name": "武进区",
  "value": "320412",
  "parent": "320400"
}, {
  "name": "金坛区",
  "value": "320413",
  "parent": "320400"
}, {
  "name": "溧阳市",
  "value": "320481",
  "parent": "320400"
}, {
  "name": "虎丘区",
  "value": "320505",
  "parent": "320500"
}, {
  "name": "吴中区",
  "value": "320506",
  "parent": "320500"
}, {
  "name": "相城区",
  "value": "320507",
  "parent": "320500"
}, {
  "name": "姑苏区",
  "value": "320508",
  "parent": "320500"
}, {
  "name": "吴江区",
  "value": "320509",
  "parent": "320500"
}, {
  "name": "常熟市",
  "value": "320581",
  "parent": "320500"
}, {
  "name": "张家港市",
  "value": "320582",
  "parent": "320500"
}, {
  "name": "昆山市",
  "value": "320583",
  "parent": "320500"
}, {
  "name": "太仓市",
  "value": "320585",
  "parent": "320500"
}, {
  "name": "崇川区",
  "value": "320602",
  "parent": "320600"
}, {
  "name": "港闸区",
  "value": "320611",
  "parent": "320600"
}, {
  "name": "通州区",
  "value": "320612",
  "parent": "320600"
}, {
  "name": "海安县",
  "value": "320621",
  "parent": "320600"
}, {
  "name": "如东县",
  "value": "320623",
  "parent": "320600"
}, {
  "name": "启东市",
  "value": "320681",
  "parent": "320600"
}, {
  "name": "如皋市",
  "value": "320682",
  "parent": "320600"
}, {
  "name": "海门市",
  "value": "320684",
  "parent": "320600"
}, {
  "name": "连云区",
  "value": "320703",
  "parent": "320700"
}, {
  "name": "海州区",
  "value": "320706",
  "parent": "320700"
}, {
  "name": "赣榆区",
  "value": "320707",
  "parent": "320700"
}, {
  "name": "东海县",
  "value": "320722",
  "parent": "320700"
}, {
  "name": "灌云县",
  "value": "320723",
  "parent": "320700"
}, {
  "name": "灌南县",
  "value": "320724",
  "parent": "320700"
}, {
  "name": "清河区",
  "value": "320802",
  "parent": "320800"
}, {
  "name": "淮安区",
  "value": "320803",
  "parent": "320800"
}, {
  "name": "淮阴区",
  "value": "320804",
  "parent": "320800"
}, {
  "name": "清浦区",
  "value": "320811",
  "parent": "320800"
}, {
  "name": "涟水县",
  "value": "320826",
  "parent": "320800"
}, {
  "name": "洪泽县",
  "value": "320829",
  "parent": "320800"
}, {
  "name": "盱眙县",
  "value": "320830",
  "parent": "320800"
}, {
  "name": "金湖县",
  "value": "320831",
  "parent": "320800"
}, {
  "name": "亭湖区",
  "value": "320902",
  "parent": "320900"
}, {
  "name": "盐都区",
  "value": "320903",
  "parent": "320900"
}, {
  "name": "大丰区",
  "value": "320904",
  "parent": "320900"
}, {
  "name": "响水县",
  "value": "320921",
  "parent": "320900"
}, {
  "name": "滨海县",
  "value": "320922",
  "parent": "320900"
}, {
  "name": "阜宁县",
  "value": "320923",
  "parent": "320900"
}, {
  "name": "射阳县",
  "value": "320924",
  "parent": "320900"
}, {
  "name": "建湖县",
  "value": "320925",
  "parent": "320900"
}, {
  "name": "东台市",
  "value": "320981",
  "parent": "320900"
}, {
  "name": "广陵区",
  "value": "321002",
  "parent": "321000"
}, {
  "name": "邗江区",
  "value": "321003",
  "parent": "321000"
}, {
  "name": "江都区",
  "value": "321012",
  "parent": "321000"
}, {
  "name": "宝应县",
  "value": "321023",
  "parent": "321000"
}, {
  "name": "仪征市",
  "value": "321081",
  "parent": "321000"
}, {
  "name": "高邮市",
  "value": "321084",
  "parent": "321000"
}, {
  "name": "京口区",
  "value": "321102",
  "parent": "321100"
}, {
  "name": "润州区",
  "value": "321111",
  "parent": "321100"
}, {
  "name": "丹徒区",
  "value": "321112",
  "parent": "321100"
}, {
  "name": "丹阳市",
  "value": "321181",
  "parent": "321100"
}, {
  "name": "扬中市",
  "value": "321182",
  "parent": "321100"
}, {
  "name": "句容市",
  "value": "321183",
  "parent": "321100"
}, {
  "name": "海陵区",
  "value": "321202",
  "parent": "321200"
}, {
  "name": "高港区",
  "value": "321203",
  "parent": "321200"
}, {
  "name": "姜堰区",
  "value": "321204",
  "parent": "321200"
}, {
  "name": "兴化市",
  "value": "321281",
  "parent": "321200"
}, {
  "name": "靖江市",
  "value": "321282",
  "parent": "321200"
}, {
  "name": "泰兴市",
  "value": "321283",
  "parent": "321200"
}, {
  "name": "宿城区",
  "value": "321302",
  "parent": "321300"
}, {
  "name": "宿豫区",
  "value": "321311",
  "parent": "321300"
}, {
  "name": "沭阳县",
  "value": "321322",
  "parent": "321300"
}, {
  "name": "泗阳县",
  "value": "321323",
  "parent": "321300"
}, {
  "name": "泗洪县",
  "value": "321324",
  "parent": "321300"
}, {
  "name": "杭州市",
  "value": "330100",
  "parent": "330000"
}, {
  "name": "宁波市",
  "value": "330200",
  "parent": "330000"
}, {
  "name": "温州市",
  "value": "330300",
  "parent": "330000"
}, {
  "name": "嘉兴市",
  "value": "330400",
  "parent": "330000"
}, {
  "name": "湖州市",
  "value": "330500",
  "parent": "330000"
}, {
  "name": "绍兴市",
  "value": "330600",
  "parent": "330000"
}, {
  "name": "金华市",
  "value": "330700",
  "parent": "330000"
}, {
  "name": "衢州市",
  "value": "330800",
  "parent": "330000"
}, {
  "name": "舟山市",
  "value": "330900",
  "parent": "330000"
}, {
  "name": "台州市",
  "value": "331000",
  "parent": "330000"
}, {
  "name": "丽水市",
  "value": "331100",
  "parent": "330000"
}, {
  "name": "上城区",
  "value": "330102",
  "parent": "330100"
}, {
  "name": "下城区",
  "value": "330103",
  "parent": "330100"
}, {
  "name": "江干区",
  "value": "330104",
  "parent": "330100"
}, {
  "name": "拱墅区",
  "value": "330105",
  "parent": "330100"
}, {
  "name": "西湖区",
  "value": "330106",
  "parent": "330100"
}, {
  "name": "滨江区",
  "value": "330108",
  "parent": "330100"
}, {
  "name": "萧山区",
  "value": "330109",
  "parent": "330100"
}, {
  "name": "余杭区",
  "value": "330110",
  "parent": "330100"
}, {
  "name": "富阳区",
  "value": "330111",
  "parent": "330100"
}, {
  "name": "桐庐县",
  "value": "330122",
  "parent": "330100"
}, {
  "name": "淳安县",
  "value": "330127",
  "parent": "330100"
}, {
  "name": "建德市",
  "value": "330182",
  "parent": "330100"
}, {
  "name": "临安市",
  "value": "330185",
  "parent": "330100"
}, {
  "name": "海曙区",
  "value": "330203",
  "parent": "330200"
}, {
  "name": "江东区",
  "value": "330204",
  "parent": "330200"
}, {
  "name": "江北区",
  "value": "330205",
  "parent": "330200"
}, {
  "name": "北仑区",
  "value": "330206",
  "parent": "330200"
}, {
  "name": "镇海区",
  "value": "330211",
  "parent": "330200"
}, {
  "name": "鄞州区",
  "value": "330212",
  "parent": "330200"
}, {
  "name": "象山县",
  "value": "330225",
  "parent": "330200"
}, {
  "name": "宁海县",
  "value": "330226",
  "parent": "330200"
}, {
  "name": "余姚市",
  "value": "330281",
  "parent": "330200"
}, {
  "name": "慈溪市",
  "value": "330282",
  "parent": "330200"
}, {
  "name": "奉化市",
  "value": "330283",
  "parent": "330200"
}, {
  "name": "鹿城区",
  "value": "330302",
  "parent": "330300"
}, {
  "name": "龙湾区",
  "value": "330303",
  "parent": "330300"
}, {
  "name": "瓯海区",
  "value": "330304",
  "parent": "330300"
}, {
  "name": "洞头区",
  "value": "330305",
  "parent": "330300"
}, {
  "name": "永嘉县",
  "value": "330324",
  "parent": "330300"
}, {
  "name": "平阳县",
  "value": "330326",
  "parent": "330300"
}, {
  "name": "苍南县",
  "value": "330327",
  "parent": "330300"
}, {
  "name": "文成县",
  "value": "330328",
  "parent": "330300"
}, {
  "name": "泰顺县",
  "value": "330329",
  "parent": "330300"
}, {
  "name": "瑞安市",
  "value": "330381",
  "parent": "330300"
}, {
  "name": "乐清市",
  "value": "330382",
  "parent": "330300"
}, {
  "name": "南湖区",
  "value": "330402",
  "parent": "330400"
}, {
  "name": "秀洲区",
  "value": "330411",
  "parent": "330400"
}, {
  "name": "嘉善县",
  "value": "330421",
  "parent": "330400"
}, {
  "name": "海盐县",
  "value": "330424",
  "parent": "330400"
}, {
  "name": "海宁市",
  "value": "330481",
  "parent": "330400"
}, {
  "name": "平湖市",
  "value": "330482",
  "parent": "330400"
}, {
  "name": "桐乡市",
  "value": "330483",
  "parent": "330400"
}, {
  "name": "吴兴区",
  "value": "330502",
  "parent": "330500"
}, {
  "name": "南浔区",
  "value": "330503",
  "parent": "330500"
}, {
  "name": "德清县",
  "value": "330521",
  "parent": "330500"
}, {
  "name": "长兴县",
  "value": "330522",
  "parent": "330500"
}, {
  "name": "安吉县",
  "value": "330523",
  "parent": "330500"
}, {
  "name": "越城区",
  "value": "330602",
  "parent": "330600"
}, {
  "name": "柯桥区",
  "value": "330603",
  "parent": "330600"
}, {
  "name": "上虞区",
  "value": "330604",
  "parent": "330600"
}, {
  "name": "新昌县",
  "value": "330624",
  "parent": "330600"
}, {
  "name": "诸暨市",
  "value": "330681",
  "parent": "330600"
}, {
  "name": "嵊州市",
  "value": "330683",
  "parent": "330600"
}, {
  "name": "婺城区",
  "value": "330702",
  "parent": "330700"
}, {
  "name": "金东区",
  "value": "330703",
  "parent": "330700"
}, {
  "name": "武义县",
  "value": "330723",
  "parent": "330700"
}, {
  "name": "浦江县",
  "value": "330726",
  "parent": "330700"
}, {
  "name": "磐安县",
  "value": "330727",
  "parent": "330700"
}, {
  "name": "兰溪市",
  "value": "330781",
  "parent": "330700"
}, {
  "name": "义乌市",
  "value": "330782",
  "parent": "330700"
}, {
  "name": "东阳市",
  "value": "330783",
  "parent": "330700"
}, {
  "name": "永康市",
  "value": "330784",
  "parent": "330700"
}, {
  "name": "柯城区",
  "value": "330802",
  "parent": "330800"
}, {
  "name": "衢江区",
  "value": "330803",
  "parent": "330800"
}, {
  "name": "常山县",
  "value": "330822",
  "parent": "330800"
}, {
  "name": "开化县",
  "value": "330824",
  "parent": "330800"
}, {
  "name": "龙游县",
  "value": "330825",
  "parent": "330800"
}, {
  "name": "江山市",
  "value": "330881",
  "parent": "330800"
}, {
  "name": "定海区",
  "value": "330902",
  "parent": "330900"
}, {
  "name": "普陀区",
  "value": "330903",
  "parent": "330900"
}, {
  "name": "岱山县",
  "value": "330921",
  "parent": "330900"
}, {
  "name": "嵊泗县",
  "value": "330922",
  "parent": "330900"
}, {
  "name": "椒江区",
  "value": "331002",
  "parent": "331000"
}, {
  "name": "黄岩区",
  "value": "331003",
  "parent": "331000"
}, {
  "name": "路桥区",
  "value": "331004",
  "parent": "331000"
}, {
  "name": "玉环县",
  "value": "331021",
  "parent": "331000"
}, {
  "name": "三门县",
  "value": "331022",
  "parent": "331000"
}, {
  "name": "天台县",
  "value": "331023",
  "parent": "331000"
}, {
  "name": "仙居县",
  "value": "331024",
  "parent": "331000"
}, {
  "name": "温岭市",
  "value": "331081",
  "parent": "331000"
}, {
  "name": "临海市",
  "value": "331082",
  "parent": "331000"
}, {
  "name": "莲都区",
  "value": "331102",
  "parent": "331100"
}, {
  "name": "青田县",
  "value": "331121",
  "parent": "331100"
}, {
  "name": "缙云县",
  "value": "331122",
  "parent": "331100"
}, {
  "name": "遂昌县",
  "value": "331123",
  "parent": "331100"
}, {
  "name": "松阳县",
  "value": "331124",
  "parent": "331100"
}, {
  "name": "云和县",
  "value": "331125",
  "parent": "331100"
}, {
  "name": "庆元县",
  "value": "331126",
  "parent": "331100"
}, {
  "name": "景宁畲族自治县",
  "value": "331127",
  "parent": "331100"
}, {
  "name": "龙泉市",
  "value": "331181",
  "parent": "331100"
}, {
  "name": "合肥市",
  "value": "340100",
  "parent": "340000"
}, {
  "name": "芜湖市",
  "value": "340200",
  "parent": "340000"
}, {
  "name": "蚌埠市",
  "value": "340300",
  "parent": "340000"
}, {
  "name": "淮南市",
  "value": "340400",
  "parent": "340000"
}, {
  "name": "马鞍山市",
  "value": "340500",
  "parent": "340000"
}, {
  "name": "淮北市",
  "value": "340600",
  "parent": "340000"
}, {
  "name": "铜陵市",
  "value": "340700",
  "parent": "340000"
}, {
  "name": "安庆市",
  "value": "340800",
  "parent": "340000"
}, {
  "name": "黄山市",
  "value": "341000",
  "parent": "340000"
}, {
  "name": "滁州市",
  "value": "341100",
  "parent": "340000"
}, {
  "name": "阜阳市",
  "value": "341200",
  "parent": "340000"
}, {
  "name": "宿州市",
  "value": "341300",
  "parent": "340000"
}, {
  "name": "六安市",
  "value": "341500",
  "parent": "340000"
}, {
  "name": "亳州市",
  "value": "341600",
  "parent": "340000"
}, {
  "name": "池州市",
  "value": "341700",
  "parent": "340000"
}, {
  "name": "宣城市",
  "value": "341800",
  "parent": "340000"
}, {
  "name": "瑶海区",
  "value": "340102",
  "parent": "340100"
}, {
  "name": "庐阳区",
  "value": "340103",
  "parent": "340100"
}, {
  "name": "蜀山区",
  "value": "340104",
  "parent": "340100"
}, {
  "name": "包河区",
  "value": "340111",
  "parent": "340100"
}, {
  "name": "长丰县",
  "value": "340121",
  "parent": "340100"
}, {
  "name": "肥东县",
  "value": "340122",
  "parent": "340100"
}, {
  "name": "肥西县",
  "value": "340123",
  "parent": "340100"
}, {
  "name": "庐江县",
  "value": "340124",
  "parent": "340100"
}, {
  "name": "巢湖市",
  "value": "340181",
  "parent": "340100"
}, {
  "name": "镜湖区",
  "value": "340202",
  "parent": "340200"
}, {
  "name": "弋江区",
  "value": "340203",
  "parent": "340200"
}, {
  "name": "鸠江区",
  "value": "340207",
  "parent": "340200"
}, {
  "name": "三山区",
  "value": "340208",
  "parent": "340200"
}, {
  "name": "芜湖县",
  "value": "340221",
  "parent": "340200"
}, {
  "name": "繁昌县",
  "value": "340222",
  "parent": "340200"
}, {
  "name": "南陵县",
  "value": "340223",
  "parent": "340200"
}, {
  "name": "无为县",
  "value": "340225",
  "parent": "340200"
}, {
  "name": "龙子湖区",
  "value": "340302",
  "parent": "340300"
}, {
  "name": "蚌山区",
  "value": "340303",
  "parent": "340300"
}, {
  "name": "禹会区",
  "value": "340304",
  "parent": "340300"
}, {
  "name": "淮上区",
  "value": "340311",
  "parent": "340300"
}, {
  "name": "怀远县",
  "value": "340321",
  "parent": "340300"
}, {
  "name": "五河县",
  "value": "340322",
  "parent": "340300"
}, {
  "name": "固镇县",
  "value": "340323",
  "parent": "340300"
}, {
  "name": "大通区",
  "value": "340402",
  "parent": "340400"
}, {
  "name": "田家庵区",
  "value": "340403",
  "parent": "340400"
}, {
  "name": "谢家集区",
  "value": "340404",
  "parent": "340400"
}, {
  "name": "八公山区",
  "value": "340405",
  "parent": "340400"
}, {
  "name": "潘集区",
  "value": "340406",
  "parent": "340400"
}, {
  "name": "凤台县",
  "value": "340421",
  "parent": "340400"
}, {
  "name": "寿县",
  "value": "340422",
  "parent": "340400"
}, {
  "name": "花山区",
  "value": "340503",
  "parent": "340500"
}, {
  "name": "雨山区",
  "value": "340504",
  "parent": "340500"
}, {
  "name": "博望区",
  "value": "340506",
  "parent": "340500"
}, {
  "name": "当涂县",
  "value": "340521",
  "parent": "340500"
}, {
  "name": "含山县",
  "value": "340522",
  "parent": "340500"
}, {
  "name": "和县",
  "value": "340523",
  "parent": "340500"
}, {
  "name": "杜集区",
  "value": "340602",
  "parent": "340600"
}, {
  "name": "相山区",
  "value": "340603",
  "parent": "340600"
}, {
  "name": "烈山区",
  "value": "340604",
  "parent": "340600"
}, {
  "name": "濉溪县",
  "value": "340621",
  "parent": "340600"
}, {
  "name": "铜官区",
  "value": "340705",
  "parent": "340700"
}, {
  "name": "义安区",
  "value": "340706",
  "parent": "340700"
}, {
  "name": "郊区",
  "value": "340711",
  "parent": "340700"
}, {
  "name": "枞阳县",
  "value": "340722",
  "parent": "340700"
}, {
  "name": "迎江区",
  "value": "340802",
  "parent": "340800"
}, {
  "name": "大观区",
  "value": "340803",
  "parent": "340800"
}, {
  "name": "宜秀区",
  "value": "340811",
  "parent": "340800"
}, {
  "name": "怀宁县",
  "value": "340822",
  "parent": "340800"
}, {
  "name": "潜山县",
  "value": "340824",
  "parent": "340800"
}, {
  "name": "太湖县",
  "value": "340825",
  "parent": "340800"
}, {
  "name": "宿松县",
  "value": "340826",
  "parent": "340800"
}, {
  "name": "望江县",
  "value": "340827",
  "parent": "340800"
}, {
  "name": "岳西县",
  "value": "340828",
  "parent": "340800"
}, {
  "name": "桐城市",
  "value": "340881",
  "parent": "340800"
}, {
  "name": "屯溪区",
  "value": "341002",
  "parent": "341000"
}, {
  "name": "黄山区",
  "value": "341003",
  "parent": "341000"
}, {
  "name": "徽州区",
  "value": "341004",
  "parent": "341000"
}, {
  "name": "歙县",
  "value": "341021",
  "parent": "341000"
}, {
  "name": "休宁县",
  "value": "341022",
  "parent": "341000"
}, {
  "name": "黟县",
  "value": "341023",
  "parent": "341000"
}, {
  "name": "祁门县",
  "value": "341024",
  "parent": "341000"
}, {
  "name": "琅琊区",
  "value": "341102",
  "parent": "341100"
}, {
  "name": "南谯区",
  "value": "341103",
  "parent": "341100"
}, {
  "name": "来安县",
  "value": "341122",
  "parent": "341100"
}, {
  "name": "全椒县",
  "value": "341124",
  "parent": "341100"
}, {
  "name": "定远县",
  "value": "341125",
  "parent": "341100"
}, {
  "name": "凤阳县",
  "value": "341126",
  "parent": "341100"
}, {
  "name": "天长市",
  "value": "341181",
  "parent": "341100"
}, {
  "name": "明光市",
  "value": "341182",
  "parent": "341100"
}, {
  "name": "颍州区",
  "value": "341202",
  "parent": "341200"
}, {
  "name": "颍东区",
  "value": "341203",
  "parent": "341200"
}, {
  "name": "颍泉区",
  "value": "341204",
  "parent": "341200"
}, {
  "name": "临泉县",
  "value": "341221",
  "parent": "341200"
}, {
  "name": "太和县",
  "value": "341222",
  "parent": "341200"
}, {
  "name": "阜南县",
  "value": "341225",
  "parent": "341200"
}, {
  "name": "颍上县",
  "value": "341226",
  "parent": "341200"
}, {
  "name": "界首市",
  "value": "341282",
  "parent": "341200"
}, {
  "name": "埇桥区",
  "value": "341302",
  "parent": "341300"
}, {
  "name": "砀山县",
  "value": "341321",
  "parent": "341300"
}, {
  "name": "萧县",
  "value": "341322",
  "parent": "341300"
}, {
  "name": "灵璧县",
  "value": "341323",
  "parent": "341300"
}, {
  "name": "泗县",
  "value": "341324",
  "parent": "341300"
}, {
  "name": "金安区",
  "value": "341502",
  "parent": "341500"
}, {
  "name": "裕安区",
  "value": "341503",
  "parent": "341500"
}, {
  "name": "叶集区",
  "value": "341504",
  "parent": "341500"
}, {
  "name": "霍邱县",
  "value": "341522",
  "parent": "341500"
}, {
  "name": "舒城县",
  "value": "341523",
  "parent": "341500"
}, {
  "name": "金寨县",
  "value": "341524",
  "parent": "341500"
}, {
  "name": "霍山县",
  "value": "341525",
  "parent": "341500"
}, {
  "name": "谯城区",
  "value": "341602",
  "parent": "341600"
}, {
  "name": "涡阳县",
  "value": "341621",
  "parent": "341600"
}, {
  "name": "蒙城县",
  "value": "341622",
  "parent": "341600"
}, {
  "name": "利辛县",
  "value": "341623",
  "parent": "341600"
}, {
  "name": "贵池区",
  "value": "341702",
  "parent": "341700"
}, {
  "name": "东至县",
  "value": "341721",
  "parent": "341700"
}, {
  "name": "石台县",
  "value": "341722",
  "parent": "341700"
}, {
  "name": "青阳县",
  "value": "341723",
  "parent": "341700"
}, {
  "name": "宣州区",
  "value": "341802",
  "parent": "341800"
}, {
  "name": "郎溪县",
  "value": "341821",
  "parent": "341800"
}, {
  "name": "广德县",
  "value": "341822",
  "parent": "341800"
}, {
  "name": "泾县",
  "value": "341823",
  "parent": "341800"
}, {
  "name": "绩溪县",
  "value": "341824",
  "parent": "341800"
}, {
  "name": "旌德县",
  "value": "341825",
  "parent": "341800"
}, {
  "name": "宁国市",
  "value": "341881",
  "parent": "341800"
}, {
  "name": "福州市",
  "value": "350100",
  "parent": "350000"
}, {
  "name": "厦门市",
  "value": "350200",
  "parent": "350000"
}, {
  "name": "莆田市",
  "value": "350300",
  "parent": "350000"
}, {
  "name": "三明市",
  "value": "350400",
  "parent": "350000"
}, {
  "name": "泉州市",
  "value": "350500",
  "parent": "350000"
}, {
  "name": "漳州市",
  "value": "350600",
  "parent": "350000"
}, {
  "name": "南平市",
  "value": "350700",
  "parent": "350000"
}, {
  "name": "龙岩市",
  "value": "350800",
  "parent": "350000"
}, {
  "name": "宁德市",
  "value": "350900",
  "parent": "350000"
}, {
  "name": "鼓楼区",
  "value": "350102",
  "parent": "350100"
}, {
  "name": "台江区",
  "value": "350103",
  "parent": "350100"
}, {
  "name": "仓山区",
  "value": "350104",
  "parent": "350100"
}, {
  "name": "马尾区",
  "value": "350105",
  "parent": "350100"
}, {
  "name": "晋安区",
  "value": "350111",
  "parent": "350100"
}, {
  "name": "闽侯县",
  "value": "350121",
  "parent": "350100"
}, {
  "name": "连江县",
  "value": "350122",
  "parent": "350100"
}, {
  "name": "罗源县",
  "value": "350123",
  "parent": "350100"
}, {
  "name": "闽清县",
  "value": "350124",
  "parent": "350100"
}, {
  "name": "永泰县",
  "value": "350125",
  "parent": "350100"
}, {
  "name": "平潭县",
  "value": "350128",
  "parent": "350100"
}, {
  "name": "福清市",
  "value": "350181",
  "parent": "350100"
}, {
  "name": "长乐市",
  "value": "350182",
  "parent": "350100"
}, {
  "name": "思明区",
  "value": "350203",
  "parent": "350200"
}, {
  "name": "海沧区",
  "value": "350205",
  "parent": "350200"
}, {
  "name": "湖里区",
  "value": "350206",
  "parent": "350200"
}, {
  "name": "集美区",
  "value": "350211",
  "parent": "350200"
}, {
  "name": "同安区",
  "value": "350212",
  "parent": "350200"
}, {
  "name": "翔安区",
  "value": "350213",
  "parent": "350200"
}, {
  "name": "城厢区",
  "value": "350302",
  "parent": "350300"
}, {
  "name": "涵江区",
  "value": "350303",
  "parent": "350300"
}, {
  "name": "荔城区",
  "value": "350304",
  "parent": "350300"
}, {
  "name": "秀屿区",
  "value": "350305",
  "parent": "350300"
}, {
  "name": "仙游县",
  "value": "350322",
  "parent": "350300"
}, {
  "name": "梅列区",
  "value": "350402",
  "parent": "350400"
}, {
  "name": "三元区",
  "value": "350403",
  "parent": "350400"
}, {
  "name": "明溪县",
  "value": "350421",
  "parent": "350400"
}, {
  "name": "清流县",
  "value": "350423",
  "parent": "350400"
}, {
  "name": "宁化县",
  "value": "350424",
  "parent": "350400"
}, {
  "name": "大田县",
  "value": "350425",
  "parent": "350400"
}, {
  "name": "尤溪县",
  "value": "350426",
  "parent": "350400"
}, {
  "name": "沙县",
  "value": "350427",
  "parent": "350400"
}, {
  "name": "将乐县",
  "value": "350428",
  "parent": "350400"
}, {
  "name": "泰宁县",
  "value": "350429",
  "parent": "350400"
}, {
  "name": "建宁县",
  "value": "350430",
  "parent": "350400"
}, {
  "name": "永安市",
  "value": "350481",
  "parent": "350400"
}, {
  "name": "鲤城区",
  "value": "350502",
  "parent": "350500"
}, {
  "name": "丰泽区",
  "value": "350503",
  "parent": "350500"
}, {
  "name": "洛江区",
  "value": "350504",
  "parent": "350500"
}, {
  "name": "泉港区",
  "value": "350505",
  "parent": "350500"
}, {
  "name": "惠安县",
  "value": "350521",
  "parent": "350500"
}, {
  "name": "安溪县",
  "value": "350524",
  "parent": "350500"
}, {
  "name": "永春县",
  "value": "350525",
  "parent": "350500"
}, {
  "name": "德化县",
  "value": "350526",
  "parent": "350500"
}, {
  "name": "金门县",
  "value": "350527",
  "parent": "350500"
}, {
  "name": "石狮市",
  "value": "350581",
  "parent": "350500"
}, {
  "name": "晋江市",
  "value": "350582",
  "parent": "350500"
}, {
  "name": "南安市",
  "value": "350583",
  "parent": "350500"
}, {
  "name": "芗城区",
  "value": "350602",
  "parent": "350600"
}, {
  "name": "龙文区",
  "value": "350603",
  "parent": "350600"
}, {
  "name": "云霄县",
  "value": "350622",
  "parent": "350600"
}, {
  "name": "漳浦县",
  "value": "350623",
  "parent": "350600"
}, {
  "name": "诏安县",
  "value": "350624",
  "parent": "350600"
}, {
  "name": "长泰县",
  "value": "350625",
  "parent": "350600"
}, {
  "name": "东山县",
  "value": "350626",
  "parent": "350600"
}, {
  "name": "南靖县",
  "value": "350627",
  "parent": "350600"
}, {
  "name": "平和县",
  "value": "350628",
  "parent": "350600"
}, {
  "name": "华安县",
  "value": "350629",
  "parent": "350600"
}, {
  "name": "龙海市",
  "value": "350681",
  "parent": "350600"
}, {
  "name": "延平区",
  "value": "350702",
  "parent": "350700"
}, {
  "name": "建阳区",
  "value": "350703",
  "parent": "350700"
}, {
  "name": "顺昌县",
  "value": "350721",
  "parent": "350700"
}, {
  "name": "浦城县",
  "value": "350722",
  "parent": "350700"
}, {
  "name": "光泽县",
  "value": "350723",
  "parent": "350700"
}, {
  "name": "松溪县",
  "value": "350724",
  "parent": "350700"
}, {
  "name": "政和县",
  "value": "350725",
  "parent": "350700"
}, {
  "name": "邵武市",
  "value": "350781",
  "parent": "350700"
}, {
  "name": "武夷山市",
  "value": "350782",
  "parent": "350700"
}, {
  "name": "建瓯市",
  "value": "350783",
  "parent": "350700"
}, {
  "name": "新罗区",
  "value": "350802",
  "parent": "350800"
}, {
  "name": "永定区",
  "value": "350803",
  "parent": "350800"
}, {
  "name": "长汀县",
  "value": "350821",
  "parent": "350800"
}, {
  "name": "上杭县",
  "value": "350823",
  "parent": "350800"
}, {
  "name": "武平县",
  "value": "350824",
  "parent": "350800"
}, {
  "name": "连城县",
  "value": "350825",
  "parent": "350800"
}, {
  "name": "漳平市",
  "value": "350881",
  "parent": "350800"
}, {
  "name": "蕉城区",
  "value": "350902",
  "parent": "350900"
}, {
  "name": "霞浦县",
  "value": "350921",
  "parent": "350900"
}, {
  "name": "古田县",
  "value": "350922",
  "parent": "350900"
}, {
  "name": "屏南县",
  "value": "350923",
  "parent": "350900"
}, {
  "name": "寿宁县",
  "value": "350924",
  "parent": "350900"
}, {
  "name": "周宁县",
  "value": "350925",
  "parent": "350900"
}, {
  "name": "柘荣县",
  "value": "350926",
  "parent": "350900"
}, {
  "name": "福安市",
  "value": "350981",
  "parent": "350900"
}, {
  "name": "福鼎市",
  "value": "350982",
  "parent": "350900"
}, {
  "name": "南昌市",
  "value": "360100",
  "parent": "360000"
}, {
  "name": "景德镇市",
  "value": "360200",
  "parent": "360000"
}, {
  "name": "萍乡市",
  "value": "360300",
  "parent": "360000"
}, {
  "name": "九江市",
  "value": "360400",
  "parent": "360000"
}, {
  "name": "新余市",
  "value": "360500",
  "parent": "360000"
}, {
  "name": "鹰潭市",
  "value": "360600",
  "parent": "360000"
}, {
  "name": "赣州市",
  "value": "360700",
  "parent": "360000"
}, {
  "name": "吉安市",
  "value": "360800",
  "parent": "360000"
}, {
  "name": "宜春市",
  "value": "360900",
  "parent": "360000"
}, {
  "name": "抚州市",
  "value": "361000",
  "parent": "360000"
}, {
  "name": "上饶市",
  "value": "361100",
  "parent": "360000"
}, {
  "name": "东湖区",
  "value": "360102",
  "parent": "360100"
}, {
  "name": "西湖区",
  "value": "360103",
  "parent": "360100"
}, {
  "name": "青云谱区",
  "value": "360104",
  "parent": "360100"
}, {
  "name": "湾里区",
  "value": "360105",
  "parent": "360100"
}, {
  "name": "青山湖区",
  "value": "360111",
  "parent": "360100"
}, {
  "name": "新建区",
  "value": "360112",
  "parent": "360100"
}, {
  "name": "南昌县",
  "value": "360121",
  "parent": "360100"
}, {
  "name": "安义县",
  "value": "360123",
  "parent": "360100"
}, {
  "name": "进贤县",
  "value": "360124",
  "parent": "360100"
}, {
  "name": "昌江区",
  "value": "360202",
  "parent": "360200"
}, {
  "name": "珠山区",
  "value": "360203",
  "parent": "360200"
}, {
  "name": "浮梁县",
  "value": "360222",
  "parent": "360200"
}, {
  "name": "乐平市",
  "value": "360281",
  "parent": "360200"
}, {
  "name": "安源区",
  "value": "360302",
  "parent": "360300"
}, {
  "name": "湘东区",
  "value": "360313",
  "parent": "360300"
}, {
  "name": "莲花县",
  "value": "360321",
  "parent": "360300"
}, {
  "name": "上栗县",
  "value": "360322",
  "parent": "360300"
}, {
  "name": "芦溪县",
  "value": "360323",
  "parent": "360300"
}, {
  "name": "庐山区",
  "value": "360402",
  "parent": "360400"
}, {
  "name": "浔阳区",
  "value": "360403",
  "parent": "360400"
}, {
  "name": "九江县",
  "value": "360421",
  "parent": "360400"
}, {
  "name": "武宁县",
  "value": "360423",
  "parent": "360400"
}, {
  "name": "修水县",
  "value": "360424",
  "parent": "360400"
}, {
  "name": "永修县",
  "value": "360425",
  "parent": "360400"
}, {
  "name": "德安县",
  "value": "360426",
  "parent": "360400"
}, {
  "name": "星子县",
  "value": "360427",
  "parent": "360400"
}, {
  "name": "都昌县",
  "value": "360428",
  "parent": "360400"
}, {
  "name": "湖口县",
  "value": "360429",
  "parent": "360400"
}, {
  "name": "彭泽县",
  "value": "360430",
  "parent": "360400"
}, {
  "name": "瑞昌市",
  "value": "360481",
  "parent": "360400"
}, {
  "name": "共青城市",
  "value": "360482",
  "parent": "360400"
}, {
  "name": "渝水区",
  "value": "360502",
  "parent": "360500"
}, {
  "name": "分宜县",
  "value": "360521",
  "parent": "360500"
}, {
  "name": "月湖区",
  "value": "360602",
  "parent": "360600"
}, {
  "name": "余江县",
  "value": "360622",
  "parent": "360600"
}, {
  "name": "贵溪市",
  "value": "360681",
  "parent": "360600"
}, {
  "name": "章贡区",
  "value": "360702",
  "parent": "360700"
}, {
  "name": "南康区",
  "value": "360703",
  "parent": "360700"
}, {
  "name": "赣县",
  "value": "360721",
  "parent": "360700"
}, {
  "name": "信丰县",
  "value": "360722",
  "parent": "360700"
}, {
  "name": "大余县",
  "value": "360723",
  "parent": "360700"
}, {
  "name": "上犹县",
  "value": "360724",
  "parent": "360700"
}, {
  "name": "崇义县",
  "value": "360725",
  "parent": "360700"
}, {
  "name": "安远县",
  "value": "360726",
  "parent": "360700"
}, {
  "name": "龙南县",
  "value": "360727",
  "parent": "360700"
}, {
  "name": "定南县",
  "value": "360728",
  "parent": "360700"
}, {
  "name": "全南县",
  "value": "360729",
  "parent": "360700"
}, {
  "name": "宁都县",
  "value": "360730",
  "parent": "360700"
}, {
  "name": "于都县",
  "value": "360731",
  "parent": "360700"
}, {
  "name": "兴国县",
  "value": "360732",
  "parent": "360700"
}, {
  "name": "会昌县",
  "value": "360733",
  "parent": "360700"
}, {
  "name": "寻乌县",
  "value": "360734",
  "parent": "360700"
}, {
  "name": "石城县",
  "value": "360735",
  "parent": "360700"
}, {
  "name": "瑞金市",
  "value": "360781",
  "parent": "360700"
}, {
  "name": "吉州区",
  "value": "360802",
  "parent": "360800"
}, {
  "name": "青原区",
  "value": "360803",
  "parent": "360800"
}, {
  "name": "吉安县",
  "value": "360821",
  "parent": "360800"
}, {
  "name": "吉水县",
  "value": "360822",
  "parent": "360800"
}, {
  "name": "峡江县",
  "value": "360823",
  "parent": "360800"
}, {
  "name": "新干县",
  "value": "360824",
  "parent": "360800"
}, {
  "name": "永丰县",
  "value": "360825",
  "parent": "360800"
}, {
  "name": "泰和县",
  "value": "360826",
  "parent": "360800"
}, {
  "name": "遂川县",
  "value": "360827",
  "parent": "360800"
}, {
  "name": "万安县",
  "value": "360828",
  "parent": "360800"
}, {
  "name": "安福县",
  "value": "360829",
  "parent": "360800"
}, {
  "name": "永新县",
  "value": "360830",
  "parent": "360800"
}, {
  "name": "井冈山市",
  "value": "360881",
  "parent": "360800"
}, {
  "name": "袁州区",
  "value": "360902",
  "parent": "360900"
}, {
  "name": "奉新县",
  "value": "360921",
  "parent": "360900"
}, {
  "name": "万载县",
  "value": "360922",
  "parent": "360900"
}, {
  "name": "上高县",
  "value": "360923",
  "parent": "360900"
}, {
  "name": "宜丰县",
  "value": "360924",
  "parent": "360900"
}, {
  "name": "靖安县",
  "value": "360925",
  "parent": "360900"
}, {
  "name": "铜鼓县",
  "value": "360926",
  "parent": "360900"
}, {
  "name": "丰城市",
  "value": "360981",
  "parent": "360900"
}, {
  "name": "樟树市",
  "value": "360982",
  "parent": "360900"
}, {
  "name": "高安市",
  "value": "360983",
  "parent": "360900"
}, {
  "name": "临川区",
  "value": "361002",
  "parent": "361000"
}, {
  "name": "南城县",
  "value": "361021",
  "parent": "361000"
}, {
  "name": "黎川县",
  "value": "361022",
  "parent": "361000"
}, {
  "name": "南丰县",
  "value": "361023",
  "parent": "361000"
}, {
  "name": "崇仁县",
  "value": "361024",
  "parent": "361000"
}, {
  "name": "乐安县",
  "value": "361025",
  "parent": "361000"
}, {
  "name": "宜黄县",
  "value": "361026",
  "parent": "361000"
}, {
  "name": "金溪县",
  "value": "361027",
  "parent": "361000"
}, {
  "name": "资溪县",
  "value": "361028",
  "parent": "361000"
}, {
  "name": "东乡县",
  "value": "361029",
  "parent": "361000"
}, {
  "name": "广昌县",
  "value": "361030",
  "parent": "361000"
}, {
  "name": "信州区",
  "value": "361102",
  "parent": "361100"
}, {
  "name": "广丰区",
  "value": "361103",
  "parent": "361100"
}, {
  "name": "上饶县",
  "value": "361121",
  "parent": "361100"
}, {
  "name": "玉山县",
  "value": "361123",
  "parent": "361100"
}, {
  "name": "铅山县",
  "value": "361124",
  "parent": "361100"
}, {
  "name": "横峰县",
  "value": "361125",
  "parent": "361100"
}, {
  "name": "弋阳县",
  "value": "361126",
  "parent": "361100"
}, {
  "name": "余干县",
  "value": "361127",
  "parent": "361100"
}, {
  "name": "鄱阳县",
  "value": "361128",
  "parent": "361100"
}, {
  "name": "万年县",
  "value": "361129",
  "parent": "361100"
}, {
  "name": "婺源县",
  "value": "361130",
  "parent": "361100"
}, {
  "name": "德兴市",
  "value": "361181",
  "parent": "361100"
}, {
  "name": "济南市",
  "value": "370100",
  "parent": "370000"
}, {
  "name": "青岛市",
  "value": "370200",
  "parent": "370000"
}, {
  "name": "淄博市",
  "value": "370300",
  "parent": "370000"
}, {
  "name": "枣庄市",
  "value": "370400",
  "parent": "370000"
}, {
  "name": "东营市",
  "value": "370500",
  "parent": "370000"
}, {
  "name": "烟台市",
  "value": "370600",
  "parent": "370000"
}, {
  "name": "潍坊市",
  "value": "370700",
  "parent": "370000"
}, {
  "name": "济宁市",
  "value": "370800",
  "parent": "370000"
}, {
  "name": "泰安市",
  "value": "370900",
  "parent": "370000"
}, {
  "name": "威海市",
  "value": "371000",
  "parent": "370000"
}, {
  "name": "日照市",
  "value": "371100",
  "parent": "370000"
}, {
  "name": "莱芜市",
  "value": "371200",
  "parent": "370000"
}, {
  "name": "临沂市",
  "value": "371300",
  "parent": "370000"
}, {
  "name": "德州市",
  "value": "371400",
  "parent": "370000"
}, {
  "name": "聊城市",
  "value": "371500",
  "parent": "370000"
}, {
  "name": "滨州市",
  "value": "371600",
  "parent": "370000"
}, {
  "name": "菏泽市",
  "value": "371700",
  "parent": "370000"
}, {
  "name": "历下区",
  "value": "370102",
  "parent": "370100"
}, {
  "name": "市中区",
  "value": "370103",
  "parent": "370100"
}, {
  "name": "槐荫区",
  "value": "370104",
  "parent": "370100"
}, {
  "name": "天桥区",
  "value": "370105",
  "parent": "370100"
}, {
  "name": "历城区",
  "value": "370112",
  "parent": "370100"
}, {
  "name": "长清区",
  "value": "370113",
  "parent": "370100"
}, {
  "name": "平阴县",
  "value": "370124",
  "parent": "370100"
}, {
  "name": "济阳县",
  "value": "370125",
  "parent": "370100"
}, {
  "name": "商河县",
  "value": "370126",
  "parent": "370100"
}, {
  "name": "章丘市",
  "value": "370181",
  "parent": "370100"
}, {
  "name": "市南区",
  "value": "370202",
  "parent": "370200"
}, {
  "name": "市北区",
  "value": "370203",
  "parent": "370200"
}, {
  "name": "黄岛区",
  "value": "370211",
  "parent": "370200"
}, {
  "name": "崂山区",
  "value": "370212",
  "parent": "370200"
}, {
  "name": "李沧区",
  "value": "370213",
  "parent": "370200"
}, {
  "name": "城阳区",
  "value": "370214",
  "parent": "370200"
}, {
  "name": "胶州市",
  "value": "370281",
  "parent": "370200"
}, {
  "name": "即墨市",
  "value": "370282",
  "parent": "370200"
}, {
  "name": "平度市",
  "value": "370283",
  "parent": "370200"
}, {
  "name": "莱西市",
  "value": "370285",
  "parent": "370200"
}, {
  "name": "淄川区",
  "value": "370302",
  "parent": "370300"
}, {
  "name": "张店区",
  "value": "370303",
  "parent": "370300"
}, {
  "name": "博山区",
  "value": "370304",
  "parent": "370300"
}, {
  "name": "临淄区",
  "value": "370305",
  "parent": "370300"
}, {
  "name": "周村区",
  "value": "370306",
  "parent": "370300"
}, {
  "name": "桓台县",
  "value": "370321",
  "parent": "370300"
}, {
  "name": "高青县",
  "value": "370322",
  "parent": "370300"
}, {
  "name": "沂源县",
  "value": "370323",
  "parent": "370300"
}, {
  "name": "市中区",
  "value": "370402",
  "parent": "370400"
}, {
  "name": "薛城区",
  "value": "370403",
  "parent": "370400"
}, {
  "name": "峄城区",
  "value": "370404",
  "parent": "370400"
}, {
  "name": "台儿庄区",
  "value": "370405",
  "parent": "370400"
}, {
  "name": "山亭区",
  "value": "370406",
  "parent": "370400"
}, {
  "name": "滕州市",
  "value": "370481",
  "parent": "370400"
}, {
  "name": "东营区",
  "value": "370502",
  "parent": "370500"
}, {
  "name": "河口区",
  "value": "370503",
  "parent": "370500"
}, {
  "name": "垦利县",
  "value": "370521",
  "parent": "370500"
}, {
  "name": "利津县",
  "value": "370522",
  "parent": "370500"
}, {
  "name": "广饶县",
  "value": "370523",
  "parent": "370500"
}, {
  "name": "芝罘区",
  "value": "370602",
  "parent": "370600"
}, {
  "name": "福山区",
  "value": "370611",
  "parent": "370600"
}, {
  "name": "牟平区",
  "value": "370612",
  "parent": "370600"
}, {
  "name": "莱山区",
  "value": "370613",
  "parent": "370600"
}, {
  "name": "长岛县",
  "value": "370634",
  "parent": "370600"
}, {
  "name": "龙口市",
  "value": "370681",
  "parent": "370600"
}, {
  "name": "莱阳市",
  "value": "370682",
  "parent": "370600"
}, {
  "name": "莱州市",
  "value": "370683",
  "parent": "370600"
}, {
  "name": "蓬莱市",
  "value": "370684",
  "parent": "370600"
}, {
  "name": "招远市",
  "value": "370685",
  "parent": "370600"
}, {
  "name": "栖霞市",
  "value": "370686",
  "parent": "370600"
}, {
  "name": "海阳市",
  "value": "370687",
  "parent": "370600"
}, {
  "name": "潍城区",
  "value": "370702",
  "parent": "370700"
}, {
  "name": "寒亭区",
  "value": "370703",
  "parent": "370700"
}, {
  "name": "坊子区",
  "value": "370704",
  "parent": "370700"
}, {
  "name": "奎文区",
  "value": "370705",
  "parent": "370700"
}, {
  "name": "临朐县",
  "value": "370724",
  "parent": "370700"
}, {
  "name": "昌乐县",
  "value": "370725",
  "parent": "370700"
}, {
  "name": "青州市",
  "value": "370781",
  "parent": "370700"
}, {
  "name": "诸城市",
  "value": "370782",
  "parent": "370700"
}, {
  "name": "寿光市",
  "value": "370783",
  "parent": "370700"
}, {
  "name": "安丘市",
  "value": "370784",
  "parent": "370700"
}, {
  "name": "高密市",
  "value": "370785",
  "parent": "370700"
}, {
  "name": "昌邑市",
  "value": "370786",
  "parent": "370700"
}, {
  "name": "任城区",
  "value": "370811",
  "parent": "370800"
}, {
  "name": "兖州区",
  "value": "370812",
  "parent": "370800"
}, {
  "name": "微山县",
  "value": "370826",
  "parent": "370800"
}, {
  "name": "鱼台县",
  "value": "370827",
  "parent": "370800"
}, {
  "name": "金乡县",
  "value": "370828",
  "parent": "370800"
}, {
  "name": "嘉祥县",
  "value": "370829",
  "parent": "370800"
}, {
  "name": "汶上县",
  "value": "370830",
  "parent": "370800"
}, {
  "name": "泗水县",
  "value": "370831",
  "parent": "370800"
}, {
  "name": "梁山县",
  "value": "370832",
  "parent": "370800"
}, {
  "name": "曲阜市",
  "value": "370881",
  "parent": "370800"
}, {
  "name": "邹城市",
  "value": "370883",
  "parent": "370800"
}, {
  "name": "泰山区",
  "value": "370902",
  "parent": "370900"
}, {
  "name": "岱岳区",
  "value": "370911",
  "parent": "370900"
}, {
  "name": "宁阳县",
  "value": "370921",
  "parent": "370900"
}, {
  "name": "东平县",
  "value": "370923",
  "parent": "370900"
}, {
  "name": "新泰市",
  "value": "370982",
  "parent": "370900"
}, {
  "name": "肥城市",
  "value": "370983",
  "parent": "370900"
}, {
  "name": "环翠区",
  "value": "371002",
  "parent": "371000"
}, {
  "name": "文登区",
  "value": "371003",
  "parent": "371000"
}, {
  "name": "荣成市",
  "value": "371082",
  "parent": "371000"
}, {
  "name": "乳山市",
  "value": "371083",
  "parent": "371000"
}, {
  "name": "东港区",
  "value": "371102",
  "parent": "371100"
}, {
  "name": "岚山区",
  "value": "371103",
  "parent": "371100"
}, {
  "name": "五莲县",
  "value": "371121",
  "parent": "371100"
}, {
  "name": "莒县",
  "value": "371122",
  "parent": "371100"
}, {
  "name": "莱城区",
  "value": "371202",
  "parent": "371200"
}, {
  "name": "钢城区",
  "value": "371203",
  "parent": "371200"
}, {
  "name": "兰山区",
  "value": "371302",
  "parent": "371300"
}, {
  "name": "罗庄区",
  "value": "371311",
  "parent": "371300"
}, {
  "name": "河东区",
  "value": "371312",
  "parent": "371300"
}, {
  "name": "沂南县",
  "value": "371321",
  "parent": "371300"
}, {
  "name": "郯城县",
  "value": "371322",
  "parent": "371300"
}, {
  "name": "沂水县",
  "value": "371323",
  "parent": "371300"
}, {
  "name": "兰陵县",
  "value": "371324",
  "parent": "371300"
}, {
  "name": "费县",
  "value": "371325",
  "parent": "371300"
}, {
  "name": "平邑县",
  "value": "371326",
  "parent": "371300"
}, {
  "name": "莒南县",
  "value": "371327",
  "parent": "371300"
}, {
  "name": "蒙阴县",
  "value": "371328",
  "parent": "371300"
}, {
  "name": "临沭县",
  "value": "371329",
  "parent": "371300"
}, {
  "name": "德城区",
  "value": "371402",
  "parent": "371400"
}, {
  "name": "陵城区",
  "value": "371403",
  "parent": "371400"
}, {
  "name": "宁津县",
  "value": "371422",
  "parent": "371400"
}, {
  "name": "庆云县",
  "value": "371423",
  "parent": "371400"
}, {
  "name": "临邑县",
  "value": "371424",
  "parent": "371400"
}, {
  "name": "齐河县",
  "value": "371425",
  "parent": "371400"
}, {
  "name": "平原县",
  "value": "371426",
  "parent": "371400"
}, {
  "name": "夏津县",
  "value": "371427",
  "parent": "371400"
}, {
  "name": "武城县",
  "value": "371428",
  "parent": "371400"
}, {
  "name": "乐陵市",
  "value": "371481",
  "parent": "371400"
}, {
  "name": "禹城市",
  "value": "371482",
  "parent": "371400"
}, {
  "name": "东昌府区",
  "value": "371502",
  "parent": "371500"
}, {
  "name": "阳谷县",
  "value": "371521",
  "parent": "371500"
}, {
  "name": "莘县",
  "value": "371522",
  "parent": "371500"
}, {
  "name": "茌平县",
  "value": "371523",
  "parent": "371500"
}, {
  "name": "东阿县",
  "value": "371524",
  "parent": "371500"
}, {
  "name": "冠县",
  "value": "371525",
  "parent": "371500"
}, {
  "name": "高唐县",
  "value": "371526",
  "parent": "371500"
}, {
  "name": "临清市",
  "value": "371581",
  "parent": "371500"
}, {
  "name": "滨城区",
  "value": "371602",
  "parent": "371600"
}, {
  "name": "沾化区",
  "value": "371603",
  "parent": "371600"
}, {
  "name": "惠民县",
  "value": "371621",
  "parent": "371600"
}, {
  "name": "阳信县",
  "value": "371622",
  "parent": "371600"
}, {
  "name": "无棣县",
  "value": "371623",
  "parent": "371600"
}, {
  "name": "博兴县",
  "value": "371625",
  "parent": "371600"
}, {
  "name": "邹平县",
  "value": "371626",
  "parent": "371600"
}, {
  "name": "牡丹区",
  "value": "371702",
  "parent": "371700"
}, {
  "name": "曹县",
  "value": "371721",
  "parent": "371700"
}, {
  "name": "单县",
  "value": "371722",
  "parent": "371700"
}, {
  "name": "成武县",
  "value": "371723",
  "parent": "371700"
}, {
  "name": "巨野县",
  "value": "371724",
  "parent": "371700"
}, {
  "name": "郓城县",
  "value": "371725",
  "parent": "371700"
}, {
  "name": "鄄城县",
  "value": "371726",
  "parent": "371700"
}, {
  "name": "定陶县",
  "value": "371727",
  "parent": "371700"
}, {
  "name": "东明县",
  "value": "371728",
  "parent": "371700"
}, {
  "name": "郑州市",
  "value": "410100",
  "parent": "410000"
}, {
  "name": "开封市",
  "value": "410200",
  "parent": "410000"
}, {
  "name": "洛阳市",
  "value": "410300",
  "parent": "410000"
}, {
  "name": "平顶山市",
  "value": "410400",
  "parent": "410000"
}, {
  "name": "安阳市",
  "value": "410500",
  "parent": "410000"
}, {
  "name": "鹤壁市",
  "value": "410600",
  "parent": "410000"
}, {
  "name": "新乡市",
  "value": "410700",
  "parent": "410000"
}, {
  "name": "焦作市",
  "value": "410800",
  "parent": "410000"
}, {
  "name": "濮阳市",
  "value": "410900",
  "parent": "410000"
}, {
  "name": "许昌市",
  "value": "411000",
  "parent": "410000"
}, {
  "name": "漯河市",
  "value": "411100",
  "parent": "410000"
}, {
  "name": "三门峡市",
  "value": "411200",
  "parent": "410000"
}, {
  "name": "南阳市",
  "value": "411300",
  "parent": "410000"
}, {
  "name": "商丘市",
  "value": "411400",
  "parent": "410000"
}, {
  "name": "信阳市",
  "value": "411500",
  "parent": "410000"
}, {
  "name": "周口市",
  "value": "411600",
  "parent": "410000"
}, {
  "name": "驻马店市",
  "value": "411700",
  "parent": "410000"
}, {
  "name": "济源市",
  "value": "419001",
  "parent": "410000"
}, {
  "name": "中原区",
  "value": "410102",
  "parent": "410100"
}, {
  "name": "二七区",
  "value": "410103",
  "parent": "410100"
}, {
  "name": "管城回族区",
  "value": "410104",
  "parent": "410100"
}, {
  "name": "金水区",
  "value": "410105",
  "parent": "410100"
}, {
  "name": "上街区",
  "value": "410106",
  "parent": "410100"
}, {
  "name": "惠济区",
  "value": "410108",
  "parent": "410100"
}, {
  "name": "中牟县",
  "value": "410122",
  "parent": "410100"
}, {
  "name": "巩义市",
  "value": "410181",
  "parent": "410100"
}, {
  "name": "荥阳市",
  "value": "410182",
  "parent": "410100"
}, {
  "name": "新密市",
  "value": "410183",
  "parent": "410100"
}, {
  "name": "新郑市",
  "value": "410184",
  "parent": "410100"
}, {
  "name": "登封市",
  "value": "410185",
  "parent": "410100"
}, {
  "name": "龙亭区",
  "value": "410202",
  "parent": "410200"
}, {
  "name": "顺河回族区",
  "value": "410203",
  "parent": "410200"
}, {
  "name": "鼓楼区",
  "value": "410204",
  "parent": "410200"
}, {
  "name": "禹王台区",
  "value": "410205",
  "parent": "410200"
}, {
  "name": "祥符区",
  "value": "410212",
  "parent": "410200"
}, {
  "name": "杞县",
  "value": "410221",
  "parent": "410200"
}, {
  "name": "通许县",
  "value": "410222",
  "parent": "410200"
}, {
  "name": "尉氏县",
  "value": "410223",
  "parent": "410200"
}, {
  "name": "兰考县",
  "value": "410225",
  "parent": "410200"
}, {
  "name": "老城区",
  "value": "410302",
  "parent": "410300"
}, {
  "name": "西工区",
  "value": "410303",
  "parent": "410300"
}, {
  "name": "瀍河回族区",
  "value": "410304",
  "parent": "410300"
}, {
  "name": "涧西区",
  "value": "410305",
  "parent": "410300"
}, {
  "name": "吉利区",
  "value": "410306",
  "parent": "410300"
}, {
  "name": "洛龙区",
  "value": "410311",
  "parent": "410300"
}, {
  "name": "孟津县",
  "value": "410322",
  "parent": "410300"
}, {
  "name": "新安县",
  "value": "410323",
  "parent": "410300"
}, {
  "name": "栾川县",
  "value": "410324",
  "parent": "410300"
}, {
  "name": "嵩县",
  "value": "410325",
  "parent": "410300"
}, {
  "name": "汝阳县",
  "value": "410326",
  "parent": "410300"
}, {
  "name": "宜阳县",
  "value": "410327",
  "parent": "410300"
}, {
  "name": "洛宁县",
  "value": "410328",
  "parent": "410300"
}, {
  "name": "伊川县",
  "value": "410329",
  "parent": "410300"
}, {
  "name": "偃师市",
  "value": "410381",
  "parent": "410300"
}, {
  "name": "新华区",
  "value": "410402",
  "parent": "410400"
}, {
  "name": "卫东区",
  "value": "410403",
  "parent": "410400"
}, {
  "name": "石龙区",
  "value": "410404",
  "parent": "410400"
}, {
  "name": "湛河区",
  "value": "410411",
  "parent": "410400"
}, {
  "name": "宝丰县",
  "value": "410421",
  "parent": "410400"
}, {
  "name": "叶县",
  "value": "410422",
  "parent": "410400"
}, {
  "name": "鲁山县",
  "value": "410423",
  "parent": "410400"
}, {
  "name": "郏县",
  "value": "410425",
  "parent": "410400"
}, {
  "name": "舞钢市",
  "value": "410481",
  "parent": "410400"
}, {
  "name": "汝州市",
  "value": "410482",
  "parent": "410400"
}, {
  "name": "文峰区",
  "value": "410502",
  "parent": "410500"
}, {
  "name": "北关区",
  "value": "410503",
  "parent": "410500"
}, {
  "name": "殷都区",
  "value": "410505",
  "parent": "410500"
}, {
  "name": "龙安区",
  "value": "410506",
  "parent": "410500"
}, {
  "name": "安阳县",
  "value": "410522",
  "parent": "410500"
}, {
  "name": "汤阴县",
  "value": "410523",
  "parent": "410500"
}, {
  "name": "滑县",
  "value": "410526",
  "parent": "410500"
}, {
  "name": "内黄县",
  "value": "410527",
  "parent": "410500"
}, {
  "name": "林州市",
  "value": "410581",
  "parent": "410500"
}, {
  "name": "鹤山区",
  "value": "410602",
  "parent": "410600"
}, {
  "name": "山城区",
  "value": "410603",
  "parent": "410600"
}, {
  "name": "淇滨区",
  "value": "410611",
  "parent": "410600"
}, {
  "name": "浚县",
  "value": "410621",
  "parent": "410600"
}, {
  "name": "淇县",
  "value": "410622",
  "parent": "410600"
}, {
  "name": "红旗区",
  "value": "410702",
  "parent": "410700"
}, {
  "name": "卫滨区",
  "value": "410703",
  "parent": "410700"
}, {
  "name": "凤泉区",
  "value": "410704",
  "parent": "410700"
}, {
  "name": "牧野区",
  "value": "410711",
  "parent": "410700"
}, {
  "name": "新乡县",
  "value": "410721",
  "parent": "410700"
}, {
  "name": "获嘉县",
  "value": "410724",
  "parent": "410700"
}, {
  "name": "原阳县",
  "value": "410725",
  "parent": "410700"
}, {
  "name": "延津县",
  "value": "410726",
  "parent": "410700"
}, {
  "name": "封丘县",
  "value": "410727",
  "parent": "410700"
}, {
  "name": "长垣县",
  "value": "410728",
  "parent": "410700"
}, {
  "name": "卫辉市",
  "value": "410781",
  "parent": "410700"
}, {
  "name": "辉县市",
  "value": "410782",
  "parent": "410700"
}, {
  "name": "解放区",
  "value": "410802",
  "parent": "410800"
}, {
  "name": "中站区",
  "value": "410803",
  "parent": "410800"
}, {
  "name": "马村区",
  "value": "410804",
  "parent": "410800"
}, {
  "name": "山阳区",
  "value": "410811",
  "parent": "410800"
}, {
  "name": "修武县",
  "value": "410821",
  "parent": "410800"
}, {
  "name": "博爱县",
  "value": "410822",
  "parent": "410800"
}, {
  "name": "武陟县",
  "value": "410823",
  "parent": "410800"
}, {
  "name": "温县",
  "value": "410825",
  "parent": "410800"
}, {
  "name": "沁阳市",
  "value": "410882",
  "parent": "410800"
}, {
  "name": "孟州市",
  "value": "410883",
  "parent": "410800"
}, {
  "name": "华龙区",
  "value": "410902",
  "parent": "410900"
}, {
  "name": "清丰县",
  "value": "410922",
  "parent": "410900"
}, {
  "name": "南乐县",
  "value": "410923",
  "parent": "410900"
}, {
  "name": "范县",
  "value": "410926",
  "parent": "410900"
}, {
  "name": "台前县",
  "value": "410927",
  "parent": "410900"
}, {
  "name": "濮阳县",
  "value": "410928",
  "parent": "410900"
}, {
  "name": "魏都区",
  "value": "411002",
  "parent": "411000"
}, {
  "name": "许昌县",
  "value": "411023",
  "parent": "411000"
}, {
  "name": "鄢陵县",
  "value": "411024",
  "parent": "411000"
}, {
  "name": "襄城县",
  "value": "411025",
  "parent": "411000"
}, {
  "name": "禹州市",
  "value": "411081",
  "parent": "411000"
}, {
  "name": "长葛市",
  "value": "411082",
  "parent": "411000"
}, {
  "name": "源汇区",
  "value": "411102",
  "parent": "411100"
}, {
  "name": "郾城区",
  "value": "411103",
  "parent": "411100"
}, {
  "name": "召陵区",
  "value": "411104",
  "parent": "411100"
}, {
  "name": "舞阳县",
  "value": "411121",
  "parent": "411100"
}, {
  "name": "临颍县",
  "value": "411122",
  "parent": "411100"
}, {
  "name": "湖滨区",
  "value": "411202",
  "parent": "411200"
}, {
  "name": "陕州区",
  "value": "411203",
  "parent": "411200"
}, {
  "name": "渑池县",
  "value": "411221",
  "parent": "411200"
}, {
  "name": "卢氏县",
  "value": "411224",
  "parent": "411200"
}, {
  "name": "义马市",
  "value": "411281",
  "parent": "411200"
}, {
  "name": "灵宝市",
  "value": "411282",
  "parent": "411200"
}, {
  "name": "宛城区",
  "value": "411302",
  "parent": "411300"
}, {
  "name": "卧龙区",
  "value": "411303",
  "parent": "411300"
}, {
  "name": "南召县",
  "value": "411321",
  "parent": "411300"
}, {
  "name": "方城县",
  "value": "411322",
  "parent": "411300"
}, {
  "name": "西峡县",
  "value": "411323",
  "parent": "411300"
}, {
  "name": "镇平县",
  "value": "411324",
  "parent": "411300"
}, {
  "name": "内乡县",
  "value": "411325",
  "parent": "411300"
}, {
  "name": "淅川县",
  "value": "411326",
  "parent": "411300"
}, {
  "name": "社旗县",
  "value": "411327",
  "parent": "411300"
}, {
  "name": "唐河县",
  "value": "411328",
  "parent": "411300"
}, {
  "name": "新野县",
  "value": "411329",
  "parent": "411300"
}, {
  "name": "桐柏县",
  "value": "411330",
  "parent": "411300"
}, {
  "name": "邓州市",
  "value": "411381",
  "parent": "411300"
}, {
  "name": "梁园区",
  "value": "411402",
  "parent": "411400"
}, {
  "name": "睢阳区",
  "value": "411403",
  "parent": "411400"
}, {
  "name": "民权县",
  "value": "411421",
  "parent": "411400"
}, {
  "name": "睢县",
  "value": "411422",
  "parent": "411400"
}, {
  "name": "宁陵县",
  "value": "411423",
  "parent": "411400"
}, {
  "name": "柘城县",
  "value": "411424",
  "parent": "411400"
}, {
  "name": "虞城县",
  "value": "411425",
  "parent": "411400"
}, {
  "name": "夏邑县",
  "value": "411426",
  "parent": "411400"
}, {
  "name": "永城市",
  "value": "411481",
  "parent": "411400"
}, {
  "name": "浉河区",
  "value": "411502",
  "parent": "411500"
}, {
  "name": "平桥区",
  "value": "411503",
  "parent": "411500"
}, {
  "name": "罗山县",
  "value": "411521",
  "parent": "411500"
}, {
  "name": "光山县",
  "value": "411522",
  "parent": "411500"
}, {
  "name": "新县",
  "value": "411523",
  "parent": "411500"
}, {
  "name": "商城县",
  "value": "411524",
  "parent": "411500"
}, {
  "name": "固始县",
  "value": "411525",
  "parent": "411500"
}, {
  "name": "潢川县",
  "value": "411526",
  "parent": "411500"
}, {
  "name": "淮滨县",
  "value": "411527",
  "parent": "411500"
}, {
  "name": "息县",
  "value": "411528",
  "parent": "411500"
}, {
  "name": "川汇区",
  "value": "411602",
  "parent": "411600"
}, {
  "name": "扶沟县",
  "value": "411621",
  "parent": "411600"
}, {
  "name": "西华县",
  "value": "411622",
  "parent": "411600"
}, {
  "name": "商水县",
  "value": "411623",
  "parent": "411600"
}, {
  "name": "沈丘县",
  "value": "411624",
  "parent": "411600"
}, {
  "name": "郸城县",
  "value": "411625",
  "parent": "411600"
}, {
  "name": "淮阳县",
  "value": "411626",
  "parent": "411600"
}, {
  "name": "太康县",
  "value": "411627",
  "parent": "411600"
}, {
  "name": "鹿邑县",
  "value": "411628",
  "parent": "411600"
}, {
  "name": "项城市",
  "value": "411681",
  "parent": "411600"
}, {
  "name": "驿城区",
  "value": "411702",
  "parent": "411700"
}, {
  "name": "西平县",
  "value": "411721",
  "parent": "411700"
}, {
  "name": "上蔡县",
  "value": "411722",
  "parent": "411700"
}, {
  "name": "平舆县",
  "value": "411723",
  "parent": "411700"
}, {
  "name": "正阳县",
  "value": "411724",
  "parent": "411700"
}, {
  "name": "确山县",
  "value": "411725",
  "parent": "411700"
}, {
  "name": "泌阳县",
  "value": "411726",
  "parent": "411700"
}, {
  "name": "汝南县",
  "value": "411727",
  "parent": "411700"
}, {
  "name": "遂平县",
  "value": "411728",
  "parent": "411700"
}, {
  "name": "新蔡县",
  "value": "411729",
  "parent": "411700"
}, {
  "name": "武汉市",
  "value": "420100",
  "parent": "420000"
}, {
  "name": "黄石市",
  "value": "420200",
  "parent": "420000"
}, {
  "name": "十堰市",
  "value": "420300",
  "parent": "420000"
}, {
  "name": "宜昌市",
  "value": "420500",
  "parent": "420000"
}, {
  "name": "襄阳市",
  "value": "420600",
  "parent": "420000"
}, {
  "name": "鄂州市",
  "value": "420700",
  "parent": "420000"
}, {
  "name": "荆门市",
  "value": "420800",
  "parent": "420000"
}, {
  "name": "孝感市",
  "value": "420900",
  "parent": "420000"
}, {
  "name": "荆州市",
  "value": "421000",
  "parent": "420000"
}, {
  "name": "黄冈市",
  "value": "421100",
  "parent": "420000"
}, {
  "name": "咸宁市",
  "value": "421200",
  "parent": "420000"
}, {
  "name": "随州市",
  "value": "421300",
  "parent": "420000"
}, {
  "name": "恩施土家族苗族自治州",
  "value": "422800",
  "parent": "420000"
}, {
  "name": "仙桃市",
  "value": "429004",
  "parent": "420000"
}, {
  "name": "潜江市",
  "value": "429005",
  "parent": "420000"
}, {
  "name": "天门市",
  "value": "429006",
  "parent": "420000"
}, {
  "name": "神农架林区",
  "value": "429021",
  "parent": "420000"
}, {
  "name": "江岸区",
  "value": "420102",
  "parent": "420100"
}, {
  "name": "江汉区",
  "value": "420103",
  "parent": "420100"
}, {
  "name": "硚口区",
  "value": "420104",
  "parent": "420100"
}, {
  "name": "汉阳区",
  "value": "420105",
  "parent": "420100"
}, {
  "name": "武昌区",
  "value": "420106",
  "parent": "420100"
}, {
  "name": "青山区",
  "value": "420107",
  "parent": "420100"
}, {
  "name": "洪山区",
  "value": "420111",
  "parent": "420100"
}, {
  "name": "东西湖区",
  "value": "420112",
  "parent": "420100"
}, {
  "name": "汉南区",
  "value": "420113",
  "parent": "420100"
}, {
  "name": "蔡甸区",
  "value": "420114",
  "parent": "420100"
}, {
  "name": "江夏区",
  "value": "420115",
  "parent": "420100"
}, {
  "name": "黄陂区",
  "value": "420116",
  "parent": "420100"
}, {
  "name": "新洲区",
  "value": "420117",
  "parent": "420100"
}, {
  "name": "黄石港区",
  "value": "420202",
  "parent": "420200"
}, {
  "name": "西塞山区",
  "value": "420203",
  "parent": "420200"
}, {
  "name": "下陆区",
  "value": "420204",
  "parent": "420200"
}, {
  "name": "铁山区",
  "value": "420205",
  "parent": "420200"
}, {
  "name": "阳新县",
  "value": "420222",
  "parent": "420200"
}, {
  "name": "大冶市",
  "value": "420281",
  "parent": "420200"
}, {
  "name": "茅箭区",
  "value": "420302",
  "parent": "420300"
}, {
  "name": "张湾区",
  "value": "420303",
  "parent": "420300"
}, {
  "name": "郧阳区",
  "value": "420304",
  "parent": "420300"
}, {
  "name": "郧西县",
  "value": "420322",
  "parent": "420300"
}, {
  "name": "竹山县",
  "value": "420323",
  "parent": "420300"
}, {
  "name": "竹溪县",
  "value": "420324",
  "parent": "420300"
}, {
  "name": "房县",
  "value": "420325",
  "parent": "420300"
}, {
  "name": "丹江口市",
  "value": "420381",
  "parent": "420300"
}, {
  "name": "西陵区",
  "value": "420502",
  "parent": "420500"
}, {
  "name": "伍家岗区",
  "value": "420503",
  "parent": "420500"
}, {
  "name": "点军区",
  "value": "420504",
  "parent": "420500"
}, {
  "name": "猇亭区",
  "value": "420505",
  "parent": "420500"
}, {
  "name": "夷陵区",
  "value": "420506",
  "parent": "420500"
}, {
  "name": "远安县",
  "value": "420525",
  "parent": "420500"
}, {
  "name": "兴山县",
  "value": "420526",
  "parent": "420500"
}, {
  "name": "秭归县",
  "value": "420527",
  "parent": "420500"
}, {
  "name": "长阳土家族自治县",
  "value": "420528",
  "parent": "420500"
}, {
  "name": "五峰土家族自治县",
  "value": "420529",
  "parent": "420500"
}, {
  "name": "宜都市",
  "value": "420581",
  "parent": "420500"
}, {
  "name": "当阳市",
  "value": "420582",
  "parent": "420500"
}, {
  "name": "枝江市",
  "value": "420583",
  "parent": "420500"
}, {
  "name": "襄城区",
  "value": "420602",
  "parent": "420600"
}, {
  "name": "樊城区",
  "value": "420606",
  "parent": "420600"
}, {
  "name": "襄州区",
  "value": "420607",
  "parent": "420600"
}, {
  "name": "南漳县",
  "value": "420624",
  "parent": "420600"
}, {
  "name": "谷城县",
  "value": "420625",
  "parent": "420600"
}, {
  "name": "保康县",
  "value": "420626",
  "parent": "420600"
}, {
  "name": "老河口市",
  "value": "420682",
  "parent": "420600"
}, {
  "name": "枣阳市",
  "value": "420683",
  "parent": "420600"
}, {
  "name": "宜城市",
  "value": "420684",
  "parent": "420600"
}, {
  "name": "梁子湖区",
  "value": "420702",
  "parent": "420700"
}, {
  "name": "华容区",
  "value": "420703",
  "parent": "420700"
}, {
  "name": "鄂城区",
  "value": "420704",
  "parent": "420700"
}, {
  "name": "东宝区",
  "value": "420802",
  "parent": "420800"
}, {
  "name": "掇刀区",
  "value": "420804",
  "parent": "420800"
}, {
  "name": "京山县",
  "value": "420821",
  "parent": "420800"
}, {
  "name": "沙洋县",
  "value": "420822",
  "parent": "420800"
}, {
  "name": "钟祥市",
  "value": "420881",
  "parent": "420800"
}, {
  "name": "孝南区",
  "value": "420902",
  "parent": "420900"
}, {
  "name": "孝昌县",
  "value": "420921",
  "parent": "420900"
}, {
  "name": "大悟县",
  "value": "420922",
  "parent": "420900"
}, {
  "name": "云梦县",
  "value": "420923",
  "parent": "420900"
}, {
  "name": "应城市",
  "value": "420981",
  "parent": "420900"
}, {
  "name": "安陆市",
  "value": "420982",
  "parent": "420900"
}, {
  "name": "汉川市",
  "value": "420984",
  "parent": "420900"
}, {
  "name": "沙市区",
  "value": "421002",
  "parent": "421000"
}, {
  "name": "荆州区",
  "value": "421003",
  "parent": "421000"
}, {
  "name": "公安县",
  "value": "421022",
  "parent": "421000"
}, {
  "name": "监利县",
  "value": "421023",
  "parent": "421000"
}, {
  "name": "江陵县",
  "value": "421024",
  "parent": "421000"
}, {
  "name": "石首市",
  "value": "421081",
  "parent": "421000"
}, {
  "name": "洪湖市",
  "value": "421083",
  "parent": "421000"
}, {
  "name": "松滋市",
  "value": "421087",
  "parent": "421000"
}, {
  "name": "黄州区",
  "value": "421102",
  "parent": "421100"
}, {
  "name": "团风县",
  "value": "421121",
  "parent": "421100"
}, {
  "name": "红安县",
  "value": "421122",
  "parent": "421100"
}, {
  "name": "罗田县",
  "value": "421123",
  "parent": "421100"
}, {
  "name": "英山县",
  "value": "421124",
  "parent": "421100"
}, {
  "name": "浠水县",
  "value": "421125",
  "parent": "421100"
}, {
  "name": "蕲春县",
  "value": "421126",
  "parent": "421100"
}, {
  "name": "黄梅县",
  "value": "421127",
  "parent": "421100"
}, {
  "name": "麻城市",
  "value": "421181",
  "parent": "421100"
}, {
  "name": "武穴市",
  "value": "421182",
  "parent": "421100"
}, {
  "name": "咸安区",
  "value": "421202",
  "parent": "421200"
}, {
  "name": "嘉鱼县",
  "value": "421221",
  "parent": "421200"
}, {
  "name": "通城县",
  "value": "421222",
  "parent": "421200"
}, {
  "name": "崇阳县",
  "value": "421223",
  "parent": "421200"
}, {
  "name": "通山县",
  "value": "421224",
  "parent": "421200"
}, {
  "name": "赤壁市",
  "value": "421281",
  "parent": "421200"
}, {
  "name": "曾都区",
  "value": "421303",
  "parent": "421300"
}, {
  "name": "随县",
  "value": "421321",
  "parent": "421300"
}, {
  "name": "广水市",
  "value": "421381",
  "parent": "421300"
}, {
  "name": "恩施市",
  "value": "422801",
  "parent": "422800"
}, {
  "name": "利川市",
  "value": "422802",
  "parent": "422800"
}, {
  "name": "建始县",
  "value": "422822",
  "parent": "422800"
}, {
  "name": "巴东县",
  "value": "422823",
  "parent": "422800"
}, {
  "name": "宣恩县",
  "value": "422825",
  "parent": "422800"
}, {
  "name": "咸丰县",
  "value": "422826",
  "parent": "422800"
}, {
  "name": "来凤县",
  "value": "422827",
  "parent": "422800"
}, {
  "name": "鹤峰县",
  "value": "422828",
  "parent": "422800"
}, {
  "name": "长沙市",
  "value": "430100",
  "parent": "430000"
}, {
  "name": "株洲市",
  "value": "430200",
  "parent": "430000"
}, {
  "name": "湘潭市",
  "value": "430300",
  "parent": "430000"
}, {
  "name": "衡阳市",
  "value": "430400",
  "parent": "430000"
}, {
  "name": "邵阳市",
  "value": "430500",
  "parent": "430000"
}, {
  "name": "岳阳市",
  "value": "430600",
  "parent": "430000"
}, {
  "name": "常德市",
  "value": "430700",
  "parent": "430000"
}, {
  "name": "张家界市",
  "value": "430800",
  "parent": "430000"
}, {
  "name": "益阳市",
  "value": "430900",
  "parent": "430000"
}, {
  "name": "郴州市",
  "value": "431000",
  "parent": "430000"
}, {
  "name": "永州市",
  "value": "431100",
  "parent": "430000"
}, {
  "name": "怀化市",
  "value": "431200",
  "parent": "430000"
}, {
  "name": "娄底市",
  "value": "431300",
  "parent": "430000"
}, {
  "name": "湘西土家族苗族自治州",
  "value": "433100",
  "parent": "430000"
}, {
  "name": "芙蓉区",
  "value": "430102",
  "parent": "430100"
}, {
  "name": "天心区",
  "value": "430103",
  "parent": "430100"
}, {
  "name": "岳麓区",
  "value": "430104",
  "parent": "430100"
}, {
  "name": "开福区",
  "value": "430105",
  "parent": "430100"
}, {
  "name": "雨花区",
  "value": "430111",
  "parent": "430100"
}, {
  "name": "望城区",
  "value": "430112",
  "parent": "430100"
}, {
  "name": "长沙县",
  "value": "430121",
  "parent": "430100"
}, {
  "name": "宁乡县",
  "value": "430124",
  "parent": "430100"
}, {
  "name": "浏阳市",
  "value": "430181",
  "parent": "430100"
}, {
  "name": "荷塘区",
  "value": "430202",
  "parent": "430200"
}, {
  "name": "芦淞区",
  "value": "430203",
  "parent": "430200"
}, {
  "name": "石峰区",
  "value": "430204",
  "parent": "430200"
}, {
  "name": "天元区",
  "value": "430211",
  "parent": "430200"
}, {
  "name": "株洲县",
  "value": "430221",
  "parent": "430200"
}, {
  "name": "攸县",
  "value": "430223",
  "parent": "430200"
}, {
  "name": "茶陵县",
  "value": "430224",
  "parent": "430200"
}, {
  "name": "炎陵县",
  "value": "430225",
  "parent": "430200"
}, {
  "name": "醴陵市",
  "value": "430281",
  "parent": "430200"
}, {
  "name": "雨湖区",
  "value": "430302",
  "parent": "430300"
}, {
  "name": "岳塘区",
  "value": "430304",
  "parent": "430300"
}, {
  "name": "湘潭县",
  "value": "430321",
  "parent": "430300"
}, {
  "name": "湘乡市",
  "value": "430381",
  "parent": "430300"
}, {
  "name": "韶山市",
  "value": "430382",
  "parent": "430300"
}, {
  "name": "珠晖区",
  "value": "430405",
  "parent": "430400"
}, {
  "name": "雁峰区",
  "value": "430406",
  "parent": "430400"
}, {
  "name": "石鼓区",
  "value": "430407",
  "parent": "430400"
}, {
  "name": "蒸湘区",
  "value": "430408",
  "parent": "430400"
}, {
  "name": "南岳区",
  "value": "430412",
  "parent": "430400"
}, {
  "name": "衡阳县",
  "value": "430421",
  "parent": "430400"
}, {
  "name": "衡南县",
  "value": "430422",
  "parent": "430400"
}, {
  "name": "衡山县",
  "value": "430423",
  "parent": "430400"
}, {
  "name": "衡东县",
  "value": "430424",
  "parent": "430400"
}, {
  "name": "祁东县",
  "value": "430426",
  "parent": "430400"
}, {
  "name": "耒阳市",
  "value": "430481",
  "parent": "430400"
}, {
  "name": "常宁市",
  "value": "430482",
  "parent": "430400"
}, {
  "name": "双清区",
  "value": "430502",
  "parent": "430500"
}, {
  "name": "大祥区",
  "value": "430503",
  "parent": "430500"
}, {
  "name": "北塔区",
  "value": "430511",
  "parent": "430500"
}, {
  "name": "邵东县",
  "value": "430521",
  "parent": "430500"
}, {
  "name": "新邵县",
  "value": "430522",
  "parent": "430500"
}, {
  "name": "邵阳县",
  "value": "430523",
  "parent": "430500"
}, {
  "name": "隆回县",
  "value": "430524",
  "parent": "430500"
}, {
  "name": "洞口县",
  "value": "430525",
  "parent": "430500"
}, {
  "name": "绥宁县",
  "value": "430527",
  "parent": "430500"
}, {
  "name": "新宁县",
  "value": "430528",
  "parent": "430500"
}, {
  "name": "城步苗族自治县",
  "value": "430529",
  "parent": "430500"
}, {
  "name": "武冈市",
  "value": "430581",
  "parent": "430500"
}, {
  "name": "岳阳楼区",
  "value": "430602",
  "parent": "430600"
}, {
  "name": "云溪区",
  "value": "430603",
  "parent": "430600"
}, {
  "name": "君山区",
  "value": "430611",
  "parent": "430600"
}, {
  "name": "岳阳县",
  "value": "430621",
  "parent": "430600"
}, {
  "name": "华容县",
  "value": "430623",
  "parent": "430600"
}, {
  "name": "湘阴县",
  "value": "430624",
  "parent": "430600"
}, {
  "name": "平江县",
  "value": "430626",
  "parent": "430600"
}, {
  "name": "汨罗市",
  "value": "430681",
  "parent": "430600"
}, {
  "name": "临湘市",
  "value": "430682",
  "parent": "430600"
}, {
  "name": "武陵区",
  "value": "430702",
  "parent": "430700"
}, {
  "name": "鼎城区",
  "value": "430703",
  "parent": "430700"
}, {
  "name": "安乡县",
  "value": "430721",
  "parent": "430700"
}, {
  "name": "汉寿县",
  "value": "430722",
  "parent": "430700"
}, {
  "name": "澧县",
  "value": "430723",
  "parent": "430700"
}, {
  "name": "临澧县",
  "value": "430724",
  "parent": "430700"
}, {
  "name": "桃源县",
  "value": "430725",
  "parent": "430700"
}, {
  "name": "石门县",
  "value": "430726",
  "parent": "430700"
}, {
  "name": "津市市",
  "value": "430781",
  "parent": "430700"
}, {
  "name": "永定区",
  "value": "430802",
  "parent": "430800"
}, {
  "name": "武陵源区",
  "value": "430811",
  "parent": "430800"
}, {
  "name": "慈利县",
  "value": "430821",
  "parent": "430800"
}, {
  "name": "桑植县",
  "value": "430822",
  "parent": "430800"
}, {
  "name": "资阳区",
  "value": "430902",
  "parent": "430900"
}, {
  "name": "赫山区",
  "value": "430903",
  "parent": "430900"
}, {
  "name": "南县",
  "value": "430921",
  "parent": "430900"
}, {
  "name": "桃江县",
  "value": "430922",
  "parent": "430900"
}, {
  "name": "安化县",
  "value": "430923",
  "parent": "430900"
}, {
  "name": "沅江市",
  "value": "430981",
  "parent": "430900"
}, {
  "name": "北湖区",
  "value": "431002",
  "parent": "431000"
}, {
  "name": "苏仙区",
  "value": "431003",
  "parent": "431000"
}, {
  "name": "桂阳县",
  "value": "431021",
  "parent": "431000"
}, {
  "name": "宜章县",
  "value": "431022",
  "parent": "431000"
}, {
  "name": "永兴县",
  "value": "431023",
  "parent": "431000"
}, {
  "name": "嘉禾县",
  "value": "431024",
  "parent": "431000"
}, {
  "name": "临武县",
  "value": "431025",
  "parent": "431000"
}, {
  "name": "汝城县",
  "value": "431026",
  "parent": "431000"
}, {
  "name": "桂东县",
  "value": "431027",
  "parent": "431000"
}, {
  "name": "安仁县",
  "value": "431028",
  "parent": "431000"
}, {
  "name": "资兴市",
  "value": "431081",
  "parent": "431000"
}, {
  "name": "零陵区",
  "value": "431102",
  "parent": "431100"
}, {
  "name": "冷水滩区",
  "value": "431103",
  "parent": "431100"
}, {
  "name": "祁阳县",
  "value": "431121",
  "parent": "431100"
}, {
  "name": "东安县",
  "value": "431122",
  "parent": "431100"
}, {
  "name": "双牌县",
  "value": "431123",
  "parent": "431100"
}, {
  "name": "道县",
  "value": "431124",
  "parent": "431100"
}, {
  "name": "江永县",
  "value": "431125",
  "parent": "431100"
}, {
  "name": "宁远县",
  "value": "431126",
  "parent": "431100"
}, {
  "name": "蓝山县",
  "value": "431127",
  "parent": "431100"
}, {
  "name": "新田县",
  "value": "431128",
  "parent": "431100"
}, {
  "name": "江华瑶族自治县",
  "value": "431129",
  "parent": "431100"
}, {
  "name": "鹤城区",
  "value": "431202",
  "parent": "431200"
}, {
  "name": "中方县",
  "value": "431221",
  "parent": "431200"
}, {
  "name": "沅陵县",
  "value": "431222",
  "parent": "431200"
}, {
  "name": "辰溪县",
  "value": "431223",
  "parent": "431200"
}, {
  "name": "溆浦县",
  "value": "431224",
  "parent": "431200"
}, {
  "name": "会同县",
  "value": "431225",
  "parent": "431200"
}, {
  "name": "麻阳苗族自治县",
  "value": "431226",
  "parent": "431200"
}, {
  "name": "新晃侗族自治县",
  "value": "431227",
  "parent": "431200"
}, {
  "name": "芷江侗族自治县",
  "value": "431228",
  "parent": "431200"
}, {
  "name": "靖州苗族侗族自治县",
  "value": "431229",
  "parent": "431200"
}, {
  "name": "通道侗族自治县",
  "value": "431230",
  "parent": "431200"
}, {
  "name": "洪江市",
  "value": "431281",
  "parent": "431200"
}, {
  "name": "娄星区",
  "value": "431302",
  "parent": "431300"
}, {
  "name": "双峰县",
  "value": "431321",
  "parent": "431300"
}, {
  "name": "新化县",
  "value": "431322",
  "parent": "431300"
}, {
  "name": "冷水江市",
  "value": "431381",
  "parent": "431300"
}, {
  "name": "涟源市",
  "value": "431382",
  "parent": "431300"
}, {
  "name": "吉首市",
  "value": "433101",
  "parent": "433100"
}, {
  "name": "泸溪县",
  "value": "433122",
  "parent": "433100"
}, {
  "name": "凤凰县",
  "value": "433123",
  "parent": "433100"
}, {
  "name": "花垣县",
  "value": "433124",
  "parent": "433100"
}, {
  "name": "保靖县",
  "value": "433125",
  "parent": "433100"
}, {
  "name": "古丈县",
  "value": "433126",
  "parent": "433100"
}, {
  "name": "永顺县",
  "value": "433127",
  "parent": "433100"
}, {
  "name": "龙山县",
  "value": "433130",
  "parent": "433100"
}, {
  "name": "广州市",
  "value": "440100",
  "parent": "440000"
}, {
  "name": "韶关市",
  "value": "440200",
  "parent": "440000"
}, {
  "name": "深圳市",
  "value": "440300",
  "parent": "440000"
}, {
  "name": "珠海市",
  "value": "440400",
  "parent": "440000"
}, {
  "name": "汕头市",
  "value": "440500",
  "parent": "440000"
}, {
  "name": "佛山市",
  "value": "440600",
  "parent": "440000"
}, {
  "name": "江门市",
  "value": "440700",
  "parent": "440000"
}, {
  "name": "湛江市",
  "value": "440800",
  "parent": "440000"
}, {
  "name": "茂名市",
  "value": "440900",
  "parent": "440000"
}, {
  "name": "肇庆市",
  "value": "441200",
  "parent": "440000"
}, {
  "name": "惠州市",
  "value": "441300",
  "parent": "440000"
}, {
  "name": "梅州市",
  "value": "441400",
  "parent": "440000"
}, {
  "name": "汕尾市",
  "value": "441500",
  "parent": "440000"
}, {
  "name": "河源市",
  "value": "441600",
  "parent": "440000"
}, {
  "name": "阳江市",
  "value": "441700",
  "parent": "440000"
}, {
  "name": "清远市",
  "value": "441800",
  "parent": "440000"
}, {
  "name": "东莞市",
  "value": "441900",
  "parent": "440000"
}, {
  "name": "中山市",
  "value": "442000",
  "parent": "440000"
}, {
  "name": "潮州市",
  "value": "445100",
  "parent": "440000"
}, {
  "name": "揭阳市",
  "value": "445200",
  "parent": "440000"
}, {
  "name": "云浮市",
  "value": "445300",
  "parent": "440000"
}, {
  "name": "荔湾区",
  "value": "440103",
  "parent": "440100"
}, {
  "name": "越秀区",
  "value": "440104",
  "parent": "440100"
}, {
  "name": "海珠区",
  "value": "440105",
  "parent": "440100"
}, {
  "name": "天河区",
  "value": "440106",
  "parent": "440100"
}, {
  "name": "白云区",
  "value": "440111",
  "parent": "440100"
}, {
  "name": "黄埔区",
  "value": "440112",
  "parent": "440100"
}, {
  "name": "番禺区",
  "value": "440113",
  "parent": "440100"
}, {
  "name": "花都区",
  "value": "440114",
  "parent": "440100"
}, {
  "name": "南沙区",
  "value": "440115",
  "parent": "440100"
}, {
  "name": "从化区",
  "value": "440117",
  "parent": "440100"
}, {
  "name": "增城区",
  "value": "440118",
  "parent": "440100"
}, {
  "name": "武江区",
  "value": "440203",
  "parent": "440200"
}, {
  "name": "浈江区",
  "value": "440204",
  "parent": "440200"
}, {
  "name": "曲江区",
  "value": "440205",
  "parent": "440200"
}, {
  "name": "始兴县",
  "value": "440222",
  "parent": "440200"
}, {
  "name": "仁化县",
  "value": "440224",
  "parent": "440200"
}, {
  "name": "翁源县",
  "value": "440229",
  "parent": "440200"
}, {
  "name": "乳源瑶族自治县",
  "value": "440232",
  "parent": "440200"
}, {
  "name": "新丰县",
  "value": "440233",
  "parent": "440200"
}, {
  "name": "乐昌市",
  "value": "440281",
  "parent": "440200"
}, {
  "name": "南雄市",
  "value": "440282",
  "parent": "440200"
}, {
  "name": "罗湖区",
  "value": "440303",
  "parent": "440300"
}, {
  "name": "福田区",
  "value": "440304",
  "parent": "440300"
}, {
  "name": "南山区",
  "value": "440305",
  "parent": "440300"
}, {
  "name": "宝安区",
  "value": "440306",
  "parent": "440300"
}, {
  "name": "龙岗区",
  "value": "440307",
  "parent": "440300"
}, {
  "name": "盐田区",
  "value": "440308",
  "parent": "440300"
}, {
  "name": "光明新区",
  "value": "440300000",
  "parent": "440300"
}, {
  "name": "坪山新区",
  "value": "440300002",
  "parent": "440300"
}, {
  "name": "龙华新区",
  "value": "4403001768",
  "parent": "440300"
}, {
  "name": "大鹏新区",
  "value": "4403001777",
  "parent": "440300"
}, {
  "name": "香洲区",
  "value": "440402",
  "parent": "440400"
}, {
  "name": "斗门区",
  "value": "440403",
  "parent": "440400"
}, {
  "name": "金湾区",
  "value": "440404",
  "parent": "440400"
}, {
  "name": "龙湖区",
  "value": "440507",
  "parent": "440500"
}, {
  "name": "金平区",
  "value": "440511",
  "parent": "440500"
}, {
  "name": "濠江区",
  "value": "440512",
  "parent": "440500"
}, {
  "name": "潮阳区",
  "value": "440513",
  "parent": "440500"
}, {
  "name": "潮南区",
  "value": "440514",
  "parent": "440500"
}, {
  "name": "澄海区",
  "value": "440515",
  "parent": "440500"
}, {
  "name": "南澳县",
  "value": "440523",
  "parent": "440500"
}, {
  "name": "禅城区",
  "value": "440604",
  "parent": "440600"
}, {
  "name": "南海区",
  "value": "440605",
  "parent": "440600"
}, {
  "name": "顺德区",
  "value": "440606",
  "parent": "440600"
}, {
  "name": "三水区",
  "value": "440607",
  "parent": "440600"
}, {
  "name": "高明区",
  "value": "440608",
  "parent": "440600"
}, {
  "name": "蓬江区",
  "value": "440703",
  "parent": "440700"
}, {
  "name": "江海区",
  "value": "440704",
  "parent": "440700"
}, {
  "name": "新会区",
  "value": "440705",
  "parent": "440700"
}, {
  "name": "台山市",
  "value": "440781",
  "parent": "440700"
}, {
  "name": "开平市",
  "value": "440783",
  "parent": "440700"
}, {
  "name": "鹤山市",
  "value": "440784",
  "parent": "440700"
}, {
  "name": "恩平市",
  "value": "440785",
  "parent": "440700"
}, {
  "name": "赤坎区",
  "value": "440802",
  "parent": "440800"
}, {
  "name": "霞山区",
  "value": "440803",
  "parent": "440800"
}, {
  "name": "坡头区",
  "value": "440804",
  "parent": "440800"
}, {
  "name": "麻章区",
  "value": "440811",
  "parent": "440800"
}, {
  "name": "遂溪县",
  "value": "440823",
  "parent": "440800"
}, {
  "name": "徐闻县",
  "value": "440825",
  "parent": "440800"
}, {
  "name": "廉江市",
  "value": "440881",
  "parent": "440800"
}, {
  "name": "雷州市",
  "value": "440882",
  "parent": "440800"
}, {
  "name": "吴川市",
  "value": "440883",
  "parent": "440800"
}, {
  "name": "茂南区",
  "value": "440902",
  "parent": "440900"
}, {
  "name": "电白区",
  "value": "440904",
  "parent": "440900"
}, {
  "name": "高州市",
  "value": "440981",
  "parent": "440900"
}, {
  "name": "化州市",
  "value": "440982",
  "parent": "440900"
}, {
  "name": "信宜市",
  "value": "440983",
  "parent": "440900"
}, {
  "name": "端州区",
  "value": "441202",
  "parent": "441200"
}, {
  "name": "鼎湖区",
  "value": "441203",
  "parent": "441200"
}, {
  "name": "高要区",
  "value": "441204",
  "parent": "441200"
}, {
  "name": "广宁县",
  "value": "441223",
  "parent": "441200"
}, {
  "name": "怀集县",
  "value": "441224",
  "parent": "441200"
}, {
  "name": "封开县",
  "value": "441225",
  "parent": "441200"
}, {
  "name": "德庆县",
  "value": "441226",
  "parent": "441200"
}, {
  "name": "四会市",
  "value": "441284",
  "parent": "441200"
}, {
  "name": "惠城区",
  "value": "441302",
  "parent": "441300"
}, {
  "name": "惠阳区",
  "value": "441303",
  "parent": "441300"
}, {
  "name": "博罗县",
  "value": "441322",
  "parent": "441300"
}, {
  "name": "惠东县",
  "value": "441323",
  "parent": "441300"
}, {
  "name": "龙门县",
  "value": "441324",
  "parent": "441300"
}, {
  "name": "梅江区",
  "value": "441402",
  "parent": "441400"
}, {
  "name": "梅县区",
  "value": "441403",
  "parent": "441400"
}, {
  "name": "大埔县",
  "value": "441422",
  "parent": "441400"
}, {
  "name": "丰顺县",
  "value": "441423",
  "parent": "441400"
}, {
  "name": "五华县",
  "value": "441424",
  "parent": "441400"
}, {
  "name": "平远县",
  "value": "441426",
  "parent": "441400"
}, {
  "name": "蕉岭县",
  "value": "441427",
  "parent": "441400"
}, {
  "name": "兴宁市",
  "value": "441481",
  "parent": "441400"
}, {
  "name": "城区",
  "value": "441502",
  "parent": "441500"
}, {
  "name": "海丰县",
  "value": "441521",
  "parent": "441500"
}, {
  "name": "陆河县",
  "value": "441523",
  "parent": "441500"
}, {
  "name": "陆丰市",
  "value": "441581",
  "parent": "441500"
}, {
  "name": "源城区",
  "value": "441602",
  "parent": "441600"
}, {
  "name": "紫金县",
  "value": "441621",
  "parent": "441600"
}, {
  "name": "龙川县",
  "value": "441622",
  "parent": "441600"
}, {
  "name": "连平县",
  "value": "441623",
  "parent": "441600"
}, {
  "name": "和平县",
  "value": "441624",
  "parent": "441600"
}, {
  "name": "东源县",
  "value": "441625",
  "parent": "441600"
}, {
  "name": "江城区",
  "value": "441702",
  "parent": "441700"
}, {
  "name": "阳东区",
  "value": "441704",
  "parent": "441700"
}, {
  "name": "阳西县",
  "value": "441721",
  "parent": "441700"
}, {
  "name": "阳春市",
  "value": "441781",
  "parent": "441700"
}, {
  "name": "清城区",
  "value": "441802",
  "parent": "441800"
}, {
  "name": "清新区",
  "value": "441803",
  "parent": "441800"
}, {
  "name": "佛冈县",
  "value": "441821",
  "parent": "441800"
}, {
  "name": "阳山县",
  "value": "441823",
  "parent": "441800"
}, {
  "name": "连山壮族瑶族自治县",
  "value": "441825",
  "parent": "441800"
}, {
  "name": "连南瑶族自治县",
  "value": "441826",
  "parent": "441800"
}, {
  "name": "英德市",
  "value": "441881",
  "parent": "441800"
}, {
  "name": "连州市",
  "value": "441882",
  "parent": "441800"
}, {
  "name": "茶山镇",
  "value": "4419001039",
  "parent": "441900"
}, {
  "name": "长安镇",
  "value": "4419001056",
  "parent": "441900"
}, {
  "name": "常平镇",
  "value": "4419001046",
  "parent": "441900"
}, {
  "name": "大朗镇",
  "value": "4419001050",
  "parent": "441900"
}, {
  "name": "大岭山镇",
  "value": "4419001055",
  "parent": "441900"
}, {
  "name": "道滘镇",
  "value": "4419001060",
  "parent": "441900"
}, {
  "name": "东城街道",
  "value": "4419001033",
  "parent": "441900"
}, {
  "name": "东坑镇",
  "value": "4419001045",
  "parent": "441900"
}, {
  "name": "凤岗镇",
  "value": "4419001054",
  "parent": "441900"
}, {
  "name": "高埗镇",
  "value": "4419001065",
  "parent": "441900"
}, {
  "name": "横沥镇",
  "value": "4419001042",
  "parent": "441900"
}, {
  "name": "洪梅镇",
  "value": "4419001061",
  "parent": "441900"
}, {
  "name": "厚街镇",
  "value": "4419001058",
  "parent": "441900"
}, {
  "name": "虎门镇",
  "value": "4419001057",
  "parent": "441900"
}, {
  "name": "黄江镇",
  "value": "4419001051",
  "parent": "441900"
}, {
  "name": "寮步镇",
  "value": "4419001048",
  "parent": "441900"
}, {
  "name": "麻涌镇",
  "value": "4419001062",
  "parent": "441900"
}, {
  "name": "南城街道",
  "value": "4419001034",
  "parent": "441900"
}, {
  "name": "企石镇",
  "value": "4419001041",
  "parent": "441900"
}, {
  "name": "桥头镇",
  "value": "4419001043",
  "parent": "441900"
}, {
  "name": "清溪镇",
  "value": "4419001052",
  "parent": "441900"
}, {
  "name": "沙田镇",
  "value": "4419001059",
  "parent": "441900"
}, {
  "name": "石碣镇",
  "value": "4419001037",
  "parent": "441900"
}, {
  "name": "石龙镇",
  "value": "4419001038",
  "parent": "441900"
}, {
  "name": "石排镇",
  "value": "4419001040",
  "parent": "441900"
}, {
  "name": "塘厦镇",
  "value": "4419001053",
  "parent": "441900"
}, {
  "name": "莞城街道",
  "value": "4419001036",
  "parent": "441900"
}, {
  "name": "万江街道",
  "value": "4419001035",
  "parent": "441900"
}, {
  "name": "望牛墩镇",
  "value": "4419001063",
  "parent": "441900"
}, {
  "name": "谢岗镇",
  "value": "4419001044",
  "parent": "441900"
}, {
  "name": "樟木头镇",
  "value": "4419001049",
  "parent": "441900"
}, {
  "name": "中堂镇",
  "value": "4419001064",
  "parent": "441900"
}, {
  "name": "湖滨北路",
  "value": "442000",
  "parent": "442000"
}, {
  "name": "湘桥区",
  "value": "445102",
  "parent": "445100"
}, {
  "name": "潮安区",
  "value": "445103",
  "parent": "445100"
}, {
  "name": "饶平县",
  "value": "445122",
  "parent": "445100"
}, {
  "name": "榕城区",
  "value": "445202",
  "parent": "445200"
}, {
  "name": "揭东区",
  "value": "445203",
  "parent": "445200"
}, {
  "name": "揭西县",
  "value": "445222",
  "parent": "445200"
}, {
  "name": "惠来县",
  "value": "445224",
  "parent": "445200"
}, {
  "name": "普宁市",
  "value": "445281",
  "parent": "445200"
}, {
  "name": "云城区",
  "value": "445302",
  "parent": "445300"
}, {
  "name": "云安区",
  "value": "445303",
  "parent": "445300"
}, {
  "name": "新兴县",
  "value": "445321",
  "parent": "445300"
}, {
  "name": "郁南县",
  "value": "445322",
  "parent": "445300"
}, {
  "name": "罗定市",
  "value": "445381",
  "parent": "445300"
}, {
  "name": "南宁市",
  "value": "450100",
  "parent": "450000"
}, {
  "name": "柳州市",
  "value": "450200",
  "parent": "450000"
}, {
  "name": "桂林市",
  "value": "450300",
  "parent": "450000"
}, {
  "name": "梧州市",
  "value": "450400",
  "parent": "450000"
}, {
  "name": "北海市",
  "value": "450500",
  "parent": "450000"
}, {
  "name": "防城港市",
  "value": "450600",
  "parent": "450000"
}, {
  "name": "钦州市",
  "value": "450700",
  "parent": "450000"
}, {
  "name": "贵港市",
  "value": "450800",
  "parent": "450000"
}, {
  "name": "玉林市",
  "value": "450900",
  "parent": "450000"
}, {
  "name": "百色市",
  "value": "451000",
  "parent": "450000"
}, {
  "name": "贺州市",
  "value": "451100",
  "parent": "450000"
}, {
  "name": "河池市",
  "value": "451200",
  "parent": "450000"
}, {
  "name": "来宾市",
  "value": "451300",
  "parent": "450000"
}, {
  "name": "崇左市",
  "value": "451400",
  "parent": "450000"
}, {
  "name": "兴宁区",
  "value": "450102",
  "parent": "450100"
}, {
  "name": "青秀区",
  "value": "450103",
  "parent": "450100"
}, {
  "name": "江南区",
  "value": "450105",
  "parent": "450100"
}, {
  "name": "西乡塘区",
  "value": "450107",
  "parent": "450100"
}, {
  "name": "良庆区",
  "value": "450108",
  "parent": "450100"
}, {
  "name": "邕宁区",
  "value": "450109",
  "parent": "450100"
}, {
  "name": "武鸣区",
  "value": "450110",
  "parent": "450100"
}, {
  "name": "隆安县",
  "value": "450123",
  "parent": "450100"
}, {
  "name": "马山县",
  "value": "450124",
  "parent": "450100"
}, {
  "name": "上林县",
  "value": "450125",
  "parent": "450100"
}, {
  "name": "宾阳县",
  "value": "450126",
  "parent": "450100"
}, {
  "name": "横县",
  "value": "450127",
  "parent": "450100"
}, {
  "name": "城中区",
  "value": "450202",
  "parent": "450200"
}, {
  "name": "鱼峰区",
  "value": "450203",
  "parent": "450200"
}, {
  "name": "柳南区",
  "value": "450204",
  "parent": "450200"
}, {
  "name": "柳北区",
  "value": "450205",
  "parent": "450200"
}, {
  "name": "柳江县",
  "value": "450221",
  "parent": "450200"
}, {
  "name": "柳城县",
  "value": "450222",
  "parent": "450200"
}, {
  "name": "鹿寨县",
  "value": "450223",
  "parent": "450200"
}, {
  "name": "融安县",
  "value": "450224",
  "parent": "450200"
}, {
  "name": "融水苗族自治县",
  "value": "450225",
  "parent": "450200"
}, {
  "name": "三江侗族自治县",
  "value": "450226",
  "parent": "450200"
}, {
  "name": "秀峰区",
  "value": "450302",
  "parent": "450300"
}, {
  "name": "叠彩区",
  "value": "450303",
  "parent": "450300"
}, {
  "name": "象山区",
  "value": "450304",
  "parent": "450300"
}, {
  "name": "七星区",
  "value": "450305",
  "parent": "450300"
}, {
  "name": "雁山区",
  "value": "450311",
  "parent": "450300"
}, {
  "name": "临桂区",
  "value": "450312",
  "parent": "450300"
}, {
  "name": "阳朔县",
  "value": "450321",
  "parent": "450300"
}, {
  "name": "灵川县",
  "value": "450323",
  "parent": "450300"
}, {
  "name": "全州县",
  "value": "450324",
  "parent": "450300"
}, {
  "name": "兴安县",
  "value": "450325",
  "parent": "450300"
}, {
  "name": "永福县",
  "value": "450326",
  "parent": "450300"
}, {
  "name": "灌阳县",
  "value": "450327",
  "parent": "450300"
}, {
  "name": "龙胜各族自治县",
  "value": "450328",
  "parent": "450300"
}, {
  "name": "资源县",
  "value": "450329",
  "parent": "450300"
}, {
  "name": "平乐县",
  "value": "450330",
  "parent": "450300"
}, {
  "name": "荔浦县",
  "value": "450331",
  "parent": "450300"
}, {
  "name": "恭城瑶族自治县",
  "value": "450332",
  "parent": "450300"
}, {
  "name": "万秀区",
  "value": "450403",
  "parent": "450400"
}, {
  "name": "长洲区",
  "value": "450405",
  "parent": "450400"
}, {
  "name": "龙圩区",
  "value": "450406",
  "parent": "450400"
}, {
  "name": "苍梧县",
  "value": "450421",
  "parent": "450400"
}, {
  "name": "藤县",
  "value": "450422",
  "parent": "450400"
}, {
  "name": "蒙山县",
  "value": "450423",
  "parent": "450400"
}, {
  "name": "岑溪市",
  "value": "450481",
  "parent": "450400"
}, {
  "name": "海城区",
  "value": "450502",
  "parent": "450500"
}, {
  "name": "银海区",
  "value": "450503",
  "parent": "450500"
}, {
  "name": "铁山港区",
  "value": "450512",
  "parent": "450500"
}, {
  "name": "合浦县",
  "value": "450521",
  "parent": "450500"
}, {
  "name": "港口区",
  "value": "450602",
  "parent": "450600"
}, {
  "name": "防城区",
  "value": "450603",
  "parent": "450600"
}, {
  "name": "上思县",
  "value": "450621",
  "parent": "450600"
}, {
  "name": "东兴市",
  "value": "450681",
  "parent": "450600"
}, {
  "name": "钦南区",
  "value": "450702",
  "parent": "450700"
}, {
  "name": "钦北区",
  "value": "450703",
  "parent": "450700"
}, {
  "name": "灵山县",
  "value": "450721",
  "parent": "450700"
}, {
  "name": "浦北县",
  "value": "450722",
  "parent": "450700"
}, {
  "name": "港北区",
  "value": "450802",
  "parent": "450800"
}, {
  "name": "港南区",
  "value": "450803",
  "parent": "450800"
}, {
  "name": "覃塘区",
  "value": "450804",
  "parent": "450800"
}, {
  "name": "平南县",
  "value": "450821",
  "parent": "450800"
}, {
  "name": "桂平市",
  "value": "450881",
  "parent": "450800"
}, {
  "name": "玉州区",
  "value": "450902",
  "parent": "450900"
}, {
  "name": "福绵区",
  "value": "450903",
  "parent": "450900"
}, {
  "name": "容县",
  "value": "450921",
  "parent": "450900"
}, {
  "name": "陆川县",
  "value": "450922",
  "parent": "450900"
}, {
  "name": "博白县",
  "value": "450923",
  "parent": "450900"
}, {
  "name": "兴业县",
  "value": "450924",
  "parent": "450900"
}, {
  "name": "北流市",
  "value": "450981",
  "parent": "450900"
}, {
  "name": "右江区",
  "value": "451002",
  "parent": "451000"
}, {
  "name": "田阳县",
  "value": "451021",
  "parent": "451000"
}, {
  "name": "田东县",
  "value": "451022",
  "parent": "451000"
}, {
  "name": "平果县",
  "value": "451023",
  "parent": "451000"
}, {
  "name": "德保县",
  "value": "451024",
  "parent": "451000"
}, {
  "name": "那坡县",
  "value": "451026",
  "parent": "451000"
}, {
  "name": "凌云县",
  "value": "451027",
  "parent": "451000"
}, {
  "name": "乐业县",
  "value": "451028",
  "parent": "451000"
}, {
  "name": "田林县",
  "value": "451029",
  "parent": "451000"
}, {
  "name": "西林县",
  "value": "451030",
  "parent": "451000"
}, {
  "name": "隆林各族自治县",
  "value": "451031",
  "parent": "451000"
}, {
  "name": "靖西市",
  "value": "451081",
  "parent": "451000"
}, {
  "name": "八步区",
  "value": "451102",
  "parent": "451100"
}, {
  "name": "昭平县",
  "value": "451121",
  "parent": "451100"
}, {
  "name": "钟山县",
  "value": "451122",
  "parent": "451100"
}, {
  "name": "富川瑶族自治县",
  "value": "451123",
  "parent": "451100"
}, {
  "name": "金城江区",
  "value": "451202",
  "parent": "451200"
}, {
  "name": "南丹县",
  "value": "451221",
  "parent": "451200"
}, {
  "name": "天峨县",
  "value": "451222",
  "parent": "451200"
}, {
  "name": "凤山县",
  "value": "451223",
  "parent": "451200"
}, {
  "name": "东兰县",
  "value": "451224",
  "parent": "451200"
}, {
  "name": "罗城仫佬族自治县",
  "value": "451225",
  "parent": "451200"
}, {
  "name": "环江毛南族自治县",
  "value": "451226",
  "parent": "451200"
}, {
  "name": "巴马瑶族自治县",
  "value": "451227",
  "parent": "451200"
}, {
  "name": "都安瑶族自治县",
  "value": "451228",
  "parent": "451200"
}, {
  "name": "大化瑶族自治县",
  "value": "451229",
  "parent": "451200"
}, {
  "name": "宜州市",
  "value": "451281",
  "parent": "451200"
}, {
  "name": "兴宾区",
  "value": "451302",
  "parent": "451300"
}, {
  "name": "忻城县",
  "value": "451321",
  "parent": "451300"
}, {
  "name": "象州县",
  "value": "451322",
  "parent": "451300"
}, {
  "name": "武宣县",
  "value": "451323",
  "parent": "451300"
}, {
  "name": "金秀瑶族自治县",
  "value": "451324",
  "parent": "451300"
}, {
  "name": "合山市",
  "value": "451381",
  "parent": "451300"
}, {
  "name": "江州区",
  "value": "451402",
  "parent": "451400"
}, {
  "name": "扶绥县",
  "value": "451421",
  "parent": "451400"
}, {
  "name": "宁明县",
  "value": "451422",
  "parent": "451400"
}, {
  "name": "龙州县",
  "value": "451423",
  "parent": "451400"
}, {
  "name": "大新县",
  "value": "451424",
  "parent": "451400"
}, {
  "name": "天等县",
  "value": "451425",
  "parent": "451400"
}, {
  "name": "凭祥市",
  "value": "451481",
  "parent": "451400"
}, {
  "name": "海口市",
  "value": "460100",
  "parent": "460000"
}, {
  "name": "三亚市",
  "value": "460200",
  "parent": "460000"
}, {
  "name": "三沙市",
  "value": "460300",
  "parent": "460000"
}, {
  "name": "儋州市",
  "value": "460400",
  "parent": "460000"
}, {
  "name": "五指山市",
  "value": "469001",
  "parent": "460000"
}, {
  "name": "琼海市",
  "value": "469002",
  "parent": "460000"
}, {
  "name": "文昌市",
  "value": "469005",
  "parent": "460000"
}, {
  "name": "万宁市",
  "value": "469006",
  "parent": "460000"
}, {
  "name": "东方市",
  "value": "469007",
  "parent": "460000"
}, {
  "name": "定安县",
  "value": "469021",
  "parent": "460000"
}, {
  "name": "屯昌县",
  "value": "469022",
  "parent": "460000"
}, {
  "name": "澄迈县",
  "value": "469023",
  "parent": "460000"
}, {
  "name": "临高县",
  "value": "469024",
  "parent": "460000"
}, {
  "name": "白沙黎族自治县",
  "value": "469025",
  "parent": "460000"
}, {
  "name": "昌江黎族自治县",
  "value": "469026",
  "parent": "460000"
}, {
  "name": "乐东黎族自治县",
  "value": "469027",
  "parent": "460000"
}, {
  "name": "陵水黎族自治县",
  "value": "469028",
  "parent": "460000"
}, {
  "name": "保亭黎族苗族自治县",
  "value": "469029",
  "parent": "460000"
}, {
  "name": "琼中黎族苗族自治县",
  "value": "469030",
  "parent": "460000"
}, {
  "name": "秀英区",
  "value": "460105",
  "parent": "460100"
}, {
  "name": "龙华区",
  "value": "460106",
  "parent": "460100"
}, {
  "name": "琼山区",
  "value": "460107",
  "parent": "460100"
}, {
  "name": "美兰区",
  "value": "460108",
  "parent": "460100"
}, {
  "name": "三亚湾",
  "value": "460200",
  "parent": "460200"
}, {
  "name": "海棠区",
  "value": "460202",
  "parent": "460200"
}, {
  "name": "吉阳区",
  "value": "460203",
  "parent": "460200"
}, {
  "name": "天涯区",
  "value": "460204",
  "parent": "460200"
}, {
  "name": "崖州区",
  "value": "460205",
  "parent": "460200"
}, {
  "name": "西沙群岛",
  "value": "460321",
  "parent": "460300"
}, {
  "name": "南沙群岛",
  "value": "460322",
  "parent": "460300"
}, {
  "name": "中沙群岛的岛礁及其海域",
  "value": "460323",
  "parent": "460300"
}, {
  "name": "重庆市市辖区",
  "value": "500100",
  "parent": "500000"
}, {
  "name": "重庆市郊县",
  "value": "500200",
  "parent": "500000"
}, {
  "name": "万州区",
  "value": "500101",
  "parent": "500100"
}, {
  "name": "涪陵区",
  "value": "500102",
  "parent": "500100"
}, {
  "name": "渝中区",
  "value": "500103",
  "parent": "500100"
}, {
  "name": "大渡口区",
  "value": "500104",
  "parent": "500100"
}, {
  "name": "江北区",
  "value": "500105",
  "parent": "500100"
}, {
  "name": "沙坪坝区",
  "value": "500106",
  "parent": "500100"
}, {
  "name": "九龙坡区",
  "value": "500107",
  "parent": "500100"
}, {
  "name": "南岸区",
  "value": "500108",
  "parent": "500100"
}, {
  "name": "北碚区",
  "value": "500109",
  "parent": "500100"
}, {
  "name": "綦江区",
  "value": "500110",
  "parent": "500100"
}, {
  "name": "大足区",
  "value": "500111",
  "parent": "500100"
}, {
  "name": "渝北区",
  "value": "500112",
  "parent": "500100"
}, {
  "name": "巴南区",
  "value": "500113",
  "parent": "500100"
}, {
  "name": "黔江区",
  "value": "500114",
  "parent": "500100"
}, {
  "name": "长寿区",
  "value": "500115",
  "parent": "500100"
}, {
  "name": "江津区",
  "value": "500116",
  "parent": "500100"
}, {
  "name": "合川区",
  "value": "500117",
  "parent": "500100"
}, {
  "name": "永川区",
  "value": "500118",
  "parent": "500100"
}, {
  "name": "南川区",
  "value": "500119",
  "parent": "500100"
}, {
  "name": "璧山区",
  "value": "500120",
  "parent": "500100"
}, {
  "name": "铜梁区",
  "value": "500151",
  "parent": "500100"
}, {
  "name": "潼南区",
  "value": "500152",
  "parent": "500100"
}, {
  "name": "荣昌区",
  "value": "500153",
  "parent": "500100"
}, {
  "name": "梁平县",
  "value": "500228",
  "parent": "500100"
}, {
  "name": "城口县",
  "value": "500229",
  "parent": "500100"
}, {
  "name": "丰都县",
  "value": "500230",
  "parent": "500100"
}, {
  "name": "垫江县",
  "value": "500231",
  "parent": "500100"
}, {
  "name": "武隆县",
  "value": "500232",
  "parent": "500100"
}, {
  "name": "忠县",
  "value": "500233",
  "parent": "500100"
}, {
  "name": "开县",
  "value": "500234",
  "parent": "500100"
}, {
  "name": "云阳县",
  "value": "500235",
  "parent": "500100"
}, {
  "name": "奉节县",
  "value": "500236",
  "parent": "500100"
}, {
  "name": "巫山县",
  "value": "500237",
  "parent": "500100"
}, {
  "name": "巫溪县",
  "value": "500238",
  "parent": "500100"
}, {
  "name": "石柱土家族自治县",
  "value": "500240",
  "parent": "500100"
}, {
  "name": "秀山土家族苗族自治县",
  "value": "500241",
  "parent": "500100"
}, {
  "name": "酉阳土家族苗族自治县",
  "value": "500242",
  "parent": "500100"
}, {
  "name": "彭水苗族土家族自治县",
  "value": "500243",
  "parent": "500100"
}, {
  "name": "成都市",
  "value": "510100",
  "parent": "510000"
}, {
  "name": "自贡市",
  "value": "510300",
  "parent": "510000"
}, {
  "name": "攀枝花市",
  "value": "510400",
  "parent": "510000"
}, {
  "name": "泸州市",
  "value": "510500",
  "parent": "510000"
}, {
  "name": "德阳市",
  "value": "510600",
  "parent": "510000"
}, {
  "name": "绵阳市",
  "value": "510700",
  "parent": "510000"
}, {
  "name": "广元市",
  "value": "510800",
  "parent": "510000"
}, {
  "name": "遂宁市",
  "value": "510900",
  "parent": "510000"
}, {
  "name": "内江市",
  "value": "511000",
  "parent": "510000"
}, {
  "name": "乐山市",
  "value": "511100",
  "parent": "510000"
}, {
  "name": "南充市",
  "value": "511300",
  "parent": "510000"
}, {
  "name": "眉山市",
  "value": "511400",
  "parent": "510000"
}, {
  "name": "宜宾市",
  "value": "511500",
  "parent": "510000"
}, {
  "name": "广安市",
  "value": "511600",
  "parent": "510000"
}, {
  "name": "达州市",
  "value": "511700",
  "parent": "510000"
}, {
  "name": "雅安市",
  "value": "511800",
  "parent": "510000"
}, {
  "name": "巴中市",
  "value": "511900",
  "parent": "510000"
}, {
  "name": "资阳市",
  "value": "512000",
  "parent": "510000"
}, {
  "name": "阿坝藏族羌族自治州",
  "value": "513200",
  "parent": "510000"
}, {
  "name": "甘孜藏族自治州",
  "value": "513300",
  "parent": "510000"
}, {
  "name": "凉山彝族自治州",
  "value": "513400",
  "parent": "510000"
}, {
  "name": "锦江区",
  "value": "510104",
  "parent": "510100"
}, {
  "name": "青羊区",
  "value": "510105",
  "parent": "510100"
}, {
  "name": "金牛区",
  "value": "510106",
  "parent": "510100"
}, {
  "name": "武侯区",
  "value": "510107",
  "parent": "510100"
}, {
  "name": "成华区",
  "value": "510108",
  "parent": "510100"
}, {
  "name": "龙泉驿区",
  "value": "510112",
  "parent": "510100"
}, {
  "name": "青白江区",
  "value": "510113",
  "parent": "510100"
}, {
  "name": "新都区",
  "value": "510114",
  "parent": "510100"
}, {
  "name": "温江区",
  "value": "510115",
  "parent": "510100"
}, {
  "name": "双流区",
  "value": "510116",
  "parent": "510100"
}, {
  "name": "金堂县",
  "value": "510121",
  "parent": "510100"
}, {
  "name": "郫县",
  "value": "510124",
  "parent": "510100"
}, {
  "name": "大邑县",
  "value": "510129",
  "parent": "510100"
}, {
  "name": "蒲江县",
  "value": "510131",
  "parent": "510100"
}, {
  "name": "新津县",
  "value": "510132",
  "parent": "510100"
}, {
  "name": "都江堰市",
  "value": "510181",
  "parent": "510100"
}, {
  "name": "彭州市",
  "value": "510182",
  "parent": "510100"
}, {
  "name": "邛崃市",
  "value": "510183",
  "parent": "510100"
}, {
  "name": "崇州市",
  "value": "510184",
  "parent": "510100"
}, {
  "name": "自流井区",
  "value": "510302",
  "parent": "510300"
}, {
  "name": "贡井区",
  "value": "510303",
  "parent": "510300"
}, {
  "name": "大安区",
  "value": "510304",
  "parent": "510300"
}, {
  "name": "沿滩区",
  "value": "510311",
  "parent": "510300"
}, {
  "name": "荣县",
  "value": "510321",
  "parent": "510300"
}, {
  "name": "富顺县",
  "value": "510322",
  "parent": "510300"
}, {
  "name": "东区",
  "value": "510402",
  "parent": "510400"
}, {
  "name": "西区",
  "value": "510403",
  "parent": "510400"
}, {
  "name": "仁和区",
  "value": "510411",
  "parent": "510400"
}, {
  "name": "米易县",
  "value": "510421",
  "parent": "510400"
}, {
  "name": "盐边县",
  "value": "510422",
  "parent": "510400"
}, {
  "name": "江阳区",
  "value": "510502",
  "parent": "510500"
}, {
  "name": "纳溪区",
  "value": "510503",
  "parent": "510500"
}, {
  "name": "龙马潭区",
  "value": "510504",
  "parent": "510500"
}, {
  "name": "泸县",
  "value": "510521",
  "parent": "510500"
}, {
  "name": "合江县",
  "value": "510522",
  "parent": "510500"
}, {
  "name": "叙永县",
  "value": "510524",
  "parent": "510500"
}, {
  "name": "古蔺县",
  "value": "510525",
  "parent": "510500"
}, {
  "name": "旌阳区",
  "value": "510603",
  "parent": "510600"
}, {
  "name": "中江县",
  "value": "510623",
  "parent": "510600"
}, {
  "name": "罗江县",
  "value": "510626",
  "parent": "510600"
}, {
  "name": "广汉市",
  "value": "510681",
  "parent": "510600"
}, {
  "name": "什邡市",
  "value": "510682",
  "parent": "510600"
}, {
  "name": "绵竹市",
  "value": "510683",
  "parent": "510600"
}, {
  "name": "涪城区",
  "value": "510703",
  "parent": "510700"
}, {
  "name": "游仙区",
  "value": "510704",
  "parent": "510700"
}, {
  "name": "三台县",
  "value": "510722",
  "parent": "510700"
}, {
  "name": "盐亭县",
  "value": "510723",
  "parent": "510700"
}, {
  "name": "安县",
  "value": "510724",
  "parent": "510700"
}, {
  "name": "梓潼县",
  "value": "510725",
  "parent": "510700"
}, {
  "name": "北川羌族自治县",
  "value": "510726",
  "parent": "510700"
}, {
  "name": "平武县",
  "value": "510727",
  "parent": "510700"
}, {
  "name": "江油市",
  "value": "510781",
  "parent": "510700"
}, {
  "name": "利州区",
  "value": "510802",
  "parent": "510800"
}, {
  "name": "昭化区",
  "value": "510811",
  "parent": "510800"
}, {
  "name": "朝天区",
  "value": "510812",
  "parent": "510800"
}, {
  "name": "旺苍县",
  "value": "510821",
  "parent": "510800"
}, {
  "name": "青川县",
  "value": "510822",
  "parent": "510800"
}, {
  "name": "剑阁县",
  "value": "510823",
  "parent": "510800"
}, {
  "name": "苍溪县",
  "value": "510824",
  "parent": "510800"
}, {
  "name": "船山区",
  "value": "510903",
  "parent": "510900"
}, {
  "name": "安居区",
  "value": "510904",
  "parent": "510900"
}, {
  "name": "蓬溪县",
  "value": "510921",
  "parent": "510900"
}, {
  "name": "射洪县",
  "value": "510922",
  "parent": "510900"
}, {
  "name": "大英县",
  "value": "510923",
  "parent": "510900"
}, {
  "name": "市中区",
  "value": "511002",
  "parent": "511000"
}, {
  "name": "东兴区",
  "value": "511011",
  "parent": "511000"
}, {
  "name": "威远县",
  "value": "511024",
  "parent": "511000"
}, {
  "name": "资中县",
  "value": "511025",
  "parent": "511000"
}, {
  "name": "隆昌县",
  "value": "511028",
  "parent": "511000"
}, {
  "name": "市中区",
  "value": "511102",
  "parent": "511100"
}, {
  "name": "沙湾区",
  "value": "511111",
  "parent": "511100"
}, {
  "name": "五通桥区",
  "value": "511112",
  "parent": "511100"
}, {
  "name": "金口河区",
  "value": "511113",
  "parent": "511100"
}, {
  "name": "犍为县",
  "value": "511123",
  "parent": "511100"
}, {
  "name": "井研县",
  "value": "511124",
  "parent": "511100"
}, {
  "name": "夹江县",
  "value": "511126",
  "parent": "511100"
}, {
  "name": "沐川县",
  "value": "511129",
  "parent": "511100"
}, {
  "name": "峨边彝族自治县",
  "value": "511132",
  "parent": "511100"
}, {
  "name": "马边彝族自治县",
  "value": "511133",
  "parent": "511100"
}, {
  "name": "峨眉山市",
  "value": "511181",
  "parent": "511100"
}, {
  "name": "顺庆区",
  "value": "511302",
  "parent": "511300"
}, {
  "name": "高坪区",
  "value": "511303",
  "parent": "511300"
}, {
  "name": "嘉陵区",
  "value": "511304",
  "parent": "511300"
}, {
  "name": "南部县",
  "value": "511321",
  "parent": "511300"
}, {
  "name": "营山县",
  "value": "511322",
  "parent": "511300"
}, {
  "name": "蓬安县",
  "value": "511323",
  "parent": "511300"
}, {
  "name": "仪陇县",
  "value": "511324",
  "parent": "511300"
}, {
  "name": "西充县",
  "value": "511325",
  "parent": "511300"
}, {
  "name": "阆中市",
  "value": "511381",
  "parent": "511300"
}, {
  "name": "东坡区",
  "value": "511402",
  "parent": "511400"
}, {
  "name": "彭山区",
  "value": "511403",
  "parent": "511400"
}, {
  "name": "仁寿县",
  "value": "511421",
  "parent": "511400"
}, {
  "name": "洪雅县",
  "value": "511423",
  "parent": "511400"
}, {
  "name": "丹棱县",
  "value": "511424",
  "parent": "511400"
}, {
  "name": "青神县",
  "value": "511425",
  "parent": "511400"
}, {
  "name": "翠屏区",
  "value": "511502",
  "parent": "511500"
}, {
  "name": "南溪区",
  "value": "511503",
  "parent": "511500"
}, {
  "name": "宜宾县",
  "value": "511521",
  "parent": "511500"
}, {
  "name": "江安县",
  "value": "511523",
  "parent": "511500"
}, {
  "name": "长宁县",
  "value": "511524",
  "parent": "511500"
}, {
  "name": "高县",
  "value": "511525",
  "parent": "511500"
}, {
  "name": "珙县",
  "value": "511526",
  "parent": "511500"
}, {
  "name": "筠连县",
  "value": "511527",
  "parent": "511500"
}, {
  "name": "兴文县",
  "value": "511528",
  "parent": "511500"
}, {
  "name": "屏山县",
  "value": "511529",
  "parent": "511500"
}, {
  "name": "广安区",
  "value": "511602",
  "parent": "511600"
}, {
  "name": "前锋区",
  "value": "511603",
  "parent": "511600"
}, {
  "name": "岳池县",
  "value": "511621",
  "parent": "511600"
}, {
  "name": "武胜县",
  "value": "511622",
  "parent": "511600"
}, {
  "name": "邻水县",
  "value": "511623",
  "parent": "511600"
}, {
  "name": "华蓥市",
  "value": "511681",
  "parent": "511600"
}, {
  "name": "通川区",
  "value": "511702",
  "parent": "511700"
}, {
  "name": "达川区",
  "value": "511703",
  "parent": "511700"
}, {
  "name": "宣汉县",
  "value": "511722",
  "parent": "511700"
}, {
  "name": "开江县",
  "value": "511723",
  "parent": "511700"
}, {
  "name": "大竹县",
  "value": "511724",
  "parent": "511700"
}, {
  "name": "渠县",
  "value": "511725",
  "parent": "511700"
}, {
  "name": "万源市",
  "value": "511781",
  "parent": "511700"
}, {
  "name": "雨城区",
  "value": "511802",
  "parent": "511800"
}, {
  "name": "名山区",
  "value": "511803",
  "parent": "511800"
}, {
  "name": "荥经县",
  "value": "511822",
  "parent": "511800"
}, {
  "name": "汉源县",
  "value": "511823",
  "parent": "511800"
}, {
  "name": "石棉县",
  "value": "511824",
  "parent": "511800"
}, {
  "name": "天全县",
  "value": "511825",
  "parent": "511800"
}, {
  "name": "芦山县",
  "value": "511826",
  "parent": "511800"
}, {
  "name": "宝兴县",
  "value": "511827",
  "parent": "511800"
}, {
  "name": "巴州区",
  "value": "511902",
  "parent": "511900"
}, {
  "name": "恩阳区",
  "value": "511903",
  "parent": "511900"
}, {
  "name": "通江县",
  "value": "511921",
  "parent": "511900"
}, {
  "name": "南江县",
  "value": "511922",
  "parent": "511900"
}, {
  "name": "平昌县",
  "value": "511923",
  "parent": "511900"
}, {
  "name": "雁江区",
  "value": "512002",
  "parent": "512000"
}, {
  "name": "安岳县",
  "value": "512021",
  "parent": "512000"
}, {
  "name": "乐至县",
  "value": "512022",
  "parent": "512000"
}, {
  "name": "简阳市",
  "value": "512081",
  "parent": "512000"
}, {
  "name": "马尔康市",
  "value": "513201",
  "parent": "513200"
}, {
  "name": "汶川县",
  "value": "513221",
  "parent": "513200"
}, {
  "name": "理县",
  "value": "513222",
  "parent": "513200"
}, {
  "name": "茂县",
  "value": "513223",
  "parent": "513200"
}, {
  "name": "松潘县",
  "value": "513224",
  "parent": "513200"
}, {
  "name": "九寨沟县",
  "value": "513225",
  "parent": "513200"
}, {
  "name": "金川县",
  "value": "513226",
  "parent": "513200"
}, {
  "name": "小金县",
  "value": "513227",
  "parent": "513200"
}, {
  "name": "黑水县",
  "value": "513228",
  "parent": "513200"
}, {
  "name": "壤塘县",
  "value": "513230",
  "parent": "513200"
}, {
  "name": "阿坝县",
  "value": "513231",
  "parent": "513200"
}, {
  "name": "若尔盖县",
  "value": "513232",
  "parent": "513200"
}, {
  "name": "红原县",
  "value": "513233",
  "parent": "513200"
}, {
  "name": "康定市",
  "value": "513301",
  "parent": "513300"
}, {
  "name": "泸定县",
  "value": "513322",
  "parent": "513300"
}, {
  "name": "丹巴县",
  "value": "513323",
  "parent": "513300"
}, {
  "name": "九龙县",
  "value": "513324",
  "parent": "513300"
}, {
  "name": "雅江县",
  "value": "513325",
  "parent": "513300"
}, {
  "name": "道孚县",
  "value": "513326",
  "parent": "513300"
}, {
  "name": "炉霍县",
  "value": "513327",
  "parent": "513300"
}, {
  "name": "甘孜县",
  "value": "513328",
  "parent": "513300"
}, {
  "name": "新龙县",
  "value": "513329",
  "parent": "513300"
}, {
  "name": "德格县",
  "value": "513330",
  "parent": "513300"
}, {
  "name": "白玉县",
  "value": "513331",
  "parent": "513300"
}, {
  "name": "石渠县",
  "value": "513332",
  "parent": "513300"
}, {
  "name": "色达县",
  "value": "513333",
  "parent": "513300"
}, {
  "name": "理塘县",
  "value": "513334",
  "parent": "513300"
}, {
  "name": "巴塘县",
  "value": "513335",
  "parent": "513300"
}, {
  "name": "乡城县",
  "value": "513336",
  "parent": "513300"
}, {
  "name": "稻城县",
  "value": "513337",
  "parent": "513300"
}, {
  "name": "得荣县",
  "value": "513338",
  "parent": "513300"
}, {
  "name": "西昌市",
  "value": "513401",
  "parent": "513400"
}, {
  "name": "木里藏族自治县",
  "value": "513422",
  "parent": "513400"
}, {
  "name": "盐源县",
  "value": "513423",
  "parent": "513400"
}, {
  "name": "德昌县",
  "value": "513424",
  "parent": "513400"
}, {
  "name": "会理县",
  "value": "513425",
  "parent": "513400"
}, {
  "name": "会东县",
  "value": "513426",
  "parent": "513400"
}, {
  "name": "宁南县",
  "value": "513427",
  "parent": "513400"
}, {
  "name": "普格县",
  "value": "513428",
  "parent": "513400"
}, {
  "name": "布拖县",
  "value": "513429",
  "parent": "513400"
}, {
  "name": "金阳县",
  "value": "513430",
  "parent": "513400"
}, {
  "name": "昭觉县",
  "value": "513431",
  "parent": "513400"
}, {
  "name": "喜德县",
  "value": "513432",
  "parent": "513400"
}, {
  "name": "冕宁县",
  "value": "513433",
  "parent": "513400"
}, {
  "name": "越西县",
  "value": "513434",
  "parent": "513400"
}, {
  "name": "甘洛县",
  "value": "513435",
  "parent": "513400"
}, {
  "name": "美姑县",
  "value": "513436",
  "parent": "513400"
}, {
  "name": "雷波县",
  "value": "513437",
  "parent": "513400"
}, {
  "name": "贵阳市",
  "value": "520100",
  "parent": "520000"
}, {
  "name": "六盘水市",
  "value": "520200",
  "parent": "520000"
}, {
  "name": "遵义市",
  "value": "520300",
  "parent": "520000"
}, {
  "name": "安顺市",
  "value": "520400",
  "parent": "520000"
}, {
  "name": "毕节市",
  "value": "520500",
  "parent": "520000"
}, {
  "name": "铜仁市",
  "value": "520600",
  "parent": "520000"
}, {
  "name": "黔西南布依族苗族自治州",
  "value": "522300",
  "parent": "520000"
}, {
  "name": "黔东南苗族侗族自治州",
  "value": "522600",
  "parent": "520000"
}, {
  "name": "黔南布依族苗族自治州",
  "value": "522700",
  "parent": "520000"
}, {
  "name": "南明区",
  "value": "520102",
  "parent": "520100"
}, {
  "name": "云岩区",
  "value": "520103",
  "parent": "520100"
}, {
  "name": "花溪区",
  "value": "520111",
  "parent": "520100"
}, {
  "name": "乌当区",
  "value": "520112",
  "parent": "520100"
}, {
  "name": "白云区",
  "value": "520113",
  "parent": "520100"
}, {
  "name": "观山湖区",
  "value": "520115",
  "parent": "520100"
}, {
  "name": "开阳县",
  "value": "520121",
  "parent": "520100"
}, {
  "name": "息烽县",
  "value": "520122",
  "parent": "520100"
}, {
  "name": "修文县",
  "value": "520123",
  "parent": "520100"
}, {
  "name": "清镇市",
  "value": "520181",
  "parent": "520100"
}, {
  "name": "钟山区",
  "value": "520201",
  "parent": "520200"
}, {
  "name": "六枝特区",
  "value": "520203",
  "parent": "520200"
}, {
  "name": "水城县",
  "value": "520221",
  "parent": "520200"
}, {
  "name": "盘县",
  "value": "520222",
  "parent": "520200"
}, {
  "name": "红花岗区",
  "value": "520302",
  "parent": "520300"
}, {
  "name": "汇川区",
  "value": "520303",
  "parent": "520300"
}, {
  "name": "遵义县",
  "value": "520321",
  "parent": "520300"
}, {
  "name": "桐梓县",
  "value": "520322",
  "parent": "520300"
}, {
  "name": "绥阳县",
  "value": "520323",
  "parent": "520300"
}, {
  "name": "正安县",
  "value": "520324",
  "parent": "520300"
}, {
  "name": "道真仡佬族苗族自治县",
  "value": "520325",
  "parent": "520300"
}, {
  "name": "务川仡佬族苗族自治县",
  "value": "520326",
  "parent": "520300"
}, {
  "name": "凤冈县",
  "value": "520327",
  "parent": "520300"
}, {
  "name": "湄潭县",
  "value": "520328",
  "parent": "520300"
}, {
  "name": "余庆县",
  "value": "520329",
  "parent": "520300"
}, {
  "name": "习水县",
  "value": "520330",
  "parent": "520300"
}, {
  "name": "赤水市",
  "value": "520381",
  "parent": "520300"
}, {
  "name": "仁怀市",
  "value": "520382",
  "parent": "520300"
}, {
  "name": "西秀区",
  "value": "520402",
  "parent": "520400"
}, {
  "name": "平坝区",
  "value": "520403",
  "parent": "520400"
}, {
  "name": "普定县",
  "value": "520422",
  "parent": "520400"
}, {
  "name": "镇宁布依族苗族自治县",
  "value": "520423",
  "parent": "520400"
}, {
  "name": "关岭布依族苗族自治县",
  "value": "520424",
  "parent": "520400"
}, {
  "name": "紫云苗族布依族自治县",
  "value": "520425",
  "parent": "520400"
}, {
  "name": "七星关区",
  "value": "520502",
  "parent": "520500"
}, {
  "name": "大方县",
  "value": "520521",
  "parent": "520500"
}, {
  "name": "黔西县",
  "value": "520522",
  "parent": "520500"
}, {
  "name": "金沙县",
  "value": "520523",
  "parent": "520500"
}, {
  "name": "织金县",
  "value": "520524",
  "parent": "520500"
}, {
  "name": "纳雍县",
  "value": "520525",
  "parent": "520500"
}, {
  "name": "威宁彝族回族苗族自治县",
  "value": "520526",
  "parent": "520500"
}, {
  "name": "赫章县",
  "value": "520527",
  "parent": "520500"
}, {
  "name": "碧江区",
  "value": "520602",
  "parent": "520600"
}, {
  "name": "万山区",
  "value": "520603",
  "parent": "520600"
}, {
  "name": "江口县",
  "value": "520621",
  "parent": "520600"
}, {
  "name": "玉屏侗族自治县",
  "value": "520622",
  "parent": "520600"
}, {
  "name": "石阡县",
  "value": "520623",
  "parent": "520600"
}, {
  "name": "思南县",
  "value": "520624",
  "parent": "520600"
}, {
  "name": "印江土家族苗族自治县",
  "value": "520625",
  "parent": "520600"
}, {
  "name": "德江县",
  "value": "520626",
  "parent": "520600"
}, {
  "name": "沿河土家族自治县",
  "value": "520627",
  "parent": "520600"
}, {
  "name": "松桃苗族自治县",
  "value": "520628",
  "parent": "520600"
}, {
  "name": "兴义市",
  "value": "522301",
  "parent": "522300"
}, {
  "name": "兴仁县",
  "value": "522322",
  "parent": "522300"
}, {
  "name": "普安县",
  "value": "522323",
  "parent": "522300"
}, {
  "name": "晴隆县",
  "value": "522324",
  "parent": "522300"
}, {
  "name": "贞丰县",
  "value": "522325",
  "parent": "522300"
}, {
  "name": "望谟县",
  "value": "522326",
  "parent": "522300"
}, {
  "name": "册亨县",
  "value": "522327",
  "parent": "522300"
}, {
  "name": "安龙县",
  "value": "522328",
  "parent": "522300"
}, {
  "name": "凯里市",
  "value": "522601",
  "parent": "522600"
}, {
  "name": "黄平县",
  "value": "522622",
  "parent": "522600"
}, {
  "name": "施秉县",
  "value": "522623",
  "parent": "522600"
}, {
  "name": "三穗县",
  "value": "522624",
  "parent": "522600"
}, {
  "name": "镇远县",
  "value": "522625",
  "parent": "522600"
}, {
  "name": "岑巩县",
  "value": "522626",
  "parent": "522600"
}, {
  "name": "天柱县",
  "value": "522627",
  "parent": "522600"
}, {
  "name": "锦屏县",
  "value": "522628",
  "parent": "522600"
}, {
  "name": "剑河县",
  "value": "522629",
  "parent": "522600"
}, {
  "name": "台江县",
  "value": "522630",
  "parent": "522600"
}, {
  "name": "黎平县",
  "value": "522631",
  "parent": "522600"
}, {
  "name": "榕江县",
  "value": "522632",
  "parent": "522600"
}, {
  "name": "从江县",
  "value": "522633",
  "parent": "522600"
}, {
  "name": "雷山县",
  "value": "522634",
  "parent": "522600"
}, {
  "name": "麻江县",
  "value": "522635",
  "parent": "522600"
}, {
  "name": "丹寨县",
  "value": "522636",
  "parent": "522600"
}, {
  "name": "都匀市",
  "value": "522701",
  "parent": "522700"
}, {
  "name": "福泉市",
  "value": "522702",
  "parent": "522700"
}, {
  "name": "荔波县",
  "value": "522722",
  "parent": "522700"
}, {
  "name": "贵定县",
  "value": "522723",
  "parent": "522700"
}, {
  "name": "瓮安县",
  "value": "522725",
  "parent": "522700"
}, {
  "name": "独山县",
  "value": "522726",
  "parent": "522700"
}, {
  "name": "平塘县",
  "value": "522727",
  "parent": "522700"
}, {
  "name": "罗甸县",
  "value": "522728",
  "parent": "522700"
}, {
  "name": "长顺县",
  "value": "522729",
  "parent": "522700"
}, {
  "name": "龙里县",
  "value": "522730",
  "parent": "522700"
}, {
  "name": "惠水县",
  "value": "522731",
  "parent": "522700"
}, {
  "name": "三都水族自治县",
  "value": "522732",
  "parent": "522700"
}, {
  "name": "昆明市",
  "value": "530100",
  "parent": "530000"
}, {
  "name": "曲靖市",
  "value": "530300",
  "parent": "530000"
}, {
  "name": "玉溪市",
  "value": "530400",
  "parent": "530000"
}, {
  "name": "保山市",
  "value": "530500",
  "parent": "530000"
}, {
  "name": "昭通市",
  "value": "530600",
  "parent": "530000"
}, {
  "name": "丽江市",
  "value": "530700",
  "parent": "530000"
}, {
  "name": "普洱市",
  "value": "530800",
  "parent": "530000"
}, {
  "name": "临沧市",
  "value": "530900",
  "parent": "530000"
}, {
  "name": "楚雄彝族自治州",
  "value": "532300",
  "parent": "530000"
}, {
  "name": "红河哈尼族彝族自治州",
  "value": "532500",
  "parent": "530000"
}, {
  "name": "文山壮族苗族自治州",
  "value": "532600",
  "parent": "530000"
}, {
  "name": "西双版纳傣族自治州",
  "value": "532800",
  "parent": "530000"
}, {
  "name": "大理白族自治州",
  "value": "532900",
  "parent": "530000"
}, {
  "name": "德宏傣族景颇族自治州",
  "value": "533100",
  "parent": "530000"
}, {
  "name": "怒江傈僳族自治州",
  "value": "533300",
  "parent": "530000"
}, {
  "name": "迪庆藏族自治州",
  "value": "533400",
  "parent": "530000"
}, {
  "name": "五华区",
  "value": "530102",
  "parent": "530100"
}, {
  "name": "盘龙区",
  "value": "530103",
  "parent": "530100"
}, {
  "name": "官渡区",
  "value": "530111",
  "parent": "530100"
}, {
  "name": "西山区",
  "value": "530112",
  "parent": "530100"
}, {
  "name": "东川区",
  "value": "530113",
  "parent": "530100"
}, {
  "name": "呈贡区",
  "value": "530114",
  "parent": "530100"
}, {
  "name": "晋宁县",
  "value": "530122",
  "parent": "530100"
}, {
  "name": "富民县",
  "value": "530124",
  "parent": "530100"
}, {
  "name": "宜良县",
  "value": "530125",
  "parent": "530100"
}, {
  "name": "石林彝族自治县",
  "value": "530126",
  "parent": "530100"
}, {
  "name": "嵩明县",
  "value": "530127",
  "parent": "530100"
}, {
  "name": "禄劝彝族苗族自治县",
  "value": "530128",
  "parent": "530100"
}, {
  "name": "寻甸回族彝族自治县",
  "value": "530129",
  "parent": "530100"
}, {
  "name": "安宁市",
  "value": "530181",
  "parent": "530100"
}, {
  "name": "麒麟区",
  "value": "530302",
  "parent": "530300"
}, {
  "name": "马龙县",
  "value": "530321",
  "parent": "530300"
}, {
  "name": "陆良县",
  "value": "530322",
  "parent": "530300"
}, {
  "name": "师宗县",
  "value": "530323",
  "parent": "530300"
}, {
  "name": "罗平县",
  "value": "530324",
  "parent": "530300"
}, {
  "name": "富源县",
  "value": "530325",
  "parent": "530300"
}, {
  "name": "会泽县",
  "value": "530326",
  "parent": "530300"
}, {
  "name": "沾益县",
  "value": "530328",
  "parent": "530300"
}, {
  "name": "宣威市",
  "value": "530381",
  "parent": "530300"
}, {
  "name": "红塔区",
  "value": "530402",
  "parent": "530400"
}, {
  "name": "江川区",
  "value": "530403",
  "parent": "530400"
}, {
  "name": "澄江县",
  "value": "530422",
  "parent": "530400"
}, {
  "name": "通海县",
  "value": "530423",
  "parent": "530400"
}, {
  "name": "华宁县",
  "value": "530424",
  "parent": "530400"
}, {
  "name": "易门县",
  "value": "530425",
  "parent": "530400"
}, {
  "name": "峨山彝族自治县",
  "value": "530426",
  "parent": "530400"
}, {
  "name": "新平彝族傣族自治县",
  "value": "530427",
  "parent": "530400"
}, {
  "name": "元江哈尼族彝族傣族自治县",
  "value": "530428",
  "parent": "530400"
}, {
  "name": "隆阳区",
  "value": "530502",
  "parent": "530500"
}, {
  "name": "施甸县",
  "value": "530521",
  "parent": "530500"
}, {
  "name": "龙陵县",
  "value": "530523",
  "parent": "530500"
}, {
  "name": "昌宁县",
  "value": "530524",
  "parent": "530500"
}, {
  "name": "腾冲市",
  "value": "530581",
  "parent": "530500"
}, {
  "name": "昭阳区",
  "value": "530602",
  "parent": "530600"
}, {
  "name": "鲁甸县",
  "value": "530621",
  "parent": "530600"
}, {
  "name": "巧家县",
  "value": "530622",
  "parent": "530600"
}, {
  "name": "盐津县",
  "value": "530623",
  "parent": "530600"
}, {
  "name": "大关县",
  "value": "530624",
  "parent": "530600"
}, {
  "name": "永善县",
  "value": "530625",
  "parent": "530600"
}, {
  "name": "绥江县",
  "value": "530626",
  "parent": "530600"
}, {
  "name": "镇雄县",
  "value": "530627",
  "parent": "530600"
}, {
  "name": "彝良县",
  "value": "530628",
  "parent": "530600"
}, {
  "name": "威信县",
  "value": "530629",
  "parent": "530600"
}, {
  "name": "水富县",
  "value": "530630",
  "parent": "530600"
}, {
  "name": "古城区",
  "value": "530702",
  "parent": "530700"
}, {
  "name": "玉龙纳西族自治县",
  "value": "530721",
  "parent": "530700"
}, {
  "name": "永胜县",
  "value": "530722",
  "parent": "530700"
}, {
  "name": "华坪县",
  "value": "530723",
  "parent": "530700"
}, {
  "name": "宁蒗彝族自治县",
  "value": "530724",
  "parent": "530700"
}, {
  "name": "思茅区",
  "value": "530802",
  "parent": "530800"
}, {
  "name": "宁洱哈尼族彝族自治县",
  "value": "530821",
  "parent": "530800"
}, {
  "name": "墨江哈尼族自治县",
  "value": "530822",
  "parent": "530800"
}, {
  "name": "景东彝族自治县",
  "value": "530823",
  "parent": "530800"
}, {
  "name": "景谷傣族彝族自治县",
  "value": "530824",
  "parent": "530800"
}, {
  "name": "镇沅彝族哈尼族拉祜族自治县",
  "value": "530825",
  "parent": "530800"
}, {
  "name": "江城哈尼族彝族自治县",
  "value": "530826",
  "parent": "530800"
}, {
  "name": "孟连傣族拉祜族佤族自治县",
  "value": "530827",
  "parent": "530800"
}, {
  "name": "澜沧拉祜族自治县",
  "value": "530828",
  "parent": "530800"
}, {
  "name": "西盟佤族自治县",
  "value": "530829",
  "parent": "530800"
}, {
  "name": "临翔区",
  "value": "530902",
  "parent": "530900"
}, {
  "name": "凤庆县",
  "value": "530921",
  "parent": "530900"
}, {
  "name": "云县",
  "value": "530922",
  "parent": "530900"
}, {
  "name": "永德县",
  "value": "530923",
  "parent": "530900"
}, {
  "name": "镇康县",
  "value": "530924",
  "parent": "530900"
}, {
  "name": "双江拉祜族佤族布朗族傣族自治县",
  "value": "530925",
  "parent": "530900"
}, {
  "name": "耿马傣族佤族自治县",
  "value": "530926",
  "parent": "530900"
}, {
  "name": "沧源佤族自治县",
  "value": "530927",
  "parent": "530900"
}, {
  "name": "楚雄市",
  "value": "532301",
  "parent": "532300"
}, {
  "name": "双柏县",
  "value": "532322",
  "parent": "532300"
}, {
  "name": "牟定县",
  "value": "532323",
  "parent": "532300"
}, {
  "name": "南华县",
  "value": "532324",
  "parent": "532300"
}, {
  "name": "姚安县",
  "value": "532325",
  "parent": "532300"
}, {
  "name": "大姚县",
  "value": "532326",
  "parent": "532300"
}, {
  "name": "永仁县",
  "value": "532327",
  "parent": "532300"
}, {
  "name": "元谋县",
  "value": "532328",
  "parent": "532300"
}, {
  "name": "武定县",
  "value": "532329",
  "parent": "532300"
}, {
  "name": "禄丰县",
  "value": "532331",
  "parent": "532300"
}, {
  "name": "个旧市",
  "value": "532501",
  "parent": "532500"
}, {
  "name": "开远市",
  "value": "532502",
  "parent": "532500"
}, {
  "name": "蒙自市",
  "value": "532503",
  "parent": "532500"
}, {
  "name": "弥勒市",
  "value": "532504",
  "parent": "532500"
}, {
  "name": "屏边苗族自治县",
  "value": "532523",
  "parent": "532500"
}, {
  "name": "建水县",
  "value": "532524",
  "parent": "532500"
}, {
  "name": "石屏县",
  "value": "532525",
  "parent": "532500"
}, {
  "name": "泸西县",
  "value": "532527",
  "parent": "532500"
}, {
  "name": "元阳县",
  "value": "532528",
  "parent": "532500"
}, {
  "name": "红河县",
  "value": "532529",
  "parent": "532500"
}, {
  "name": "金平苗族瑶族傣族自治县",
  "value": "532530",
  "parent": "532500"
}, {
  "name": "绿春县",
  "value": "532531",
  "parent": "532500"
}, {
  "name": "河口瑶族自治县",
  "value": "532532",
  "parent": "532500"
}, {
  "name": "文山市",
  "value": "532601",
  "parent": "532600"
}, {
  "name": "砚山县",
  "value": "532622",
  "parent": "532600"
}, {
  "name": "西畴县",
  "value": "532623",
  "parent": "532600"
}, {
  "name": "麻栗坡县",
  "value": "532624",
  "parent": "532600"
}, {
  "name": "马关县",
  "value": "532625",
  "parent": "532600"
}, {
  "name": "丘北县",
  "value": "532626",
  "parent": "532600"
}, {
  "name": "广南县",
  "value": "532627",
  "parent": "532600"
}, {
  "name": "富宁县",
  "value": "532628",
  "parent": "532600"
}, {
  "name": "景洪市",
  "value": "532801",
  "parent": "532800"
}, {
  "name": "勐海县",
  "value": "532822",
  "parent": "532800"
}, {
  "name": "勐腊县",
  "value": "532823",
  "parent": "532800"
}, {
  "name": "大理市",
  "value": "532901",
  "parent": "532900"
}, {
  "name": "漾濞彝族自治县",
  "value": "532922",
  "parent": "532900"
}, {
  "name": "祥云县",
  "value": "532923",
  "parent": "532900"
}, {
  "name": "宾川县",
  "value": "532924",
  "parent": "532900"
}, {
  "name": "弥渡县",
  "value": "532925",
  "parent": "532900"
}, {
  "name": "南涧彝族自治县",
  "value": "532926",
  "parent": "532900"
}, {
  "name": "巍山彝族回族自治县",
  "value": "532927",
  "parent": "532900"
}, {
  "name": "永平县",
  "value": "532928",
  "parent": "532900"
}, {
  "name": "云龙县",
  "value": "532929",
  "parent": "532900"
}, {
  "name": "洱源县",
  "value": "532930",
  "parent": "532900"
}, {
  "name": "剑川县",
  "value": "532931",
  "parent": "532900"
}, {
  "name": "鹤庆县",
  "value": "532932",
  "parent": "532900"
}, {
  "name": "瑞丽市",
  "value": "533102",
  "parent": "533100"
}, {
  "name": "芒市",
  "value": "533103",
  "parent": "533100"
}, {
  "name": "梁河县",
  "value": "533122",
  "parent": "533100"
}, {
  "name": "盈江县",
  "value": "533123",
  "parent": "533100"
}, {
  "name": "陇川县",
  "value": "533124",
  "parent": "533100"
}, {
  "name": "泸水县",
  "value": "533321",
  "parent": "533300"
}, {
  "name": "福贡县",
  "value": "533323",
  "parent": "533300"
}, {
  "name": "贡山独龙族怒族自治县",
  "value": "533324",
  "parent": "533300"
}, {
  "name": "兰坪白族普米族自治县",
  "value": "533325",
  "parent": "533300"
}, {
  "name": "香格里拉市",
  "value": "533401",
  "parent": "533400"
}, {
  "name": "德钦县",
  "value": "533422",
  "parent": "533400"
}, {
  "name": "维西傈僳族自治县",
  "value": "533423",
  "parent": "533400"
}, {
  "name": "拉萨市",
  "value": "540100",
  "parent": "540000"
}, {
  "name": "日喀则市",
  "value": "540200",
  "parent": "540000"
}, {
  "name": "昌都市",
  "value": "540300",
  "parent": "540000"
}, {
  "name": "林芝市",
  "value": "540400",
  "parent": "540000"
}, {
  "name": "山南地区",
  "value": "542200",
  "parent": "540000"
}, {
  "name": "那曲地区",
  "value": "542400",
  "parent": "540000"
}, {
  "name": "阿里地区",
  "value": "542500",
  "parent": "540000"
}, {
  "name": "城关区",
  "value": "540102",
  "parent": "540100"
}, {
  "name": "堆龙德庆区",
  "value": "540103",
  "parent": "540100"
}, {
  "name": "林周县",
  "value": "540121",
  "parent": "540100"
}, {
  "name": "当雄县",
  "value": "540122",
  "parent": "540100"
}, {
  "name": "尼木县",
  "value": "540123",
  "parent": "540100"
}, {
  "name": "曲水县",
  "value": "540124",
  "parent": "540100"
}, {
  "name": "达孜县",
  "value": "540126",
  "parent": "540100"
}, {
  "name": "墨竹工卡县",
  "value": "540127",
  "parent": "540100"
}, {
  "name": "桑珠孜区",
  "value": "540202",
  "parent": "540200"
}, {
  "name": "南木林县",
  "value": "540221",
  "parent": "540200"
}, {
  "name": "江孜县",
  "value": "540222",
  "parent": "540200"
}, {
  "name": "定日县",
  "value": "540223",
  "parent": "540200"
}, {
  "name": "萨迦县",
  "value": "540224",
  "parent": "540200"
}, {
  "name": "拉孜县",
  "value": "540225",
  "parent": "540200"
}, {
  "name": "昂仁县",
  "value": "540226",
  "parent": "540200"
}, {
  "name": "谢通门县",
  "value": "540227",
  "parent": "540200"
}, {
  "name": "白朗县",
  "value": "540228",
  "parent": "540200"
}, {
  "name": "仁布县",
  "value": "540229",
  "parent": "540200"
}, {
  "name": "康马县",
  "value": "540230",
  "parent": "540200"
}, {
  "name": "定结县",
  "value": "540231",
  "parent": "540200"
}, {
  "name": "仲巴县",
  "value": "540232",
  "parent": "540200"
}, {
  "name": "亚东县",
  "value": "540233",
  "parent": "540200"
}, {
  "name": "吉隆县",
  "value": "540234",
  "parent": "540200"
}, {
  "name": "聂拉木县",
  "value": "540235",
  "parent": "540200"
}, {
  "name": "萨嘎县",
  "value": "540236",
  "parent": "540200"
}, {
  "name": "岗巴县",
  "value": "540237",
  "parent": "540200"
}, {
  "name": "卡若区",
  "value": "540302",
  "parent": "540300"
}, {
  "name": "江达县",
  "value": "540321",
  "parent": "540300"
}, {
  "name": "贡觉县",
  "value": "540322",
  "parent": "540300"
}, {
  "name": "类乌齐县",
  "value": "540323",
  "parent": "540300"
}, {
  "name": "丁青县",
  "value": "540324",
  "parent": "540300"
}, {
  "name": "察雅县",
  "value": "540325",
  "parent": "540300"
}, {
  "name": "八宿县",
  "value": "540326",
  "parent": "540300"
}, {
  "name": "左贡县",
  "value": "540327",
  "parent": "540300"
}, {
  "name": "芒康县",
  "value": "540328",
  "parent": "540300"
}, {
  "name": "洛隆县",
  "value": "540329",
  "parent": "540300"
}, {
  "name": "边坝县",
  "value": "540330",
  "parent": "540300"
}, {
  "name": "巴宜区",
  "value": "540402",
  "parent": "540400"
}, {
  "name": "工布江达县",
  "value": "540421",
  "parent": "540400"
}, {
  "name": "米林县",
  "value": "540422",
  "parent": "540400"
}, {
  "name": "墨脱县",
  "value": "540423",
  "parent": "540400"
}, {
  "name": "波密县",
  "value": "540424",
  "parent": "540400"
}, {
  "name": "察隅县",
  "value": "540425",
  "parent": "540400"
}, {
  "name": "朗县",
  "value": "540426",
  "parent": "540400"
}, {
  "name": "乃东县",
  "value": "542221",
  "parent": "542200"
}, {
  "name": "扎囊县",
  "value": "542222",
  "parent": "542200"
}, {
  "name": "贡嘎县",
  "value": "542223",
  "parent": "542200"
}, {
  "name": "桑日县",
  "value": "542224",
  "parent": "542200"
}, {
  "name": "琼结县",
  "value": "542225",
  "parent": "542200"
}, {
  "name": "曲松县",
  "value": "542226",
  "parent": "542200"
}, {
  "name": "措美县",
  "value": "542227",
  "parent": "542200"
}, {
  "name": "洛扎县",
  "value": "542228",
  "parent": "542200"
}, {
  "name": "加查县",
  "value": "542229",
  "parent": "542200"
}, {
  "name": "隆子县",
  "value": "542231",
  "parent": "542200"
}, {
  "name": "错那县",
  "value": "542232",
  "parent": "542200"
}, {
  "name": "浪卡子县",
  "value": "542233",
  "parent": "542200"
}, {
  "name": "那曲县",
  "value": "542421",
  "parent": "542400"
}, {
  "name": "嘉黎县",
  "value": "542422",
  "parent": "542400"
}, {
  "name": "比如县",
  "value": "542423",
  "parent": "542400"
}, {
  "name": "聂荣县",
  "value": "542424",
  "parent": "542400"
}, {
  "name": "安多县",
  "value": "542425",
  "parent": "542400"
}, {
  "name": "申扎县",
  "value": "542426",
  "parent": "542400"
}, {
  "name": "索县",
  "value": "542427",
  "parent": "542400"
}, {
  "name": "班戈县",
  "value": "542428",
  "parent": "542400"
}, {
  "name": "巴青县",
  "value": "542429",
  "parent": "542400"
}, {
  "name": "尼玛县",
  "value": "542430",
  "parent": "542400"
}, {
  "name": "双湖县",
  "value": "542431",
  "parent": "542400"
}, {
  "name": "普兰县",
  "value": "542521",
  "parent": "542500"
}, {
  "name": "札达县",
  "value": "542522",
  "parent": "542500"
}, {
  "name": "噶尔县",
  "value": "542523",
  "parent": "542500"
}, {
  "name": "日土县",
  "value": "542524",
  "parent": "542500"
}, {
  "name": "革吉县",
  "value": "542525",
  "parent": "542500"
}, {
  "name": "改则县",
  "value": "542526",
  "parent": "542500"
}, {
  "name": "措勤县",
  "value": "542527",
  "parent": "542500"
}, {
  "name": "西安市",
  "value": "610100",
  "parent": "610000"
}, {
  "name": "铜川市",
  "value": "610200",
  "parent": "610000"
}, {
  "name": "宝鸡市",
  "value": "610300",
  "parent": "610000"
}, {
  "name": "咸阳市",
  "value": "610400",
  "parent": "610000"
}, {
  "name": "渭南市",
  "value": "610500",
  "parent": "610000"
}, {
  "name": "延安市",
  "value": "610600",
  "parent": "610000"
}, {
  "name": "汉中市",
  "value": "610700",
  "parent": "610000"
}, {
  "name": "榆林市",
  "value": "610800",
  "parent": "610000"
}, {
  "name": "安康市",
  "value": "610900",
  "parent": "610000"
}, {
  "name": "商洛市",
  "value": "611000",
  "parent": "610000"
}, {
  "name": "新城区",
  "value": "610102",
  "parent": "610100"
}, {
  "name": "碑林区",
  "value": "610103",
  "parent": "610100"
}, {
  "name": "莲湖区",
  "value": "610104",
  "parent": "610100"
}, {
  "name": "灞桥区",
  "value": "610111",
  "parent": "610100"
}, {
  "name": "未央区",
  "value": "610112",
  "parent": "610100"
}, {
  "name": "雁塔区",
  "value": "610113",
  "parent": "610100"
}, {
  "name": "阎良区",
  "value": "610114",
  "parent": "610100"
}, {
  "name": "临潼区",
  "value": "610115",
  "parent": "610100"
}, {
  "name": "长安区",
  "value": "610116",
  "parent": "610100"
}, {
  "name": "高陵区",
  "value": "610117",
  "parent": "610100"
}, {
  "name": "蓝田县",
  "value": "610122",
  "parent": "610100"
}, {
  "name": "周至县",
  "value": "610124",
  "parent": "610100"
}, {
  "name": "户县",
  "value": "610125",
  "parent": "610100"
}, {
  "name": "王益区",
  "value": "610202",
  "parent": "610200"
}, {
  "name": "印台区",
  "value": "610203",
  "parent": "610200"
}, {
  "name": "耀州区",
  "value": "610204",
  "parent": "610200"
}, {
  "name": "宜君县",
  "value": "610222",
  "parent": "610200"
}, {
  "name": "渭滨区",
  "value": "610302",
  "parent": "610300"
}, {
  "name": "金台区",
  "value": "610303",
  "parent": "610300"
}, {
  "name": "陈仓区",
  "value": "610304",
  "parent": "610300"
}, {
  "name": "凤翔县",
  "value": "610322",
  "parent": "610300"
}, {
  "name": "岐山县",
  "value": "610323",
  "parent": "610300"
}, {
  "name": "扶风县",
  "value": "610324",
  "parent": "610300"
}, {
  "name": "眉县",
  "value": "610326",
  "parent": "610300"
}, {
  "name": "陇县",
  "value": "610327",
  "parent": "610300"
}, {
  "name": "千阳县",
  "value": "610328",
  "parent": "610300"
}, {
  "name": "麟游县",
  "value": "610329",
  "parent": "610300"
}, {
  "name": "凤县",
  "value": "610330",
  "parent": "610300"
}, {
  "name": "太白县",
  "value": "610331",
  "parent": "610300"
}, {
  "name": "秦都区",
  "value": "610402",
  "parent": "610400"
}, {
  "name": "杨陵区",
  "value": "610403",
  "parent": "610400"
}, {
  "name": "渭城区",
  "value": "610404",
  "parent": "610400"
}, {
  "name": "三原县",
  "value": "610422",
  "parent": "610400"
}, {
  "name": "泾阳县",
  "value": "610423",
  "parent": "610400"
}, {
  "name": "乾县",
  "value": "610424",
  "parent": "610400"
}, {
  "name": "礼泉县",
  "value": "610425",
  "parent": "610400"
}, {
  "name": "永寿县",
  "value": "610426",
  "parent": "610400"
}, {
  "name": "彬县",
  "value": "610427",
  "parent": "610400"
}, {
  "name": "长武县",
  "value": "610428",
  "parent": "610400"
}, {
  "name": "旬邑县",
  "value": "610429",
  "parent": "610400"
}, {
  "name": "淳化县",
  "value": "610430",
  "parent": "610400"
}, {
  "name": "武功县",
  "value": "610431",
  "parent": "610400"
}, {
  "name": "兴平市",
  "value": "610481",
  "parent": "610400"
}, {
  "name": "临渭区",
  "value": "610502",
  "parent": "610500"
}, {
  "name": "华州区",
  "value": "610503",
  "parent": "610500"
}, {
  "name": "潼关县",
  "value": "610522",
  "parent": "610500"
}, {
  "name": "大荔县",
  "value": "610523",
  "parent": "610500"
}, {
  "name": "合阳县",
  "value": "610524",
  "parent": "610500"
}, {
  "name": "澄城县",
  "value": "610525",
  "parent": "610500"
}, {
  "name": "蒲城县",
  "value": "610526",
  "parent": "610500"
}, {
  "name": "白水县",
  "value": "610527",
  "parent": "610500"
}, {
  "name": "富平县",
  "value": "610528",
  "parent": "610500"
}, {
  "name": "韩城市",
  "value": "610581",
  "parent": "610500"
}, {
  "name": "华阴市",
  "value": "610582",
  "parent": "610500"
}, {
  "name": "宝塔区",
  "value": "610602",
  "parent": "610600"
}, {
  "name": "延长县",
  "value": "610621",
  "parent": "610600"
}, {
  "name": "延川县",
  "value": "610622",
  "parent": "610600"
}, {
  "name": "子长县",
  "value": "610623",
  "parent": "610600"
}, {
  "name": "安塞县",
  "value": "610624",
  "parent": "610600"
}, {
  "name": "志丹县",
  "value": "610625",
  "parent": "610600"
}, {
  "name": "吴起县",
  "value": "610626",
  "parent": "610600"
}, {
  "name": "甘泉县",
  "value": "610627",
  "parent": "610600"
}, {
  "name": "富县",
  "value": "610628",
  "parent": "610600"
}, {
  "name": "洛川县",
  "value": "610629",
  "parent": "610600"
}, {
  "name": "宜川县",
  "value": "610630",
  "parent": "610600"
}, {
  "name": "黄龙县",
  "value": "610631",
  "parent": "610600"
}, {
  "name": "黄陵县",
  "value": "610632",
  "parent": "610600"
}, {
  "name": "汉台区",
  "value": "610702",
  "parent": "610700"
}, {
  "name": "南郑县",
  "value": "610721",
  "parent": "610700"
}, {
  "name": "城固县",
  "value": "610722",
  "parent": "610700"
}, {
  "name": "洋县",
  "value": "610723",
  "parent": "610700"
}, {
  "name": "西乡县",
  "value": "610724",
  "parent": "610700"
}, {
  "name": "勉县",
  "value": "610725",
  "parent": "610700"
}, {
  "name": "宁强县",
  "value": "610726",
  "parent": "610700"
}, {
  "name": "略阳县",
  "value": "610727",
  "parent": "610700"
}, {
  "name": "镇巴县",
  "value": "610728",
  "parent": "610700"
}, {
  "name": "留坝县",
  "value": "610729",
  "parent": "610700"
}, {
  "name": "佛坪县",
  "value": "610730",
  "parent": "610700"
}, {
  "name": "榆阳区",
  "value": "610802",
  "parent": "610800"
}, {
  "name": "横山区",
  "value": "610803",
  "parent": "610800"
}, {
  "name": "神木县",
  "value": "610821",
  "parent": "610800"
}, {
  "name": "府谷县",
  "value": "610822",
  "parent": "610800"
}, {
  "name": "靖边县",
  "value": "610824",
  "parent": "610800"
}, {
  "name": "定边县",
  "value": "610825",
  "parent": "610800"
}, {
  "name": "绥德县",
  "value": "610826",
  "parent": "610800"
}, {
  "name": "米脂县",
  "value": "610827",
  "parent": "610800"
}, {
  "name": "佳县",
  "value": "610828",
  "parent": "610800"
}, {
  "name": "吴堡县",
  "value": "610829",
  "parent": "610800"
}, {
  "name": "清涧县",
  "value": "610830",
  "parent": "610800"
}, {
  "name": "子洲县",
  "value": "610831",
  "parent": "610800"
}, {
  "name": "汉滨区",
  "value": "610902",
  "parent": "610900"
}, {
  "name": "汉阴县",
  "value": "610921",
  "parent": "610900"
}, {
  "name": "石泉县",
  "value": "610922",
  "parent": "610900"
}, {
  "name": "宁陕县",
  "value": "610923",
  "parent": "610900"
}, {
  "name": "紫阳县",
  "value": "610924",
  "parent": "610900"
}, {
  "name": "岚皋县",
  "value": "610925",
  "parent": "610900"
}, {
  "name": "平利县",
  "value": "610926",
  "parent": "610900"
}, {
  "name": "镇坪县",
  "value": "610927",
  "parent": "610900"
}, {
  "name": "旬阳县",
  "value": "610928",
  "parent": "610900"
}, {
  "name": "白河县",
  "value": "610929",
  "parent": "610900"
}, {
  "name": "商州区",
  "value": "611002",
  "parent": "611000"
}, {
  "name": "洛南县",
  "value": "611021",
  "parent": "611000"
}, {
  "name": "丹凤县",
  "value": "611022",
  "parent": "611000"
}, {
  "name": "商南县",
  "value": "611023",
  "parent": "611000"
}, {
  "name": "山阳县",
  "value": "611024",
  "parent": "611000"
}, {
  "name": "镇安县",
  "value": "611025",
  "parent": "611000"
}, {
  "name": "柞水县",
  "value": "611026",
  "parent": "611000"
}, {
  "name": "兰州市",
  "value": "620100",
  "parent": "620000"
}, {
  "name": "嘉峪关市",
  "value": "620200",
  "parent": "620000"
}, {
  "name": "金昌市",
  "value": "620300",
  "parent": "620000"
}, {
  "name": "白银市",
  "value": "620400",
  "parent": "620000"
}, {
  "name": "天水市",
  "value": "620500",
  "parent": "620000"
}, {
  "name": "武威市",
  "value": "620600",
  "parent": "620000"
}, {
  "name": "张掖市",
  "value": "620700",
  "parent": "620000"
}, {
  "name": "平凉市",
  "value": "620800",
  "parent": "620000"
}, {
  "name": "酒泉市",
  "value": "620900",
  "parent": "620000"
}, {
  "name": "庆阳市",
  "value": "621000",
  "parent": "620000"
}, {
  "name": "定西市",
  "value": "621100",
  "parent": "620000"
}, {
  "name": "陇南市",
  "value": "621200",
  "parent": "620000"
}, {
  "name": "临夏回族自治州",
  "value": "622900",
  "parent": "620000"
}, {
  "name": "甘南藏族自治州",
  "value": "623000",
  "parent": "620000"
}, {
  "name": "城关区",
  "value": "620102",
  "parent": "620100"
}, {
  "name": "七里河区",
  "value": "620103",
  "parent": "620100"
}, {
  "name": "西固区",
  "value": "620104",
  "parent": "620100"
}, {
  "name": "安宁区",
  "value": "620105",
  "parent": "620100"
}, {
  "name": "红古区",
  "value": "620111",
  "parent": "620100"
}, {
  "name": "永登县",
  "value": "620121",
  "parent": "620100"
}, {
  "name": "皋兰县",
  "value": "620122",
  "parent": "620100"
}, {
  "name": "榆中县",
  "value": "620123",
  "parent": "620100"
}, {
  "name": "金川区",
  "value": "620302",
  "parent": "620300"
}, {
  "name": "永昌县",
  "value": "620321",
  "parent": "620300"
}, {
  "name": "白银区",
  "value": "620402",
  "parent": "620400"
}, {
  "name": "平川区",
  "value": "620403",
  "parent": "620400"
}, {
  "name": "靖远县",
  "value": "620421",
  "parent": "620400"
}, {
  "name": "会宁县",
  "value": "620422",
  "parent": "620400"
}, {
  "name": "景泰县",
  "value": "620423",
  "parent": "620400"
}, {
  "name": "秦州区",
  "value": "620502",
  "parent": "620500"
}, {
  "name": "麦积区",
  "value": "620503",
  "parent": "620500"
}, {
  "name": "清水县",
  "value": "620521",
  "parent": "620500"
}, {
  "name": "秦安县",
  "value": "620522",
  "parent": "620500"
}, {
  "name": "甘谷县",
  "value": "620523",
  "parent": "620500"
}, {
  "name": "武山县",
  "value": "620524",
  "parent": "620500"
}, {
  "name": "张家川回族自治县",
  "value": "620525",
  "parent": "620500"
}, {
  "name": "凉州区",
  "value": "620602",
  "parent": "620600"
}, {
  "name": "民勤县",
  "value": "620621",
  "parent": "620600"
}, {
  "name": "古浪县",
  "value": "620622",
  "parent": "620600"
}, {
  "name": "天祝藏族自治县",
  "value": "620623",
  "parent": "620600"
}, {
  "name": "甘州区",
  "value": "620702",
  "parent": "620700"
}, {
  "name": "肃南裕固族自治县",
  "value": "620721",
  "parent": "620700"
}, {
  "name": "民乐县",
  "value": "620722",
  "parent": "620700"
}, {
  "name": "临泽县",
  "value": "620723",
  "parent": "620700"
}, {
  "name": "高台县",
  "value": "620724",
  "parent": "620700"
}, {
  "name": "山丹县",
  "value": "620725",
  "parent": "620700"
}, {
  "name": "崆峒区",
  "value": "620802",
  "parent": "620800"
}, {
  "name": "泾川县",
  "value": "620821",
  "parent": "620800"
}, {
  "name": "灵台县",
  "value": "620822",
  "parent": "620800"
}, {
  "name": "崇信县",
  "value": "620823",
  "parent": "620800"
}, {
  "name": "华亭县",
  "value": "620824",
  "parent": "620800"
}, {
  "name": "庄浪县",
  "value": "620825",
  "parent": "620800"
}, {
  "name": "静宁县",
  "value": "620826",
  "parent": "620800"
}, {
  "name": "肃州区",
  "value": "620902",
  "parent": "620900"
}, {
  "name": "金塔县",
  "value": "620921",
  "parent": "620900"
}, {
  "name": "瓜州县",
  "value": "620922",
  "parent": "620900"
}, {
  "name": "肃北蒙古族自治县",
  "value": "620923",
  "parent": "620900"
}, {
  "name": "阿克塞哈萨克族自治县",
  "value": "620924",
  "parent": "620900"
}, {
  "name": "玉门市",
  "value": "620981",
  "parent": "620900"
}, {
  "name": "敦煌市",
  "value": "620982",
  "parent": "620900"
}, {
  "name": "西峰区",
  "value": "621002",
  "parent": "621000"
}, {
  "name": "庆城县",
  "value": "621021",
  "parent": "621000"
}, {
  "name": "环县",
  "value": "621022",
  "parent": "621000"
}, {
  "name": "华池县",
  "value": "621023",
  "parent": "621000"
}, {
  "name": "合水县",
  "value": "621024",
  "parent": "621000"
}, {
  "name": "正宁县",
  "value": "621025",
  "parent": "621000"
}, {
  "name": "宁县",
  "value": "621026",
  "parent": "621000"
}, {
  "name": "镇原县",
  "value": "621027",
  "parent": "621000"
}, {
  "name": "安定区",
  "value": "621102",
  "parent": "621100"
}, {
  "name": "通渭县",
  "value": "621121",
  "parent": "621100"
}, {
  "name": "陇西县",
  "value": "621122",
  "parent": "621100"
}, {
  "name": "渭源县",
  "value": "621123",
  "parent": "621100"
}, {
  "name": "临洮县",
  "value": "621124",
  "parent": "621100"
}, {
  "name": "漳县",
  "value": "621125",
  "parent": "621100"
}, {
  "name": "岷县",
  "value": "621126",
  "parent": "621100"
}, {
  "name": "武都区",
  "value": "621202",
  "parent": "621200"
}, {
  "name": "成县",
  "value": "621221",
  "parent": "621200"
}, {
  "name": "文县",
  "value": "621222",
  "parent": "621200"
}, {
  "name": "宕昌县",
  "value": "621223",
  "parent": "621200"
}, {
  "name": "康县",
  "value": "621224",
  "parent": "621200"
}, {
  "name": "西和县",
  "value": "621225",
  "parent": "621200"
}, {
  "name": "礼县",
  "value": "621226",
  "parent": "621200"
}, {
  "name": "徽县",
  "value": "621227",
  "parent": "621200"
}, {
  "name": "两当县",
  "value": "621228",
  "parent": "621200"
}, {
  "name": "临夏市",
  "value": "622901",
  "parent": "622900"
}, {
  "name": "临夏县",
  "value": "622921",
  "parent": "622900"
}, {
  "name": "康乐县",
  "value": "622922",
  "parent": "622900"
}, {
  "name": "永靖县",
  "value": "622923",
  "parent": "622900"
}, {
  "name": "广河县",
  "value": "622924",
  "parent": "622900"
}, {
  "name": "和政县",
  "value": "622925",
  "parent": "622900"
}, {
  "name": "东乡族自治县",
  "value": "622926",
  "parent": "622900"
}, {
  "name": "积石山保安族东乡族撒拉族自治县",
  "value": "622927",
  "parent": "622900"
}, {
  "name": "合作市",
  "value": "623001",
  "parent": "623000"
}, {
  "name": "临潭县",
  "value": "623021",
  "parent": "623000"
}, {
  "name": "卓尼县",
  "value": "623022",
  "parent": "623000"
}, {
  "name": "舟曲县",
  "value": "623023",
  "parent": "623000"
}, {
  "name": "迭部县",
  "value": "623024",
  "parent": "623000"
}, {
  "name": "玛曲县",
  "value": "623025",
  "parent": "623000"
}, {
  "name": "碌曲县",
  "value": "623026",
  "parent": "623000"
}, {
  "name": "夏河县",
  "value": "623027",
  "parent": "623000"
}, {
  "name": "西宁市",
  "value": "630100",
  "parent": "630000"
}, {
  "name": "海东市",
  "value": "630200",
  "parent": "630000"
}, {
  "name": "海北藏族自治州",
  "value": "632200",
  "parent": "630000"
}, {
  "name": "黄南藏族自治州",
  "value": "632300",
  "parent": "630000"
}, {
  "name": "海南藏族自治州",
  "value": "632500",
  "parent": "630000"
}, {
  "name": "果洛藏族自治州",
  "value": "632600",
  "parent": "630000"
}, {
  "name": "玉树藏族自治州",
  "value": "632700",
  "parent": "630000"
}, {
  "name": "海西蒙古族藏族自治州",
  "value": "632800",
  "parent": "630000"
}, {
  "name": "城东区",
  "value": "630102",
  "parent": "630100"
}, {
  "name": "城中区",
  "value": "630103",
  "parent": "630100"
}, {
  "name": "城西区",
  "value": "630104",
  "parent": "630100"
}, {
  "name": "城北区",
  "value": "630105",
  "parent": "630100"
}, {
  "name": "大通回族土族自治县",
  "value": "630121",
  "parent": "630100"
}, {
  "name": "湟中县",
  "value": "630122",
  "parent": "630100"
}, {
  "name": "湟源县",
  "value": "630123",
  "parent": "630100"
}, {
  "name": "乐都区",
  "value": "630202",
  "parent": "630200"
}, {
  "name": "平安区",
  "value": "630203",
  "parent": "630200"
}, {
  "name": "民和回族土族自治县",
  "value": "630222",
  "parent": "630200"
}, {
  "name": "互助土族自治县",
  "value": "630223",
  "parent": "630200"
}, {
  "name": "化隆回族自治县",
  "value": "630224",
  "parent": "630200"
}, {
  "name": "循化撒拉族自治县",
  "value": "630225",
  "parent": "630200"
}, {
  "name": "门源回族自治县",
  "value": "632221",
  "parent": "632200"
}, {
  "name": "祁连县",
  "value": "632222",
  "parent": "632200"
}, {
  "name": "海晏县",
  "value": "632223",
  "parent": "632200"
}, {
  "name": "刚察县",
  "value": "632224",
  "parent": "632200"
}, {
  "name": "同仁县",
  "value": "632321",
  "parent": "632300"
}, {
  "name": "尖扎县",
  "value": "632322",
  "parent": "632300"
}, {
  "name": "泽库县",
  "value": "632323",
  "parent": "632300"
}, {
  "name": "河南蒙古族自治县",
  "value": "632324",
  "parent": "632300"
}, {
  "name": "共和县",
  "value": "632521",
  "parent": "632500"
}, {
  "name": "同德县",
  "value": "632522",
  "parent": "632500"
}, {
  "name": "贵德县",
  "value": "632523",
  "parent": "632500"
}, {
  "name": "兴海县",
  "value": "632524",
  "parent": "632500"
}, {
  "name": "贵南县",
  "value": "632525",
  "parent": "632500"
}, {
  "name": "玛沁县",
  "value": "632621",
  "parent": "632600"
}, {
  "name": "班玛县",
  "value": "632622",
  "parent": "632600"
}, {
  "name": "甘德县",
  "value": "632623",
  "parent": "632600"
}, {
  "name": "达日县",
  "value": "632624",
  "parent": "632600"
}, {
  "name": "久治县",
  "value": "632625",
  "parent": "632600"
}, {
  "name": "玛多县",
  "value": "632626",
  "parent": "632600"
}, {
  "name": "玉树市",
  "value": "632701",
  "parent": "632700"
}, {
  "name": "杂多县",
  "value": "632722",
  "parent": "632700"
}, {
  "name": "称多县",
  "value": "632723",
  "parent": "632700"
}, {
  "name": "治多县",
  "value": "632724",
  "parent": "632700"
}, {
  "name": "囊谦县",
  "value": "632725",
  "parent": "632700"
}, {
  "name": "曲麻莱县",
  "value": "632726",
  "parent": "632700"
}, {
  "name": "格尔木市",
  "value": "632801",
  "parent": "632800"
}, {
  "name": "德令哈市",
  "value": "632802",
  "parent": "632800"
}, {
  "name": "乌兰县",
  "value": "632821",
  "parent": "632800"
}, {
  "name": "都兰县",
  "value": "632822",
  "parent": "632800"
}, {
  "name": "天峻县",
  "value": "632823",
  "parent": "632800"
}, {
  "name": "海西蒙古族藏族自治州直辖",
  "value": "632825",
  "parent": "632800"
}, {
  "name": "银川市",
  "value": "640100",
  "parent": "640000"
}, {
  "name": "石嘴山市",
  "value": "640200",
  "parent": "640000"
}, {
  "name": "吴忠市",
  "value": "640300",
  "parent": "640000"
}, {
  "name": "固原市",
  "value": "640400",
  "parent": "640000"
}, {
  "name": "中卫市",
  "value": "640500",
  "parent": "640000"
}, {
  "name": "兴庆区",
  "value": "640104",
  "parent": "640100"
}, {
  "name": "西夏区",
  "value": "640105",
  "parent": "640100"
}, {
  "name": "金凤区",
  "value": "640106",
  "parent": "640100"
}, {
  "name": "永宁县",
  "value": "640121",
  "parent": "640100"
}, {
  "name": "贺兰县",
  "value": "640122",
  "parent": "640100"
}, {
  "name": "灵武市",
  "value": "640181",
  "parent": "640100"
}, {
  "name": "大武口区",
  "value": "640202",
  "parent": "640200"
}, {
  "name": "惠农区",
  "value": "640205",
  "parent": "640200"
}, {
  "name": "平罗县",
  "value": "640221",
  "parent": "640200"
}, {
  "name": "利通区",
  "value": "640302",
  "parent": "640300"
}, {
  "name": "红寺堡区",
  "value": "640303",
  "parent": "640300"
}, {
  "name": "盐池县",
  "value": "640323",
  "parent": "640300"
}, {
  "name": "同心县",
  "value": "640324",
  "parent": "640300"
}, {
  "name": "青铜峡市",
  "value": "640381",
  "parent": "640300"
}, {
  "name": "原州区",
  "value": "640402",
  "parent": "640400"
}, {
  "name": "西吉县",
  "value": "640422",
  "parent": "640400"
}, {
  "name": "隆德县",
  "value": "640423",
  "parent": "640400"
}, {
  "name": "泾源县",
  "value": "640424",
  "parent": "640400"
}, {
  "name": "彭阳县",
  "value": "640425",
  "parent": "640400"
}, {
  "name": "沙坡头区",
  "value": "640502",
  "parent": "640500"
}, {
  "name": "中宁县",
  "value": "640521",
  "parent": "640500"
}, {
  "name": "海原县",
  "value": "640522",
  "parent": "640500"
}, {
  "name": "乌鲁木齐市",
  "value": "650100",
  "parent": "650000"
}, {
  "name": "克拉玛依市",
  "value": "650200",
  "parent": "650000"
}, {
  "name": "吐鲁番市",
  "value": "650400",
  "parent": "650000"
}, {
  "name": "哈密地区",
  "value": "652200",
  "parent": "650000"
}, {
  "name": "昌吉回族自治州",
  "value": "652300",
  "parent": "650000"
}, {
  "name": "博尔塔拉蒙古自治州",
  "value": "652700",
  "parent": "650000"
}, {
  "name": "巴音郭楞蒙古自治州",
  "value": "652800",
  "parent": "650000"
}, {
  "name": "阿克苏地区",
  "value": "652900",
  "parent": "650000"
}, {
  "name": "克孜勒苏柯尔克孜自治州",
  "value": "653000",
  "parent": "650000"
}, {
  "name": "喀什地区",
  "value": "653100",
  "parent": "650000"
}, {
  "name": "和田地区",
  "value": "653200",
  "parent": "650000"
}, {
  "name": "伊犁哈萨克自治州",
  "value": "654000",
  "parent": "650000"
}, {
  "name": "塔城地区",
  "value": "654200",
  "parent": "650000"
}, {
  "name": "阿勒泰地区",
  "value": "654300",
  "parent": "650000"
}, {
  "name": "石河子市",
  "value": "659001",
  "parent": "650000"
}, {
  "name": "阿拉尔市",
  "value": "659002",
  "parent": "650000"
}, {
  "name": "图木舒克市",
  "value": "659003",
  "parent": "650000"
}, {
  "name": "五家渠市",
  "value": "659004",
  "parent": "650000"
}, {
  "name": "北屯市",
  "value": "659005",
  "parent": "650000"
}, {
  "name": "铁门关市",
  "value": "659006",
  "parent": "650000"
}, {
  "name": "双河市",
  "value": "659007",
  "parent": "650000"
}, {
  "name": "可克达拉市",
  "value": "659008",
  "parent": "650000"
}, {
  "name": "天山区",
  "value": "650102",
  "parent": "650100"
}, {
  "name": "沙依巴克区",
  "value": "650103",
  "parent": "650100"
}, {
  "name": "新市区",
  "value": "650104",
  "parent": "650100"
}, {
  "name": "水磨沟区",
  "value": "650105",
  "parent": "650100"
}, {
  "name": "头屯河区",
  "value": "650106",
  "parent": "650100"
}, {
  "name": "达坂城区",
  "value": "650107",
  "parent": "650100"
}, {
  "name": "米东区",
  "value": "650109",
  "parent": "650100"
}, {
  "name": "乌鲁木齐县",
  "value": "650121",
  "parent": "650100"
}, {
  "name": "独山子区",
  "value": "650202",
  "parent": "650200"
}, {
  "name": "克拉玛依区",
  "value": "650203",
  "parent": "650200"
}, {
  "name": "白碱滩区",
  "value": "650204",
  "parent": "650200"
}, {
  "name": "乌尔禾区",
  "value": "650205",
  "parent": "650200"
}, {
  "name": "高昌区",
  "value": "650402",
  "parent": "650400"
}, {
  "name": "鄯善县",
  "value": "650421",
  "parent": "650400"
}, {
  "name": "托克逊县",
  "value": "650422",
  "parent": "650400"
}, {
  "name": "哈密市",
  "value": "652201",
  "parent": "652200"
}, {
  "name": "巴里坤哈萨克自治县",
  "value": "652222",
  "parent": "652200"
}, {
  "name": "伊吾县",
  "value": "652223",
  "parent": "652200"
}, {
  "name": "昌吉市",
  "value": "652301",
  "parent": "652300"
}, {
  "name": "阜康市",
  "value": "652302",
  "parent": "652300"
}, {
  "name": "呼图壁县",
  "value": "652323",
  "parent": "652300"
}, {
  "name": "玛纳斯县",
  "value": "652324",
  "parent": "652300"
}, {
  "name": "奇台县",
  "value": "652325",
  "parent": "652300"
}, {
  "name": "吉木萨尔县",
  "value": "652327",
  "parent": "652300"
}, {
  "name": "木垒哈萨克自治县",
  "value": "652328",
  "parent": "652300"
}, {
  "name": "博乐市",
  "value": "652701",
  "parent": "652700"
}, {
  "name": "阿拉山口市",
  "value": "652702",
  "parent": "652700"
}, {
  "name": "精河县",
  "value": "652722",
  "parent": "652700"
}, {
  "name": "温泉县",
  "value": "652723",
  "parent": "652700"
}, {
  "name": "库尔勒市",
  "value": "652801",
  "parent": "652800"
}, {
  "name": "轮台县",
  "value": "652822",
  "parent": "652800"
}, {
  "name": "尉犁县",
  "value": "652823",
  "parent": "652800"
}, {
  "name": "若羌县",
  "value": "652824",
  "parent": "652800"
}, {
  "name": "且末县",
  "value": "652825",
  "parent": "652800"
}, {
  "name": "焉耆回族自治县",
  "value": "652826",
  "parent": "652800"
}, {
  "name": "和静县",
  "value": "652827",
  "parent": "652800"
}, {
  "name": "和硕县",
  "value": "652828",
  "parent": "652800"
}, {
  "name": "博湖县",
  "value": "652829",
  "parent": "652800"
}, {
  "name": "阿克苏市",
  "value": "652901",
  "parent": "652900"
}, {
  "name": "温宿县",
  "value": "652922",
  "parent": "652900"
}, {
  "name": "库车县",
  "value": "652923",
  "parent": "652900"
}, {
  "name": "沙雅县",
  "value": "652924",
  "parent": "652900"
}, {
  "name": "新和县",
  "value": "652925",
  "parent": "652900"
}, {
  "name": "拜城县",
  "value": "652926",
  "parent": "652900"
}, {
  "name": "乌什县",
  "value": "652927",
  "parent": "652900"
}, {
  "name": "阿瓦提县",
  "value": "652928",
  "parent": "652900"
}, {
  "name": "柯坪县",
  "value": "652929",
  "parent": "652900"
}, {
  "name": "阿图什市",
  "value": "653001",
  "parent": "653000"
}, {
  "name": "阿克陶县",
  "value": "653022",
  "parent": "653000"
}, {
  "name": "阿合奇县",
  "value": "653023",
  "parent": "653000"
}, {
  "name": "乌恰县",
  "value": "653024",
  "parent": "653000"
}, {
  "name": "喀什市",
  "value": "653101",
  "parent": "653100"
}, {
  "name": "疏附县",
  "value": "653121",
  "parent": "653100"
}, {
  "name": "疏勒县",
  "value": "653122",
  "parent": "653100"
}, {
  "name": "英吉沙县",
  "value": "653123",
  "parent": "653100"
}, {
  "name": "泽普县",
  "value": "653124",
  "parent": "653100"
}, {
  "name": "莎车县",
  "value": "653125",
  "parent": "653100"
}, {
  "name": "叶城县",
  "value": "653126",
  "parent": "653100"
}, {
  "name": "麦盖提县",
  "value": "653127",
  "parent": "653100"
}, {
  "name": "岳普湖县",
  "value": "653128",
  "parent": "653100"
}, {
  "name": "伽师县",
  "value": "653129",
  "parent": "653100"
}, {
  "name": "巴楚县",
  "value": "653130",
  "parent": "653100"
}, {
  "name": "塔什库尔干塔吉克自治县",
  "value": "653131",
  "parent": "653100"
}, {
  "name": "和田市",
  "value": "653201",
  "parent": "653200"
}, {
  "name": "和田县",
  "value": "653221",
  "parent": "653200"
}, {
  "name": "墨玉县",
  "value": "653222",
  "parent": "653200"
}, {
  "name": "皮山县",
  "value": "653223",
  "parent": "653200"
}, {
  "name": "洛浦县",
  "value": "653224",
  "parent": "653200"
}, {
  "name": "策勒县",
  "value": "653225",
  "parent": "653200"
}, {
  "name": "于田县",
  "value": "653226",
  "parent": "653200"
}, {
  "name": "民丰县",
  "value": "653227",
  "parent": "653200"
}, {
  "name": "伊宁市",
  "value": "654002",
  "parent": "654000"
}, {
  "name": "奎屯市",
  "value": "654003",
  "parent": "654000"
}, {
  "name": "霍尔果斯市",
  "value": "654004",
  "parent": "654000"
}, {
  "name": "伊宁县",
  "value": "654021",
  "parent": "654000"
}, {
  "name": "察布查尔锡伯自治县",
  "value": "654022",
  "parent": "654000"
}, {
  "name": "霍城县",
  "value": "654023",
  "parent": "654000"
}, {
  "name": "巩留县",
  "value": "654024",
  "parent": "654000"
}, {
  "name": "新源县",
  "value": "654025",
  "parent": "654000"
}, {
  "name": "昭苏县",
  "value": "654026",
  "parent": "654000"
}, {
  "name": "特克斯县",
  "value": "654027",
  "parent": "654000"
}, {
  "name": "尼勒克县",
  "value": "654028",
  "parent": "654000"
}, {
  "name": "塔城市",
  "value": "654201",
  "parent": "654200"
}, {
  "name": "乌苏市",
  "value": "654202",
  "parent": "654200"
}, {
  "name": "额敏县",
  "value": "654221",
  "parent": "654200"
}, {
  "name": "沙湾县",
  "value": "654223",
  "parent": "654200"
}, {
  "name": "托里县",
  "value": "654224",
  "parent": "654200"
}, {
  "name": "裕民县",
  "value": "654225",
  "parent": "654200"
}, {
  "name": "和布克赛尔蒙古自治县",
  "value": "654226",
  "parent": "654200"
}, {
  "name": "阿勒泰市",
  "value": "654301",
  "parent": "654300"
}, {
  "name": "布尔津县",
  "value": "654321",
  "parent": "654300"
}, {
  "name": "富蕴县",
  "value": "654322",
  "parent": "654300"
}, {
  "name": "福海县",
  "value": "654323",
  "parent": "654300"
}, {
  "name": "哈巴河县",
  "value": "654324",
  "parent": "654300"
}, {
  "name": "青河县",
  "value": "654325",
  "parent": "654300"
}, {
  "name": "吉木乃县",
  "value": "654326",
  "parent": "654300"
}, {
  "name": "台北市",
  "value": "710100",
  "parent": "710000"
}, {
  "name": "高雄市",
  "value": "710200",
  "parent": "710000"
}, {
  "name": "基隆市",
  "value": "710300",
  "parent": "710000"
}, {
  "name": "台中市",
  "value": "710400",
  "parent": "710000"
}, {
  "name": "台南市",
  "value": "710500",
  "parent": "710000"
}, {
  "name": "新竹市",
  "value": "710600",
  "parent": "710000"
}, {
  "name": "嘉义市",
  "value": "710700",
  "parent": "710000"
}, {
  "name": "内湖区",
  "value": "710101",
  "parent": "710100"
}, {
  "name": "南港区",
  "value": "710102",
  "parent": "710100"
}, {
  "name": "中正区",
  "value": "710103",
  "parent": "710100"
}, {
  "name": "松山区",
  "value": "710104",
  "parent": "710100"
}, {
  "name": "信义区",
  "value": "710105",
  "parent": "710100"
}, {
  "name": "大安区",
  "value": "710106",
  "parent": "710100"
}, {
  "name": "中山区",
  "value": "710107",
  "parent": "710100"
}, {
  "name": "文山区",
  "value": "710108",
  "parent": "710100"
}, {
  "name": "大同区",
  "value": "710109",
  "parent": "710100"
}, {
  "name": "万华区",
  "value": "710110",
  "parent": "710100"
}, {
  "name": "士林区",
  "value": "710111",
  "parent": "710100"
}, {
  "name": "北投区",
  "value": "710112",
  "parent": "710100"
}, {
  "name": "新兴区",
  "value": "710201",
  "parent": "710200"
}, {
  "name": "前金区",
  "value": "710202",
  "parent": "710200"
}, {
  "name": "芩雅区",
  "value": "710203",
  "parent": "710200"
}, {
  "name": "盐埕区",
  "value": "710204",
  "parent": "710200"
}, {
  "name": "鼓山区",
  "value": "710205",
  "parent": "710200"
}, {
  "name": "旗津区",
  "value": "710206",
  "parent": "710200"
}, {
  "name": "前镇区",
  "value": "710207",
  "parent": "710200"
}, {
  "name": "三民区",
  "value": "710208",
  "parent": "710200"
}, {
  "name": "左营区",
  "value": "710209",
  "parent": "710200"
}, {
  "name": "楠梓区",
  "value": "710210",
  "parent": "710200"
}, {
  "name": "小港区",
  "value": "710211",
  "parent": "710200"
}, {
  "name": "仁爱区",
  "value": "710301",
  "parent": "710300"
}, {
  "name": "信义区",
  "value": "710302",
  "parent": "710300"
}, {
  "name": "中正区",
  "value": "710303",
  "parent": "710300"
}, {
  "name": "暖暖区",
  "value": "710304",
  "parent": "710300"
}, {
  "name": "安乐区",
  "value": "710305",
  "parent": "710300"
}, {
  "name": "七堵区",
  "value": "710307",
  "parent": "710300"
}, {
  "name": "中区",
  "value": "710301",
  "parent": "710400"
}, {
  "name": "东区",
  "value": "710302",
  "parent": "710400"
}, {
  "name": "南区",
  "value": "710303",
  "parent": "710400"
}, {
  "name": "西区",
  "value": "710304",
  "parent": "710400"
}, {
  "name": "北区",
  "value": "710305",
  "parent": "710400"
}, {
  "name": "北屯区",
  "value": "710306",
  "parent": "710400"
}, {
  "name": "西屯区",
  "value": "710307",
  "parent": "710400"
}, {
  "name": "南屯区",
  "value": "710308",
  "parent": "710400"
}, {
  "name": "中西区",
  "value": "710501",
  "parent": "710500"
}, {
  "name": "东区",
  "value": "710502",
  "parent": "710500"
}, {
  "name": "南区",
  "value": "710503",
  "parent": "710500"
}, {
  "name": "北区",
  "value": "710504",
  "parent": "710500"
}, {
  "name": "安平区",
  "value": "710505",
  "parent": "710500"
}, {
  "name": "安南区",
  "value": "710506",
  "parent": "710500"
}, {
  "name": "东区",
  "value": "710601",
  "parent": "710600"
}, {
  "name": "北区",
  "value": "710602",
  "parent": "710600"
}, {
  "name": "香山区",
  "value": "710603",
  "parent": "710600"
}, {
  "name": "东区",
  "value": "710701",
  "parent": "710700"
}, {
  "name": "西区",
  "value": "710702",
  "parent": "710700"
}, {
  "name": "中西区",
  "value": "810001",
  "parent": "810000"
}, {
  "name": "湾仔区",
  "value": "810002",
  "parent": "810000"
}, {
  "name": "东区",
  "value": "810003",
  "parent": "810000"
}, {
  "name": "南区",
  "value": "810004",
  "parent": "810000"
}, {
  "name": "油尖旺区",
  "value": "810005",
  "parent": "810000"
}, {
  "name": "深水埗区",
  "value": "810006",
  "parent": "810000"
}, {
  "name": "九龙城区",
  "value": "810007",
  "parent": "810000"
}, {
  "name": "黄大仙区",
  "value": "810008",
  "parent": "810000"
}, {
  "name": "观塘区",
  "value": "810009",
  "parent": "810000"
}, {
  "name": "荃湾区",
  "value": "810010",
  "parent": "810000"
}, {
  "name": "屯门区",
  "value": "810011",
  "parent": "810000"
}, {
  "name": "元朗区",
  "value": "810012",
  "parent": "810000"
}, {
  "name": "北区",
  "value": "810013",
  "parent": "810000"
}, {
  "name": "大埔区",
  "value": "810014",
  "parent": "810000"
}, {
  "name": "西贡区",
  "value": "810015",
  "parent": "810000"
}, {
  "name": "沙田区",
  "value": "810016",
  "parent": "810000"
}, {
  "name": "葵青区",
  "value": "810017",
  "parent": "810000"
}, {
  "name": "离岛区",
  "value": "810018",
  "parent": "810000"
}, {
  "name": "花地玛堂区",
  "value": "820001",
  "parent": "820000"
}, {
  "name": "花王堂区",
  "value": "820002",
  "parent": "820000"
}, {
  "name": "望德堂区",
  "value": "820003",
  "parent": "820000"
}, {
  "name": "大堂区",
  "value": "820004",
  "parent": "820000"
}, {
  "name": "风顺堂区",
  "value": "820005",
  "parent": "820000"
}, {
  "name": "嘉模堂区",
  "value": "820006",
  "parent": "820000"
}, {
  "name": "路凼填海区",
  "value": "820007",
  "parent": "820000"
}, {
  "name": "圣方济各堂区",
  "value": "820008",
  "parent": "820000"
}, {
  "name": "--",
  "value": "120200--",
  "parent": "120200"
}, {
  "name": "--",
  "value": "310200--",
  "parent": "310200"
}, {
  "name": "--",
  "value": "419001--",
  "parent": "419001"
}, {
  "name": "--",
  "value": "429004--",
  "parent": "429004"
}, {
  "name": "--",
  "value": "429005--",
  "parent": "429005"
}, {
  "name": "--",
  "value": "429006--",
  "parent": "429006"
}, {
  "name": "--",
  "value": "429021--",
  "parent": "429021"
}, {
  "name": "--",
  "value": "460400--",
  "parent": "460400"
}, {
  "name": "--",
  "value": "469001--",
  "parent": "469001"
}, {
  "name": "--",
  "value": "469002--",
  "parent": "469002"
}, {
  "name": "--",
  "value": "469005--",
  "parent": "469005"
}, {
  "name": "--",
  "value": "469006--",
  "parent": "469006"
}, {
  "name": "--",
  "value": "469007--",
  "parent": "469007"
}, {
  "name": "--",
  "value": "469021--",
  "parent": "469021"
}, {
  "name": "--",
  "value": "469022--",
  "parent": "469022"
}, {
  "name": "--",
  "value": "469023--",
  "parent": "469023"
}, {
  "name": "--",
  "value": "469024--",
  "parent": "469024"
}, {
  "name": "--",
  "value": "469025--",
  "parent": "469025"
}, {
  "name": "--",
  "value": "469026--",
  "parent": "469026"
}, {
  "name": "--",
  "value": "469027--",
  "parent": "469027"
}, {
  "name": "--",
  "value": "469028--",
  "parent": "469028"
}, {
  "name": "--",
  "value": "469029--",
  "parent": "469029"
}, {
  "name": "--",
  "value": "469030--",
  "parent": "469030"
}, {
  "name": "--",
  "value": "500200--",
  "parent": "500200"
}, {
  "name": "--",
  "value": "620200--",
  "parent": "620200"
}, {
  "name": "--",
  "value": "659001--",
  "parent": "659001"
}, {
  "name": "--",
  "value": "659002--",
  "parent": "659002"
}, {
  "name": "--",
  "value": "659003--",
  "parent": "659003"
}, {
  "name": "--",
  "value": "659004--",
  "parent": "659004"
}, {
  "name": "--",
  "value": "659005--",
  "parent": "659005"
}, {
  "name": "--",
  "value": "659006--",
  "parent": "659006"
}, {
  "name": "--",
  "value": "659007--",
  "parent": "659007"
}, {
  "name": "--",
  "value": "659008--",
  "parent": "659008"
}, {
  "name": "--",
  "value": "810001--",
  "parent": "810001"
}, {
  "name": "--",
  "value": "810002--",
  "parent": "810002"
}, {
  "name": "--",
  "value": "810003--",
  "parent": "810003"
}, {
  "name": "--",
  "value": "810004--",
  "parent": "810004"
}, {
  "name": "--",
  "value": "810005--",
  "parent": "810005"
}, {
  "name": "--",
  "value": "810006--",
  "parent": "810006"
}, {
  "name": "--",
  "value": "810007--",
  "parent": "810007"
}, {
  "name": "--",
  "value": "810008--",
  "parent": "810008"
}, {
  "name": "--",
  "value": "810009--",
  "parent": "810009"
}, {
  "name": "--",
  "value": "810010--",
  "parent": "810010"
}, {
  "name": "--",
  "value": "810011--",
  "parent": "810011"
}, {
  "name": "--",
  "value": "810012--",
  "parent": "810012"
}, {
  "name": "--",
  "value": "810013--",
  "parent": "810013"
}, {
  "name": "--",
  "value": "810014--",
  "parent": "810014"
}, {
  "name": "--",
  "value": "810015--",
  "parent": "810015"
}, {
  "name": "--",
  "value": "810016--",
  "parent": "810016"
}, {
  "name": "--",
  "value": "810017--",
  "parent": "810017"
}, {
  "name": "--",
  "value": "810018--",
  "parent": "810018"
}, {
  "name": "--",
  "value": "820001--",
  "parent": "820001"
}, {
  "name": "--",
  "value": "820002--",
  "parent": "820002"
}, {
  "name": "--",
  "value": "820003--",
  "parent": "820003"
}, {
  "name": "--",
  "value": "820004--",
  "parent": "820004"
}, {
  "name": "--",
  "value": "820005--",
  "parent": "820005"
}, {
  "name": "--",
  "value": "820006--",
  "parent": "820006"
}, {
  "name": "--",
  "value": "820007--",
  "parent": "820007"
}, {
  "name": "--",
  "value": "820008--",
  "parent": "820008"
}];

function name2value (name, list) {
  var rs = map(name, function (one, index) {
    var parent = '';
    if (index === 2) {
      // 可能存在区名一样的情况，比如南山区
      parent = find(list, function (item) {
        return item.name === name[1];
      }) || { value: '__' };
      return find(list, function (item) {
        return item.name === one && item.parent === parent.value;
      });
    } else {
      return find(list, function (item) {
        return item.name === one;
      });
    }
  });
  return map(rs, function (one) {
    return one ? one.value : '__';
  }).join(' ');
}

function value2name (value, list) {
  var rs = map(value, function (one, index) {
    return find(list, function (item) {
      return item.value === one;
    });
  });
  return map(rs, function (one) {
    return one ? one.name : '';
  }).join(' ').replace('--', '');
}

var index = {
  name2value: name2value,
  value2name: value2name
};

exports.cvux = cvux;
exports.tools = index;
//# sourceMappingURL=mobile.js.map


/***/ }),

/***/ "mPHm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("gh4x");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("22f0fc75", content, true);

/***/ }),

/***/ "msXi":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("77Pl");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("qkKv"), __esModule: true };

/***/ }),

/***/ "myzo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function isLeapYear(year) {
  return year % 100 !== 0 && year % 4 === 0 || year % 400 === 0;
}

function getMaxDay(year, month) {
  year = parseFloat(year);
  month = parseFloat(month);
  if (month === 2) {
    return isLeapYear(year) ? 29 : 28;
  }
  return [4, 6, 9, 11].indexOf(month) >= 0 ? 30 : 31;
}

function getYears(startDate, endDate) {
  var startYear = startDate.getFullYear();
  var endYear = endDate.getFullYear();
  var rs = [];
  while (startYear <= endYear) {
    rs.push(startYear);
    startYear++;
  }
  return {
    minYear: rs[0],
    maxYear: rs[rs.length - 1]
  };
}

function getMonths(startDate, endDate, year) {
  var startYear = startDate.getFullYear();
  var endYear = endDate.getFullYear();
  var startMonth = startDate.getMonth() + 1;
  var endMonth = endDate.getMonth() + 1;
  var start = 1;
  var end = 12;
  if (year === startYear) {
    start = startMonth;
  }
  if (year === endYear) {
    end = endMonth;
  }
  return {
    minMonth: start,
    maxMonth: end
  };
}

function getDays(startDate, endDate, year, month) {
  var startYear = startDate.getFullYear();
  var endYear = endDate.getFullYear();
  var startMonth = startDate.getMonth() + 1;
  var endMonth = endDate.getMonth() + 1;
  var startDay = startDate.getDate();
  var endDay = endDate.getDate();

  var start = 1;
  var end = getMaxDay(year, month);

  if (year === startYear && month === startMonth) {
    start = startDay;
  }
  if (year === endYear && month === endMonth) {
    end = endDay;
  }
  return {
    minDay: start,
    maxDay: end
  };
}

exports.getYears = getYears;
exports.getMonths = getMonths;
exports.getDays = getDays;

/***/ }),

/***/ "n0T6":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("Ibhu");
var hiddenKeys = __webpack_require__("xnc9").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "n3MF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-center,.vux-center-h,.vux-center-v{display:flex}.vux-center,.vux-center-v{align-items:center}.vux-center,.vux-center-h{justify-content:center}", ""]);

// exports


/***/ }),

/***/ "nFV1":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_progress"
  }, [_c('div', {
    staticClass: "weui_progress_bar"
  }, [_c('div', {
    staticClass: "weui_progress_inner_bar",
    style: ({
      width: _vm.percent + '%'
    })
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCancel),
      expression: "showCancel"
    }],
    staticClass: "weui_progress_opr",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "weui_icon_cancel",
    on: {
      "click": _vm.cancel
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ "nNlF":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("POu9")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("WOkT"),
  /* template */
  __webpack_require__("78dt"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "nPpt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (array) {
  return array.length === 1 ? array[0] : array.join(' ');
};

/***/ }),

/***/ "neo6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "ng6w":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4w7B");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2d91c66c", content, true);

/***/ }),

/***/ "nhh6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-fade-transition{opacity:1;transition:opacity .2s linear}.vux-fade-enter,.vux-fade-leave{opacity:0}.vux-dialog-transition{opacity:1;transition-duration:.4s;-webkit-transform:translate(-50%,-50%) scale(1)!important;transform:translate(-50%,-50%) scale(1)!important;transition-property:opacity,-webkit-transform!important;transition-property:transform,opacity!important;transition-property:transform,opacity,-webkit-transform!important}.vux-dialog-enter,.vux-dialog-leave{opacity:0}.vux-dialog-enter{-webkit-transform:translate(-50%,-50%) scale(1.185)!important;transform:translate(-50%,-50%) scale(1.185)!important}.vux-dialog-leave{-webkit-transform:translate(-50%,-50%) scale(1)!important;transform:translate(-50%,-50%) scale(1)!important}.weui-mask{background:rgba(0,0,0,.6)}.weui-mask,.weui-mask_transparent{position:fixed;z-index:1000;top:0;right:0;left:0;bottom:0}.weui_mask{z-index:1000;background:rgba(0,0,0,.6)}.weui_mask,.weui_mask_transparent{position:fixed;width:100%;height:100%;top:0;left:0}.weui_mask_transparent{z-index:5001}.weui_mask_transition{display:none;position:fixed;z-index:1000;width:100%;height:100%;top:0;left:0;background:transparent;transition:background .3s}.weui_fade_toggle{background:rgba(0,0,0,.6)}@font-face{font-weight:400;font-style:normal;font-family:weui;src:url(\"data:application/octet-stream;base64,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\") format(\"truetype\")}[class*=\" weui_icon_\"]:before,[class^=weui_icon_]:before{font-family:weui;font-style:normal;font-weight:400;speak:none;display:inline-block;vertical-align:middle;text-decoration:inherit;width:1em;margin-right:.56rem;text-align:center;font-variant:normal;text-transform:none;line-height:1;margin-left:.2rem}.weui_icon_circle:before{content:\"\\EA01\"}.weui_icon_download:before{content:\"\\EA02\"}.weui_icon_info:before{content:\"\\EA03\"}.weui_icon_safe_success:before{content:\"\\EA04\"}.weui_icon_safe_warn:before{content:\"\\EA05\"}.weui_icon_success:before{content:\"\\EA06\"}.weui_icon_success_circle:before{content:\"\\EA07\"}.weui_icon_success_no_circle:before{content:\"\\EA08\"}.weui_icon_waiting:before{content:\"\\EA09\"}.weui_icon_waiting_circle:before{content:\"\\EA0A\"}.weui_icon_warn:before{content:\"\\EA0B\"}.weui_icon_info_circle:before{content:\"\\EA0C\"}.weui_icon_cancel:before{content:\"\\EA0D\"}.weui_icon_search:before{content:\"\\EA0E\"}.weui_icon_clear:before{content:\"\\EA0F\"}[class*=\" weui_icon_\"]:before,[class^=weui_icon_]:before{margin:0}.weui_icon_success:before{font-size:.61333333rem;color:#09bb07}.weui_icon_waiting:before{font-size:.61333333rem;color:#10aeff}.weui_icon_warn:before{font-size:.61333333rem;color:#f43530}.weui_icon_info:before{font-size:.61333333rem;color:#10aeff}.weui_icon_success_circle:before,.weui_icon_success_no_circle:before{font-size:.61333333rem;color:#09bb07}.weui_icon_waiting_circle:before{font-size:.48rem;color:#10aeff}.weui_icon_circle:before{font-size:.48rem;color:#c9c9c9}.weui_icon_download:before,.weui_icon_info_circle:before{font-size:.48rem;color:#09bb07}.weui_icon_safe_success:before{color:#09bb07}.weui_icon_safe_warn:before{color:#ffbe00}.weui_icon_cancel:before{color:#f43530;font-size:.58666667rem}.weui_icon_clear:before,.weui_icon_search:before{color:#b2b2b2;font-size:.37333333rem}.weui_icon_msg:before{font-size:2.77333333rem}.weui_icon_warn.weui_icon_msg:before{color:#f76260}.weui_icon_safe:before{font-size:2.77333333rem}.weui_toast{position:fixed;z-index:50000;width:3.25333333rem;min-height:3.25333333rem;top:4.8rem;left:50%;margin-left:-.81333333rem;background:rgba(40,40,40,.75);text-align:center;border-radius:5px;color:#fff}.weui_icon_toast{margin:.58666667rem 0 0;display:block}.weui_icon_toast:before{content:\"\\EA08\";color:#fff;font-size:1.46666667rem}.weui_toast_content{margin:0 0 .4rem}.weui_loading_toast .weui_toast_content{margin-top:64%;font-size:.37333333rem}.weui_loading{position:absolute;width:0;z-index:1;left:50%;top:38%}.weui_toast{-webkit-transform:translateX(-50%);transform:translateX(-50%);margin-left:0!important}.weui_toast_forbidden{color:#f76260}.weui_toast.weui_toast_text{min-height:0}.weui_toast_text .weui_toast_content{margin:0;padding-top:.26666667rem;padding-bottom:.26666667rem;border-radius:.4rem}.weui_toast_success .weui_icon_toast:before{content:\"\\EA08\"}.weui_toast_cancel .weui_icon_toast:before{content:\"\\EA0D\"}.weui_toast_forbidden .weui_icon_toast:before{content:\"\\EA0B\";color:#f76260}", ""]);

// exports


/***/ }),

/***/ "nnTn":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("I1r6")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("6WL6"),
  /* template */
  __webpack_require__("HjgP"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "nsQR":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("iCsi")

var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  __webpack_require__("3PEC"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ntOx":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("khXJ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3d6e2cdb", content, true);

/***/ }),

/***/ "nvcE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tip = __webpack_require__("kFvY");

var _tip2 = _interopRequireDefault(_tip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_tip2.default.install = function (Vue) {
  Vue.component('LxTip', _tip2.default);
};

exports.default = _tip2.default;

/***/ }),

/***/ "nwxr":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("CO1h");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("dde55b54", content, true);

/***/ }),

/***/ "o3S7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    disabled: Boolean
  },
  computed: {
    classNames: function classNames() {
      var names = {
        'vux-tap-active': !this.disabled
      };
      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }
      if (this.$parent.selectedItemClass) {
        names[this.$parent.selectedItemClass] = this.$parent.type === 'radio' ? this.$parent.currentValue === this.value : this.$parent.currentValue.indexOf(this.value) > -1;
      }
      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }
      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        this.$set(this.$parent, 'currentValue', this.value);
        this.$emit('on-item-click', this.value, this.disabled);
      }
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.disabled) {
        var index = this.$parent.currentValue.indexOf(this.value);
        if (index > -1) {
          this.$parent.value.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue.length < this.$parent.max) {
            this.$parent.currentValue.push(this.value);
          }
        }
        this.$emit('on-item-click', this.value, this.disabled);
      }
    }
  }
};

/***/ }),

/***/ "o5lu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scroller = __webpack_require__("bRpw");

var _scroller2 = _interopRequireDefault(_scroller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_scroller2.default.install = function (Vue) {
  Vue.component('LxScroller', _scroller2.default);
};

exports.default = _scroller2.default;

/***/ }),

/***/ "oCxr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loading = __webpack_require__("jlVh");

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_loading2.default.install = function (Vue) {
  Vue.component('LxLoading', _loading2.default);
};

exports.default = _loading2.default;

/***/ }),

/***/ "oGHZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKbp":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ssAp"),
  /* template */
  __webpack_require__("bdnq"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "oRv6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (el, icon) {
  if (isServer) return;
  var spinnerName, anim;
  spinnerName = icon;
  var container = document.createElement('div');
  createSvgElement('svg', {
    viewBox: '0 0 64 64',
    g: [spinners[spinnerName]]
  }, container, spinnerName);

  el.innerHTML = container.innerHTML;
  start();
  function start() {
    if (animations[spinnerName]) {
      anim = animations[spinnerName](el)();
    }
  }
  return el;
};

__webpack_require__("xULZ");

var isServer = typeof window === 'undefined';
var TRANSLATE32 = 'translate(32,32)';
var STROKE_OPACITY = 'stroke-opacity';
var ROUND = 'round';
var INDEFINITE = 'indefinite';
var DURATION = '750ms';
var NONE = 'none';
var SHORTCUTS = {
  a: 'animate',
  an: 'attributeName',
  at: 'animateTransform',
  c: 'circle',
  da: 'stroke-dasharray',
  os: 'stroke-dashoffset',
  f: 'fill',
  lc: 'stroke-linecap',
  rc: 'repeatCount',
  sw: 'stroke-width',
  t: 'transform',
  v: 'values'
};

var SPIN_ANIMATION = {
  v: '0,32,32;360,32,32',
  an: 'transform',
  type: 'rotate',
  rc: INDEFINITE,
  dur: DURATION
};

function createSvgElement(tagName, data, parent, spinnerName) {
  if (isServer) return;
  var ele = document.createElement(SHORTCUTS[tagName] || tagName);
  var k, x, y;

  for (k in data) {
    if (Object.prototype.toString.call(data[k]) === '[object Array]') {
      for (x = 0; x < data[k].length; x++) {
        if (data[k][x].fn) {
          for (y = 0; y < data[k][x].t; y++) {
            createSvgElement(k, data[k][x].fn(y, spinnerName), ele, spinnerName);
          }
        } else {
          createSvgElement(k, data[k][x], ele, spinnerName);
        }
      }
    } else {
      setSvgAttribute(ele, k, data[k]);
    }
  }

  parent.appendChild(ele);
}

function setSvgAttribute(ele, k, v) {
  ele.setAttribute(SHORTCUTS[k] || k, v);
}

function animationValues(strValues, i) {
  var values = strValues.split(';');
  var back = values.slice(i);
  var front = values.slice(0, values.length - back.length);
  values = back.concat(front).reverse();
  return values.join(';') + ';' + values[0];
}

var IOS_SPINNER = {
  sw: 4,
  lc: ROUND,
  line: [{
    fn: function fn(i, spinnerName) {
      return {
        y1: spinnerName === 'ios' ? 17 : 12,
        y2: spinnerName === 'ios' ? 29 : 20,
        t: TRANSLATE32 + ' rotate(' + (30 * i + (i < 6 ? 180 : -180)) + ')',
        a: [{
          fn: function fn() {
            return {
              an: STROKE_OPACITY,
              dur: DURATION,
              v: animationValues('0;.1;.15;.25;.35;.45;.55;.65;.7;.85;1', i),
              rc: INDEFINITE
            };
          },

          t: 1
        }]
      };
    },

    t: 12
  }]
};

var spinners = {

  android: {
    c: [{
      sw: 6,
      da: 128,
      os: 82,
      r: 26,
      cx: 32,
      cy: 32,
      f: NONE
    }]
  },

  ios: IOS_SPINNER,

  'ios-small': IOS_SPINNER,

  bubbles: {
    sw: 0,
    c: [{
      fn: function fn(i) {
        return {
          cx: 24 * Math.cos(2 * Math.PI * i / 8),
          cy: 24 * Math.sin(2 * Math.PI * i / 8),
          t: TRANSLATE32,
          a: [{
            fn: function fn() {
              return {
                an: 'r',
                dur: DURATION,
                v: animationValues('1;2;3;4;5;6;7;8', i),
                rc: INDEFINITE
              };
            },

            t: 1
          }]
        };
      },

      t: 8
    }]
  },

  circles: {

    c: [{
      fn: function fn(i) {
        return {
          r: 5,
          cx: 24 * Math.cos(2 * Math.PI * i / 8),
          cy: 24 * Math.sin(2 * Math.PI * i / 8),
          t: TRANSLATE32,
          sw: 0,
          a: [{
            fn: function fn() {
              return {
                an: 'fill-opacity',
                dur: DURATION,
                v: animationValues('.3;.3;.3;.4;.7;.85;.9;1', i),
                rc: INDEFINITE
              };
            },

            t: 1
          }]
        };
      },

      t: 8
    }]
  },

  crescent: {
    c: [{
      sw: 4,
      da: 128,
      os: 82,
      r: 26,
      cx: 32,
      cy: 32,
      f: NONE,
      at: [SPIN_ANIMATION]
    }]
  },

  dots: {

    c: [{
      fn: function fn(i) {
        return {
          cx: 16 + 16 * i,
          cy: 32,
          sw: 0,
          a: [{
            fn: function fn() {
              return {
                an: 'fill-opacity',
                dur: DURATION,
                v: animationValues('.5;.6;.8;1;.8;.6;.5', i),
                rc: INDEFINITE
              };
            },

            t: 1
          }, {
            fn: function fn() {
              return {
                an: 'r',
                dur: DURATION,
                v: animationValues('4;5;6;5;4;3;3', i),
                rc: INDEFINITE
              };
            },

            t: 1
          }]
        };
      },

      t: 3
    }]
  },

  lines: {
    sw: 7,
    lc: ROUND,
    line: [{
      fn: function fn(i) {
        return {
          x1: 10 + i * 14,
          x2: 10 + i * 14,
          a: [{
            fn: function fn() {
              return {
                an: 'y1',
                dur: DURATION,
                v: animationValues('16;18;28;18;16', i),
                rc: INDEFINITE
              };
            },

            t: 1
          }, {
            fn: function fn() {
              return {
                an: 'y2',
                dur: DURATION,
                v: animationValues('48;44;36;46;48', i),
                rc: INDEFINITE
              };
            },

            t: 1
          }, {
            fn: function fn() {
              return {
                an: STROKE_OPACITY,
                dur: DURATION,
                v: animationValues('1;.8;.5;.4;1', i),
                rc: INDEFINITE
              };
            },

            t: 1
          }]
        };
      },

      t: 4
    }]
  },

  ripple: {
    f: NONE,
    'fill-rule': 'evenodd',
    sw: 3,
    circle: [{
      fn: function fn(i) {
        return {
          cx: 32,
          cy: 32,
          a: [{
            fn: function fn() {
              return {
                an: 'r',
                begin: i * -1 + 's',
                dur: '2s',
                v: '0;24',
                keyTimes: '0;1',
                keySplines: '0.1,0.2,0.3,1',
                calcMode: 'spline',
                rc: INDEFINITE
              };
            },

            t: 1
          }, {
            fn: function fn() {
              return {
                an: STROKE_OPACITY,
                begin: i * -1 + 's',
                dur: '2s',
                v: '.2;1;.2;0',
                rc: INDEFINITE
              };
            },

            t: 1
          }]
        };
      },

      t: 2
    }]
  },

  spiral: {
    defs: [{
      linearGradient: [{
        id: 'sGD',
        gradientUnits: 'userSpaceOnUse',
        x1: 55,
        y1: 46,
        x2: 2,
        y2: 46,
        stop: [{
          offset: 0.1,
          class: 'stop1'
        }, {
          offset: 1,
          class: 'stop2'
        }]
      }]
    }],
    g: [{
      sw: 4,
      lc: ROUND,
      f: NONE,
      path: [{
        stroke: 'url(#sGD)',
        d: 'M4,32 c0,15,12,28,28,28c8,0,16-4,21-9'
      }, {
        d: 'M60,32 C60,16,47.464,4,32,4S4,16,4,32'
      }],
      at: [SPIN_ANIMATION]
    }]
  }

};

var animations = {
  android: function android(ele) {
    var self = this;

    this.stop = false;

    var rIndex = 0;
    var rotateCircle = 0;
    var startTime;
    var svgEle = ele.querySelector('g');
    var circleEle = ele.querySelector('circle');

    function run() {
      if (isServer) return;
      if (self.stop) return;

      var v = easeInOutCubic(Date.now() - startTime, 650);
      var scaleX = 1;
      var translateX = 0;
      var dasharray = 188 - 58 * v;
      var dashoffset = 182 - 182 * v;

      if (rIndex % 2) {
        scaleX = -1;
        translateX = -64;
        dasharray = 128 - -58 * v;
        dashoffset = 182 * v;
      }

      var rotateLine = [0, -101, -90, -11, -180, 79, -270, -191][rIndex];

      setSvgAttribute(circleEle, 'da', Math.max(Math.min(dasharray, 188), 128));
      setSvgAttribute(circleEle, 'os', Math.max(Math.min(dashoffset, 182), 0));
      setSvgAttribute(circleEle, 't', 'scale(' + scaleX + ',1) translate(' + translateX + ',0) rotate(' + rotateLine + ',32,32)');

      rotateCircle += 4.1;
      if (rotateCircle > 359) rotateCircle = 0;
      setSvgAttribute(svgEle, 't', 'rotate(' + rotateCircle + ',32,32)');

      if (v >= 1) {
        rIndex++;
        if (rIndex > 7) rIndex = 0;
        startTime = Date.now();
      }

      window.requestAnimationFrame(run);
    }

    return function () {
      startTime = Date.now();
      run();
      return self;
    };
  }
};

function easeInOutCubic(t, c) {
  t /= c / 2;
  if (t < 1) return 1 / 2 * t * t * t;
  t -= 2;
  return 1 / 2 * (t * t * t + 2);
}

/***/ }),

/***/ "omWz":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("K6xk")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("dnAt"),
  /* template */
  __webpack_require__("rllK"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "omrE":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("czWR")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("h06R"),
  /* template */
  __webpack_require__("e05S"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ooks":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popup = __webpack_require__("P2UH");

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_popup2.default.install = function (Vue) {
  Vue.component('LxPopup', _popup2.default);
};

exports.default = _popup2.default;

/***/ }),

/***/ "p/vT":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-slider",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "vux-swiper",
    style: ({
      height: _vm.xheight
    })
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "vux-swiper-item",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          _vm.clickListItem(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('div', {
      staticClass: "vux-img",
      style: ({
        backgroundImage: _vm.buildBackgroundUrl(item[_vm.imgKey])
      })
    }), _vm._v(" "), (_vm.showDescMask) ? _c('p', {
      staticClass: "vux-swiper-desc"
    }, [_vm._v(_vm._s(item[_vm.titleKey]))]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDots),
      expression: "showDots"
    }],
    class: [_vm.dotsClass, 'vux-indicator', 'vux-indicator-' + _vm.dotsPosition]
  }, _vm._l((_vm.length), function(key) {
    return _c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('i', {
      staticClass: "vux-icon-dot",
      class: {
        'active': key === _vm.current + 1
      }
    })])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ "p/yB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("BzPr");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    XDialog: _xDialog2.default
  },
  props: {
    value: {
      type: Boolean,
      defalut: false
    },
    title: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: 'confirm'
    },
    cancelText: {
      type: String,
      default: 'cancel'
    },
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    }
  },
  methods: {
    onConfirm: function onConfirm() {
      this.show = false;
      this.$emit('on-confirm');
    },
    onCancel: function onCancel() {
      this.show = false;
      this.$emit('on-cancel');
    }
  },
  mounted: function mounted() {
    this.show = this.value;
  },
  data: function data() {
    return {
      show: false
    };
  },

  watch: {
    show: function show(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.show !== val) {
        this.show = val;
      }
    }
  }
};

/***/ }),

/***/ "pCng":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{line-height:1.6;font-family:Helvetica Neue,Helvetica,microsoft yahei,Arial,sans-serif}*{margin:0;padding:0}a img{border:0}a{text-decoration:none}", ""]);

// exports


/***/ }),

/***/ "pDJT":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui_cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);left:.4rem}.weui_cell:first-child:before{display:none}.weui_cells{background-color:#fff;line-height:2.26666667;font-size:.4rem;overflow:hidden;position:relative}.weui_cells:before{top:0;border-top:1px solid #d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells:after,.weui_cells:before{content:\" \";position:absolute;left:0;width:100%;height:1px;color:#d9d9d9}.weui_cells:after{bottom:0;border-bottom:1px solid #d9d9d9;-webkit-transform-origin:0 100%;transform-origin:0 100%;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui_cells_title{padding-top:.4rem;padding-left:.4rem;padding-right:.4rem;color:#000;font-size:.34666667rem;line-height:.8rem;opacity:.7}.weui_cells_title+.weui_cells{margin-top:0}.weui_cells_tips{margin-top:.3em;color:#000;padding-left:.4rem;padding-right:.4rem;font-size:.34666667rem}.weui_cell{padding:.26666667rem .4rem;position:relative;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.weui_cell_ft{text-align:left;color:#666}.weui_cell_primary{-webkit-flex:1;flex:1}.weui_cell_hd img{width:.8rem;margin-right:.4rem}.weui_cell_hd span{font-size:.37333333rem}.weui_cell_flexStar{-webkit-align-items:flex-star;align-items:flex-star}.search_input{background-color:#eee;padding:.26666667rem .4rem;font-size:15px;border-radius:.05333333rem}.search_input .weui_cell{background-color:#fff}.search_input .weui_input{line-height:.66666667rem}.search_input .weui_cell{padding:.2rem .4rem}.search_input .search_icon{width:.53333333rem;margin-bottom:-.13333333rem;margin-left:.13333333rem}", ""]);

// exports


/***/ }),

/***/ "pFYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "pNBO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("D8b5");

var _index2 = _interopRequireDefault(_index);

var _radio = __webpack_require__("Atmb");

var _radio2 = _interopRequireDefault(_radio);

var _xInput = __webpack_require__("uk4t");

var _xInput2 = _interopRequireDefault(_xInput);

var _xNumber = __webpack_require__("We/D");

var _xNumber2 = _interopRequireDefault(_xNumber);

var _cell = __webpack_require__("0juH");

var _cell2 = _interopRequireDefault(_cell);

var _inlineDesc = __webpack_require__("hc1C");

var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

var _checklist = __webpack_require__("j9Fw");

var _checklist2 = _interopRequireDefault(_checklist);

var _xSwitch = __webpack_require__("lYBz");

var _xSwitch2 = _interopRequireDefault(_xSwitch);

var _xTextarea = __webpack_require__("0oNg");

var _xTextarea2 = _interopRequireDefault(_xTextarea);

var _group = __webpack_require__("LRgB");

var _group2 = _interopRequireDefault(_group);

var _groupTitle = __webpack_require__("pszS");

var _groupTitle2 = _interopRequireDefault(_groupTitle);

var _box = __webpack_require__("MjVu");

var _box2 = _interopRequireDefault(_box);

var _tip = __webpack_require__("nvcE");

var _tip2 = _interopRequireDefault(_tip);

var _selector = __webpack_require__("uTeD");

var _selector2 = _interopRequireDefault(_selector);

var _xButton = __webpack_require__("O+Sz");

var _xButton2 = _interopRequireDefault(_xButton);

var _swiper = __webpack_require__("hetT");

var _swiper2 = _interopRequireDefault(_swiper);

var _swiperItem = __webpack_require__("zynq");

var _swiperItem2 = _interopRequireDefault(_swiperItem);

var _sticky = __webpack_require__("knUv");

var _sticky2 = _interopRequireDefault(_sticky);

var _picker = __webpack_require__("aDd6");

var _picker2 = _interopRequireDefault(_picker);

var _datetime = __webpack_require__("sj7C");

var _datetime2 = _interopRequireDefault(_datetime);

var _popup = __webpack_require__("ooks");

var _popup2 = _interopRequireDefault(_popup);

var _actionsheet = __webpack_require__("VoyQ");

var _actionsheet2 = _interopRequireDefault(_actionsheet);

var _clocker = __webpack_require__("UVJq");

var _clocker2 = _interopRequireDefault(_clocker);

var _popupPicker = __webpack_require__("SNea");

var _popupPicker2 = _interopRequireDefault(_popupPicker);

var _xAddress = __webpack_require__("QAu5");

var _xAddress2 = _interopRequireDefault(_xAddress);

var _toast = __webpack_require__("EzvB");

var _toast2 = _interopRequireDefault(_toast);

var _loading = __webpack_require__("oCxr");

var _loading2 = _interopRequireDefault(_loading);

var _xAlert = __webpack_require__("I9ad");

var _xAlert2 = _interopRequireDefault(_xAlert);

var _confirm = __webpack_require__("wB4O");

var _confirm2 = _interopRequireDefault(_confirm);

var _xProgress = __webpack_require__("vj+x");

var _xProgress2 = _interopRequireDefault(_xProgress);

var _spinner = __webpack_require__("TmAB");

var _spinner2 = _interopRequireDefault(_spinner);

var _calendar = __webpack_require__("yNag");

var _calendar2 = _interopRequireDefault(_calendar);

var _icon = __webpack_require__("6O5g");

var _icon2 = _interopRequireDefault(_icon);

var _colorPicker = __webpack_require__("AoOK");

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _divider = __webpack_require__("Ht/C");

var _divider2 = _interopRequireDefault(_divider);

var _countup = __webpack_require__("ABbd");

var _countup2 = _interopRequireDefault(_countup);

var _scroller = __webpack_require__("o5lu");

var _scroller2 = _interopRequireDefault(_scroller);

var _shake = __webpack_require__("g4ZZ");

var _shake2 = _interopRequireDefault(_shake);

var _search = __webpack_require__("YUPw");

var _search2 = _interopRequireDefault(_search);

var _format = __webpack_require__("YWpz");

var _format2 = _interopRequireDefault(_format);

var _masker = __webpack_require__("GjZm");

var _masker2 = _interopRequireDefault(_masker);

var _countdown = __webpack_require__("EbfE");

var _countdown2 = _interopRequireDefault(_countdown);

var _friendlyTime = __webpack_require__("PQj0");

var _friendlyTime2 = _interopRequireDefault(_friendlyTime);

var _xHeader = __webpack_require__("PHL5");

var _xHeader2 = _interopRequireDefault(_xHeader);

var _panel = __webpack_require__("OesP");

var _panel2 = _interopRequireDefault(_panel);

var _inlineCalendar = __webpack_require__("iys0");

var _inlineCalendar2 = _interopRequireDefault(_inlineCalendar);

var _badge = __webpack_require__("vjrk");

var _badge2 = _interopRequireDefault(_badge);

var _xDialog = __webpack_require__("BzPr");

var _xDialog2 = _interopRequireDefault(_xDialog);

var _card = __webpack_require__("0PLs");

var _card2 = _interopRequireDefault(_card);

var _previewer = __webpack_require__("Plik");

var _previewer2 = _interopRequireDefault(_previewer);

var _numberRoller = __webpack_require__("aoRB");

var _numberRoller2 = _interopRequireDefault(_numberRoller);

var _viewBox = __webpack_require__("MME6");

var _viewBox2 = _interopRequireDefault(_viewBox);

var _verifyCode = __webpack_require__("WuYj");

var _verifyCode2 = _interopRequireDefault(_verifyCode);

var _buttonTab = __webpack_require__("tIc8");

var _buttonTab2 = _interopRequireDefault(_buttonTab);

var _buttonTabItem = __webpack_require__("B/Q7");

var _buttonTabItem2 = _interopRequireDefault(_buttonTabItem);

var _checker = __webpack_require__("U1wk");

var _checker2 = _interopRequireDefault(_checker);

var _checkerItem = __webpack_require__("yZwH");

var _checkerItem2 = _interopRequireDefault(_checkerItem);

var _flexbox = __webpack_require__("MeU4");

var _flexbox2 = _interopRequireDefault(_flexbox);

var _flexboxItem = __webpack_require__("0/UE");

var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

var _tabbar = __webpack_require__("X/SP");

var _tabbar2 = _interopRequireDefault(_tabbar);

var _tabbarItem = __webpack_require__("7RVF");

var _tabbarItem2 = _interopRequireDefault(_tabbarItem);

var _tab = __webpack_require__("TDUU");

var _tab2 = _interopRequireDefault(_tab);

var _tabItem = __webpack_require__("Rxl4");

var _tabItem2 = _interopRequireDefault(_tabItem);

var _keyboard = __webpack_require__("fDWL");

var _keyboard2 = _interopRequireDefault(_keyboard);

var _selectorList = __webpack_require__("42BS");

var _selectorList2 = _interopRequireDefault(_selectorList);

var _steps = __webpack_require__("P8xc");

var _steps2 = _interopRequireDefault(_steps);

var _checkIcon = __webpack_require__("v04r");

var _checkIcon2 = _interopRequireDefault(_checkIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cvux = {
  Radio: _radio2.default,
  Group: _group2.default,

  XInput: _xInput2.default,
  GroupTitle: _groupTitle2.default,
  XNumber: _xNumber2.default,
  Checklist: _checklist2.default,

  XSwitch: _xSwitch2.default,
  Box: _box2.default,
  Tip: _tip2.default,
  Selector: _selector2.default,
  SelectorList: _selectorList2.default,
  Steps: _steps2.default,
  Cell: _cell2.default,
  InlineDesc: _inlineDesc2.default,
  XButton: _xButton2.default,
  XTextarea: _xTextarea2.default,
  Flexbox: _flexbox2.default,
  FlexboxItem: _flexboxItem2.default,
  Tab: _tab2.default,
  TabItem: _tabItem2.default,
  Swiper: _swiper2.default,
  SwiperItem: _swiperItem2.default,
  Sticky: _sticky2.default,
  Picker: _picker2.default,
  Datetime: _datetime2.default,
  Popup: _popup2.default,

  Actionsheet: _actionsheet2.default,
  Clocker: _clocker2.default,

  PopupPicker: _popupPicker2.default,
  XAddress: _xAddress2.default,
  Toast: _toast2.default,
  Loading: _loading2.default,
  XAlert: _xAlert2.default,
  Confirm: _confirm2.default,
  XProgress: _xProgress2.default,

  Spinner: _spinner2.default,
  Calendar: _calendar2.default,
  Icon: _icon2.default,

  ColorPicker: _colorPicker2.default,
  Divider: _divider2.default,

  Countup: _countup2.default,
  Scroller: _scroller2.default,
  Shake: _shake2.default,
  Search: _search2.default,
  DateFormatter: _format2.default,
  Masker: _masker2.default,
  Countdown: _countdown2.default,
  FriendlyTime: _friendlyTime2.default,
  XHeader: _xHeader2.default,
  Checker: _checker2.default,
  CheckerItem: _checkerItem2.default,

  Tabbar: _tabbar2.default,
  TabbarItem: _tabbarItem2.default,
  Panel: _panel2.default,
  ButtonTab: _buttonTab2.default,
  ButtonTabItem: _buttonTabItem2.default,
  InlineCalendar: _inlineCalendar2.default,
  Badge: _badge2.default,
  XDialog: _xDialog2.default,
  Card: _card2.default,
  Previewer: _previewer2.default,
  NumberRoller: _numberRoller2.default,
  ViewBox: _viewBox2.default,
  VerifyCode: _verifyCode2.default,
  Keyboard: _keyboard2.default,
  CheckIcon: _checkIcon2.default
};

cvux.install = function (Vue) {
  for (var component in cvux) {
    if (component === 'install') return;
    console.log('component name: ', component);
    Vue.component('Lx' + component, cvux[component]);
  }
};

module.exports = cvux;

module.exports.default = module.exports;

/***/ }),

/***/ "pVtq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLabels = exports.getLabel = exports.getInlineDesc = exports.getKey = exports.getValue = undefined;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValue = exports.getValue = function getValue(item) {
  return (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' ? item.value : item;
};

var getKey = exports.getKey = function getKey(item) {
  return (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' ? item.key : item;
};

var getInlineDesc = exports.getInlineDesc = function getInlineDesc(item) {
  return (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' ? item.inlineDesc : '';
};

var getLabel = exports.getLabel = function getLabel() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments[1];

  if (!list.length) {
    return value;
  }
  if (typeof list[0] === 'string') {
    return value;
  }
  var match = list.filter(function (one) {
    return one.key === value;
  });
  if (match.length) {
    return match[0].value || match[0].label;
  }
  return value;
};

var getLabels = exports.getLabels = function getLabels() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return values.map(function (value) {
    return getLabel(list, value);
  });
};

/***/ }),

/***/ "pszS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _groupTitle = __webpack_require__("xNwy");

var _groupTitle2 = _interopRequireDefault(_groupTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_groupTitle2.default.install = function (Vue) {
  Vue.component('LxGroupTitle', _groupTitle2.default);
};

exports.default = _groupTitle2.default;

/***/ }),

/***/ "pzLd":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("zQ+c")

var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  __webpack_require__("U2OI"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "q+df":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("APE8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("42c361fc", content, true);

/***/ }),

/***/ "q3JJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/**
 * mixin 全局的 toast
 */

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    showToast: function showToast(text) {
      this.$store.dispatch('UPDATE_TOAST', {
        show: true,
        text: text,
        time: 1000
      });
    },
    switchLoading: function switchLoading(loading) {
      this.$store.dispatch('UPDATE_LOADING', {
        status: loading.status || false,
        text: loading.text || '',
        time: loading.time || 0
      });
    }
  }
});

/***/ }),

/***/ "qARP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("lOnJ");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "qXpI":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selector-list"
  }, [_c('div', {
    staticClass: "search_input"
  }, [_c('div', {
    staticClass: "vux-x-input weui_cell"
  }, [_c('div', {
    staticClass: "weui_cell_hd"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    staticClass: "weui_input",
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }, _vm.inputSearch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_ft",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.valueSearch($event)
      }
    }
  }, [_c('img', {
    staticClass: "search_icon",
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "weui_cells_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.roleNew.length > 0) ? _c('div', {
    staticClass: "weui_cells"
  }, _vm._l((_vm.roleNew), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "weui_cell vux-tap-active",
      on: {
        "click": function($event) {
          _vm.checkItem(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "weui_cell_hd"
    }), _vm._v(" "), _c('div', {
      staticClass: "weui_cell_bd weui_cell_primary"
    }, [_c('p', [_vm._v(_vm._s(item[_vm.nameKey]))]), _vm._v(" "), _c('span', {
      staticClass: "vux-label-desc"
    }, [_vm._v(_vm._s(item[_vm.roleKey]))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "radio",
        "name": "selectorradio"
      },
      domProps: {
        "checked": item.ischecked
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "check_item_icon"
    })])])
  })) : _c('div', {
    staticClass: "no-record"
  }, [_vm._v("\n    没有相关记录\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ "qio6":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var anObject = __webpack_require__("77Pl");
var getKeys = __webpack_require__("lktj");

module.exports = __webpack_require__("+E39") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "qkKv":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "qnRG":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("ng6w")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("WKYa"),
  /* template */
  __webpack_require__("TTBw"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "rDjO":
/***/ (function(module, exports) {

module.exports = [{"code":"110000","value":"京","name":"北京"},{"code":"120000","value":"津","name":"天津市"},{"code":"130000","value":"冀","name":"河北省"},{"code":"140000","value":"晋","name":"山西省"},{"code":"150000","value":"蒙","name":"内蒙古自治区"},{"code":"210000","value":"辽","name":"辽宁省"},{"code":"220000","value":"吉","name":"吉林省"},{"code":"230000","value":"黑","name":"黑龙江省"},{"code":"310000","value":"沪","name":"上海市"},{"code":"320000","value":"苏","name":"江苏省"},{"code":"330000","value":"浙","name":"浙江省"},{"code":"340000","value":"皖","name":"安徽省"},{"code":"350000","value":"闽","name":"福建省"},{"code":"360000","value":"赣","name":"江西省"},{"code":"370000","value":"鲁","name":"山东省"},{"code":"410000","value":"豫","name":"河南省"},{"code":"420000","value":"鄂","name":"湖北省"},{"code":"430000","value":"湘","name":"湖南省"},{"code":"440000","value":"粤","name":"广东省"},{"code":"450000","value":"桂","name":"广西壮族自治区"},{"code":"460000","value":"琼","name":"海南省"},{"code":"500000","value":"渝","name":"重庆市"},{"code":"510000","value":"川","name":"四川省"},{"code":"520000","value":"贵","name":"贵州省"},{"code":"530000","value":"云","name":"云南省"},{"code":"540000","value":"藏","name":"西藏自治区"},{"code":"610000","value":"陕","name":"陕西省"},{"code":"620000","value":"甘","name":"甘肃省"},{"code":"630000","value":"青","name":"青海省"},{"code":"640000","value":"宁","name":"宁夏回族自治区"},{"code":"650000","value":"新","name":"新疆维吾尔自治区"}]

/***/ }),

/***/ "rjj0":
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__("tTVk")

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "rla3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isServer = typeof window === 'undefined'
var SUBSTITUTE_REG = /\\?\{([^{}]+)\}/g,
	EMPTY = '';

var RE_TRIM = /^[\s\xa0]+|[\s\xa0]+$/g,
	trim = String.prototype.trim;

var _trim = trim ?
	function(str) {
		return str == null ? EMPTY : trim.call(str);
	} : function(str) {
		return str == null ? EMPTY : (str + '').replace(RE_TRIM, EMPTY);
	};

function upperCase() {
	return arguments[1].toUpperCase();
}

function Empty() {}

function createObject(proto, constructor) {
	var newProto;
	if (Object.create) {
		newProto = Object.create(proto);
	} else {
		Empty.prototype = proto;
		newProto = new Empty();
	}
	newProto.constructor = constructor;
	return newProto;
}

function getNodes(node, rootNode) {
	if (!node) return;
	if (node.nodeType) return [node];
	var rootNode = rootNode && rootNode.nodeType ? rootNode : document;
	if (node && typeof node === "string") {
		return rootNode.querySelectorAll(node);
	}
	return;
}

// Useful for temporary DOM ids.
var idCounter = 0;

var getOffsetTop = function(el) {
	var offset = el.offsetTop;
	if (el.offsetParent != null) offset += getOffsetTop(el.offsetParent);
	return offset;
};
var getOffsetLeft = function(el) {
	var offset = el.offsetLeft;
	if (el.offsetParent != null) offset += getOffsetLeft(el.offsetParent);
	return offset;
};

var Util = {
	// Is a given variable an object?
	isObject: function(obj) {
		return obj === Object(obj);
	},
	isArray: Array.isArray || function(obj) {
		return toString.call(obj) == '[object Array]';
	},
	// Is a given array, string, or object empty?
	// An "empty" object has no enumerable own-properties.
	isEmpty: function(obj) {
		if (obj == null) return true;
		if (this.isArray(obj) || this.isString(obj)) return obj.length === 0;
		for (var key in obj)
			if (this.has(obj, key)) return false;
		return true;
	},
	mix: function(to, from, deep) {
		for (var i in from) {
			to[i] = from[i];
		}
		return to;
	},
	extend: function(r, s, px, sx) {
		if (!s || !r) {
			return r;
		}
		var sp = s.prototype,
			rp;
		// add prototype chain
		rp = createObject(sp, r);
		r.prototype = this.mix(rp, r.prototype);
		r.superclass = createObject(sp, s);
		// add prototype overrides
		if (px) {
			this.mix(rp, px);
		}
		// add object overrides
		if (sx) {
			this.mix(r, sx);
		}
		return r;
	},
	/**
	 * test whether a string start with a specified substring
	 * @param {String} str the whole string
	 * @param {String} prefix a specified substring
	 * @return {Boolean} whether str start with prefix
	 * @member util
	 */
	startsWith: function(str, prefix) {
		return str.lastIndexOf(prefix, 0) === 0;
	},

	/**
	 * test whether a string end with a specified substring
	 * @param {String} str the whole string
	 * @param {String} suffix a specified substring
	 * @return {Boolean} whether str end with suffix
	 * @member util
	 */
	endsWith: function(str, suffix) {
		var ind = str.length - suffix.length;
		return ind >= 0 && str.indexOf(suffix, ind) === ind;
	},
	/**
	 * Removes the whitespace from the beginning and end of a string.
	 * @method
	 * @member util
	 */
	trim: _trim,
	/**
	 * Substitutes keywords in a string using an object/array.
	 * Removes undef keywords and ignores escaped keywords.
	 * @param {String} str template string
	 * @param {Object} o json data
	 * @member util
	 * @param {RegExp} [regexp] to match a piece of template string
	 */
	substitute: function(str, o, regexp) {
		if (typeof str !== 'string' || !o) {
			return str;
		}

		return str.replace(regexp || SUBSTITUTE_REG, function(match, name) {
			if (match.charAt(0) === '\\') {
				return match.slice(1);
			}
			return (o[name] === undefined) ? EMPTY : o[name];
		});
	},
	/**
	 * vendors
	 * @return { String } webkit|moz|ms|o
	 * @memberOf Util
	 */
	vendor: (function() {
		if (isServer) return false
		var el = document.createElement('div').style;
		var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			transform,
			i = 0,
			l = vendors.length;
		for (; i < l; i++) {
			transform = vendors[i] + 'ransform';
			if (transform in el) return vendors[i].substr(0, vendors[i].length - 1);
		}
		return false;
	})(),
	/**
	 *  add vendor to attribute
	 *  @memberOf Util
	 *  @param {String} attrName name of attribute
	 *  @return { String }
	 **/
	prefixStyle: function(attrName) {
		if (this.vendor === false) return false;
		if (this.vendor === '') return attrName;
		return this.vendor + attrName.charAt(0).toUpperCase() + attrName.substr(1);
	},
	/**
	 * judge if has class
	 * @memberOf Util
	 * @param  {HTMLElement}  el
	 * @param  {String}  className
	 * @return {Boolean}
	 */
	hasClass: function(el, className) {
		return el && el.className && className && el.className.indexOf(className) != -1;
	},
	/**
	 * add className for the element
	 * @memberOf Util
	 * @param  {HTMLElement}  el
	 * @param  {String}  className
	 */
	addClass: function(el, className) {
		if (el && className && !this.hasClass(el, className)) {
			el.className += " " + className;
		}
	},
	/**
	 * remove className for the element
	 * @memberOf Util
	 * @param  {HTMLElement}  el
	 * @param  {String}  className
	 */
	removeClass: function(el, className) {
		if (el && el.className && className) {
			el.className = el.className.replace(className, "");
		}
	},
	/**
	 * remove an element
	 * @memberOf Util
	 * @param  {HTMLElement}  el
	 */
	remove: function(el) {
		if (!el || !el.parentNode) return;
		el.parentNode.removeChild(el);
	},
	/**
	 * get offset top
	 * @memberOf Util
	 * @param  {HTMLElement}   el
	 * @return {Number} offsetTop
	 */
	getOffsetTop: getOffsetTop,
	/**
	 * get offset left
	 * @memberOf Util
	 * @param  {HTMLElement}  el
	 * @return {Number} offsetLeft
	 */
	getOffsetLeft: getOffsetLeft,
	/**
	 * get offset left
	 * @memberOf Util
	 * @param  {HTMLElement} el
	 * @param  {String} selector
	 * @param  {HTMLElement} rootNode
	 * @return {HTMLElement} parent element
	 */
	findParentEl: function(el, selector, rootNode) {
		var rs = null,
			parent = null;
		var type = /^#/.test(selector) ? "id" : /^\./.test(selector) ? "class" : "tag";
		var sel = selector.replace(/\.|#/g, "");
		if (rootNode && typeof rootNode === "string") {
			rootNode = document.querySelector(rootNode);
		}
		rootNode = rootNode || document.body;
		if (!el || !selector) return;
		if (type == "class" && el.className && el.className.match(sel)) {
			return el;
		} else if (type == "id" && el.id && _trim(el.id) == sel) {
			return el;
		} else if (type == "tag" && el.tagName.toLowerCase() == sel) {
			return el;
		}
		while (!rs) {
			if (parent == rootNode) break;
			parent = el.parentNode;
			if (!parent) break;
			if ((type == "class" && parent.className && parent.className.match(sel)) || (type == "id" && parent.id && _trim(parent.id) == sel) || (type == "tag" && parent.tagName && parent.tagName.toLowerCase() == sel)) {
				rs = parent
				return rs;
				break;
			} else {
				el = parent;
			}
		}
		return null;
	},
	/**
	 * Generate a unique integer id (unique within the entire client session).
	 * @param  {String} prefix
	 * @return {String} guid
	 */
	guid: function(prefix) {
		var id = ++idCounter + '';
		return prefix ? prefix + id : id;
	},
	/**
	 * judge if is an android os
	 * @return {Boolean} [description]
	 */
	isAndroid: function() {
		return /Android /.test(window.navigator.appVersion);
	},
	/**
	 * judge if is an android device with low  performance
	 * @return {Boolean}
	 */
	isBadAndroid: function() {
		return /Android /.test(window.navigator.appVersion) && !(/Chrome\/\d/.test(window.navigator.appVersion))
	},
	px2Num: function(px) {
		return Number(px.replace(/px/, ''));
	},
	getNodes: getNodes,
	getNode: function(node, rootNode) {
		var nodes = getNodes(node, rootNode);
		return nodes && nodes[0];
	},
	stringifyStyle: function(style) {
		var styleStr = "";
		for (var i in style) {
			styleStr += [i, ":", style[i], ";"].join("");
		}
		return styleStr;
	}
}

// Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
var names = ['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'];
for (var i = 0; i < names.length; i++) {
	Util['is' + names[i]] = function(obj) {
		return toString.call(obj) == '[object ' + names[i] + ']';
	};
}

if (typeof module == 'object' && module.exports) {
	module.exports = Util;
}


/***/ }),

/***/ "rllK":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    staticClass: "weui_dialog_alert",
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "weui_dialog_mes"
  }, [_c('div', {
    staticClass: "weui_dialog_hd"
  }, [_c('strong', {
    staticClass: "weui_dialog_title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui_dialog_bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "weui_dialog_ft"
  }, [_c('a', {
    staticClass: "weui_btn_dialog primary",
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "rrdG":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("WS8O")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("f2/U"),
  /* template */
  __webpack_require__("hoPN"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "sB3e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "sFQ0":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cvux-check-icon",
    on: {
      "click": _vm.updateValue
    }
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'default' && _vm.value),
      expression: "type === 'default' && value"
    }],
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'plain' && _vm.value),
      expression: "type === 'plain' && value"
    }],
    attrs: {
      "type": "success-circle"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.value),
      expression: "!value"
    }],
    attrs: {
      "type": "circle"
    }
  }), _vm._v(" "), _c('span', [_vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "sFvm":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_cell weui_cell_switch"
  }, [_c('div', {
    staticClass: "weui_cell_hd weui_cell_primary"
  }, [_c('label', {
    staticClass: "weui_label",
    style: (_vm.labelStyle),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "weui_cell_ft"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui_switch",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, null) > -1 : (_vm.currentValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.currentValue = $$c
        }
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ "sWRC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = typeof window === 'undefined';
var Roller = function () {
  function Roller(opts) {
    (0, _classCallCheck3.default)(this, Roller);

    if (isServer) return;
    this.container = typeof opts.container === 'string' ? document.querySelector(opts.container) : opts.container;
    this.width = opts.width || 1;
    if (!this.container) {
      throw Error('no container');
    }
    this.container.style.overflow = 'hidden';
    this.rollHeight = parseInt(window.getComputedStyle(this.container).height);

    if (this.rollHeight < 1) {
      this.container.style.height = '20px';
      this.rollHeight = 20;
    }
    this.setWidth();
  }

  (0, _createClass3.default)(Roller, [{
    key: 'roll',
    value: function roll(n) {
      if (isServer) return;
      var self = this;
      this.number = parseInt(n) + '';
      if (this.number.length < this.width) {
        this.number = new Array(this.width - this.number.length + 1).join('0') + this.number;
      } else if (this.number.length > this.width) {
        this.width = this.number.length;
        this.setWidth();
      }
      Array.prototype.forEach.call(this.container.querySelectorAll('.num'), function (item, i) {
        if (isServer) return;
        var currentNum = parseInt(item.querySelector('div:last-child').innerHTML);
        var goalNum = parseInt(self.number[i]);
        var gapNum = 0;
        var gapStr = '';
        if (currentNum === goalNum) {
          return;
        } else if (currentNum < goalNum) {
          gapNum = goalNum - currentNum;
          for (var j = currentNum; j < goalNum + 1; j++) {
            gapStr += '<div>' + j + '</div>';
          }
        } else {
          gapNum = 10 - currentNum + goalNum;
          for (var _j = currentNum; _j < 10; _j++) {
            gapStr += '<div>' + _j + '</div>';
          }
          for (var _j2 = 0; _j2 < goalNum + 1; _j2++) {
            gapStr += '<div>' + _j2 + '</div>';
          }
        }
        item.style.cssText += '-webkit-transition-duration:0;s-webkit-transform:translateY(0)';
        item.innerHTML = gapStr;
        var time = gapNum * (1 / 9);
        setTimeout(function () {
          item.style.cssText += '-webkit-transition-duration:' + time + 's;-webkit-transform:translateY(-' + self.rollHeight * gapNum + 'px)';
        }, 50);
      });
    }
  }, {
    key: 'setWidth',
    value: function setWidth(n) {
      if (isServer) return;
      n = n || this.width;
      var str = '';
      for (var i = 0; i < n; i++) {
        str += '<div class="num" style="float:left;height:100%;line-height:' + this.rollHeight + 'px"><div>0</div></div>';
      }
      this.container.innerHTML = str;
    }
  }]);
  return Roller;
}();

exports.default = Roller;

/***/ }),

/***/ "sZYo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3"),
	Base = __webpack_require__("5dD5"),
	Timer = __webpack_require__("dJCP"),
	Animate = __webpack_require__("W0DV"),
	Hammer = __webpack_require__("ZOvT"),
	SimuScroll = __webpack_require__("CT+H"),
	OriginScroll = __webpack_require__("3bsv");
var XScroll = function(cfg) {
		var _ = cfg && cfg.useOriginScroll ? OriginScroll : SimuScroll;
		return new _(cfg);
	}
/**
 * Util
 * @namespace Util
 * @type {Object}
 */
XScroll.Util = Util;
/**
 * Base
 * @namespace Base
 * @type {Base}
 */
XScroll.Base = Base;
/**
 * Timer
 * @namespace Timer
 * @type {Timer}
 */
XScroll.Timer = Timer;
/**
 * Animate
 * @namespace Animate
 * @type {Animate}
 */
XScroll.Animate = Animate;
/**
 * Hammer
 * @namespace Hammer
 * @type {Hammer}
 */
XScroll.Hammer = Hammer;
/**
 * plugins
 * @namespace Plugins
 * @type {Object}
 */
XScroll.Plugins = {};

if (typeof module == 'object' && module.exports) {
	module.exports = XScroll;
}


/***/ }),

/***/ "siDO":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("vNQ7")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("8toS"),
  /* template */
  __webpack_require__("sr2X"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "sj7C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _datetime = __webpack_require__("omrE");

var _datetime2 = _interopRequireDefault(_datetime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.install = function (Vue) {
  Vue.component('LxDatetime', _datetime2.default);
};

exports.default = _datetime2.default;

/***/ }),

/***/ "sr2X":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-button-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "ssAp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shake = __webpack_require__("kqA7");

var _shake2 = _interopRequireDefault(_shake);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    stop: Boolean,
    threshold: {
      type: Number,
      default: 15
    },
    timeout: {
      type: Number,
      default: 1000
    }
  },
  mounted: function mounted() {
    var _this = this;
    this._shake = new _shake2.default({
      threshold: _this.threshold,
      timeout: _this.timeout });
    window.addEventListener('shake', this.handler, false);
    this._shake.start();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('shake', this.handler, false);
  },

  methods: {
    handler: function handler() {
      var _this = this;
      if (_this.stop) {
        this.$emit('on-shake');
      } else {
        this._shake.stop();
      }
    }
  }
};

/***/ }),

/***/ "t3S2":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-header"
  }, [_c('div', {
    staticClass: "vux-header-left"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leftOptions.showBack),
      expression: "leftOptions.showBack"
    }],
    staticClass: "vux-header-back",
    attrs: {
      "transition": _vm.transition
    },
    on: {
      "click": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault", undefined, $event.key)) { return null; }
      }, _vm.onClickBack]
    }
  }, [_vm._v(_vm._s(_vm.leftOptions.backText))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leftOptions.showBack),
      expression: "leftOptions.showBack"
    }],
    staticClass: "left-arrow",
    attrs: {
      "transition": _vm.transition
    },
    on: {
      "click": _vm.onClickBack
    }
  }), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), _c('h1', {
    staticClass: "vux-header-title",
    on: {
      "click": function($event) {
        _vm.$emit('on-click-title')
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "transition": _vm.transition
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-header-right"
  }, [(_vm.rightOptions.showMore) ? _c('a', {
    staticClass: "vux-header-more",
    on: {
      "click": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault", undefined, $event.key)) { return null; }
      }, function($event) {
        _vm.$emit('on-click-more')
      }]
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "t8x9":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("77Pl");
var aFunction = __webpack_require__("lOnJ");
var SPECIES = __webpack_require__("dSzd")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "tIc8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buttonTab = __webpack_require__("siDO");

var _buttonTab2 = _interopRequireDefault(_buttonTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_buttonTab2.default.install = function (Vue) {
  Vue.component('LxButtonTab', _buttonTab2.default);
};

exports.default = _buttonTab2.default;

/***/ }),

/***/ "tO1L":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("7BQH")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Oe79"),
  /* template */
  __webpack_require__("p/vT"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "tOj0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vZ3K");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ed674b64", content, true);

/***/ }),

/***/ "tTVk":
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ "tX24":
/***/ (function(module, exports) {


/**
 * Array#filter.
 *
 * @param {Array} arr
 * @param {Function} fn
 * @param {Object=} self
 * @return {Array}
 * @throw TypeError
 */

module.exports = function (arr, fn, self) {
  if (arr.filter) return arr.filter(fn, self);
  if (void 0 === arr || null === arr) throw new TypeError;
  if ('function' != typeof fn) throw new TypeError;
  var ret = [];
  for (var i = 0; i < arr.length; i++) {
    if (!hasOwn.call(arr, i)) continue;
    var val = arr[i];
    if (fn.call(self, val, i, arr)) ret.push(val);
  }
  return ret;
};

var hasOwn = Object.prototype.hasOwnProperty;


/***/ }),

/***/ "tta2":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/1W4"),
  /* template */
  __webpack_require__("hKtO"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "u4Ff":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.shell) ? _c('div', {
    staticClass: "weui_cell"
  }, [_c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "weui_cell_ft",
    staticStyle: {
      "font-size": "0"
    }
  }, [_c('a', {
    staticClass: "vux-number-selector vux-number-selector-sub",
    class: {
      'vux-number-disabled': _vm.disabledMin
    },
    on: {
      "click": _vm.sub
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "vux-number-input",
    style: ({
      width: _vm.width + 'px'
    }),
    attrs: {
      "name": _vm.name,
      "readonly": !_vm.fillable
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "vux-number-selector vux-number-selector-plus",
    class: {
      'vux-number-disabled': _vm.disabledMax
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("+")])]) : _c('div', {
    staticClass: "weui_cell_ft"
  }, [_vm._v("\n      " + _vm._s(_vm.currentValue) + "\n    ")])]) : _c('div', [(!_vm.readonly) ? _c('div', [_c('span', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.sub
    }
  }, [_vm._t("sub", [_c('a', {
    staticClass: "vux-number-selector vux-number-selector-sub",
    class: {
      'vux-number-disabled': _vm.disabledMin
    }
  }, [_vm._v("-")])])], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "vux-number-input",
    class: _vm.inputClasses,
    attrs: {
      "name": _vm.name,
      "readonly": !_vm.fillable
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.add
    }
  }, [_vm._t("add", [_c('a', {
    staticClass: "vux-number-selector vux-number-selector-plus",
    class: {
      'vux-number-disabled': _vm.disabledMax
    }
  }, [_vm._v("+")])])], 2)]) : _c('div', [_vm._v("\n      " + _vm._s(_vm.currentValue) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),

/***/ "uAG8":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-dialog', {
    staticClass: "weui_dialog_confirm",
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "weui_dialog_mes"
  }, [_c('div', {
    staticClass: "weui_dialog_hd"
  }, [_c('strong', {
    staticClass: "weui_dialog_title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui_dialog_bd"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "weui_dialog_ft"
  }, [_c('a', {
    staticClass: "weui_btn_dialog default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('a', {
    staticClass: "weui_btn_dialog primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "uFQh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-fade-transition{opacity:1;transition:opacity .2s linear}.vux-fade-enter,.vux-fade-leave{opacity:0}.vux-dialog-transition{opacity:1;transition-duration:.4s;transform:translate(-50%,-50%) scale(1)!important;transition-property:transform,opacity!important}.vux-dialog-enter,.vux-dialog-leave{opacity:0}.vux-dialog-enter{transform:translate(-50%,-50%) scale(1.185)!important}.vux-dialog-leave{transform:translate(-50%,-50%) scale(1)!important}", ""]);

// exports


/***/ }),

/***/ "uOiQ":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("f/u1"),
  /* template */
  __webpack_require__("PgOA"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "uTeD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _selector = __webpack_require__("Z41a");

var _selector2 = _interopRequireDefault(_selector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_selector2.default.install = function (Vue) {
  Vue.component('LxSelector', _selector2.default);
};

exports.default = _selector2.default;

/***/ }),

/***/ "uTsL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3");
var Base = __webpack_require__("5dD5");
var clsPrefix;
var containerCls;
var loadingContent = "Loading...";
var upContent = "Pull Up To Refresh";
var downContent = "Release To Refresh";
var PULL_UP_HEIGHT = 60;
var HEIGHT = 40;
/**
 * A pullup to load plugin for xscroll.
 * @constructor
 * @param {object} cfg
 * @param {number} cfg.height
 * @param {string} cfg.downContent
 * @param {string} cfg.upContent
 * @param {string} cfg.loadingContent
 * @param {string} cfg.clsPrefix  class prefix which default value is "xs-plugin-pullup-"
 * @param {number} cfg.bufferHeight preload data before scrolling to the bottom of the boundry
 * @extends {Base}
 */
var PullUp = function(cfg) {
	PullUp.superclass.constructor.call(this);
	this.userConfig = Util.mix({
		upContent: upContent,
		downContent: downContent,
		pullUpHeight: PULL_UP_HEIGHT,
		height: HEIGHT,
		loadingContent: loadingContent,
		bufferHeight: 0,
		clsPrefix: "xs-plugin-pullup-"
	}, cfg);
}
Util.extend(PullUp, Base, {
	/**
	 * a pluginId
	 * @memberOf PullUp
	 * @type {string}
	 */
	pluginId: "pullup",
	/**
	 * plugin initializer
	 * @memberOf PullUp
	 * @override Base
	 * @return {PullUp}
	 */
	pluginInitializer: function(xscroll) {
		var self = this;
		self.xscroll = xscroll.render();
		clsPrefix = self.userConfig.clsPrefix;
		self.render();
		return self;
	},
	/**
	 * detroy the plugin
	 * @memberOf PullUp
	 * @override Base
	 * @return {PullUp}
	 */
	pluginDestructor: function() {
		var self = this;
		Util.remove(self.pullup);		
		self.xscroll.off("scrollend", self._scrollEndHandler, self);
		self.xscroll.off("scroll", self._scrollHandler, self);
		self.xscroll.off("pan", self._panHandler, self);
		self.xscroll.boundry.resetBottom();
		self.__isRender = false;
		self._evtBinded = false;
	},
	/**
	 * disable the plugin
	 * @memberOf PullUp
	 * @override Base
	 * @return {PullUp}
	 */
	pluginDisable: function () {
		var self = this;
		self.userConfig.container || Util.remove(self.pullup)
		self.xscroll.off("scrollend", self._scrollEndHandler, self);
		self.xscroll.off("scroll", self._scrollHandler, self);
		self.xscroll.off("pan", self._panHandler, self);
		self.xscroll.boundry.resetBottom();
		self.__isRender = false;
		self._evtBinded = false;
	},
	/**
	 * render pullup plugin
	 * @memberOf PullUp
	 * @return {PullUp}
	 */
	render: function() {
		var self = this;
		if (self.__isRender) return;
		self.__isRender = true;
		var containerCls = clsPrefix + "container";
		var height = self.userConfig.height;
		var pullup = self.pullup = document.createElement("div");
		pullup.className = containerCls;
		pullup.style.position = "absolute";
		pullup.style.width = "100%";
		pullup.style.height = height + "px";
		pullup.style.bottom = -height + "px";
		self.xscroll.container.appendChild(pullup);
		self.xscroll.boundry.expandBottom(self.userConfig.height);
		self.status = 'up';
		Util.addClass(pullup, clsPrefix + self.status);
		pullup.innerHTML = self.userConfig[self.status + "Content"] || self.userConfig.content;
		self._bindEvt();
		return self;
	},
	_bindEvt: function() {
		var self = this;
		if (self._evtBinded) return;
		self._evtBinded = true;
		var pullup = self.pullup;
		var xscroll = self.xscroll;
		xscroll.on("pan", self._panHandler, self);
		//load width a buffer
		if (self.userConfig.bufferHeight > 0) {
			xscroll.on("scroll", self._scrollHandler, self);
		}
		//bounce bottom
		xscroll.on("scrollend", self._scrollEndHandler, self);
		return self;
	},
	_scrollEndHandler: function(e) {
		var self = this,
			xscroll = self.xscroll,
			scrollTop = xscroll.getScrollTop();
		if (Math.abs(scrollTop - (xscroll.containerHeight - xscroll.height + self.userConfig.height)) < 1) {
			self._changeStatus("loading");
		}
		return self;
	},
	_scrollHandler: function(e) {
		var self = this,
			xscroll = self.xscroll;
		if (!self.isLoading && Math.abs(e.scrollTop) + xscroll.height + self.userConfig.height + self.userConfig.bufferHeight >= xscroll.containerHeight + xscroll.boundry._xtop + xscroll.boundry._xbottom) {
			self._changeStatus("loading");
		}
		return self;
	},
	_panHandler: function(e) {
		var self = this;
		var xscroll = self.xscroll;
		var offsetTop = -xscroll.getScrollTop();
		if (offsetTop < xscroll.height - xscroll.containerHeight - self.userConfig.pullUpHeight) {
			self._changeStatus("down")
		} else {
			self._changeStatus("up");
		}
		return self;
	},
	_changeStatus: function(status) {
		if (status != "loading" && this.isLoading) return;
		var prevVal = this.status;
		this.status = status;
		Util.removeClass(this.pullup, clsPrefix + prevVal)
		Util.addClass(this.pullup, clsPrefix + status);
		this.pullup.innerHTML = this.userConfig[status + "Content"];
		if (prevVal != status) {
			this.trigger("statuschange", {
				prevVal: prevVal,
				newVal: status
			});
			if (status == "loading") {
				this.isLoading = true;
				this.trigger("loading");
			}
		}
		return this;
	},
	/**
	 * notify pullup plugin to complete state after a remote data request
	 * @memberOf PullUp
	 * @return {PullUp}
	 */
	complete: function() {
		var self = this;
		var xscroll = self.xscroll;
		self.isLoading = false;
		self._changeStatus("up");
		return self;
	},
	stop: function () {
		var xscroll = this.xscroll;
		this.isLoading = false;
		this._changeStatus("stop");
		this.pluginDisable()
		return this;
	},
	restart: function () {
		var xscroll = this.xscroll;
		this.isLoading = false;
		this._changeStatus("default");
		this.render()
		return this;
	}
});

if (typeof module == 'object' && module.exports) {
	module.exports = PullUp;
}


/***/ }),

/***/ "uXSg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-group-tip,.vux-group-tip p{font-size:14px;color:#888;text-align:center;padding-top:.3em;padding-left:10px;padding-right:5px}.vux-group-tip .weui_icon{padding-right:3px}", ""]);

// exports


/***/ }),

/***/ "ui1D":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: _vm.disabled ? 'vux-checklist-disabled' : ''
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "weui_cells_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("after-title"), _vm._v(" "), _c('div', {
    staticClass: "weui_cells weui_cells_checkbox"
  }, _vm._l((_vm.currentOptions), function(one, index) {
    return _c('label', {
      staticClass: "weui_cell weui_check_label",
      class: {
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },
      attrs: {
        "for": ("checkbox_" + _vm.uuid + "_" + index)
      }
    }, [_c('div', {
      staticClass: "weui_cell_hd"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "weui_check",
      attrs: {
        "type": "checkbox",
        "name": ("vux-checkbox-" + _vm.uuid),
        "id": _vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),
        "disabled": _vm.isDisabled(_vm.getKey(one))
      },
      domProps: {
        "value": _vm.getKey(one),
        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, _vm.getKey(one)) > -1 : (_vm.currentValue)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.currentValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.getKey(one),
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.currentValue = $$c
          }
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "weui_icon_checked"
    })]), _vm._v(" "), _c('div', {
      staticClass: "weui_cell_bd weui_cell_primary"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.getValue(one))
      }
    }), _vm._v(" "), (_vm.getInlineDesc(one)) ? _c('inline-desc', [_vm._v(_vm._s(_vm.getInlineDesc(one)))]) : _vm._e()], 1)])
  })), _vm._v(" "), _c('tip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validy && _vm.dirty),
      expression: "!validy && dirty"
    }]
  }, [_c('icon', {
    staticClass: "icon_small",
    attrs: {
      "type": "warn"
    }
  }), _vm._v(_vm._s(_vm.error))], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ "uk4t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xInput = __webpack_require__("PZnC");

var _xInput2 = _interopRequireDefault(_xInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xInput2.default.install = function (Vue) {
  Vue.component('LxXInput', _xInput2.default);
};

exports.default = _xInput2.default;

/***/ }),

/***/ "uqUo":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var fails = __webpack_require__("S82l");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "uvUq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = __webpack_require__("T131");

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  minxins: [_base2.default],
  props: {
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: {
      type: String,
      default: ''
    },
    name: String,
    placeholder: String,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,

    autocomplete: 'off',
    autocapitalize: 'off',
    autocorrect: 'off',
    spellcheck: 'false'
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      if (this.max && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max);
      }
      this.$emit('on-change', this.currentValue);
      this.$emit('input', this.currentValue);
    }
  },
  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    }
  }
};

/***/ }),

/***/ "uwDN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "@font-face{font-weight:400;font-style:normal;font-family:weui;src:url(\"data:application/octet-stream;base64,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\") format(\"truetype\")}[class*=\" weui_icon_\"]:before,[class^=weui_icon_]:before{font-family:weui;font-style:normal;font-weight:400;speak:none;display:inline-block;vertical-align:middle;text-decoration:inherit;width:1em;margin-right:.56rem;text-align:center;font-variant:normal;text-transform:none;line-height:1;margin-left:.2rem}.weui_icon_circle:before{content:\"\\EA01\"}.weui_icon_download:before{content:\"\\EA02\"}.weui_icon_info:before{content:\"\\EA03\"}.weui_icon_safe_success:before{content:\"\\EA04\"}.weui_icon_safe_warn:before{content:\"\\EA05\"}.weui_icon_success:before{content:\"\\EA06\"}.weui_icon_success_circle:before{content:\"\\EA07\"}.weui_icon_success_no_circle:before{content:\"\\EA08\"}.weui_icon_waiting:before{content:\"\\EA09\"}.weui_icon_waiting_circle:before{content:\"\\EA0A\"}.weui_icon_warn:before{content:\"\\EA0B\"}.weui_icon_info_circle:before{content:\"\\EA0C\"}.weui_icon_cancel:before{content:\"\\EA0D\"}.weui_icon_search:before{content:\"\\EA0E\"}.weui_icon_clear:before{content:\"\\EA0F\"}[class*=\" weui_icon_\"]:before,[class^=weui_icon_]:before{margin:0}.weui_icon_success:before{font-size:.61333333rem;color:#09bb07}.weui_icon_waiting:before{font-size:.61333333rem;color:#10aeff}.weui_icon_warn:before{font-size:.61333333rem;color:#f43530}.weui_icon_info:before{font-size:.61333333rem;color:#10aeff}.weui_icon_success_circle:before,.weui_icon_success_no_circle:before{font-size:.61333333rem;color:#09bb07}.weui_icon_waiting_circle:before{font-size:.48rem;color:#10aeff}.weui_icon_circle:before{font-size:.48rem;color:#c9c9c9}.weui_icon_download:before,.weui_icon_info_circle:before{font-size:.48rem;color:#09bb07}.weui_icon_safe_success:before{color:#09bb07}.weui_icon_safe_warn:before{color:#ffbe00}.weui_icon_cancel:before{color:#f43530;font-size:.58666667rem}.weui_icon_clear:before,.weui_icon_search:before{color:#b2b2b2;font-size:.37333333rem}.weui_icon_msg:before{font-size:2.77333333rem}.weui_icon_warn.weui_icon_msg:before{color:#f76260}.weui_icon_safe:before{font-size:2.77333333rem}.vux-color-box{text-align:center}.vux-color-picker{font-size:0}.vux-color-item{display:inline-block;text-align:center;box-sizing:border-box;position:relative}.vux-color-checked.weui_icon_success_no_circle:before{color:#fff}.vux-color-checked{width:100%;position:absolute;left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vux-color-white{border:1px solid #ccc}.vux-color-white .vux-color-checked:before{color:#ccc}.vux-color-picker-small .vux-color-checked:before{font-size:10px}.vux-color-picker-middle .vux-color-checked:before{font-size:18px}", ""]);

// exports


/***/ }),

/***/ "uxDs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineCalendar = __webpack_require__("iys0");

var _inlineCalendar2 = _interopRequireDefault(_inlineCalendar);

var _popup = __webpack_require__("ooks");

var _popup2 = _interopRequireDefault(_popup);

var _cell = __webpack_require__("0juH");

var _cell2 = _interopRequireDefault(_cell);

var _props = __webpack_require__("lsGX");

var _props2 = _interopRequireDefault(_props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Props = (0, _props2.default)();
Props.title = {
  type: String,
  required: true
};

exports.default = {
  components: {
    InlineCalendar: _inlineCalendar2.default,
    Popup: _popup2.default,
    Cell: _cell2.default
  },
  props: Props,
  methods: {
    onClick: function onClick() {
      console.log(this.show);
      this.show = true;
    },
    onSelect: function onSelect() {
      this.show = false;
    }
  },
  data: function data() {
    return {
      show: false,
      currentValue: ''
    };
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    }
  }
};

/***/ }),

/***/ "uy6L":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("wPn5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("026a9578", content, true);

/***/ }),

/***/ "uyHn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sticky = __webpack_require__("O/iI");

var _sticky2 = _interopRequireDefault(_sticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    (0, _sticky2.default)(this.$el);
  }
};

/***/ }),

/***/ "v04r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkIcon = __webpack_require__("CJig");

var _checkIcon2 = _interopRequireDefault(_checkIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_checkIcon2.default.install = function (Vue) {
  Vue.component('LxCheckIcon', _checkIcon2.default);
};

exports.default = _checkIcon2.default;

/***/ }),

/***/ "v4qD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _arrayFilter = __webpack_require__("tX24");

var _arrayFilter2 = _interopRequireDefault(_arrayFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Manager = function () {
  function Manager(data, count, fixedColumns) {
    (0, _classCallCheck3.default)(this, Manager);

    this.data = data;
    this.count = count;
    if (fixedColumns) {
      this.fixedColumns = fixedColumns;
    }
  }

  (0, _createClass3.default)(Manager, [{
    key: 'getChildren',
    value: function getChildren(value) {
      return (0, _arrayFilter2.default)(this.data, function (one) {
        return one.parent === value;
      });
    }
  }, {
    key: 'getFirstColumn',
    value: function getFirstColumn() {
      return (0, _arrayFilter2.default)(this.data, function (one) {
        return !one.parent || one.parent === 0 || one.parent === '0';
      });
    }
  }, {
    key: 'getPure',
    value: function getPure(obj) {
      return JSON.parse((0, _stringify2.default)(obj));
    }
  }, {
    key: 'getColumns',
    value: function getColumns(value) {
      var _this = this;

      if (value.length > 0) {
        var matchCount = this.getPure(this.data).filter(function (item) {
          return _this.getPure(value).indexOf(item.value) > -1;
        }).length;
        if (matchCount < this.getPure(value).length) {
          value = [];
        }
      }
      var datas = [];
      var max = this.fixedColumns || 8;
      for (var i = 0; i < max; i++) {
        if (i === 0) {
          datas.push(this.getFirstColumn());
        } else {
          if (!value[i]) {
            if (typeof datas[i - 1][0] === 'undefined') {
              break;
            } else {
              var topValue = datas[i - 1][0].value;
              datas.push(this.getChildren(topValue));
            }
          } else {
            datas.push(this.getChildren(value[i - 1]));
          }
        }
      }
      var list = datas.filter(function (item) {
        return item.length > 0;
      });

      this.count = list.length;
      return list;
    }
  }]);
  return Manager;
}();

exports.default = Manager;

/***/ }),

/***/ "v93z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toRGB = toRGB;
exports.toHex = toHex;
function toRGB(color) {
  var num = parseInt(color, 16);
  return [num >> 16, num >> 8 & 255, num & 255];
}

function toHex(red, green, blue) {
  return (blue | green << 8 | red << 16 | 1 << 24).toString(16).slice(1);
}

/***/ }),

/***/ "vFc/":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("TcQ7");
var toLength = __webpack_require__("QRG4");
var toAbsoluteIndex = __webpack_require__("fkB2");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "vIB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var hide = __webpack_require__("hJx8");
var has = __webpack_require__("D2L2");
var Iterators = __webpack_require__("/bQp");
var $iterCreate = __webpack_require__("94VQ");
var setToStringTag = __webpack_require__("e6n0");
var getPrototypeOf = __webpack_require__("PzxK");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "vNQ7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BkBg");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("27263dc4", content, true);

/***/ }),

/***/ "vQ0r":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("q+df")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("SQEW"),
  /* template */
  __webpack_require__("SEQM"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "vZ3K":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("jvnJ"), "");
exports.i(__webpack_require__("ZSw/"), "");

// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "vfpP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Util = __webpack_require__("rla3");
var Base = __webpack_require__("5dD5");
var clsPrefix;
var containerCls;
var content = "Pull Down To Refresh";
var loadingContent = "Loading...";
/**
 * A pulldown to refresh plugin for xscroll.
 * @constructor
 * @param {object} cfg
 * @param {number} cfg.height
 * @param {string} cfg.content default html for pulldown
 * @param {string} cfg.downContent html for pulldown when scrollTop is smaller than cfg.height
 * @param {string} cfg.upContent html for pulldown when scrollTop is larger than cfg.height
 * @param {string} cfg.loadingContent html for pulldown when released
 * @param {string} cfg.clsPrefix  class prefix which default value is "xs-plugin-pulldown-"
 * @extends {Base}
 */
var PullDown = function(cfg) {
	PullDown.superclass.constructor.call(this, cfg);
	this.userConfig = Util.mix({
		content: content,
		height: 60,
		autoRefresh: true,
		downContent: "Pull Down To Refresh",
		upContent: "Release To Refresh",
		loadingContent: loadingContent,
		clsPrefix: "xs-plugin-pulldown-"
	}, cfg);
}
Util.extend(PullDown, Base, {
	/**
	 * a pluginId
	 * @memberOf PullDown
	 * @type {string}
	 */
	pluginId: "pulldown",
	/**
	 * plugin initializer
	 * @memberOf PullDown
	 * @override Base
	 * @return {PullDown}
	 */
	pluginInitializer: function(xscroll) {
		var self = this;
		self.xscroll = xscroll.render();
		clsPrefix = self.userConfig.clsPrefix;
		self.render();
		return self;
	},
	/**
	 * detroy the plugin
	 * @memberOf PullDown
	 * @override Base
	 * @return {PullDown}
	 */
	pluginDestructor: function() {
		var self = this;
		Util.remove(self.pulldown);
		self.xscroll.off("panstart", self._panStartHandler, self);
		self.xscroll.off("pan", self._panHandler, self);
		self.xscroll.off("panend", self._panEndHandler, self);
		self.__isRender = false;
		self._evtBinded = false;
	},
	/**
	 * render pulldown plugin
	 * @memberOf PullDown
	 * @return {PullDown}
	 */
	render: function() {
		var self = this;
		if (self.__isRender) return;
		self.__isRender = true;
		var containerCls = clsPrefix + "container";
		var height = self.userConfig.height || 60;
		var pulldown = self.pulldown = document.createElement("div");
		pulldown.className = containerCls;
		pulldown.style.position = "absolute";
		pulldown.style.width = "100%";
		pulldown.style.height = height + "px";
		pulldown.style.lineHeight = height + "px";
		pulldown.style.top = -height + "px";
		pulldown.style.textAlign = "center";
		self.xscroll.container.appendChild(pulldown);
		self.status = 'up';
		Util.addClass(pulldown, clsPrefix + self.status);
		pulldown.innerHTML = self.userConfig[self.status + "Content"] || self.userConfig.content;
		self._bindEvt();
		return self;
	},
	_bindEvt: function() {
		var self = this;
		if (self._evtBinded) return;
		self._evtBinded = true;
		var pulldown = self.pulldown;
		var xscroll = self.xscroll;
		xscroll.on("pan", self._panHandler, self);
		xscroll.on("panstart", self._panStartHandler, self);
		xscroll.on("panend", self._panEndHandler, self);
	},
	_changeStatus: function(status) {
		var prevVal = this.status;
		this.status = status;
		Util.removeClass(this.pulldown, clsPrefix + prevVal)
		Util.addClass(this.pulldown, clsPrefix + status);
		if (this.userConfig[status + "Content"]) {
			this.pulldown.innerHTML = this.userConfig[status + "Content"];
		}
		if (prevVal != status) {
			this.trigger("statuschange", {
				prevVal: prevVal,
				newVal: status
			});
			if (status == "loading") {
				this.trigger("loading");
			}
		}
	},
	/**
	 * reset the pulldown plugin
	 * @memberOf PullDown
	 * @param {function} callback
	 * @return {PullDown}
	 */
	reset: function(callback) {
		this.xscroll.boundry.resetTop()
		this.xscroll.boundryCheckY(callback);
		this._expanded = false;
		return this;
	},
	_panStartHandler: function(e) {
		clearTimeout(this.loadingItv);
	},
	_panHandler: function(e) {
		var self = this;
		var scrollTop = self.xscroll.getScrollTop();
		if (scrollTop > 0) return;
		self._changeStatus(Math.abs(scrollTop) < self.userConfig.height ? "down" : "up");
	},
	_panEndHandler: function(e) {
		var self = this;
		var xscroll = self.xscroll;
		var height = self.userConfig.height || 60;
		var scrollTop = xscroll.getScrollTop();
		if (scrollTop < -height) {
			//prevent default bounce
			e.preventDefault();
			xscroll.boundry.resetTop();
			xscroll.boundry.expandTop(height);
			xscroll.boundryCheckY(function() {
				self._changeStatus("loading");
			});
			if (self.userConfig.autoRefresh) {
				clearTimeout(self.loadingItv);
				self.loadingItv = setTimeout(function() {
					xscroll.boundry.resetTop();
					xscroll.boundryCheckY(function() {
						window.location.reload();
					})
				}, 800);
			}
		}
	}
});

if (typeof module == 'object' && module.exports) {
	module.exports = PullDown;
}


/***/ }),

/***/ "vj+x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xProgress = __webpack_require__("5mS4");

var _xProgress2 = _interopRequireDefault(_xProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_xProgress2.default.install = function (Vue) {
  Vue.component('LxXProgress', _xProgress2.default);
};

exports.default = _xProgress2.default;

/***/ }),

/***/ "vjrk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _badge = __webpack_require__("3Uo8");

var _badge2 = _interopRequireDefault(_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_badge2.default.install = function (Vue) {
  Vue.component('LxBadge', _badge2.default);
};

exports.default = _badge2.default;

/***/ }),

/***/ "vjwT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: Object,
      default: {
        time: 60,
        start: true
      }
    }
  },
  methods: {
    tick: function tick() {
      var _this = this;

      this.interval = setInterval(function () {
        if (_this.time > 0) {
          _this.time--;
        } else {
          _this.stop();
          _this.index++;
          _this.$emit('on-finish', _this.index);
        }
      }, 1000);
    },
    stop: function stop() {
      clearInterval(this.interval);
    }
  },
  watch: {
    'value.time': function valueTime(val) {
      this.time = val;
    },
    'value.start': function valueStart(val) {
      this.start = val;
    },
    time: function time(val) {
      var options = {
        time: val,
        start: this.start
      };
      this.$emit('input', options);
    },
    start: function start(newVal, oldVal) {
      if (newVal === true && oldVal === false && this.time > 0) {
        this.tick();
      }
      if (newVal === false && oldVal === true) {
        this.stop();
      }
      var options = {
        time: this.time,
        start: newVal
      };
      this.$emit('input', options);
    }
  },
  created: function created() {
    this.time = this.value.time;
    this.start = this.value.start;
    if (this.start) {
      this.tick();
    }
  },
  data: function data() {
    return {
      interval: null,
      index: 0,
      time: 60,
      start: true
    };
  }
};

/***/ }),

/***/ "vqbq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".weui-mask{background:rgba(0,0,0,.6)}.weui-mask,.weui-mask_transparent{position:fixed;z-index:1000;top:0;right:0;left:0;bottom:0}.weui_mask{z-index:1000;background:rgba(0,0,0,.6)}.weui_mask,.weui_mask_transparent{position:fixed;width:100%;height:100%;top:0;left:0}.weui_mask_transparent{z-index:5001}.weui_mask_transition{display:none;position:fixed;z-index:1000;width:100%;height:100%;top:0;left:0;background:transparent;transition:background .3s}.weui_fade_toggle{background:rgba(0,0,0,.6)}.weui-actionsheet{position:fixed;left:0;bottom:0;-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:5000;width:100%;background-color:#efeff4;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.weui-actionsheet__menu{background-color:#fff}.weui-actionsheet__action{margin-top:6px;background-color:#fff}.weui-actionsheet__cell{position:relative;padding:10px 0;text-align:center;font-size:18px}.weui-actionsheet__cell:before{content:\" \";position:absolute;left:0;top:0;width:100%;height:1px;border-top:1px solid #d9d9d9;color:#d9d9d9;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5)}.weui-actionsheet__cell:active{background-color:#ececec}.weui-actionsheet__cell:first-child:before{display:none}.weui-skin_android .weui-actionsheet{position:fixed;left:50%;top:50%;bottom:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:274px;box-sizing:border-box;-webkit-backface-visibility:hidden;backface-visibility:hidden;background:transparent;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.weui-skin_android .weui-actionsheet__action{display:none}.weui-skin_android .weui-actionsheet__menu{border-radius:2px;box-shadow:0 6px 30px 0 rgba(0,0,0,.1)}.weui-skin_android .weui-actionsheet__cell{padding:13px 24px;font-size:16px;line-height:1.4;text-align:left}.weui-skin_android .weui-actionsheet__cell:first-child{border-top-left-radius:2px;border-top-right-radius:2px}.weui-skin_android .weui-actionsheet__cell:last-child{border-bottom-left-radius:2px;border-bottom-right-radius:2px}.weui-actionsheet_toggle{-webkit-transform:translate(0);transform:translate(0)}.vux-actionsheet-menu-primary{color:#1aad19}.vux-actionsheet-menu-warn{color:#e64340}.vux-actionsheet-menu-default{color:#000}.vux-actionsheet-menu-disabled{color:#ccc}.vux-actionsheet-mask-enter,.vux-actionsheet-mask-leave-active,.vux-android-actionsheet-enter,.vux-android-actionsheet-leave-active{opacity:0}.vux-actionsheet-mask-enter-active,.vux-actionsheet-mask-leave-active,.vux-android-actionsheet-enter-active,.vux-android-actionsheet-leave-active{transition:opacity .3s!important}", ""]);

// exports


/***/ }),

/***/ "w+x0":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Jb5b")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("7dzo"),
  /* template */
  __webpack_require__("u4Ff"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "w6eq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("H4bY");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2209355d", content, true);

/***/ }),

/***/ "wB4O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _confirm = __webpack_require__("JiaV");

var _confirm2 = _interopRequireDefault(_confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_confirm2.default.install = function (Vue) {
  Vue.component('LxConfirm', _confirm2.default);
};

exports.default = _confirm2.default;

/***/ }),

/***/ "wPn5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "woOf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("V3tA"), __esModule: true };

/***/ }),

/***/ "wojb":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "xs-container"
  }, [_vm._t("default"), _vm._v(" "), _vm._t("pulldown"), _vm._v(" "), _vm._t("pullup")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "x75x":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("nwxr")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("zvDl"),
  /* template */
  __webpack_require__("xHnC"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "xAyU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".xs-plugin-pullup-container{text-align:center}", ""]);

// exports


/***/ }),

/***/ "xGkn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("4mcu");
var step = __webpack_require__("EGZi");
var Iterators = __webpack_require__("/bQp");
var toIObject = __webpack_require__("TcQ7");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("vIB/")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "xH/j":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("hJx8");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "xHnC":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox",
    class: {
      'vux-flex-col': _vm.orient === 'vertical', 'vux-flex-row': _vm.orient === 'horizontal'
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "xNwy":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  null,
  /* template */
  __webpack_require__("9R7u"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "xULZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isServer = typeof window === 'undefined';
if (!isServer) {
  var lastTime = 0;
  var vendors = ['webkit', 'moz'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (handler, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        handler(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}

/***/ }),

/***/ "xnc0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("MbSb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("742088d2", content, true);

/***/ }),

/***/ "xnc9":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "xoz2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8vQr");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("f7c66e1a", content, true);

/***/ }),

/***/ "xsd4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-popup{border-top:2px solid #04be02}.vux-popup-dialog{position:fixed;left:0;bottom:0;width:100%;background:#eee;z-index:999999;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform;transition-duration:.3s}.vux-popup-mask{display:block;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.6);opacity:0;tap-highlight-color:transparent;z-index:-1}.vux-popup-mask.vux-popup-show{opacity:1;z-index:100;transition:opacity .3s}.vux-popup-enter,.vux-popup-leave{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}", ""]);

// exports


/***/ }),

/***/ "xy9C":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("SXob")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("PURL"),
  /* template */
  __webpack_require__("4+zm"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "y1vT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "yJfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("5zA6");

var _badge = __webpack_require__("vjrk");

var _badge2 = _interopRequireDefault(_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TabbarItem',
  components: {
    Badge: _badge2.default
  },
  mixins: [_multiItems.childMixin],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  }
};

/***/ }),

/***/ "yNag":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calendar = __webpack_require__("FaU1");

var _calendar2 = _interopRequireDefault(_calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_calendar2.default.install = function (Vue) {
  Vue.component('LxCalendar', _calendar2.default);
};

exports.default = _calendar2.default;

/***/ }),

/***/ "yZwH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkerItem = __webpack_require__("Fatl");

var _checkerItem2 = _interopRequireDefault(_checkerItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_checkerItem2.default.install = function (Vue) {
  Vue.component('LxCheckerItem', _checkerItem2.default);
};

exports.default = _checkerItem2.default;

/***/ }),

/***/ "ypYz":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-group-tip",
    style: ({
      'text-align': _vm.align
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ "ytHL":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var n=t();for(var r in n)("object"==typeof exports?exports:e)[r]=n[r]}}(window,function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=48)}({0:function(e,t,n){"use strict";function r(e,t,n,r,o,i,u,f){var s,a="function"==typeof e?e.options:e;if(t&&(a.render=t,a.staticRenderFns=n,a._compiled=!0),r&&(a.functional=!0),i&&(a._scopeId="data-v-"+i),u?(s=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),o&&o.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(u)},a._ssrRegister=s):o&&(s=f?function(){o.call(this,this.$root.$options.shadowRoot)}:o),s)if(a.functional){a._injectStyles=s;var c=a.render;a.render=function(e,t){return s.call(t),c(e,t)}}else{var l=a.beforeCreate;a.beforeCreate=l?[].concat(l,s):[s]}return{exports:e,options:a}}n.d(t,"a",function(){return r})},17:function(e,t,n){"use strict";n.r(t);var r=n(18),o=n.n(r);for(var i in r)"default"!==i&&function(e){n.d(t,e,function(){return r[e]})}(i);t.default=o.a},18:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=["-moz-box-","-webkit-box-",""];t.default={props:{span:[Number,String],order:[Number,String]},methods:{buildWidth:function(e){return"number"==typeof e?e<1?e:e/12:"string"==typeof e?e.replace("px","")/document.documentElement.offsetWidth:void 0}},computed:{style:function(){var e={};if(e["horizontal"===this.$parent.orient?"marginLeft":"marginTop"]=this.$parent.gutter+"px",this.span)for(var t=0;t<r.length;t++)e[r[t]+"flex"]="0 0 "+100*this.buildWidth(this.span)+"%";return void 0!==this.order&&(e.order=this.order),e}},data:function(){return{}}}},19:function(e,t,n){},32:function(e,t,n){"use strict";var r=function(){var e=this.$createElement;return(this._self._c||e)("div",{staticClass:"vux-flexbox-item",style:this.style},[this._t("default")],2)},o=[];r._withStripped=!0,n.d(t,"a",function(){return r}),n.d(t,"b",function(){return o})},48:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=function(e){return e&&e.__esModule?e:{default:e}}(n(64));r.default.install=function(e){e.component("LxFlexboxItem",r.default)},t.default=r.default},64:function(e,t,n){"use strict";n.r(t);var r=n(32),o=n(17);for(var i in o)"default"!==i&&function(e){n.d(t,e,function(){return o[e]})}(i);n(65);var u=n(0),f=Object(u.a)(o.default,r.a,r.b,!1,null,null,null);f.options.__file="src\\components\\flexbox-item\\flexbox-item.vue",t.default=f.exports},65:function(e,t,n){"use strict";var r=n(19);n.n(r).a}})});

/***/ }),

/***/ "zFCM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _animate = __webpack_require__("HXfK");

var _animate2 = _interopRequireDefault(_animate);

var _util = __webpack_require__("BTc1");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isBrowser = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object';

var TEMPLATE = '\n<div class="scroller-component" data-role="component">\n  <div class="scroller-mask" data-role="mask"></div>\n  <div class="scroller-indicator" data-role="indicator"></div>\n  <div class="scroller-content" data-role="content"></div>\n</div>\n';

var getDpr = function getDpr() {
  var dpr = 1;
  if (isBrowser) {
    dpr = document.documentElement.getAttribute('data-dpr') || 1;
  }
  return dpr;
};

var Scroller = function Scroller(container, options) {
  var self = this;
  self.dpr = getDpr();

  options = options || {};

  self.options = {
    itemClass: 'scroller-item',
    onSelect: function onSelect() {},

    defaultValue: 0,
    data: []
  };

  for (var key in options) {
    if (options[key] !== undefined) {
      self.options[key] = options[key];
    }
  }

  self.__container = (0, _util.getElement)(container);

  var tempContainer = document.createElement('div');
  tempContainer.innerHTML = options.template || TEMPLATE;

  var component = self.__component = tempContainer.querySelector('[data-role=component]');
  var content = self.__content = component.querySelector('[data-role=content]');
  var indicator = component.querySelector('[data-role=indicator]');

  var data = self.options.data;
  var html = '';
  if (data.length && data[0].constructor === Object) {
    data.forEach(function (row) {
      html += '<div class="' + self.options.itemClass + '" data-value=' + (0, _stringify2.default)({ value: encodeURI(row.value) }) + '>' + row.name + '</div>';
    });
  } else {
    data.forEach(function (val) {
      html += '<div class="' + self.options.itemClass + '" data-value=' + (0, _stringify2.default)({ value: encodeURI(val) }) + '>' + val + '</div>';
    });
  }
  content.innerHTML = html;
  if (self.__container) {
    self.__container.appendChild(component);
  }

  self.__itemHeight = parseFloat((0, _util.getComputedStyle)(indicator, 'height'), 10).toFixed(6);

  self.__callback = options.callback || function (top) {
    var distance = -top * self.dpr;
    content.style.webkitTransform = 'translate3d(0, ' + distance + 'px, 0)';
    content.style.transform = 'translate3d(0, ' + distance + 'px, 0)';
  };

  var rect = component.getBoundingClientRect();

  self.__clientTop = rect.top + component.clientTop || 0;

  self.__setDimensions(component.clientHeight, content.offsetHeight);

  if (component.clientHeight === 0) {
    self.__setDimensions(parseFloat((0, _util.getComputedStyle)(component, 'height'), 10), 204);
  }
  self.select(self.options.defaultValue, false);

  component.addEventListener('touchstart', function (e) {
    if (e.target.tagName.match(/input|textarea|select/i)) {
      return;
    }
    e.preventDefault();
    self.__doTouchStart(e.touches, e.timeStamp);
  }, false);

  component.addEventListener('touchmove', function (e) {
    self.__doTouchMove(e.touches, e.timeStamp);
  }, false);

  component.addEventListener('touchend', function (e) {
    self.__doTouchEnd(e.timeStamp);
  }, false);
};

var members = {
  value: null,
  __prevValue: null,
  __isSingleTouch: false,
  __isTracking: false,
  __didDecelerationComplete: false,
  __isGesturing: false,
  __isDragging: false,
  __isDecelerating: false,
  __isAnimating: false,
  __clientTop: 0,
  __clientHeight: 0,
  __contentHeight: 0,
  __itemHeight: 0,
  __scrollTop: 0,
  __minScrollTop: 0,
  __maxScrollTop: 0,
  __scheduledTop: 0,
  __lastTouchTop: null,
  __lastTouchMove: null,
  __positions: null,
  __minDecelerationScrollTop: null,
  __maxDecelerationScrollTop: null,
  __decelerationVelocityY: null,

  __setDimensions: function __setDimensions(clientHeight, contentHeight) {
    var self = this;

    self.__clientHeight = clientHeight;
    self.__contentHeight = contentHeight;

    var totalItemCount = self.options.data.length;
    var clientItemCount = Math.round(self.__clientHeight / self.__itemHeight);

    self.__minScrollTop = -self.__itemHeight * (clientItemCount / 2);
    self.__maxScrollTop = self.__minScrollTop + totalItemCount * self.__itemHeight - 0.1;
  },
  selectByIndex: function selectByIndex(index, animate) {
    var self = this;
    if (index < 0 || index > self.__content.childElementCount - 1) {
      return;
    }
    self.__scrollTop = self.__minScrollTop + index * self.__itemHeight;

    self.scrollTo(self.__scrollTop, animate);

    self.__selectItem(self.__content.children[index]);
  },
  select: function select(value, animate) {
    var self = this;

    var children = self.__content.children;
    for (var i = 0, len = children.length; i < len; i++) {
      if (decodeURI(JSON.parse(children[i].dataset.value).value) === value) {
        self.selectByIndex(i, animate);
        return;
      }
    }

    self.selectByIndex(0, animate);
  },
  getValue: function getValue() {
    return this.value;
  },
  scrollTo: function scrollTo(top, animate) {
    var self = this;

    animate = animate === undefined ? true : animate;

    if (self.__isDecelerating) {
      _animate2.default.stop(self.__isDecelerating);
      self.__isDecelerating = false;
    }

    top = Math.round((top / self.__itemHeight).toFixed(5)) * self.__itemHeight;
    top = Math.max(Math.min(self.__maxScrollTop, top), self.__minScrollTop);

    if (top === self.__scrollTop || !animate) {
      self.__publish(top);
      self.__scrollingComplete();
      return;
    }
    self.__publish(top, 250);
  },
  destroy: function destroy() {
    this.__component.parentNode && this.__component.parentNode.removeChild(this.__component);
  },
  __selectItem: function __selectItem(selectedItem) {
    var self = this;

    var selectedItemClass = self.options.itemClass + '-selected';
    var lastSelectedElem = self.__content.querySelector('.' + selectedItemClass);
    if (lastSelectedElem) {
      lastSelectedElem.classList.remove(selectedItemClass);
    }
    if (selectedItem) {
      selectedItem.classList.add(selectedItemClass);
    }
    if (self.value !== null) {
      self.__prevValue = self.value;
    }
    if (selectedItem) {
      self.value = decodeURI(JSON.parse(selectedItem.dataset.value).value);
    }
  },
  __scrollingComplete: function __scrollingComplete() {
    var self = this;

    var index = Math.round((self.__scrollTop - self.__minScrollTop - self.__itemHeight / 2) / self.__itemHeight);

    self.__selectItem(self.__content.children[index]);

    if (self.__prevValue !== null && self.__prevValue !== self.value) {
      self.options.onSelect(self.value);
    }
  },
  __doTouchStart: function __doTouchStart(touches, timeStamp) {
    var self = this;

    if (touches.length == null) {
      throw new Error('Invalid touch list: ' + touches);
    }
    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== 'number') {
      throw new Error('Invalid timestamp value: ' + timeStamp);
    }

    self.__interruptedAnimation = true;

    if (self.__isDecelerating) {
      _animate2.default.stop(self.__isDecelerating);
      self.__isDecelerating = false;
      self.__interruptedAnimation = true;
    }

    if (self.__isAnimating) {
      _animate2.default.stop(self.__isAnimating);
      self.__isAnimating = false;
      self.__interruptedAnimation = true;
    }

    var currentTouchTop;
    var isSingleTouch = touches.length === 1;
    if (isSingleTouch) {
      currentTouchTop = touches[0].pageY;
    } else {
      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
    }

    self.__initialTouchTop = currentTouchTop;
    self.__lastTouchTop = currentTouchTop;
    self.__lastTouchMove = timeStamp;
    self.__lastScale = 1;
    self.__enableScrollY = !isSingleTouch;
    self.__isTracking = true;
    self.__didDecelerationComplete = false;
    self.__isDragging = !isSingleTouch;
    self.__isSingleTouch = isSingleTouch;
    self.__positions = [];
  },
  __doTouchMove: function __doTouchMove(touches, timeStamp, scale) {
    var self = this;

    if (touches.length == null) {
      throw new Error('Invalid touch list: ' + touches);
    }
    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== 'number') {
      throw new Error('Invalid timestamp value: ' + timeStamp);
    }

    if (!self.__isTracking) {
      return;
    }

    var currentTouchTop;

    if (touches.length === 2) {
      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
    } else {
      currentTouchTop = touches[0].pageY;
    }

    var positions = self.__positions;

    if (self.__isDragging) {
      var moveY = currentTouchTop - self.__lastTouchTop;
      var scrollTop = self.__scrollTop;

      if (self.__enableScrollY) {
        scrollTop -= moveY;

        var minScrollTop = self.__minScrollTop;
        var maxScrollTop = self.__maxScrollTop;

        if (scrollTop > maxScrollTop || scrollTop < minScrollTop) {
          if (scrollTop > maxScrollTop) {
            scrollTop = maxScrollTop;
          } else {
            scrollTop = minScrollTop;
          }
        }
      }

      if (positions.length > 40) {
        positions.splice(0, 20);
      }

      positions.push(scrollTop, timeStamp);

      self.__publish(scrollTop);
    } else {
      var minimumTrackingForScroll = 0;
      var minimumTrackingForDrag = 5;

      var distanceY = Math.abs(currentTouchTop - self.__initialTouchTop);

      self.__enableScrollY = distanceY >= minimumTrackingForScroll;

      positions.push(self.__scrollTop, timeStamp);

      self.__isDragging = self.__enableScrollY && distanceY >= minimumTrackingForDrag;

      if (self.__isDragging) {
        self.__interruptedAnimation = false;
      }
    }

    self.__lastTouchTop = currentTouchTop;
    self.__lastTouchMove = timeStamp;
    self.__lastScale = scale;
  },
  __doTouchEnd: function __doTouchEnd(timeStamp) {
    var self = this;

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== 'number') {
      throw new Error('Invalid timestamp value: ' + timeStamp);
    }

    if (!self.__isTracking) {
      return;
    }

    self.__isTracking = false;

    if (self.__isDragging) {
      self.__isDragging = false;

      if (self.__isSingleTouch && timeStamp - self.__lastTouchMove <= 100) {
        var positions = self.__positions;
        var endPos = positions.length - 1;
        var startPos = endPos;

        for (var i = endPos; i > 0 && positions[i] > self.__lastTouchMove - 100; i -= 2) {
          startPos = i;
        }

        if (startPos !== endPos) {
          var timeOffset = positions[endPos] - positions[startPos];
          var movedTop = self.__scrollTop - positions[startPos - 1];

          self.__decelerationVelocityY = movedTop / timeOffset * (1000 / 60);

          var minVelocityToStartDeceleration = 4;

          if (Math.abs(self.__decelerationVelocityY) > minVelocityToStartDeceleration) {
            self.__startDeceleration(timeStamp);
          }
        }
      }
    }

    if (!self.__isDecelerating) {
      self.scrollTo(self.__scrollTop);
    }

    self.__positions.length = 0;
  },
  __publish: function __publish(top, animationDuration) {
    var self = this;

    var wasAnimating = self.__isAnimating;
    if (wasAnimating) {
      _animate2.default.stop(wasAnimating);
      self.__isAnimating = false;
    }

    if (animationDuration) {
      self.__scheduledTop = top;

      var oldTop = self.__scrollTop;
      var diffTop = top - oldTop;

      var step = function step(percent, now, render) {
        self.__scrollTop = oldTop + diffTop * percent;

        if (self.__callback) {
          self.__callback(self.__scrollTop);
        }
      };

      var verify = function verify(id) {
        return self.__isAnimating === id;
      };

      var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
        if (animationId === self.__isAnimating) {
          self.__isAnimating = false;
        }
        if (self.__didDecelerationComplete || wasFinished) {
          self.__scrollingComplete();
        }
      };

      self.__isAnimating = _animate2.default.start(step, verify, completed, animationDuration, wasAnimating ? _util.easeOutCubic : _util.easeInOutCubic);
    } else {
      self.__scheduledTop = self.__scrollTop = top;

      if (self.__callback) {
        self.__callback(top);
      }
    }
  },
  __startDeceleration: function __startDeceleration(timeStamp) {
    var self = this;

    self.__minDecelerationScrollTop = self.__minScrollTop;
    self.__maxDecelerationScrollTop = self.__maxScrollTop;

    var step = function step(percent, now, render) {
      self.__stepThroughDeceleration(render);
    };

    var minVelocityToKeepDecelerating = 0.5;

    var verify = function verify() {
      var shouldContinue = Math.abs(self.__decelerationVelocityY) >= minVelocityToKeepDecelerating;
      if (!shouldContinue) {
        self.__didDecelerationComplete = true;
      }
      return shouldContinue;
    };

    var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
      self.__isDecelerating = false;
      if (self.__scrollTop <= self.__minScrollTop || self.__scrollTop >= self.__maxScrollTop) {
        self.scrollTo(self.__scrollTop);
        return;
      }
      if (self.__didDecelerationComplete) {
        self.__scrollingComplete();
      }
    };

    self.__isDecelerating = _animate2.default.start(step, verify, completed);
  },
  __stepThroughDeceleration: function __stepThroughDeceleration(render) {
    var self = this;

    var scrollTop = self.__scrollTop + self.__decelerationVelocityY;

    var scrollTopFixed = Math.max(Math.min(self.__maxDecelerationScrollTop, scrollTop), self.__minDecelerationScrollTop);
    if (scrollTopFixed !== scrollTop) {
      scrollTop = scrollTopFixed;
      self.__decelerationVelocityY = 0;
    }

    if (Math.abs(self.__decelerationVelocityY) <= 1) {
      if (Math.abs(scrollTop % self.__itemHeight) < 1) {
        self.__decelerationVelocityY = 0;
      }
    } else {
      self.__decelerationVelocityY *= 0.95;
    }

    self.__publish(scrollTop);
  }
};

for (var key in members) {
  Scroller.prototype[key] = members[key];
}

module.exports = Scroller;

/***/ }),

/***/ "zQ+c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PL3R");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3d8fda1b", content, true);

/***/ }),

/***/ "zQR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("h65t")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("vIB/")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "zeGv":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("nhh6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9a566588", content, true);

/***/ }),

/***/ "ziR6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".vux-sticky{width:100%;position:-webkit-sticky;position:sticky;top:0}.vux-fixed{width:100%;position:fixed;top:0}", ""]);

// exports


/***/ }),

/***/ "zpZo":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("uXSg");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("d54c7ac2", content, true);

/***/ }),

/***/ "zpgl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Q3JV");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("f22f27de", content, true);

/***/ }),

/***/ "zvDl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      return {
        'justify-content': this.justify,
        'align-items': this.align,
        'flex-wrap': this.wrap,
        'flex-direction': this.direction
      };
    }
  }
};

/***/ }),

/***/ "zynq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiperItem = __webpack_require__("EhX6");

var _swiperItem2 = _interopRequireDefault(_swiperItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_swiperItem2.default.install = function (Vue) {
  Vue.component('LxSwiperItem', _swiperItem2.default);
};

exports.default = _swiperItem2.default;

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/modules/app.21532ccdb366e30619cd.js